(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[28452],{

/***/ 15920:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "q": function() { return /* binding */ sendEvent; },
  "e": function() { return /* binding */ sendEventBatch; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/axios/index.js
var axios = __webpack_require__(89644);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
;// CONCATENATED MODULE: ../shared/src/clients/dataEvents/httpClient.js

var client = axios_default().create({
  baseURL: "https://data-events.uniplaces.com"
});
/* harmony default export */ var httpClient = (client);
;// CONCATENATED MODULE: ../shared/src/clients/dataEvents/index.js

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var sendEvent = function sendEvent(streamName, data) {
  return httpClient.put("streams/".concat(streamName, "/record"), {
    data: _objectSpread(_objectSpread({}, data), {}, {
      timestamp: Date.now()
    })
  });
};
var sendEventBatch = function sendEventBatch(streamName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return httpClient.put("streams/".concat(streamName, "/record-batch"), data);
};

/***/ }),

/***/ 98600:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Counter; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(23769);
;// CONCATENATED MODULE: ../shared/src/svg/plus.js

var __jsx = react.createElement;

var Plus = function Plus(props) {
  return __jsx("svg", (0,esm_extends/* default */.Z)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), __jsx("g", {
    stroke: "#647A85",
    strokeLinecap: "round",
    clipPath: "url(#a)"
  }, __jsx("path", {
    fill: "#E4EAED",
    strokeLinejoin: "round",
    d: "M12.166 23c6.076 0 11-4.925 11-11s-4.924-11-11-11c-6.075 0-11 4.925-11 11s4.925 11 11 11Z"
  }), __jsx("path", {
    d: "M6.167 11.75h11.5M11.916 6v11.5"
  })), __jsx("defs", null, __jsx("clipPath", {
    id: "a"
  }, __jsx("path", {
    fill: "#fff",
    d: "M.167 0h24v24h-24z"
  }))));
};
/* harmony default export */ var plus = (Plus);
;// CONCATENATED MODULE: ../shared/src/svg/minus.js

var minus_jsx = react.createElement;

var Minus = function Minus(props) {
  return minus_jsx("svg", (0,esm_extends/* default */.Z)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), minus_jsx("g", {
    stroke: "#647A85",
    strokeLinecap: "round",
    clipPath: "url(#a)"
  }, minus_jsx("path", {
    fill: "#E4EAED",
    strokeLinejoin: "round",
    d: "M12.166 23c6.076 0 11-4.925 11-11s-4.924-11-11-11c-6.075 0-11 4.925-11 11s4.925 11 11 11Z"
  }), minus_jsx("path", {
    d: "M6.167 11.75h11.5"
  })), minus_jsx("defs", null, minus_jsx("clipPath", {
    id: "a"
  }, minus_jsx("path", {
    fill: "#fff",
    d: "M.167 0h24v24h-24z"
  }))));
};
/* harmony default export */ var minus = (Minus);
// EXTERNAL MODULE: ../shared/src/components/Counter/styles.js
var styles = __webpack_require__(59841);
;// CONCATENATED MODULE: ../shared/src/components/Counter/index.js
var Counter_jsx = react.createElement;




var Counter = function Counter(_ref) {
  var _ref$max = _ref.max,
    max = _ref$max === void 0 ? null : _ref$max,
    _ref$min = _ref.min,
    min = _ref$min === void 0 ? 1 : _ref$min,
    value = _ref.value,
    _ref$increment = _ref.increment,
    increment = _ref$increment === void 0 ? 1 : _ref$increment,
    _ref$onUpdate = _ref.onUpdate,
    onUpdate = _ref$onUpdate === void 0 ? function () {} : _ref$onUpdate;
  var _useState = (0,react.useState)(value),
    count = _useState[0],
    setCount = _useState[1];
  (0,react.useEffect)(function () {
    setCount(value);
  }, [value]);
  var incrementCount = function incrementCount() {
    if (max && count === max) {
      return;
    }
    setCount(count + increment);
    onUpdate(count + increment);
  };
  var decrementCount = function decrementCount() {
    if (min && count === min) {
      return;
    }
    setCount(count - increment);
    onUpdate(count - increment);
  };
  return Counter_jsx(styles/* Wrapper */.i, null, Counter_jsx("button", {
    onClick: decrementCount,
    disabled: count === min
  }, Counter_jsx(minus, null)), Counter_jsx("span", null, count), Counter_jsx("button", {
    onClick: incrementCount,
    disabled: count === max
  }, Counter_jsx(plus, null)));
};
/* harmony default export */ var components_Counter = (Counter);

/***/ }),

/***/ 59841:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ Wrapper; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41401);

var Wrapper = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  componentId: "sc-1y177wv-0"
})(["display:flex;align-items:center;flex-grow:0;justify-content:space-between;width:auto;button{display:flex;width:auto;padding:0;margin:0;background:transparent;border:none;cursor:pointer;&:disabled{opacity:0.5;cursor:auto;}svg{width:auto;margin-right:0;}}span{width:50px;display:inline-flex;justify-content:center;}"]);

/***/ }),

/***/ 86095:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ Wrapper; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41401);

var Wrapper = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].button.withConfig */ .ZP.button.withConfig({
  componentId: "sc-iua1rb-0"
})(["display:flex;align-items:center;justify-content:center;width:27px;height:27px;background-color:transparent;cursor:pointer;border:none;overflow:visible;-webkit-appearance:none;padding:0;svg{width:27px;height:25px;&.active > path{fill:", ";}path{fill:grey;stroke:white;}}"], function (props) {
  return props.theme.card.favouriteButtonColor;
});

/***/ }),

/***/ 3373:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ PROPERTY_FEATURES; }
/* harmony export */ });
var PROPERTY_FEATURES = {
  WI_FI: 'wi-fi',
  CENTRAL_HEATING: 'central-heating',
  DISHWASHER: 'dishwasher',
  WASHING_MACHINE: 'washing-machine',
  MICROWAVE: 'microwave',
  OVEN: 'oven',
  CABLE_TV: 'cable-tv',
  AIR_CONDITIONING: 'air-conditioning',
  OUTDOOR_AREA: 'outdoor-area',
  ELEVATOR: 'elevator',
  ACCESSIBILITY: 'accessibility',
  UNFURNISHED: 'unfurnished'
};

/***/ }),

/***/ 42395:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ ProfileContext; }
/* harmony export */ });
/* unused harmony export ProfileProvider */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _spa_shared_hooks_auth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34543);
var __jsx = react__WEBPACK_IMPORTED_MODULE_0__.createElement;



var ProfileContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});
var ProfileProvider = function ProfileProvider(_ref) {
  var children = _ref.children;
  var history = useRouter();
  var authProperties = useAuth(history);
  return __jsx(ProfileContext.Provider, {
    value: authProperties
  }, children);
};


/***/ }),

/***/ 59808:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "j": function() { return /* binding */ WishlistContext; },
  "T": function() { return /* binding */ WishlistContextProvider; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
// EXTERNAL MODULE: ../shared/src/utils/user/index.js
var user = __webpack_require__(3291);
// EXTERNAL MODULE: ../shared/src/hooks/storage.js + 1 modules
var hooks_storage = __webpack_require__(54200);
// EXTERNAL MODULE: ../shared/src/hooks/debounce.js + 1 modules
var hooks_debounce = __webpack_require__(53129);
;// CONCATENATED MODULE: ../shared/src/contexts/modal/index.js

var modal_ModalContext = /*#__PURE__*/(0,react.createContext)();
// EXTERNAL MODULE: ../shared/src/contexts/profile/index.js
var contexts_profile = __webpack_require__(42395);
// EXTERNAL MODULE: ../shared/src/clients/core/index.js + 1 modules
var core = __webpack_require__(30629);
;// CONCATENATED MODULE: ../shared/src/reducers/modal/index.js


var _excluded = (/* unused pure expression or super */ null && (["modalId"]));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var modalReducerActions = {
  SHOW: 'show',
  HIDE: 'hide'
};
var modalReducer = function modalReducer(state, _ref) {
  var type = _ref.type,
    _ref$payload = _ref.payload;
  _ref$payload = _ref$payload === void 0 ? {} : _ref$payload;
  var modalId = _ref$payload.modalId,
    payload = _objectWithoutProperties(_ref$payload, _excluded);
  switch (type) {
    case modalReducerActions.SHOW:
      return _objectSpread(_objectSpread({}, state), {}, {
        modalId: modalId
      }, payload);
    case modalReducerActions.HIDE:
      return _objectSpread(_objectSpread({}, state), {}, {
        modalId: null
      });
    default:
      throw new Error('unrecognized action "${type}"');
  }
};
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(12741);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
;// CONCATENATED MODULE: ../shared/src/contexts/wishlist/reducer.js


function reducer_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function reducer_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? reducer_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : reducer_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var WishlistReducerActions = {
  LOAD_WISHLIST: 'load',
  ADD_OFFER: 'add',
  REMOVE_OFFER: 'remove'
};
var WishlistReducer = function WishlistReducer(_ref, _ref2) {
  var wishlist = _ref.wishlist;
  var type = _ref2.type,
    payload = _ref2.payload;
  switch (type) {
    case WishlistReducerActions.LOAD_WISHLIST:
      return {
        wishlist: payload,
        isToMakeApiRequest: false
      };
    case WishlistReducerActions.ADD_OFFER:
      return addOffer(wishlist, payload);
    case WishlistReducerActions.REMOVE_OFFER:
      return removeOffer(wishlist, payload);
    default:
      throw Error("unrecognized action \"".concat(type, "\""));
  }
};
var cityWishlist = function cityWishlist(wishlist, city) {
  return wishlist[city] || [];
};
var addOffer = function addOffer(wishlist, _ref3) {
  var offerId = _ref3.offerId,
    city = _ref3.city,
    _ref3$isToMakeApiRequ = _ref3.isToMakeApiRequest,
    isToMakeApiRequest = _ref3$isToMakeApiRequ === void 0 ? true : _ref3$isToMakeApiRequ;
  return {
    wishlist: reducer_objectSpread(reducer_objectSpread({}, wishlist), {}, (0,defineProperty/* default */.Z)({}, city, [].concat((0,toConsumableArray/* default */.Z)(cityWishlist(wishlist, city)), [parseInt(offerId, 10)]))),
    isToMakeApiRequest: isToMakeApiRequest
  };
};
var removeOffer = function removeOffer(wishlist, _ref4) {
  var offerId = _ref4.offerId,
    city = _ref4.city,
    _ref4$isToMakeApiRequ = _ref4.isToMakeApiRequest,
    isToMakeApiRequest = _ref4$isToMakeApiRequ === void 0 ? true : _ref4$isToMakeApiRequ;
  return {
    wishlist: reducer_objectSpread(reducer_objectSpread({}, wishlist), {}, (0,defineProperty/* default */.Z)({}, city, cityWishlist(wishlist, city).filter(function (id) {
      return id !== parseInt(offerId, 10);
    }))),
    isToMakeApiRequest: isToMakeApiRequest
  };
};

// EXTERNAL MODULE: ../../node_modules/next-i18next/dist/esm/index.js + 16 modules
var esm = __webpack_require__(69324);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(7328);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 6 modules
var styled_components_browser_esm = __webpack_require__(41401);
// EXTERNAL MODULE: ../shared/src/theme.js
var theme = __webpack_require__(24701);
;// CONCATENATED MODULE: ../shared/src/components/Modals/CreateOfferAlertModal/styles.js

var _templateObject;


var filtersContainerFontSize = 14;
var styles_modalStyle = {
  box: {
    width: '580px'
  }
};
var styles_Container = /*#__PURE__*/(/* unused pure expression or super */ null && (styled.div.withConfig({
  componentId: "sc-z4mjxn-0"
})(["font-family:IntervalNextReg,sans-serif;font-weight:100;line-height:normal;color:", ";.description{line-height:normal;}.terms-and-conditions{opacity:0.55;font-size:", ";a{color:", ";text-decoration:none;}}"], function (props) {
  return props.theme.createOfferAlertModal.primaryTextColor;
}, function (props) {
  return props.theme.rem(filtersContainerFontSize);
}, function (props) {
  return props.theme.createOfferAlertModal.linksColor;
})));
var styles_FiltersContainer = /*#__PURE__*/(/* unused pure expression or super */ null && (styled.div.withConfig({
  componentId: "sc-z4mjxn-1"
})(["display:flex;justify-content:space-between;flex-wrap:wrap;margin-top:", ";p{font-size:", ";font-weight:bold;}"], function (props) {
  return props.theme.space(8);
}, function (props) {
  return props.theme.rem(filtersContainerFontSize);
})));
var styles_RentType = /*#__PURE__*/(/* unused pure expression or super */ null && (styled.div.withConfig({
  componentId: "sc-z4mjxn-2"
})(["display:flex;flex-direction:column;> div{height:40px;span{font-size:", ";}}"], function (props) {
  return props.theme.rem(filtersContainerFontSize);
})));
var styles_Budget = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-z4mjxn-3"
})(["display:flex;flex-direction:column;> div{padding:0;box-shadow:none;margin-top:", ";}", ""], function (props) {
  return props.theme.space(3);
}, theme/* mediaMin.smallBreakpoint */.A3.smallBreakpoint(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-top: ", "\n  "])), function (props) {
  return props.theme.space(4);
}));
var styles_CommunicationContainer = /*#__PURE__*/(/* unused pure expression or super */ null && (styled.div.withConfig({
  componentId: "sc-z4mjxn-4"
})(["margin:", " 0 ", ";> input{height:44px;background-color:", ";border-radius:0px;border:0px;border-bottom:solid 0.5px ", ";&::placeholder{opacity:0.55;color:#667485;}}.label{opacity:0.55;font-size:", ";}"], function (props) {
  return props.theme.space(4);
}, function (props) {
  return props.theme.space(4);
}, function (props) {
  return props.theme.createOfferAlertModal.inputBackgroundColor;
}, function (props) {
  return props.theme.createOfferAlertModal.inputBorderColor;
}, function (props) {
  return props.theme.rem(filtersContainerFontSize);
})));
var styles_ActionsContainer = /*#__PURE__*/(/* unused pure expression or super */ null && (styled.div.withConfig({
  componentId: "sc-z4mjxn-5"
})(["display:flex;margin-top:", ";> button{width:", ";height:", ";margin:0;&:first-child{margin-right:", ";}}"], function (props) {
  return props.theme.space(6);
}, function (props) {
  return props.theme.space(36);
}, function (props) {
  return props.theme.space(10);
}, function (props) {
  return props.theme.space(2);
})));

// EXTERNAL MODULE: ../shared/src/components/Modal/index.js + 1 modules
var components_Modal = __webpack_require__(44554);
// EXTERNAL MODULE: ../shared/src/components/Button/index.js
var components_Button = __webpack_require__(39631);
// EXTERNAL MODULE: ../shared/src/components/Checkbox/index.js + 1 modules
var components_Checkbox = __webpack_require__(80425);
// EXTERNAL MODULE: ../shared/src/hooks/tracking/index.js + 1 modules
var tracking = __webpack_require__(3912);
// EXTERNAL MODULE: ../shared/src/utils/language/index.js
var language = __webpack_require__(90703);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(28526);
// EXTERNAL MODULE: ../shared/src/constants/locales.js
var constants_locales = __webpack_require__(44338);
// EXTERNAL MODULE: ../../node_modules/lodash.isequal/index.js
var lodash_isequal = __webpack_require__(33958);
var lodash_isequal_default = /*#__PURE__*/__webpack_require__.n(lodash_isequal);
// EXTERNAL MODULE: ../shared/src/utils/queryParams/index.js + 1 modules
var queryParams = __webpack_require__(50436);
;// CONCATENATED MODULE: ../shared/src/hooks/search/history.js




var history_excluded = (/* unused pure expression or super */ null && (["south", "west", "north", "east"]));
function history_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function history_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? history_ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : history_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }





var SET_STATE = 'set_state';
var oldSearchParams = (/* unused pure expression or super */ null && (['south', 'west', 'north', 'east']));
var hasOldParameter = function hasOldParameter(parameter) {
  return oldSearchParams.find(function (oldParameter) {
    return oldParameter === parameter;
  });
};
var hasCoordinatesFromOldSearch = function hasCoordinatesFromOldSearch(changedParams) {
  return changedParams.filter(hasOldParameter).length === oldSearchParams.length;
};
var getStateFromOldQuery = function getStateFromOldQuery(_ref) {
  var south = _ref.south,
    west = _ref.west,
    north = _ref.north,
    east = _ref.east,
    state = _objectWithoutProperties(_ref, history_excluded);
  var sw = "".concat(south, ",").concat(west);
  var ne = "".concat(north, ",").concat(east);
  return history_objectSpread(history_objectSpread({}, state), {}, {
    sw: sw,
    ne: ne
  });
};
var getState = function getState(_ref2, query, changedParams) {
  var state = _ref2.state,
    key = _ref2.key;
  return {
    state: hasCoordinatesFromOldSearch(changedParams) ? getStateFromOldQuery(state, query) : state,
    key: changedParams.length > 0 ? makeKey() : key
  };
};
var getChangedParams = function getChangedParams() {
  var prev = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var current = arguments.length > 1 ? arguments[1] : undefined;
  var differentValues = function differentValues(key) {
    return !isEqual(prev[key], current[key]);
  };
  var keys = _toConsumableArray(new Set([].concat(_toConsumableArray(Object.keys(prev).filter(differentValues)), _toConsumableArray(Object.keys(current).filter(differentValues)))));
  return keys;
};
var history_reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref3 = arguments.length > 1 ? arguments[1] : undefined,
    type = _ref3.type,
    payload = _ref3.payload;
  switch (type) {
    case SET_STATE:
      return history_objectSpread(history_objectSpread(history_objectSpread({}, state), payload), {}, {
        changedParams: getChangedParams(state.query, payload.query)
      });
    default:
      return state;
  }
};

/**
 * searchQueryParams = invisible params + query-params from our search
 * it manages the difference between the requests we need to make to our search
 * and the ones we use on our search page
 */
var history_useSearchHistory = function useSearchHistory(keyFromServer) {
  var router = useRouter();
  var queryParams = _extends({}, router.query);
  var _useState = useState({
      key: keyFromServer
    }),
    searchState = _useState[0];
  var query = cleanStateQuery(history_objectSpread(history_objectSpread({}, queryParams), handlePathToQuery(queryParams.city)));
  var changedParams = Object.keys(query);
  var _getState = getState({
      state: history_objectSpread(history_objectSpread({}, searchState), query)
    }, {}, changedParams),
    state = _getState.state,
    key = _getState.key;
  var _useReducer = useReducer(history_reducer, {
      state: state,
      query: query,
      changedParams: changedParams,
      key: key
    }),
    historyState = _useReducer[0],
    dispatch = _useReducer[1];
  useEffect(function () {
    var newState = key ? history_objectSpread(history_objectSpread({}, state), {}, {
      key: key
    }) : state;
    var payload = {
      query: query,
      state: newState
    };
    dispatch({
      type: SET_STATE,
      payload: payload
    });
  }, [router.query]);
  return historyState;
};
// EXTERNAL MODULE: ../../node_modules/axios/index.js
var axios = __webpack_require__(89644);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
;// CONCATENATED MODULE: ../shared/src/clients/search/httpClient.js

var httpClient_client = axios_default().create({
  baseURL: "https://search-api-new.uniplaces.com"
});
/* harmony default export */ var httpClient = ((/* unused pure expression or super */ null && (httpClient_client)));
;// CONCATENATED MODULE: ../shared/src/clients/search/index.js

function search_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function search_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? search_ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : search_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var getUserIdAsHeader = function getUserIdAsHeader(userId) {
  return userId ? {
    'X-Uni-User-Id': userId
  } : {};
};
var search = function search(params) {
  return client.get('locations_autocomplete', {
    params: params
  }).then(function (_ref) {
    var data = _ref.data;
    return data;
  });
};
var offers = function offers(params) {
  var experimentId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var userId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var headers = search_objectSpread(search_objectSpread({}, experimentId ? {
    'X-Uni-Experiment-Id': experimentId
  } : {}), getUserIdAsHeader(userId));
  return client.get('offers', {
    params: params,
    headers: headers
  }).then(function (_ref2) {
    var data = _ref2.data;
    return data;
  });
};
var search_residencesOffers = function residencesOffers(params) {
  var userId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var headers = search_objectSpread({}, getUserIdAsHeader(userId));
  return client.get('residences', {
    params: params,
    headers: headers
  }).then(function (_ref3) {
    var data = _ref3.data;
    return data;
  });
};
var nearbyNeighbourhoodsBySlug = function nearbyNeighbourhoodsBySlug(slug) {
  return client.get("neighbourhoods/".concat(slug, "/nearby")).then(function (_ref4) {
    var data = _ref4.data;
    return data;
  });
};
var neighbourhoodsFromCityCode = function neighbourhoodsFromCityCode(cityCode) {
  return client.get("city/".concat(cityCode, "/neighbourhoods"), {
    limit: 100
  }).then(function (_ref5) {
    var data = _ref5.data;
    return data;
  });
};
var nearbyNeighbourhoodsByUniversitySlug = function nearbyNeighbourhoodsByUniversitySlug(universitySlug) {
  return client.get("neighbourhoods?search_by=nearby_by_university&slug=".concat(universitySlug)).then(function (_ref6) {
    var data = _ref6.data;
    return data;
  });
};
var similarOffers = function similarOffers(params) {
  return client.get('recommendations', {
    params: params
  }).then(function (_ref7) {
    var data = _ref7.data;
    return data;
  });
};
// EXTERNAL MODULE: ../shared/src/utils/location/index.js
var utils_location = __webpack_require__(82044);
// EXTERNAL MODULE: ../shared/src/hooks/index.js + 2 modules
var hooks = __webpack_require__(31681);
;// CONCATENATED MODULE: ../shared/src/contexts/resources/index.js


var __jsx = react.createElement;

function resources_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function resources_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? resources_ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : resources_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }











var RESULTS_LIMIT = 42;
var resources_ResourcesContext = /*#__PURE__*/(/* unused pure expression or super */ null && (createContext()));
var SOURCE = 'spa';
var ResourcesProvider = function ResourcesProvider(_ref) {
  var _query$key;
  var children = _ref.children,
    _ref$offers = _ref.offers,
    offers = _ref$offers === void 0 ? [] : _ref$offers,
    _ref$location = _ref.location,
    location = _ref$location === void 0 ? {} : _ref$location,
    offersKey = _ref.offersKey,
    _ref$isResidences = _ref.isResidences,
    isResidences = _ref$isResidences === void 0 ? false : _ref$isResidences,
    _ref$shouldLoad = _ref.shouldLoad,
    shouldLoad = _ref$shouldLoad === void 0 ? true : _ref$shouldLoad,
    _ref$staticOffer = _ref.staticOffer,
    staticOffer = _ref$staticOffer === void 0 ? null : _ref$staticOffer;
  var router = useRouter();
  var debouncedQueryParams = useDebounce(router.query, 500);
  var _useContext = useContext(ProfileContext),
    profile = _useContext.profile;
  var _useTranslation = useTranslation(),
    language = _useTranslation.i18n.language;
  var initialState = resources_objectSpread(resources_objectSpread({}, resultsTransformer(offers, {
    limit: RESULTS_LIMIT,
    key: offersKey
  })), {}, {
    limit: RESULTS_LIMIT,
    isInitialRequest: true,
    location: location,
    key: offersKey,
    isLoading: false,
    staticOffer: staticOffer
  });
  var experiment_id = offers.meta.experiment_id;
  var _useSearchHistory = useSearchHistory(offersKey),
    query = _useSearchHistory.query,
    _useSearchHistory$sta = _useSearchHistory.state,
    state = _useSearchHistory$sta === void 0 ? {} : _useSearchHistory$sta;
  var _useReducer = useReducer(reducer, resources_objectSpread(resources_objectSpread({}, initialState), {}, {
      read: function read() {
        return initialState;
      }
    })),
    results = _useReducer[0],
    dispatch = _useReducer[1];
  var key = (_query$key = query.key) !== null && _query$key !== void 0 ? _query$key : offersKey;
  useEffect(function () {
    dispatch({
      type: SET_RESULTS,
      payload: resources_objectSpread(resources_objectSpread({
        query: resources_objectSpread(resources_objectSpread({}, query), {}, {
          city: state.city
        }),
        state: state
      }, resultsTransformer(offers, {
        limit: RESULTS_LIMIT,
        key: offersKey
      })), {}, {
        key: key,
        location: location,
        staticOffer: !(query !== null && query !== void 0 && query.page) ? staticOffer : null
      })
    });
  }, [offers]);
  useEffect(function () {
    if (results.isInitialRequest) {
      dispatch({
        type: INITIAL_LOAD
      });
      return;
    }
    var updateSearchResultsState = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var type, payload, params, city, queryParams, _router$query, _results;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                type = SET_RESULTS;
                payload = {
                  query: resources_objectSpread(resources_objectSpread({}, query), {}, {
                    city: state.city
                  }),
                  state: state,
                  location: location
                };
                if (shouldLoad) {
                  dispatch({
                    type: type,
                    payload: {
                      isLoading: true
                    }
                  });
                }
                params = handleMultipleFields(resources_objectSpread({}, router.query));
                city = location.city ? location.city.code : location.code;
                queryParams = resources_objectSpread(resources_objectSpread(resources_objectSpread(resources_objectSpread({}, locationToSearch(location)), params), handlePathToQuery(router.query.city)), {}, {
                  limit: RESULTS_LIMIT,
                  city: city,
                  key: key,
                  source: SOURCE,
                  locale: locales[language.toUpperCase()] || locales.EN
                });
                _context.prev = 6;
                if (!isResidences) {
                  _context.next = 13;
                  break;
                }
                _context.next = 10;
                return residencesOffers(queryParams, profile === null || profile === void 0 ? void 0 : profile.id);
              case 10:
                _context.t0 = _context.sent;
                _context.next = 16;
                break;
              case 13:
                _context.next = 15;
                return offersAction(queryParams, experiment_id, profile === null || profile === void 0 ? void 0 : profile.id);
              case 15:
                _context.t0 = _context.sent;
              case 16:
                _results = _context.t0;
                dispatch({
                  type: type,
                  payload: resources_objectSpread(resources_objectSpread(resources_objectSpread({}, payload), resultsTransformer(_results, {
                    limit: RESULTS_LIMIT,
                    key: key
                  })), {}, {
                    isLoading: false,
                    staticOffer: !((_router$query = router.query) !== null && _router$query !== void 0 && _router$query.page) ? staticOffer : null
                  })
                });
                _context.next = 23;
                break;
              case 20:
                _context.prev = 20;
                _context.t1 = _context["catch"](6);
                dispatch({
                  type: type,
                  payload: initialState
                });
              case 23:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[6, 20]]);
      }));
      return function updateSearchResultsState() {
        return _ref2.apply(this, arguments);
      };
    }();
    updateSearchResultsState();
  }, [debouncedQueryParams]);
  return __jsx(resources_ResourcesContext.Provider, {
    value: results
  }, children);
};

// EXTERNAL MODULE: ../shared/src/utils/money/index.js
var money = __webpack_require__(55201);
;// CONCATENATED MODULE: ../shared/src/components/Filters/BudgetRange/Input/index.js
var Input_jsx = react.createElement;



var Input_BudgetInput = function BudgetInput(_ref) {
  var name = _ref.name,
    label = _ref.label,
    onChange = _ref.onChange,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value,
    _ref$currencyCode = _ref.currencyCode,
    currencyCode = _ref$currencyCode === void 0 ? 'EUR' : _ref$currencyCode,
    _ref$onFocus = _ref.onFocus,
    onFocus = _ref$onFocus === void 0 ? function () {} : _ref$onFocus,
    _ref$onBlur = _ref.onBlur,
    onBlur = _ref$onBlur === void 0 ? function () {} : _ref$onBlur;
  var inputRef = useRef(null);
  var currencySymbol = useMemo(function () {
    return getCurrencySymbol(currencyCode);
  }, [currencyCode]);
  return Input_jsx(Container, {
    onClick: function onClick() {
      return inputRef.current.focus();
    }
  }, Input_jsx(Label, {
    htmlFor: name
  }, label, Input_jsx(Value, null, Input_jsx("span", null, currencySymbol), Input_jsx("input", {
    name: name,
    ref: inputRef,
    onChange: onChange,
    onBlur: onBlur,
    onFocus: onFocus,
    value: value
  }))));
};

// EXTERNAL MODULE: ../../node_modules/react-spring/web.js
var web = __webpack_require__(2212);
;// CONCATENATED MODULE: ../shared/src/components/Histogram/index.js


var Histogram_jsx = react.createElement;




var width = 50;
var height = 10;
var Histogram_Histogram = function Histogram(_ref) {
  var data = _ref.data,
    _ref$range = _slicedToArray(_ref.range, 2),
    minRange = _ref$range[0],
    maxRange = _ref$range[1];
  var max = useMemo(function () {
    return Math.max.apply(Math, _toConsumableArray(Object.values(data))) || 1;
  }, [data]);
  var keys = useMemo(function () {
    return Object.keys(data);
  }, [data]);
  var isOutsideRange = useCallback(function (value) {
    if (!minRange && !maxRange) {
      return;
    }
    return value < minRange || value > maxRange;
  }, [minRange, maxRange]);
  var styles = useSprings(keys.length, keys.map(function (key) {
    var value = data[key];
    return {
      from: {
        height: 0
      },
      to: {
        height: clamp(mapValue(value, 0, max, 0, height), 0, height)
      }
    };
  }));
  return Histogram_jsx(Svg, {
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    viewBox: "0 0 ".concat(width, " ").concat(height),
    role: "img"
  }, Histogram_jsx("g", {
    transform: "translate(0,".concat(height, ") scale(1,-1)")
  }, keys.map(function (key, index) {
    return Histogram_jsx("g", {
      key: key,
      className: "bar ".concat(isOutsideRange(key) ? 'outside' : '')
    }, Histogram_jsx(animated.rect, {
      x: Math.floor(mapValue(index, 0, keys.length, 0, width)),
      width: width / keys.length,
      height: styles[index].height
    }));
  })));
};
/* harmony default export */ var components_Histogram = ((/* unused pure expression or super */ null && (Histogram_Histogram)));
// EXTERNAL MODULE: ../shared/src/components/Slider/range.js + 1 modules
var range = __webpack_require__(56693);
// EXTERNAL MODULE: ../../node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__(80594);
;// CONCATENATED MODULE: ../shared/src/hooks/priceRange.js




var UPDATE_FILTERS_DELAY_MS = 300;
var SEARCHABLE_PRICE_LENGTH = 3;
var filterNonDigitChars = function filterNonDigitChars(string) {
  return string.toString().replaceAll(/[^0-9]/g, '');
};
var isEmptyOrDigitsWithOptionalPlus = function isEmptyOrDigitsWithOptionalPlus(string) {
  return /^([0-9]+\+?)?$/g.test(string);
};
var endValueDisplayFormat = function endValueDisplayFormat(value, max) {
  return toMoneyCoreFormat(value) == max ? "".concat(value, "+") : value;
};
var priceRange_usePriceRange = function usePriceRange(_ref, _ref2, onChange) {
  var _ref3 = _slicedToArray(_ref, 2),
    startCoreFormat = _ref3[0],
    endCoreFormat = _ref3[1];
  var _ref4 = _slicedToArray(_ref2, 2),
    min = _ref4[0],
    max = _ref4[1];
  var _useState = useState(function () {
      var _map = [startCoreFormat, endCoreFormat].map(fromMoneyCoreFormat),
        _map2 = _slicedToArray(_map, 2),
        start = _map2[0],
        end = _map2[1];
      return [start, endValueDisplayFormat(end, max)];
    }),
    displayedRange = _useState[0],
    _setDisplayedRange = _useState[1];
  var internalOnChange = function internalOnChange(_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
      start = _ref6[0],
      end = _ref6[1];
    _setDisplayedRange([start, endValueDisplayFormat(end, max)]);
    onChange([start, end]);
  };
  var debouncedOnChange = useCallback(debounce(internalOnChange, UPDATE_FILTERS_DELAY_MS), []);
  var onStartChange = function onStartChange(start) {
    if (!isEmptyOrDigitsWithOptionalPlus(start)) {
      return;
    }
    var _ref7 = [start, displayedRange[1]],
      newStart = _ref7[0],
      newEnd = _ref7[1];
    _setDisplayedRange([newStart, endValueDisplayFormat(newEnd, max)]);
    onRangeChange([newStart, newEnd]);
  };
  var onEndChange = function onEndChange(end) {
    if (!isEmptyOrDigitsWithOptionalPlus(end)) {
      return;
    }
    var _ref8 = [displayedRange[0], end],
      newStart = _ref8[0],
      newEnd = _ref8[1];
    _setDisplayedRange([newStart, endValueDisplayFormat(newEnd, max)]);
    onRangeChange([newStart, newEnd]);
  };
  var onRangeChange = function onRangeChange(_ref9) {
    var _ref10 = _slicedToArray(_ref9, 2),
      start = _ref10[0],
      end = _ref10[1];
    if (start.length < SEARCHABLE_PRICE_LENGTH || end.length < SEARCHABLE_PRICE_LENGTH) {
      debouncedOnChange.cancel();
      return;
    }
    debouncedOnChange([start, end].map(filterNonDigitChars));
  };
  return {
    displayedRange: displayedRange,
    setDisplayedRange: function setDisplayedRange(_ref11) {
      var _ref12 = _slicedToArray(_ref11, 2),
        start = _ref12[0],
        end = _ref12[1];
      return _setDisplayedRange([start, endValueDisplayFormat(end, max)]);
    },
    onStartChange: onStartChange,
    onEndChange: onEndChange
  };
};
// EXTERNAL MODULE: ../shared/src/components/FilterCard/index.js
var components_FilterCard = __webpack_require__(33200);
;// CONCATENATED MODULE: ../shared/src/components/Filters/styles.js

var styles_templateObject;



var FilterContainer = /*#__PURE__*/(/* unused pure expression or super */ null && (styled.div.withConfig({
  componentId: "sc-1loy5yl-0"
})(["align-self:start;width:100%;position:relative;"])));
var styles_ClearFilters = /*#__PURE__*/styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  componentId: "sc-1loy5yl-1"
})(["color:", ";background:none;border:none;padding:0;position:absolute;top:-2px;right:0;cursor:pointer;font-family:IntervalNextReg,sans-serif;font-size:", ";transition:opacity 0.25s ease-in-out;", " &.disabled{opacity:0;}"], function (props) {
  return props.theme.clearButton.color;
}, function (props) {
  return props.theme.rem(14);
}, theme/* mediaMin.smallBreakpoint */.A3.smallBreakpoint(styles_templateObject || (styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n    position: initial;\n    float: right;\n  "]))));
var StickyWrapper = /*#__PURE__*/(/* unused pure expression or super */ null && (styled.div.withConfig({
  componentId: "sc-1loy5yl-2"
})(["position:relative;height:70px;.sticky-inner{width:190px;opacity:0;}&.sticky{.sticky-inner{position:fixed;top:80px;left:auto;right:auto;z-index:1;opacity:1;transition:opacity 1s ease-out;}}"])));

;// CONCATENATED MODULE: ../shared/src/components/Filters/BudgetRange/styles.js

var BudgetRange_styles_templateObject, _templateObject2;





var BudgetRange_styles_Container = /*#__PURE__*/(/* unused pure expression or super */ null && (styled.div.withConfig({
  componentId: "sc-13h9bcj-0"
})(["", " flex-direction:column;height:auto;", "{height:3px;}", "{width:100%;}"], FilterCard, SliderContainer, Svg)));
var styles_Label = /*#__PURE__*/(/* unused pure expression or super */ null && (styled.label.withConfig({
  componentId: "sc-13h9bcj-1"
})(["display:flex;color:#667485;text-align:left;font-size:", ";font-family:IntervalNextReg,sans-serif;"], function (props) {
  return props.theme.rem(14);
})));
var styles_ValuesContainer = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-13h9bcj-2"
})(["display:flex;justify-content:space-between;align-items:center;width:100%;margin-top:", ";", ""], function (props) {
  return props.theme.space(4);
}, theme/* mediaMin.largeBreakpoint */.A3.largeBreakpoint(BudgetRange_styles_templateObject || (BudgetRange_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n    flex-wrap: wrap;\n    gap: ", ";\n  "])), function (props) {
  return props.theme.space(1);
}));
var styles_ValuesSeparator = /*#__PURE__*/styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  componentId: "sc-13h9bcj-3"
})(["width:10px;height:4px;background-color:", ";margin:", " ", ";", ""], function (props) {
  return props.theme.colors.shadyGray;
}, function (props) {
  return props.theme.space(0);
}, function (props) {
  return props.theme.space(3);
}, theme/* mediaMin.largeBreakpoint */.A3.largeBreakpoint(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    display: none;\n  "]))));
;// CONCATENATED MODULE: ../shared/src/components/Filters/BudgetRange/index.js



var BudgetRange_jsx = react.createElement;








var getInitialRange = function getInitialRange(_ref, _ref2) {
  var _ref3 = _slicedToArray(_ref, 2),
    start = _ref3[0],
    end = _ref3[1];
  var _ref4 = _slicedToArray(_ref2, 2),
    min = _ref4[0],
    max = _ref4[1];
  return [start || min, end || max];
};
var RangeFilter = function RangeFilter(_ref5) {
  var start = _ref5.start,
    end = _ref5.end,
    startName = _ref5.startName,
    endName = _ref5.endName,
    _ref5$min = _ref5.min,
    min = _ref5$min === void 0 ? 0 : _ref5$min,
    _ref5$max = _ref5.max,
    max = _ref5$max === void 0 ? 100 : _ref5$max,
    onChange = _ref5.onChange,
    _ref5$histogram = _ref5.histogram,
    histogram = _ref5$histogram === void 0 ? {} : _ref5$histogram,
    _ref5$currencyCode = _ref5.currencyCode,
    currencyCode = _ref5$currencyCode === void 0 ? 'EUR' : _ref5$currencyCode;
  var initialRange = getInitialRange([start, end], [min, max]);
  var _useState = useState(initialRange),
    histogramRange = _useState[0],
    setHistogramRange = _useState[1];
  var _useState2 = useState(initialRange.map(fromMoneyCoreFormat)),
    sliderRange = _useState2[0],
    setSliderRange = _useState2[1];
  var _useTranslation = useTranslation('translations'),
    t = _useTranslation.t;
  var updateFilters = function updateFilters(range) {
    var _onChange;
    var _range$map = range.map(toMoneyCoreFormat),
      _range$map2 = _slicedToArray(_range$map, 2),
      start = _range$map2[0],
      end = _range$map2[1];
    var cappedRangeWithCents = [Math.max(start, min), Math.min(end, max)];
    var cappedRangeWithoutCents = cappedRangeWithCents.map(fromMoneyCoreFormat);
    setHistogramRange(cappedRangeWithCents);
    setSliderRange(cappedRangeWithoutCents);
    onChange((_onChange = {}, _defineProperty(_onChange, startName, cappedRangeWithCents[0]), _defineProperty(_onChange, endName, cappedRangeWithCents[1]), _onChange));
  };
  var _usePriceRange = usePriceRange(initialRange, [min, max], updateFilters),
    displayedRange = _usePriceRange.displayedRange,
    setDisplayedRange = _usePriceRange.setDisplayedRange,
    onStartChange = _usePriceRange.onStartChange,
    onEndChange = _usePriceRange.onEndChange;

  // reset to initial state when filters are cleared
  useEffect(function () {
    var range = getInitialRange([start, end], [min, max]);
    var rangeWithoutCents = range.map(fromMoneyCoreFormat);
    setHistogramRange(range);
    setDisplayedRange(rangeWithoutCents);
    setSliderRange(rangeWithoutCents);
  }, [start, end, min, max]);
  var onSliderChange = function onSliderChange(isDragging, newRange) {
    setDisplayedRange(newRange);
    setHistogramRange(newRange.map(toMoneyCoreFormat));
    if (!isDragging) {
      updateFilters(newRange);
    }
  };
  var onPriceStartInputChange = function onPriceStartInputChange(e) {
    var value = e.target.value;
    onStartChange(value);
  };
  var onPriceEndInputChange = function onPriceEndInputChange(e) {
    var value = e.target.value;
    onEndChange(value);
  };
  var onPriceInputBlur = function onPriceInputBlur() {
    return setDisplayedRange(histogramRange.map(fromMoneyCoreFormat));
  };
  var onPriceInputStartFocus = function onPriceInputStartFocus() {
    return setDisplayedRange(['', displayedRange[1]]);
  };
  var onPriceInputEndFocus = function onPriceInputEndFocus() {
    return setDisplayedRange([displayedRange[0], '']);
  };
  return BudgetRange_jsx(Container, null, BudgetRange_jsx(Histogram, {
    data: histogram,
    range: _toConsumableArray(histogramRange)
  }), BudgetRange_jsx(Range, {
    min: fromMoneyCoreFormat(min),
    max: fromMoneyCoreFormat(max),
    valueMin: parseInt(sliderRange[0], 10),
    valueMax: parseInt(sliderRange[1], 10),
    onChange: onSliderChange,
    step: 10
  }), BudgetRange_jsx(ValuesContainer, null, BudgetRange_jsx(BudgetInput, {
    name: startName,
    value: displayedRange[0],
    label: t('filters.sections.budget.label.min_price'),
    currencyCode: currencyCode,
    onBlur: onPriceInputBlur,
    onFocus: onPriceInputStartFocus,
    onChange: onPriceStartInputChange
  }), BudgetRange_jsx(ValuesSeparator, null), BudgetRange_jsx(BudgetInput, {
    name: endName,
    value: displayedRange[1],
    label: t('filters.sections.budget.label.max_price'),
    currencyCode: currencyCode,
    onBlur: onPriceInputBlur,
    onFocus: onPriceInputEndFocus,
    onChange: onPriceEndInputChange
  })));
};
/* harmony default export */ var Filters_BudgetRange = ((/* unused pure expression or super */ null && (RangeFilter)));
// EXTERNAL MODULE: ../shared/src/hooks/tracking/services/amplitude/dataAmplitude.js
var dataAmplitude = __webpack_require__(79884);
;// CONCATENATED MODULE: ../shared/src/components/Modals/CreateOfferAlertModal/index.js

var CreateOfferAlertModal_jsx = react.createElement;














var CreateOfferAlertModal_CreateOfferAlertModal = function CreateOfferAlertModal(_ref) {
  var onClose = _ref.onClose;
  var _useState = useState(true),
    allowsMarketingCommunications = _useState[0],
    setAllowsMarketingCommunications = _useState[1];
  var _useState2 = useState(''),
    email = _useState2[0],
    setEmail = _useState2[1];
  var _useState3 = useState(false),
    canCreateAlert = _useState3[0],
    setCanCreateAlert = _useState3[1];
  var _useTranslation = useTranslation('translations'),
    t = _useTranslation.t,
    language = _useTranslation.i18n.language;
  var _useContext = useContext(ResourcesContext),
    histogram = _useContext.histogram,
    currency = _useContext.currency;
  var _useRouter = useRouter(),
    query = _useRouter.query;
  var _useTracking = useTracking(),
    track = _useTracking.track,
    events = _useTracking.events;
  var _useContext2 = useContext(ModalContext),
    state = _useContext2.state;
  var _useState4 = useState(function () {
      return {
        budgetMin: query['budget-min'] || 0,
        budgetMax: query['budget-max'] || 250000
      };
    }),
    selectedBudget = _useState4[0],
    setSelectedBudget = _useState4[1];
  var _useState5 = useState(function () {
      return query['rent-type'] || [];
    }),
    selectedRentTypes = _useState5[0],
    setSelectedRentTypes = _useState5[1];
  var termsAndConditionsTranslation = t('create_offer_alert_modal.terms_conditions_description', {
    termsAndConditionsUrl: "".concat("https://uniplaces.com/").concat(language, "/terms/terms-of-service"),
    privacyPolicyUrl: "".concat("https://uniplaces.com/").concat(language, "/terms/privacy-policy")
  });
  var handleRentTypeChange = function handleRentTypeChange(_ref2) {
    var _ref2$target = _ref2.target,
      name = _ref2$target.name,
      checked = _ref2$target.checked;
    var newSelectedRentTypes = checked ? [].concat(_toConsumableArray(selectedRentTypes), [name]) : selectedRentTypes.filter(function (type) {
      return type !== name;
    });
    setSelectedRentTypes(newSelectedRentTypes);
  };
  var handleBudgetChange = function handleBudgetChange(_ref3) {
    var budgetMin = _ref3['budget-min'],
      budgetMax = _ref3['budget-max'];
    return setSelectedBudget({
      budgetMin: budgetMin,
      budgetMax: budgetMax
    });
  };
  var handleCreateAlert = function handleCreateAlert() {
    track(events.offerAlertCreated, {
      acceptedTerms: true,
      budgetMin: selectedBudget.budgetMin,
      budgetMax: selectedBudget.budgetMax,
      email: email,
      rentTypes: selectedRentTypes,
      destinationCity: query.city,
      allowsMarketingCommunications: allowsMarketingCommunications,
      locale: languageToLocale(language)
    });
    trackAmplitude(events.offerAlertCreated, {
      budgetMin: selectedBudget.budgetMin,
      budgetMax: selectedBudget.budgetMax,
      typology: selectedRentTypes,
      destinationCity: query.city,
      source: state.source
    });
    onClose();
  };
  useEffect(function () {
    return setCanCreateAlert(!!email);
  }, [email]);
  return CreateOfferAlertModal_jsx(Modal, {
    style: modalStyle,
    title: t('create_offer_alert_modal.title'),
    onClose: onClose
  }, CreateOfferAlertModal_jsx(Container, null, CreateOfferAlertModal_jsx("p", {
    className: "description"
  }, t('create_offer_alert_modal.description')), CreateOfferAlertModal_jsx(FiltersContainer, null, CreateOfferAlertModal_jsx(RentType, null, CreateOfferAlertModal_jsx("p", null, t('create_offer_alert_modal.looking_for_label')), CreateOfferAlertModal_jsx(Checkbox, {
    name: "property",
    label: t('filters.labels.entireProperty'),
    checked: query['rent-type'] && query['rent-type'].includes('property'),
    onChange: handleRentTypeChange
  }), CreateOfferAlertModal_jsx(Checkbox, {
    name: "unit",
    label: t('filters.labels.bedroom'),
    checked: query['rent-type'] && query['rent-type'].includes('unit'),
    onChange: handleRentTypeChange
  }), CreateOfferAlertModal_jsx(Checkbox, {
    name: "subunit",
    label: t('filters.labels.sharedBedroom'),
    checked: query['rent-type'] && query['rent-type'].includes('subunit'),
    onChange: handleRentTypeChange
  })), CreateOfferAlertModal_jsx(Budget, null, CreateOfferAlertModal_jsx("p", null, t('filters.sections.budget')), CreateOfferAlertModal_jsx(BudgetRange, {
    histogram: histogram,
    onChange: handleBudgetChange,
    start: query['budget-min'],
    end: query['budget-max'],
    startName: "budget-min",
    endName: "budget-max",
    currencyCode: currency,
    min: 0,
    max: 250000
  }))), CreateOfferAlertModal_jsx(CommunicationContainer, null, CreateOfferAlertModal_jsx(Input, {
    type: "email",
    placeholder: t('global.labels.email_address'),
    onChange: function onChange(_ref4) {
      var value = _ref4.target.value;
      return setEmail(value);
    }
  }), CreateOfferAlertModal_jsx(Checkbox, {
    name: "communications",
    label: t('create_offer_alert_modal.marketing_communications_label'),
    value: "true",
    checked: allowsMarketingCommunications,
    onChange: function onChange(_ref5) {
      var checked = _ref5.target.checked;
      return setAllowsMarketingCommunications(checked);
    }
  })), CreateOfferAlertModal_jsx("p", {
    className: "terms-and-conditions",
    dangerouslySetInnerHTML: {
      __html: termsAndConditionsTranslation
    }
  }), CreateOfferAlertModal_jsx(ActionsContainer, null, CreateOfferAlertModal_jsx(Button, {
    isDisabled: !canCreateAlert,
    onClick: handleCreateAlert
  }, t('create_offer_alert_modal.create_button_text')), CreateOfferAlertModal_jsx(Button, {
    className: "submit-button--secondary",
    onClick: onClose
  }, t('global.labels.cancel')))));
};
/* harmony default export */ var Modals_CreateOfferAlertModal = ((/* unused pure expression or super */ null && (CreateOfferAlertModal_CreateOfferAlertModal)));
;// CONCATENATED MODULE: ../shared/src/contexts/location/index.js


var location_jsx = react.createElement;
function location_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function location_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? location_ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : location_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }





var location_LocationContext = /*#__PURE__*/(/* unused pure expression or super */ null && (createContext()));
var LocationProvider = function LocationProvider(_ref) {
  var children = _ref.children,
    initialLocation = _ref.location;
  var router = useRouter();
  var asPath = router.asPath,
    params = router.query;
  var _asPath$split = asPath.split('?'),
    _asPath$split2 = _slicedToArray(_asPath$split, 1),
    pathname = _asPath$split2[0];
  var _useState = useState(initialLocation),
    location = _useState[0],
    setLocation = _useState[1];
  var _ref2 = params.city || [],
    _ref3 = _slicedToArray(_ref2, 1),
    city = _ref3[0];
  var universityQuery = findValueAfterKey(params.city, 'university');
  var neighbourhoodQuery = findValueAfterKey(params.city, 'neighbourhood');
  var transformedLocationPayload = location_objectSpread(location_objectSpread(location_objectSpread(location_objectSpread({}, params), universityQuery ? {
    university: universityQuery
  } : {}), neighbourhoodQuery ? {
    neighbourhood: neighbourhoodQuery
  } : {}), {}, {
    city: city
  });
  var _useState2 = useState(transformedLocationPayload),
    locationPayload = _useState2[0],
    setLocationPayload = _useState2[1];
  var isResidences = pathname.includes('residences');
  var setLocationState = useCallback(function (location) {
    if (!(pathname.includes('accommodation') || isResidences)) {
      return null;
    }
    setPath(router, location_objectSpread(location_objectSpread({}, location), {}, {
      pathname: pathname
    }), isResidences);
  }, [router, location, pathname, isResidences]);
  useEffect(function () {
    var _ref4 = params.city || [],
      _ref5 = _slicedToArray(_ref4, 1),
      city = _ref5[0];
    var universityQuery = findValueAfterKey(params.city, 'university');
    var neighbourhoodQuery = findValueAfterKey(params.city, 'neighbourhood');
    var transformedLocationPayload = location_objectSpread(location_objectSpread(location_objectSpread(location_objectSpread({}, params), universityQuery ? {
      university: universityQuery
    } : {}), neighbourhoodQuery ? {
      neighbourhood: neighbourhoodQuery
    } : {}), {}, {
      city: city
    });
    setLocationPayload(transformedLocationPayload);
  }, [router.query]);
  useEffect(function () {
    if (!locationPayload || isSameLocation(locationPayload, location)) {
      return;
    }
    getLocation(locationPayload).then(setLocation)["catch"](console.error);
  }, [locationPayload]);
  useEffect(function () {
    if (!location || location.configuration.slug === initialLocation.configuration.slug) {
      return;
    }
    setLocationState(location);
  }, [location]);
  return location_jsx(location_LocationContext.Provider, {
    value: [location, setLocationPayload]
  }, children);
};

;// CONCATENATED MODULE: ../shared/src/hooks/search/location.js

var location_excluded = (/* unused pure expression or super */ null && (["type", "city"]));






var INITIAL_CITY_STATE = {
  metadata: {
    name_translations: {
      items: []
    }
  },
  _embedded: {
    country: {
      metadata: {
        name_translations: {
          items: []
        }
      },
      configuration: {
        slug: ''
      }
    }
  }
};
var getTranslationFromLocation = function getTranslationFromLocation(language, location) {
  var locale = languageToLocale(language);
  return locationTranslation(location, locale);
};
var getCityFromLocation = function getCityFromLocation(_ref) {
  var type = _ref.type,
    city = _ref.city,
    location = _objectWithoutProperties(_ref, location_excluded);
  if (type === CITIES) {
    return location;
  }
  return city;
};
var location_useCityLocation = function useCityLocation() {
  var _useTranslation = useTranslation(),
    language = _useTranslation.i18n.language;
  var _useContext = useContext(LocationContext),
    location = _useContext[0],
    setLocation = _useContext[1];
  var initialTranslation = location ? getTranslationFromLocation(language, location) : '';
  var initialCity = location ? getCityFromLocation(location) : INITIAL_CITY_STATE;
  var _useState = useState(initialTranslation),
    translation = _useState[0],
    setTranslation = _useState[1];
  var _useState2 = useState(initialCity),
    city = _useState2[0],
    setCity = _useState2[1];
  useEffect(function () {
    if (!location) {
      return;
    }
    setTranslation(getTranslationFromLocation(language, location));
    setCity(getCityFromLocation(location));
  }, [location, language]);
  return {
    city: city,
    translation: translation,
    location: location,
    setLocation: setLocation
  };
};
// EXTERNAL MODULE: ../shared/src/utils/history/index.js
var utils_history = __webpack_require__(50250);
;// CONCATENATED MODULE: ../shared/src/hooks/search/filterToQueryParameters.js


var filterToQueryParameters_excluded = (/* unused pure expression or super */ null && (["page"]));
function filterToQueryParameters_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function filterToQueryParameters_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? filterToQueryParameters_ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : filterToQueryParameters_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }











var SET_PARAMS = 'set_params';
var ADD_PARAMS = 'add_params';
var CLEAR_PARAMS = 'clear_params';
var filterToQueryParameters_QUERY_PARAMS_KEYS = {
  ORDER: 'order',
  PAGE: 'page'
};
var paramsReducer = function paramsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref = arguments.length > 1 ? arguments[1] : undefined,
    type = _ref.type,
    payload = _ref.payload;
  switch (type) {
    case SET_PARAMS:
      return payload;
    case ADD_PARAMS:
      {
        return filterToQueryParameters_objectSpread(filterToQueryParameters_objectSpread({}, state), payload);
      }
    case CLEAR_PARAMS:
      return {};
    default:
      state;
  }
};
var filterToQueryParameters_useFilterToQueryParameters = function useFilterToQueryParameters() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref2$submitOnChange = _ref2.submitOnChange,
    submitOnChange = _ref2$submitOnChange === void 0 ? true : _ref2$submitOnChange,
    _ref2$onChange = _ref2.onChange,
    onChange = _ref2$onChange === void 0 ? function (params) {
      return params;
    } : _ref2$onChange;
  var history = useRouter();
  var _useSearchHistory = useSearchHistory(),
    query = _useSearchHistory.query,
    changedParams = _useSearchHistory.changedParams;
  var _useReducer = useReducer(paramsReducer, {}),
    params = _useReducer[0],
    dispatch = _useReducer[1];
  var _useTracking = useTracking(),
    track = _useTracking.track,
    events = _useTracking.events,
    experimentId = _useTracking.experimentId;
  var _useCityLocation = useCityLocation(),
    _useCityLocation$loca = _useCityLocation.location;
  _useCityLocation$loca = _useCityLocation$loca === void 0 ? {} : _useCityLocation$loca;
  var _useCityLocation$loca2 = _useCityLocation$loca.configuration;
  _useCityLocation$loca2 = _useCityLocation$loca2 === void 0 ? {} : _useCityLocation$loca2;
  var slug = _useCityLocation$loca2.slug,
    country_code = _useCityLocation$loca2.country_code;
  var _useContext = useContext(ProfileContext),
    profile = _useContext.profile;

  // external changes to query
  useEffect(function () {
    return dispatch({
      type: CLEAR_PARAMS
    });
  }, [query]);

  // submit the changes handler
  useEffect(function () {
    if (!submitOnChange) {
      return;
    }
    submitHandler();
  }, [params]);
  var fields = useMemo(function () {
    return cleanFields(submitOnChange ? query : filterToQueryParameters_objectSpread(filterToQueryParameters_objectSpread({}, query), params));
  }, [submitOnChange, query, params]);
  var submitHandler = useCallback(function () {
    if (params && !Object.keys(params).length) {
      return;
    }
    var page = params.page,
      restParams = _objectWithoutProperties(params, filterToQueryParameters_excluded);
    var newQuery = filterToQueryParameters_objectSpread(filterToQueryParameters_objectSpread(filterToQueryParameters_objectSpread({}, cleanPage(query)), restParams), page ? {
      page: page
    } : {});
    if (isEqual(query, newQuery)) {
      return;
    }
    setQueryParamsFromObject(history, newQuery);
  }, [history, query, params]);

  // handlers to export
  var clearFieldsHandler = useCallback(function () {
    var payload = Object.keys(query).reduce(function (acc, key) {
      if (key === filterToQueryParameters_QUERY_PARAMS_KEYS.ORDER) {
        return filterToQueryParameters_objectSpread(filterToQueryParameters_objectSpread({}, acc), {}, _defineProperty({}, key, query[key]));
      }
      return filterToQueryParameters_objectSpread(filterToQueryParameters_objectSpread({}, acc), {}, _defineProperty({}, key, undefined));
    }, {});
    dispatch({
      type: SET_PARAMS,
      payload: payload
    });
  }, [query]);
  var onMultiChangeHandler = useCallback(function (payload) {
    var eventParams = filterToQueryParameters_objectSpread(filterToQueryParameters_objectSpread(filterToQueryParameters_objectSpread({}, query), payload), {}, {
      cityName: slug,
      userId: profile && profile.id,
      country: country_code,
      experiment_id: experimentId
    });
    track(events.filtersApplied, filterToQueryParameters_objectSpread({}, eventParams), {
      query: query,
      payload: payload
    });
    trackAmplitude(events.filtersApplied, filterToQueryParameters_objectSpread({}, payload));
    dispatch({
      type: ADD_PARAMS,
      payload: onChange(payload)
    });
  }, [changedParams]);
  var onChangeHandler = useCallback(function (key, value) {
    var forceArray = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isArrayForced = forceArray && value && !(value instanceof Array);
    var payload = isArrayForced ? _defineProperty({}, key, [value]) : _defineProperty({}, key, value);
    onMultiChangeHandler(payload);
  }, [onMultiChangeHandler]);
  var onChangeHandlerForceArray = useCallback(function (key, value) {
    onChangeHandler(key, value, true);
  }, [onMultiChangeHandler]);
  var onChangeEventHandler = useCallback(function (event) {
    var isValueBinary = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var key = event.target.name;
    onChangeHandler(key, getValueFromEvent(event, isValueBinary));
  }, [onChangeHandler]);
  var onChangeEventForceArrayHandler = useCallback(function (event) {
    var key = event.target.name;
    onChangeHandler(key, getValueFromEvent(event), true);
  }, [onChangeHandler]);
  return {
    fields: fields,
    query: query,
    onChangeHandler: onChangeHandler,
    onChangeEventHandler: onChangeEventHandler,
    onChangeEventForceArrayHandler: onChangeEventForceArrayHandler,
    onChangeHandlerForceArray: onChangeHandlerForceArray,
    onMultiChangeHandler: onMultiChangeHandler,
    clearFieldsHandler: clearFieldsHandler,
    submitHandler: submitHandler
  };
};
;// CONCATENATED MODULE: ../shared/src/hooks/search/index.js

// EXTERNAL MODULE: ../shared/src/components/Modal/styles.js
var styles = __webpack_require__(32378);
;// CONCATENATED MODULE: ../shared/src/hooks/useIsScrolledDown/index.js

var DEFAULT_SCROLL_THRESHOLD = 50;
var useIsScrolledDown_useIsScrolledDown = function useIsScrolledDown() {
  var scrollThreshold = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_SCROLL_THRESHOLD;
  var _useState = useState(false),
    isScrolledDown = _useState[0],
    setIsScrolledDown = _useState[1];
  useEffect(function () {
    var scrollListener = window.addEventListener('scroll', function () {
      return setIsScrolledDown(window.scrollY > scrollThreshold);
    });
    (function () {
      return removeEventListener('scroll', scrollListener);
    });
  }, [isScrolledDown]);
  return isScrolledDown;
};
/* harmony default export */ var hooks_useIsScrolledDown = ((/* unused pure expression or super */ null && (useIsScrolledDown_useIsScrolledDown)));
;// CONCATENATED MODULE: ../shared/src/components/Search/FloatingBox/index.js

var FloatingBox_excluded = (/* unused pure expression or super */ null && (["show", "close", "children"]));
var FloatingBox_jsx = react.createElement;



var FloatingBox_FloatingBox = function FloatingBox(_ref) {
  var show = _ref.show,
    close = _ref.close,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, FloatingBox_excluded);
  var ref = useRef();
  var isScrolledDown = useIsScrolledDown();
  return FloatingBox_jsx(Wrapper, {
    show: show,
    ref: ref,
    isScrolledDown: isScrolledDown
  }, FloatingBox_jsx(InnerWrapper, props, children));
};
/* harmony default export */ var Search_FloatingBox = ((/* unused pure expression or super */ null && (FloatingBox_FloatingBox)));
// EXTERNAL MODULE: ../shared/src/components/Unisystem/Button/styles.js
var Button_styles = __webpack_require__(5550);
;// CONCATENATED MODULE: ../shared/src/components/Search/FloatingBox/Filters/styles.js

var Filters_styles_templateObject;




var FloatingBoxWrapper = /*#__PURE__*/(/* unused pure expression or super */ null && (styled(FloatingBox).withConfig({
  componentId: "sc-6kidga-0"
})(["background-color:", ";"], function (props) {
  return props.theme.colors.pearlWhite;
})));
var Filters_styles_FiltersContainer = /*#__PURE__*/(/* unused pure expression or super */ null && (styled.div.withConfig({
  componentId: "sc-6kidga-1"
})(["width:auto;position:relative;& > div:first-of-type{& > div:first-of-type{margin-top:0;}}"])));
var Filters_styles_ClearFilters = /*#__PURE__*/styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  componentId: "sc-6kidga-2"
})(["color:", ";background:none;border:none;padding:0;cursor:pointer;font-family:IntervalNextReg,sans-serif;font-size:", ";transition:opacity 0.25s ease-in-out;", " &.disabled{opacity:0;}"], function (props) {
  return props.theme.clearButton.color;
}, function (props) {
  return props.theme.rem(14);
}, theme/* mediaMin.smallBreakpoint */.A3.smallBreakpoint(Filters_styles_templateObject || (Filters_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n    position: initial;\n    float: right;\n  "]))));
var styles_ClearFiltersWrapper = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-6kidga-3"
})(["--innerPadding:-26px;--inlinePadding:26px;display:flex;align-items:center;justify-content:space-between;width:calc(100% + var(--inlinePadding) * 2);margin-inline:var(--innerPadding);margin-block-end:var(--innerPadding);padding-inline:var(--inlinePadding);height:60px;background:", ";border-top:1px solid ", ";position:sticky;bottom:0;", "{&:hover{background-color:", ";}}button{font-family:IntervalNextReg,sans-serif;}"], function (props) {
  return props.theme.colors.lightest;
}, function (props) {
  return props.theme.colors.shadyGray;
}, Button_styles/* Wrapper */.i, function (props) {
  return props.theme.colors.uniBlue;
});
var styles_StickyWrapper = /*#__PURE__*/(/* unused pure expression or super */ null && (styled.div.withConfig({
  componentId: "sc-6kidga-4"
})(["position:relative;height:70px;.sticky-inner{width:190px;opacity:0;}&.sticky{.sticky-inner{position:fixed;top:80px;left:auto;right:auto;z-index:1;opacity:1;transition:opacity 1s ease-out;}}"])));
var UniresidencesWrapper = /*#__PURE__*/(/* unused pure expression or super */ null && (styled.div.withConfig({
  componentId: "sc-6kidga-5"
})(["margin-bottom:", ";& > div:first-of-type{margin-bottom:", ";}"], function (props) {
  return props.theme.space(5);
}, function (props) {
  return props.theme.space(2);
})));
;// CONCATENATED MODULE: ../shared/src/components/Filters/Group/styles.js

var GroupHeader = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-p43na0-0"
})(["& > span{display:flex;color:", ";font-size:", ";font-weight:600;margin-right:", ";", " strong{font-weight:700;}}display:flex;align-items:center;margin-bottom:", ";"], function (props) {
  return props.theme.filter.groupTitleColor;
}, function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.space(1);
}, function (_ref) {
  var theme = _ref.theme;
  return theme.gap(1);
}, function (props) {
  return props.theme.space(3);
});
var GroupContainer = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-p43na0-1"
})(["margin-bottom:", ";> *:not(:first-child){margin-bottom:", ";}&:active,&:focus{outline:none;}"], function (props) {
  return props.theme.space(5);
}, function (props) {
  return props.theme.space(2);
});
;// CONCATENATED MODULE: ../shared/src/components/Labels/styles.js

var Labels_styles_Label = /*#__PURE__*/styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  componentId: "sc-173lx7y-0"
})(["padding:", ";border-radius:2px;color:", ";font-family:IntervalNextReg,sans-serif;font-weight:600;font-size:", ";text-transform:capitalize;"], function (props) {
  return props.theme.space(2);
}, function (props) {
  return props.theme.labels.color;
}, function (props) {
  return props.theme.rem(14);
});
var NewLabel = /*#__PURE__*/(0,styled_components_browser_esm/* default */.ZP)(Labels_styles_Label).withConfig({
  componentId: "sc-173lx7y-1"
})(["background-color:", ";"], function (props) {
  return props.theme.labels.newBackground;
});
var ExclusiveLabel = /*#__PURE__*/(/* unused pure expression or super */ null && (styled(Labels_styles_Label).withConfig({
  componentId: "sc-173lx7y-2"
})(["background-color:", ";"], function (props) {
  return props.theme.labels.exclusiveBackground;
})));
var VerifiedLabel = /*#__PURE__*/(/* unused pure expression or super */ null && (styled(Labels_styles_Label).withConfig({
  componentId: "sc-173lx7y-3"
})(["background-color:", ";"], function (props) {
  return props.theme.labels.verifiedBackground;
})));
var TrustedLabel = /*#__PURE__*/(/* unused pure expression or super */ null && (styled(Labels_styles_Label).withConfig({
  componentId: "sc-173lx7y-4"
})(["background-color:", ";"], function (props) {
  return props.theme.labels.trustedBackground;
})));
var InstantBookingLabel = /*#__PURE__*/(/* unused pure expression or super */ null && (styled(Labels_styles_Label).withConfig({
  componentId: "sc-173lx7y-5"
})(["background-color:", ";"], function (props) {
  return props.theme.labels.instantBookingBackground;
})));
var SoldOutLabel = /*#__PURE__*/(/* unused pure expression or super */ null && (styled(Labels_styles_Label).withConfig({
  componentId: "sc-173lx7y-6"
})(["background-color:", ";"], function (props) {
  return props.theme.labels.soldOutBackground;
})));
var NewFilterLabel = /*#__PURE__*/(0,styled_components_browser_esm/* default */.ZP)(NewLabel).withConfig({
  componentId: "sc-173lx7y-7"
})(["font-family:IntervalNextReg,sans-serif;font-weight:600;font-size:", ";padding:", ";"], function (props) {
  return props.theme.rem(12);
}, function (props) {
  return props.theme.space();
});
var NoDepositLabel = /*#__PURE__*/(/* unused pure expression or super */ null && (styled(Labels_styles_Label).withConfig({
  componentId: "sc-173lx7y-8"
})(["background-color:", ";"], function (props) {
  return props.theme.labels.noDepositBackground;
})));
var UniplacesExclusiveLabel = /*#__PURE__*/(/* unused pure expression or super */ null && (styled(Labels_styles_Label).withConfig({
  componentId: "sc-173lx7y-9"
})(["width:fit-content;height:29px;font-size:", ";color:", ";background-color:", ";padding-inline:18px;"], function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.typography.invertedColor;
}, function (props) {
  return props.theme.labels.uniplacesExclusive;
})));
// EXTERNAL MODULE: ../shared/src/components/Slider/styles.js
var Slider_styles = __webpack_require__(56089);
;// CONCATENATED MODULE: ../shared/src/components/Filters/TenantCounter/styles.js

var TenantCounter_styles_templateObject;





var TenantCounter_styles_Container = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1h240d7-0"
})(["", " align-items:center;justify-content:space-between;padding:", ";margin:", ";", "{height:5px;width:151px;margin-left:auto;}svg{width:20px;margin-right:", ";g{stroke:", ";}}span{display:flex;}label{text-align:left;display:flex;min-width:85px;}display:flex;cursor:pointer;", "{margin-left:auto;}", ""], components_FilterCard/* default */.Z, function (props) {
  return props.theme.space(1);
}, function (props) {
  return props.theme.space(2);
}, Slider_styles/* Container */.W2, function (props) {
  return props.theme.space(2);
}, function (props) {
  return props.theme.filter.color;
}, NewFilterLabel, theme/* mediaMin.smallBreakpoint */.A3.smallBreakpoint(TenantCounter_styles_templateObject || (TenantCounter_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin: 0;\n    padding: ", ";\n  "])), function (props) {
  return props.theme.space(4);
}));
;// CONCATENATED MODULE: ../shared/src/components/Search/MobileFiltersModals/FiltersModal/styles.js

var FiltersModal_styles_templateObject, styles_templateObject2;






var styles_GlobalStyleDesktop = /*#__PURE__*/(/* unused pure expression or super */ null && (createGlobalStyle(["body{", "{border-radius:0;background:", ";svg.close-icon{background-color:transparent;}}}"], Box, function (props) {
  return props.theme.colors.pearlWhite;
})));
var styles_GlobalStyleMobile = /*#__PURE__*/(0,styled_components_browser_esm/* createGlobalStyle */.vJ)(["body{", "{z-index:5;}", "{border-radius:0;background:", ";width:100%;height:100%;svg.close-icon{background-color:transparent;}}", "{", "}", "{padding-top:", ";padding-bottom:", ";width:100%;height:64px;margin-left:unset;margin-right:unset;& > button:first-of-type{position:initial;}}", "{", "}", "{margin:0;}}"], styles/* Wrapper */.im, styles/* Box */.xu, function (props) {
  return props.theme.colors.pearlWhite;
}, Filters_styles_ClearFilters, theme/* mediaMin.smallBreakpoint */.A3.smallBreakpoint(FiltersModal_styles_templateObject || (FiltersModal_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n        position: relative;\n        text-align: right;\n        top: ", ";\n        right: ", ";\n      "])), function (props) {
  return props.theme.space(-2.5);
}, function (props) {
  return props.theme.space(-3);
}), styles_ClearFiltersWrapper, function (props) {
  return props.theme.space(3);
}, function (props) {
  return props.theme.space(3);
}, GroupContainer, theme/* mediaMin.smallBreakpoint */.A3.smallBreakpoint(styles_templateObject2 || (styles_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n        &:not(:first-child) {\n          margin-bottom: ", ";\n        }\n      "])), function (props) {
  return props.theme.space(6);
}), TenantCounter_styles_Container);
var styles_FiltersWithoutGroup = /*#__PURE__*/(/* unused pure expression or super */ null && (styled.div.withConfig({
  componentId: "sc-1bfzues-0"
})(["margin-bottom:10px;"])));
;// CONCATENATED MODULE: ../shared/src/constants/aggregatedFilterFieldsValue.js
var aggregatedFilterFieldsValue_AGGREGATED_FILTER_FIELDS = {
  'restrictions-occupation': {
    postgraduate: 1,
    undergraduate: 0,
    'professional-placement': 1
  }
};
// EXTERNAL MODULE: ../shared/src/utils/transformers/contracts.js + 10 modules
var contracts = __webpack_require__(46483);
// EXTERNAL MODULE: ../shared/src/utils/date/index.js + 2 modules
var date = __webpack_require__(73544);
;// CONCATENATED MODULE: ../shared/src/utils/filters/index.js






// Counts the aggregated filter fields that have more than one value for a single filter field
var FLEX_MOVE_IN_FILTER = 'flex-move-in';
var filters_countAggregatedFilters = function countAggregatedFilters(fields, filter) {
  var aggregatedKeys = AGGREGATED_FILTER_FIELDS[filter];
  var field = fields[filter];
  if (filter === FLEX_MOVE_IN_FILTER) {
    return 1;
  }
  if (aggregatedKeys === undefined) {
    return field.length;
  }
  return Object.keys(aggregatedKeys).reduce(function (acc, key) {
    return field.find(function (value) {
      return value === key;
    }) ? acc + aggregatedKeys[key] : acc;
  }, 0);
};
var transformFlexMoveIn = function transformFlexMoveIn(t, flexMoveInQuery, language, isInResidencesSearch) {
  if (!flexMoveInQuery) {
    return '';
  }
  if (typeof flexMoveInQuery === 'string') {
    var prefix = !isInResidencesSearch ? "".concat(t('filters.labels.flexible'), " | ") : '';
    return "".concat(prefix).concat(formatDate(new Date(flexMoveInQuery), language, DATE_FORMAT_SHORT_MONTH));
  }
  var sortedflexMoveInQuery = flexMoveInQuery.sort(function (a, b) {
    return new Date(a) - new Date(b);
  });
  return sortedflexMoveInQuery.reduce(function (acc, flexString, index) {
    var monthDate = formatDate(new Date(flexString), language, DATE_FORMAT_SHORT_MONTH);
    if (acc.visited.includes(monthDate)) {
      return acc;
    }
    var group_by = 3;
    var comma = index !== 0 ? ',' : '';
    var isRestOfArrayGroupable = flexMoveInQuery.length >= index + group_by;
    if (isRestOfArrayGroupable) {
      var numberOfConsecutiveMonths = flexMoveInQuery.reduce(function (acc, _, i) {
        var currentIndex = index + i;
        if (acc.emptySpace && acc.sum || currentIndex >= flexMoveInQuery.length) {
          return acc;
        }
        var monthDateSubtractedByIndex = formatDate(sub(new Date(flexMoveInQuery[currentIndex]), {
          months: i
        }), language, DATE_FORMAT_SHORT_MONTH);
        if (monthDateSubtractedByIndex === monthDate) {
          return {
            sum: acc.sum + 1,
            emptySpace: false
          };
        }
        return {
          sum: acc.sum,
          emptySpace: true
        };
      }, {
        sum: 0,
        emptySpace: false
      }).sum;
      if (numberOfConsecutiveMonths >= group_by) {
        var nextDate = formatDate(add(new Date(flexString), {
          months: numberOfConsecutiveMonths - 1
        }), language, DATE_FORMAT_SHORT_MONTH);
        var visitedMonthsArray = Array.from(new Array(numberOfConsecutiveMonths)).map(function (_, i) {
          return formatDate(add(new Date(flexString), {
            months: i
          }), language, DATE_FORMAT_SHORT_MONTH);
        });
        return {
          flexMoveInString: "".concat(acc.flexMoveInString).concat(comma, " ").concat(monthDate, " ").concat(t('global.labels.to'), " ").concat(nextDate),
          visited: [].concat(_toConsumableArray(acc.visited), _toConsumableArray(visitedMonthsArray))
        };
      }
    }
    return {
      flexMoveInString: "".concat(acc.flexMoveInString).concat(comma, " ").concat(monthDate),
      visited: [].concat(_toConsumableArray(acc.visited), [monthDate])
    };
  }, {
    flexMoveInString: !isInResidencesSearch ? "".concat(t('filters.labels.flexible'), " |") : '',
    visited: []
  }).flexMoveInString;
};
// EXTERNAL MODULE: ../shared/src/index.js
var src = __webpack_require__(67824);
;// CONCATENATED MODULE: ../shared/src/components/Filters/Group/index.js
var Group_jsx = react.createElement;




var Group_Group = function Group(_ref) {
  var title = _ref.title,
    children = _ref.children,
    _ref$isNew = _ref.isNew,
    isNew = _ref$isNew === void 0 ? false : _ref$isNew,
    _ref$hasTitle = _ref.hasTitle,
    hasTitle = _ref$hasTitle === void 0 ? true : _ref$hasTitle;
  var _useTranslation = (0,esm/* useTranslation */.$G)('translations'),
    t = _useTranslation.t;
  return Group_jsx(GroupContainer, {
    "aria-labelledby": title,
    tabIndex: "0"
  }, Group_jsx(GroupHeader, null, hasTitle && Group_jsx("span", null, title), isNew && Group_jsx(NewFilterLabel, null, " ", t('global.labels.new'), " ")), children);
};
/* harmony default export */ var Filters_Group = (Group_Group);
;// CONCATENATED MODULE: ../shared/src/components/Filters/Checkbox/styles.js



var Checkbox_styles_Container = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-nx05r1-0"
})(["", "{", " display:flex;align-items:center;cursor:pointer;", " svg{width:auto;}}", "{display:none;&:checked ~ ", "{background:", ";color:", ";border-color:", ";box-shadow:none;}}"], components_Checkbox/* Label */.__, components_FilterCard/* default */.Z, function (props) {
  return props.hasHelperText && 'height: 60px;';
}, components_Checkbox/* Input */.II, components_Checkbox/* Label */.__, function (props) {
  return props.theme.filter.checkbox.checked.background;
}, function (props) {
  return props.theme.filter.checkbox.checked.color;
}, function (props) {
  return props.theme.filter.checkbox.checked.borderColor;
});
var BadgesGroup = /*#__PURE__*/styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  componentId: "sc-nx05r1-1"
})(["display:flex;align-items:center;gap:", ";margin-left:auto;"], function (props) {
  return props.theme.space(1);
});
;// CONCATENATED MODULE: ../shared/src/components/Filters/Checkbox/index.js
var Checkbox_jsx = react.createElement;





var FilterCheckbox = function FilterCheckbox(_ref) {
  var name = _ref.name,
    onChange = _ref.onChange,
    icon = _ref.icon,
    label = _ref.label,
    value = _ref.value,
    _ref$selected = _ref.selected,
    selected = _ref$selected === void 0 ? false : _ref$selected,
    _ref$isNew = _ref.isNew,
    isNew = _ref$isNew === void 0 ? false : _ref$isNew,
    helperText = _ref.helperText;
  var stringifiedValue = value !== undefined && value !== null ? value.toString() : value;
  var _useTranslation = (0,esm/* useTranslation */.$G)('translations'),
    t = _useTranslation.t;
  return Checkbox_jsx(Checkbox_styles_Container, {
    hasHelperText: !!helperText
  }, Checkbox_jsx(components_Checkbox/* default */.ZP, {
    name: name,
    value: stringifiedValue,
    checked: selected,
    onChange: onChange,
    label: label,
    icon: icon,
    helperText: helperText
  }, Checkbox_jsx(BadgesGroup, null, isNew ? Checkbox_jsx(NewFilterLabel, {
    className: "new"
  }, t('global.labels.new')) : null)));
};
/* harmony default export */ var Filters_Checkbox = (/*#__PURE__*/react.memo(FilterCheckbox));
;// CONCATENATED MODULE: ../shared/src/contexts/filters/index.js

var filters_jsx = react.createElement;
function filters_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function filters_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? filters_ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : filters_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var FiltersContext = /*#__PURE__*/(0,react.createContext)(filters_jsx(react.Fragment, null));
var FiltersReducerActions = {
  OPEN_DATES_FILTER: 'openDatesFilter',
  CLOSE_DATES_FILTER: 'closeDatesFilter'
};
var filtersReducer = function filtersReducer(state, _ref) {
  var type = _ref.type;
  switch (type) {
    case FiltersReducerActions.OPEN_DATES_FILTER:
      return filters_objectSpread(filters_objectSpread({}, state), {}, {
        shouldOpenDatesFilter: true
      });
    case FiltersReducerActions.CLOSE_DATES_FILTER:
      return filters_objectSpread(filters_objectSpread({}, state), {}, {
        shouldOpenDatesFilter: false
      });
    default:
      throw Error("[Filters Reducer] Unrecognized action: ".concat(type));
  }
};
var FiltersProvider = function FiltersProvider(_ref2) {
  var children = _ref2.children;
  var _useReducer = useReducer(filtersReducer, {
      shouldOpenDatesFilter: false
    }),
    filters = _useReducer[0],
    dispatch = _useReducer[1];
  return filters_jsx(FiltersContext.Provider, {
    value: {
      filters: filters,
      dispatch: dispatch
    }
  }, children);
};

;// CONCATENATED MODULE: ../shared/src/components/Filters/Groups/Dates.js
var Dates_jsx = react.createElement;







var barcelona = 'barcelona';
var Dates = function Dates(_ref) {
  var fields = _ref.fields,
    onMultiChangeHandler = _ref.onMultiChangeHandler,
    onChangeEventHandler = _ref.onChangeEventHandler;
  var _useRouter = (0,router.useRouter)(),
    params = _useRouter.params;
  var _useTranslation = (0,esm/* useTranslation */.$G)('translations'),
    t = _useTranslation.t;
  var _useContext = (0,react.useContext)(FiltersContext),
    shouldOpenDatesFilter = _useContext.filters.shouldOpenDatesFilter,
    dispatch = _useContext.dispatch;
  var closeDatesFilter = function closeDatesFilter() {
    return dispatch({
      type: FiltersReducerActions.CLOSE_DATES_FILTER
    });
  };
  return Dates_jsx(Filters_Group, {
    title: t('filters.sections.dates')
  }, Dates_jsx(src/* DateRange */.C0, {
    startName: "move-in",
    endName: "move-out",
    startLabel: t('filters.labels.moveIn'),
    endLabel: t('filters.labels.moveOut'),
    start: fields['move-in'],
    end: fields['move-out'],
    onChange: onMultiChangeHandler,
    isBarcelona: params && params.city === barcelona,
    shouldOpenDatesFilter: shouldOpenDatesFilter,
    closeDatesFilter: closeDatesFilter
  }), Dates_jsx(Filters_Checkbox, {
    isNew: true,
    name: "instant-bookings",
    value: "true",
    onChange: onChangeEventHandler,
    selected: fields['instant-bookings'] === 'true',
    label: t('global.labels.instant_booking')
  }));
};
/* harmony default export */ var Groups_Dates = (Dates);
// EXTERNAL MODULE: ../shared/src/contexts/media/index.js
var media = __webpack_require__(98680);
;// CONCATENATED MODULE: ../shared/src/components/Filters/Groups/Place.js
var Place_jsx = react.createElement;





var Place = function Place(_ref) {
  var fields = _ref.fields,
    onChangeEventHandler = _ref.onChangeEventHandler,
    onChangeEventForceArrayHandler = _ref.onChangeEventForceArrayHandler;
  var _useTranslation = (0,esm/* useTranslation */.$G)('translations'),
    t = _useTranslation.t;
  var _useContext = (0,react.useContext)(media/* MediaContext */.Y),
    is = _useContext.is;
  var rentType = fields['rent-type'];
  var housingType = fields['housing-type'];
  return Place_jsx(Filters_Group, {
    title: t('filters.sections.places')
  }, Place_jsx(Filters_Checkbox, {
    name: "rent-type",
    value: "property",
    onChange: onChangeEventHandler,
    selected: rentType && (rentType.includes('property') || rentType.includes('entire-house')),
    label: t('filters.labels.entireProperty')
  }), Place_jsx(Filters_Checkbox, {
    name: "rent-type",
    value: "unit",
    onChange: onChangeEventHandler,
    selected: rentType && (rentType.includes('unit') || rentType.includes('private-bedroom')),
    label: t('filters.labels.bedroom')
  }), Place_jsx(Filters_Checkbox, {
    name: "rent-type",
    value: "subunit",
    onChange: onChangeEventHandler,
    selected: rentType && (rentType.includes('subunit') || rentType.includes('shared-bedroom')),
    label: t('filters.labels.sharedBedroom')
  }), is.mobile ? Place_jsx(Filters_Checkbox, {
    isResidence: true,
    isNew: true,
    name: "housing-type",
    value: "residence",
    onChange: onChangeEventForceArrayHandler,
    selected: housingType && housingType.includes('residence'),
    label: t('filters.labels.studentResidence')
  }) : null);
};
/* harmony default export */ var Groups_Place = (Place);
// EXTERNAL MODULE: ../shared/src/components/Counter/index.js + 2 modules
var Counter = __webpack_require__(98600);
;// CONCATENATED MODULE: ../shared/src/constants/tenantTypes.js
var GUESTS = 'guests';

;// CONCATENATED MODULE: ../shared/src/components/Filters/TenantCounter/index.js
var TenantCounter_jsx = react.createElement;





var TenantCounter = function TenantCounter(_ref) {
  var min = _ref.min,
    max = _ref.max,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? 1 : _ref$value,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
    labelTranslation = _ref.labelTranslation,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? null : _ref$icon;
  var _useTranslation = (0,esm/* useTranslation */.$G)('translations'),
    t = _useTranslation.t;
  var onChangeWithIndicator = (0,react.useCallback)(function (value) {
    onChange(GUESTS, value > min ? value : null);
  }, [labelTranslation, onChange, value]);
  return TenantCounter_jsx(TenantCounter_styles_Container, null, TenantCounter_jsx("span", null, icon, TenantCounter_jsx("label", null, t(labelTranslation, {
    count: value
  }))), TenantCounter_jsx(Counter/* default */.Z, {
    min: min,
    max: max,
    value: value,
    onUpdate: onChangeWithIndicator
  }));
};
/* harmony default export */ var Filters_TenantCounter = (TenantCounter);
;// CONCATENATED MODULE: ../shared/src/components/Filters/Groups/Tenants.js

var Tenants_jsx = react.createElement;






var minGuests = 1;
var maxGuests = 12;
var Icon = Tenants_jsx(src/* PeopleIcon */.t0, {
  width: 20
});
var Tenants = function Tenants(_ref) {
  var fields = _ref.fields,
    onMultiChangeHandler = _ref.onMultiChangeHandler;
  var _useTranslation = (0,esm/* useTranslation */.$G)('translations'),
    t = _useTranslation.t;
  var _useMedia = (0,src/* useMedia */.GS)(),
    is = _useMedia.is;
  var onGuestsChangeHandler = (0,react.useCallback)(function (name, value) {
    onMultiChangeHandler((0,defineProperty/* default */.Z)({}, name, value));
  }, [onMultiChangeHandler]);
  return Tenants_jsx(Filters_Group, {
    hasTitle: is.mobile,
    title: t('filters.sections.set_people')
  }, Tenants_jsx(Filters_TenantCounter, {
    icon: Icon,
    min: minGuests,
    max: maxGuests,
    value: fields[GUESTS],
    onChange: onGuestsChangeHandler,
    labelTranslation: "filters.label.number_of_tenants"
  }));
};
/* harmony default export */ var Groups_Tenants = (Tenants);
;// CONCATENATED MODULE: ../shared/src/components/Filters/Groups/Landlord.js
var Landlord_jsx = react.createElement;




var HIGH_RESPONSE_RATE = 80;
var MAX_RESPONSE_TIME = 12;
var Landlord = function Landlord(_ref) {
  var fields = _ref.fields,
    onChangeEventHandler = _ref.onChangeEventHandler;
  var _useTranslation = (0,esm/* useTranslation */.$G)('translations'),
    t = _useTranslation.t;
  return Landlord_jsx(Filters_Group, {
    title: t('filters.sections.landlord')
  }, Landlord_jsx(Filters_Checkbox, {
    name: "instant-bookings",
    value: "true",
    onChange: onChangeEventHandler,
    selected: fields['instant-bookings'] === 'true',
    label: t('global.labels.instant_booking')
  }), Landlord_jsx(Filters_Checkbox, {
    name: "max-response-time",
    value: MAX_RESPONSE_TIME,
    onChange: onChangeEventHandler,
    selected: parseInt(fields['max-response-time'], 10) === MAX_RESPONSE_TIME,
    label: t('filters.labels.answers_within_12_hours')
  }), Landlord_jsx(Filters_Checkbox, {
    name: "min-response-rate",
    value: HIGH_RESPONSE_RATE,
    onChange: onChangeEventHandler,
    selected: parseInt(fields['min-response-rate'], 10) === HIGH_RESPONSE_RATE,
    label: t('filters.labels.high_response_rate')
  }), Landlord_jsx(Filters_Checkbox, {
    name: "has-resident-landlord",
    value: false,
    onChange: onChangeEventHandler,
    selected: fields['has-resident-landlord'] === 'false',
    label: t('filters.labels.no_resident_landlord')
  }));
};
/* harmony default export */ var Groups_Landlord = (Landlord);
// EXTERNAL MODULE: ../shared/src/components/Counter/styles.js
var Counter_styles = __webpack_require__(59841);
;// CONCATENATED MODULE: ../shared/src/components/Filters/FilterCounter/styles.js

var FilterCounter_styles_templateObject, FilterCounter_styles_templateObject2;





var FilterCounter_styles_Container = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-tugdj5-0"
})(["display:flex;cursor:pointer;align-items:center;justify-content:space-between;padding-inline:10px;height:50px;margin-bottom:", ";background:", ";border-radius:4px;box-shadow:0px 1px 2px 0px #00000014;& + div{margin-top:0;}", "{height:5px;width:151px;margin-left:auto;}svg{width:20px;margin-right:", ";g{stroke:", ";}}span{display:flex;align-items:center;}label{text-align:left;display:flex;min-width:85px;", "}", "{margin-left:auto;}", "{span{font-size:", ";color:", ";}}", ""], function (props) {
  return props.theme.space(2);
}, function (props) {
  return props.theme.filter.background;
}, Slider_styles/* Container */.W2, function (props) {
  return props.theme.space(2);
}, function (props) {
  return props.theme.filter.color;
}, theme/* mediaMin.mediumBreakpoint */.A3.mediumBreakpoint(FilterCounter_styles_templateObject || (FilterCounter_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n      font-size: ", ";\n      color: ", ";\n    "])), function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.colors.paleSky;
}), NewFilterLabel, Counter_styles/* Wrapper */.i, function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.colors.paleSky;
}, theme/* mediaMin.smallBreakpoint */.A3.smallBreakpoint(FilterCounter_styles_templateObject2 || (FilterCounter_styles_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin: 0;\n    padding: ", ";\n  "])), function (props) {
  return props.theme.space(4);
}));
;// CONCATENATED MODULE: ../shared/src/components/Filters/FilterCounter/index.js
var FilterCounter_jsx = react.createElement;



var FilterCounter = function FilterCounter(_ref) {
  var name = _ref.name,
    min = _ref.min,
    max = _ref.max,
    value = _ref.value,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
    labelTranslation = _ref.labelTranslation,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? null : _ref$icon;
  var onChangeWithIndicator = (0,react.useCallback)(function (value) {
    return onChange(name, value);
  }, [labelTranslation, onChange]);
  return FilterCounter_jsx(FilterCounter_styles_Container, null, FilterCounter_jsx("span", null, icon, FilterCounter_jsx("label", null, labelTranslation)), FilterCounter_jsx(Counter/* default */.Z, {
    min: min,
    max: max,
    value: value,
    onUpdate: onChangeWithIndicator
  }));
};
/* harmony default export */ var Filters_FilterCounter = (FilterCounter);
;// CONCATENATED MODULE: ../shared/src/components/Filters/Groups/Typology.js

var Typology_jsx = react.createElement;






var getMaxCount = function getMaxCount(typology) {
  if (!typology) {
    return 0;
  }
  var valueArray = "".concat(typology).split(',');
  return Number(valueArray.length === 1 ? typology : Math.max.apply(Math, (0,toConsumableArray/* default */.Z)(valueArray)));
};
var Typology = function Typology(_ref) {
  var fields = _ref.fields,
    onChangeEventHandler = _ref.onChangeEventHandler,
    onChangeHandlerForceArray = _ref.onChangeHandlerForceArray;
  var _useTranslation = (0,esm/* useTranslation */.$G)('translations'),
    t = _useTranslation.t;
  var ensuite = fields.ensuite,
    bedrooms = fields.bedrooms,
    bathrooms = fields.bathrooms;
  return Typology_jsx(Filters_Group, {
    title: t('filters.sections.typology')
  }, Typology_jsx(Filters_FilterCounter, {
    icon: Typology_jsx(src/* BedroomsIcon */.vs, null),
    name: "bedrooms",
    min: 0,
    max: 4,
    value: getMaxCount(bedrooms),
    onChange: onChangeHandlerForceArray,
    labelTranslation: t('filters.labels.bedroom_general')
  }), Typology_jsx(Filters_FilterCounter, {
    icon: Typology_jsx(src/* BathroomsIcon */.$v, null),
    name: "bathrooms",
    min: 0,
    max: 4,
    value: getMaxCount(bathrooms),
    onChange: onChangeHandlerForceArray,
    labelTranslation: t('filters.labels.bathrooms_general')
  }), Typology_jsx(Filters_Checkbox, {
    name: "ensuite",
    value: true,
    onChange: onChangeEventHandler,
    selected: ensuite && ensuite === 'true',
    label: t('filters.labels.private_bathroom')
  }));
};
/* harmony default export */ var Groups_Typology = (Typology);
// EXTERNAL MODULE: ../shared/src/utils/countryTranslation/index.js
var countryTranslation = __webpack_require__(47839);
;// CONCATENATED MODULE: ../shared/src/components/Filters/Groups/styles.js

var Groups_styles_templateObject;


var styles_GroupItemsContainer = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1bchauu-0"
})(["display:grid;grid-template-columns:1fr 1fr;gap:9px;", ""], theme/* mediaMin.compactPhoneBreakpoint */.A3.compactPhoneBreakpoint(Groups_styles_templateObject || (Groups_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n    display: flex;\n    flex-direction: column;\n  "]))));
var FilterDescription = /*#__PURE__*/styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  componentId: "sc-1bchauu-1"
})(["font-size:", ";color:", ";span{font-style:italic;padding-inline-start:2px;}"], function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.checkbox.color;
});
;// CONCATENATED MODULE: ../shared/src/components/Filters/Groups/Registration.js
var Registration_jsx = react.createElement;






var localRegistrationNamesByCountry = {
  spain: 'Empadronamiento',
  germany: 'Anmeldung',
  italy: 'Certificato di Residenza',
  portugal: 'Certificado de Registro',
  // eslint-disable-next-line quotes
  france: "Certificat d'immatriculation"
};
var getLocalRegistrationName = function getLocalRegistrationName(location) {
  var countrySlug = (0,countryTranslation/* getCountrySlugFromLocation */.Xl)(location);
  return countrySlug && localRegistrationNamesByCountry[countrySlug] ? "(".concat(localRegistrationNamesByCountry[countrySlug], ")") : undefined;
};
var Registration_Registration = function Registration(_ref) {
  var fields = _ref.fields,
    onChangeEventHandler = _ref.onChangeEventHandler,
    _ref$location = _ref.location,
    location = _ref$location === void 0 ? {} : _ref$location;
  var _useTranslation = (0,esm/* useTranslation */.$G)('translations'),
    t = _useTranslation.t;
  var localRegistrationName = getLocalRegistrationName(location);
  return Registration_jsx(Filters_Group, {
    title: t('filters.sections.registration')
  }, Registration_jsx(FilterDescription, null, t('filters.description.official_registration'), localRegistrationName ? Registration_jsx("span", null, localRegistrationName) : null), Registration_jsx(Filters_Checkbox, {
    name: 'has-official-registration',
    value: true,
    onChange: onChangeEventHandler,
    selected: fields['has-official-registration'] === 'true',
    label: t('global.labels.registration_possible')
  }));
};
/* harmony default export */ var Groups_Registration = (Registration_Registration);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
;// CONCATENATED MODULE: ../shared/src/components/Filters/Groups/utils.js

var utils_excluded = ["fields"],
  _excluded2 = ["fields"];

var getFieldsAreEqual = function getFieldsAreEqual() {
  var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return function (prevProps, nextProps) {
    if (!prevProps) {
      return false;
    }
    if (!keys.length) {
      return lodash_isequal_default()(prevProps, nextProps);
    }
    var prevFields = prevProps.fields,
      comparablePrevProps = (0,objectWithoutProperties/* default */.Z)(prevProps, utils_excluded);
    var nextFields = nextProps.fields,
      comparableNextProps = (0,objectWithoutProperties/* default */.Z)(nextProps, _excluded2);
    return lodash_isequal_default()(comparableNextProps, comparablePrevProps) && !keys.some(function (key) {
      return !lodash_isequal_default()(prevFields[key], nextFields[key]);
    });
  };
};
;// CONCATENATED MODULE: ../shared/src/components/Filters/Groups/index.js








var memoizeComponent = function memoizeComponent(component) {
  return function (fields) {
    var areEqual = getFieldsAreEqual(fields);
    return /*#__PURE__*/react.memo(component, areEqual);
  };
};
var DatesGroup = memoizeComponent(Groups_Dates);
var PlacesGroup = memoizeComponent(Groups_Place);
var TenantsGroup = memoizeComponent(Groups_Tenants);
var LandlordGroup = memoizeComponent(Groups_Landlord);
var TypologyGroup = memoizeComponent(Groups_Typology);
var RegistrationGroup = memoizeComponent(Groups_Registration);

;// CONCATENATED MODULE: ../shared/src/components/Filters/Groups/Bedroom.js


var _filters;
var Bedroom_jsx = react.createElement;





var filters = (_filters = {}, (0,defineProperty/* default */.Z)(_filters, 'bed-type', ['single-bed', 'double-bed', 'twin-bed', 'multiple-bed']), (0,defineProperty/* default */.Z)(_filters, 'offer-features', ['wardrobe', 'window', 'balcony', 'desk', 'lock', 'unfurnished']), _filters);
var Bedroom_Bedroom = function Bedroom(_ref) {
  var fields = _ref.fields,
    onChangeEventHandler = _ref.onChangeEventHandler;
  var _useTranslation = useTranslation('translations'),
    t = _useTranslation.t;
  return Bedroom_jsx(Group, {
    title: t('filters.sections.bedroom')
  }, Bedroom_jsx(GroupItemsContainer, null, Object.entries(filters).map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
      filter = _ref3[0],
      values = _ref3[1];
    return values.map(function (value) {
      return Bedroom_jsx(CheckboxFilter, {
        key: value,
        name: filter,
        value: value,
        onChange: onChangeEventHandler,
        selected: fields[filter] && fields[filter].includes(value),
        label: t("filters.labels.".concat(filter, ".").concat(value))
      });
    });
  })));
};
/* harmony default export */ var Groups_Bedroom = ((/* unused pure expression or super */ null && (Bedroom_Bedroom)));
// EXTERNAL MODULE: ../shared/src/constants/propertyFeatures.js
var propertyFeatures = __webpack_require__(3373);
;// CONCATENATED MODULE: ../shared/src/components/Filters/Groups/House.js
var House_jsx = react.createElement;






var filtersCategory = 'property-features';
var House_House = function House(_ref) {
  var fields = _ref.fields,
    onChangeEventHandler = _ref.onChangeEventHandler;
  var _useTranslation = useTranslation('translations'),
    t = _useTranslation.t;
  var filters = Object.values(PROPERTY_FEATURES);
  return House_jsx(Group, {
    title: t('filters.sections.house-features')
  }, House_jsx(GroupItemsContainer, null, filters.map(function (filter) {
    return House_jsx(CheckboxFilter, {
      key: filter,
      name: filtersCategory,
      value: filter,
      onChange: onChangeEventHandler,
      selected: fields[filtersCategory] && fields[filtersCategory].includes(filter),
      label: t("filters.labels.".concat(filtersCategory, ".").concat(filter))
    });
  })));
};
/* harmony default export */ var Groups_House = ((/* unused pure expression or super */ null && (House_House)));
;// CONCATENATED MODULE: ../shared/src/components/Filters/Groups/Verification.js
var Verification_jsx = react.createElement;





var Verification_GroupItemsContainer = /*#__PURE__*/(/* unused pure expression or super */ null && (styled.div.withConfig({
  componentId: "sc-1xvts6v-0"
})(["display:flex;flex-direction:column;gap:9px;"])));
var Verification_filters = (/* unused pure expression or super */ null && (['has-trusted-landlord', 'has-checked-place']));
var Verification_Verification = function Verification(_ref) {
  var fields = _ref.fields,
    onChangeEventHandler = _ref.onChangeEventHandler;
  var _useTranslation = useTranslation('translations'),
    t = _useTranslation.t;
  return Verification_jsx(Group, {
    title: t('filters.sections.verification')
  }, Verification_jsx(Verification_GroupItemsContainer, null, Verification_filters.map(function (filter) {
    return Verification_jsx(CheckboxFilter, {
      key: filter,
      name: filter,
      value: true,
      onChange: onChangeEventHandler,
      selected: fields[filter],
      label: t("filters.labels.".concat(filter))
    });
  })));
};
/* harmony default export */ var Groups_Verification = ((/* unused pure expression or super */ null && (Verification_Verification)));
;// CONCATENATED MODULE: ../shared/src/components/Filters/Groups/SuitableFor.js

var SuitableFor_filters;
var SuitableFor_jsx = react.createElement;





var restrictionsOccupation = 'restrictions-occupation';
var rules = 'rules';
var restrictionsOccupancy = 'restrictions-occupancy';
var Groups_SuitableFor_filters = (SuitableFor_filters = {}, (0,defineProperty/* default */.Z)(SuitableFor_filters, restrictionsOccupation, [['postgraduate', 'undergraduate'], ['professional-placement']]), (0,defineProperty/* default */.Z)(SuitableFor_filters, rules, ['smoking-allowed', 'pets-allowed', 'overnight-guests-allowed']), (0,defineProperty/* default */.Z)(SuitableFor_filters, restrictionsOccupancy, ['couples']), SuitableFor_filters);
var SuitableFor_SuitableFor = function SuitableFor(_ref) {
  var fields = _ref.fields,
    onChangeEventHandler = _ref.onChangeEventHandler,
    onChangeEventForceArrayHandler = _ref.onChangeEventForceArrayHandler;
  var _useTranslation = useTranslation('translations'),
    t = _useTranslation.t;
  var onRestrictionsOccupancyChange = function onRestrictionsOccupancyChange(event) {
    return onChangeEventForceArrayHandler(event);
  };
  return SuitableFor_jsx(Group, {
    title: t('filters.sections.suitable_for')
  }, SuitableFor_jsx(GroupItemsContainer, null, Groups_SuitableFor_filters[restrictionsOccupation].map(function (value) {
    return SuitableFor_jsx(CheckboxFilter, {
      key: value,
      name: restrictionsOccupation,
      value: value,
      onChange: onChangeEventHandler,
      selected: fields['restrictions-occupation'] && value.every(function (value) {
        return fields[restrictionsOccupation].includes(value);
      }),
      label: t("filters.labels.".concat(restrictionsOccupation, ".").concat(value))
    });
  }), Groups_SuitableFor_filters[rules].map(function (value) {
    return SuitableFor_jsx(CheckboxFilter, {
      key: value,
      name: rules,
      value: value,
      onChange: onChangeEventHandler,
      selected: fields[rules] && fields[rules].includes(value),
      label: t("filters.labels.rules.".concat(value))
    });
  }), Groups_SuitableFor_filters[restrictionsOccupancy].map(function (value) {
    return SuitableFor_jsx(CheckboxFilter, {
      key: value,
      name: restrictionsOccupancy,
      value: value,
      onChange: onRestrictionsOccupancyChange,
      selected: fields[restrictionsOccupancy] && fields[restrictionsOccupancy].includes(value),
      label: t("filters.labels.".concat(restrictionsOccupancy, ".").concat(value))
    });
  })));
};
/* harmony default export */ var Groups_SuitableFor = ((/* unused pure expression or super */ null && (SuitableFor_SuitableFor)));
;// CONCATENATED MODULE: ../shared/src/components/Filters/Groups/Budget.js
var Budget_jsx = react.createElement;





var minPrice = 0;
var maxPrice = 250000;
var Budget_Budget = function Budget(_ref) {
  var fields = _ref.fields,
    onMultiChangeHandler = _ref.onMultiChangeHandler,
    onChangeEventHandler = _ref.onChangeEventHandler,
    _ref$priceHistogram = _ref.priceHistogram,
    priceHistogram = _ref$priceHistogram === void 0 ? {} : _ref$priceHistogram,
    _ref$currency = _ref.currency,
    currency = _ref$currency === void 0 ? 'EUR' : _ref$currency;
  var _useTranslation = useTranslation('translations'),
    t = _useTranslation.t;
  return Budget_jsx(Group, {
    title: t('filters.sections.budget')
  }, Budget_jsx(BudgetRange, {
    histogram: priceHistogram,
    onChange: onMultiChangeHandler,
    start: fields['budget-min'],
    end: fields['budget-max'],
    startName: "budget-min",
    endName: "budget-max",
    currencyCode: currency,
    min: minPrice,
    max: maxPrice
  }), Budget_jsx(CheckboxFilter, {
    name: "bills-included",
    value: "true",
    onChange: onChangeEventHandler,
    selected: fields['bills-included'] === 'true',
    label: t('global.labels.with_bills')
  }));
};
/* harmony default export */ var Groups_Budget = ((/* unused pure expression or super */ null && (Budget_Budget)));
// EXTERNAL MODULE: ../shared/src/components/Unisystem/Button/index.js + 1 modules
var Unisystem_Button = __webpack_require__(99964);
// EXTERNAL MODULE: ../shared/src/constants/genderRestrictions.js
var genderRestrictions = __webpack_require__(9292);
;// CONCATENATED MODULE: ../shared/src/components/Filters/Groups/GenderPreferences.js
var GenderPreferences_jsx = react.createElement;





var FEMALE_ROOM = genderRestrictions/* GENDER_RESTRICTIONS.FEMALE_ROOM */.y.FEMALE_ROOM,
  FEMALE_PROPERTY = genderRestrictions/* GENDER_RESTRICTIONS.FEMALE_PROPERTY */.y.FEMALE_PROPERTY,
  MALE_ROOM = genderRestrictions/* GENDER_RESTRICTIONS.MALE_ROOM */.y.MALE_ROOM,
  MALE_PROPERTY = genderRestrictions/* GENDER_RESTRICTIONS.MALE_PROPERTY */.y.MALE_PROPERTY;
var GENDER_RESTRICTIONS_CHECKBOXES = [{
  filter: FEMALE_ROOM,
  text: 'Female-only room',
  subtext: 'May share common areas with any gender.'
}, {
  filter: FEMALE_PROPERTY,
  text: 'All-female property',
  subtext: 'Entire property is restricted to women only.'
}, {
  filter: MALE_ROOM,
  text: 'Male-only room',
  subtext: 'May share common areas with any gender.'
}, {
  filter: MALE_PROPERTY,
  text: 'All-male property',
  subtext: 'Entire property is restricted to men only.'
}];
var GenderPreferences_GenderPreferences = function GenderPreferences(_ref) {
  var fields = _ref.fields,
    onChangeEventHandler = _ref.onChangeEventHandler;
  var _useTranslation = useTranslation('translations'),
    t = _useTranslation.t;
  var onGenderFiltersChange = function onGenderFiltersChange(event) {
    return onChangeEventHandler(event, true);
  };
  return GenderPreferences_jsx(Group, {
    title: t('Gender preferences')
  }, GENDER_RESTRICTIONS_CHECKBOXES.map(function (_ref2) {
    var filter = _ref2.filter,
      text = _ref2.text,
      subtext = _ref2.subtext;
    return GenderPreferences_jsx(CheckboxFilter, {
      key: filter,
      name: 'restrictions-gender',
      value: filter,
      onChange: onGenderFiltersChange,
      selected: fields['restrictions-gender'] && fields['restrictions-gender'] === filter,
      label: t(text),
      helperText: t(subtext)
    });
  }));
};
/* harmony default export */ var Groups_GenderPreferences = ((/* unused pure expression or super */ null && (GenderPreferences_GenderPreferences)));
;// CONCATENATED MODULE: ../shared/src/components/Search/MobileFiltersModals/FiltersModal/index.js

var FiltersModal_jsx = react.createElement;
function FiltersModal_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function FiltersModal_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? FiltersModal_ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : FiltersModal_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }



















var Places = PlacesGroup(['housing-type', 'rent-type']);
var FiltersModal_Tenants = TenantsGroup(['guests', 'restrictions-occupancy']);
var FiltersModal_Landlord = LandlordGroup(['min-response-rate', 'has-resident-landlord', 'max-response-rate']);
var FiltersModal_Typology = TypologyGroup(['bedrooms', 'bathrooms', 'ensuite']);
var unsetPageField = function unsetPageField(fields) {
  return FiltersModal_objectSpread(FiltersModal_objectSpread({}, fields), {}, _defineProperty({}, QUERY_PARAMS_KEYS.PAGE, undefined));
};
var FiltersModal_FiltersModal = function FiltersModal(_ref) {
  var onClose = _ref.onClose,
    numberOfFiltersApplied = _ref.numberOfFiltersApplied,
    setNumberOfFiltersApplied = _ref.setNumberOfFiltersApplied,
    _ref$location = _ref.location,
    location = _ref$location === void 0 ? {} : _ref$location;
  var _useContext = useContext(ResourcesContext),
    count = _useContext.count;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useMedia = useMedia(),
    is = _useMedia.is;
  var _useFilterToQueryPara = useFilterToQueryParameters({
      onChange: unsetPageField
    }),
    fields = _useFilterToQueryPara.fields,
    onChangeEventHandler = _useFilterToQueryPara.onChangeEventHandler,
    onChangeEventForceArrayHandler = _useFilterToQueryPara.onChangeEventForceArrayHandler,
    onMultiChangeHandler = _useFilterToQueryPara.onMultiChangeHandler,
    onChangeHandler = _useFilterToQueryPara.onChangeHandler,
    onChangeHandlerForceArray = _useFilterToQueryPara.onChangeHandlerForceArray,
    clearFieldsHandler = _useFilterToQueryPara.clearFieldsHandler;
  var _useContext2 = useContext(ResourcesContext),
    histogram = _useContext2.histogram,
    currency = _useContext2.currency;
  var _useState = useState(numberOfFiltersApplied),
    numberOfFiltersToClear = _useState[0],
    setNumberOfFiltersToClear = _useState[1];
  useEffect(function () {
    var filtersLength = Object.keys(fields).reduce(function (acc, filter) {
      return Array.isArray(fields[filter]) ? acc + countAggregatedFilters(fields, filter) : acc + 1;
    }, 0);
    setNumberOfFiltersApplied(filtersLength);
    setNumberOfFiltersToClear(filtersLength);
  }, [fields]);
  var footerInfo = FiltersModal_jsx(ClearFiltersWrapper, null, FiltersModal_jsx(ClearFilters, {
    className: numberOfFiltersToClear ? null : 'disabled',
    onClick: clearFieldsHandler
  }, t('filters.labels.clearFilters', {
    number: numberOfFiltersToClear
  })), FiltersModal_jsx(Button, {
    isPrimary: true,
    onClick: onClose
  }, t('filters.labels.show_listings', {
    count: count
  })));
  var GlobalStyle = useMemo(function () {
    return is.mobile ? GlobalStyleMobile : GlobalStyleDesktop;
  }, [is.mobile]);
  return FiltersModal_jsx(Modal, {
    onClose: onClose,
    footer: footerInfo
  }, FiltersModal_jsx(GlobalStyle, null), FiltersModal_jsx(FiltersWithoutGroup, null, FiltersModal_jsx(CheckboxFilter, {
    isNew: true,
    name: "exclusive",
    value: true,
    onChange: onChangeEventHandler,
    selected: fields['exclusive'],
    label: t('global.labels.has-exclusive')
  })), FiltersModal_jsx(Budget, {
    priceHistogram: histogram,
    fields: fields,
    currency: currency,
    onChangeEventHandler: onChangeEventHandler,
    onMultiChangeHandler: onMultiChangeHandler
  }), FiltersModal_jsx(FiltersModal_Tenants, {
    fields: fields,
    onMultiChangeHandler: onMultiChangeHandler,
    onChangeEventForceArrayHandler: onChangeEventForceArrayHandler,
    onChangeHandler: onChangeHandler
  }), FiltersModal_jsx(Places, {
    onChangeEventHandler: onChangeEventHandler,
    onChangeEventForceArrayHandler: onChangeEventForceArrayHandler,
    fields: fields
  }), FiltersModal_jsx(FiltersModal_Landlord, {
    fields: fields,
    onChangeEventHandler: onChangeEventHandler
  }), FiltersModal_jsx(GenderPreferences, {
    fields: fields,
    onChangeEventHandler: onChangeEventHandler,
    onChangeEventForceArrayHandler: onChangeEventForceArrayHandler
  }), FiltersModal_jsx(SuitableFor, {
    fields: fields,
    onChangeEventHandler: onChangeEventHandler,
    onChangeEventForceArrayHandler: onChangeEventForceArrayHandler
  }), FiltersModal_jsx(Registration, {
    fields: fields,
    onChangeEventHandler: onChangeEventHandler,
    location: location
  }), FiltersModal_jsx(FiltersModal_Typology, {
    fields: fields,
    onChangeEventHandler: onChangeEventHandler,
    onChangeHandler: onChangeHandler,
    onChangeHandlerForceArray: onChangeHandlerForceArray
  }), FiltersModal_jsx(Bedroom, {
    fields: fields,
    onChangeEventHandler: onChangeEventForceArrayHandler
  }), FiltersModal_jsx(House, {
    fields: fields,
    onChangeEventHandler: onChangeEventForceArrayHandler
  }), FiltersModal_jsx(Verification, {
    fields: fields,
    onChangeEventHandler: onChangeEventHandler
  }));
};
/* harmony default export */ var MobileFiltersModals_FiltersModal = ((/* unused pure expression or super */ null && (FiltersModal_FiltersModal)));
// EXTERNAL MODULE: ../shared/src/utils/i18next/index.js
var i18next = __webpack_require__(10221);
;// CONCATENATED MODULE: ../shared/src/components/Modals/WishlistModal/styles.js

var WishlistModal_styles_templateObject, WishlistModal_styles_templateObject2, _templateObject3, _templateObject4;



var styles_ModalGlobalStyle = /*#__PURE__*/(/* unused pure expression or super */ null && (createGlobalStyle([".wishlist{", "{display:flex;flex-direction:column;}}"], Box)));
var styles_ContentWrapper = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1gx0fj7-0"
})(["display:flex;flex-direction:column;& > p{font-family:IntervalNextReg,sans-serif;font-weight:100;line-height:normal;font-size:", ";line-height:1.31;color:", ";", ";}& > svg{position:absolute;bottom:-", ";right:", ";width:135px;height:auto;", ";}", ";"], function (props) {
  return props.theme.rem(16);
}, function (props) {
  return props.theme.wishlistModal.textColor;
}, function (props) {
  return props.theme.smallBreakpoint(WishlistModal_styles_templateObject || (WishlistModal_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n      margin-top: ", ";\n    "])), function (props) {
    return props.theme.space(4);
  });
}, function (props) {
  return props.theme.space(7);
}, function (props) {
  return props.theme.space(17);
}, function (props) {
  return props.theme.smallBreakpoint(WishlistModal_styles_templateObject2 || (WishlistModal_styles_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n      position: initial;\n    "])));
}, theme/* mediaMin.smallBreakpoint */.A3.smallBreakpoint(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n    align-items: center;\n  "]))));
var styles_ActionsWrapper = /*#__PURE__*/(/* unused pure expression or super */ null && (styled.div.withConfig({
  componentId: "sc-1gx0fj7-1"
})(["display:flex;width:50%;margin-top:", ";", ";& > button{height:44px;margin:0;&:first-child{margin-right:", ";}}"], function (props) {
  return props.theme.space(15);
}, function (props) {
  return props.theme.smallBreakpoint(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    width: 100%;\n  "])));
}, function (props) {
  return props.theme.space(4);
})));
// EXTERNAL MODULE: ../shared/src/svg/inacio-valentine.js
var inacio_valentine = __webpack_require__(87117);
;// CONCATENATED MODULE: ../shared/src/components/Modals/WishlistModal/index.js
var WishlistModal_jsx = react.createElement;







var WishlistModal_WishlistModal = function WishlistModal(_ref) {
  var onClose = _ref.onClose;
  var _useTranslation = useTranslation('translations'),
    t = _useTranslation.t;
  var handleSignUp = function handleSignUp() {
    window.location.href = "".concat("https://uniplaces.com/", "signup?from=property&context=wish-list-modal-offer");
  };
  var handleLogIn = function handleLogIn() {
    window.location.href = "".concat("https://uniplaces.com/", "login");
  };
  return WishlistModal_jsx(Modal, {
    className: "wishlist",
    title: t('wishlist_modal.title'),
    onClose: onClose
  }, WishlistModal_jsx(ModalGlobalStyle, null), WishlistModal_jsx(ContentWrapper, null, WishlistModal_jsx(IgnacioValentine, null), WishlistModal_jsx("p", null, multipleLines(t('wishlist_modal.text')))), WishlistModal_jsx(ActionsWrapper, null, WishlistModal_jsx(Button, {
    onClick: handleSignUp
  }, t('global.labels.sign_up')), WishlistModal_jsx(Button, {
    className: "submit-button--secondary",
    onClick: handleLogIn
  }, t('global.labels.log_in'))));
};
/* harmony default export */ var Modals_WishlistModal = ((/* unused pure expression or super */ null && (WishlistModal_WishlistModal)));
;// CONCATENATED MODULE: ../shared/src/components/Modal/modalDisplayer.js
var modalDisplayer_jsx = react.createElement;





var modalIds = {
  WISHLIST: 'wishlist',
  CREATE_OFFER_ALERT: 'create-offer-alert',
  FILTERS_MODAL: 'filters-modal'
};
var ModalDisplayer = function ModalDisplayer() {
  var _useContext = useContext(ModalContext),
    _useContext$state = _useContext.state;
  _useContext$state = _useContext$state === void 0 ? {} : _useContext$state;
  var modalId = _useContext$state.modalId,
    dispatch = _useContext.dispatch;
  switch (modalId) {
    case modalIds.WISHLIST:
      return modalDisplayer_jsx(WishlistModal, {
        onClose: function onClose() {
          return dispatch({
            type: 'hide'
          });
        }
      });
    case modalIds.CREATE_OFFER_ALERT:
      return modalDisplayer_jsx(CreateOfferAlertModal, {
        onClose: function onClose() {
          return dispatch({
            type: 'hide'
          });
        }
      });
    case modalIds.FILTERS_MODAL:
      return modalDisplayer_jsx(FiltersModal, {
        onClose: function onClose() {
          return dispatch({
            type: 'hide'
          });
        }
      });
    default:
      return null;
  }
};
/* harmony default export */ var modalDisplayer = ((/* unused pure expression or super */ null && (ModalDisplayer)));
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(81333);
;// CONCATENATED MODULE: ../shared/src/utils/wishlistTransformer/index.js


function wishlistTransformer_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function wishlistTransformer_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? wishlistTransformer_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : wishlistTransformer_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * This util exports two functions that ease the wishlist manipulation.
 * toApplicationSchema - transforms the wishlist core schema into the application schema
 * which is more friendly to add and remove offers from it.
 * toCoreSchema - transforms the the wishlist application schema into the core schema in order
 * to do the API request and persist the wishlist.
 */

var toApplicationSchema = function toApplicationSchema(wishlist) {
  if (!wishlist || !wishlist.cities) {
    return {};
  }
  var items = wishlist.cities.items;
  return items.reduce(function (acc, _ref) {
    var city_slug = _ref.city_slug,
      accommodation_offer_ids = _ref.accommodation_offer_ids;
    return wishlistTransformer_objectSpread(wishlistTransformer_objectSpread({}, acc), {}, (0,defineProperty/* default */.Z)({}, city_slug, accommodation_offer_ids));
  }, {});
};
var toCoreSchema = function toCoreSchema() {
  var wishlist = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    cities: {
      items: Object.entries(wishlist).map(function (_ref2) {
        var _ref3 = (0,slicedToArray/* default */.Z)(_ref2, 2),
          city = _ref3[0],
          offerIds = _ref3[1];
        return {
          city_slug: city,
          accommodation_offer_ids: offerIds
        };
      })
    }
  };
};
;// CONCATENATED MODULE: ../shared/src/contexts/wishlist/index.js
var wishlist_jsx = react.createElement;












var API_REQUEST_DELAY_IN_MILISECONDS = 500;
var WishlistContext = /*#__PURE__*/(0,react.createContext)();
var WishlistContextProvider = function WishlistContextProvider(_ref) {
  var children = _ref.children;
  var storage = (0,hooks_storage/* useStorage */.y)('sessionStorage');
  var _useContext = (0,react.useContext)(contexts_profile/* ProfileContext */.J),
    profile = _useContext.profile;
  var wishlistInput = profile && profile.wish_list;
  var userId = profile && profile.id;
  var _useReducer = (0,react.useReducer)(WishlistReducer, {
      wishlist: {},
      isToMakeApiRequest: false
    }),
    _useReducer$ = _useReducer[0],
    wishlist = _useReducer$.wishlist,
    isToMakeApiRequest = _useReducer$.isToMakeApiRequest,
    dispatch = _useReducer[1];
  var modalContext = (0,react.useContext)(modal_ModalContext);
  var _useRouter = (0,router.useRouter)(),
    _useRouter$query = _useRouter.query;
  _useRouter$query = _useRouter$query === void 0 ? {} : _useRouter$query;
  var city = _useRouter$query.city;
  var debouncedState = (0,hooks_debounce/* useDebounce */.N)(wishlist, API_REQUEST_DELAY_IN_MILISECONDS);
  (0,react.useEffect)(function () {
    if (!wishlistInput) {
      return;
    }
    dispatch({
      type: WishlistReducerActions.LOAD_WISHLIST,
      payload: toApplicationSchema(wishlistInput)
    });
  }, [wishlistInput]);
  (0,react.useEffect)(function () {
    if (!isToMakeApiRequest) {
      return;
    }
    (0,core/* replaceGuestWishlist */.Bw)(userId, toCoreSchema(wishlist)).then(function () {
      return (0,user/* saveProfile */.Ii)(storage, profile);
    })["catch"](function () {
      return console.error('could not update the wishlist');
    });
  }, [debouncedState]);
  var addToWishlist = (0,react.useCallback)(function (offerId) {
    if (!userId) {
      modalContext.dispatch({
        type: modalReducerActions.SHOW,
        payload: {
          modalId: modalIds.WISHLIST
        }
      });
      return false;
    }
    dispatch({
      type: WishlistReducerActions.ADD_OFFER,
      payload: {
        offerId: offerId,
        city: city
      }
    });
    return true;
  }, [city, userId]);
  var removeFromWishlist = (0,react.useCallback)(function (offerId) {
    dispatch({
      type: WishlistReducerActions.REMOVE_OFFER,
      payload: {
        offerId: offerId,
        city: city
      }
    });
    return true;
  }, [city]);
  var isOnWishlist = (0,react.useCallback)(function (offerId) {
    var offersInCity = wishlist[city] || [];
    return offersInCity.includes(parseInt(offerId, 10));
  }, [wishlist, city]);
  return wishlist_jsx(WishlistContext.Provider, {
    value: {
      addToWishlist: addToWishlist,
      removeFromWishlist: removeFromWishlist,
      isOnWishlist: isOnWishlist
    }
  }, children);
};


/***/ }),

/***/ 3912:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "r": function() { return /* binding */ useTracking; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(20406);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(28526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../shared/src/contexts/tracking/index.js

var __jsx = react.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var TrackingContext = /*#__PURE__*/(0,react.createContext)({});
var TrackingContextProvider = function TrackingContextProvider(_ref) {
  var children = _ref.children,
    _ref$isCrawler = _ref.isCrawler,
    isCrawler = _ref$isCrawler === void 0 ? false : _ref$isCrawler,
    experimentId = _ref.experimentId;
  var _useState = useState({
      isCrawler: isCrawler,
      experimentId: experimentId
    }),
    state = _useState[0],
    setState = _useState[1];
  useEffect(function () {
    var _localStorage$getItem;
    if (isCrawler) {
      return;
    }
    var touchId = (_localStorage$getItem = localStorage.getItem('touch_id')) !== null && _localStorage$getItem !== void 0 ? _localStorage$getItem : Math.random().toString(36).substring(2, 15);
    var searchId = "".concat(touchId, "_").concat(Date.now());
    if (!localStorage.getItem('touch_id')) {
      localStorage.setItem('touch_id', touchId);
    }
    setState(_objectSpread(_objectSpread({}, state), {}, {
      searchId: searchId,
      experimentId: experimentId
    }));
  }, []);
  return __jsx(TrackingContext.Provider, {
    value: [state, setState]
  }, children);
};

// EXTERNAL MODULE: ../shared/src/hooks/tracking/events.js
var events = __webpack_require__(29915);
;// CONCATENATED MODULE: ../shared/src/hooks/tracking/index.js



function tracking_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function tracking_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? tracking_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : tracking_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }



var useTracking = function useTracking() {
  var _useContext = (0,react.useContext)(TrackingContext),
    state = _useContext[0];
  var trackingServices = [__webpack_require__.e(/* import() */ 33371).then(__webpack_require__.bind(__webpack_require__, 33371)), __webpack_require__.e(/* import() */ 27450).then(__webpack_require__.bind(__webpack_require__, 27450)), __webpack_require__.e(/* import() */ 1723).then(__webpack_require__.bind(__webpack_require__, 1723))];
  var track = function track(eventName, eventData) {
    for (var _len = arguments.length, rest = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      rest[_key - 2] = arguments[_key];
    }
    return Promise.all(trackingServices.map( /*#__PURE__*/function () {
      var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(service) {
        var _ref2, track;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!service.hasOwnProperty('track')) {
                  _context.next = 4;
                  break;
                }
                _context.t0 = service;
                _context.next = 7;
                break;
              case 4:
                _context.next = 6;
                return service;
              case 6:
                _context.t0 = _context.sent["default"];
              case 7:
                _ref2 = _context.t0;
                track = _ref2.track;
                track.apply(void 0, [eventName, tracking_objectSpread(tracking_objectSpread({}, eventData), state)].concat(rest));
              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()));
  };
  return tracking_objectSpread(tracking_objectSpread({}, state), {}, {
    track: track,
    events: events/* default */.Z
  });
};

/***/ }),

/***/ 78078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var __jsx = react__WEBPACK_IMPORTED_MODULE_0__.createElement;

var NewHeart = function NewHeart(_ref) {
  var className = _ref.className,
    _ref$active = _ref.active,
    active = _ref$active === void 0 ? false : _ref$active,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick;
  return __jsx("svg", {
    width: 27,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className, " ").concat(active ? 'active' : ''),
    onClick: onClick
  }, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.962 1c2.011 0 3.84.933 4.89 2.495.633.942 2.395 4.505-1.51 10.814-2.893 4.673-8.321 8.53-10.06 9.691-1.74-1.162-7.167-5.018-10.06-9.69C-.683 8 1.078 4.436 1.712 3.494 2.762 1.932 4.59 1 6.602 1c.156 0 .314.006.47.018 2.117.161 3.424 1.149 4.935 2.292.216.163.432.327.652.488l.623.46.622-.46c.22-.161.436-.325.652-.488 1.513-1.143 2.819-2.13 4.936-2.292a6.39 6.39 0 0 1 .47-.018Z",
    fill: "#224251",
    fillOpacity: 0.8,
    stroke: "#fff"
  }));
};
/* harmony default export */ __webpack_exports__["Z"] = (NewHeart);

/***/ }),

/***/ 46483:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "zT": function() { return /* binding */ DATE_FORMAT; },
  "yA": function() { return /* binding */ getAvailableFrom; },
  "ZU": function() { return /* binding */ toDate; }
});

// UNUSED EXPORTS: DATE_FORMAT_FROM, DATE_FORMAT_PRINT, DATE_FORMAT_SHORT, DATE_FORMAT_SHORT_MONTH, formatDate, getAvailability, getContractType, getDatesForOption, getDatesForStandard, getMoveInOutToCheckout, getPriceForFixedContract, transformAvailabilityStandard, transformAvailabilityStandardUnitary, transformContract

// EXTERNAL MODULE: ../../node_modules/date-fns/esm/addDays/index.js
var esm_addDays = __webpack_require__(63761);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/parse/index.js + 44 modules
var esm_parse = __webpack_require__(97026);
// EXTERNAL MODULE: ../shared/src/constants/billTypes.js
var billTypes = __webpack_require__(35144);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(23769);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../shared/src/svg/internet.js

var __jsx = react.createElement;

var Internet = function Internet(props) {
  return __jsx("svg", (0,esm_extends/* default */.Z)({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 16 17",
    preserveAspectRatio: "xMidYMid",
    style: {
      enableBackground: 'new 0 0 16 17'
    },
    xmlSpace: "preserve"
  }, props), __jsx("style", null, '.st5{fill:none;stroke:#bcc6ca;stroke-linecap:round;stroke-linejoin:round}'), __jsx("path", {
    className: "st5",
    d: "M2.3 7.1c3-3.1 8-3.2 11.1-.2.1.1.2.1.2.2"
  }), __jsx("path", {
    className: "st5",
    d: "M15.9 4.4C11.7 0 4.7-.1.3 4.1c-.1.1-.2.2-.2.3M4.6 10.5c1.8-1.9 4.8-1.9 6.7-.1l.1.1"
  }), __jsx("path", {
    className: "st5",
    d: "M13.6 7.1c-3-3.1-8-3.2-11.1-.2l-.2.2M11.4 10.5c-1.8-1.9-4.8-1.9-6.7-.1l-.1.1M8 12.8c.9 0 1.6.7 1.6 1.6 0 .9-.7 1.6-1.6 1.6s-1.6-.7-1.6-1.6c0-.9.7-1.6 1.6-1.6h0z"
  }));
};
/* harmony default export */ var internet = (Internet);
;// CONCATENATED MODULE: ../shared/src/svg/no-internet.js

var no_internet_jsx = react.createElement;

var NoInternet = function NoInternet(props) {
  return no_internet_jsx("svg", (0,esm_extends/* default */.Z)({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    preserveAspectRatio: "xMidYMid",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), no_internet_jsx("path", {
    clipRule: "evenodd",
    d: "M8.573 19.12a12.102 12.102 0 0 1 17.374 0H8.573Zm20.945-4.177a16.95 16.95 0 0 0-24.329 0h24.329Zm-17.562 9.483a7.264 7.264 0 0 1 10.428 0H11.956Zm13.988-5.306a12.099 12.099 0 0 0-17.371 0h17.37Zm-3.56 5.305a7.264 7.264 0 0 0-10.426 0h10.426Zm-4.582 3.44c1.358 0 2.455 1.125 2.455 2.51 0 1.388-1.098 2.513-2.456 2.513-1.358 0-2.458-1.125-2.458-2.511 0-1.384 1.1-2.509 2.459-2.509v-.003Z",
    stroke: "#BCC6CA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), no_internet_jsx("path", {
    d: "M4 34 33.647 4",
    stroke: "#647A85",
    strokeWidth: 5.04,
    strokeLinecap: "square"
  }), no_internet_jsx("path", {
    d: "M4 34 33.647 4",
    stroke: "#BCC6CA",
    strokeLinecap: "square"
  }));
};
/* harmony default export */ var no_internet = (NoInternet);
;// CONCATENATED MODULE: ../shared/src/svg/electricity.js

var electricity_jsx = react.createElement;

var Electricity = function Electricity(props) {
  return electricity_jsx("svg", (0,esm_extends/* default */.Z)({
    width: 21,
    height: 32,
    viewBox: "0 0 21 32",
    preserveAspectRatio: "xMidYMid",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), electricity_jsx("path", {
    d: "M20.407 12.736 8.121 31l2.46-11.74H.752L13.039 1l-2.46 11.736h9.828Z",
    stroke: "#FAFAFA",
    strokeLinejoin: "round"
  }));
};
/* harmony default export */ var electricity = (Electricity);
;// CONCATENATED MODULE: ../shared/src/svg/no-electricity.js

var no_electricity_jsx = react.createElement;

var NoElectricity = function NoElectricity(props) {
  return no_electricity_jsx("svg", (0,esm_extends/* default */.Z)({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    preserveAspectRatio: "xMidYMid",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), no_electricity_jsx("path", {
    clipRule: "evenodd",
    d: "m26.9 17.438-11.141 16.56 2.23-10.645H9.076L20.218 6.796l-2.23 10.643 8.911-.001Z",
    stroke: "#BCC6CA",
    strokeLinejoin: "round"
  }), no_electricity_jsx("path", {
    d: "M4.313 34 33.96 4",
    stroke: "#647A85",
    strokeWidth: 5.04,
    strokeLinecap: "square"
  }), no_electricity_jsx("path", {
    d: "M4.313 34 33.96 4",
    stroke: "#BCC6CA",
    strokeLinecap: "square"
  }));
};
/* harmony default export */ var no_electricity = (NoElectricity);
;// CONCATENATED MODULE: ../shared/src/svg/gas.js

var gas_jsx = react.createElement;

var Gas = function Gas(props) {
  return gas_jsx("svg", (0,esm_extends/* default */.Z)({
    width: 25,
    height: 32,
    viewBox: "0 0 25 32",
    preserveAspectRatio: "xMidYMid",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), gas_jsx("path", {
    clipRule: "evenodd",
    d: "M10.353 17.44c.928.584 1.775 1.758 1.775 2.962 0 .987-.411 1.983-1.065 2.591-.544-.507-.955-1.433-1.067-2.223-1.775.864-2.84 2.835-2.84 4.817 0 2.862 2.228 5.186 4.974 5.186 2.75 0 4.976-2.322 4.976-5.186 0-4.004-3.017-7.497-6.752-8.148h-.001Z",
    stroke: "#FAFAFA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), gas_jsx("path", {
    clipRule: "evenodd",
    d: "M8.604 1c2.087 1.318 3.998 3.961 3.998 6.668 0 2.218-.928 4.462-2.4 5.833-1.221-1.144-2.147-3.226-2.398-5.001-3.993 1.94-6.397 6.374-6.397 10.834C1.407 25.78 6.421 31 12.601 31c6.183 0 11.194-5.221 11.194-11.666 0-9.011-6.791-16.87-15.191-18.334Z",
    stroke: "#FAFAFA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
/* harmony default export */ var gas = (Gas);
;// CONCATENATED MODULE: ../shared/src/svg/no-gas.js

var no_gas_jsx = react.createElement;

var NoGas = function NoGas(props) {
  return no_gas_jsx("svg", (0,esm_extends/* default */.Z)({
    width: 37,
    height: 38,
    fill: "none",
    viewBox: "0 0 37 38",
    preserveAspectRatio: "xMidYMid",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), no_gas_jsx("path", {
    clipRule: "evenodd",
    d: "M16.657 19.597c.88.555 1.685 1.669 1.685 2.811 0 .937-.39 1.882-1.01 2.458-.517-.48-.907-1.36-1.013-2.109-1.684.82-2.694 2.69-2.694 4.57 0 2.716 2.113 4.92 4.718 4.92 2.61 0 4.722-2.202 4.722-4.92 0-3.799-2.863-7.112-6.406-7.73h-.002Z",
    stroke: "#BCC6CA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), no_gas_jsx("path", {
    clipRule: "evenodd",
    d: "M14.997 4c1.98 1.25 3.794 3.758 3.794 6.327 0 2.104-.88 4.233-2.276 5.533-1.16-1.085-2.038-3.062-2.276-4.744-3.789 1.84-6.07 6.047-6.07 10.279 0 6.114 4.757 11.068 10.622 11.068s10.62-4.954 10.62-11.068c0-8.55-6.444-16.007-14.414-17.395Z",
    stroke: "#BCC6CA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), no_gas_jsx("path", {
    d: "M3.96 34 33.272 4.338",
    stroke: "#647A85",
    strokeWidth: 5.04,
    strokeLinecap: "square"
  }), no_gas_jsx("path", {
    d: "M3.96 34 33.272 4.338",
    stroke: "#BCC6CA",
    strokeLinecap: "square"
  }));
};
/* harmony default export */ var no_gas = (NoGas);
;// CONCATENATED MODULE: ../shared/src/svg/water.js

var water_jsx = react.createElement;

var Water = function Water(props) {
  return water_jsx("svg", (0,esm_extends/* default */.Z)({
    width: 22,
    height: 32,
    viewBox: "0 0 22 32",
    preserveAspectRatio: "xMidYMid",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), water_jsx("path", {
    clipRule: "evenodd",
    d: "M20.753 21c0 5.524-4.42 10-9.877 10C5.42 31 1 26.522 1 21c0-5.521 9.876-20 9.876-20s9.877 14.479 9.877 20Z",
    stroke: "#FAFAFA",
    strokeLinejoin: "round"
  }), water_jsx("path", {
    d: "M10.339 25.627c-2.543 0-4.606-2.09-4.606-4.665",
    stroke: "#FAFAFA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
/* harmony default export */ var water = (Water);
;// CONCATENATED MODULE: ../shared/src/svg/no-water.js

var no_water_jsx = react.createElement;

var NoWater = function NoWater(props) {
  return no_water_jsx("svg", (0,esm_extends/* default */.Z)({
    width: 37,
    height: 38,
    viewBox: "0 0 37 38",
    preserveAspectRatio: "xMidYMid",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), no_water_jsx("path", {
    clipRule: "evenodd",
    d: "M26.95 22.976c0 5.24-4.193 9.487-9.37 9.487-5.176 0-9.37-4.248-9.37-9.487C8.21 17.736 17.58 4 17.58 4s9.37 13.737 9.37 18.976Z",
    stroke: "#BCC6CA",
    strokeLinejoin: "round"
  }), no_water_jsx("path", {
    d: "M17.07 27.365c-2.412 0-4.369-1.983-4.369-4.425",
    stroke: "#BCC6CA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), no_water_jsx("path", {
    d: "M4 34 33.313 4.338",
    stroke: "#647A85",
    strokeWidth: 5.04,
    strokeLinecap: "square"
  }), no_water_jsx("path", {
    d: "M4 34 33.313 4.338",
    stroke: "#BCC6CA",
    strokeLinecap: "square"
  }));
};
/* harmony default export */ var no_water = (NoWater);
;// CONCATENATED MODULE: ../shared/src/constants/bills-features.js








var bills_features_GLOBAL_BILLS = {
  internet: {
    Component: internet,
    translation: 'global_bills.internet'
  },
  'no-internet': {
    Component: no_internet,
    translation: 'global_bills.internet'
  },
  electricity: {
    Component: electricity,
    translation: 'global_bills.electricity'
  },
  'no-electricity': {
    Component: no_electricity,
    translation: 'global_bills.electricity'
  },
  gas: {
    Component: gas,
    translation: 'global_bills.gas'
  },
  'no-gas': {
    Component: no_gas,
    translation: 'global_bills.gas'
  },
  water: {
    Component: water,
    translation: 'global_bills.water'
  },
  'no-water': {
    Component: no_water,
    translation: 'global_bills.water'
  }
};
;// CONCATENATED MODULE: ../shared/src/utils/transformers/bills.js



var _excluded = (/* unused pure expression or super */ null && (["gas"]));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }


var calculateBillsIncluded = function calculateBillsIncluded(costs, property) {
  if (!(costs !== null && costs !== void 0 && costs.bills)) {
    return BILLS_SUMMARY_TYPE.NONE;
  }
  if (allBillsIncluded(costs, property)) {
    return BILLS_SUMMARY_TYPE.ALL;
  }
  if (someBillsIncluded(costs, property)) {
    return BILLS_SUMMARY_TYPE.SOME;
  }
  return BILLS_SUMMARY_TYPE.NONE;
};
var allBillsIncluded = function allBillsIncluded(costs, property) {
  var _property$main_featur;
  if (!(costs !== null && costs !== void 0 && costs.bills)) {
    return false;
  }
  var gasType = (property === null || property === void 0 ? void 0 : (_property$main_featur = property.main_features) === null || _property$main_featur === void 0 ? void 0 : _property$main_featur.gas_type) || null;
  return getBillsType(gasType).reduce(function (acc, bill) {
    var _costs$bills$bill;
    return acc && ((_costs$bills$bill = costs.bills[bill]) === null || _costs$bills$bill === void 0 ? void 0 : _costs$bills$bill.included);
  }, true);
};
var someBillsIncluded = function someBillsIncluded(costs, property) {
  var _property$main_featur2;
  if (!(costs !== null && costs !== void 0 && costs.bills)) {
    return false;
  }
  var gasType = (property === null || property === void 0 ? void 0 : (_property$main_featur2 = property.main_features) === null || _property$main_featur2 === void 0 ? void 0 : _property$main_featur2.gas_type) || null;
  return getBillsType(gasType).reduce(function (acc, bill) {
    var _costs$bills$bill2;
    return acc || ((_costs$bills$bill2 = costs.bills[bill]) === null || _costs$bills$bill2 === void 0 ? void 0 : _costs$bills$bill2.included);
  }, false);
};
var noBillsIncluded = function noBillsIncluded(costs, property) {
  return !someBillsIncluded(costs, property);
};
var getBillsType = function getBillsType() {
  var gasType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : GAS_INSTALLATION;
  return gasType === GAS_INSTALLATION ? Object.values(BILLS_TYPE) : Object.values(BILLS_TYPE).filter(function (bill) {
    return bill !== BILLS_TYPE.GAS;
  });
};
var bills_getBills = function getBills(costs, property) {
  if (!(costs !== null && costs !== void 0 && costs.bills) || !(property !== null && property !== void 0 && property.main_features)) {
    return {
      included: BILLS_SUMMARY_TYPE.NONE
    };
  }
  var bills = costs.bills;
  var included = calculateBillsIncluded(costs, property);
  var gasType = property.main_features.gas_type;
  if (gasType !== GAS_INSTALLATION) {
    var _ = bills.gas,
      billsWithoutGas = _objectWithoutProperties(bills, _excluded);
    return _objectSpread({
      included: included
    }, billsWithoutGas);
  }
  return _objectSpread({
    included: included
  }, bills);
};
var getComponentsFromBills = function getComponentsFromBills(bills) {
  if (!bills) {
    return {
      included: [],
      notIncluded: []
    };
  }
  return Object.values(BILLS_TYPE).reduce(function (acc, key) {
    var _bills$key;
    if (!bills[key]) {
      return _objectSpread({}, acc);
    }
    (_bills$key = bills[key]) !== null && _bills$key !== void 0 && _bills$key.included ? acc.included = [].concat(_toConsumableArray(acc.included), [_objectSpread(_objectSpread({}, bills[key]), GLOBAL_BILLS[key])]) : acc.notIncluded = [].concat(_toConsumableArray(acc.notIncluded), [_objectSpread(_objectSpread({}, bills[key]), GLOBAL_BILLS["no-".concat(key)])]);
    return _objectSpread({}, acc);
  }, {
    included: [],
    notIncluded: []
  });
};
var getBillsStatus = function getBillsStatus(_ref) {
  var _ref$bills = _ref.bills,
    bills = _ref$bills === void 0 ? {} : _ref$bills;
  return getBillsType(GAS_INSTALLATION).reduce(function (acc, bill) {
    var _bills$bill;
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, bill, ((_bills$bill = bills[bill]) === null || _bills$bill === void 0 ? void 0 : _bills$bill.included) || false));
  }, {});
};
// EXTERNAL MODULE: ../shared/src/constants/contractType.js
var contractType = __webpack_require__(50957);
// EXTERNAL MODULE: ../shared/src/utils/index.js + 1 modules
var utils = __webpack_require__(73706);
;// CONCATENATED MODULE: ../shared/src/utils/transformers/contracts.js


function contracts_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function contracts_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? contracts_ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : contracts_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }




var DATE_FORMAT_FROM = 'yyyy-MM-dd HH:mm:ss';
var DATE_FORMAT_PRINT = 'dd MMM yyyy';
var DATE_FORMAT = 'yyyy-MM-dd';
var DATE_FORMAT_SHORT_MONTH = 'MMM';
var DATE_FORMAT_SHORT = 'dd MMM';
var getContractType = function getContractType(offer) {
  var contract = offer.contract;
  if (contract.type === CONTRACT_TYPE.FIXED) {
    return sortContractOptionsByAvailability(contract.fixed, offer.availabilities.fixed.options);
  }
  if (contract.type === CONTRACT_TYPE.FIXED_UNITARY) {
    return sortContractOptionsByAvailability(contract.fixed_unitary, offer.availabilities.fixed_unitary.options);
  }
  return contract.standard;
};
var getAvailableFrom = function getAvailableFrom(offer, minimumGap) {
  var availabilitySummaryInfo = offer.availability_summary_info,
    _offer$availabilities = offer.availabilities,
    standard = _offer$availabilities.standard,
    standard_unitary = _offer$availabilities.standard_unitary;
  if (standard && standard.available_periods) {
    return (0,esm_addDays/* default */.Z)(toDate(standard.available_periods[0].start_date), minimumGap + 1 || 0);
  }
  if (standard_unitary && standard_unitary.available_periods) {
    return (0,esm_addDays/* default */.Z)(toDate(standard_unitary.available_periods[0].start_date), minimumGap + 1 || 0);
  }
  if (!availabilitySummaryInfo || !availabilitySummaryInfo.standard_unitary_contract) {
    return null;
  }
  var availableFrom = availabilitySummaryInfo.standard_unitary_contract.available_from;
  return availableFrom ? (0,esm_addDays/* default */.Z)(toDate(availableFrom), minimumGap + 1 || 0) : new Date();
};
var getAvailability = function getAvailability(contractType, availability, minimumNights, availableFrom) {
  if (contractType === CONTRACT_TYPE.FIXED) {
    return availability.fixed;
  }
  if (contractType === CONTRACT_TYPE.FIXED_UNITARY) {
    return availability.fixed_unitary;
  }
  if (availability.standard) {
    return contracts_objectSpread(contracts_objectSpread({}, transformAvailabilityStandard(availability.standard, minimumNights, availableFrom)), {}, {
      type: AVAILABILITY_TYPE.STANDARD
    });
  }
  return contracts_objectSpread(contracts_objectSpread({}, transformAvailabilityStandardUnitary(availability.standard_unitary, minimumNights, availableFrom)), {}, {
    type: AVAILABILITY_TYPE.STANDARD_UNITARY
  });
};
var transformContract = function transformContract(offer, property) {
  var contract = getContractType(offer);
  var bills = getBills(offer.costs, property);
  var availableFrom = getAvailableFrom(offer);
  var minimumNights = offer.requisites.conditions.minimum_nights;
  var availability = getAvailability(offer.contract.type, offer.availabilities, minimumNights, availableFrom);
  var adminFee = offer.contract.admin_fee.value;
  var securityDeposit = offer.contract.deposit.value;
  var landlordPolicies = offer.contract.landlord_policies.costs.items;
  var penalty = offer.contract.standard.penalty;
  var extraPerGuest = offer.contract.fixed_unitary.extra_per_guest || offer.contract.standard.extra_per_guest;
  var cleaningFrequency = offer.costs.services.cleaning.periodicity;
  var requirements = offer.requisites.requirements;
  return {
    offerId: offer.id,
    offerVersion: offer.version,
    enquire: {
      offerTitle: offer.title
    },
    contract: contracts_objectSpread(contracts_objectSpread({
      type: offer.contract.type
    }, contract), {}, {
      price: offer.reference_price,
      availableFrom: availableFrom || availability.availableFromCalendar,
      availability: contracts_objectSpread(contracts_objectSpread({}, getAvailability(offer.contract.type, offer.availabilities, minimumNights, availableFrom)), {}, {
        availabilityRules: offer.availabilities.availability_rules
      }),
      minimumNights: minimumNights,
      adminFee: adminFee,
      securityDeposit: securityDeposit,
      landlordPolicies: landlordPolicies,
      penalty: penalty,
      extraPerGuest: extraPerGuest,
      cleaningFrequency: cleaningFrequency,
      requirements: requirements
    }),
    bills: bills,
    maxGuests: offer.requisites.conditions.max_guests,
    manualFlow: offer.requisites.requirements.manual_flow,
    published: offer.lifecycle.published.published
  };
};
var toDate = function toDate(date) {
  var dateFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DATE_FORMAT_FROM;
  return (0,esm_parse/* default */.Z)(date, dateFormat, new Date());
};
var formatDate = function formatDate(date) {
  var toFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DATE_FORMAT_PRINT;
  return format(date, toFormat);
};
var getDatesForOption = function getDatesForOption(_ref) {
  var start_date = _ref.start_date,
    end_date = _ref.end_date;
  var startDate = parse(start_date, DATE_FORMAT_FROM, new Date());
  var endDate = parse(end_date, DATE_FORMAT_FROM, new Date());
  var start = format(startDate, DATE_FORMAT_PRINT);
  var end = format(endDate, DATE_FORMAT_PRINT);
  var diffInMonths = differenceInMonths(endDate, startDate);
  var diffInWeeks = differenceInWeeks(endDate, startDate);
  var diffInDays = differenceInDays(endDate, startDate);
  return {
    startDate: startDate,
    endDate: endDate,
    start: start,
    end: end,
    diffInMonths: diffInMonths,
    diffInWeeks: diffInWeeks,
    diffInDays: diffInDays
  };
};
var getDatesForStandard = function getDatesForStandard(moveInOut) {
  if (!moveInOut.start || !moveInOut.end) {
    return {
      start: '',
      end: ''
    };
  }
  var start = formatDate(parseISO(moveInOut.start), DATE_FORMAT);
  var end = formatDate(parseISO(moveInOut.end), DATE_FORMAT);
  return {
    start: start,
    end: end
  };
};
var getPriceForFixedContract = function getPriceForFixedContract(_ref2, diffInDays) {
  var price = _ref2.contract_value;
  var isFixedUnitary = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (isFixedUnitary) {
    return price;
  }
  var currency_code = price.currency_code;
  var amount = toMoneyCoreFormat(Math.floor(fromMoneyCoreFormat(price.amount) / diffInDays * 30));
  return {
    amount: amount,
    currency_code: currency_code
  };
};
var getMoveInOutToCheckout = function getMoveInOutToCheckout(_ref3) {
  var start_date = _ref3.start_date,
    end_date = _ref3.end_date;
  var startDate = parse(start_date, DATE_FORMAT_FROM, new Date());
  var endDate = parse(end_date, DATE_FORMAT_FROM, new Date());
  return {
    moveIn: format(startDate, DATE_FORMAT),
    moveOut: format(endDate, DATE_FORMAT)
  };
};
var transformAvailabilityStandardUnitary = function transformAvailabilityStandardUnitary(_ref4, minimumNights, availableFrom) {
  var blocked_intervals = _ref4.blocked_intervals;
  var today = new Date();
  var _ref5 = blocked_intervals ? _toConsumableArray(blocked_intervals).sort(function (firstDate, secondDate) {
      return compareAsc(toDate(firstDate.start_date), toDate(secondDate.start_date));
    }).reduce(function (_ref6, _ref7) {
      var blockedPeriods = _ref6.blockedPeriods,
        blockedDates = _ref6.blockedDates;
      var start_date = _ref7.start_date,
        end_date = _ref7.end_date;
      var start = toDate(start_date);
      var end = toDate(end_date);
      var range = {
        start: start,
        end: end
      };
      var lastRange = blockedPeriods.length ? blockedPeriods[blockedPeriods.length - 1] : {
        end: today
      };
      if (isAfter(lastRange.end, range.end)) {
        return {
          blockedPeriods: blockedPeriods,
          blockedDates: blockedDates
        };
      }
      var newStart = isAfter(start, today) ? addDays(lastRange.end, minimumNights) : start;
      var modifiedRange = isAfter(newStart, start) ? {
        start: lastRange.end,
        end: end
      } : range;
      var dates = eachDayOfInterval(contracts_objectSpread({}, modifiedRange));
      return {
        blockedPeriods: [].concat(_toConsumableArray(blockedPeriods), [range]),
        blockedDates: [].concat(_toConsumableArray(blockedDates), _toConsumableArray(dates))
      };
    }, {
      blockedPeriods: [],
      blockedDates: []
    }) : {
      blockedPeriods: [],
      blockedDates: []
    },
    blockedDates = _ref5.blockedDates,
    blockedPeriods = _ref5.blockedPeriods;
  var availableFromCalendar = blockedDates.reduce(function (acc, date) {
    return isSameDay(acc, date) ? addDays(acc, 1) : acc;
  }, today);
  return {
    blocked_intervals: blocked_intervals,
    blockedPeriods: blockedPeriods,
    blockedDates: blockedDates,
    availableFromCalendar: isBefore(availableFromCalendar, availableFrom) ? availableFrom : availableFromCalendar
  };
};
var transformAvailabilityStandard = function transformAvailabilityStandard(_ref8, minimumNights, availableFrom) {
  var years = _ref8.years;
  var today = new Date();
  var currentYear = parseInt(format(today, 'yyyy'), 10);
  var currentMonth = format(today, 'MMM');
  var blockedDates = years.reduce(function (acc, _ref9) {
    var year = _ref9.year,
      months = _ref9.months;
    if (parseInt(year, 10) < currentYear) {
      return acc;
    }
    if (year === currentYear) {
      var _Object$keys$reduce = Object.keys(months).reduce(function (currentAcc, key) {
          if (key !== currentMonth && currentAcc.lacksCurrent || months[key] !== 'none') {
            return currentAcc;
          }
          var start = parse("01-".concat(key, "-").concat(year), 'dd-MMM-yyyy', new Date());
          var end = lastDayOfMonth(start);
          return {
            blockedYearDates: [].concat(_toConsumableArray(currentAcc.blockedYearDates), _toConsumableArray(eachDayOfInterval({
              start: start,
              end: end
            }))),
            lacksCurrent: false
          };
        }, {
          blockedYearDates: [],
          lacksCurrent: true
        }),
        blockedYearDates = _Object$keys$reduce.blockedYearDates;
      return [].concat(_toConsumableArray(acc), _toConsumableArray(blockedYearDates));
    }
    var blockedDatesForYear = Object.keys(months).reduce(function (yearAcc, key) {
      if (months[key] !== 'none') {
        return yearAcc;
      }
      if (yearAcc.blockedYearDates) {
        return [].concat(_toConsumableArray(yearAcc.blockedYearDates), _toConsumableArray(getDaysInMonth(parse("".concat(key, "-").concat(year), 'MMM-yyyy'))));
      }
      return [];
    }, []);
    return [].concat(_toConsumableArray(acc), _toConsumableArray(blockedDatesForYear));
  }, []);
  var availableFromCalendar = blockedDates.reduce(function (acc, date) {
    return isSameDay(acc, date) ? addDays(acc, 1) : acc;
  }, today);
  return {
    blockedPeriods: [],
    blockedDates: blockedDates,
    availableFromCalendar: isBefore(availableFromCalendar, availableFrom) ? availableFrom : availableFromCalendar
  };
};
var sortContractOptionsByAvailability = function sortContractOptionsByAvailability(contract, availabilityOptions) {
  return contracts_objectSpread(contracts_objectSpread({}, contract), {}, {
    options: contract.options.reduce(function (acc, option, index) {
      var isSoldOut = availabilityOptions[index].status === 'none';
      return [].concat(_toConsumableArray(acc), [contracts_objectSpread(contracts_objectSpread({}, option), {}, {
        isSoldOut: isSoldOut
      })]);
    }, []).sort(function (option) {
      return option.isSoldOut ? 1 : -1;
    })
  });
};

/***/ }),

/***/ 64807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _offerId_; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next-i18next/dist/esm/index.js + 16 modules
var esm = __webpack_require__(69324);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__(56580);
// EXTERNAL MODULE: ../shared/src/contexts/media/index.js
var media = __webpack_require__(98680);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(81333);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../node_modules/react-intersection-observer/react-intersection-observer.m.js
var react_intersection_observer_m = __webpack_require__(97704);
;// CONCATENATED MODULE: ../shared/src/hooks/inView.js

var isIntersectionObserverSupported = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
var useInView = function useInView(options) {
  if (!isIntersectionObserverSupported) {
    return [null, true];
  }
  return (0,react_intersection_observer_m/* useInView */.YD)(options);
};
// EXTERNAL MODULE: ../shared/src/hooks/tracking/index.js + 1 modules
var tracking = __webpack_require__(3912);
// EXTERNAL MODULE: ../shared/src/components/Accordion/index.js
var Accordion = __webpack_require__(41161);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(7328);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 6 modules
var styled_components_browser_esm = __webpack_require__(41401);
// EXTERNAL MODULE: ../shared/src/theme.js
var theme = __webpack_require__(24701);
// EXTERNAL MODULE: ../shared/src/components/Accordion/styles.js
var styles = __webpack_require__(61477);
;// CONCATENATED MODULE: ../shared/src/components/FAQ/styles.js

var _templateObject, _templateObject2, _templateObject3;



var Wrapper = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-yso0wf-0"
})(["display:flex;flex-direction:column;width:100%;", ";", "{background:none;border-radius:0;padding-bottom:", ";&:not(:last-child){border-bottom:1px solid #e5e5e5;}", "}", ""], function (props) {
  return props.theme.gap(2, 'column');
}, styles/* Wrapper */.im, function (props) {
  return props.theme.space(2);
}, theme/* mediaMin.smallBreakpoint */.A3.smallBreakpoint(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n      width: 100%;\n    "]))), theme/* mediaMin.smallBreakpoint */.A3.smallBreakpoint(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    align-items: center;\n  "]))));
var Title = /*#__PURE__*/styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  componentId: "sc-yso0wf-1"
})(["font-family:'IntervalNextReg',sans-serif;font-size:", ";line-height:", ";font-weight:600;margin-bottom:", ";color:", ";", ""], function (props) {
  return props.theme.rem(22);
}, function (props) {
  return props.theme.rem(26);
}, function (props) {
  return props.theme.space(5);
}, function (props) {
  return props.theme.colors.blueDianne;
}, theme/* mediaMin.smallBreakpoint */.A3.smallBreakpoint(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n    font-size: ", ";\n  "])), function (props) {
  return props.theme.rem(18);
}));
;// CONCATENATED MODULE: ../shared/src/components/FAQ/index.js
var __jsx = react.createElement;




var FAQ = function FAQ(_ref) {
  var title = _ref.title,
    questionsAnswers = _ref.questionsAnswers,
    learnMoreText = _ref.learnMoreText,
    trackOpen = _ref.trackOpen;
  var _useTracking = (0,tracking/* useTracking */.r)(),
    track = _useTracking.track,
    events = _useTracking.events;
  var _onOpen = function onOpen(question) {
    if (trackOpen) {
      trackOpen(question);
      return;
    }
    track(events.faqOpened, {
      question: question
    });
  };
  return __jsx(Wrapper, null, __jsx(Title, null, title), questionsAnswers.map(function (_ref2) {
    var question = _ref2.question,
      answer = _ref2.answer,
      url = _ref2.url;
    return __jsx(Accordion/* default */.Z, {
      key: question,
      title: question,
      description: answer,
      url: url,
      urlText: learnMoreText,
      onOpen: function onOpen() {
        return _onOpen(question);
      }
    });
  }));
};
/* harmony default export */ var components_FAQ = (FAQ);
// EXTERNAL MODULE: ../shared/src/components/Unisystem/Separator/index.js
var Separator = __webpack_require__(39428);
// EXTERNAL MODULE: ./src/store/actions/tracking/index.js + 5 modules
var actions_tracking = __webpack_require__(53444);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(12741);
// EXTERNAL MODULE: ../shared/src/constants/locationTypes.js
var locationTypes = __webpack_require__(8481);
// EXTERNAL MODULE: ../shared/src/utils/transformers/index.js + 1 modules
var transformers = __webpack_require__(3585);
// EXTERNAL MODULE: ../shared/src/utils/language/index.js
var utils_language = __webpack_require__(90703);
;// CONCATENATED MODULE: ../shared/src/utils/transformers/seo.js




var transformQuestionsAnswersAndRelatedLinks = function transformQuestionsAnswersAndRelatedLinks(location, language) {
  if (!location || !location.type) {
    return {};
  }
  var locationType = location.type;
  var _ref = location.questions_answers || {
      items: []
    },
    questionsAnswers = _ref.items;
  var _ref2 = location.related_links || {
      items: []
    },
    relatedLinks = _ref2.items;
  var locale = (0,utils_language/* languageToLocale */.QK)(language);
  var locationName = (0,transformers/* translationFromLocale */.jG)(location.metadata.name_translations.items, locale);
  var cityName = locationType === locationTypes/* CITIES */.MX ? locationName : (0,transformers/* translationFromLocale */.jG)(location.city.metadata.name_translations.items, locale);
  var formatedQuestionsAnswers = questionsAndAnswersFromCoreFormat(questionsAnswers, locale);
  var formatedRelatedlinks = relatedLinksFromCoreFormat(relatedLinks, locale);
  return {
    questionsAnswers: formatedQuestionsAnswers,
    relatedLinks: formatedRelatedlinks,
    cityName: cityName,
    locationName: locationName
  };
};
var relatedLinksFromCoreFormat = function relatedLinksFromCoreFormat(relatedLinks, locale) {
  return relatedLinks.reduce(function (acc, link) {
    var url = link.url,
      _link$metadata = link.metadata,
      titleTranslations = _link$metadata.title_translations.items,
      subtitle_translations = _link$metadata.subtitle_translations;
    var title = (0,transformers/* translationFromLocale */.jG)(titleTranslations, locale);
    var subtitle = subtitle_translations && subtitle_translations.items.length ? (0,transformers/* translationFromLocale */.jG)(subtitle_translations.items, locale) : null;
    return [].concat((0,toConsumableArray/* default */.Z)(acc), [{
      url: url,
      title: title,
      subtitle: subtitle
    }]);
  }, []);
};
var questionsAndAnswersFromCoreFormat = function questionsAndAnswersFromCoreFormat(questionsAnswers, locale) {
  return questionsAnswers.reduce(function (acc, questionAnswer) {
    var url = questionAnswer.url,
      _questionAnswer$metad = questionAnswer.metadata,
      questionTranslations = _questionAnswer$metad.question_translations.items,
      answerTranslations = _questionAnswer$metad.answer_translations.items;
    var question = (0,transformers/* translationFromLocale */.jG)(questionTranslations, locale);
    var answer = (0,transformers/* translationFromLocale */.jG)(answerTranslations, locale);
    return [].concat((0,toConsumableArray/* default */.Z)(acc), [{
      url: url,
      question: question,
      answer: answer
    }]);
  }, []);
};
;// CONCATENATED MODULE: ./src/components/FAQ/index.js
var FAQ_jsx = react.createElement;








var FAQ_FAQ = function FAQ(_ref) {
  var location = _ref.location,
      trackOfferPageFaqOpenedAction = _ref.trackOfferPageFaqOpenedAction;

  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t,
      language = _useTranslation.i18n.language;

  var _transformQuestionsAn = transformQuestionsAnswersAndRelatedLinks(location, language),
      _transformQuestionsAn2 = _transformQuestionsAn.questionsAnswers,
      questionsAnswers = _transformQuestionsAn2 === void 0 ? null : _transformQuestionsAn2;

  if (!(questionsAnswers !== null && questionsAnswers !== void 0 && questionsAnswers.length)) {
    return null;
  }

  return FAQ_jsx(react.Fragment, null, FAQ_jsx(components_FAQ, {
    title: t('Frequently asked questions'),
    questionsAnswers: questionsAnswers,
    learnMoreText: t('Learn more'),
    trackOpen: trackOfferPageFaqOpenedAction
  }), FAQ_jsx(Separator/* default */.Z, null));
};

var mapStateToProps = function mapStateToProps(_ref2) {
  var location = _ref2.location;
  return {
    location: location
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    trackOfferPageFaqOpenedAction: function trackOfferPageFaqOpenedAction(question) {
      return dispatch((0,actions_tracking/* trackOfferPageFaqOpened */.vF)({
        question: question
      }));
    }
  };
};

/* harmony default export */ var src_components_FAQ = ((0,es/* connect */.$j)(mapStateToProps, mapDispatchToProps)(FAQ_FAQ));
// EXTERNAL MODULE: ../shared/src/svg/mini-camera.js
var mini_camera = __webpack_require__(37283);
// EXTERNAL MODULE: ./src/components/Modals/modal-displayer.js + 74 modules
var modal_displayer = __webpack_require__(52882);
// EXTERNAL MODULE: ../shared/src/store/actions/modal/index.js
var modal = __webpack_require__(92018);
// EXTERNAL MODULE: ../shared/src/constants/photos.js
var constants_photos = __webpack_require__(70561);
// EXTERNAL MODULE: ../shared/src/utils/photos/index.js
var utils_photos = __webpack_require__(27405);
;// CONCATENATED MODULE: ./src/components/Gallery/GalleryButtons/styles.js

var styles_Wrapper = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1ejqzs0-0"
})(["display:flex;width:100%;", " button{min-width:fit-content;width:fit-content;&.floor-plan{svg{width:20px;height:20px;}}&.video{svg{path{fill:", ";}}}}", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.gap(3);
}, function (props) {
  return props.theme.colors.blueDianne;
}, function (props) {
  return props.isMobile && "\n      justify-content: flex-start;\n      margin-block: ".concat(props.theme.space(6), ";\n      padding-inline: ").concat(props.theme.space(5), ";\n\n      @supports not (padding-inline: 10px) {\n        padding-left: ").concat(props.theme.space(5), ";\n        padding-right: ").concat(props.theme.space(5), ";\n      }\n  ");
});
// EXTERNAL MODULE: ../shared/src/svg/index.js + 22 modules
var svg = __webpack_require__(59306);
// EXTERNAL MODULE: ../shared/src/components/Unisystem/Chip/index.js
var Chip = __webpack_require__(84574);
// EXTERNAL MODULE: ../shared/src/svg/floor-plan.js
var floor_plan = __webpack_require__(42047);
// EXTERNAL MODULE: ../shared/src/svg/youtube-alternative.js
var youtube_alternative = __webpack_require__(57540);
// EXTERNAL MODULE: ./src/constants/modals/index.js
var modals = __webpack_require__(69771);
;// CONCATENATED MODULE: ./src/components/Gallery/GalleryButtons/index.js
var GalleryButtons_jsx = react.createElement;














var GalleryButtons = function GalleryButtons(_ref) {
  var hasFloorPlan = _ref.hasFloorPlan,
      hasVideo = _ref.hasVideo,
      showMap = _ref.showMap,
      showGallery = _ref.showGallery;

  var _useContext = (0,react.useContext)(media/* MediaContext */.Y),
      is = _useContext.is;

  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var showFloorPlan = function showFloorPlan() {
    return showGallery(modals/* PHOTOS_MODAL_SECTIONS.floor_plan.label */.c.floor_plan.label);
  };

  var showVideo = function showVideo() {
    return showGallery(modals/* PHOTOS_MODAL_SECTIONS.video.label */.c.video.label);
  };

  return GalleryButtons_jsx(styles_Wrapper, {
    isMobile: is.mobile
  }, GalleryButtons_jsx(Chip/* default */.Z, {
    isPrimary: true,
    label: t('Map'),
    icon: svg/* MapIcon */.Zl,
    onClick: showMap
  }), hasFloorPlan && GalleryButtons_jsx(Chip/* default */.Z, {
    className: 'floor-plan',
    isPrimary: true,
    label: t('Floor plan'),
    icon: floor_plan/* default */.Z,
    onClick: showFloorPlan
  }), hasVideo && GalleryButtons_jsx(Chip/* default */.Z, {
    className: 'video',
    isPrimary: true,
    label: t('Video'),
    icon: youtube_alternative/* default */.Z,
    onClick: showVideo
  }));
};

var GalleryButtons_mapStateToProps = function mapStateToProps(_ref2) {
  var offerAggregate = _ref2.offer.offerAggregate;
  var _offerAggregate$accom = offerAggregate.accommodation_offer;
  _offerAggregate$accom = _offerAggregate$accom === void 0 ? {} : _offerAggregate$accom;
  var _offerAggregate$accom2 = _offerAggregate$accom.floor_plan;
  _offerAggregate$accom2 = _offerAggregate$accom2 === void 0 ? {} : _offerAggregate$accom2;
  var floorPlanName = _offerAggregate$accom2.name,
      _offerAggregate$prope = offerAggregate.property_aggregate.property;
  _offerAggregate$prope = _offerAggregate$prope === void 0 ? {} : _offerAggregate$prope;
  var video = _offerAggregate$prope.video;
  return {
    hasFloorPlan: !!floorPlanName,
    hasVideo: !!(video !== null && video !== void 0 && video.url)
  };
};

var GalleryButtons_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    showMap: function showMap() {
      dispatch((0,actions_tracking/* trackMapOpened */.t7)());
      dispatch((0,modal/* showModalAction */.bF)({
        modalId: modal_displayer.modalIds.MAP
      }));
    },
    showGallery: function showGallery(section) {
      section === modals/* PHOTOS_MODAL_SECTIONS.floor_plan.label */.c.floor_plan.label ? dispatch((0,actions_tracking/* trackFloorPlanOpened */.Cv)()) : dispatch((0,actions_tracking/* trackVideoOpened */.f8)());
      dispatch((0,modal/* showModalAction */.bF)({
        modalId: modal_displayer.modalIds.PHOTOS_MODAL,
        section: section
      }));
    }
  };
};

/* harmony default export */ var Gallery_GalleryButtons = ((0,es/* connect */.$j)(GalleryButtons_mapStateToProps, GalleryButtons_mapDispatchToProps)(GalleryButtons));
// EXTERNAL MODULE: ../shared/src/components/Unisystem/Placeholder/styles.js
var Placeholder_styles = __webpack_require__(95325);
;// CONCATENATED MODULE: ./src/components/Gallery/styles.js



var Gallery_styles_Wrapper = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-bm5mmu-0"
})(["display:grid;grid-template-columns:3fr repeat(2,1fr);grid-template-rows:repeat(2,221px);gap:", ";height:455px;width:100%;position:relative;", "{cursor:pointer;transition:filter 0.2s ease-in-out;&:hover{filter:brightness(0.9);}}", ";"], function (props) {
  return props.theme.space(3);
}, Placeholder_styles/* Wrapper */.im, function (props) {
  return props.isMobile && "\n    display: block;\n    height: calc(100vw * 9 / 16);\n    margin-top: ".concat(props.theme.space(15), ";\n    margin-bottom: ").concat(props.theme.space(3), ";\n  ");
});
var MainPhoto = /*#__PURE__*/styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  componentId: "sc-bm5mmu-1"
})(["width:100%;height:100%;grid-row-start:1;grid-row-end:3;object-fit:cover;border-radius:12px;cursor:pointer;transition:filter 0.2s ease-in-out;&:hover{filter:brightness(0.9);}", ";"], function (_ref) {
  var isMobile = _ref.isMobile;
  return isMobile && 'border-radius: 0';
});
var Photo = /*#__PURE__*/styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  componentId: "sc-bm5mmu-2"
})(["border-radius:12px;width:100%;height:100%;object-fit:cover;cursor:pointer;transition:filter 0.2s ease-in-out;&:hover{filter:brightness(0.9);}"]);
var PhotosChip = /*#__PURE__*/(0,styled_components_browser_esm/* default */.ZP)(Chip/* default */.Z).withConfig({
  componentId: "sc-bm5mmu-3"
})(["position:absolute;right:15px;bottom:10px;", ""], function (_ref2) {
  var isGalleryHover = _ref2.isGalleryHover;
  return isGalleryHover && "\n      min-width: 120px;\n  ";
});
var Fomo = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-bm5mmu-4"
})(["position:absolute;top:", ";display:flex;align-items:center;gap:", ";padding-right:", ";border-radius:0 8px 8px 0;height:40px;z-index:1;background:", ";color:", ";font-size:", ";line-height:", ";span{display:flex;align-items:center;height:26px;padding:", " ", ";border-radius:0 2px 2px 0;background:", ";color:", ";}"], function (props) {
  return props.theme.space(8);
}, function (props) {
  return props.theme.space(1);
}, function (props) {
  return props.theme.space(2);
}, function (props) {
  return props.theme.fomo.hours.background;
}, function (props) {
  return props.theme.fomo.hours.text;
}, function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.rem(18);
}, function (props) {
  return props.theme.space(1);
}, function (props) {
  return props.theme.space(2);
}, function (props) {
  return props.theme.fomo.views.background;
}, function (props) {
  return props.theme.fomo.views.text;
});
// EXTERNAL MODULE: ../shared/src/components/Unisystem/Placeholder/index.js + 8 modules
var Placeholder = __webpack_require__(85324);
;// CONCATENATED MODULE: ./src/components/Gallery/index.js
var Gallery_jsx = react.createElement;














var SHOW_FOMO_THRESHOLD = 10;

var Gallery = function Gallery(_ref) {
  var mainPhoto = _ref.mainPhoto,
      thumbnails = _ref.thumbnails,
      totalPhotos = _ref.totalPhotos,
      offerViews = _ref.offerViews,
      showGallery = _ref.showGallery;

  var _useContext = (0,react.useContext)(media/* MediaContext */.Y),
      is = _useContext.is;

  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t;

  return Gallery_jsx(react.Fragment, null, Gallery_jsx(Gallery_styles_Wrapper, {
    isMobile: is.mobile
  }, offerViews >= SHOW_FOMO_THRESHOLD && Gallery_jsx(Fomo, null, Gallery_jsx("span", null, "".concat(offerViews, " ").concat(t('views'))), t('in the last 12h')), Gallery_jsx(MainPhoto, {
    src: (0,utils_photos/* photoUrl */.wX)({
      hash: mainPhoto === null || mainPhoto === void 0 ? void 0 : mainPhoto.hash,
      size: constants_photos/* PHOTO_SIZES.X_LARGE */.c.X_LARGE
    }),
    isMobile: is.mobile,
    onClick: showGallery
  }), is.notMobile && thumbnails.slice(0, 4).map(function (_ref2, index) {
    var hash = _ref2.hash,
        unitType = _ref2.unitType,
        isPlaceholder = _ref2.isPlaceholder;
    return hash && !isPlaceholder ? Gallery_jsx(Photo, {
      key: "".concat(hash, "-").concat(index),
      src: (0,utils_photos/* photoUrl */.wX)({
        hash: hash,
        size: constants_photos/* PHOTO_SIZES.MEDIUM */.c.MEDIUM
      }),
      onClick: showGallery
    }) : Gallery_jsx(Placeholder/* default */.Z, {
      key: "placeholder-".concat(index),
      type: unitType,
      title: t('No photo yet') // eslint-disable-next-line prettier/prettier
      ,
      subtitle: t('but we\'re working on it!'),
      onClick: showGallery
    });
  }), Gallery_jsx(PhotosChip, {
    isPrimary: true,
    isGalleryHover: is.mobile,
    label: is.mobile ? totalPhotos : t('Photos'),
    icon: mini_camera/* default */.Z,
    onClick: showGallery
  })), Gallery_jsx(Gallery_GalleryButtons, null));
};

var Gallery_mapStateToProps = function mapStateToProps(_ref3) {
  var _ref3$offer = _ref3.offer,
      mainPhotoId = _ref3$offer.offerAggregate.accommodation_offer.main_photo.id,
      photosModal = _ref3$offer.photosModal,
      offerViews = _ref3$offer.offerViews;
  var photos = (photosModal === null || photosModal === void 0 ? void 0 : photosModal.photos) || [];
  return {
    mainPhoto: (0,utils_photos/* findPhotoById */.Eh)(mainPhotoId, photos),
    thumbnails: photos.filter(function (photo) {
      return photo.id !== mainPhotoId;
    }),
    totalPhotos: photos.length,
    offerViews: offerViews
  };
};

var Gallery_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    showGallery: function showGallery() {
      dispatch((0,actions_tracking/* trackGalleryOpened */.ZQ)());
      dispatch((0,modal/* showModalAction */.bF)({
        modalId: modal_displayer.modalIds.PHOTOS_MODAL,
        section: modals/* PHOTOS_MODAL_SECTIONS.photos.label */.c.photos.label
      }));
    }
  };
};

/* harmony default export */ var components_Gallery = ((0,es/* connect */.$j)(Gallery_mapStateToProps, Gallery_mapDispatchToProps)(Gallery));
// EXTERNAL MODULE: ../shared/src/components/Reviews/index.js + 6 modules
var components_Reviews = __webpack_require__(24130);
;// CONCATENATED MODULE: ./src/components/Reviews/index.js
var Reviews_jsx = react.createElement;






var VISIBLE_REVIEWS = 3;

var Reviews = function Reviews(_ref) {
  var _bookingReviews$revie;

  var bookingReviews = _ref.bookingReviews,
      showReviewsModal = _ref.showReviewsModal;
  var items = bookingReviews === null || bookingReviews === void 0 ? void 0 : (_bookingReviews$revie = bookingReviews.review_aggregates) === null || _bookingReviews$revie === void 0 ? void 0 : _bookingReviews$revie.items;

  if (!(items !== null && items !== void 0 && items.length)) {
    return null;
  }

  var showMore = items.length > VISIBLE_REVIEWS;
  var reviews = showMore ? items.slice(0, VISIBLE_REVIEWS) : items;

  var handleShowMore = function handleShowMore() {
    return showReviewsModal(bookingReviews);
  };

  return Reviews_jsx(react.Fragment, null, Reviews_jsx(components_Reviews/* default */.Z, {
    bookingReviews: bookingReviews,
    reviews: reviews,
    showMore: showMore,
    handleShowMore: handleShowMore
  }), Reviews_jsx(Separator/* default */.Z, null));
};

var Reviews_mapStateToProps = function mapStateToProps(_ref2) {
  var offerAggregate = _ref2.offer.offerAggregate;
  return {
    bookingReviews: offerAggregate === null || offerAggregate === void 0 ? void 0 : offerAggregate.booking_review_aggregate
  };
};

var Reviews_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    showReviewsModal: function showReviewsModal(bookingReviews) {
      return dispatch((0,modal/* showModalAction */.bF)({
        modalId: modal_displayer.modalIds.REVIEWS,
        bookingReviews: bookingReviews
      }));
    }
  };
};

/* harmony default export */ var src_components_Reviews = ((0,es/* connect */.$j)(Reviews_mapStateToProps, Reviews_mapDispatchToProps)(Reviews));
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(23769);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
;// CONCATENATED MODULE: ../shared/src/svg/contract.js


var _excluded = ["color"];
var contract_jsx = react.createElement;

var Contract = function Contract(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#224251' : _ref$color,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);
  return contract_jsx("svg", (0,esm_extends/* default */.Z)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), contract_jsx("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.051 21.478h-9.64V7.82h9.64v13.658Z",
    clipRule: "evenodd"
  }), contract_jsx("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.41 15.854H3V5.41a2.41 2.41 0 1 1 2.41 2.41V6.214h2.243"
  }), contract_jsx("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.051 7.82a2.41 2.41 0 1 0 0-4.82h-9.64M10.231 10.911h3.214M10.23 13.566h3.214M10.23 16.663h3.214M7.018 10.633l.401.402 1.607-1.607M7.018 13.846l.401.402 1.607-1.607"
  }), contract_jsx("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21.478 20.273a1.205 1.205 0 1 1-2.41 0V8.623a1.206 1.206 0 0 1 2.41 0v11.65Z",
    clipRule: "evenodd"
  }), contract_jsx("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19.067 19.317h2.41M19.068 13.566h2.41M17.462 15.454V9.428c0-.665.54-1.205 1.205-1.205h.402"
  }));
};
/* harmony default export */ var svg_contract = (Contract);
// EXTERNAL MODULE: ../shared/src/components/Tooltip/styles.js
var Tooltip_styles = __webpack_require__(19868);
;// CONCATENATED MODULE: ./src/components/Contract/styles.js


var Contract_styles_Wrapper = /*#__PURE__*/styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  componentId: "sc-b3fn9o-0"
})(["width:100%;h2{font-family:'IntervalNextReg',sans-serif;font-size:", ";line-height:", ";font-weight:600;color:", ";margin-bottom:", ";}"], function (props) {
  return props.theme.rem(22);
}, function (props) {
  return props.theme.rem(26);
}, function (props) {
  return props.theme.contract.description.color;
}, function (props) {
  return props.theme.space(5);
});
var Item = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-b3fn9o-1"
})(["display:flex;", " margin:", " 0;&:last-of-type{margin-bottom:0;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.gap(2);
}, function (props) {
  return props.theme.space(5);
});
var ItemDescription = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-b3fn9o-2"
})(["display:flex;font-family:'IntervalNextReg',sans-serif;flex-direction:column;h4{font-weight:500;font-size:", ";line-height:", ";display:flex;color:", ";", "{margin-left:", ";}& + p{font-weight:400;font-size:", ";line-height:", ";color:", ";}}a{font-weight:500;font-size:", ";line-height:", ";margin-top:", ";}"], function (props) {
  return props.theme.rem(16);
}, function (props) {
  return props.theme.rem(20);
}, function (props) {
  return props.theme.contract.title.color;
}, Tooltip_styles/* TooltipWrapper */.pf, function (props) {
  return props.theme.space(1);
}, function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.rem(18);
}, function (props) {
  return props.theme.contract.title.color;
}, function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.rem(18);
}, function (props) {
  return props.theme.space(1);
});
;// CONCATENATED MODULE: ../shared/src/svg/cancellation.js


var cancellation_excluded = ["color", "background"];
var cancellation_jsx = react.createElement;

var Cancellation = function Cancellation(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#224251' : _ref$color,
    _ref$background = _ref.background,
    background = _ref$background === void 0 ? '#fff' : _ref$background,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, cancellation_excluded);
  return cancellation_jsx("svg", (0,esm_extends/* default */.Z)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), cancellation_jsx("g", {
    clipPath: "url(#a)"
  }, cancellation_jsx("g", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    clipPath: "url(#b)"
  }, cancellation_jsx("path", {
    d: "M17.5 23.501a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z"
  }), cancellation_jsx("path", {
    d: "M9.5 18.5h-8a1 1 0 0 1-1-1v-14a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1V10M5.5.501v5M15.5.501v5M.5 7.501h20M15 20l5-5M20 20l-5-5"
  }))), cancellation_jsx("defs", null, cancellation_jsx("clipPath", {
    id: "a"
  }, cancellation_jsx("path", {
    fill: background,
    d: "M0 0h24v24H0z"
  })), cancellation_jsx("clipPath", {
    id: "b"
  }, cancellation_jsx("path", {
    fill: background,
    d: "M0 0h24v24H0z"
  }))));
};
/* harmony default export */ var svg_cancellation = (Cancellation);
;// CONCATENATED MODULE: ../shared/src/svg/registration.js


var registration_excluded = ["color", "background"];
var registration_jsx = react.createElement;

var Registration = function Registration(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#224251' : _ref$color,
    _ref$background = _ref.background,
    background = _ref$background === void 0 ? '#fff' : _ref$background,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, registration_excluded);
  return registration_jsx("svg", (0,esm_extends/* default */.Z)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), registration_jsx("g", {
    clipPath: "url(#a)"
  }, registration_jsx("g", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    clipPath: "url(#b)"
  }, registration_jsx("path", {
    d: "M4.5 8.5H14M4.5 11.5h6M4.5 5.5h7M4.5 14.5h4M4.5 17.5h4M10.5 23.5h-9a1 1 0 0 1-1-1v-21a1 1 0 0 1 1-1h13.293a1 1 0 0 1 .707.293L19.207 4.5a1 1 0 0 1 .293.707V8.5"
  }), registration_jsx("path", {
    d: "M11.5 17.5a6 6 0 1 0 12 0 6 6 0 0 0-12 0Z"
  }), registration_jsx("path", {
    d: "m20.174 15.756-2.905 3.873a.752.752 0 0 1-1.13.081l-1.5-1.5"
  }))), registration_jsx("defs", null, registration_jsx("clipPath", {
    id: "a"
  }, registration_jsx("path", {
    fill: background,
    d: "M0 0h24v24H0z"
  })), registration_jsx("clipPath", {
    id: "b"
  }, registration_jsx("path", {
    fill: background,
    d: "M0 0h24v24H0z"
  }))));
};
/* harmony default export */ var registration = (Registration);
;// CONCATENATED MODULE: ./src/constants/contracts/index.js
var CONTRACTS = {
  fortnight: {
    title: 'Fortnightly contract',
    description: 'Fortnightly contract refers to a contract type where you are charged per fortnight booked.',
    urlPath: 'fortnightly'
  },
  monthly: {
    title: 'Monthly contract',
    description: 'Monthly contract refers to a contract type where full months are charged.',
    urlPath: 'monthly'
  },
  nightly: {
    title: 'Daily contract',
    description: 'Daily contract refers to a contract type where your rents are calculated in proportion to the days of your stay.',
    urlPath: 'daily'
  },
  fixed: {
    title: 'Fixed contract',
    description: 'Fixed contract refers to a contract type with fixed start and end dates, defined by the landlord.',
    urlPath: 'fixed'
  }
};
;// CONCATENATED MODULE: ../shared/src/constants/registration.js
var REGISTRATION = {
  GB: 'registration possible',
  ES: 'empadronamiento',
  DE: 'anmeldung',
  IT: 'certificato di residenza',
  FR: 'certificat d’immatriculation',
  PT: 'certificado de registo'
};
;// CONCATENATED MODULE: ../shared/src/components/Unisystem/ArrowLink/styles.js

var Link = /*#__PURE__*/styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  componentId: "sc-1ebk6lf-0"
})(["display:inline-flex;align-items:center;", " font-size:", ";line-height:", ";color:", ";margin-top:", ";text-decoration:none;svg{width:18px;path{fill:", ";}}&:hover{text-decoration:underline;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.gap(3);
}, function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.rem(18);
}, function (props) {
  return props.theme.unisystem.arrowLink.color;
}, function (props) {
  return props.theme.space(9);
}, function (props) {
  return props.theme.unisystem.arrowLink.color;
});
// EXTERNAL MODULE: ../shared/src/svg/arrow-next.js
var arrow_next = __webpack_require__(50954);
;// CONCATENATED MODULE: ../shared/src/components/Unisystem/ArrowLink/index.js


var ArrowLink_excluded = ["href", "text"];
var ArrowLink_jsx = react.createElement;



var ArrowLink = function ArrowLink(_ref) {
  var href = _ref.href,
    text = _ref.text,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, ArrowLink_excluded);
  return ArrowLink_jsx(Link, (0,esm_extends/* default */.Z)({
    href: href,
    target: "_blank"
  }, props), ArrowLink_jsx("span", null, text), ArrowLink_jsx(arrow_next/* default */.Z, null));
};
/* harmony default export */ var Unisystem_ArrowLink = (ArrowLink);
;// CONCATENATED MODULE: ../shared/src/constants/cancellations.js
var CANCELLATIONS = {
  flexible: {
    title: 'Cancellation flexible',
    description: 'Your 1st rent will be 100% refunded if you cancel up to 30 days before the contract start date or you’ll get a 50% refund if you cancel up to 15 days.'
  },
  moderate: {
    title: 'Cancellation moderate',
    description: 'Your 1st rent will be 100% refunded if you cancel up to 60 days before the contract start date or you’ll get a 50% refund if you cancel up to 30 days.'
  },
  strict: {
    title: 'Cancellation strict',
    description: 'Your 1st rent will be 100% refunded if you cancel up to 90 days before the contract start date or you’ll get a 50% refund if you cancel up to 30 days.'
  },
  'super-strict': {
    title: 'Cancellation non-refundable',
    description: 'This type of policy doesn’t allow any refunds, regardless of when you decide to cancel a confirmed booking.'
  }
};
// EXTERNAL MODULE: ../shared/src/components/index.js + 8 modules
var components = __webpack_require__(45604);
// EXTERNAL MODULE: ../shared/src/svg/exclamation.js
var exclamation = __webpack_require__(16627);
// EXTERNAL MODULE: ./src/theme.js
var src_theme = __webpack_require__(63263);
;// CONCATENATED MODULE: ./src/components/Contract/index.js
var Contract_jsx = react.createElement;















var HELP_LINKS = {
  CANCELLATION_POLICIES: 'cancellation policies',
  CONTRACT_TYPES: 'more about the contract'
};

var Contract_Contract = function Contract(_ref) {
  var _REGISTRATION$country;

  var contractType = _ref.contractType,
      cancellationType = _ref.cancellationType,
      hasRegistration = _ref.hasRegistration,
      country = _ref.country,
      trackHelpCenterAction = _ref.trackHelpCenterAction;

  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t,
      language = _useTranslation.i18n.language;

  var contract = CONTRACTS[contractType];
  var cancellation = CANCELLATIONS[cancellationType];
  var countryRegistration = (_REGISTRATION$country = REGISTRATION[country]) !== null && _REGISTRATION$country !== void 0 ? _REGISTRATION$country : t('Registration possible');
  var languagePath = language === 'en' ? '' : "".concat(language, "/");
  return Contract_jsx(Contract_styles_Wrapper, {
    id: 'Contract'
  }, Contract_jsx("h2", null, t('Contract')), Contract_jsx(Item, null, Contract_jsx("div", null, Contract_jsx(svg_cancellation, null)), Contract_jsx(ItemDescription, null, Contract_jsx("h4", null, t(cancellation.title), Contract_jsx(components/* Tooltip */.u, {
    bottom: false
  }, Contract_jsx(exclamation/* default */.Z, {
    color: src_theme/* theme.tooltip.iconColor */.r.tooltip.iconColor
  }), Contract_jsx("p", null, t('Uniplaces uses the contract start date and not the move-in date to calculate how many days are applied in the policy.')))), Contract_jsx("p", null, t(cancellation.description)), Contract_jsx(Unisystem_ArrowLink, {
    href: "https://help.uniplaces.com/s/article/How-much-can-you-be-refunded-by-Uniplaces-Read-all-about-Uniplaces-Cancellation-Policies?language=en_US",
    text: t('More about our cancellation policies'),
    onClick: function onClick() {
      return trackHelpCenterAction(HELP_LINKS.CANCELLATION_POLICIES);
    }
  }))), Contract_jsx(Item, null, Contract_jsx("div", null, Contract_jsx(svg_contract, null)), Contract_jsx(ItemDescription, null, Contract_jsx("h4", null, t(contract.title)), Contract_jsx("p", null, t(contract.description)), Contract_jsx(Unisystem_ArrowLink, {
    href: "".concat("https://uniplaces.com/").concat(languagePath, "contract-types/").concat(contract.urlPath),
    text: t('More about the contract'),
    onClick: function onClick() {
      return trackHelpCenterAction(HELP_LINKS.CONTRACT_TYPES);
    }
  }))), hasRegistration ? Contract_jsx(Item, null, Contract_jsx("div", null, Contract_jsx(registration, null)), Contract_jsx(ItemDescription, null, Contract_jsx("h4", null, t('Registration possible')), Contract_jsx("p", null, t('You can get registered on this place'), " (", countryRegistration, ")."))) : null);
};

var Contract_mapStateToProps = function mapStateToProps(_ref2) {
  var _documentation$offici;

  var _ref2$offer$offerAggr = _ref2.offer.offerAggregate,
      _ref2$offer$offerAggr2 = _ref2$offer$offerAggr.accommodation_offer,
      type = _ref2$offer$offerAggr2.contract.type,
      cancellation_policy = _ref2$offer$offerAggr2.requisites.conditions.cancellation_policy,
      _ref2$offer$offerAggr3 = _ref2$offer$offerAggr.property_aggregate.property,
      documentation = _ref2$offer$offerAggr3.documentation,
      city_code = _ref2$offer$offerAggr3.location.address.city_code;
  return {
    contractType: type.split('-')[0],
    cancellationType: cancellation_policy,
    hasRegistration: !!(documentation !== null && documentation !== void 0 && (_documentation$offici = documentation.official_registration) !== null && _documentation$offici !== void 0 && _documentation$offici.enabled),
    country: city_code.split('-')[0]
  };
};

var Contract_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    trackHelpCenterAction: function trackHelpCenterAction(destination) {
      return dispatch((0,actions_tracking/* trackHelpCenter */.Tl)({
        destination: destination
      }));
    }
  };
};

/* harmony default export */ var components_Contract = ((0,es/* connect */.$j)(Contract_mapStateToProps, Contract_mapDispatchToProps)(Contract_Contract));
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/parseISO/index.js
var parseISO = __webpack_require__(31807);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/isValid/index.js
var isValid = __webpack_require__(4478);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/format/index.js + 4 modules
var format = __webpack_require__(73053);
;// CONCATENATED MODULE: ../shared/src/components/Unisystem/Pill/styles.js

var Pill_styles_Wrapper = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-ru6obx-0"
})(["display:flex;justify-content:center;align-items:center;", ";padding:", " ", ";max-width:max-content;border-radius:20px;p{align-self:center;margin-bottom:0;}", ";", ";", ";", ";", ";", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.gap(2);
}, function (props) {
  return props.theme.space(1);
}, function (props) {
  return props.theme.space(3);
}, function (props) {
  return props.isUniBlue && "background: ".concat(props.theme.unisystem.pill.background.uniBlue);
}, function (props) {
  return props.isBlue && "background: ".concat(props.theme.unisystem.pill.background.blue);
}, function (props) {
  return props.isRed && "background: ".concat(props.theme.unisystem.pill.background.red);
}, function (props) {
  return props.isYellow && "background: ".concat(props.theme.unisystem.pill.background.yellow);
}, function (props) {
  return props.isGrey && "background: ".concat(props.theme.unisystem.pill.background.grey);
}, function (props) {
  return props.isGreen && "background: ".concat(props.theme.unisystem.pill.background.green);
});
;// CONCATENATED MODULE: ../shared/src/components/Unisystem/Pill/index.js
var Pill_jsx = react.createElement;


var Pill = function Pill(_ref) {
  var Icon = _ref.Icon,
    label = _ref.label,
    isBlue = _ref.isBlue,
    isRed = _ref.isRed,
    isYellow = _ref.isYellow,
    isGrey = _ref.isGrey,
    isGreen = _ref.isGreen,
    isUniBlue = _ref.isUniBlue;
  return Pill_jsx(Pill_styles_Wrapper, {
    isUniBlue: isUniBlue,
    isBlue: isBlue,
    isRed: isRed,
    isYellow: isYellow,
    isGrey: isGrey,
    isGreen: isGreen
  }, Icon ? Pill_jsx(Icon, null) : null, Pill_jsx("p", null, label));
};
/* harmony default export */ var Unisystem_Pill = (Pill);
;// CONCATENATED MODULE: ../shared/src/components/SimpleCarousel/styles.js

var styles_templateObject, styles_templateObject2, styles_templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;


var SimpleCarousel_styles_Wrapper = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1h628ya-0"
})(["display:flex;flex-direction:column;position:relative;"]);
var styles_CarouselWrapper = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1h628ya-1"
})(["display:flex;position:relative;gap:", ";width:100%;height:100%;overflow-x:hidden;"], function (props) {
  return props.theme.gap(4);
});
var Header = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1h628ya-2"
})(["display:flex;justify-content:space-between;align-items:center;position:relative;"]);
var ButtonsWrapper = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1h628ya-3"
})(["display:flex;align-items:center;justify-content:space-between;gap:", ";& > div{display:flex;gap:", ";}.left,.right{display:flex;align-items:center;justify-content:center;width:30px;height:30px;z-index:1;border:none;cursor:pointer;border-radius:50%;background-color:", ";box-shadow:0px 3px 10px 0px rgba(34,66,81,0.1);svg{position:relative;width:8px;height:16px;}}.right{cursor:", ";pointer-events:", ";opacity:", ";", " ", " ", "}.left{cursor:", ";pointer-events:", ";opacity:", ";", " ", " ", "}", ""], function (props) {
  return props.theme.space(4);
}, function (props) {
  return props.theme.space(3);
}, function (props) {
  return props.theme.simpleCarousel.navigationControls.backgroundColor;
}, function (props) {
  return props.rightEnabled ? 'pointer' : 'default';
}, function (props) {
  return props.rightEnabled ? 'auto' : 'none';
}, function (props) {
  return props.rightEnabled ? 1 : 0.5;
}, theme/* mediaMin.smallBreakpoint */.A3.smallBreakpoint(styles_templateObject || (styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n      display: none;\n    "]))), theme/* tabletRange.ipad */.zM.ipad()(styles_templateObject2 || (styles_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n      display: none;\n    "]))), theme/* tabletRange.ipad */.zM.ipad('landscape')(styles_templateObject3 || (styles_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n      display: none;\n    "]))), function (props) {
  return props.leftEnabled ? 'pointer' : 'default';
}, function (props) {
  return props.leftEnabled ? 'auto' : 'none';
}, function (props) {
  return props.leftEnabled ? 1 : 0.5;
}, theme/* mediaMin.smallBreakpoint */.A3.smallBreakpoint(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n      display: none;\n    "]))), theme/* tabletRange.ipad */.zM.ipad()(_templateObject5 || (_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n      display: none;\n    "]))), theme/* tabletRange.ipad */.zM.ipad('landscape')(_templateObject6 || (_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n      display: none;\n    "]))), theme/* mediaMin.largeBreakpoint */.A3.largeBreakpoint(_templateObject7 || (_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n    display: none;\n  "]))));
var Carousel = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1h628ya-4"
})(["display:flex;", " transform:translateX(-", "px);transition:transform 0.5s ease;", " ", ""], function (_ref) {
  var theme = _ref.theme;
  return theme.gap(4);
}, function (props) {
  return props.carouselOffset;
}, theme/* mediaMin.mediumBreakpoint */.A3.mediumBreakpoint(_templateObject8 || (_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n    width: 100%;\n  "]))), theme/* mediaMin.largeBreakpoint */.A3.largeBreakpoint(_templateObject9 || (_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n    overflow-x: auto;\n    max-width: 100%;\n    width: 90vw;\n  "]))));
;// CONCATENATED MODULE: ./src/components/Landlord/styles.js


var Landlord_styles_templateObject;






var Landlord_styles_Wrapper = /*#__PURE__*/styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  componentId: "sc-rf4wwr-0"
})(["display:flex;flex-direction:column;", " color:", ";width:100%;", "{", " ", "{p{font-size:", ";line-height:", ";font-weight:400;}}}"], function (_ref) {
  var theme = _ref.theme;
  return theme.gap(5, 'column');
}, function (props) {
  return props.theme.landlordSection.textColor;
}, SimpleCarousel_styles_Wrapper, function (_ref2) {
  var theme = _ref2.theme;
  return theme.gap(6, 'column');
}, Header, function (props) {
  return props.theme.rem(16);
}, function (props) {
  return props.theme.rem(20);
});
var styles_Title = /*#__PURE__*/styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  componentId: "sc-rf4wwr-1"
})(["display:flex;", " align-items:flex-start;flex-wrap:wrap;h2{font-family:'IntervalNextReg',sans-serif;font-size:", ";line-height:", ";font-weight:600;}& > span{display:flex;align-items:center;flex-wrap:wrap;", " ", "{", "}}", "{font-size:", ";line-height:", ";color:", ";padding:", " ", ";height:32px;svg{path{fill:", ";}}}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.gap(3);
}, function (props) {
  return props.theme.rem(22);
}, function (props) {
  return props.theme.rem(26);
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.gap(3);
}, Tooltip_styles/* TooltipContainer */.DY, theme/* mediaMin.smallBreakpoint */.A3.smallBreakpoint(Landlord_styles_templateObject || (Landlord_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n        min-width: 180px;\n        max-width: 180px;\n      "]))), Pill_styles_Wrapper, function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.rem(18);
}, function (props) {
  return props.theme.landlordSection.pill.textColor;
}, function (props) {
  return props.theme.space(2);
}, function (props) {
  return props.theme.space(3);
}, function (props) {
  return props.theme.landlordSection.pill.textColor;
});
var LandlordStats = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-rf4wwr-2"
})(["display:flex;", " flex-wrap:wrap;div{display:flex;", " align-items:center;svg{width:24px;height:24px;}}"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.gap(4);
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.gap(2);
});
;// CONCATENATED MODULE: ../shared/src/components/Search/Card/Gallery/styles.js

var Gallery_styles_templateObject, Gallery_styles_templateObject2, Gallery_styles_templateObject3;


var Card_Gallery_styles_Wrapper = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1k24ja-0"
})(["display:flex;flex-direction:row;margin-bottom:", ";cursor:pointer;text-decoration:none;", ";"], function (props) {
  return props.theme.space(4);
}, theme/* mediaMin.smallBreakpoint */.A3.smallBreakpoint(Gallery_styles_templateObject || (Gallery_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n    flex-direction: column;\n  "]))));
var Photos = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1k24ja-1"
})(["min-width:100%;overflow:hidden;will-change:transform;position:relative;display:flex;flex-direction:row;[loading='lazy']{position:absolute;height:100%;width:100%;}", ";[aria-label]{position:absolute;z-index:1;top:calc(50% - 15px);opacity:0;}[aria-label='previous']{left:", ";}[aria-label='next']{right:", ";}&:hover{[aria-label]{opacity:1;}}img{width:100%;height:100%;display:block;object-fit:cover;object-position:center center;will-change:transform;background:transparent;position:absolute;top:0;right:0;bottom:0;left:0;border-radius:12px;}> div > span{", ";}"], theme/* mediaMin.smallBreakpoint */.A3.smallBreakpoint(Gallery_styles_templateObject2 || (Gallery_styles_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    height: 200px;\n  "]))), function (props) {
  return props.theme.space(3);
}, function (props) {
  return props.theme.space(3);
}, theme/* mediaMin.smallBreakpoint */.A3.smallBreakpoint(Gallery_styles_templateObject3 || (Gallery_styles_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n      height: 200px;\n    "]))));
var ScrollIndicatorContainer = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1k24ja-2"
})(["position:absolute;display:flex;width:100%;justify-content:center;bottom:12px;"]);
// EXTERNAL MODULE: ../shared/src/components/Search/Card/Controls/AddToWishList/styles.js
var AddToWishList_styles = __webpack_require__(86095);
;// CONCATENATED MODULE: ../shared/src/components/Search/Card/Controls/CloseCards/styles.js

var CloseCards_styles_Wrapper = /*#__PURE__*/styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  componentId: "sc-1uk9izu-0"
})(["display:flex;align-items:center;justify-content:center;width:24px;height:24px;background-color:rgba(34,66,81,0.5);border-radius:50%;border:none;overflow:visible;-webkit-appearance:none;cursor:pointer;svg{width:10px;fill:", ";}"], function (props) {
  return props.theme.card.background;
});
;// CONCATENATED MODULE: ../shared/src/components/Search/Card/Mapview/styles.js


var WrapperLink = /*#__PURE__*/(/* unused pure expression or super */ null && (styled.a.withConfig({
  componentId: "sc-1pggvqu-0"
})(["& > *{text-decoration:none;}"])));
var Mapview_styles_Wrapper = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1pggvqu-1"
})(["display:flex;flex-direction:column;width:285px;min-height:257px;box-shadow:0px 10px 20px rgba(34,66,81,0.3);border-radius:12px;background:", ";", ""], function (props) {
  return props.theme.card.background;
}, function (props) {
  return props.isMobile && "\n      flex-direction: row;\n      width: 346px;\n      height: 160px;\n      min-height: 0px;\n    ";
});
var MediaWrapper = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1pggvqu-2"
})(["width:100%;position:relative;img{width:100%;height:160px;object-fit:cover;border-radius:12px 12px 0 0;}", ""], function (props) {
  return props.isMobile && "\n      width: 160px;\n\n      img {\n        width: 160px;\n        border-radius: 12px 0 0 12px;\n      }\n    ";
});
var InfoWrapper = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1pggvqu-3"
})(["padding:", " ", " ", ";h2{font-size:", ";", "}", ""], function (props) {
  return props.theme.space(1);
}, function (props) {
  return props.theme.space(3);
}, function (props) {
  return props.theme.space(3);
}, function (props) {
  return props.theme.rem(16);
}, function (props) {
  return props.isMobile && "\n        margin-right: 30px;\n        width: 140px;\n        height: 40px;\n        overflow: hidden;\n        line-clamp: 2;\n        text-decoration: none;\n        display: -webkit-box;\n        -webkit-line-clamp: 2;\n        -webkit-box-orient: vertical;\n        text-overflow: ellipsis;\n    ";
}, function (props) {
  return props.isMobile && "\n      padding: ".concat(props.theme.space(3), " ").concat(props.theme.space(2), ";\n\n      ").concat(PriceBillsWrapper, " {\n        flex-direction: column;\n        align-items: flex-start;\n\n        > span {\n          margin: ").concat(props.theme.space(2), " 0;\n        }\n      }\n    ");
});
;// CONCATENATED MODULE: ../shared/src/components/Search/Card/Labels/styles.js

var Labels_styles_templateObject;


var Labels_styles_Wrapper = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-7ypfop-0"
})(["display:flex;align-items:center;justify-content:center;width:100%;height:28px;background-color:rgba(34,66,81,0.6);color:", ";font-family:IntervalNextReg,sans-serif;font-weight:100;line-height:normal;font-size:", ";border-radius:0 0 12px 12px;", " svg{width:180px;", " ", "}"], function (props) {
  return props.theme.typography.invertedColor;
}, function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.isFeatured && "\n    background-color: ".concat(props.theme.backgrounds.uniBlueFaded, ";\n  ");
}, theme/* mediaMin.smallBreakpoint */.A3.smallBreakpoint(Labels_styles_templateObject || (Labels_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n      width: 150px;\n    "]))), function (props) {
  return props.isFeatured && "\n      width: 15px;\n      margin-right: ".concat(props.theme.space(1), ";\n    ");
});
;// CONCATENATED MODULE: ../shared/src/components/Search/Card/Tags/styles.js

var Tags_styles_Wrapper = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1g6rzkm-0"
})(["display:flex;align-items:center;min-width:30px;height:22px;background:rgba(247,247,247,0.8);padding:0 ", ";font-family:IntervalNextReg,sans-serif;font-weight:500;font-size:", ";color:", ";border-top-right-radius:4px;border-bottom-right-radius:4px;position:absolute;top:13px;"], function (props) {
  return props.theme.space(2);
}, function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.card.primaryTextColor;
});
;// CONCATENATED MODULE: ../shared/src/components/Search/Card/OfferCard/styles.js

var OfferCard_styles_templateObject, OfferCard_styles_templateObject2;








var styles_WrapperLink = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-8a44ft-0"
})(["position:relative;display:block;max-width:360px;padding-bottom:", ";text-decoration:none;cursor:pointer;flex:1;a{text-decoration:none;}", " ", " ", " & > *{text-decoration:none;}", "{position:absolute;top:11px;right:11px;}", "{", "{right:11px;}}", "{", "}", "{", " ", "{position:absolute;bottom:0;", " ", " ", " ", "}}", "{height:240px;", "}", "{z-index:1;}"], function (props) {
  return props.theme.space(3);
}, theme/* mediaMin.mediumBreakpoint */.A3.mediumBreakpoint(OfferCard_styles_templateObject || (OfferCard_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n    ", "\n  "])), function (props) {
  return !props.isMap && "\n        width: 100%;\n      ";
}), theme/* mediaMin.smallBreakpoint */.A3.smallBreakpoint(OfferCard_styles_templateObject2 || (OfferCard_styles_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    max-width: 100%;\n  "]))), function (props) {
  return props.isMap && "\n      width: ".concat(props.isMobile ? '346px' : '285px', "\n    ");
}, AddToWishList_styles/* Wrapper */.i, Mapview_styles_Wrapper, AddToWishList_styles/* Wrapper */.i, CloseCards_styles_Wrapper, function (props) {
  return props.isMap && "\n      position: absolute;\n      top: 11px;\n      left: 11px;\n    ";
}, Card_Gallery_styles_Wrapper, function (props) {
  return props.isMap && "\n        margin-bottom: 0;\n    ";
}, Labels_styles_Wrapper, function (props) {
  return props.isMap && !props.isMobile && "\n        border-radius: 0px;\n      ";
}, function (props) {
  return props.isMobile && "\n        right: 0;\n        border-bottom-right-radius: 12px;\n      ";
}, function (props) {
  return props.isMobile && props.isUniresidences && "\n        background-color:  ".concat(props.theme.labels.uniResidencesBackground, ";\n      ");
}, function (props) {
  return props.isMobile && props.isMap && "\n        border-bottom-right-radius: 0px;\n      ";
}, Photos, function (props) {
  return props.isMap && "\n      width: ".concat(props.isMobile ? '160px' : '287px', ";\n      min-width: ").concat(props.isMobile ? 'auto' : '260px', ";\n      height: 160px;\n    ");
}, Tags_styles_Wrapper);
var OfferCard_styles_Title = /*#__PURE__*/styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  componentId: "sc-8a44ft-1"
})(["p,h2{font-family:IntervalNextReg,sans-serif;font-size:", ";line-height:", ";font-weight:600;color:", ";margin-bottom:", ";}"], function (props) {
  return props.theme.rem(18);
}, function (props) {
  return props.theme.rem(22);
}, function (props) {
  return props.theme.card.primaryTextColor;
}, function (props) {
  return props.theme.space(3);
});
var FromDate = /*#__PURE__*/styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  componentId: "sc-8a44ft-2"
})(["font-family:IntervalNextReg,sans-serif;font-weight:100;line-height:normal;font-size:", ";line-height:", ";font-weight:500;color:", ";margin-bottom:", ";"], function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.rem(19);
}, function (props) {
  return props.theme.card.neighbourhoodIconColor;
}, function (props) {
  return props.theme.space(2);
});
var Price = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-8a44ft-3"
})(["font-family:IntervalNextReg,sans-serif;font-weight:100;line-height:normal;font-size:", ";line-height:", ";font-weight:400;color:", ";margin-right:", ";span{font-family:IntervalNextReg,sans-serif;font-size:", ";font-weight:600;color:", ";margin:0 2px 0 5px;&.old__price{color:", ";font-size:", ";text-decoration-line:line-through;}}"], function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.rem(17);
}, function (props) {
  return props.theme.card.thirdColor;
}, function (props) {
  return props.theme.space(3);
}, function (props) {
  return props.theme.rem(22);
}, function (props) {
  return props.theme.card.primaryTextColor;
}, function (props) {
  return props.theme.colors.redPrimary;
}, function (props) {
  return props.theme.rem(16);
});
var styles_InfoWrapper = /*#__PURE__*/(/* unused pure expression or super */ null && (styled.div.withConfig({
  componentId: "sc-8a44ft-4"
})(["padding:", " ", " ", ";", ""], function (props) {
  return props.theme.space(1);
}, function (props) {
  return props.theme.space(3);
}, function (props) {
  return props.theme.space(3);
}, function (props) {
  return props.isMobile && "\n      padding: ".concat(props.theme.space(3), " ").concat(props.theme.space(2), ";\n    ");
})));
var Typology = /*#__PURE__*/styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  componentId: "sc-8a44ft-5"
})(["font-family:IntervalNextReg,sans-serif;font-weight:100;line-height:normal;font-size:", ";line-height:", ";font-weight:400;margin-top:", ";color:", ";"], function (props) {
  return props.theme.rem(12);
}, function (props) {
  return props.theme.rem(15);
}, function (props) {
  return props.theme.space(4);
}, function (props) {
  return props.theme.card.thirdColor;
});
var BillsIncluded = /*#__PURE__*/styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  componentId: "sc-8a44ft-6"
})(["font-family:IntervalNextReg,sans-serif;font-size:", ";line-height:", ";color:", ";"], function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.rem(17);
}, function (props) {
  return props.theme.card.billsIncludedColor;
});
var PriceBillsWrapper = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-8a44ft-7"
})(["display:flex;align-items:baseline;color:", ";flex-wrap:wrap;"], function (props) {
  return props.theme.card.thirdColor;
});
var LabelsWrapper = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-8a44ft-8"
})(["display:flex;flex-wrap:wrap;gap:", ";margin-bottom:", ";"], function (props) {
  return props.theme.space(2);
}, function (props) {
  return props.theme.space(2);
});
var HomepageTag = /*#__PURE__*/styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  componentId: "sc-8a44ft-9"
})(["display:flex;align-items:center !important;min-width:30px;height:22px;background:#f6f6f6;color:#224251;padding:0 ", ";font-family:IntervalNextReg,sans-serif;font-size:", ";color:", ";border-radius:4px;"], function (props) {
  return props.theme.space(2);
}, function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.card.primaryTextColor;
});
;// CONCATENATED MODULE: ./src/components/MoreListings/styles.js


var MoreListings_styles_templateObject;





var MoreListings_styles_Wrapper = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1pxl8eg-0"
})(["display:flex;flex-direction:column;gap:", ";margin-top:", ";", " ", "{width:224px;", "{display:none;}", "{margin-bottom:", ";}", "{height:160px;}", "{span{margin-left:0;}}", "{color:", ";}}"], function (props) {
  return props.theme.space(3);
}, function (props) {
  return props.theme.space(7);
}, theme/* mediaMin.smallBreakpoint */.A3.smallBreakpoint(MoreListings_styles_templateObject || (MoreListings_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-top: ", ";\n    ", "\n  "])), function (props) {
  return props.theme.space(3);
}, function (_ref) {
  var theme = _ref.theme;
  return theme.gap(3, 'column');
}), styles_WrapperLink, OfferCard_styles_Title, Card_Gallery_styles_Wrapper, function (props) {
  return props.theme.space(2);
}, Photos, Price, BillsIncluded, function (props) {
  return props.theme.landlordSection.card.billsIncludedColor;
});
// EXTERNAL MODULE: ../shared/src/svg/arrow-left.js
var arrow_left = __webpack_require__(32107);
// EXTERNAL MODULE: ../shared/src/svg/arrow-right.js
var arrow_right = __webpack_require__(24202);
;// CONCATENATED MODULE: ../shared/src/components/SimpleCarousel/index.js
var SimpleCarousel_jsx = react.createElement;






var SimpleCarousel = function SimpleCarousel(_ref) {
  var children = _ref.children,
    title = _ref.title,
    numberOfElements = _ref.numberOfElements,
    itemWidth = _ref.itemWidth,
    gap = _ref.gap;
  var _useTranslation = (0,esm/* useTranslation */.$G)(),
    t = _useTranslation.t;
  var wrapperRef = (0,react.useRef)();
  var _useState = (0,react.useState)(0),
    activeIndex = _useState[0],
    setActiveIndex = _useState[1];
  var _useState2 = (0,react.useState)(0),
    elementsVisible = _useState2[0],
    setElementsVisible = _useState2[1];
  var goLeft = function goLeft() {
    return setActiveIndex(activeIndex - 1);
  };
  var goRight = function goRight() {
    return setActiveIndex(activeIndex + 1);
  };
  var maxIndex = Math.ceil(numberOfElements - elementsVisible - 1);
  var carouselOffset = activeIndex * (itemWidth + gap);
  (0,react.useEffect)(function () {
    var _wrapperRef$current;
    return setElementsVisible((wrapperRef === null || wrapperRef === void 0 ? void 0 : (_wrapperRef$current = wrapperRef.current) === null || _wrapperRef$current === void 0 ? void 0 : _wrapperRef$current.clientWidth) / (itemWidth + gap));
  }, []);
  return SimpleCarousel_jsx(SimpleCarousel_styles_Wrapper, {
    ref: wrapperRef
  }, SimpleCarousel_jsx(Header, null, SimpleCarousel_jsx("p", null, t(title)), numberOfElements > Math.round(elementsVisible) ? SimpleCarousel_jsx(ButtonsWrapper, {
    leftEnabled: activeIndex > 0,
    rightEnabled: activeIndex < maxIndex
  }, SimpleCarousel_jsx("span", null, activeIndex + 1, "/", maxIndex + 1), SimpleCarousel_jsx("div", null, SimpleCarousel_jsx("button", {
    className: "left",
    onClick: goLeft
  }, SimpleCarousel_jsx(arrow_left/* default */.Z, {
    color: theme/* theme.simpleCarousel.navigationControls.svgColor */.rS.simpleCarousel.navigationControls.svgColor
  })), SimpleCarousel_jsx("button", {
    className: "right",
    onClick: goRight
  }, SimpleCarousel_jsx(arrow_right/* default */.Z, {
    color: theme/* theme.simpleCarousel.navigationControls.svgColor */.rS.simpleCarousel.navigationControls.svgColor
  })))) : null), SimpleCarousel_jsx(styles_CarouselWrapper, null, SimpleCarousel_jsx(Carousel, {
    carouselOffset: carouselOffset
  }, children)));
};
/* harmony default export */ var components_SimpleCarousel = (SimpleCarousel);
// EXTERNAL MODULE: ../shared/src/utils/redirect/index.js
var redirect = __webpack_require__(82041);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toArray.js
var toArray = __webpack_require__(95922);
;// CONCATENATED MODULE: ../shared/src/utils/cityCodeToCitySlug/index.js

var cityCodeToCitySlug = function cityCodeToCitySlug(cityCode) {
  if (!cityCode.includes('-')) {
    return cityCode;
  }
  var _cityCode$split = cityCode.split('-'),
    _cityCode$split2 = (0,toArray/* default */.Z)(_cityCode$split),
    city = _cityCode$split2.slice(1);
  return city.join('-');
};
// EXTERNAL MODULE: ../shared/src/store/actions/profile/index.js
var profile = __webpack_require__(60224);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/addHours/index.js
var addHours = __webpack_require__(20578);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/subMonths/index.js
var subMonths = __webpack_require__(94873);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/isWithinInterval/index.js
var isWithinInterval = __webpack_require__(1713);
// EXTERNAL MODULE: ../shared/src/utils/index.js + 1 modules
var utils = __webpack_require__(73706);
;// CONCATENATED MODULE: ../shared/src/containers/Card/transformer.js



var getResultOffer = function getResultOffer(_ref) {
  var _attributes$offers;
  var id = _ref.id,
    attributes = _ref.attributes;
  var isResidences = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var offerAttributes = isResidences && (_attributes$offers = attributes.offers) !== null && _attributes$offers !== void 0 && _attributes$offers.length ? attributes.offers[0] : attributes;
  var _offerAttributes$acco = offerAttributes.accommodation_offer,
    allBillsIncluded = _offerAttributes$acco.all_bills_included,
    availableFrom = _offerAttributes$acco.available_from,
    maxGuests = _offerAttributes$acco.max_guests,
    offerTitle = _offerAttributes$acco.title,
    _offerAttributes$acco2 = _offerAttributes$acco.price,
    amount = _offerAttributes$acco2.amount,
    currencyCode = _offerAttributes$acco2.currency_code,
    oldPrice = _offerAttributes$acco.old_price,
    reviewsRating = _offerAttributes$acco.reviews_average,
    isExclusive = _offerAttributes$acco.exclusive,
    isInstantBooking = _offerAttributes$acco.is_instant_booking,
    createdAt = _offerAttributes$acco.created_at,
    isSoldOut = _offerAttributes$acco.is_sold_out,
    _offerAttributes$prop = offerAttributes.property,
    propertyId = _offerAttributes$prop.id,
    propertyTitle = _offerAttributes$prop.title,
    _offerAttributes$prop2 = _offerAttributes$prop.neighbourhood;
  _offerAttributes$prop2 = _offerAttributes$prop2 === void 0 ? {} : _offerAttributes$prop2;
  var neighbourhood = _offerAttributes$prop2.name,
    numberOfBathrooms = _offerAttributes$prop.number_of_bathrooms,
    numberOfRooms = _offerAttributes$prop.number_of_rooms,
    rentBy = _offerAttributes$prop.rent_by,
    isVerified = _offerAttributes$prop.verified,
    building = _offerAttributes$prop.building,
    _offerAttributes$prop3 = _offerAttributes$prop.photos,
    propertyPhotos = _offerAttributes$prop3 === void 0 ? [] : _offerAttributes$prop3,
    isTrusted = offerAttributes.accommodation_provider.verifications.trusted,
    _offerAttributes$phot = offerAttributes.photos,
    photos = _offerAttributes$phot === void 0 ? [] : _offerAttributes$phot;
  var title = isResidences ? propertyTitle || offerTitle : offerTitle;
  return {
    id: id,
    propertyId: propertyId,
    title: title,
    maxGuests: maxGuests,
    availableFrom: new Date(availableFrom),
    allBillsIncluded: allBillsIncluded,
    rent: {
      amount: amount,
      currencyCode: currencyCode
    },
    oldRent: oldPrice ? {
      amount: oldPrice.amount,
      currencyCode: oldPrice.currency_code
    } : null,
    neighbourhood: neighbourhood,
    numberOfBathrooms: numberOfBathrooms,
    numberOfRooms: numberOfRooms,
    rentBy: rentBy,
    building: building,
    reviewsRating: reviewsRating,
    isExclusive: isExclusive,
    isInstantBooking: isInstantBooking,
    isVerified: isVerified,
    isTrusted: isTrusted,
    isSoldOut: isSoldOut,
    isNew: isNew(createdAt),
    photos: transformPhotosUrl(isResidences && propertyPhotos.length ? propertyPhotos : photos)
  };
};
var getStaticOffer = function getStaticOffer(_ref2, language) {
  var id = _ref2.id,
    titles = _ref2.titles,
    maxGuests = _ref2.maxGuests,
    availableFrom = _ref2.availableFrom,
    allBillsIncluded = _ref2.isBillsIncluded,
    price = _ref2.price,
    currencyCode = _ref2.currencyCode,
    numberOfRooms = _ref2.countBedrooms,
    rentBy = _ref2.rentBy,
    isExclusive = _ref2.exclusive,
    isInstantBooking = _ref2.instant_booking,
    isVerified = _ref2.checked,
    isTrusted = _ref2.trusted_landlord,
    photos = _ref2.photos;
  return {
    id: id,
    propertyId: null,
    title: titles[languageToLocale(language)],
    maxGuests: maxGuests,
    availableFrom: new Date(availableFrom),
    allBillsIncluded: allBillsIncluded,
    rent: {
      amount: price * 100,
      currencyCode: currencyCode
    },
    oldRent: null,
    neighbourhood: '',
    numberOfRooms: numberOfRooms,
    rentBy: rentBy,
    reviewsRating: 0,
    isExclusive: isExclusive,
    isInstantBooking: isInstantBooking,
    isVerified: isVerified,
    isTrusted: isTrusted,
    isSoldOut: false,
    isNew: false,
    photos: photos,
    building: null
  };
};
var isNew = function isNew(createdAt) {
  var now = Date.now();
  var oneMonthAgo = (0,subMonths/* default */.Z)(now, 1);
  return (0,isWithinInterval/* default */.Z)((0,parseISO/* default */.Z)(createdAt), {
    start: oneMonthAgo,
    end: now
  });
};
var transformPhotosUrl = function transformPhotosUrl(photos) {
  var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'small';
  return photos.reduce(function (acc, _ref3) {
    var placeholder = _ref3.placeholder,
      hash = _ref3.hash;
    if (placeholder) {
      return acc;
    }
    return [].concat(_toConsumableArray(acc), [{
      hash: hash,
      path: "".concat("https://cdn-static-new.uniplaces.com", "/property-photos/").concat(hash, "/").concat(size, ".jpg")
    }]);
  }, []);
};
;// CONCATENATED MODULE: ../shared/src/components/Search/Card/Mapview/index.js
var Mapview_jsx = react.createElement;


var Card = function Card(_ref) {
  var media = _ref.media,
    description = _ref.description,
    isMobile = _ref.isMobile,
    isMap = _ref.isMap;
  return Mapview_jsx(Mapview_styles_Wrapper, {
    isMobile: isMobile,
    isMap: isMap
  }, Mapview_jsx(MediaWrapper, {
    isMobile: isMobile
  }, media), Mapview_jsx(InfoWrapper, {
    isMobile: isMobile
  }, description));
};
/* harmony default export */ var Mapview = (Card);
;// CONCATENATED MODULE: ../shared/src/components/Search/Card/Listview/styles.js

var Listview_styles_WrapperLink = /*#__PURE__*/(/* unused pure expression or super */ null && (styled.a.withConfig({
  componentId: "sc-swn7q2-0"
})(["& > *{text-decoration:none;}"])));
var Listview_styles_Wrapper = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-swn7q2-1"
})(["display:flex;flex-direction:column;width:100%;position:relative;"]);
var styles_MediaWrapper = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-swn7q2-2"
})(["width:100%;position:relative;img{border-radius:12px;}"]);
var styles_Typology = /*#__PURE__*/(/* unused pure expression or super */ null && (styled.span.withConfig({
  componentId: "sc-swn7q2-3"
})(["font-family:IntervalNextReg,sans-serif;font-weight:100;line-height:normal;font-size:", ";line-height:", ";font-weight:400;margin-top:", ";padding-right:", ";padding-left:", ";color:", ";"], function (props) {
  return props.theme.rem(12);
}, function (props) {
  return props.theme.rem(15);
}, function (props) {
  return props.theme.space(4);
}, function (props) {
  return props.theme.space(3);
}, function (props) {
  return props.theme.space(3);
}, function (props) {
  return props.theme.card.thirdColor;
})));
var Listview_styles_Title = /*#__PURE__*/(/* unused pure expression or super */ null && (styled.h2.withConfig({
  componentId: "sc-swn7q2-4"
})(["font-family:IntervalNextReg,sans-serif;font-weight:100;line-height:normal;font-size:", ";line-height:", ";font-weight:600;color:", ";margin-bottom:", ";padding-right:", ";padding-left:", ";"], function (props) {
  return props.theme.rem(18);
}, function (props) {
  return props.theme.rem(20);
}, function (props) {
  return props.theme.card.primaryTextColor;
}, function (props) {
  return props.theme.space(2);
}, function (props) {
  return props.theme.space(3);
}, function (props) {
  return props.theme.space(3);
})));
var styles_Date = /*#__PURE__*/(/* unused pure expression or super */ null && (styled.p.withConfig({
  componentId: "sc-swn7q2-5"
})(["font-family:IntervalNextReg,sans-serif;font-weight:100;line-height:normal;font-size:", ";line-height:", ";font-weight:400;color:", ";margin-bottom:", ";padding-right:", ";padding-left:", ";"], function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.rem(19);
}, function (props) {
  return props.theme.card.neighbourhoodIconColor;
}, function (props) {
  return props.theme.space(2);
}, function (props) {
  return props.theme.space(3);
}, function (props) {
  return props.theme.space(3);
})));
var styles_Price = /*#__PURE__*/(/* unused pure expression or super */ null && (styled.p.withConfig({
  componentId: "sc-swn7q2-6"
})(["font-family:IntervalNextReg,sans-serif;font-weight:100;line-height:normal;font-size:", ";line-height:", ";font-weight:400;color:", ";padding-right:", ";padding-left:", ";span{font-family:IntervalNextReg,sans-serif;font-size:", ";font-weight:600;color:", ";}"], function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.rem(17);
}, function (props) {
  return props.theme.card.thirdColor;
}, function (props) {
  return props.theme.space(3);
}, function (props) {
  return props.theme.space(3);
}, function (props) {
  return props.theme.rem(22);
}, function (props) {
  return props.theme.card.primaryTextColor;
})));
var DescriptionWrapper = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-swn7q2-7"
})(["padding-right:", ";padding-left:", ";"], function (props) {
  return props.theme.space(1);
}, function (props) {
  return props.theme.space(1);
});
;// CONCATENATED MODULE: ../shared/src/components/Search/Card/Listview/index.js
var Listview_jsx = react.createElement;


var Listview_Card = function Card(_ref) {
  var media = _ref.media,
    description = _ref.description;
  return Listview_jsx(Listview_styles_Wrapper, null, Listview_jsx(styles_MediaWrapper, null, media), Listview_jsx(DescriptionWrapper, null, description));
};
/* harmony default export */ var Listview = (Listview_Card);
// EXTERNAL MODULE: ../shared/src/svg/close.js
var svg_close = __webpack_require__(5292);
;// CONCATENATED MODULE: ../shared/src/components/Search/Card/Controls/CloseCards/index.js
var CloseCards_jsx = react.createElement;



var CloseCard = function CloseCard(_ref) {
  var onClick = _ref.onClick;
  return CloseCards_jsx(CloseCards_styles_Wrapper, {
    className: "popup-close",
    onClick: onClick
  }, CloseCards_jsx(svg_close/* CloseIcon */.T, null));
};
/* harmony default export */ var CloseCards = (CloseCard);
;// CONCATENATED MODULE: ../shared/src/components/Search/Card/Labels/index.js
var Labels_jsx = react.createElement;


var Label = function Label(_ref) {
  var children = _ref.children,
    isFeatured = _ref.isFeatured,
    isUniresidences = _ref.isUniresidences;
  return Labels_jsx(Labels_styles_Wrapper, {
    isFeatured: isFeatured,
    isUniresidences: isUniresidences
  }, children);
};
/* harmony default export */ var Labels = (Label);
;// CONCATENATED MODULE: ../shared/src/svg/star-full.js

var star_full_jsx = react.createElement;

var StarFull = function StarFull(props) {
  return star_full_jsx("svg", (0,esm_extends/* default */.Z)({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 53.867 53.867",
    style: {
      enableBackground: 'new 0 0 53.867 53.867'
    },
    xmlSpace: "preserve"
  }, props), star_full_jsx("path", {
    style: {
      fill: '#ffffff'
    },
    d: "m26.934 1.318 8.322 16.864 18.611 2.705L40.4 34.013l3.179 18.536-16.645-8.751-16.646 8.751 3.179-18.536L0 20.887l18.611-2.705z"
  }));
};
/* harmony default export */ var star_full = (StarFull);
// EXTERNAL MODULE: ../../node_modules/react-spring/web.js
var web = __webpack_require__(2212);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
;// CONCATENATED MODULE: ../shared/src/components/Search/Card/Controls/ScrollIndicator/styles.js

var OverflowContainer = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1q4175o-0"
})(["max-width:60px;overflow-x:hidden;"]);
var Container = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1q4175o-1"
})(["display:flex;transform:translateX(", ");transition:transform ", "s ease-out;"], function (props) {
  return "".concat(props.translateValue, "px");
}, function (props) {
  return props.transitionValue;
});
var Dot = /*#__PURE__*/styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  componentId: "sc-1q4175o-2"
})(["width:6px;height:6px;margin:0 3px;border-radius:50%;background-color:rgba(255,255,255,0.4);flex-shrink:0;&.shrunken{margin:0.5px 3.5px;height:5px;width:5px;}&.active{background-color:white;}"]);
// EXTERNAL MODULE: ../shared/src/svg/arrowCarousel.js
var arrowCarousel = __webpack_require__(93553);
// EXTERNAL MODULE: ../shared/src/utils/order/index.js
var order = __webpack_require__(94421);
;// CONCATENATED MODULE: ../shared/src/components/Carousel/styles.js

var Carousel_styles_templateObject, Carousel_styles_templateObject2, Carousel_styles_templateObject3;


var styles_CarouselContainer = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1nlnttl-0"
})(["position:absolute;top:0;left:0;z-index:3;overflow:hidden;width:100%;&:active{outline:none;border:none;}&:focus{outline:0;}", ";"], theme/* mediaMin.smallBreakpoint */.A3.smallBreakpoint(Carousel_styles_templateObject || (Carousel_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n    width: 100%;\n    position: fixed;\n    bottom: ", ";\n  "])), function (props) {
  return props.theme.space(17);
}));
var styles_InnerCarouselContainer = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1nlnttl-1"
})(["position:absolute;top:0;left:0;z-index:1;overflow:hidden;width:100%;height:100%;", ";"], theme/* mediaMin.smallBreakpoint */.A3.smallBreakpoint(Carousel_styles_templateObject2 || (Carousel_styles_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    height: 310px;\n  "]))));
var Carousel_styles_CarouselWrapper = /*#__PURE__*/(/* unused pure expression or super */ null && (styled.div.withConfig({
  componentId: "sc-1nlnttl-2"
})(["position:absolute;top:0;left:0;display:flex;flex-wrap:nowrap;"])));
var styles_CarouselItem = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1nlnttl-3"
})(["position:relative;background:", ";height:", ";width:", ";display:flex;flex-wrap:wrap;align-items:flex-start;margin:0 10px;border-radius:4px;> a{width:100%;h3{width:442px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}}", ";"], function (props) {
  return props.theme.carousel.background;
}, function (props) {
  return props.theme.space(100);
}, function (props) {
  return props.width + 'px' || 0;
}, theme/* mediaMin.smallBreakpoint */.A3.smallBreakpoint(Carousel_styles_templateObject3 || (Carousel_styles_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n    height: ", ";\n\n    > a {\n      height: 100%;\n      margin-bottom: 0;\n\n      > div:first-child {\n        min-height: 150px;\n      }\n\n      .offer__badges {\n        span {\n          max-width: calc(100% / 3);\n          white-space: nowrap;\n          overflow: hidden;\n          text-overflow: ellipsis;\n        }\n      }\n    }\n  "])), function (props) {
  return props.theme.space(71);
}));
var Navigator = /*#__PURE__*/(/* unused pure expression or super */ null && (styled.div.withConfig({
  componentId: "sc-1nlnttl-4"
})(["position:absolute;z-index:2;top:calc(150px - 19px);width:38px;height:38px;display:flex;background-color:", ";border-radius:19px;box-shadow:0 2px 4px 0 rgba(0,0,0,0.1);cursor:pointer;svg{opacity:0.6;margin:auto;}"], function (props) {
  return props.theme.carousel.background;
})));
var styles_LeftNavigator = /*#__PURE__*/(/* unused pure expression or super */ null && (styled(Navigator).withConfig({
  componentId: "sc-1nlnttl-5"
})(["left:", ";svg{transform:rotate(180deg);}"], function (props) {
  return "".concat(props.navigatorPos, "px") || 0;
})));
var styles_RightNavigator = /*#__PURE__*/(/* unused pure expression or super */ null && (styled(Navigator).withConfig({
  componentId: "sc-1nlnttl-6"
})(["right:", ";"], function (props) {
  return "".concat(props.navigatorPos, "px") || 0;
})));
;// CONCATENATED MODULE: ../shared/src/components/Carousel/index.js

var Carousel_jsx = react.createElement;




var getDisplayedIndexes = function getDisplayedIndexes(itemsCount, active) {
  var displayedItemsCount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5;
  if (itemsCount <= 1) {
    return Array.from(new Array(itemsCount), function (_, index) {
      return "".concat(index);
    });
  }
  var halfOfTheItems = Math.floor(displayedItemsCount / 2);
  if (itemsCount < 5) {
    return Array.from(new Array(displayedItemsCount), function (_, index) {
      return "".concat(Array.from(new Array(index), function () {
        return '0';
      }).join('')).concat((0,order/* order */.v)(itemsCount, active, index - halfOfTheItems));
    });
  }
  return Array.from(new Array(displayedItemsCount), function (_, index) {
    return (0,order/* order */.v)(itemsCount, active, index - halfOfTheItems);
  });
};
var Carousel_Carousel = function Carousel(_ref) {
  var carouselRef = _ref.carouselRef,
    handleBack = _ref.handleBack,
    handleNext = _ref.handleNext,
    style = _ref.style,
    handlers = _ref.handlers,
    _ref$showNavigators = _ref.showNavigators,
    showNavigators = _ref$showNavigators === void 0 ? false : _ref$showNavigators,
    children = _ref.children;
  return Carousel_jsx(CarouselContainer, {
    ref: carouselRef,
    style: style.container,
    tabIndex: "0"
  }, Carousel_jsx(InnerCarouselContainer, null, Carousel_jsx(CarouselWrapper, _extends({
    style: style.carousel
  }, handlers, {
    tabIndex: "-1"
  }), children)), showNavigators ? Carousel_jsx(Fragment, null, Carousel_jsx(LeftNavigator, {
    navigatorPos: style.navigatorPos,
    onClick: handleBack
  }, Carousel_jsx(ArrowCarouselIcon, null)), Carousel_jsx(RightNavigator, {
    navigatorPos: style.navigatorPos,
    onClick: handleNext
  }, Carousel_jsx(ArrowCarouselIcon, null))) : null);
};
var Carousel_Item = function Item(_ref2) {
  var style = _ref2.style,
    width = _ref2.width,
    children = _ref2.children;
  return Carousel_jsx(CarouselItem, {
    width: width,
    style: style
  }, children);
};
/* harmony default export */ var components_Carousel = ((/* unused pure expression or super */ null && (Carousel_Carousel)));
;// CONCATENATED MODULE: ../shared/src/components/Search/Card/Controls/ScrollIndicator/index.js

var ScrollIndicator_jsx = react.createElement;



var DIRECTION_LEFT = -1;
var DIRECTION_RIGHT = 1;
var VISIBLE_DOTS_NUMBER = 5;
var TRANSITION_VALUE = 0.2;
var dotsConfig = {
  size: 6,
  margin: 3,
  number: VISIBLE_DOTS_NUMBER
};
var DOT_SIZE = dotsConfig.size + dotsConfig.margin * 2;
var calculateTranslateValue = function calculateTranslateValue() {
  var step = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  return -1 * (DOT_SIZE * step);
};
var ScrollIndicator = function ScrollIndicator(_ref) {
  var count = _ref.count,
    activeIndex = _ref.activeIndex;
  var _useState = (0,react.useState)(0),
    translateValue = _useState[0],
    setTranslateValue = _useState[1];
  var _useState2 = (0,react.useState)(0.2),
    transitionValue = _useState2[0],
    setTransitionValue = _useState2[1];
  var _useState3 = (0,react.useState)(0),
    internalActiveIndex = _useState3[0],
    setInternalActiveIndex = _useState3[1];
  var visibleNumber = count > 5 ? VISIBLE_DOTS_NUMBER : count;
  var dots = (0,toConsumableArray/* default */.Z)(new Array(visibleNumber)).map(function (_, index) {
    return index;
  });
  var _useState4 = (0,react.useState)(dots.slice(0, visibleNumber)),
    visibleDots = _useState4[0],
    setVisibleDots = _useState4[1];
  var isDotShrunken = function isDotShrunken(index) {
    var dots = visibleDots.length === 7 ? visibleDots.slice(1, 6) : visibleDots;
    var isFirstOrLastOfAllDots = index === 0 || index === count - 1;
    var isFirstOrLastOfVisibleDots = [dots[0], dots[dots.length - 1]].includes(index);
    return !dots.includes(index) || isFirstOrLastOfVisibleDots && !isFirstOrLastOfAllDots;
  };
  (0,react.useEffect)(function () {
    var shouldRefreshVisibleDots = activeIndex < count - 2 && activeIndex > 2;
    setTransitionValue(0);
    if (shouldRefreshVisibleDots) {
      setVisibleDots(getDisplayedIndexes(count, activeIndex, 7));
      setTranslateValue(calculateTranslateValue());
      return;
    }
    setVisibleDots(activeIndex >= count - 2 ? (0,toConsumableArray/* default */.Z)(new Array(visibleNumber)).map(function (_, index) {
      return count - 1 - index;
    }).reverse() : (0,toConsumableArray/* default */.Z)(new Array(visibleNumber)).map(function (_, index) {
      return index;
    }));
    setTranslateValue(0);
  }, [internalActiveIndex]);
  (0,react.useEffect)(function () {
    if (count < 6) {
      return;
    }
    var step = activeIndex - internalActiveIndex > 0 ? 1 : 0;
    var shouldRefreshVisibleDots = activeIndex < count - 2 && activeIndex > 2;
    var direction = activeIndex - internalActiveIndex > 0 ? DIRECTION_RIGHT : DIRECTION_LEFT;
    if (!shouldRefreshVisibleDots && !(activeIndex === 2 && direction === DIRECTION_LEFT)) {
      setInternalActiveIndex(activeIndex);
      return;
    }
    setTransitionValue(TRANSITION_VALUE);
    var multiplier = (activeIndex === 3 ? 1 : 2) * direction;
    setTranslateValue(calculateTranslateValue(step) * multiplier);
    var timeout = setTimeout(function () {
      return setInternalActiveIndex(activeIndex);
    }, 250);
    return function () {
      return clearTimeout(timeout);
    };
  }, [activeIndex]);
  return ScrollIndicator_jsx(OverflowContainer, null, ScrollIndicator_jsx(Container, {
    translateValue: translateValue,
    transitionValue: transitionValue
  }, visibleDots.map(function (value) {
    var classNames = [].concat((0,toConsumableArray/* default */.Z)(isDotShrunken(value) ? ['shrunken'] : []), (0,toConsumableArray/* default */.Z)(value === activeIndex ? ['active'] : [])).join(' ');
    return ScrollIndicator_jsx(Dot, {
      className: classNames,
      key: value,
      config: dotsConfig
    });
  })));
};
/* harmony default export */ var Controls_ScrollIndicator = (ScrollIndicator);
;// CONCATENATED MODULE: ../shared/src/components/Search/Card/Controls/NavigationArrows/styles.js

var NavigationArrows_styles_Wrapper = /*#__PURE__*/styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  componentId: "sc-1nl3ekt-0"
})(["display:flex;align-items:center;justify-content:center;width:30px;height:30px;background-color:", ";box-shadow:0px 1px 2px rgba(0,0,0,0.2);border-radius:50%;border:none;overflow:visible;-webkit-appearance:none;cursor:pointer;svg{width:6px;fill:", ";}"], function (props) {
  return props.theme.backgrounds.neutral;
}, function (props) {
  return props.theme.colors.blueDianne;
});
;// CONCATENATED MODULE: ../shared/src/components/Search/Card/Controls/NavigationArrows/index.js
var NavigationArrows_jsx = react.createElement;


var NavigationArrow = function NavigationArrow(_ref) {
  var children = _ref.children,
    arialabel = _ref.arialabel,
    onClick = _ref.onClick;
  return NavigationArrows_jsx(NavigationArrows_styles_Wrapper, {
    "aria-label": arialabel,
    onClick: onClick
  }, children);
};
/* harmony default export */ var NavigationArrows = (NavigationArrow);
// EXTERNAL MODULE: ../shared/src/hooks/swipe/index.js + 1 modules
var swipe = __webpack_require__(53320);
;// CONCATENATED MODULE: ../shared/src/svg/studentsresidences-logo.js

var studentsresidences_logo_jsx = react.createElement;

var StudentResidencesLogo = function StudentResidencesLogo(props) {
  return studentsresidences_logo_jsx("svg", (0,esm_extends/* default */.Z)({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 801.05 56.98"
  }, props), studentsresidences_logo_jsx("path", {
    d: "M41.74 1.23 2.56.02C1.02.02-.19 1.23.03 2.88l6.6 48.53c.22 1.65 1.43 2.09 2.75 1.21l5.28-3.74c1.32-.88 3.19-1.65 5.28-1.54s18.16 1.21 18.16 1.21c1.65.11 2.97-1.1 3.19-2.75l3.08-41.49c.22-1.65-.99-2.97-2.64-3.08Zm-.77 4.62-2.42 38.41c0 .66-.55 1.1-1.21.88L24.9 42.5c-1.76-.33-2.97-1.32-3.19-3.08L18.52 10.7c-.11-.66.44-1.32.99-1.43l20.25-4.29c.77-.11 1.21.22 1.21.88Zm50.11 23.7c-.66 5.44-2.3 9.43-5.02 11.96-2.66 2.48-6.89 3.75-12.63 3.75-11.12 0-15.05-4.83-13.66-15.71l2.9-23.5c.12-1.21.79-1.81 1.99-1.81h7.19c1.15 0 1.63.6 1.51 1.81l-2.84 23.2c-.6 4.65-.48 7.61 4.05 7.61 4.11 0 5.2-2.05 5.92-7.61l2.84-23.2c.12-1.21.79-1.81 1.99-1.81h7.13c1.15 0 1.63.6 1.51 1.81l-2.9 23.5Zm7.13-11.54c.12-1.27.79-2.11 1.99-2.54 4.83-1.87 9.61-2.84 14.32-2.84 3.44 0 5.92.54 8.16 2.05 2.36 1.45 3.26 4.53 2.72 9.06l-2.36 19.03c-.12 1.21-.79 1.81-1.93 1.81h-6.53c-1.21 0-1.75-.6-1.63-1.81l2.24-18.31c.36-2.96-.6-4.41-2.84-4.41-1.57 0-3.08.3-4.47.91l-2.72 21.81c-.12 1.21-.79 1.81-1.93 1.81H96.7c-1.15 0-1.69-.6-1.57-1.81L98.21 18Zm40.36 24.77c-.12 1.21-.79 1.81-1.93 1.81h-6.77c-1.15 0-1.69-.6-1.57-1.81l3.44-27.74c.12-1.21.79-1.81 1.93-1.81h6.77c1.15 0 1.69.6 1.57 1.81l-3.44 27.74Zm-5.26-40.97C133.49.6 134.16 0 135.3 0h6.77c1.15 0 1.69.6 1.51 1.81l-.79 6.41c-.12 1.21-.79 1.81-1.93 1.81h-6.77c-1.15 0-1.69-.6-1.57-1.81l.79-6.41Zm13.84 15.23c.18-1.21.91-1.99 2.17-2.42 4.17-1.27 8.34-1.87 12.39-1.87 9.91 0 14.2 5.26 12.93 15.77-1.09 8.94-5.5 16.8-16.86 16.8-1.27 0-2.6-.12-3.93-.36l-1.27 10.21c-.18 1.21-.85 1.81-1.99 1.81H144c-1.15 0-1.69-.6-1.51-1.81l4.65-38.13Zm7.67 20c.97.24 1.87.36 2.66.36 3.87 0 6.28-3.32 6.95-8.94.66-5.32-.79-7.98-4.41-7.98-1.15 0-2.24.12-3.2.36l-1.99 16.19Zm39.64 4.59c-.06 1.27-.73 2.18-1.93 2.66-1.87.67-3.99 1.03-6.22 1.03-6.59 0-8.58-3.69-7.79-10.51l3.81-30.7c.12-1.21.79-1.81 1.93-1.81h6.77c1.15 0 1.69.6 1.57 1.81l-3.75 30.15c-.3 2.17.6 3.26 2.72 3.26l1.09-.12c1.27-.24 1.75.06 1.75 1.33l.06 2.9Zm31-26.77c1.09.42 1.57 1.27 1.45 2.54l-2.3 18.55c-.36 2.84-.42 5.26-.12 7.13.12 1.21-.36 1.81-1.51 1.81h-5.38c-1.15 0-1.93-.54-2.24-1.69l-.24-.85c-1.81 1.93-4.23 2.9-7.19 2.9s-5.32-.79-7.07-2.3c-3.38-3.08-3.99-7.49-3.26-13.47.54-4.35 2.05-8.1 4.77-11.3 2.84-3.32 7.55-5.26 13.41-5.26 3.14 0 6.34.66 9.67 1.93Zm-9.06 6.04c-.67-.24-1.39-.36-2.05-.36-3.56 0-5.74 3.14-6.53 9.49-.54 4.35.54 7.67 3.63 7.67 1.21 0 2.18-.24 2.96-.79l1.99-16.01Zm16.79 20.49c-2.54-2.72-3.44-6.77-2.78-12.15s2.54-9.43 5.68-12.21c3.2-2.78 6.95-4.17 11.24-4.17 3.08 0 5.8.54 8.04 1.69 1.03.54 1.33 1.45.91 2.6l-1.27 3.75c-.36 1.09-1.09 1.45-2.12 1.09-1.63-.67-3.26-.97-4.77-.97-4.47 0-7.01 2.78-7.67 8.28-.73 5.74 1.03 8.58 5.32 8.58 2.3 0 4.41-.24 6.28-.72 1.21-.42 1.63 0 1.57 1.27L253.5 42c-.18 1.21-.79 1.93-1.87 2.24-3.08.79-5.68 1.15-7.86 1.15-4.47 0-7.98-1.33-10.57-3.99Zm53.54-18.91c-.42 3.5-1.99 6.22-4.71 8.22s-5.74 2.96-9.18 2.96c-2.11 0-3.93-.36-5.44-1.15.06 3.63 3.44 5.14 7.98 5.14 2.11 0 4.23-.3 6.34-.91 1.09-.3 1.63.12 1.69 1.27l.06 3.5c0 1.27-.6 2.05-1.75 2.36-3.5.85-6.89 1.27-10.15 1.27-5.08 0-8.7-1.39-10.88-4.23s-3.02-6.53-2.48-10.94c.6-4.77 2.42-8.76 5.44-11.96 3.02-3.2 7.25-4.83 12.69-4.83 7.01 0 11.12 3.26 10.39 9.31Zm-11.06-2.42c-4.17 0-7.19 3.02-8.1 7.31.66.24 1.57.36 2.66.36 4.05 0 7.67-1.81 8.1-5.2.24-1.51-.97-2.48-2.66-2.48Zm36.43 1.27c-.42 1.03-1.15 1.33-2.17.85-2.24-1.03-4.35-1.57-6.34-1.57s-2.96.67-3.14 1.99c-.06.54.18 1.09.6 1.57.97.97 1.57 1.21 3.69 1.99 2.12.91 2.66 1.03 4.35 2.18 2.42 1.39 3.2 3.2 3.14 6.59-.79 6.95-5.56 10.45-14.2 10.45-3.2 0-6.22-.54-9-1.69-1.09-.48-1.39-1.33-.97-2.6l1.21-3.75c.36-1.03 1.09-1.39 2.12-1.09 3.02 1.03 5.56 1.51 7.67 1.51 1.99 0 3.02-.66 3.2-1.99.06-.48-.06-.97-.48-1.39-.72-.91-1.39-1.15-3.14-2.05l-3.14-1.57c-.67-.42-1.51-.97-2.48-1.75-1.93-1.63-2.6-3.5-2.3-6.1.42-3.32 1.87-5.8 4.35-7.49 2.48-1.69 5.44-2.54 8.82-2.54s6.16.72 8.52 2.12c1.03.66 1.33 1.57.91 2.84l-1.21 3.5Zm15.11 18.85c.3-.54.67-.72 1.21-.54 3.14 1.39 6.16 2.05 9.12 2.05 5.5 0 9.61-2.17 10.27-7.43.3-2.48-.24-4.23-2.12-5.62s-2.96-1.87-6.04-3.02c-3.56-1.39-6.16-2.84-7.79-4.41-1.63-1.63-2.24-3.87-1.87-6.77.48-3.93 2.05-6.71 4.65-8.34 2.6-1.69 5.86-2.54 9.67-2.54 3.02 0 5.68.48 7.92 1.45.54.3.73.73.54 1.33l-.42 1.51c-.18.54-.54.73-1.15.48-2.12-.97-4.53-1.45-7.31-1.45-5.86 0-9.06 2.24-9.61 6.77-.3 2.36.36 4.17 2.11 5.44 1.75 1.27 3.2 1.93 5.92 2.96 7.25 2.66 10.51 5.74 9.85 11.6-.54 3.99-2.24 6.95-5.14 8.88-2.9 1.87-6.34 2.84-10.33 2.84-3.44 0-6.71-.67-9.73-1.99-.54-.24-.67-.67-.36-1.27l.6-1.93Zm44.47 3.14c.06.6-.18.97-.67 1.15-1.81.48-3.69.72-5.62.72-2.96 0-4.83-.6-5.68-1.75-.85-1.21-1.09-3.32-.72-6.34l2.42-19.7h-3.2c-.66 0-.91-.3-.79-.91l.12-1.33c.12-.6.48-.91 1.03-.91h3.2l.85-6.77c.06-.67.42-.97 1.03-1.03l2.05-.3c.54-.06.79.12.72.79l-.91 7.31h9c.54 0 .72.3.54.91l-.36 1.33c-.18.6-.6.91-1.15.91h-8.46l-2.54 20.3c-.12 2.36-.54 4.35 3.5 4.35 1.33 0 2.84-.18 4.47-.54.66-.18 1.03.06 1.03.66l.12 1.15Zm29.25-3.86c-.12 2.12-.12 3.62-.06 4.53 0 .6-.3.91-.85.91h-1.57c-.66 0-.97-.3-.97-.91l-.24-1.21c-2.78 1.75-5.68 2.6-8.7 2.6-7.43 0-10.76-3.57-9.85-10.63l2.36-19.58c.12-.6.42-.91.97-.91h1.93c.67 0 .91.3.79.91l-2.36 19.21c-.73 5.8 1.93 7.79 7.55 7.79 2.42 0 4.83-.72 7.25-2.17l3.02-24.83c.12-.6.42-.91.97-.91h1.93c.66 0 .91.3.79.91l-2.96 24.29Zm23.68-25.62c1.87 0 4.29.36 7.19 1.03l1.51-12.39c.06-.6.36-.91.97-.91h1.93c.6 0 .85.3.79.91l-4.96 40.36c-.06.6-.36.97-.91 1.09-4.29.97-7.79 1.45-10.39 1.45-7.25 0-13.11-3.08-11.6-14.68 1.21-10.33 6.04-16.86 15.47-16.86Zm6.77 4.65c-2.42-.91-4.83-1.33-7.31-1.33-6.53 0-9.73 4.71-10.76 13.47-1.03 8.4 2.42 11.54 8.94 11.54 1.75 0 3.87-.36 6.34-1.09l2.78-22.6Zm29.3 21.81c.67-.24.97-.06.97.48l.06 1.39c.06.6-.24 1.03-.91 1.33-3.14 1.27-6.22 1.87-9.18 1.87-8.4 0-11.84-6.1-10.7-15.29.6-4.77 2.36-8.58 5.32-11.54s6.77-4.47 11.3-4.47c5.62 0 8.46 3.57 7.92 8.1-1.27 10.45-14.5 12.02-20.67 9.91-.18 2.78.24 5.08 1.33 6.95 1.15 1.87 3.2 2.78 6.28 2.78s5.92-.48 8.28-1.51Zm-4.05-23.08c-7.07 0-10.51 6.53-11.42 11.78 2.24.97 5.86 1.03 9.25.3 3.38-.79 6.34-3.2 6.83-6.59.42-3.2-1.33-5.5-4.65-5.5Zm16.68.3c.06-.66.42-1.09 1.03-1.39 4.89-1.75 9.06-2.66 12.63-2.66 6.34 0 9.61 2.48 8.64 9.97l-2.48 20.24c-.06.6-.42.91-.97.91h-1.87c-.6 0-.85-.3-.79-.91l2.42-19.28c.66-5.86-1.45-7.49-6.47-7.49-3.44 0-6.34.66-8.64 2.05l-3.08 24.71c-.06.6-.36.91-.97.91h-1.93c-.6 0-.85-.3-.79-.91l3.26-26.16Zm42.84 25.8c.06.6-.18.97-.66 1.15-1.81.48-3.69.72-5.62.72-2.96 0-4.83-.6-5.68-1.75-.85-1.21-1.09-3.32-.72-6.34l2.42-19.7h-3.2c-.66 0-.91-.3-.79-.91l.12-1.33c.12-.6.48-.91 1.03-.91h3.2l.85-6.77c.06-.67.42-.97 1.03-1.03l2.05-.3c.54-.06.79.12.72.79l-.91 7.31h9c.54 0 .72.3.54.91l-.36 1.33c-.18.6-.6.91-1.15.91h-8.46l-2.54 20.3c-.12 2.36-.54 4.35 3.5 4.35 1.33 0 2.84-.18 4.47-.54.67-.18 1.03.06 1.03.66l.12 1.15Zm32.39-14.62h-1.27c-1.87 0-3.87-.18-5.86-.48l-1.93 15.47c-.06.6-.36.91-.91.91h-2.24c-.6 0-.91-.3-.85-.91l4.65-37.83c.12-.54.48-.91 1.03-1.03 3.02-.42 5.98-.67 8.82-.67 4.41 0 7.43.42 10.39 2.05 2.96 1.51 4.41 4.89 3.75 9.79-.85 6.65-4.59 10.7-11.3 12.15L562 43.86c.3.48.18.72-.42.72h-3.14c-.6 0-1.09-.24-1.39-.72l-8.52-15.17Zm-6.71-3.87c2.05.42 4.05.67 5.92.67 5.5 0 11.42-1.87 12.27-9.18.48-3.69-.48-6.22-2.72-7.37-2.17-1.21-4.35-1.51-7.73-1.51-1.51 0-3.44.12-5.68.42l-2.05 16.98Zm46.1 15.47c.67-.24.97-.06.97.48l.06 1.39c.06.6-.24 1.03-.91 1.33-3.14 1.27-6.22 1.87-9.18 1.87-8.4 0-11.84-6.1-10.7-15.29.6-4.77 2.36-8.58 5.32-11.54s6.77-4.47 11.3-4.47c5.62 0 8.46 3.57 7.92 8.1-1.27 10.45-14.5 12.02-20.67 9.91-.18 2.78.24 5.08 1.33 6.95 1.15 1.87 3.2 2.78 6.28 2.78s5.92-.48 8.28-1.51Zm-4.05-23.08c-7.07 0-10.51 6.53-11.42 11.78 2.24.97 5.86 1.03 9.25.3 3.38-.79 6.34-3.2 6.83-6.59.42-3.2-1.33-5.5-4.65-5.5Zm12.63 23.57c.24-.54.67-.72 1.21-.42 2.36 1.09 4.53 1.63 6.53 1.63 4.59 0 7.07-1.69 7.49-5.08 1.03-7.92-14.44-4.65-13.17-14.68.67-5.56 4.89-8.7 11.48-8.7 2.24 0 4.35.42 6.22 1.33.42.24.6.66.42 1.33l-.54 1.45c-.18.6-.48.79-1.03.54-1.69-.85-3.5-1.27-5.38-1.27-4.35 0-6.71 1.63-7.13 4.89-.85 7.19 14.38 4.83 13.29 14.38-.72 5.62-4.95 9.25-12.27 9.25-3.08 0-5.56-.54-7.49-1.63-.42-.3-.54-.73-.3-1.33l.66-1.69Zm28.04 2.9c-.06.6-.36.91-.91.91h-1.93c-.6 0-.91-.3-.85-.91l3.5-28.52c.12-.6.48-.91 1.03-.91h1.93c.6 0 .85.3.73.91l-3.5 28.52Zm1.27-40c.06-.6.36-.91.97-.91h1.93c.6 0 .85.3.79.91l-.48 3.62c-.06.6-.42.91-.97.91h-1.93c-.54 0-.85-.3-.79-.91l.48-3.62Zm22.35 10.15c1.87 0 4.29.36 7.19 1.03l1.51-12.39c.06-.6.36-.91.97-.91h1.93c.6 0 .85.3.79.91l-4.96 40.36c-.06.6-.36.97-.91 1.09-4.29.97-7.79 1.45-10.39 1.45-7.25 0-13.11-3.08-11.6-14.68 1.21-10.33 6.04-16.86 15.47-16.86Zm6.77 4.65c-2.42-.91-4.83-1.33-7.31-1.33-6.53 0-9.73 4.71-10.76 13.47-1.03 8.4 2.42 11.54 8.94 11.54 1.75 0 3.87-.36 6.34-1.09l2.78-22.6Zm29.31 21.81c.67-.24.97-.06.97.48l.06 1.39c.06.6-.24 1.03-.91 1.33-3.14 1.27-6.22 1.87-9.18 1.87-8.4 0-11.84-6.1-10.7-15.29.6-4.77 2.36-8.58 5.32-11.54s6.77-4.47 11.3-4.47c5.62 0 8.46 3.57 7.92 8.1-1.27 10.45-14.5 12.02-20.67 9.91-.18 2.78.24 5.08 1.33 6.95 1.15 1.87 3.2 2.78 6.28 2.78s5.92-.48 8.28-1.51Zm-4.05-23.08c-7.07 0-10.51 6.53-11.42 11.78 2.24.97 5.86 1.03 9.25.3 3.38-.79 6.34-3.2 6.83-6.59.42-3.2-1.33-5.5-4.65-5.5Zm16.67.3c.06-.66.42-1.09 1.03-1.39 4.89-1.75 9.06-2.66 12.63-2.66 6.34 0 9.61 2.48 8.64 9.97l-2.48 20.24c-.06.6-.42.91-.97.91h-1.87c-.6 0-.85-.3-.79-.91l2.42-19.28c.67-5.86-1.45-7.49-6.46-7.49-3.44 0-6.34.66-8.64 2.05l-3.08 24.71c-.06.6-.36.91-.97.91h-1.93c-.6 0-.85-.3-.79-.91l3.26-26.16Zm51.06-.06c-.3.6-.67.79-1.15.54-1.63-.72-3.56-1.09-5.92-1.09-2.72 0-5.2 1.03-7.31 3.02-2.12 1.99-3.44 5.2-3.99 9.55-1.03 8.76 2.72 12.63 8.7 12.63 2.17 0 4.23-.3 6.22-.91.67-.18.97 0 1.03.6l.06 1.21c0 .6-.3 1.03-.85 1.21-2.6.79-4.95 1.21-7.07 1.21-4.11 0-7.31-1.33-9.67-3.93-2.3-2.66-3.14-6.65-2.48-12.02.67-5.26 2.42-9.25 5.32-11.96 2.9-2.72 6.28-4.05 10.21-4.05 2.78 0 5.08.42 6.89 1.27.6.3.79.73.48 1.33l-.48 1.39Zm24.29 22.84c.66-.24.97-.06.97.48l.06 1.39c.06.6-.24 1.03-.91 1.33-3.14 1.27-6.22 1.87-9.18 1.87-8.4 0-11.84-6.1-10.7-15.29.6-4.77 2.36-8.58 5.32-11.54 2.96-2.96 6.77-4.47 11.3-4.47 5.62 0 8.46 3.57 7.92 8.1-1.27 10.45-14.5 12.02-20.67 9.91-.18 2.78.24 5.08 1.33 6.95 1.15 1.87 3.2 2.78 6.28 2.78s5.92-.48 8.28-1.51Zm-4.05-23.08c-7.07 0-10.51 6.53-11.42 11.78 2.24.97 5.86 1.03 9.24.3 3.38-.79 6.34-3.2 6.83-6.59.42-3.2-1.33-5.5-4.65-5.5Zm12.63 23.57c.24-.54.67-.72 1.21-.42 2.36 1.09 4.53 1.63 6.53 1.63 4.59 0 7.07-1.69 7.49-5.08 1.03-7.92-14.44-4.65-13.17-14.68.67-5.56 4.89-8.7 11.48-8.7 2.24 0 4.35.42 6.22 1.33.42.24.6.66.42 1.33l-.54 1.45c-.18.6-.48.79-1.03.54-1.69-.85-3.5-1.27-5.38-1.27-4.35 0-6.71 1.63-7.13 4.89-.85 7.19 14.38 4.83 13.29 14.38-.72 5.62-4.96 9.25-12.27 9.25-3.08 0-5.56-.54-7.49-1.63-.42-.3-.54-.73-.3-1.33l.66-1.69Z",
    style: {
      fill: '#fff'
    }
  }));
};
;// CONCATENATED MODULE: ../shared/src/components/Search/Card/Gallery/index.js



var Gallery_excluded = ["photos", "disableNavigationArrows", "disableFullNavigation", "title", "isFeatured", "isUniresidences", "isLazy"];
var Card_Gallery_jsx = react.createElement;













var Gallery_Gallery = function Gallery(_ref) {
  var photos = _ref.photos,
    _ref$disableNavigatio = _ref.disableNavigationArrows,
    disableNavigationArrows = _ref$disableNavigatio === void 0 ? false : _ref$disableNavigatio,
    _ref$disableFullNavig = _ref.disableFullNavigation,
    disableFullNavigation = _ref$disableFullNavig === void 0 ? false : _ref$disableFullNavig,
    title = _ref.title,
    isFeatured = _ref.isFeatured,
    isUniresidences = _ref.isUniresidences,
    isLazy = _ref.isLazy,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, Gallery_excluded);
  var _useSwipe = (0,swipe/* useSwipe */.Y)({
      slides: photos
    }),
    _useSwipe2 = (0,slicedToArray/* default */.Z)(_useSwipe, 6),
    _useSwipe2$ = _useSwipe2[0],
    active = _useSwipe2$.active,
    translate = _useSwipe2$.translate,
    goLeft = _useSwipe2[2],
    goRight = _useSwipe2[3],
    handlers = _useSwipe2[4],
    resetTranslate = _useSwipe2[5];
  var _useTranslation = (0,esm/* useTranslation */.$G)(),
    t = _useTranslation.t;
  var router = (0,next_router.useRouter)();
  var isInResidencesSearch = router.pathname.includes('/residences');
  var diff = translate === 100 ? 1 : -1;
  var transitions = (0,web.useTransition)(photos[active], {
    from: {
      transform: "translateX(".concat(-(translate ? 300 * diff : translate), "px)")
    },
    enter: {
      transform: 'translateX(0px)'
    },
    leave: {
      transform: "translateX(".concat(translate ? 300 * diff : translate, "px)")
    },
    onRest: resetTranslate,
    config: web.config.stiff,
    keys: function keys(item) {
      return item.path;
    }
  });
  if (!photos.length) {
    return null;
  }
  var loading = {
    loading: isLazy ? 'lazy' : 'eager'
  };
  var handleNavigationGestures = disableFullNavigation ? {} : handlers;
  return Card_Gallery_jsx(Card_Gallery_styles_Wrapper, props, Card_Gallery_jsx(Photos, handleNavigationGestures, !disableNavigationArrows && Card_Gallery_jsx(react.Fragment, null, Card_Gallery_jsx(NavigationArrows, {
    arialabel: "next",
    onClick: goRight
  }, Card_Gallery_jsx(arrow_right/* default */.Z, null)), Card_Gallery_jsx(NavigationArrows, {
    arialabel: "previous",
    onClick: goLeft
  }, Card_Gallery_jsx(arrow_left/* default */.Z, null))), transitions(function (style, item) {
    return Card_Gallery_jsx(web.animated.div, {
      loading: "lazy",
      key: item.path,
      style: style
    }, Card_Gallery_jsx("img", (0,esm_extends/* default */.Z)({
      src: item.path,
      alt: title,
      style: {
        objectFit: 'cover'
      }
    }, loading)));
  }), !disableFullNavigation && Card_Gallery_jsx(ScrollIndicatorContainer, null, Card_Gallery_jsx(Controls_ScrollIndicator, {
    activeIndex: active,
    count: photos.length
  })), isFeatured && Card_Gallery_jsx(Labels, {
    isFeatured: true,
    isUniresidences: false
  }, Card_Gallery_jsx(star_full, null), t('results.offer.featured')), isUniresidences && !isInResidencesSearch && Card_Gallery_jsx(Labels, {
    isFeatured: false,
    isUniresidences: true
  }, Card_Gallery_jsx(StudentResidencesLogo, null))));
};
/* harmony default export */ var Card_Gallery = (/*#__PURE__*/react.memo(Gallery_Gallery));
;// CONCATENATED MODULE: ../shared/src/components/PropertyCard/Info/FeaturesUnitsIcons/styles.js


var FeaturesUnitsIcons_styles_Wrapper = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-pdlzdz-0"
})(["display:flex;align-items:center;margin-top:", ";margin-bottom:", ";overflow:hidden;flex-wrap:wrap;height:20px;", "{", "{background:", ";color:", ";&:after,&:before{display:none;}}&:not(:last-of-type){margin-right:", ";}span{display:flex;flex-direction:column;align-items:center;font-family:IntervalNextReg,sans-serif;font-weight:400;line-height:17px;font-size:", ";}}svg{height:20px;}"], function (props) {
  return props.theme.space(2);
}, function (props) {
  return props.theme.space(2);
}, Tooltip_styles/* TooltipWrapper */.pf, Tooltip_styles/* TooltipContainer */.DY, function (props) {
  return props.theme.backgrounds.shuttleGray;
}, function (props) {
  return props.theme.typography.inverted;
}, function (props) {
  return props.theme.space(2.5);
}, function (props) {
  return props.theme.rem(14);
});
// EXTERNAL MODULE: ../shared/src/components/Tooltip/index.js
var Tooltip = __webpack_require__(30122);
// EXTERNAL MODULE: ../shared/src/constants/services-features.js + 85 modules
var services_features = __webpack_require__(90050);
;// CONCATENATED MODULE: ../shared/src/components/PropertyCard/Info/FeaturesUnitsIcons/index.js

var FeaturesUnitsIcons_jsx = react.createElement;





var filterDuplicateIcons = function filterDuplicateIcons(featuresAndUnits) {
  return featuresAndUnits.reduce(function (acc, code) {
    var featureService = services_features/* SERVICES_FEATURES */.V[code];
    if (!acc || !featureService || acc.some(function (obj) {
      return obj.Component === featureService.Component;
    })) {
      return acc;
    }
    return [].concat((0,toConsumableArray/* default */.Z)(acc), [featureService]);
  }, []);
};
var FeaturesUnitsIcons = function FeaturesUnitsIcons(_ref) {
  var building = _ref.building;
  if (!building) {
    return null;
  }
  var featuresAndUnits = filterDuplicateIcons([].concat((0,toConsumableArray/* default */.Z)(building.features), (0,toConsumableArray/* default */.Z)(building.units)));
  var _useTranslation = (0,esm/* useTranslation */.$G)(),
    t = _useTranslation.t;
  return FeaturesUnitsIcons_jsx(FeaturesUnitsIcons_styles_Wrapper, null, featuresAndUnits.map(function (_ref2) {
    var Component = _ref2.Component,
      translation = _ref2.translation;
    return FeaturesUnitsIcons_jsx(Tooltip/* default */.Z, {
      key: translation,
      bottom: true
    }, FeaturesUnitsIcons_jsx(Component, {
      key: translation
    }), t(translation));
  }));
};
/* harmony default export */ var Info_FeaturesUnitsIcons = (FeaturesUnitsIcons);
// EXTERNAL MODULE: ../shared/src/utils/money/index.js
var money = __webpack_require__(55201);
;// CONCATENATED MODULE: ../shared/src/components/PropertyCard/Info/PropertyPrice/index.js
var PropertyPrice_jsx = react.createElement;



var PropertyPrice = function PropertyPrice(_ref) {
  var price = _ref.price,
    isUniresidences = _ref.isUniresidences;
  var _useTranslation = (0,esm/* useTranslation */.$G)('translations'),
    t = _useTranslation.t,
    language = _useTranslation.i18n.language;
  var currencyCode = price.currencyCode,
    amount = price.amount;
  var recurrence = currencyCode === 'GBP' && isUniresidences ? t('week') : t('month');
  if (isUniresidences && currencyCode === 'GBP') {
    var weeklyPrice = (0,money/* getWeeklyPrice */.Qc)(amount);
    return PropertyPrice_jsx(react.Fragment, null, PropertyPrice_jsx("span", null, (0,money/* formatMoney */.lb)(weeklyPrice, currencyCode, language)), " /", recurrence);
  }
  return PropertyPrice_jsx(react.Fragment, null, PropertyPrice_jsx("span", null, (0,money/* formatMoney */.lb)(amount, currencyCode, language)), " /", recurrence);
};
/* harmony default export */ var Info_PropertyPrice = (PropertyPrice);
// EXTERNAL MODULE: ../shared/src/svg/new-heart.js
var new_heart = __webpack_require__(78078);
;// CONCATENATED MODULE: ../shared/src/components/Search/Card/Controls/AddToWishList/skeleton.js
var skeleton_jsx = react.createElement;



var AddToWishListSkeleton = function AddToWishListSkeleton() {
  return skeleton_jsx(AddToWishList_styles/* Wrapper */.i, null, skeleton_jsx(new_heart/* default */.Z, {
    className: "wishlist-button"
  }));
};
/* harmony default export */ var skeleton = (AddToWishListSkeleton);
;// CONCATENATED MODULE: ../shared/src/components/Search/Card/Tags/index.js
var Tags_jsx = react.createElement;


var Tag = function Tag(_ref) {
  var text = _ref.text;
  return Tags_jsx(Tags_styles_Wrapper, null, text);
};
/* harmony default export */ var Tags = (Tag);
;// CONCATENATED MODULE: ../shared/src/components/Search/Card/OfferCard/index.js
var OfferCard_jsx = react.createElement;















var AddToWishList = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 14600).then(__webpack_require__.bind(__webpack_require__, 14600));
}, {
  loading: skeleton,
  ssr: true,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(14600)];
    }
  }
});
var OfferCard_Card = function Card(_ref) {
  var offerId = _ref.offerId,
    title = _ref.title,
    price = _ref.price,
    isMobile = _ref.isMobile,
    isMap = _ref.isMap,
    isLazy = _ref.isLazy,
    isUniresidences = _ref.isUniresidences,
    isHomepage = _ref.isHomepage,
    isChecked = _ref.isChecked,
    isInstantBooking = _ref.isInstantBooking,
    isTrustedLandlord = _ref.isTrustedLandlord,
    isExclusive = _ref.isExclusive,
    isFeatured = _ref.isFeatured,
    _ref$photos = _ref.photos,
    photos = _ref$photos === void 0 ? [] : _ref$photos,
    tag = _ref.tag,
    oldRent = _ref.oldRent,
    maxGuests = _ref.maxGuests,
    availableFrom = _ref.availableFrom,
    numberOfRooms = _ref.numberOfRooms,
    style = _ref.style,
    handleOfferClick = _ref.handleOfferClick,
    href = _ref.href,
    target = _ref.target,
    sendWishlistClickEvent = _ref.sendWishlistClickEvent,
    isBillsIncluded = _ref.isBillsIncluded,
    building = _ref.building,
    _ref$structuredData = _ref.structuredData,
    structuredData = _ref$structuredData === void 0 ? {} : _ref$structuredData,
    _ref$disableWishlist = _ref.disableWishlist,
    disableWishlist = _ref$disableWishlist === void 0 ? false : _ref$disableWishlist,
    _ref$disableGallerySl = _ref.disableGallerySlide,
    disableGallerySlide = _ref$disableGallerySl === void 0 ? false : _ref$disableGallerySl,
    handleWishlistClick = _ref.handleWishlistClick,
    _ref$isOfferOnWishlis = _ref.isOfferOnWishlist,
    isOfferOnWishlist = _ref$isOfferOnWishlis === void 0 ? false : _ref$isOfferOnWishlis,
    _ref$onClose = _ref.onClose,
    onClose = _ref$onClose === void 0 ? function () {} : _ref$onClose,
    _ref$onMouseEnter = _ref.onMouseEnter,
    onMouseEnter = _ref$onMouseEnter === void 0 ? function () {} : _ref$onMouseEnter,
    _ref$onMouseLeave = _ref.onMouseLeave,
    onMouseLeave = _ref$onMouseLeave === void 0 ? function () {} : _ref$onMouseLeave,
    _ref$language = _ref.language,
    language = _ref$language === void 0 ? 'en' : _ref$language;
  var _useTranslation = (0,esm/* useTranslation */.$G)('translations'),
    t = _useTranslation.t;
  var Component = isMap ? Mapview : Listview;
  var tagComponent = isMap || !tag ? null : OfferCard_jsx(Tags, {
    text: tag,
    key: "tag"
  });
  var GalleryComponent = OfferCard_jsx(Card_Gallery, {
    key: "Gallery",
    photos: photos,
    disableNavigationArrows: isMobile,
    disableFullNavigation: disableGallerySlide || isMobile && isMap,
    isLazy: isLazy,
    title: title,
    isFeatured: isFeatured,
    isUniresidences: isUniresidences
  });
  var maxGuestsTranslation = maxGuests > 1 ? t('Up to maxGuests people', {
    maxGuests: maxGuests
  }) : t('Up to 1 person');
  var TypologyComponent = isMap ? null : OfferCard_jsx(Typology, {
    key: "Typology"
  }, numberOfRooms > 1 ? "".concat(maxGuestsTranslation, " \u2022 ").concat(t('count bedrooms', {
    count: numberOfRooms
  })) : numberOfRooms === 1 ? "".concat(maxGuestsTranslation, " \u2022 ").concat(t('count bedroom', {
    count: numberOfRooms
  })) : "".concat(maxGuestsTranslation));
  var isBillsIncludedComponent = isBillsIncluded ? OfferCard_jsx(BillsIncluded, {
    key: "BillsIncluded"
  }, t('Bills included')) : null;
  var PriceBillsRowComponent = OfferCard_jsx(PriceBillsWrapper, {
    key: "Price"
  }, isUniresidences ? t('From') : null, OfferCard_jsx(Price, null, oldRent && OfferCard_jsx("span", {
    className: "old__price"
  }, (0,utils/* formatMoneyPerCountry */.h6)(oldRent.amount, oldRent.currencyCode, language), " "), OfferCard_jsx(Info_PropertyPrice, {
    price: price,
    isUniresidences: isUniresidences
  })), isBillsIncludedComponent);
  var AvailabilityComponent = !isUniresidences && !isHomepage ? OfferCard_jsx(FromDate, {
    key: "FromDate"
  }, t('From'), " ", (0,utils/* formatDate */.p6)(availableFrom, language, 'dd MMM yyyy')) : null;
  var FeaturesComponent = isUniresidences && !isMap ? OfferCard_jsx(Info_FeaturesUnitsIcons, {
    building: building
  }) : null;
  var HomepageLabelsComponent = isHomepage ? OfferCard_jsx(LabelsWrapper, null, isChecked ? OfferCard_jsx(HomepageTag, null, t('global.labels.verified')) : null, isInstantBooking ? OfferCard_jsx(HomepageTag, null, t('global.labels.instant_booking')) : null, isTrustedLandlord ? OfferCard_jsx(HomepageTag, null, t('global.labels.trusted'), " ") : null, isExclusive ? OfferCard_jsx(HomepageTag, null, t('global.labels.has-exclusive')) : null) : null;
  var TitleComponent = OfferCard_jsx(OfferCard_styles_Title, {
    href: href,
    target: target,
    rel: "noreferrer"
  }, isHomepage ? OfferCard_jsx("p", null, title) : OfferCard_jsx("h2", {
    key: "Title"
  }, title));
  return OfferCard_jsx(styles_WrapperLink, {
    isMobile: isMobile,
    isMap: isMap,
    isFeatured: isFeatured,
    style: style,
    onClick: handleOfferClick,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    itemProp: "itemListElement",
    itemType: "https://schema.org/Offer",
    itemScope: true
  }, Object.keys(structuredData).map(function (key) {
    return OfferCard_jsx("meta", {
      key: key,
      itemProp: key,
      content: structuredData[key]
    });
  }), OfferCard_jsx(Component, {
    isMobile: isMobile,
    isMap: isMap,
    media: [tagComponent, GalleryComponent],
    isUniresidences: isUniresidences,
    isHomepage: isHomepage,
    description: [TypologyComponent, TitleComponent, HomepageLabelsComponent, FeaturesComponent, AvailabilityComponent, PriceBillsRowComponent]
  }), isMap && OfferCard_jsx(CloseCards, {
    onClick: onClose
  }), isMap && isFeatured && OfferCard_jsx(Labels, {
    isFeatured: true,
    isUniresidences: false
  }, OfferCard_jsx(star_full, null), t('Featured')), !isHomepage && !disableWishlist ? OfferCard_jsx(AddToWishList, {
    offerId: offerId,
    sendWishlistClickEvent: sendWishlistClickEvent,
    handleWishlistClick: handleWishlistClick,
    isOfferOnWishlist: isOfferOnWishlist
  }) : null);
};
/* harmony default export */ var OfferCard = (/*#__PURE__*/react.memo(OfferCard_Card));
// EXTERNAL MODULE: ../shared/src/constants/accommodationType.js
var accommodationType = __webpack_require__(87433);
;// CONCATENATED MODULE: ../shared/src/components/Recommendation/index.js

var Recommendation_jsx = react.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }







var Recommendation = function Recommendation(_ref) {
  var _wishlist$cities;
  var recommendation = _ref.recommendation,
    cityCode = _ref.cityCode,
    wishlist = _ref.wishlist,
    showTrustedTag = _ref.showTrustedTag,
    isMobile = _ref.isMobile,
    language = _ref.language,
    t = _ref.t,
    _handleOfferClick = _ref.handleOfferClick,
    handleWishlistClick = _ref.handleWishlistClick,
    disableWishlist = _ref.disableWishlist,
    withMapOpened = _ref.withMapOpened;
  var offerId = recommendation.id,
    _recommendation$attri = recommendation.attributes,
    _recommendation$attri2 = _recommendation$attri.accommodation_offer,
    title = _recommendation$attri2.title,
    price = _recommendation$attri2.price,
    max_guests = _recommendation$attri2.max_guests,
    available_from = _recommendation$attri2.available_from,
    all_bills_included = _recommendation$attri2.all_bills_included,
    number_of_bedrooms = _recommendation$attri2.number_of_bedrooms,
    is_instant_booking = _recommendation$attri2.is_instant_booking,
    exclusive = _recommendation$attri2.exclusive,
    createdAt = _recommendation$attri2.created_at,
    isSoldOut = _recommendation$attri2.is_sold_out,
    _recommendation$attri3 = _recommendation$attri.property,
    propertyId = _recommendation$attri3.id,
    typeCode = _recommendation$attri3.type,
    accommodationTypeCode = _recommendation$attri3.accommodation_type,
    verified = _recommendation$attri3.verified,
    isTrusted = _recommendation$attri.accommodation_provider.verifications.trusted,
    photos = _recommendation$attri.photos;
  var isResidence = accommodationTypeCode === accommodationType/* ACCOMMODATION_TYPE_CODE.RESIDENCE */.s.RESIDENCE && typeCode === accommodationType/* ACCOMMODATION_TYPE_CODE.RESIDENCE */.s.RESIDENCE;
  var photosWithPath = photos.map(function (photo) {
    return _objectSpread(_objectSpread({}, photo), {}, {
      path: "".concat("https://cdn-static-new.uniplaces.com", "/property-photos/").concat(photo === null || photo === void 0 ? void 0 : photo.hash, "/small.jpg")
    });
  });
  var href = (0,redirect/* getOfferPageUrl */.k9)({
    city: cityCodeToCitySlug(cityCode),
    offerId: offerId,
    withMapOpened: withMapOpened,
    isResidence: isResidence,
    propertyId: isResidence ? propertyId : null,
    language: language
  });
  var tag = [{
    is: isSoldOut,
    key: 'Sold out'
  }, {
    is: is_instant_booking,
    key: 'Instant booking'
  }, {
    is: exclusive,
    key: 'Uniplaces Exclusive'
  }, {
    is: isNew(createdAt),
    key: 'New'
  }, {
    is: verified,
    key: 'Checked'
  }, {
    is: showTrustedTag && isTrusted,
    key: 'Trusted Landlord'
  }].find(function (_ref2) {
    var is = _ref2.is;
    return !!is;
  });
  var isOfferOnWishlist = (wishlist === null || wishlist === void 0 ? void 0 : (_wishlist$cities = wishlist.cities) === null || _wishlist$cities === void 0 ? void 0 : _wishlist$cities.items.some(function (_ref3) {
    var accommodation_offer_ids = _ref3.accommodation_offer_ids;
    return accommodation_offer_ids === null || accommodation_offer_ids === void 0 ? void 0 : accommodation_offer_ids.includes(+offerId);
  })) || false;
  return Recommendation_jsx(OfferCard, {
    key: offerId,
    offerId: offerId,
    title: title,
    price: _objectSpread(_objectSpread({}, price), {}, {
      currencyCode: price.currency_code
    }),
    isMobile: isMobile,
    photos: photosWithPath,
    maxGuests: max_guests,
    availableFrom: (0,addHours/* default */.Z)((0,parseISO/* default */.Z)(available_from), 12),
    isBillsIncluded: all_bills_included,
    numberOfRooms: number_of_bedrooms,
    language: language,
    href: href,
    tag: tag ? t(tag.key) : null,
    disableWishlist: disableWishlist,
    disableGallerySlide: isMobile,
    handleWishlistClick: handleWishlistClick,
    isOfferOnWishlist: isOfferOnWishlist,
    handleOfferClick: function handleOfferClick(e) {
      return _handleOfferClick(e, href, recommendation);
    }
  });
};
/* harmony default export */ var components_Recommendation = (Recommendation);
;// CONCATENATED MODULE: ./src/components/MoreListings/index.js
var MoreListings_jsx = react.createElement;













var MoreListings = function MoreListings(_ref) {
  var title = _ref.title,
      cityCode = _ref.cityCode,
      recommendations = _ref.recommendations,
      showTrustedTag = _ref.showTrustedTag,
      _ref$disableWishlist = _ref.disableWishlist,
      disableWishlist = _ref$disableWishlist === void 0 ? true : _ref$disableWishlist,
      isLoggedIn = _ref.isLoggedIn,
      cardWidth = _ref.cardWidth,
      cardGap = _ref.cardGap,
      wishlist = _ref.wishlist,
      showWishlistModal = _ref.showWishlistModal,
      addToWishlist = _ref.addToWishlist,
      removeFromWishlist = _ref.removeFromWishlist,
      trackListing = _ref.trackListing;

  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t,
      language = _useTranslation.i18n.language;

  var _useContext = (0,react.useContext)(media/* MediaContext */.Y),
      is = _useContext.is;

  var handleOfferClick = function handleOfferClick(e, href) {
    e.preventDefault();
    e.stopPropagation();
    trackListing();
    (0,redirect/* redirect */.uX)()(href, is.notMobile);
  };

  var handleWishlistClick = function handleWishlistClick(e, id) {
    var _wishlist$cities;

    e.preventDefault();
    e.stopPropagation();

    if (!isLoggedIn) {
      showWishlistModal();
      return;
    }

    var city = cityCodeToCitySlug(cityCode);
    var isOnWishlist = wishlist === null || wishlist === void 0 ? void 0 : (_wishlist$cities = wishlist.cities) === null || _wishlist$cities === void 0 ? void 0 : _wishlist$cities.items.some(function (_ref2) {
      var accommodation_offer_ids = _ref2.accommodation_offer_ids;
      return accommodation_offer_ids.includes(+id);
    });
    isOnWishlist ? removeFromWishlist({
      offerId: +id,
      city: city
    }) : addToWishlist({
      offerId: +id,
      city: city
    });
  };

  return MoreListings_jsx(MoreListings_styles_Wrapper, null, MoreListings_jsx(components_SimpleCarousel, {
    title: title,
    numberOfElements: recommendations === null || recommendations === void 0 ? void 0 : recommendations.data.length,
    itemWidth: cardWidth,
    gap: cardGap
  }, recommendations === null || recommendations === void 0 ? void 0 : recommendations.data.map(function (recommendation) {
    return MoreListings_jsx("div", {
      key: title
    }, MoreListings_jsx(components_Recommendation, {
      recommendation: recommendation,
      cityCode: cityCode,
      wishlist: wishlist,
      isMobile: is.mobile,
      language: language,
      t: t,
      handleOfferClick: handleOfferClick,
      handleWishlistClick: handleWishlistClick,
      disableWishlist: disableWishlist,
      showTrustedTag: showTrustedTag
    }));
  })));
};

var MoreListings_mapStateToProps = function mapStateToProps(_ref3) {
  var cityCode = _ref3.offer.offerAggregate.property_aggregate.property.location.address.city_code,
      _ref3$profile = _ref3.profile,
      isLoggedIn = _ref3$profile.isLoggedIn,
      wishlist = _ref3$profile.wish_list;
  return {
    cityCode: cityCode,
    isLoggedIn: isLoggedIn,
    wishlist: wishlist,
    isWishlistLoading: wishlist === null || wishlist === void 0 ? void 0 : wishlist.isLoading
  };
};

var MoreListings_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    showWishlistModal: function showWishlistModal() {
      return dispatch((0,modal/* showModalAction */.bF)({
        modalId: modal_displayer.modalIds.WISHLIST
      }));
    },
    addToWishlist: function addToWishlist(_ref4) {
      var offerId = _ref4.offerId,
          city = _ref4.city;
      return dispatch((0,profile/* addToWishlistAction */.$C)({
        offerId: offerId,
        city: city
      }));
    },
    removeFromWishlist: function removeFromWishlist(_ref5) {
      var offerId = _ref5.offerId,
          city = _ref5.city;
      return dispatch((0,profile/* removeFromWishlistAction */.b5)({
        offerId: offerId,
        city: city
      }));
    }
  };
};

/* harmony default export */ var components_MoreListings = ((0,es/* connect */.$j)(MoreListings_mapStateToProps, MoreListings_mapDispatchToProps)(MoreListings));
;// CONCATENATED MODULE: ../shared/src/svg/mail.js


var mail_excluded = ["color"];
var mail_jsx = react.createElement;

var Mail = function Mail(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#224251' : _ref$color,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, mail_excluded);
  return mail_jsx("svg", (0,esm_extends/* default */.Z)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), mail_jsx("g", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    clipPath: "url(#a)"
  }, mail_jsx("path", {
    d: "M22.5 12.5V7A1.5 1.5 0 0 0 21 5.5H3A1.5 1.5 0 0 0 1.5 7v11A1.5 1.5 0 0 0 3 19.5h11"
  }), mail_jsx("path", {
    d: "m22 6-10 8L2 6M16 17.5a3.5 3.5 0 1 0 7 0 3.5 3.5 0 0 0-7 0Z"
  }), mail_jsx("path", {
    d: "m21 16-1.574 2.785a.468.468 0 0 1-.131.15.317.317 0 0 1-.337.032.415.415 0 0 1-.145-.124L18 17.764"
  })), mail_jsx("defs", null, mail_jsx("clipPath", {
    id: "a"
  }, mail_jsx("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};
/* harmony default export */ var mail = (Mail);
;// CONCATENATED MODULE: ../shared/src/svg/time.js


var time_excluded = ["color"];
var time_jsx = react.createElement;

var Time = function Time(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#224251' : _ref$color,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, time_excluded);
  return time_jsx("svg", (0,esm_extends/* default */.Z)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), time_jsx("g", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    clipPath: "url(#a)"
  }, time_jsx("path", {
    d: "M12 23.5c6.351 0 11.5-5.149 11.5-11.5S18.351.5 12 .5.5 5.649.5 12 5.649 23.5 12 23.5Z"
  }), time_jsx("path", {
    d: "M11.5 6.5V12l6 5.5"
  })), time_jsx("defs", null, time_jsx("clipPath", {
    id: "a"
  }, time_jsx("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};
/* harmony default export */ var time = (Time);
;// CONCATENATED MODULE: ../shared/src/svg/users.js


var users_excluded = ["color"];
var users_jsx = react.createElement;

var Users = function Users(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#224251' : _ref$color,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, users_excluded);
  return users_jsx("svg", (0,esm_extends/* default */.Z)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 22,
    fill: "none",
    viewBox: "0 0 25 22"
  }, props), users_jsx("g", {
    stroke: color,
    strokeLinejoin: "round",
    clipRule: "evenodd"
  }, users_jsx("path", {
    d: "M1 7.932V11c0 .844.177 1.534 1.014 1.534v4.601h3.042v-4.601c.836 0 1.013-.692 1.014-1.534V7.932H1ZM19.253 7.932V11c0 .844.177 1.534 1.014 1.534v4.601h3.042v-4.601c.836 0 1.013-.692 1.014-1.534V7.932h-5.07ZM9.112 7.932h7.099v5.113a2.043 2.043 0 0 1-2.028 2.045v6.136H11.14V15.09a2.042 2.042 0 0 1-2.028-2.045V7.932ZM5.056 4.353c0 .846-.682 1.534-1.521 1.534-.84 0-1.521-.688-1.521-1.534 0-.847.681-1.534 1.52-1.534.84 0 1.522.687 1.522 1.534ZM23.31 4.353c0 .846-.682 1.534-1.521 1.534-.84 0-1.521-.688-1.521-1.534 0-.847.681-1.534 1.52-1.534.84 0 1.522.687 1.522 1.534ZM15.197 3.33a2.545 2.545 0 0 1-2.535 2.557 2.545 2.545 0 0 1-2.535-2.557A2.545 2.545 0 0 1 12.662.774c1.4 0 2.535 1.144 2.535 2.556Z"
  })));
};
/* harmony default export */ var users = (Users);
;// CONCATENATED MODULE: ../shared/src/svg/mixed-gender.js


var mixed_gender_excluded = ["color"];
var mixed_gender_jsx = react.createElement;

var Gender = function Gender(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#224251' : _ref$color,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, mixed_gender_excluded);
  return mixed_gender_jsx("svg", (0,esm_extends/* default */.Z)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 24,
    fill: "none",
    viewBox: "0 0 22 24"
  }, props), mixed_gender_jsx("path", {
    fill: color,
    stroke: color,
    d: "M14.12 2.381V1.177l-.853.85L8.94 6.335l-.322.32.288.352a4.703 4.703 0 0 1-.49 6.482 4.75 4.75 0 0 1-6.53-.163 4.705 4.705 0 0 1-.163-6.499 4.752 4.752 0 0 1 6.514-.488l.349.285.319-.318 4.326-4.308.857-.855H8.905a.025.025 0 0 1-.017-.007.02.02 0 0 1-.007-.014.02.02 0 0 1 .007-.015.025.025 0 0 1 .017-.007h5.238c.007 0 .013.003.018.007a.02.02 0 0 1 .006.015v5.217a.02.02 0 0 1-.006.015.025.025 0 0 1-.018.007.025.025 0 0 1-.017-.007l-.353.354.353-.354a.02.02 0 0 1-.007-.015V2.38ZM5.237 5.317a4.699 4.699 0 0 0-3.316 1.368 4.666 4.666 0 0 0 0 6.612 4.699 4.699 0 0 0 6.632 0 4.666 4.666 0 0 0 0-6.612 4.699 4.699 0 0 0-3.316-1.368Z"
  }), mixed_gender_jsx("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M16.762 8.948a4.2 4.2 0 0 0-2.964 1.222 4.166 4.166 0 0 0 0 5.903 4.2 4.2 0 0 0 5.927 0 4.166 4.166 0 0 0 0-5.903 4.199 4.199 0 0 0-2.963-1.222Zm-5.239 4.174c0-1.01.295-1.998.847-2.844a5.232 5.232 0 0 1 2.267-1.925 5.257 5.257 0 0 1 5.638.9 5.198 5.198 0 0 1 1.462 5.498 5.217 5.217 0 0 1-1.695 2.439 5.25 5.25 0 0 1-2.757 1.123v2.113h2.096a.525.525 0 0 1 .523.522.52.52 0 0 1-.523.522h-2.096v2.608a.52.52 0 0 1-.523.522.525.525 0 0 1-.524-.522V21.47h-2.095a.525.525 0 0 1-.524-.522.52.52 0 0 1 .524-.522h2.095v-2.113a5.246 5.246 0 0 1-3.361-1.691 5.206 5.206 0 0 1-1.354-3.5Z",
    clipRule: "evenodd"
  }));
};
/* harmony default export */ var mixed_gender = (Gender);
;// CONCATENATED MODULE: ../shared/src/svg/female-gender.js


var female_gender_excluded = ["color"];
var female_gender_jsx = react.createElement;

var FemaleGender = function FemaleGender(_ref) {
  var color = _ref.color,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, female_gender_excluded);
  return female_gender_jsx("svg", (0,esm_extends/* default */.Z)({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), female_gender_jsx("g", {
    clipPath: "url(#clip0_2379_6323)"
  }, female_gender_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5217 1.49992C10.972 1.49992 9.48564 2.13206 8.38978 3.25728C7.29391 4.3825 6.67826 5.90863 6.67826 7.49994C6.67826 9.09124 7.29391 10.6174 8.38978 11.7426C9.48564 12.8678 10.972 13.5 12.5217 13.5C14.0715 13.5 15.5578 12.8678 16.6537 11.7426C17.7496 10.6174 18.3652 9.09124 18.3652 7.49994C18.3652 5.90863 17.7496 4.3825 16.6537 3.25728C15.5578 2.13206 14.0715 1.49992 12.5217 1.49992ZM5.21739 7.49994C5.21741 6.04855 5.62756 4.62835 6.39811 3.41158C7.16865 2.1948 8.26648 1.23373 9.55845 0.64492C10.8504 0.0561102 12.281 -0.13514 13.6768 0.0943651C15.0725 0.32387 16.3734 0.964269 17.4217 1.93789C18.47 2.91152 19.2206 4.17654 19.5826 5.57954C19.9445 6.98253 19.9022 8.46322 19.4608 9.84203C19.0194 11.2208 18.1979 12.4385 17.0959 13.3474C15.9938 14.2563 14.6586 14.8173 13.2522 14.9625V18H16.1739C16.3676 18 16.5534 18.079 16.6904 18.2196C16.8274 18.3603 16.9043 18.5511 16.9043 18.75C16.9043 18.9489 16.8274 19.1397 16.6904 19.2803C16.5534 19.421 16.3676 19.5 16.1739 19.5H13.2522V23.25C13.2522 23.4489 13.1752 23.6397 13.0382 23.7803C12.9013 23.921 12.7155 24 12.5217 24C12.328 24 12.1422 23.921 12.0052 23.7803C11.8683 23.6397 11.7913 23.4489 11.7913 23.25V19.5H8.86957C8.67584 19.5 8.49005 19.421 8.35307 19.2803C8.21609 19.1397 8.13913 18.9489 8.13913 18.75C8.13913 18.5511 8.21609 18.3603 8.35307 18.2196C8.49005 18.079 8.67584 18 8.86957 18H11.7913V14.9625C9.98959 14.7765 8.31937 13.9101 7.10466 12.5312C5.88995 11.1523 5.21737 9.35924 5.21739 7.49994Z",
    fill: color !== null && color !== void 0 ? color : '#224251'
  })), female_gender_jsx("defs", null, female_gender_jsx("clipPath", {
    id: "clip0_2379_6323"
  }, female_gender_jsx("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};
/* harmony default export */ var female_gender = (FemaleGender);
;// CONCATENATED MODULE: ../shared/src/svg/male-gender.js


var male_gender_excluded = ["color"];
var male_gender_jsx = react.createElement;

var MaleGender = function MaleGender(_ref) {
  var color = _ref.color,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, male_gender_excluded);
  return male_gender_jsx("svg", (0,esm_extends/* default */.Z)({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), male_gender_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3573 2.57139C14.149 2.57139 13.9491 2.48861 13.8018 2.34127C13.6544 2.19392 13.5716 1.99408 13.5716 1.7857C13.5716 1.57732 13.6544 1.37747 13.8018 1.23013C13.9491 1.08278 14.149 1 14.3573 1H22.2143C22.4227 1 22.6225 1.08278 22.7699 1.23013C22.9172 1.37747 23 1.57732 23 1.7857V9.64266C23 9.85104 22.9172 10.0509 22.7699 10.1982C22.6225 10.3456 22.4227 10.4284 22.2143 10.4284C22.0059 10.4284 21.8061 10.3456 21.6587 10.1982C21.5114 10.0509 21.4286 9.85104 21.4286 9.64266V3.68237L14.9403 10.1706C16.216 11.7313 16.843 13.7226 16.6918 15.7326C16.5405 17.7427 15.6225 19.6177 14.1276 20.9699C12.6327 22.3221 10.6753 23.048 8.66026 22.9975C6.64518 22.9471 4.72658 22.1241 3.30125 20.6987C1.87593 19.2734 1.05293 17.3548 1.00247 15.3397C0.952001 13.3247 1.67793 11.3673 3.03013 9.87238C4.38232 8.3775 6.25732 7.45949 8.26735 7.30822C10.2774 7.15696 12.2687 7.784 13.8294 9.05967L20.3176 2.57139H14.3573ZM8.85747 8.85696C7.19043 8.85696 5.59167 9.51919 4.41289 10.698C3.23412 11.8767 2.57189 13.4755 2.57189 15.1425C2.57189 16.8096 3.23412 18.4083 4.41289 19.5871C5.59167 20.7659 7.19043 21.4281 8.85747 21.4281C10.5245 21.4281 12.1233 20.7659 13.302 19.5871C14.4808 18.4083 15.143 16.8096 15.143 15.1425C15.143 13.4755 14.4808 11.8767 13.302 10.698C12.1233 9.51919 10.5245 8.85696 8.85747 8.85696Z",
    fill: color !== null && color !== void 0 ? color : '#224251'
  }));
};
/* harmony default export */ var male_gender = (MaleGender);
;// CONCATENATED MODULE: ../shared/src/svg/registered.js


var registered_excluded = ["color"];
var registered_jsx = react.createElement;

var Registered = function Registered(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#224251' : _ref$color,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, registered_excluded);
  return registered_jsx("svg", (0,esm_extends/* default */.Z)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), registered_jsx("g", {
    stroke: color,
    clipPath: "url(#a)"
  }, registered_jsx("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M9.774 13.191v2.586L4.935 17.5C3.775 17.883 3 19.032 3 20.18V22h12.5m1-5.5-1.887-.723V13"
  }), registered_jsx("path", {
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M11.9 13.8c2.762 0 5-2.686 5-6s-2.238-6-5-6c-2.761 0-5 2.686-5 6s2.239 6 5 6Z"
  }), registered_jsx("path", {
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M16.8 7.2h-.5c-1.7.3-2.8-.3-3.7-1.9-.6 1.1-2.3 1.9-3.8 1.9-.7 0-1.3-.1-1.9-.5"
  }), registered_jsx("path", {
    strokeLinecap: "round",
    d: "M16 19.5h7M19.5 16v7"
  })), registered_jsx("defs", null, registered_jsx("clipPath", {
    id: "a"
  }, registered_jsx("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};
/* harmony default export */ var registered = (Registered);
;// CONCATENATED MODULE: ../shared/src/constants/genders.js
var GENDERS = {
  M: 'Male',
  F: 'Female'
};
// EXTERNAL MODULE: ../shared/src/svg/shared-bedroom.js
var shared_bedroom = __webpack_require__(25302);
// EXTERNAL MODULE: ../shared/src/constants/translations.js
var translations = __webpack_require__(35503);
;// CONCATENATED MODULE: ../shared/src/svg/lives-with-family.js


var lives_with_family_excluded = ["color"];
var lives_with_family_jsx = react.createElement;

var LivesWithFamily = function LivesWithFamily(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#224251' : _ref$color,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, lives_with_family_excluded);
  return lives_with_family_jsx("svg", (0,esm_extends/* default */.Z)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), lives_with_family_jsx("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m2 9 6.238-4.265C9.932 3.578 10.778 3 11.808 3c1.029 0 1.876.578 3.57 1.735L21.615 9M3.962 8v12m15.692 0V8M2 20h19.615M8.538 20v-4c0-.943 0-1.414.384-1.707C9.305 14 9.92 14 11.154 14h1.307c1.234 0 1.85 0 2.233.293s.383.764.383 1.707v4M10.5 11h2.615M10.5 8h2.615"
  }));
};
/* harmony default export */ var lives_with_family = (LivesWithFamily);
;// CONCATENATED MODULE: ../shared/src/svg/pet.js


var pet_excluded = ["color"];
var pet_jsx = react.createElement;

var Pet = function Pet(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#224251' : _ref$color,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, pet_excluded);
  return pet_jsx("svg", (0,esm_extends/* default */.Z)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), pet_jsx("path", {
    stroke: color,
    d: "M6.5 9.15c0 1.577-.997 2.65-2 2.65-1.003 0-2-1.073-2-2.65s.997-2.65 2-2.65c1.003 0 2 1.073 2 2.65ZM11 5.15c0 1.577-.997 2.65-2 2.65-1.003 0-2-1.073-2-2.65S7.997 2.5 9 2.5c1.003 0 2 1.073 2 2.65ZM17 5.15c0 1.577-.997 2.65-2 2.65-1.003 0-2-1.073-2-2.65s.997-2.65 2-2.65c1.003 0 2 1.073 2 2.65ZM21.5 9.15c0 1.577-.997 2.65-2 2.65-1.003 0-2-1.073-2-2.65s.997-2.65 2-2.65c1.003 0 2 1.073 2 2.65ZM16.96 14.184l.013.016.014.014.238.237c.594.59 1.178 1.17 1.613 1.815.477.706.741 1.443.622 2.287-.26.88-.88 1.699-1.94 1.937-.105.019-.318.017-.677-.017-.293-.029-.64-.074-1.04-.126l-.232-.03c-.985-.128-2.216-.277-3.49-.277h-.18c-1.277 0-2.508.152-3.492.28l-.206.028c-.41.053-.766.1-1.065.129-.362.034-.573.034-.674.014-1.064-.238-1.683-1.05-1.944-1.936-.114-.839.152-1.574.63-2.28.436-.643 1.02-1.223 1.613-1.812l.24-.24.014-.013.012-.013c.565-.655 1.07-1.25 1.588-1.861l.892-1.05c.454-.521.962-.977 1.533-1.173l.009-.003c.085-.03.168-.053.249-.068l.005-.001c.205-.04.427-.041.695-.041.266 0 .493.001.696.033.08.015.16.037.243.067l.009.003c.573.197 1.092.655 1.531 1.171l.003.003c.563.652 1.063 1.241 1.579 1.85.29.341.585.69.899 1.057Z"
  }));
};
/* harmony default export */ var pet = (Pet);
;// CONCATENATED MODULE: ../shared/src/svg/professional.js


var professional_excluded = ["color", "fillColor"];
var professional_jsx = react.createElement;

var Professional = function Professional(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#224251' : _ref$color,
    _ref$fillColor = _ref.fillColor,
    fillColor = _ref$fillColor === void 0 ? '#fff' : _ref$fillColor,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, professional_excluded);
  return professional_jsx("svg", (0,esm_extends/* default */.Z)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), professional_jsx("circle", {
    cx: 12.1,
    cy: 6.8,
    r: 4.5,
    fill: fillColor,
    stroke: color
  }), professional_jsx("path", {
    stroke: color,
    strokeWidth: 0.8,
    d: "M7.517 6.281c2.721-.272 4.795-1.21 5.464-1.546a.433.433 0 0 1 .441.03c.313.219.921.62 1.456.85.76.325 1.805.666 1.805.666"
  }), professional_jsx("mask", {
    id: "a",
    fill: fillColor
  }, professional_jsx("path", {
    d: "M12.96 14.93h-1.667a.353.353 0 0 1-.334-.246l-.37-1.473a.263.263 0 0 1 .074-.281c.074-.07.185-.14.296-.14h2.408c.11 0 .222.035.296.14.074.07.074.175.074.28l-.37 1.474a.458.458 0 0 1-.408.246Zm-1.371-.667H12.7l.222-.807h-1.518l.185.807Z"
  })), professional_jsx("path", {
    fill: color,
    d: "M12.96 14.93h-1.667a.353.353 0 0 1-.334-.246l-.37-1.473a.263.263 0 0 1 .074-.281c.074-.07.185-.14.296-.14h2.408c.11 0 .222.035.296.14.074.07.074.175.074.28l-.37 1.474a.458.458 0 0 1-.408.246Zm-1.371-.667H12.7l.222-.807h-1.518l.185.807Z"
  }), professional_jsx("path", {
    fill: color,
    d: "m10.96 14.684-.97.244.002.011.967-.255Zm-.371-1.473.97-.244-.011-.045-.016-.043-.943.332Zm3.074-.281-.818.575.058.082.072.069.688-.726Zm.074.28.97.244.03-.12v-.123h-1Zm-.37 1.474.884.467.056-.106.03-.117-.97-.244Zm-1.778-.42-.975.223.178.776h.797v-1Zm1.111 0v1h.762l.202-.735-.964-.266Zm.222-.808.964.266.349-1.266h-1.313v1Zm-1.518 0v-1h-1.256l.281 1.224.975-.224Zm1.555.474h-1.666v2h1.666v-2Zm-1.666 0c.157 0 .286.053.38.122.094.068.204.19.253.377l-1.934.51c.164.622.744.99 1.3.99v-2Zm.636.51-.37-1.473-1.94.487.37 1.474 1.94-.488Zm-.397-1.561a.737.737 0 0 1-.181.777l-1.376-1.452c-.309.292-.52.798-.33 1.338l1.887-.663Zm-.181.777a.402.402 0 0 1-.095.066.647.647 0 0 1-.297.068v-2c-.49 0-.838.276-.984.414l1.376 1.452Zm-.392.133h2.408v-2h-2.408v2Zm2.408 0a.594.594 0 0 1-.234-.05.686.686 0 0 1-.288-.234l1.636-1.15a1.342 1.342 0 0 0-1.114-.566v2Zm-.392-.133a.776.776 0 0 1-.23-.41c-.007-.04-.008-.067-.008-.069v.034h2c0-.032.003-.184-.027-.343a1.225 1.225 0 0 0-.36-.664l-1.375 1.452Zm-.208-.69-.37 1.475 1.94.487.37-1.474-1.94-.487Zm-.285 1.251a.542.542 0 0 1 .477-.287v2c.588 0 1.06-.34 1.292-.779l-1.769-.934Zm-.893 1.046H12.7v-2h-1.111v2Zm2.075-.734.222-.807-1.928-.531-.222.807 1.928.53Zm-.742-2.073h-1.518v2h1.518v-2ZM10.43 13.68l.185.807 1.95-.447-.186-.807-1.949.447Z",
    mask: "url(#a)"
  }), professional_jsx("mask", {
    id: "b",
    fill: fillColor
  }, professional_jsx("path", {
    d: "M13.33 17.491c-.186 0-.26.28-.297.105l-.407-2.947c-.037-.175.111-.35.296-.386.185-.035.37.105.408.28l.444 2.948L13.7 17c0 .21-.148.491-.37.491Zm-2.445.421c-.185 0-.37-.14-.37-.35v-.036l.444-2.947c.037-.176.223-.316.408-.28.185.034.333.21.296.385l-.444 2.948c0 .14-.149.28-.334.28Z"
  })), professional_jsx("path", {
    fill: color,
    d: "M13.33 17.491c-.186 0-.26.28-.297.105l-.407-2.947c-.037-.175.111-.35.296-.386.185-.035.37.105.408.28l.444 2.948L13.7 17c0 .21-.148.491-.37.491Zm-2.445.421c-.185 0-.37-.14-.37-.35v-.036l.444-2.947c.037-.176.223-.316.408-.28.185.034.333.21.296.385l-.444 2.948c0 .14-.149.28-.334.28Z"
  }), professional_jsx("path", {
    fill: color,
    d: "m13.033 17.596-1.98.274.009.07.014.07 1.957-.414Zm-.407-2.947 1.981-.274-.01-.07-.014-.069-1.957.413Zm.704-.105 1.977-.298-.008-.058-.012-.057-1.957.413ZM13.7 17l1.978-.298L11.7 17h2Zm-3.185.526-1.978-.298-.022.148v.15h2Zm.444-2.947-1.957-.413-.012.057-.008.058 1.977.298Zm.704.105-1.957-.413-.012.057-.009.058 1.978.298Zm-.444 2.948-1.978-.299-.022.149v.15h2Zm2.11-2.14c-.582 0-1.017.227-1.268.404a2.416 2.416 0 0 0-.348.297l-.03.032c-.026.027.039-.044.127-.118a1.969 1.969 0 0 1 1.042-.441 1.983 1.983 0 0 1 1.873.885c.203.312.258.596.265.632l-3.914.827c.017.08.082.394.297.723a2.017 2.017 0 0 0 2.684.662 2.09 2.09 0 0 0 .458-.346l.054-.055c.055-.057-.054.066-.21.175-.184.13-.54.322-1.03.322v-4Zm1.685 1.83-.407-2.947-3.962.548.407 2.947 3.963-.547Zm-.431-3.086a1.704 1.704 0 0 1-.324 1.409 1.607 1.607 0 0 1-.965.583l-.744-3.93c-.968.184-2.211 1.2-1.88 2.764l3.913-.826Zm-1.289 1.992a1.632 1.632 0 0 1-1.922-1.271l3.915-.826c-.239-1.13-1.374-2.091-2.737-1.833l.744 3.93Zm-1.942-1.386.444 2.947 3.956-.596-.445-2.947-3.955.596Zm4.4 2.351-.074-.491-3.956.596.074.492 3.956-.597ZM11.7 17c0-.306.09-.57.238-.79.14-.21.586-.719 1.392-.719v4c1.028 0 1.658-.649 1.928-1.051.278-.414.442-.923.442-1.44h-4Zm-.815-1.088c.681 0 1.63.531 1.63 1.65h-4c0 1.539 1.319 2.35 2.37 2.35v-4Zm1.63 1.65v-.036h-4v.035h4Zm-.023.262.445-2.947-3.955-.596-.445 2.947 3.955.596Zm.424-2.832a1.632 1.632 0 0 1-1.922 1.271l.745-3.93c-1.363-.258-2.498.704-2.737 1.833l3.914.826Zm-1.922 1.271a1.607 1.607 0 0 1-.964-.583 1.704 1.704 0 0 1-.324-1.409l3.914.826c.33-1.565-.913-2.58-1.881-2.764l-.745 3.93Zm-1.309-1.877-.444 2.947 3.955.597.445-2.948-3.956-.596Zm-.466 3.246c0-.634.317-1.078.586-1.313a1.64 1.64 0 0 1 1.08-.407v4c1.03 0 2.334-.792 2.334-2.28h-4Z",
    mask: "url(#b)"
  }), professional_jsx("path", {
    stroke: color,
    d: "M20.7 22.737H3.2a1 1 0 0 1-1-1v-4.098a4 4 0 0 1 2.824-3.824l2.528-.777a1 1 0 0 1 1.186.504l3.123 6.176a.1.1 0 0 0 .178 0l3.123-6.176a1 1 0 0 1 1.186-.505l2.528.778A4 4 0 0 1 21.7 17.64v4.098a1 1 0 0 1-1 1Z"
  }), professional_jsx("path", {
    stroke: color,
    strokeLinecap: "round",
    d: "M6 18.5v4M18 18.5v4"
  }));
};
/* harmony default export */ var professional = (Professional);
;// CONCATENATED MODULE: ../shared/src/svg/student.js


var student_excluded = ["color"];
var student_jsx = react.createElement;

var Student = function Student(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#224251' : _ref$color,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, student_excluded);
  return student_jsx("svg", (0,esm_extends/* default */.Z)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), student_jsx("path", {
    fill: color,
    d: "m19.45 18.6-4.462-1.152c.797-.648 1.355-1.44 1.514-2.448.558-.144.956-.72.956-1.44 0-.216-.08-.432-.08-.576l.399-2.808c0-.072.16-1.44-1.036-2.664C15.785 6.504 14.111 6 11.961 6c-2.152 0-3.746.504-4.782 1.512-1.195 1.152-1.036 2.592-1.036 2.664l.399 2.808c-.08.144-.08.36-.08.576 0 .72.399 1.224.956 1.44.08 1.008.717 1.872 1.594 2.52L4.39 18.6C2.956 19.104 2 20.328 2 21.768v1.872c0 .216.16.36.398.36H21.602c.239 0 .398-.144.398-.36v-1.872c-.08-1.44-1.036-2.664-2.55-3.168ZM7.737 8.016c.877-.864 2.31-1.296 4.223-1.296 1.912 0 3.347.432 4.144 1.224.956.936.796 2.088.796 2.088l-.318 2.16c-.08 0-.16-.072-.24-.072l-.398-1.656c0-.144-.239-.288-.398-.288-2.47 0-2.948-.648-3.187-1.08.08-.072 0-.216-.08-.288a.414.414 0 0 0-.558 0c-.16.072-.239.216-.319.36-.239.432-.717 1.08-3.187 1.08-.16-.072-.319.072-.398.216l-.319 1.656c-.08 0-.16.072-.239.072l-.319-2.16s-.08-1.08.797-2.016Zm.478 6.624c0-.216-.16-.36-.398-.36-.399 0-.558-.504-.558-.792 0-.288.08-.792.558-.792.16 0 .318-.144.398-.288l.319-1.584c2.23 0 2.948-.504 3.426-1.152.478.648 1.195 1.152 3.426 1.224l.32 1.584c0 .144.238.288.398.288.398 0 .557.504.557.792 0 .288-.08.792-.557.792-.24 0-.399.144-.399.36 0 1.08-.797 1.944-1.673 2.592-.08 0-.24.072-.319.144-.637.432-1.354.648-1.832.648-.399 0-1.116-.216-1.754-.576-.08-.072-.159-.072-.239-.144-.876-.648-1.673-1.584-1.673-2.736Zm3.745 5.256c-.478 0-.876-.36-.876-.792V18.6c.318.072.637.144.876.144.24 0 .558-.072.877-.144v.504c0 .432-.399.792-.877.792Zm-9.163 1.872c0-1.152.717-2.088 1.832-2.52l5.1-1.224c.16.072.319.216.558.288v.864c0 .576.398 1.152.956 1.368L9.251 23.28H2.797v-1.512Zm7.41 1.512 1.753-2.376 1.753 2.376h-3.506Zm10.916 0H14.67l-1.036-1.404-1.035-1.404c.557-.216.956-.792.956-1.368v-.864c.239-.072.398-.216.637-.36l4.94 1.296c1.196.36 1.913 1.368 1.913 2.52v1.584h.08Z"
  }), student_jsx("path", {
    fill: color,
    d: "M9.481 12.667h.815c0 .2.148.333.37.333.223 0 .445-.2.445-.333C11.11 12 10.37 12 10 12c-.37 0-1.111 0-1.111.667 0 .2.148.333.37.333.074 0 .222-.133.222-.333ZM12.868 13c.22 0 .368-.133.368-.333H14.043c0 .2.147.333.368.333.22 0 .367-.133.367-.333 0-.667-.735-.667-1.102-.667-.367 0-1.101 0-1.101.667-.074.133.073.333.293.333Z"
  }), student_jsx("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.9,
    d: "M20 3.75 16.16 5.5 12 4.5l-4 .875L4 3.75 12 .5l8 3.25Z"
  }), student_jsx("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeWidth: 0.8,
    d: "M17.715 7.5C17.715 5.843 14.603 5 12 5c-2.602 0-5.714.843-5.714 2.5"
  }), student_jsx("path", {
    stroke: color,
    strokeLinecap: "square",
    strokeWidth: 0.4,
    d: "M19.429 3.5v2.9"
  }), student_jsx("path", {
    fill: color,
    d: "M19.24 6.57a.2.2 0 0 1 .38 0l.722 2.167a.2.2 0 0 1-.19.263h-1.444a.2.2 0 0 1-.19-.263l.722-2.168Z"
  }));
};
/* harmony default export */ var student = (Student);
;// CONCATENATED MODULE: ../shared/src/svg/female-resident-landlord.js


var female_resident_landlord_excluded = ["color", "fillColor"];
var female_resident_landlord_jsx = react.createElement;

var FemaleResidentLandlord = function FemaleResidentLandlord(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#224251' : _ref$color,
    _ref$fillColor = _ref.fillColor,
    fillColor = _ref$fillColor === void 0 ? '#fff' : _ref$fillColor,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, female_resident_landlord_excluded);
  return female_resident_landlord_jsx("svg", (0,esm_extends/* default */.Z)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), female_resident_landlord_jsx("g", {
    clipPath: "url(#a)"
  }, female_resident_landlord_jsx("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m18.338 4.7.002-.005m-2.468-1.337 2.222-1.455a1.5 1.5 0 0 1 2.076.433l1.067 1.63a1.501 1.501 0 0 1-.432 2.076l-.186.122 2.648 4.044c.135.205.192.45.164.694l-.015.09-.125.598a.521.521 0 0 1-.556.413l-.06-.01-.598-.124a1.043 1.043 0 0 1-.606-.375l-.053-.074-.168-.256.213-1.02-1.02-.213.212-1.02-1.02-.213-.866-1.323-.186.122a1.5 1.5 0 0 1-2.076-.433l-1.068-1.63a1.497 1.497 0 0 1 .433-2.076ZM7.533 17.401c-3.2.55-6.66.437-6.66 3.585v2.459H18v-2.46c0-3.148-3.687-3.014-7.004-3.584M9.07 18.158l-.007 5.288"
  }), female_resident_landlord_jsx("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M11.298 20.046a.376.376 0 0 0-.373.378c0 .208.167.377.373.377.205 0 .372-.169.372-.377a.376.376 0 0 0-.372-.378ZM7.192 20.076a.376.376 0 0 0-.373.378c0 .209.167.378.373.378.205 0 .372-.17.372-.378a.376.376 0 0 0-.372-.378ZM11.298 21.556a.376.376 0 0 0-.373.378c0 .208.167.377.373.377.205 0 .372-.169.372-.377a.376.376 0 0 0-.372-.378ZM7.192 21.554a.376.376 0 0 0-.373.378c0 .208.167.378.373.378.205 0 .372-.17.372-.378a.376.376 0 0 0-.372-.378Z",
    clipRule: "evenodd"
  }), female_resident_landlord_jsx("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12.877 14.585c0 1.93 3.582 3.089 4.75.386-3.503 0-.779-11.97-8.564-8.108C1.278 3.002 4.003 14.97.5 14.97c1.168 2.703 4.757 1.544 4.757-.386"
  }), female_resident_landlord_jsx("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.134 18.183c1.142-.386 3.425-1.544 3.806-3.86 1.142 0 1.142-2.318 0-2.318l-.38-1.544c-3.045 0-3.045-1.158-3.426-1.544-.38.386-.38 1.544-3.425 1.544l-.38 1.544c-1.143 0-1.143 2.317 0 2.317.38 2.317 2.663 3.475 3.805 3.861v0Z",
    clipRule: "evenodd"
  }), female_resident_landlord_jsx("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.854 12.123c0-.427.34-.386.761-.386s.762-.04.762.386M9.634 12.123c0-.427.34-.386.761-.386s.762-.04.762.386"
  })), female_resident_landlord_jsx("defs", null, female_resident_landlord_jsx("clipPath", {
    id: "a"
  }, female_resident_landlord_jsx("path", {
    fill: fillColor,
    d: "M0 0h24v24H0z"
  }))));
};
/* harmony default export */ var female_resident_landlord = (FemaleResidentLandlord);
;// CONCATENATED MODULE: ../shared/src/svg/male-resident-landlord.js


var male_resident_landlord_excluded = ["color"];
var male_resident_landlord_jsx = react.createElement;

var MaleResidentLandlord = function MaleResidentLandlord(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#224251' : _ref$color,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, male_resident_landlord_excluded);
  return male_resident_landlord_jsx("svg", (0,esm_extends/* default */.Z)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), male_resident_landlord_jsx("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.79 17.198c-3.263.56-6.79.445-6.79 3.654v2.507h17.459v-2.507c0-3.21-3.76-3.073-7.14-3.654M9.355 17.97l-.006 5.39"
  }), male_resident_landlord_jsx("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.421 17.995c1.164-.393 3.492-1.574 3.88-3.935 1.164 0 1.164-2.362 0-2.362l-.904-2.06H6.451l-.91 2.06c-1.164 0-1.164 2.362 0 2.362.388 2.361 2.716 3.542 3.88 3.935Z",
    clipRule: "evenodd"
  }), male_resident_landlord_jsx("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.097 11.818c0-.435.347-.393.776-.393.43 0 .776-.042.776.393M9.93 11.818c0-.435.348-.393.777-.393.429 0 .776-.042.776.393"
  }), male_resident_landlord_jsx("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M11.627 19.549c-.21 0-.38.173-.38.385 0 .212.17.385.38.385s.38-.173.38-.385a.383.383 0 0 0-.38-.385ZM7.441 19.58c-.21 0-.38.173-.38.385 0 .212.17.385.38.385s.38-.173.38-.385a.383.383 0 0 0-.38-.385ZM11.627 21.088c-.21 0-.38.173-.38.385 0 .213.17.385.38.385s.38-.172.38-.385a.383.383 0 0 0-.38-.385ZM7.441 21.086c-.21 0-.38.173-.38.385 0 .213.17.385.38.385s.38-.172.38-.385a.383.383 0 0 0-.38-.385Z",
    clipRule: "evenodd"
  }), male_resident_landlord_jsx("path", {
    stroke: color,
    d: "M5.494 11.62s-.7-.613-.498-1.853c.6-3.668 8.567-3.71 8.874 0 .087 1.051-.482 1.853-.482 1.853"
  }), male_resident_landlord_jsx("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m17.338 4.7.002-.005m-2.468-1.337 2.222-1.455a1.5 1.5 0 0 1 2.076.433l1.067 1.63a1.501 1.501 0 0 1-.432 2.076l-.186.122 2.648 4.044c.135.205.192.45.164.694l-.015.09-.125.598a.521.521 0 0 1-.556.413l-.06-.01-.598-.124a1.043 1.043 0 0 1-.606-.375l-.053-.074-.168-.256.213-1.02-1.02-.213.212-1.02-1.02-.213-.866-1.323-.186.122a1.5 1.5 0 0 1-2.076-.433l-1.068-1.63a1.497 1.497 0 0 1 .433-2.076Z"
  }));
};
/* harmony default export */ var male_resident_landlord = (MaleResidentLandlord);
;// CONCATENATED MODULE: ./src/utils/transformers/translations/index.js


















var DATE_FORMAT = 'MMM yyyy';
var describeLivingWith = function describeLivingWith(_ref) {
  var _Object$values;

  var t = _ref.t,
      numberOfRoommates = _ref.numberOfRoommates,
      propertyGenderRestriction = _ref.propertyGenderRestriction,
      landlordResident = _ref.landlordResident;
  var roommates = numberOfRoommates ? [{
    translation: t("Up to {{count}} ".concat(numberOfRoommates > 2 ? 'roommates' : 'roommate'), {
      count: numberOfRoommates - 1
    }),
    icon: shared_bedroom/* default */.Z
  }] : [];
  var gender = handleGenderRestrictions(t, propertyGenderRestriction, landlordResident === null || landlordResident === void 0 ? void 0 : landlordResident.gender);
  var landlord = [].concat((0,toConsumableArray/* default */.Z)(landlordResident && Object.values(landlordResident).length && (_Object$values = Object.values(landlordResident)) !== null && _Object$values !== void 0 && _Object$values.every(function (key) {
    return key;
  }) ? [{
    translation: t('Resident landlord'),
    icon: landlordResident.gender === 'F' ? female_resident_landlord : male_resident_landlord
  }] : []), (0,toConsumableArray/* default */.Z)((landlordResident === null || landlordResident === void 0 ? void 0 : landlordResident.family) === 'yes' ? [{
    translation: t('Landlord lives with family'),
    icon: lives_with_family
  }] : []), (0,toConsumableArray/* default */.Z)((landlordResident === null || landlordResident === void 0 ? void 0 : landlordResident.pets) === 'yes' ? [{
    translation: t('Landlord has pets'),
    icon: pet
  }] : []));
  return [].concat(roommates, (0,toConsumableArray/* default */.Z)(gender), (0,toConsumableArray/* default */.Z)(landlord));
};
var describeLandlordStats = function describeLandlordStats(_ref2) {
  var t = _ref2.t,
      language = _ref2.language,
      ageRange = _ref2.ageRange,
      family = _ref2.family,
      gender = _ref2.gender,
      pets = _ref2.pets,
      confirmedBookings = _ref2.confirmedBookings,
      responseRate = _ref2.responseRate,
      responseTime = _ref2.responseTime,
      createdAt = _ref2.createdAt,
      isRentByProperty = _ref2.isRentByProperty,
      occupation = _ref2.occupation;
  return [{
    icon: gender === 'F' ? female_resident_landlord : male_resident_landlord,
    text: "".concat(t(GENDERS[gender])).concat(translations/* LANDLORD_RESIDENT_AGE_RANGE_TRANSLATIONS */.UE[ageRange] ? ", ".concat(translations/* LANDLORD_RESIDENT_AGE_RANGE_TRANSLATIONS */.UE[ageRange], " ").concat(t('years old')) : ''),
    condition: !!(gender && ageRange) && !isRentByProperty
  }, {
    icon: pet,
    text: t('Has pets'),
    condition: pets === 'yes' && !isRentByProperty
  }, {
    icon: lives_with_family,
    text: t('Lives with family'),
    condition: family === 'yes' && !isRentByProperty
  }, {
    icon: occupation === 'professional-worker' ? professional : student,
    text: t(translations/* LANDLORD_OCCUPATION_TRANSLATIONS */.HB[occupation]),
    condition: !!occupation && occupation !== 'unknown' && !isRentByProperty
  }, {
    icon: users,
    text: "".concat(t('Hosted'), " ").concat(confirmedBookings, " ").concat(confirmedBookings > 1 ? t('people') : t('person')),
    condition: confirmedBookings > 3
  }, {
    icon: mail,
    text: "".concat(t('Response rate'), " ").concat(responseRate, "%"),
    condition: responseRate > 60
  }, {
    icon: time,
    text: "".concat(t('Usually replies in'), " ").concat(Math.ceil(responseTime), " ").concat(Math.ceil(responseTime) > 1 ? t('hours') : t('hour')),
    condition: responseTime && responseTime < 24
  }, {
    icon: registered,
    text: "".concat(t('Joined'), " ").concat((0,utils/* formatDate */.p6)(new Date(createdAt), language, DATE_FORMAT)),
    condition: true
  }];
};
var handleGenderRestrictions = function handleGenderRestrictions(t, genderRestriction, landlordResidentGender, offerLevel, isRentByProperty) {
  if (genderRestriction !== null && genderRestriction !== void 0 && genderRestriction.includes('males') && (landlordResidentGender !== 'M' || offerLevel)) {
    var offerGenderTranslation = isRentByProperty ? t('Females only') : t('Female only room');
    return [{
      translation: offerLevel ? offerGenderTranslation : t('Females'),
      icon: female_gender
    }];
  }

  if (genderRestriction !== null && genderRestriction !== void 0 && genderRestriction.includes('females') && (landlordResidentGender !== 'F' || offerLevel)) {
    var _offerGenderTranslation = isRentByProperty ? t('Males only') : t('Male only room');

    return [{
      translation: offerLevel ? _offerGenderTranslation : t('Males'),
      icon: male_gender
    }];
  }

  return offerLevel ? [] : [{
    translation: t('Mixed gender'),
    icon: mixed_gender
  }];
};
// EXTERNAL MODULE: ../shared/src/index.js
var src = __webpack_require__(67824);
// EXTERNAL MODULE: ../shared/src/utils/property/index.js
var utils_property = __webpack_require__(60637);
// EXTERNAL MODULE: ../shared/src/constants/rentType.js
var rentType = __webpack_require__(68298);
;// CONCATENATED MODULE: ./src/components/Landlord/index.js
var Landlord_jsx = react.createElement;














var Landlord = function Landlord(_ref) {
  var createdAt = _ref.createdAt,
      ageRange = _ref.ageRange,
      family = _ref.family,
      gender = _ref.gender,
      pets = _ref.pets,
      occupation = _ref.occupation,
      confirmedBookings = _ref.confirmedBookings,
      responseRate = _ref.responseRate,
      responseTime = _ref.responseTime,
      isTrusted = _ref.isTrusted,
      isKeyAccount = _ref.isKeyAccount,
      recommendations = _ref.recommendations,
      isRentByProperty = _ref.isRentByProperty,
      trackMoreListingsAction = _ref.trackMoreListingsAction;

  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t,
      language = _useTranslation.i18n.language;

  var safeCreatedAt = (0,react.useMemo)(function () {
    try {
      if (!createdAt) {
        return null;
      }

      var parsedDate = (0,parseISO/* default */.Z)(createdAt);

      if (!(0,isValid/* default */.Z)(parsedDate)) {
        return null;
      } // eslint-disable-next-line quotes


      return (0,format/* default */.Z)(parsedDate, "yyyy-MM-dd'T'HH:mm:ss.SSSxxx");
    } catch (error) {
      return null;
    }
  }, [createdAt]);
  var stats = describeLandlordStats({
    t: t,
    language: language,
    ageRange: ageRange,
    family: family,
    gender: gender,
    pets: pets,
    confirmedBookings: confirmedBookings,
    responseRate: responseRate,
    responseTime: responseTime,
    createdAt: safeCreatedAt,
    isRentByProperty: isRentByProperty,
    occupation: occupation
  });
  return Landlord_jsx(Landlord_styles_Wrapper, {
    id: "Landlord"
  }, Landlord_jsx(styles_Title, null, Landlord_jsx("h2", null, t('Landlord')), Landlord_jsx("span", null, isTrusted && Landlord_jsx(src/* Tooltip */.u, null, Landlord_jsx(Unisystem_Pill, {
    Icon: exclamation/* default */.Z,
    label: t('Trusted Landlord'),
    isGreen: true
  }), Landlord_jsx("p", null, t('A trusted landlord has had at least one successful booking.'))), isKeyAccount && Landlord_jsx(src/* Tooltip */.u, null, Landlord_jsx(Unisystem_Pill, {
    Icon: exclamation/* default */.Z,
    label: t('Professional'),
    isUniBlue: true
  }), Landlord_jsx("p", null, t('A professional landlord operates as a business, and manages a large number of properties. Many of these properties are usually student residences or apartments with lots of bedrooms. You can check the type of place at the top of this listing.'))))), Landlord_jsx(LandlordStats, null, stats.map(function (_ref2) {
    var Icon = _ref2.icon,
        text = _ref2.text,
        condition = _ref2.condition;
    return condition ? Landlord_jsx("div", {
      key: text
    }, Landlord_jsx(Icon, null), Landlord_jsx("p", null, text)) : null;
  })), recommendations !== null && recommendations !== void 0 && recommendations.data.length ? Landlord_jsx(components_MoreListings, {
    title: "More listings by this landlord",
    recommendations: recommendations,
    cardWidth: 224,
    cardGap: 16,
    trackListing: trackMoreListingsAction
  }) : null);
};

var Landlord_mapStateToProps = function mapStateToProps(_ref3) {
  var _ref3$offer = _ref3.offer,
      _ref3$offer$offerAggr = _ref3$offer.offerAggregate,
      _ref3$offer$offerAggr2 = _ref3$offer$offerAggr.accommodation_offer;
  _ref3$offer$offerAggr2 = _ref3$offer$offerAggr2 === void 0 ? {} : _ref3$offer$offerAggr2;
  var unitType = _ref3$offer$offerAggr2.property.unit_type,
      _ref3$offer$offerAggr3 = _ref3$offer$offerAggr.property_aggregate.property,
      lifecycle = _ref3$offer$offerAggr3.lifecycle,
      typology = _ref3$offer$offerAggr3.typology,
      _ref3$offer$offerAggr4 = _ref3$offer$offerAggr3.landlord_resident;
  _ref3$offer$offerAggr4 = _ref3$offer$offerAggr4 === void 0 ? {} : _ref3$offer$offerAggr4;
  var ageRange = _ref3$offer$offerAggr4.age_range,
      family = _ref3$offer$offerAggr4.family,
      gender = _ref3$offer$offerAggr4.gender,
      pets = _ref3$offer$offerAggr4.pets,
      occupation = _ref3$offer$offerAggr4.occupation,
      _ref3$offer$offerAggr5 = _ref3$offer$offerAggr.accommodation_provider,
      _ref3$offer$offerAggr6 = _ref3$offer$offerAggr5.stats,
      confirmedBookings = _ref3$offer$offerAggr6.bookings.confirmed.total,
      responseRate = _ref3$offer$offerAggr6.response_rate,
      responseTime = _ref3$offer$offerAggr6.response_time,
      createdAt = _ref3$offer$offerAggr5.created.at,
      isTrusted = _ref3$offer$offerAggr5.verifications.trusted,
      isKeyAccount = _ref3$offer$offerAggr5.account_management.key_account,
      _ref3$offer$recommend = _ref3$offer.recommendations;
  _ref3$offer$recommend = _ref3$offer$recommend === void 0 ? {} : _ref3$offer$recommend;
  var recommendations = _ref3$offer$recommend.byAccommodationProvider;
  return {
    createdAt: createdAt,
    ageRange: ageRange,
    family: family,
    gender: gender,
    pets: pets,
    occupation: occupation,
    confirmedBookings: confirmedBookings,
    responseRate: responseRate,
    responseTime: responseTime,
    isTrusted: isTrusted,
    isKeyAccount: isKeyAccount,
    recommendations: recommendations,
    isRentByProperty: (0,utils_property/* getPropertyRentBy */.f)({
      unitType: unitType,
      lifecycle: lifecycle,
      typology: typology
    }) === rentType/* RENT_TYPE.ENTIRE_PROPERTY */.u.ENTIRE_PROPERTY
  };
};

var Landlord_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    trackMoreListingsAction: function trackMoreListingsAction() {
      return dispatch((0,actions_tracking/* trackMoreListings */.Mt)());
    }
  };
};

/* harmony default export */ var components_Landlord = ((0,es/* connect */.$j)(Landlord_mapStateToProps, Landlord_mapDispatchToProps)(Landlord));
;// CONCATENATED MODULE: ./src/components/Overview/styles.js


var Overview_styles_templateObject;



var Overview_styles_Wrapper = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-zi3ilj-0"
})(["display:flex;flex-direction:column;", " width:100%;", ""], function (_ref) {
  var theme = _ref.theme;
  return theme.gap(10, 'column');
}, theme/* mediaMin.mediumBreakpoint */.A3.mediumBreakpoint(Overview_styles_templateObject || (Overview_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n    ", "\n  "])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.gap(6, 'column');
}));
// EXTERNAL MODULE: ../shared/src/components/Unisystem/Button/index.js + 1 modules
var Button = __webpack_require__(99964);
;// CONCATENATED MODULE: ./src/components/Overview/YourSpace/styles.js


var YourSpace_styles_templateObject;





var YourSpace_styles_Wrapper = /*#__PURE__*/styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  componentId: "sc-jd78bw-0"
})(["display:flex;flex-direction:column;", ""], function (_ref) {
  var theme = _ref.theme;
  return theme.gap(6, 'column');
});
var YourSpace_styles_Title = /*#__PURE__*/styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  componentId: "sc-jd78bw-1"
})(["display:flex;", " align-items:flex-start;flex-wrap:wrap;h2{font-family:'IntervalNextReg';font-size:", ";font-weight:600;line-height:", ";color:", ";}", "{font-size:", ";line-height:", ";color:", ";padding:", " ", ";height:32px;svg{path{fill:", ";}}}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.gap(3);
}, function (props) {
  return props.theme.rem(22);
}, function (props) {
  return props.theme.rem(26);
}, function (props) {
  return props.theme.overview.yourSpace.title.color;
}, Pill_styles_Wrapper, function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.rem(18);
}, function (props) {
  return props.theme.landlordSection.pill.textColor;
}, function (props) {
  return props.theme.space(2);
}, function (props) {
  return props.theme.space(3);
}, function (props) {
  return props.theme.landlordSection.pill.textColor;
});
var Features = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-jd78bw-2"
})(["display:flex;flex-wrap:wrap;", ""], function (_ref3) {
  var theme = _ref3.theme;
  return theme.gap(4);
});
var Feature = /*#__PURE__*/styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  componentId: "sc-jd78bw-3"
})(["display:flex;", " align-items:center;color:", ";svg{width:24px;height:24px;}"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.gap(2);
}, function (props) {
  return props.theme.overview.yourSpace.features.color;
});
var SpaceInfo = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-jd78bw-4"
})(["display:flex;align-items:center;", ""], function (_ref5) {
  var theme = _ref5.theme;
  return theme.gap(6);
});
var SpaceInfoRight = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-jd78bw-5"
})(["display:flex;flex-direction:column;", ""], function (_ref6) {
  var theme = _ref6.theme;
  return theme.gap(2, 'column');
});
var SpaceInfoTitle = /*#__PURE__*/styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  componentId: "sc-jd78bw-6"
})(["font-size:", ";line-height:", ";font-weight:400;color:", ";span{font-weight:600;}"], function (props) {
  return props.theme.rem(16);
}, function (props) {
  return props.theme.rem(16);
}, function (props) {
  return props.theme.overview.yourSpace.spaceInfo.title.color;
});
var SpaceInfoDescription = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-jd78bw-7"
})(["display:flex;flex-direction:column;font-size:", ";line-height:", ";color:", ";", " span{font-weight:600;}"], function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.rem(18);
}, function (props) {
  return props.theme.overview.yourSpace.spaceInfo.description.color;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.gap(1, 'column');
});
var SeeAllFeaturesButton = /*#__PURE__*/(0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
  componentId: "sc-jd78bw-8"
})(["width:fit-content;", ""], theme/* mediaMin.smallBreakpoint */.A3.smallBreakpoint(YourSpace_styles_templateObject || (YourSpace_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n    width: 100%;\n  "]))));
;// CONCATENATED MODULE: ../shared/src/svg/hamburger.js

var hamburger_jsx = react.createElement;

var Hamburger = function Hamburger(props) {
  return hamburger_jsx("svg", (0,esm_extends/* default */.Z)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), hamburger_jsx("path", {
    stroke: "#224251",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M19.48 6H4.52M19.48 12H4.52M19.48 18H4.52"
  }));
};
/* harmony default export */ var hamburger = (Hamburger);
// EXTERNAL MODULE: ../shared/src/constants/unitTypes.js
var unitTypes = __webpack_require__(11921);
// EXTERNAL MODULE: ../shared/src/utils/unitTypes/index.js
var utils_unitTypes = __webpack_require__(4204);
// EXTERNAL MODULE: ../shared/src/utils/transformers/property.js + 6 modules
var transformers_property = __webpack_require__(77741);
// EXTERNAL MODULE: ../shared/src/components/ReadMoreInline/index.js + 1 modules
var ReadMoreInline = __webpack_require__(61492);
// EXTERNAL MODULE: ../shared/src/svg/apartment.js
var apartment = __webpack_require__(83856);
// EXTERNAL MODULE: ../shared/src/svg/studio.js
var studio = __webpack_require__(55562);
;// CONCATENATED MODULE: ./src/components/Overview/EnergyCertification/styles.js

var EnergyCertification_styles_Wrapper = /*#__PURE__*/styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  componentId: "sc-1y00r0v-0"
})(["display:flex;flex-direction:column;gap:", ";margin-bottom:", ";"], function (props) {
  return props.theme.space(5);
}, function (props) {
  return props.theme.space(2);
});
var EnergyCertification_styles_Title = /*#__PURE__*/styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  componentId: "sc-1y00r0v-1"
})(["font-size:", ";line-height:", ";font-weight:600;color:", ";"], function (props) {
  return props.theme.rem(18);
}, function (props) {
  return props.theme.rem(20);
}, function (props) {
  return props.theme.overview.energyCertification.text.color;
});
var CertificationsWrapper = /*#__PURE__*/styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  componentId: "sc-1y00r0v-2"
})(["display:flex;flex-direction:column;gap:", ";"], function (props) {
  return props.theme.space(2);
});
var Row = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1y00r0v-3"
})(["display:flex;align-items:center;column-gap:", ";"], function (props) {
  return props.theme.space(2);
});
var Text = /*#__PURE__*/styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  componentId: "sc-1y00r0v-4"
})(["font-size:", ";line-height:", ";color:", ";"], function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.rem(18);
}, function (props) {
  return props.theme.overview.energyCertification.text.color;
});
var SeeEnergyCertificationLink = /*#__PURE__*/styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  componentId: "sc-1y00r0v-5"
})(["background:none;border:none;text-align:left;width:fit-content;font-size:", ";text-decoration:underline;color:", ";"], function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.links.color;
});
// EXTERNAL MODULE: ../shared/src/components/EnergyCertificationLabel/index.js + 1 modules
var EnergyCertificationLabel = __webpack_require__(93650);
// EXTERNAL MODULE: ../shared/src/constants/energyCertificationLabelSizes.js
var energyCertificationLabelSizes = __webpack_require__(27179);
;// CONCATENATED MODULE: ./src/components/Overview/EnergyCertification/index.js

var EnergyCertification_excluded = ["showEnergyCertificationModal"];
var EnergyCertification_jsx = react.createElement;








var small = energyCertificationLabelSizes/* ENERGY_CERTIFICATION_LABEL_SIZES.small */.U.small;

var EnergyCertification = function EnergyCertification(_ref) {
  var showEnergyCertificationModal = _ref.showEnergyCertificationModal,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, EnergyCertification_excluded);

  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var energyCertificateGrade = props.energyCertificateGrade,
      emissionsCertificateGrade = props.emissionsCertificateGrade;

  if (!energyCertificateGrade && !emissionsCertificateGrade) {
    return null;
  }

  return EnergyCertification_jsx(EnergyCertification_styles_Wrapper, null, EnergyCertification_jsx(EnergyCertification_styles_Title, null, t('Energy Certification')), EnergyCertification_jsx(CertificationsWrapper, null, energyCertificateGrade && EnergyCertification_jsx(EnergyCertificate, props), emissionsCertificateGrade && EnergyCertification_jsx(EmissionsCertificate, props), EnergyCertification_jsx(SeeEnergyCertificationLink, {
    onClick: function onClick() {
      return showEnergyCertificationModal(props);
    }
  }, t('See energy certification'))));
};

var EnergyCertificate = function EnergyCertificate(_ref2) {
  var energyCertificateGrade = _ref2.energyCertificateGrade,
      yearlyEnergyConsumption = _ref2.yearlyEnergyConsumption;

  var _useTranslation2 = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation2.t;

  return EnergyCertification_jsx(Row, null, EnergyCertification_jsx(EnergyCertificationLabel/* default */.Z, {
    grade: energyCertificateGrade,
    size: small
  }), yearlyEnergyConsumption ? EnergyCertification_jsx(Text, null, t('Consumption'), ": ", t('{{yearlyEnergyConsumption}} kWh/m² year', {
    yearlyEnergyConsumption: yearlyEnergyConsumption
  })) : EnergyCertification_jsx(Text, null, t('Consumption')));
};

var EmissionsCertificate = function EmissionsCertificate(_ref3) {
  var emissionsCertificateGrade = _ref3.emissionsCertificateGrade,
      yearlyEmissions = _ref3.yearlyEmissions;

  var _useTranslation3 = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation3.t;

  return EnergyCertification_jsx(Row, null, EnergyCertification_jsx(EnergyCertificationLabel/* default */.Z, {
    grade: emissionsCertificateGrade,
    size: small
  }), yearlyEmissions ? EnergyCertification_jsx(Text, null, t('Emissions'), ": ", t('{{yearlyEmissions}} kg CO2/m² year', {
    yearlyEmissions: yearlyEmissions
  })) : EnergyCertification_jsx(Text, null, t('Emissions')));
};

var EnergyCertification_mapStateToProps = function mapStateToProps(_ref4) {
  var _property$documentati;

  var property = _ref4.offer.offerAggregate.property_aggregate.property;

  var _ref5 = (property === null || property === void 0 ? void 0 : (_property$documentati = property.documentation) === null || _property$documentati === void 0 ? void 0 : _property$documentati.energy_certification) || {},
      energy_certificate = _ref5.energy_certificate,
      yearly_energy_consumption = _ref5.yearly_energy_consumption,
      emissions_certificate = _ref5.emissions_certificate,
      yearly_emissions = _ref5.yearly_emissions;

  return {
    energyCertificateGrade: energy_certificate,
    yearlyEnergyConsumption: yearly_energy_consumption,
    emissionsCertificateGrade: emissions_certificate,
    yearlyEmissions: yearly_emissions
  };
};

var EnergyCertification_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    showEnergyCertificationModal: function showEnergyCertificationModal(_ref6) {
      var energyCertificateGrade = _ref6.energyCertificateGrade,
          yearlyEnergyConsumption = _ref6.yearlyEnergyConsumption,
          emissionsCertificateGrade = _ref6.emissionsCertificateGrade,
          yearlyEmissions = _ref6.yearlyEmissions;
      return dispatch((0,modal/* showModalAction */.bF)({
        modalId: modal_displayer.modalIds.ENERGY_CERTIFICATION,
        energyCertificateGrade: energyCertificateGrade,
        yearlyEnergyConsumption: yearlyEnergyConsumption,
        emissionsCertificateGrade: emissionsCertificateGrade,
        yearlyEmissions: yearlyEmissions
      }));
    }
  };
};

/* harmony default export */ var Overview_EnergyCertification = ((0,es/* connect */.$j)(EnergyCertification_mapStateToProps, EnergyCertification_mapDispatchToProps)(EnergyCertification));
;// CONCATENATED MODULE: ../shared/src/svg/single-bed-bedroom.js


var single_bed_bedroom_excluded = ["color", "outlineColor"];
var single_bed_bedroom_jsx = react.createElement;

var SingleBedBedroom = function SingleBedBedroom(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#66D5FF' : _ref$color,
    _ref$outlineColor = _ref.outlineColor,
    outlineColor = _ref$outlineColor === void 0 ? '#224251' : _ref$outlineColor,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, single_bed_bedroom_excluded);
  return single_bed_bedroom_jsx("svg", (0,esm_extends/* default */.Z)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 46,
    viewBox: "0 0 60 46",
    fill: "none"
  }, props), single_bed_bedroom_jsx("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M57.23 14.765h-4.622a4.475 4.475 0 0 0-.439-.504 4.682 4.682 0 0 0-3.265-1.342h-2.73c-1.22 0-2.413.492-3.274 1.354a3.968 3.968 0 0 0-.423.492h-5.554V12.92h.923a2.768 2.768 0 0 0 2.723-3.277l-1.384-7.384A2.773 2.773 0 0 0 36.46 0h-4.615c-1.33 0-2.477.95-2.723 2.258l-1.385 7.384a2.768 2.768 0 0 0 2.724 3.277h.923v1.846h-2.77c-.492 0-.957.131-1.361.358a2.763 2.763 0 0 0-4.392-.358H10.368a2.763 2.763 0 0 0-2.061-.923 2.772 2.772 0 0 0-2.77 2.77v2.769c0 .723.281 1.377.735 1.869a5.587 5.587 0 0 0-.608 1.573 5.54 5.54 0 0 0-2.2 2.185 2.763 2.763 0 0 0-.696-.093A2.772 2.772 0 0 0 0 27.685v14.769a2.772 2.772 0 0 0 2.77 2.77c1.203 0 2.23-.774 2.61-1.847h22.47a2.776 2.776 0 0 0 2.611 1.846 2.772 2.772 0 0 0 2.77-2.77v-9.23h3.811a2.77 2.77 0 0 0 4.996.661c.5.716 1.331 1.185 2.27 1.185a2.772 2.772 0 0 0 2.769-2.769v-4.615H48V32.3a2.77 2.77 0 0 0 5.077 1.53 2.77 2.77 0 0 0 5.077-1.53V20.142A2.776 2.776 0 0 0 60 17.531a2.772 2.772 0 0 0-2.77-2.77v.004ZM36.924 27.69h-3.692c0-.712-.27-1.354-.712-1.847a2.746 2.746 0 0 0 .712-1.846v-3.692h3.692v7.385Z",
    clipRule: "evenodd"
  }), single_bed_bedroom_jsx("path", {
    fill: color,
    d: "M30.462 32.765H5.077v7.846h25.385v-7.846ZM24.923 17.535H8.308v4.615h16.615v-4.615ZM39.692 17.996h-9.23v13.385h9.23V17.996Z"
  }), single_bed_bedroom_jsx("path", {
    fill: outlineColor,
    d: "M5.538 28.612a.92.92 0 0 0 .923-.923c0-1.02.827-1.847 1.847-1.847h16.615c1.02 0 1.846.827 1.846 1.847a.92.92 0 0 0 .923.923.92.92 0 0 0 .923-.923 3.696 3.696 0 0 0-2.78-3.574c.003-.038.011-.076.011-.119a3.694 3.694 0 0 0-3.692-3.692H11.077a3.694 3.694 0 0 0-3.693 3.692c0 .043.008.081.012.12a3.696 3.696 0 0 0-2.78 3.573.92.92 0 0 0 .922.923Zm4.239-5.923a1.836 1.836 0 0 1 1.3-.539h11.077c.488 0 .961.196 1.307.546.343.339.539.816.539 1.3H9.23c0-.488.197-.961.547-1.307Z"
  }), single_bed_bedroom_jsx("path", {
    fill: outlineColor,
    d: "M30.462 26.765a.92.92 0 0 0-.924.924v1.846H3.692v-1.846a.92.92 0 0 0-.923-.924.92.92 0 0 0-.923.924v14.769a.92.92 0 0 0 .923.923.92.92 0 0 0 .923-.923v-.923h25.846v.923a.92.92 0 0 0 .924.923.92.92 0 0 0 .923-.923v-14.77a.921.921 0 0 0-.923-.923Zm-26.77 4.616h25.846v8.307H3.692v-8.307ZM8.308 20.304a.92.92 0 0 0 .923-.923v-.923H24v.923c0 .511.41.923.922.923a.92.92 0 0 0 .923-.923v-2.77a.92.92 0 0 0-.923-.923.92.92 0 0 0-.923.924H9.23a.92.92 0 0 0-.922-.923.92.92 0 0 0-.923.923v2.769a.92.92 0 0 0 .923.923ZM36.923 21.227a.923.923 0 1 0 0-1.846.923.923 0 0 0 0 1.846ZM30.462 11.073h2.769v3.692a.92.92 0 0 0 .923.923.92.92 0 0 0 .923-.923v-3.692h2.77a.92.92 0 0 0 .908-1.096l-1.386-7.385a.924.924 0 0 0-.907-.754h-4.616a.92.92 0 0 0-.907.754l-1.385 7.385c-.05.27.023.55.196.761a.919.919 0 0 0 .712.335Zm2.15-7.385h3.084l1.039 5.539h-5.162l1.039-5.539Z"
  }), single_bed_bedroom_jsx("path", {
    fill: outlineColor,
    d: "M57.23 16.612h-5.703a2.8 2.8 0 0 0-.654-1.035 2.826 2.826 0 0 0-1.97-.812h-2.73a2.8 2.8 0 0 0-1.97.816 2.794 2.794 0 0 0-.65 1.03H28.617a.92.92 0 0 0-.924.924.92.92 0 0 0 .924.923h.922v5.538c0 .512.412.923.924.923a.92.92 0 0 0 .923-.923v-5.538h7.384v11.077h-5.538a.92.92 0 0 0-.923.923.92.92 0 0 0 .923.923h5.538v1.038a.92.92 0 0 0 .923.923.921.921 0 0 0 .923-.923V18.458h2.77v13.846a.92.92 0 0 0 .923.923.92.92 0 0 0 .923-.923v-6.462h4.615v6.462c0 .511.412.923.923.923a.921.921 0 0 0 .923-.923V18.458h2.77v13.846c0 .511.411.923.923.923a.921.921 0 0 0 .923-.923V18.458h.923a.92.92 0 0 0 .923-.923.92.92 0 0 0-.923-.923Zm-12 .942c0-.246.1-.489.282-.665a.944.944 0 0 1 .661-.274h2.73c.247 0 .493.1.67.274a.937.937 0 0 1 .273.665v2.75h-4.615v-2.75Zm0 6.442V22.15h4.616v1.846h-4.615Z"
  }));
};
/* harmony default export */ var single_bed_bedroom = (SingleBedBedroom);
;// CONCATENATED MODULE: ../shared/src/svg/double-bed-bedroom.js


var double_bed_bedroom_excluded = ["color", "outlineColor"];
var double_bed_bedroom_jsx = react.createElement;

var DoubleBedBedroom = function DoubleBedBedroom(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#66D5FF' : _ref$color,
    _ref$outlineColor = _ref.outlineColor,
    outlineColor = _ref$outlineColor === void 0 ? '#224251' : _ref$outlineColor,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, double_bed_bedroom_excluded);
  return double_bed_bedroom_jsx("svg", (0,esm_extends/* default */.Z)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 37,
    viewBox: "0 0 64 37",
    fill: "none"
  }, props), double_bed_bedroom_jsx("path", {
    fill: color,
    d: "M45.445 16.158h-9.23v13.384h9.23V16.158Z"
  }), double_bed_bedroom_jsx("path", {
    fill: outlineColor,
    d: "M42.676 19.389a.923.923 0 1 0 0-1.847.923.923 0 0 0 0 1.846ZM36.215 9.235h2.769v3.692a.92.92 0 0 0 .923.923.92.92 0 0 0 .923-.923V9.235h2.77a.92.92 0 0 0 .908-1.096L43.12.753A.924.924 0 0 0 42.215 0h-4.616a.92.92 0 0 0-.907.754l-1.385 7.384c-.05.27.023.55.196.762a.919.919 0 0 0 .712.335Zm2.15-7.385h3.084l1.039 5.538h-5.162l1.039-5.538Z"
  }), double_bed_bedroom_jsx("path", {
    fill: outlineColor,
    d: "M62.984 14.773H57.28a2.8 2.8 0 0 0-.654-1.035 2.826 2.826 0 0 0-1.97-.811h-2.73a2.8 2.8 0 0 0-1.97.815 2.792 2.792 0 0 0-.65 1.031H34.369a.92.92 0 0 0-.923.923.92.92 0 0 0 .923.923h.923v5.539a.92.92 0 0 0 .924.923.92.92 0 0 0 .923-.923v-5.539h7.384v11.077h-5.538a.92.92 0 0 0-.923.923.92.92 0 0 0 .923.923h5.538v1.039a.92.92 0 0 0 .923.923.92.92 0 0 0 .923-.923V16.619h2.77v13.846a.92.92 0 0 0 .923.923.92.92 0 0 0 .923-.923v-6.461h4.615v6.461a.92.92 0 0 0 .923.923.92.92 0 0 0 .923-.923V16.62h2.77v13.846a.92.92 0 0 0 .923.923.92.92 0 0 0 .923-.923V16.62h.923a.921.921 0 0 0 .923-.923.921.921 0 0 0-.923-.923Zm-12 .942a.944.944 0 0 1 .942-.938h2.73c.247 0 .493.1.67.273a.937.937 0 0 1 .273.665v2.75h-4.615v-2.75Zm0 6.443V20.31h4.615v1.847h-4.615Z"
  }), double_bed_bedroom_jsx("path", {
    fill: "#fff",
    d: "M37 29.409H1v7h36v-7Z"
  }), double_bed_bedroom_jsx("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M16 22.409H8c-1.102 0-2 1.346-2 3h9.997v-3H16ZM31 22.409h-8.8c-1.213 0-2.2 1.346-2.2 3h10.997v-3H31Z",
    clipRule: "evenodd"
  }), double_bed_bedroom_jsx("path", {
    fill: color,
    d: "M37 30H2v5h35v-5Z"
  }), double_bed_bedroom_jsx("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M29 18H8v3.466l8.167-.036.582 2.57h3.502l.582-2.57H29V18Z",
    clipRule: "evenodd"
  }), double_bed_bedroom_jsx("path", {
    fill: outlineColor,
    d: "M2.003 26.224c0 .429.273.776.61.776.337 0 .61-.347.61-.776 0-.858.55-1.557 1.223-1.557h28.111c.674 0 1.223.699 1.223 1.557 0 .429.273.776.61.776.337 0 .61-.347.61-.776 0-1.716-1.098-3.114-2.446-3.114h-.916c0-.824-.263-1.626-.715-2.196-.451-.584-1.081-.914-1.728-.914h-7.334c-1.348 0-2.446 1.398-2.446 3.114h-2.14c0-.824-.262-1.626-.714-2.196-.451-.583-1.081-.914-1.728-.914H7.498c-.647 0-1.277.335-1.725.91-.458.574-.717 1.376-.717 2.2h-.61C3.098 23.114 2 24.512 2 26.228l.003-.004Zm19.861-4.667h7.334c.324 0 .637.167.866.459.226.287.357.686.357 1.098h-9.777c0-.858.55-1.557 1.223-1.557h-.003Zm-15.225.455c.226-.288.54-.455.863-.455h7.334c.324 0 .637.167.866.459.226.287.357.686.357 1.098H6.282c0-.412.131-.81.36-1.102H6.64ZM7.604 16c-.334 0-.604.335-.604.749v1.502c0 .414.27.749.604.749.334 0 .604-.335.604-.749h20.584c0 .414.27.749.604.749.334 0 .604-.335.604-.749v-1.502c0-.414-.27-.749-.604-.749-.334 0-.604.086-.604.5H8.208c0-.414-.27-.5-.604-.5Z"
  }), double_bed_bedroom_jsx("path", {
    fill: outlineColor,
    d: "M36.404 25c-.404 0-1.018-.095-1.018.656v1.973H1.356V25.655C1.355 25 .924 25 .595 25c-.33 0-.596.294-.596.656v10.688c0 .362 0 .656.596.656.475 0 .76 0 .76-.656v-.823H35.5v.823c0 .656.5.656.904.656.33 0 .596-.294.596-.656V25.656c0-.362-.191-.656-.596-.656ZM1.355 29.091H35.5v4.5H1.355v-4.5Z"
  }));
};
/* harmony default export */ var double_bed_bedroom = (DoubleBedBedroom);
;// CONCATENATED MODULE: ../shared/src/svg/twin-bed-bedroom.js


var twin_bed_bedroom_excluded = ["color", "outlineColor"];
var twin_bed_bedroom_jsx = react.createElement;

var TwinBedBedroom = function TwinBedBedroom(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#66D5FF' : _ref$color,
    _ref$outlineColor = _ref.outlineColor,
    outlineColor = _ref$outlineColor === void 0 ? '#224251' : _ref$outlineColor,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, twin_bed_bedroom_excluded);
  return twin_bed_bedroom_jsx("svg", (0,esm_extends/* default */.Z)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83,
    height: 43,
    viewBox: "0 0 83 43",
    fill: "none"
  }, props), twin_bed_bedroom_jsx("path", {
    fill: color,
    d: "M29.462 31.765H4.077v7.846h25.385v-7.846ZM23.923 16.535H7.308v4.615h16.615v-4.615ZM38.692 16.996h-9.23v13.385h9.23V16.996Z"
  }), twin_bed_bedroom_jsx("path", {
    fill: outlineColor,
    d: "M4.538 27.611a.92.92 0 0 0 .923-.923c0-1.019.827-1.846 1.847-1.846h16.615c1.02 0 1.846.827 1.846 1.846a.92.92 0 0 0 .923.924.92.92 0 0 0 .923-.924 3.696 3.696 0 0 0-2.78-3.573c.003-.038.011-.077.011-.119a3.694 3.694 0 0 0-3.692-3.692H10.077a3.694 3.694 0 0 0-3.693 3.692c0 .042.008.08.012.12a3.696 3.696 0 0 0-2.78 3.572.92.92 0 0 0 .922.924Zm4.239-5.923a1.836 1.836 0 0 1 1.3-.538h11.077c.488 0 .961.196 1.307.546.343.339.539.816.539 1.3H8.23c0-.488.197-.961.547-1.308Z"
  }), twin_bed_bedroom_jsx("path", {
    fill: outlineColor,
    d: "M29.462 25.765a.92.92 0 0 0-.924.924v1.846H2.692v-1.846a.92.92 0 0 0-.923-.924.92.92 0 0 0-.923.924v14.769a.92.92 0 0 0 .923.923.92.92 0 0 0 .923-.923v-.923h25.846v.923a.92.92 0 0 0 .924.923.921.921 0 0 0 .923-.923v-14.77a.92.92 0 0 0-.923-.923Zm-26.77 4.616h25.846v8.307H2.692v-8.307ZM7.308 19.304a.92.92 0 0 0 .923-.923v-.923H23v.923c0 .511.41.923.922.923a.92.92 0 0 0 .923-.923v-2.77a.92.92 0 0 0-.923-.923.92.92 0 0 0-.923.924H8.23a.92.92 0 0 0-.922-.924.92.92 0 0 0-.923.924v2.769a.92.92 0 0 0 .923.923Z"
  }), twin_bed_bedroom_jsx("path", {
    fill: color,
    d: "M81.616 31.077H56.23v7.846h25.385v-7.846ZM76.077 15.846H59.46v4.616h16.616v-4.616Z"
  }), twin_bed_bedroom_jsx("path", {
    fill: outlineColor,
    d: "M56.692 26.923a.92.92 0 0 0 .923-.923c0-1.02.827-1.846 1.846-1.846h16.616c1.019 0 1.846.827 1.846 1.846a.92.92 0 0 0 .923.923.92.92 0 0 0 .923-.923 3.696 3.696 0 0 0-2.78-3.573c.003-.039.01-.077.01-.12a3.694 3.694 0 0 0-3.691-3.692H62.23a3.694 3.694 0 0 0-3.693 3.693c0 .042.008.08.012.119A3.696 3.696 0 0 0 55.769 26a.92.92 0 0 0 .923.923ZM60.931 21a1.836 1.836 0 0 1 1.3-.538h11.077c.488 0 .961.196 1.307.546.343.338.539.815.539 1.3h-14.77c0-.489.197-.962.547-1.308Z"
  }), twin_bed_bedroom_jsx("path", {
    fill: outlineColor,
    d: "M81.615 25.077a.92.92 0 0 0-.923.923v1.846H54.846V26a.92.92 0 0 0-.923-.923A.92.92 0 0 0 53 26v14.77a.92.92 0 0 0 .923.922.92.92 0 0 0 .923-.923v-.923h25.846v.923a.92.92 0 0 0 .923.923.92.92 0 0 0 .924-.923V26a.92.92 0 0 0-.924-.923Zm-26.769 4.615h25.846V38H54.846v-8.308ZM59.462 18.615a.92.92 0 0 0 .923-.923v-.923h14.769v.923a.92.92 0 0 0 .923.923.92.92 0 0 0 .923-.923v-2.769a.92.92 0 0 0-.923-.923.92.92 0 0 0-.923.923h-14.77a.92.92 0 0 0-.922-.923.92.92 0 0 0-.923.923v2.77a.92.92 0 0 0 .923.922ZM35.923 20.227a.923.923 0 1 0 0-1.846.923.923 0 0 0 0 1.846ZM29.461 10.073h2.77v3.692a.92.92 0 0 0 .922.923.92.92 0 0 0 .924-.923v-3.692h2.769a.92.92 0 0 0 .908-1.096l-1.385-7.385A.924.924 0 0 0 35.46.84h-4.615a.92.92 0 0 0-.908.753l-1.384 7.385c-.05.27.023.55.196.761a.919.919 0 0 0 .711.335Zm2.15-7.385h3.085l1.038 5.539h-5.161l1.038-5.539Z"
  }), twin_bed_bedroom_jsx("path", {
    fill: outlineColor,
    d: "M56.23 15.611h-5.703a2.8 2.8 0 0 0-.654-1.034 2.826 2.826 0 0 0-1.97-.812h-2.73c-.735 0-1.45.296-1.97.816a2.794 2.794 0 0 0-.65 1.03H27.617a.92.92 0 0 0-.924.924.92.92 0 0 0 .924.923h.922v5.538a.92.92 0 0 0 .924.923.92.92 0 0 0 .923-.923v-5.538h7.384v11.077h-5.538a.92.92 0 0 0-.923.923.92.92 0 0 0 .923.923h5.538v1.038a.92.92 0 0 0 .923.923.92.92 0 0 0 .923-.923V17.458h2.77v13.846a.92.92 0 0 0 .923.923.92.92 0 0 0 .923-.923v-6.462h4.615v6.462a.92.92 0 0 0 .923.923.92.92 0 0 0 .923-.923V17.5H56.5c.511 0 .654-.454.654-.965a.92.92 0 0 0-.923-.924Zm-12 .943c0-.246.1-.489.282-.665a.944.944 0 0 1 .661-.274h2.73c.247 0 .493.1.67.274a.937.937 0 0 1 .273.665v2.75h-4.615v-2.75Zm0 6.442V21.15h4.616v1.846h-4.615Z"
  }), twin_bed_bedroom_jsx("path", {
    fill: outlineColor,
    d: "M53 17h1.9v5.95a.95.95 0 1 1-1.9 0V17Z"
  }));
};
/* harmony default export */ var twin_bed_bedroom = (TwinBedBedroom);
;// CONCATENATED MODULE: ../shared/src/svg/shared-bed-bedroom.js


var shared_bed_bedroom_excluded = ["color", "outlineColor", "secondColor"];
var shared_bed_bedroom_jsx = react.createElement;

var SharedBedBedroom = function SharedBedBedroom(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#66D5FF' : _ref$color,
    _ref$outlineColor = _ref.outlineColor,
    outlineColor = _ref$outlineColor === void 0 ? '#224251' : _ref$outlineColor,
    _ref$secondColor = _ref.secondColor,
    secondColor = _ref$secondColor === void 0 ? '#E4EAED' : _ref$secondColor,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, shared_bed_bedroom_excluded);
  return shared_bed_bedroom_jsx("svg", (0,esm_extends/* default */.Z)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85,
    height: 46,
    viewBox: "0 0 85 46",
    fill: "none"
  }, props), shared_bed_bedroom_jsx("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M57.23 14.765h-4.622a4.475 4.475 0 0 0-.439-.504 4.682 4.682 0 0 0-3.265-1.342h-2.73c-1.22 0-2.413.492-3.274 1.354a3.968 3.968 0 0 0-.423.492h-5.554V12.92h.923a2.768 2.768 0 0 0 2.723-3.277l-1.384-7.384A2.773 2.773 0 0 0 36.46 0h-4.615c-1.33 0-2.477.95-2.723 2.258l-1.385 7.384a2.768 2.768 0 0 0 2.724 3.277h.923v1.846h-2.77c-.492 0-.957.131-1.361.358a2.763 2.763 0 0 0-4.392-.358H10.368a2.763 2.763 0 0 0-2.061-.923 2.772 2.772 0 0 0-2.77 2.77v2.769c0 .723.281 1.377.735 1.869a5.587 5.587 0 0 0-.608 1.573 5.54 5.54 0 0 0-2.2 2.185 2.763 2.763 0 0 0-.696-.093A2.772 2.772 0 0 0 0 27.685v14.769a2.772 2.772 0 0 0 2.77 2.77c1.203 0 2.23-.774 2.61-1.847h22.47a2.776 2.776 0 0 0 2.611 1.846 2.772 2.772 0 0 0 2.77-2.77v-9.23h3.811a2.77 2.77 0 0 0 4.996.661c.5.716 1.331 1.185 2.27 1.185a2.772 2.772 0 0 0 2.769-2.769v-4.615H48V32.3a2.77 2.77 0 0 0 5.077 1.53 2.77 2.77 0 0 0 5.077-1.53V20.142A2.776 2.776 0 0 0 60 17.531a2.772 2.772 0 0 0-2.77-2.77v.004ZM36.924 27.69h-3.692c0-.712-.27-1.354-.712-1.847a2.746 2.746 0 0 0 .712-1.846v-3.692h3.692v7.385Z",
    clipRule: "evenodd"
  }), shared_bed_bedroom_jsx("path", {
    fill: color,
    d: "M30.462 32.765H5.077v7.846h25.385v-7.846ZM24.923 17.535H8.308v4.615h16.615v-4.615ZM39.692 17.996h-9.23v13.385h9.23V17.996Z"
  }), shared_bed_bedroom_jsx("path", {
    fill: outlineColor,
    d: "M5.538 28.611a.92.92 0 0 0 .923-.923c0-1.019.827-1.846 1.847-1.846h16.615c1.02 0 1.846.827 1.846 1.846a.92.92 0 0 0 .923.924.92.92 0 0 0 .923-.924 3.696 3.696 0 0 0-2.78-3.573c.003-.038.011-.077.011-.119a3.694 3.694 0 0 0-3.692-3.692H11.077a3.694 3.694 0 0 0-3.693 3.692c0 .042.008.08.012.12a3.696 3.696 0 0 0-2.78 3.572.92.92 0 0 0 .922.924Zm4.239-5.923a1.836 1.836 0 0 1 1.3-.538h11.077c.488 0 .961.196 1.307.546.343.339.539.816.539 1.3H9.23c0-.488.197-.961.547-1.308Z"
  }), shared_bed_bedroom_jsx("path", {
    fill: outlineColor,
    d: "M30.462 26.765a.92.92 0 0 0-.924.924v1.846H3.692v-1.846a.92.92 0 0 0-.923-.924.92.92 0 0 0-.923.924v14.769a.92.92 0 0 0 .923.923.92.92 0 0 0 .923-.923v-.923h25.846v.923a.92.92 0 0 0 .924.923.921.921 0 0 0 .923-.923v-14.77a.92.92 0 0 0-.923-.923Zm-26.77 4.616h25.846v8.307H3.692v-8.307ZM8.308 20.304a.92.92 0 0 0 .923-.923v-.923H24v.923c0 .511.41.923.922.923a.92.92 0 0 0 .923-.923v-2.77a.92.92 0 0 0-.923-.923.92.92 0 0 0-.923.924H9.23a.92.92 0 0 0-.922-.923.92.92 0 0 0-.923.923v2.769a.92.92 0 0 0 .923.923ZM36.923 21.227a.923.923 0 1 0 0-1.846.923.923 0 0 0 0 1.846ZM30.461 11.073h2.77v3.692a.92.92 0 0 0 .922.923.92.92 0 0 0 .924-.923v-3.692h2.769a.92.92 0 0 0 .908-1.096l-1.385-7.385a.924.924 0 0 0-.908-.754h-4.615a.92.92 0 0 0-.908.754l-1.384 7.385c-.05.27.023.55.196.761a.919.919 0 0 0 .711.335Zm2.15-7.385h3.085l1.038 5.539h-5.161l1.038-5.539Z"
  }), shared_bed_bedroom_jsx("path", {
    fill: outlineColor,
    d: "M57.23 16.611h-5.703a2.8 2.8 0 0 0-.654-1.034 2.826 2.826 0 0 0-1.97-.812h-2.73c-.735 0-1.45.296-1.97.816a2.794 2.794 0 0 0-.65 1.03H28.617a.92.92 0 0 0-.924.924.92.92 0 0 0 .924.923h.922v5.538a.92.92 0 0 0 .924.923.92.92 0 0 0 .923-.923v-5.538h7.384v11.077h-5.538a.92.92 0 0 0-.923.923.92.92 0 0 0 .923.923h5.538v1.038a.92.92 0 0 0 .923.923.92.92 0 0 0 .923-.923V18.458h2.77v13.846a.92.92 0 0 0 .923.923.92.92 0 0 0 .923-.923v-6.462h4.615v6.462a.92.92 0 0 0 .923.923.92.92 0 0 0 .923-.923V18.458h2.77v6.923l.007.12c.017.28.25.499.531.499.511 0 1 .012 1-.5l.308-7.042h.923a.92.92 0 0 0 .923-.923.92.92 0 0 0-.923-.924Zm-12 .943c0-.246.1-.489.282-.665a.944.944 0 0 1 .661-.274h2.73c.247 0 .493.1.67.274a.937.937 0 0 1 .273.665v2.75h-4.615v-2.75Zm0 6.442V22.15h4.616v1.846h-4.615Z"
  }), shared_bed_bedroom_jsx("path", {
    fill: secondColor,
    d: "M83.415 33.077H58.03v7.846h25.385v-7.846ZM77.877 17.846H61.26v4.616h16.616v-4.616Z"
  }), shared_bed_bedroom_jsx("path", {
    fill: color,
    d: "M58.492 28.923a.92.92 0 0 0 .924-.923c0-1.02.826-1.846 1.846-1.846h16.615c1.02 0 1.846.827 1.846 1.846a.92.92 0 0 0 .923.923.92.92 0 0 0 .923-.923 3.696 3.696 0 0 0-2.78-3.573c.003-.039.011-.077.011-.12a3.694 3.694 0 0 0-3.692-3.692H64.03a3.694 3.694 0 0 0-3.692 3.693c0 .042.007.08.011.119A3.696 3.696 0 0 0 57.57 28a.92.92 0 0 0 .922.923ZM62.731 23a1.836 1.836 0 0 1 1.3-.538h11.077c.488 0 .961.196 1.307.546.343.338.539.815.539 1.3h-14.77c0-.489.197-.962.547-1.308Z"
  }), shared_bed_bedroom_jsx("path", {
    fill: color,
    d: "M83.415 27.077a.92.92 0 0 0-.923.923v1.846H56.646V28a.92.92 0 0 0-.923-.923.92.92 0 0 0-.923.923v14.77a.92.92 0 0 0 .923.922.92.92 0 0 0 .923-.923v-.923h25.846v.923a.92.92 0 0 0 .923.923.92.92 0 0 0 .923-.923V28a.92.92 0 0 0-.923-.923Zm-26.769 4.615h25.846V40H56.646v-8.308ZM61.261 20.615a.92.92 0 0 0 .923-.923v-.923h14.77v.923a.92.92 0 0 0 .923.923.92.92 0 0 0 .923-.923v-2.769a.92.92 0 0 0-.923-.923.92.92 0 0 0-.923.923h-14.77a.92.92 0 0 0-.922-.923.92.92 0 0 0-.924.923v2.77a.92.92 0 0 0 .923.922Z"
  }));
};
/* harmony default export */ var shared_bed_bedroom = (SharedBedBedroom);
;// CONCATENATED MODULE: ../shared/src/svg/house.js


var house_excluded = ["color", "outlineColor"];
var house_jsx = react.createElement;

var House = function House(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#66D5FF' : _ref$color,
    _ref$outlineColor = _ref.outlineColor,
    outlineColor = _ref$outlineColor === void 0 ? '#224251' : _ref$outlineColor,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, house_excluded);
  return house_jsx("svg", (0,esm_extends/* default */.Z)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 47,
    viewBox: "0 0 60 47",
    fill: "none"
  }, props), house_jsx("path", {
    fill: "#fff",
    d: "M5.806 45.24h48.388V16.227H5.806V45.24Z"
  }), house_jsx("path", {
    fill: color,
    d: "M34.839 30.733h4.839v4.836h9.677v-4.836h4.84v14.464H34.838V30.733ZM5.806 30.733h4.839v4.836h9.677v-4.836h4.84v14.464H5.805V30.733Z"
  }), house_jsx("path", {
    fill: outlineColor,
    d: "M54.518 15.316c.108.046.138.053.235.12a.97.97 0 0 1 .373.53c.032.114.028.144.036.261V45.24c-.007.112-.004.141-.033.25a.976.976 0 0 1-.808.709c-.042.005-.085.005-.127.008H5.806c-.112-.007-.142-.004-.25-.033a.976.976 0 0 1-.71-.808c-.005-.042-.005-.084-.008-.126V16.227c.008-.117.004-.148.036-.261a.973.973 0 0 1 .607-.65.976.976 0 0 1 .985.204.966.966 0 0 1 .299.576c.006.043.006.087.008.131v28.046h46.453V16.227c.003-.044.003-.088.01-.131a.964.964 0 0 1 .761-.816.982.982 0 0 1 .264-.018c.043.003.087.012.13.018l.127.036Z"
  }), house_jsx("path", {
    fill: "#fff",
    d: "M51.775.995h-3.387v4.473h.846l2.54 2.539V.995Z"
  }), house_jsx("path", {
    fill: outlineColor,
    d: "M51.826.03c.045.003.056.003.1.01a.97.97 0 0 1 .77.656c.031.098.044.197.047.3v7.01c-.001.047 0 .058-.006.104a.972.972 0 0 1-.454.72.975.975 0 0 1-1.074-.039 1.162 1.162 0 0 1-.118-.1l-2.258-2.256h-.445l-.05-.001a.974.974 0 0 1-.912-.865c-.005-.045-.005-.056-.006-.101V.995c.001-.045 0-.056.005-.1a.976.976 0 0 1 .963-.866c1.145 0 2.292-.03 3.438 0Zm-2.47 1.932V4.51l.03.004c.044.008.055.01.099.02a.966.966 0 0 1 .434.25l.888.89v-3.71h-1.452Z"
  }), house_jsx("path", {
    fill: "#fff",
    d: "M49.234 5.468H10.765l-7.379 7.374h53.228l-7.38-7.374Z"
  }), house_jsx("path", {
    fill: outlineColor,
    d: "M49.36 4.51c.11.021.14.021.245.064a.984.984 0 0 1 .219.127c.033.025.063.055.094.083l7.38 7.374c.031.036.064.07.093.108a.974.974 0 0 1-.128 1.293.957.957 0 0 1-.507.24c-.047.007-.095.007-.143.01H3.386c-.047-.003-.095-.003-.142-.01a.955.955 0 0 1-.508-.24.973.973 0 0 1-.299-.905.964.964 0 0 1 .172-.388c.028-.038.062-.072.093-.108l7.38-7.374c.083-.074.102-.097.2-.153a.969.969 0 0 1 .357-.122c.042-.005.084-.005.126-.008h38.47l.125.008ZM11.166 6.434l-5.443 5.44h48.554l-5.444-5.44H11.166ZM56.751 15.27c.045.01.091.016.135.03a.968.968 0 0 1-.135 1.884c-.045.007-.092.007-.138.01H3.386c-.046-.003-.092-.003-.137-.01a.97.97 0 0 1-.594-1.59.973.973 0 0 1 .594-.324c.045-.007.091-.007.137-.01h53.227l.138.01ZM34.928 22.517c.03.004.06.007.089.013a.975.975 0 0 1 .786.862l.004.088v21.76c-.004.08-.002.1-.017.178a.971.971 0 0 1-.862.785.977.977 0 0 1-.955-.532.962.962 0 0 1-.098-.342l-.004-.09V24.448H26.13V45.24c-.004.08-.002.1-.017.178a.971.971 0 0 1-1.129.773.988.988 0 0 1-.474-.236.96.96 0 0 1-.312-.626l-.004-.09V23.48l.004-.089a.964.964 0 0 1 .7-.84.951.951 0 0 1 .175-.034l.09-.004h9.677l.09.004Z"
  }), house_jsx("path", {
    fill: outlineColor,
    d: "M28.636 34.602a.974.974 0 0 1 .91.656.981.981 0 0 1 .012.585.974.974 0 0 1-.738.674c-.09.018-.18.019-.272.019a.958.958 0 0 1-.559-.178.974.974 0 0 1-.34-1.148.974.974 0 0 1 .501-.523.982.982 0 0 1 .393-.085h.093ZM49.422 22.515l.066.007a.976.976 0 0 1 .827.827c.007.058.006.073.008.131V35.57c-.002.058 0 .073-.008.131a.976.976 0 0 1-.827.826c-.059.009-.074.008-.133.01h-9.677c-.059-.002-.074-.001-.132-.01a.975.975 0 0 1-.827-.826c-.008-.058-.007-.073-.009-.131V23.48c.002-.058 0-.073.01-.131a.976.976 0 0 1 .827-.827c.057-.008.072-.007.13-.009 3.249 0 6.498-.109 9.745.002Zm-8.776 1.932v10.155h7.742V24.447h-7.742ZM20.389 22.515l.065.007a.976.976 0 0 1 .827.827c.008.058.007.073.009.131V35.57c-.002.058-.001.073-.009.131a.976.976 0 0 1-.827.826c-.058.009-.073.008-.132.01h-9.677c-.059-.002-.074-.001-.132-.01a.975.975 0 0 1-.827-.826c-.008-.058-.007-.073-.01-.131V23.48c.003-.058.002-.073.01-.131a.976.976 0 0 1 .827-.827c.058-.008.073-.007.132-.009 3.247 0 6.497-.109 9.744.002Zm-8.777 1.932v10.155h7.743V24.447h-7.743Z"
  }), house_jsx("path", {
    fill: outlineColor,
    d: "M50.876 34.604a.97.97 0 0 1 .663 1.598.967.967 0 0 1-.594.324c-.06.009-.076.008-.138.01h-12.58c-.062-.002-.078-.001-.139-.01a.97.97 0 0 1-.742-.555.973.973 0 0 1 .196-1.086.97.97 0 0 1 .684-.283h12.581l.07.002ZM21.843 34.604a.968.968 0 0 1 .394 1.813.972.972 0 0 1-.325.11c-.061.008-.077.007-.138.009H9.193c-.062-.002-.077-.001-.138-.01a.974.974 0 0 1-.594-.324.974.974 0 0 1-.117-1.097.97.97 0 0 1 .85-.503h12.58l.07.002ZM59.034 44.316c.048.003.096.003.144.01a.971.971 0 0 1 .694.474.974.974 0 0 1-.083 1.086.967.967 0 0 1-.612.353c-.048.007-.096.007-.144.011L.966 46.207c-.048-.003-.096-.003-.144-.01a.972.972 0 0 1-.756-.604.975.975 0 0 1 .243-1.062.973.973 0 0 1 .515-.248c.047-.006.095-.006.144-.01l58.066.043ZM53.762.03c.047.003.059.003.105.011a.981.981 0 0 1 .58.329.972.972 0 0 1-.194 1.426.972.972 0 0 1-.543.166h-7.258c-.046 0-.059 0-.105-.005a.98.98 0 0 1-.598-.296.974.974 0 0 1-.26-.56.973.973 0 0 1 .464-.934.967.967 0 0 1 .499-.139c2.437 0 4.875-.064 7.31.002Z"
  }));
};
/* harmony default export */ var house = (House);
;// CONCATENATED MODULE: ./src/components/Overview/YourSpace/index.js




var _PROPERTY_TYPE_ICONS;

var YourSpace_jsx = react.createElement;

function YourSpace_ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function YourSpace_objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? YourSpace_ownKeys(Object(t), !0).forEach(function (r) {
      (0,defineProperty/* default */.Z)(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : YourSpace_ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}































var BED_TYPE_ICONS = {
  'unit-double-bed': YourSpace_jsx(double_bed_bedroom, {
    width: 110,
    height: 90
  }),
  'unit-single-bed': YourSpace_jsx(single_bed_bedroom, {
    width: 94,
    height: 90
  }),
  'unit-twin-bed': YourSpace_jsx(twin_bed_bedroom, {
    width: 110,
    height: 90
  }),
  'subunit-single-bed': YourSpace_jsx(shared_bed_bedroom, {
    width: 110,
    height: 90
  }),
  'subunit-double-bed': YourSpace_jsx(shared_bed_bedroom, {
    width: 110,
    height: 90
  }),
  'subunit-twin-bed': YourSpace_jsx(shared_bed_bedroom, {
    width: 110,
    height: 90
  })
};
var PROPERTY_TYPE_ICONS = (_PROPERTY_TYPE_ICONS = {}, (0,defineProperty/* default */.Z)(_PROPERTY_TYPE_ICONS, unitTypes/* PROPERTY_UNIT_TYPE.APARTMENT */.DV.APARTMENT, YourSpace_jsx(apartment/* default */.Z, {
  color: src_theme/* theme.colors.blueTeal */.r.colors.blueTeal,
  width: 80,
  height: 80
})), (0,defineProperty/* default */.Z)(_PROPERTY_TYPE_ICONS, unitTypes/* PROPERTY_UNIT_TYPE.STUDIO */.DV.STUDIO, YourSpace_jsx(studio/* default */.Z, {
  color: src_theme/* theme.colors.blueTeal */.r.colors.blueTeal,
  width: 90,
  height: 90
})), (0,defineProperty/* default */.Z)(_PROPERTY_TYPE_ICONS, unitTypes/* PROPERTY_UNIT_TYPE.HOUSE */.DV.HOUSE, YourSpace_jsx(house, {
  width: 90,
  height: 90
})), _PROPERTY_TYPE_ICONS);

var YourSpace = function YourSpace(_ref) {
  var _REFERENCE_WITH_GENDE, _REFERENCE_WITH_GENDE2;

  var isRentByProperty = _ref.isRentByProperty,
      propertyDescription = _ref.propertyDescription,
      offerDescription = _ref.offerDescription,
      privateFeatures = _ref.features.privateFeatures,
      propertyFeatures = _ref.propertyFeatures,
      bedType = _ref.bedType,
      rentBy = _ref.rentBy,
      numberOfBeds = _ref.numberOfBeds,
      numberOfBedrooms = _ref.numberOfBedrooms,
      showFeaturesModal = _ref.showFeaturesModal,
      typeCode = _ref.typeCode,
      isChecked = _ref.isChecked,
      offerGenderRestriction = _ref.offerGenderRestriction,
      trackAllFeaturesModalOpenedAction = _ref.trackAllFeaturesModalOpenedAction;

  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t,
      language = _useTranslation.i18n.language;

  var commonFeatures = isRentByProperty ? (0,defineProperty/* default */.Z)({}, typeCode, propertyFeatures) : null;
  var existentFeatures = Object.values((isRentByProperty ? propertyFeatures : privateFeatures) || {}).flat().filter(function (_ref3) {
    var exists = _ref3.exists;
    return exists;
  });
  var filteredExistentFeatures = rentBy === rentType/* RENT_TYPE.BEDROOM */.u.BEDROOM ? existentFeatures : (0,toConsumableArray/* default */.Z)(new Set(existentFeatures));
  var genderRestrictions = handleGenderRestrictions(t, offerGenderRestriction, null, true, isRentByProperty);
  var featuresLengthLimit = genderRestrictions.length ? 4 : 5;

  var getDescription = function getDescription() {
    if (isRentByProperty) {
      return propertyDescription !== null && propertyDescription !== void 0 && propertyDescription.length ? propertyDescription : offerDescription;
    }

    return offerDescription !== null && offerDescription !== void 0 && offerDescription.length ? offerDescription : null;
  };

  var context = (_REFERENCE_WITH_GENDE = (_REFERENCE_WITH_GENDE2 = translations/* REFERENCE_WITH_GENDER_BY_OFFER_TYPE */.Ty[!isRentByProperty ? rentBy : typeCode]) === null || _REFERENCE_WITH_GENDE2 === void 0 ? void 0 : _REFERENCE_WITH_GENDE2[language]) !== null && _REFERENCE_WITH_GENDE !== void 0 ? _REFERENCE_WITH_GENDE : {};
  return YourSpace_jsx(YourSpace_styles_Wrapper, null, YourSpace_jsx(YourSpace_styles_Title, null, YourSpace_jsx("h2", null, !isRentByProperty ? t('Your bedroom') : t("Your ".concat(typeCode))), isChecked ? YourSpace_jsx(src/* Tooltip */.u, {
    zIndex: 99
  }, YourSpace_jsx(Unisystem_Pill, {
    Icon: exclamation/* default */.Z,
    label: t('Checked'),
    isGreen: true
  }), YourSpace_jsx("p", null, t('One of our Place Checkers has visited this place, and confirmed its location and authenticity.'))) : null), offerDescription !== null && offerDescription !== void 0 && offerDescription.length || isRentByProperty && propertyDescription !== null && propertyDescription !== void 0 && propertyDescription.length ? YourSpace_jsx(ReadMoreInline/* default */.Z, {
    text: (0,transformers/* translateFromLanguage */.JB)(getDescription(), language)
  }) : null, isRentByProperty && YourSpace_jsx(Overview_EnergyCertification, null), YourSpace_jsx(Features, null, genderRestrictions.map(function (_ref4) {
    var translation = _ref4.translation,
        Icon = _ref4.icon;
    return YourSpace_jsx(Feature, {
      key: translation
    }, YourSpace_jsx("div", null, YourSpace_jsx(Icon, null)), YourSpace_jsx("div", null, t(translation)));
  }), filteredExistentFeatures.slice(0, featuresLengthLimit).map(function (_ref5) {
    var translation = _ref5.translation,
        translation_old = _ref5.translation_old,
        Component = _ref5.Component,
        area = _ref5.area;
    return YourSpace_jsx(Feature, {
      key: translation || translation_old
    }, YourSpace_jsx(Component, null), YourSpace_jsx("div", null, t(translation || translation_old, {
      area: area
    })));
  })), YourSpace_jsx(SpaceInfo, null, isRentByProperty ? PROPERTY_TYPE_ICONS[typeCode] : BED_TYPE_ICONS["".concat(rentBy, "-").concat(bedType)], YourSpace_jsx(SpaceInfoRight, null, YourSpace_jsx(SpaceInfoTitle, null, t('This is a', {
    context: context
  }), ' ', YourSpace_jsx("span", null, t(!isRentByProperty ? translations/* RENT_BY_TRANSLATIONS */.Np[rentBy] : translations/* UNIT_TYPE_TRANSLATIONS */.uS[typeCode]))), YourSpace_jsx(SpaceInfoDescription, null, rentBy === rentType/* RENT_TYPE.BEDROOM */.u.BEDROOM ? YourSpace_jsx(react.Fragment, null, YourSpace_jsx("p", null, t("You won't have to share the bedroom with anyone else")), YourSpace_jsx("p", null, t('This room has a total of {{count}} beds available', {
    count: numberOfBeds
  }))) : null, rentBy === rentType/* RENT_TYPE.BED */.u.BED ? YourSpace_jsx(react.Fragment, null, YourSpace_jsx("p", null, t('This is a single bed in a shared bedroom')), YourSpace_jsx("p", null, t('There are a total of {{count}} beds in this room', {
    count: numberOfBeds
  })), YourSpace_jsx("p", null, t('As this is a shared bedroom, other beds can be booked by other tenants'))) : null, isRentByProperty ? YourSpace_jsx("p", null, t('You will have the entire property to yourself')) : null, typeCode !== unitTypes/* PROPERTY_UNIT_TYPE.STUDIO */.DV.STUDIO ? YourSpace_jsx("span", null, t('{{count}} rooms in total', {
    count: numberOfBedrooms
  })) : null))), filteredExistentFeatures.length ? YourSpace_jsx(SeeAllFeaturesButton, {
    isSmall: true,
    isTertiary: true,
    icon: hamburger,
    iconSide: 'left',
    onClick: function onClick() {
      trackAllFeaturesModalOpenedAction();
      showFeaturesModal({
        privateFeatures: privateFeatures,
        commonFeatures: commonFeatures
      });
    }
  }, t('See all features')) : null);
};

var YourSpace_mapStateToProps = function mapStateToProps(_ref6) {
  var _unit$subunits;

  var _ref6$offer$offerAggr = _ref6.offer.offerAggregate,
      _ref6$offer$offerAggr2 = _ref6$offer$offerAggr.property_aggregate,
      property = _ref6$offer$offerAggr2.property,
      _ref6$offer$offerAggr3 = _ref6$offer$offerAggr2.property,
      propertyDescription = _ref6$offer$offerAggr3.metadata,
      _ref6$offer$offerAggr4 = _ref6$offer$offerAggr3.typology,
      numberOfBedrooms = _ref6$offer$offerAggr4.number_of_bedrooms,
      typeCode = _ref6$offer$offerAggr4.type_code,
      area = _ref6$offer$offerAggr4.area,
      floors = _ref6$offer$offerAggr3.floors,
      propertyFeatures = _ref6$offer$offerAggr3.features,
      verification = _ref6$offer$offerAggr3.verification,
      _ref6$offer$offerAggr5 = _ref6$offer$offerAggr.accommodation_offer,
      _ref6$offer$offerAggr6 = _ref6$offer$offerAggr5.property,
      unitId = _ref6$offer$offerAggr6.unit_id,
      unitType = _ref6$offer$offerAggr6.unit_type,
      offerDescription = _ref6$offer$offerAggr5.description,
      offerGenderRestriction = _ref6$offer$offerAggr5.restrictions.gender;

  var _floors = (0,slicedToArray/* default */.Z)(floors, 1),
      units = _floors[0].units;

  var unit = (0,transformers/* findUnit */.u7)(units, unitId);
  var beds = unit === null || unit === void 0 ? void 0 : (_unit$subunits = unit.subunits) === null || _unit$subunits === void 0 ? void 0 : _unit$subunits.reduce(function (acc, _ref7) {
    var type_code = _ref7.type_code;
    return (0,utils_unitTypes/* isBed */.SX)(type_code) ? acc + 1 : acc;
  }, 0);
  var rentBy = (0,utils_property/* getPropertyRentBy */.f)(property);
  var bedType = (0,utils_unitTypes/* findBedType */.dU)(unitType, units, unit) === unitTypes/* SUBUNIT_TYPES.SINGLE_BED */.vz.SINGLE_BED && beds === 2 ? unitTypes/* SUBUNIT_TYPES.TWIN_BED */.vz.TWIN_BED : (0,utils_unitTypes/* findBedType */.dU)(unitType, units, unit);
  var isChecked = verification === null || verification === void 0 ? void 0 : verification.verified;

  var propertyAreaFeature = YourSpace_objectSpread(YourSpace_objectSpread({}, services_features/* SERVICES_FEATURES.area */.V.area), {}, {
    area: area !== null && area !== void 0 ? area : 0,
    exists: !!area
  });

  return {
    propertyDescription: propertyDescription,
    offerDescription: offerDescription,
    features: (0,transformers_property/* getFeatures */.N$)(unitId, property),
    propertyFeatures: [propertyAreaFeature].concat((0,toConsumableArray/* default */.Z)((0,transformers_property/* transformFeatures */.mr)(propertyFeatures))),
    rentBy: rentBy,
    bedType: bedType,
    numberOfBeds: beds,
    numberOfBedrooms: (0,transformers/* getNumberOfBedrooms */.Y)(floors, numberOfBedrooms),
    typeCode: typeCode,
    isChecked: isChecked,
    offerGenderRestriction: offerGenderRestriction
  };
};

var YourSpace_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    showFeaturesModal: function showFeaturesModal(features) {
      return dispatch((0,modal/* showModalAction */.bF)({
        modalId: modal_displayer.modalIds.FEATURES,
        features: features
      }));
    },
    trackAllFeaturesModalOpenedAction: function trackAllFeaturesModalOpenedAction() {
      return dispatch((0,actions_tracking/* trackAllFeaturesModalOpened */.h6)());
    }
  };
};

/* harmony default export */ var Overview_YourSpace = ((0,es/* connect */.$j)(YourSpace_mapStateToProps, YourSpace_mapDispatchToProps)(YourSpace));
;// CONCATENATED MODULE: ./src/components/Overview/AboutThisPlace/styles.js


var AboutThisPlace_styles_templateObject;



var AboutThisPlace_styles_Wrapper = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1xy9fw7-0"
})(["display:flex;flex-direction:column;", ""], function (_ref) {
  var theme = _ref.theme;
  return theme.gap(5, 'column');
});
var AboutThisPlace_styles_Title = /*#__PURE__*/styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  componentId: "sc-1xy9fw7-1"
})(["font-size:", ";line-height:", ";font-weight:600;color:", ";"], function (props) {
  return props.theme.rem(22);
}, function (props) {
  return props.theme.rem(26);
}, function (props) {
  return props.theme.overview.aboutThisPlace.text.color;
});
var Subtitle = /*#__PURE__*/styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  componentId: "sc-1xy9fw7-2"
})(["font-size:", ";line-height:", ";font-weight:600;color:", ";"], function (props) {
  return props.theme.rem(18);
}, function (props) {
  return props.theme.rem(20);
}, function (props) {
  return props.theme.overview.aboutThisPlace.text.color;
});
var LivingWith = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1xy9fw7-3"
})(["display:flex;flex-wrap:wrap;font-size:", ";line-height:", ";", ";color:", ";div{display:flex;", ";}", " svg{width:24px;height:22px;.st1{fill:", ";}}"], function (props) {
  return props.theme.rem(16);
}, function (props) {
  return props.theme.rem(20);
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.gap(6);
}, function (props) {
  return props.theme.overview.aboutThisPlace.text.color;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.gap(2);
}, theme/* mediaMin.mediumBreakpoint */.A3.mediumBreakpoint(AboutThisPlace_styles_templateObject || (AboutThisPlace_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n    ", ";\n  "])), function (_ref4) {
  var theme = _ref4.theme;
  return theme.gap(3);
}), function (props) {
  return props.theme.overview.aboutThisPlace.roommatesIcon.fill;
});
;// CONCATENATED MODULE: ./src/components/Overview/AboutThisPlace/index.js

var AboutThisPlace_jsx = react.createElement;










var AboutThisPlace = function AboutThisPlace(_ref) {
  var propertyDescription = _ref.propertyDescription,
      isRentByProperty = _ref.isRentByProperty,
      numberOfRoommates = _ref.numberOfRoommates,
      landlordResident = _ref.landlordResident,
      propertyGenderRestriction = _ref.propertyGenderRestriction,
      propertyType = _ref.propertyType;

  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t;

  return AboutThisPlace_jsx(AboutThisPlace_styles_Wrapper, null, AboutThisPlace_jsx(AboutThisPlace_styles_Title, null, "".concat(t("About this ".concat(propertyType)))), propertyDescription && AboutThisPlace_jsx(ReadMoreInline/* default */.Z, {
    text: propertyDescription
  }), AboutThisPlace_jsx(Overview_EnergyCertification, null), !isRentByProperty && AboutThisPlace_jsx(react.Fragment, null, AboutThisPlace_jsx(Subtitle, null, t('You will be living with...')), AboutThisPlace_jsx(LivingWith, null, describeLivingWith({
    t: t,
    numberOfRoommates: numberOfRoommates,
    propertyGenderRestriction: propertyGenderRestriction,
    landlordResident: landlordResident
  }).map(function (_ref2) {
    var translation = _ref2.translation,
        Icon = _ref2.icon;
    return AboutThisPlace_jsx("div", {
      key: translation
    }, AboutThisPlace_jsx(Icon, null), AboutThisPlace_jsx("span", null, translation));
  }))));
};

var AboutThisPlace_mapStateToProps = function mapStateToProps(_ref3) {
  var _ref3$offer$offerAggr = _ref3.offer.offerAggregate,
      _ref3$offer$offerAggr2 = _ref3$offer$offerAggr.property_aggregate.property,
      landlordResident = _ref3$offer$offerAggr2.landlord_resident,
      floors = _ref3$offer$offerAggr2.floors,
      rentBy = _ref3$offer$offerAggr2.lifecycle.rent_by,
      propertyType = _ref3$offer$offerAggr2.typology.type_code,
      propertyGenderRestriction = _ref3$offer$offerAggr2.restrictions.gender,
      _ref3$offer$offerAggr3 = _ref3$offer$offerAggr.accommodation_offer.property,
      unitId = _ref3$offer$offerAggr3.unit_id,
      unitType = _ref3$offer$offerAggr3.unit_type;

  var _floors = (0,slicedToArray/* default */.Z)(floors, 1),
      floor = _floors[0];

  var unit = (0,transformers/* findUnit */.u7)(floor.units, unitId);
  var numberOfRoommates = rentBy === rentType/* RENT_TYPE.BED */.u.BED && unit ? (0,transformers/* getSubunitCountInUnit */.sn)(unit, unitType) : null;
  return {
    numberOfRoommates: numberOfRoommates,
    propertyGenderRestriction: propertyGenderRestriction,
    landlordResident: landlordResident,
    propertyType: propertyType
  };
};

/* harmony default export */ var Overview_AboutThisPlace = ((0,es/* connect */.$j)(AboutThisPlace_mapStateToProps)(AboutThisPlace));
;// CONCATENATED MODULE: ./src/components/Overview/SharedSpacesAndAmenities/styles.js


var SharedSpacesAndAmenities_styles_templateObject;





var SharedSpacesAndAmenities_styles_Wrapper = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1w4cuzy-0"
})(["display:flex;flex-direction:column;gap:", ";color:", ";button{width:fit-content;}", " ", "{", " flex-wrap:wrap;height:auto;", "{p{font-family:'IntervalNextReg',sans-serif;font-size:", ";line-height:", ";font-weight:600;}}", "{flex-basis:100%;", " .photo{width:229px;display:flex;flex-direction:column;", " min-height:100%;padding:", " 0;cursor:pointer;img{width:229px;height:160px;object-fit:cover;border-radius:", ";}span{font-size:", ";font-weight:600;line-height:", ";text-transform:capitalize;}}.placeholder{width:229px;display:flex;flex-direction:column;", " min-height:100%;padding:", " 0;cursor:pointer;", "{width:229px;height:160px;}.unit-name{font-size:", ";font-weight:600;line-height:", ";}}}}"], function (props) {
  return props.theme.space(5);
}, function (props) {
  return props.theme.overview.sharedSpacesAndAmenities.text.color;
}, theme/* mediaMin.extraSmallBreakpoint */.A3.extraSmallBreakpoint(SharedSpacesAndAmenities_styles_templateObject || (SharedSpacesAndAmenities_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n    button {\n      width: 100%;\n    }\n  "]))), SimpleCarousel_styles_Wrapper, function (_ref) {
  var theme = _ref.theme;
  return theme.gap(6);
}, Header, function (props) {
  return props.theme.rem(22);
}, function (props) {
  return props.theme.rem(26);
}, Carousel, function (_ref2) {
  var theme = _ref2.theme;
  return theme.gap(4);
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.gap(2, 'column');
}, function (props) {
  return props.theme.space(2);
}, function (props) {
  return props.theme.space(3);
}, function (props) {
  return props.theme.rem(18);
}, function (props) {
  return props.theme.rem(20);
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.gap(2, 'column');
}, function (props) {
  return props.theme.space(2);
}, Placeholder_styles/* Wrapper */.im, function (props) {
  return props.theme.rem(18);
}, function (props) {
  return props.theme.rem(20);
});
var SharedSpacesAndAmenities_styles_Title = /*#__PURE__*/(/* unused pure expression or super */ null && (styled.h2.withConfig({
  componentId: "sc-1w4cuzy-1"
})(["font-size:", ";line-height:", ";font-weight:600;"], function (props) {
  return props.theme.rem(18);
}, function (props) {
  return props.theme.rem(20);
})));
// EXTERNAL MODULE: ./src/utils/transformers/index.js
var utils_transformers = __webpack_require__(18186);
;// CONCATENATED MODULE: ./src/components/Overview/SharedSpacesAndAmenities/index.js

var SharedSpacesAndAmenities_jsx = react.createElement;
/* eslint-disable quotes */



















var SharedSpacesAndAmenities = function SharedSpacesAndAmenities(_ref) {
  var units = _ref.units,
      photos = _ref.photos,
      features = _ref.features,
      rentBy = _ref.rentBy,
      unitId = _ref.unitId,
      showGallery = _ref.showGallery,
      showAmenitiesModal = _ref.showAmenitiesModal;

  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var transformedUnits = (0,utils_transformers/* transformUnitsForSharedSpacesAndAmenities */.Em)(t, units, photos, rentBy);
  var rentByProperty = rentBy === rentType/* RENT_TYPE.ENTIRE_PROPERTY */.u.ENTIRE_PROPERTY;
  var commonFeatures = (0,utils_transformers/* transformFeaturesToCommonFeatures */.Dl)(transformedUnits, (0,transformers_property/* transformFeatures */.mr)(features), unitId, rentByProperty);

  var openAmenitiesModal = function openAmenitiesModal() {
    return showAmenitiesModal({
      commonFeatures: commonFeatures
    });
  };

  return SharedSpacesAndAmenities_jsx(SharedSpacesAndAmenities_styles_Wrapper, null, SharedSpacesAndAmenities_jsx(components_SimpleCarousel, {
    title: rentByProperty ? 'Property features and amenities' : 'Shared spaces and amenities',
    numberOfElements: transformedUnits.length,
    itemWidth: 229,
    gap: 16
  }, transformedUnits.map(function (_ref2) {
    var hash = _ref2.hash,
        unitName = _ref2.unitName,
        unitTypeCode = _ref2.unitTypeCode;
    return hash ? SharedSpacesAndAmenities_jsx("div", {
      key: unitName,
      onClick: function onClick() {
        return showGallery(unitName);
      },
      className: "photo"
    }, SharedSpacesAndAmenities_jsx("img", {
      src: (0,utils_photos/* photoUrl */.wX)({
        hash: hash,
        size: constants_photos/* PHOTO_SIZES.MEDIUM */.c.MEDIUM
      }),
      alt: unitName
    }), SharedSpacesAndAmenities_jsx("span", null, unitName)) : SharedSpacesAndAmenities_jsx("div", {
      key: unitName,
      onClick: openAmenitiesModal,
      className: "placeholder"
    }, SharedSpacesAndAmenities_jsx(Placeholder/* default */.Z, {
      type: unitTypeCode,
      title: t('No photo yet'),
      subtitle: t("but we're working on it!")
    }), SharedSpacesAndAmenities_jsx("span", {
      className: "unit-name"
    }, unitName));
  })), SharedSpacesAndAmenities_jsx(Button/* default */.Z, {
    isTertiary: true,
    isSmall: true,
    icon: hamburger,
    iconSide: "left",
    onClick: openAmenitiesModal
  }, t('See all amenities')));
};

var SharedSpacesAndAmenities_mapStateToProps = function mapStateToProps(_ref3) {
  var _ref3$offer$offerAggr = _ref3.offer.offerAggregate,
      unitId = _ref3$offer$offerAggr.accommodation_offer.property.unit_id,
      _ref3$offer$offerAggr2 = _ref3$offer$offerAggr.property_aggregate.property,
      floors = _ref3$offer$offerAggr2.floors,
      features = _ref3$offer$offerAggr2.features,
      rentBy = _ref3$offer$offerAggr2.lifecycle.rent_by,
      photos = _ref3$offer$offerAggr.photos;

  var _floors = (0,slicedToArray/* default */.Z)(floors, 1),
      units = _floors[0].units;

  return {
    units: units,
    photos: photos,
    features: features,
    rentBy: rentBy,
    unitId: unitId
  };
};

var SharedSpacesAndAmenities_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    showGallery: function showGallery(unitName) {
      return dispatch((0,modal/* showModalAction */.bF)({
        modalId: modal_displayer.modalIds.PHOTOS_MODAL,
        section: modals/* PHOTOS_MODAL_SECTIONS.photos.label */.c.photos.label,
        unitName: unitName
      }));
    },
    showAmenitiesModal: function showAmenitiesModal(features) {
      dispatch((0,actions_tracking/* trackSeeAllAmenities */.cN)());
      dispatch((0,modal/* showModalAction */.bF)({
        modalId: modal_displayer.modalIds.FEATURES,
        features: features
      }));
    }
  };
};

/* harmony default export */ var Overview_SharedSpacesAndAmenities = ((0,es/* connect */.$j)(SharedSpacesAndAmenities_mapStateToProps, SharedSpacesAndAmenities_mapDispatchToProps)(SharedSpacesAndAmenities));
;// CONCATENATED MODULE: ./src/components/Overview/index.js
var Overview_jsx = react.createElement;












var Overview = function Overview(_ref) {
  var isRentByProperty = _ref.isRentByProperty,
      propertyMetadata = _ref.propertyMetadata;

  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      language = _useTranslation.i18n.language;

  var propertyDescription = (0,react.useMemo)(function () {
    return (0,transformers/* translateFromLanguage */.JB)(propertyMetadata, language);
  }, [propertyMetadata, language]);
  return Overview_jsx(Overview_styles_Wrapper, {
    id: "Overview"
  }, Overview_jsx(Overview_YourSpace, {
    isRentByProperty: isRentByProperty
  }), Overview_jsx(Separator/* default */.Z, null), !isRentByProperty ? Overview_jsx(react.Fragment, null, Overview_jsx(Overview_AboutThisPlace, {
    propertyDescription: propertyDescription,
    isRentByProperty: isRentByProperty
  }), Overview_jsx(Separator/* default */.Z, null)) : null, Overview_jsx(Overview_SharedSpacesAndAmenities, null));
};

var Overview_mapStateToProps = function mapStateToProps(_ref2) {
  var _ref2$offer$offerAggr = _ref2.offer.offerAggregate,
      _ref2$offer$offerAggr2 = _ref2$offer$offerAggr.accommodation_offer;
  _ref2$offer$offerAggr2 = _ref2$offer$offerAggr2 === void 0 ? {} : _ref2$offer$offerAggr2;
  var unitType = _ref2$offer$offerAggr2.property.unit_type,
      _ref2$offer$offerAggr3 = _ref2$offer$offerAggr.property_aggregate;
  _ref2$offer$offerAggr3 = _ref2$offer$offerAggr3 === void 0 ? {} : _ref2$offer$offerAggr3;
  var _ref2$offer$offerAggr4 = _ref2$offer$offerAggr3.property;
  _ref2$offer$offerAggr4 = _ref2$offer$offerAggr4 === void 0 ? {} : _ref2$offer$offerAggr4;
  var lifecycle = _ref2$offer$offerAggr4.lifecycle,
      typology = _ref2$offer$offerAggr4.typology,
      propertyMetadata = _ref2$offer$offerAggr4.metadata,
      floors = _ref2$offer$offerAggr4.floors,
      photos = _ref2$offer$offerAggr.photos;
  return {
    isRentByProperty: (0,utils_property/* getPropertyRentBy */.f)({
      unitType: unitType,
      lifecycle: lifecycle,
      typology: typology
    }) === rentType/* RENT_TYPE.ENTIRE_PROPERTY */.u.ENTIRE_PROPERTY,
    propertyMetadata: propertyMetadata
  };
};

/* harmony default export */ var components_Overview = ((0,es/* connect */.$j)(Overview_mapStateToProps)(Overview));
;// CONCATENATED MODULE: ../shared/src/components/Unisystem/Tabs/Tab/styles.js

var Tab_styles_Wrapper = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-lqzcye-0"
})(["display:flex;align-items:flex-start;gap:", ";padding:0px ", ";max-width:max-content;color:", ";cursor:pointer;position:relative;border-bottom:2px solid transparent;&:after{content:'';position:absolute;bottom:0;left:0;width:100%;height:1px;border-bottom:1px solid ", ";", ";}&:hover{&:after{height:1px;background:", ";border-bottom:1px solid ", ";}& > p{background-color:", ";}}& > p{padding:", ";font-size:", ";border-radius:", ";line-height:", ";font-weight:", ";}"], function (props) {
  return props.theme.space(2.5);
}, function (props) {
  return "".concat(props.theme.space(3), " ").concat(props.theme.space(1.5), " ").concat(props.theme.space(3));
}, function (props) {
  return props.theme.unisystem.tab.color;
}, function (props) {
  return props.isSelected ? props.theme.unisystem.tab.border.selected : props.theme.unisystem.tab.border["default"];
}, function (props) {
  return props.isSelected && "background: ".concat(props.theme.unisystem.tab.border.selected);
}, function (props) {
  return props.theme.unisystem.tab.border.hover;
}, function (props) {
  return props.theme.unisystem.tab.border.hover;
}, function (props) {
  return props.theme.unisystem.tab.background.hover;
}, function (props) {
  return props.theme.space(1);
}, function (props) {
  return props.theme.rem(16);
}, function (props) {
  return props.theme.space(2);
}, function (props) {
  return props.theme.rem(20);
}, function (props) {
  return props.isSelected ? '500' : '400';
});
;// CONCATENATED MODULE: ../shared/src/components/Unisystem/Tabs/Tab/index.js
var Tab_jsx = react.createElement;


var Tab = function Tab(_ref) {
  var id = _ref.id,
    label = _ref.label,
    onClick = _ref.onClick,
    _ref$isSelected = _ref.isSelected,
    isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected;
  var labelHandler = function labelHandler() {
    return onClick(id);
  };
  return Tab_jsx(Tab_styles_Wrapper, {
    onClick: labelHandler,
    isSelected: isSelected,
    "data-selected": isSelected
  }, Tab_jsx("p", null, label));
};
/* harmony default export */ var Tabs_Tab = (Tab);
;// CONCATENATED MODULE: ../shared/src/components/Unisystem/Tabs/styles.js

var Tabs_styles_templateObject;


var Tabs_styles_Wrapper = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1jggv4-0"
})(["width:100%;display:flex;flex-direction:column;"]);
var TabsWrapper = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1jggv4-1"
})(["display:flex;margin-bottom:", ";", ""], function (props) {
  return props.theme.space(10);
}, theme/* mediaMin.mediumBreakpoint */.A3.mediumBreakpoint(Tabs_styles_templateObject || (Tabs_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-bottom: ", ";\n  "])), function (props) {
  return props.theme.space(5);
}));
;// CONCATENATED MODULE: ../shared/src/components/Unisystem/Tabs/index.js
var Tabs_jsx = react.createElement;




var Tabs = function Tabs(_ref) {
  var tabs = _ref.tabs,
    selectedTab = _ref.selectedTab,
    onSelectTab = _ref.onSelectTab;
  var _useTranslation = (0,esm/* useTranslation */.$G)(),
    t = _useTranslation.t;
  var _ref2 = tabs.find(function (_ref3) {
      var id = _ref3.id;
      return id === selectedTab;
    }) || {},
    Content = _ref2.content;
  return Tabs_jsx(Tabs_styles_Wrapper, null, Tabs_jsx(TabsWrapper, null, tabs.map(function (_ref4) {
    var id = _ref4.id,
      label = _ref4.label;
    return Tabs_jsx(Tabs_Tab, {
      key: id,
      id: id,
      label: t(label),
      isSelected: label === selectedTab,
      onClick: onSelectTab
    });
  })), Content);
};
/* harmony default export */ var Unisystem_Tabs = (Tabs);
;// CONCATENATED MODULE: ../shared/src/svg/breadcrumb-next.js


var breadcrumb_next_excluded = ["color"];
var breadcrumb_next_jsx = react.createElement;

var BreadcrumbNext = function BreadcrumbNext(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#BCC6CA' : _ref$color,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, breadcrumb_next_excluded);
  return breadcrumb_next_jsx("svg", (0,esm_extends/* default */.Z)({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10 18",
    width: 10,
    height: 18,
    fill: "none"
  }, props), breadcrumb_next_jsx("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M8.667 9.334 1 1.667M8.667 9.333 1 17"
  }));
};
/* harmony default export */ var breadcrumb_next = (BreadcrumbNext);
;// CONCATENATED MODULE: ../shared/src/components/CustomBreadcrumbs/styles.js

var CustomBreadcrumbs_styles_templateObject, CustomBreadcrumbs_styles_templateObject2;


var CustomBreadcrumbs_styles_Wrapper = /*#__PURE__*/styled_components_browser_esm/* default.ol.withConfig */.ZP.ol.withConfig({
  componentId: "sc-1wfvs7p-0"
})(["display:flex;align-items:center;", ";align-self:start;flex-wrap:wrap;svg{width:8px;height:8px;}", ""], function (_ref) {
  var theme = _ref.theme;
  return theme.gap(2);
}, theme/* mediaMin.mediumBreakpoint */.A3.mediumBreakpoint(CustomBreadcrumbs_styles_templateObject || (CustomBreadcrumbs_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n    align-items: flex-start;\n  "]))));
var styles_Item = /*#__PURE__*/styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
  componentId: "sc-1wfvs7p-1"
})(["display:flex;align-items:center;font-size:", ";line-height:", ";", ";", " a{color:", ";text-decoration:none;}&:hover:not(:last-child) a{text-decoration:underline;}&:last-child{color:", ";}svg{width:15px;height:15px;}"], function (props) {
  return props.theme.rem(16);
}, function (props) {
  return props.theme.rem(26);
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.gap(1);
}, theme/* mediaMin.mediumBreakpoint */.A3.mediumBreakpoint(CustomBreadcrumbs_styles_templateObject2 || (CustomBreadcrumbs_styles_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    font-size: ", ";\n    line-height: ", ";\n  "])), function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.rem(24);
}), function (props) {
  return props.theme.breadcrumbs.text.color;
}, function (props) {
  return props.theme.breadcrumbs.lastItem.color;
});
;// CONCATENATED MODULE: ../shared/src/utils/translations/index.js
var pluralization = function pluralization(singularKey, pluralKey, count, t) {
  return t(count > 1 ? pluralKey : singularKey, {
    count: count
  });
};
var getTranslatedTitle = function getTranslatedTitle(translations, locale) {
  var _translations$find, _translations$find2;
  if (!(translations !== null && translations !== void 0 && translations.length)) {
    return '';
  }
  return ((_translations$find = translations.find(function (translation) {
    return translation.locale_code === locale;
  })) === null || _translations$find === void 0 ? void 0 : _translations$find.text) || ((_translations$find2 = translations.find(function (translation) {
    return translation.main;
  })) === null || _translations$find2 === void 0 ? void 0 : _translations$find2.text) || translations[0].text;
};
;// CONCATENATED MODULE: ../shared/src/components/CustomBreadcrumbs/index.js
var CustomBreadcrumbs_jsx = react.createElement;





var CustomBreadcrumbs = function CustomBreadcrumbs(_ref) {
  var homeUrl = _ref.homeUrl,
    cityName = _ref.cityName,
    cityUrl = _ref.cityUrl,
    neighborhoodName = _ref.neighborhoodName,
    neighborhoodUrl = _ref.neighborhoodUrl,
    pageTitle = _ref.pageTitle;
  var _useTranslation = (0,esm/* useTranslation */.$G)(),
    t = _useTranslation.t,
    language = _useTranslation.i18n.language;
  var translatedTitle = Array.isArray(pageTitle) ? getTranslatedTitle(pageTitle, language) : pageTitle;
  return CustomBreadcrumbs_jsx(CustomBreadcrumbs_styles_Wrapper, null, CustomBreadcrumbs_jsx(styles_Item, null, CustomBreadcrumbs_jsx("a", {
    href: homeUrl
  }, t('Home')), CustomBreadcrumbs_jsx(breadcrumb_next, null)), CustomBreadcrumbs_jsx(styles_Item, null, CustomBreadcrumbs_jsx("a", {
    href: cityUrl
  }, t('Student accommodation in'), " ", cityName || ''), CustomBreadcrumbs_jsx(breadcrumb_next, null)), neighborhoodName && CustomBreadcrumbs_jsx(styles_Item, null, CustomBreadcrumbs_jsx("a", {
    href: neighborhoodUrl
  }, neighborhoodName), CustomBreadcrumbs_jsx(breadcrumb_next, null)), translatedTitle && CustomBreadcrumbs_jsx(styles_Item, null, translatedTitle));
};
/* harmony default export */ var components_CustomBreadcrumbs = (CustomBreadcrumbs);
;// CONCATENATED MODULE: ../shared/src/utils/stringAndUrlUtils/index.js
var getUrlFriendlySlug = function getUrlFriendlySlug(name) {
  if (!name) {
    return '';
  }
  return name.toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace(/-{2,}/g, '-').replace(/^-+/, '').replace(/-+$/, '');
};
var getHomeUrl = function getHomeUrl(currentLocale) {
  if (!currentLocale) {
    return "https://uniplaces.com/";
  }
  var language = currentLocale.split(/[-_]/)[0];
  var baseUrl = "https://uniplaces.com/".replace(/\/$/, '');
  return language === 'en' ? baseUrl : "".concat(baseUrl, "/").concat(language);
};
;// CONCATENATED MODULE: ./src/components/Breadcrumbs/index.js
var Breadcrumbs_jsx = react.createElement;






var BreadcrumbsContainer = function BreadcrumbsContainer(_ref) {
  var _neighborhood$metadat, _city$metadata, _city$configuration, _city$configuration2, _offerAggregate$accom;

  var offerAggregate = _ref.offerAggregate,
      city = _ref.city,
      neighborhood = _ref.neighborhood,
      currentLocale = _ref.currentLocale;
  var homeUrl = getHomeUrl();
  var baseAccommodationUrl = "".concat(homeUrl, "accommodation");
  var neighborhoodName = neighborhood !== null && neighborhood !== void 0 && (_neighborhood$metadat = neighborhood.metadata) !== null && _neighborhood$metadat !== void 0 && _neighborhood$metadat.name_translations ? (0,transformers/* translationFromLocale */.jG)(neighborhood.metadata.name_translations, currentLocale) : '';
  var cityName = city !== null && city !== void 0 && (_city$metadata = city.metadata) !== null && _city$metadata !== void 0 && _city$metadata.name_translations ? (0,transformers/* translationFromLocale */.jG)(city.metadata.name_translations, currentLocale) : '';
  var breadcrumbsProps = {
    homeUrl: homeUrl,
    cityName: cityName,
    cityUrl: city !== null && city !== void 0 && (_city$configuration = city.configuration) !== null && _city$configuration !== void 0 && _city$configuration.slug ? "".concat(baseAccommodationUrl, "/").concat(city.configuration.slug) : baseAccommodationUrl,
    neighborhoodName: neighborhoodName,
    neighborhoodUrl: neighborhood !== null && neighborhood !== void 0 && neighborhood.slug && city !== null && city !== void 0 && (_city$configuration2 = city.configuration) !== null && _city$configuration2 !== void 0 && _city$configuration2.slug ? "".concat(baseAccommodationUrl, "/").concat(city.configuration.slug, "/neighbourhood/").concat(neighborhood.slug) : null,
    pageTitle: offerAggregate === null || offerAggregate === void 0 ? void 0 : (_offerAggregate$accom = offerAggregate.accommodation_offer) === null || _offerAggregate$accom === void 0 ? void 0 : _offerAggregate$accom.title
  };
  return Breadcrumbs_jsx(components_CustomBreadcrumbs, breadcrumbsProps);
};

var Breadcrumbs_mapStateToProps = function mapStateToProps(_ref2) {
  var offerAggregate = _ref2.offer.offerAggregate;

  var _ref3 = offerAggregate || {},
      _ref3$globalization_a = _ref3.globalization_aggregate,
      city = _ref3$globalization_a.city,
      _ref3$globalization_a2 = _ref3$globalization_a.locale,
      currentLocale = _ref3$globalization_a2 === void 0 ? 'en' : _ref3$globalization_a2,
      neighborhood = _ref3.property_aggregate.neighborhood;

  return {
    offerAggregate: offerAggregate,
    city: city,
    neighborhood: neighborhood,
    currentLocale: currentLocale
  };
};

/* harmony default export */ var Breadcrumbs = ((0,es/* connect */.$j)(Breadcrumbs_mapStateToProps)(BreadcrumbsContainer));
// EXTERNAL MODULE: ../shared/src/utils/date/index.js + 2 modules
var utils_date = __webpack_require__(73544);
;// CONCATENATED MODULE: ../shared/src/components/Unisystem/AvailabilityYears/Description/styles.js

var Description_styles_templateObject;


var Description_styles_Wrapper = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1j9akq5-0"
})(["display:flex;", ";margin-top:", ";", ""], function (props) {
  return props.theme.gap(5);
}, function (props) {
  return props.theme.space(9);
}, theme/* mediaMin.mediumBreakpoint */.A3.mediumBreakpoint(Description_styles_templateObject || (Description_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n    flex-direction: column;\n    ", ";\n  "])), function (props) {
  return props.theme.gap(3, 'column');
}));
var Column = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1j9akq5-1"
})(["display:flex;flex-direction:column;", ";max-height:100%;p{font-size:", ";color:", ";font-weight:600;span{display:inline-block;min-width:150px;font-weight:400;}}"], function (props) {
  return props.theme.gap(3, 'column');
}, function (props) {
  return props.theme.rem(16);
}, function (props) {
  return props.theme.availabilitySection.description.color;
});
;// CONCATENATED MODULE: ../shared/src/components/Unisystem/AvailabilityYears/Description/index.js
var Description_jsx = react.createElement;





var Description_DATE_FORMAT = 'MMMM yyyy';
var Description = function Description(_ref) {
  var _Math$max, _requisites$condition, _availabilities$avail, _availabilities$avail2, _availabilities$avail3, _availabilities$avail4, _availabilities$avail5, _availabilities$avail6, _availabilities$avail7, _availabilities$avail8, _availabilities$avail9, _availabilities$avail10, _availabilities$avail11, _availabilities$avail12, _availabilities$avail13, _availabilities$avail14, _availabilities$avail15, _availabilities$avail16, _availabilities$avail17, _availability_summary, _availability_summary2, _availability_summary3;
  var accommodationOffer = _ref.accommodationOffer;
  var _useTranslation = (0,esm/* useTranslation */.$G)(),
    t = _useTranslation.t,
    language = _useTranslation.i18n.language;
  var requisites = accommodationOffer.requisites,
    availabilities = accommodationOffer.availabilities,
    availability_summary_info = accommodationOffer.availability_summary_info;
  var minimumStayDays = (_Math$max = Math.max((requisites === null || requisites === void 0 ? void 0 : (_requisites$condition = requisites.conditions) === null || _requisites$condition === void 0 ? void 0 : _requisites$condition.minimum_nights) || 0, (availabilities === null || availabilities === void 0 ? void 0 : (_availabilities$avail = availabilities.availability_rules) === null || _availabilities$avail === void 0 ? void 0 : (_availabilities$avail2 = _availabilities$avail[0]) === null || _availabilities$avail2 === void 0 ? void 0 : (_availabilities$avail3 = _availabilities$avail2.gap) === null || _availabilities$avail3 === void 0 ? void 0 : (_availabilities$avail4 = _availabilities$avail3.move_in_out) === null || _availabilities$avail4 === void 0 ? void 0 : (_availabilities$avail5 = _availabilities$avail4.items) === null || _availabilities$avail5 === void 0 ? void 0 : (_availabilities$avail6 = _availabilities$avail5[0]) === null || _availabilities$avail6 === void 0 ? void 0 : (_availabilities$avail7 = _availabilities$avail6.end) === null || _availabilities$avail7 === void 0 ? void 0 : (_availabilities$avail8 = _availabilities$avail7.min) === null || _availabilities$avail8 === void 0 ? void 0 : _availabilities$avail8.days) || 0)) !== null && _Math$max !== void 0 ? _Math$max : 'N/A';
  var maximumStayDays = (_availabilities$avail9 = availabilities === null || availabilities === void 0 ? void 0 : (_availabilities$avail10 = availabilities.availability_rules) === null || _availabilities$avail10 === void 0 ? void 0 : (_availabilities$avail11 = _availabilities$avail10[0]) === null || _availabilities$avail11 === void 0 ? void 0 : (_availabilities$avail12 = _availabilities$avail11.gap) === null || _availabilities$avail12 === void 0 ? void 0 : (_availabilities$avail13 = _availabilities$avail12.move_in_out) === null || _availabilities$avail13 === void 0 ? void 0 : (_availabilities$avail14 = _availabilities$avail13.items) === null || _availabilities$avail14 === void 0 ? void 0 : (_availabilities$avail15 = _availabilities$avail14[0]) === null || _availabilities$avail15 === void 0 ? void 0 : (_availabilities$avail16 = _availabilities$avail15.end) === null || _availabilities$avail16 === void 0 ? void 0 : (_availabilities$avail17 = _availabilities$avail16.max) === null || _availabilities$avail17 === void 0 ? void 0 : _availabilities$avail17.days) !== null && _availabilities$avail9 !== void 0 ? _availabilities$avail9 : null;
  var lastUpdated = (availability_summary_info === null || availability_summary_info === void 0 ? void 0 : (_availability_summary = availability_summary_info.fixed_contract) === null || _availability_summary === void 0 ? void 0 : _availability_summary.last_updated_at) || (availability_summary_info === null || availability_summary_info === void 0 ? void 0 : (_availability_summary2 = availability_summary_info.standard_contract) === null || _availability_summary2 === void 0 ? void 0 : _availability_summary2.last_updated_at) || (availability_summary_info === null || availability_summary_info === void 0 ? void 0 : (_availability_summary3 = availability_summary_info.standard_unitary_contract) === null || _availability_summary3 === void 0 ? void 0 : _availability_summary3.last_updated_at);
  var getAvailableFrom = function getAvailableFrom() {
    var _standard_unitary$ava, _standard_unitary$ava2, _standard$available_p, _standard$available_p2;
    var _ref2 = availabilities !== null && availabilities !== void 0 ? availabilities : {},
      standard_unitary = _ref2.standard_unitary,
      standard = _ref2.standard;
    var standardUnitaryStartDate = standard_unitary === null || standard_unitary === void 0 ? void 0 : (_standard_unitary$ava = standard_unitary.available_periods) === null || _standard_unitary$ava === void 0 ? void 0 : (_standard_unitary$ava2 = _standard_unitary$ava[0]) === null || _standard_unitary$ava2 === void 0 ? void 0 : _standard_unitary$ava2.start_date;
    var standardStartDate = standard === null || standard === void 0 ? void 0 : (_standard$available_p = standard.available_periods) === null || _standard$available_p === void 0 ? void 0 : (_standard$available_p2 = _standard$available_p[0]) === null || _standard$available_p2 === void 0 ? void 0 : _standard$available_p2.start_date;
    return (0,parseISO/* default */.Z)(standardUnitaryStartDate || standardStartDate || new Date().toISOString());
  };
  return Description_jsx(Description_styles_Wrapper, null, Description_jsx(Column, null, Description_jsx("p", null, Description_jsx("span", null, t('Available from')), " ", (0,utils_date/* formatDate */.p6)(getAvailableFrom(), language, Description_DATE_FORMAT)), Description_jsx("p", null, Description_jsx("span", null, t('Min stay')), " ", minimumStayDays, " ", t('nights')), Description_jsx("p", null, Description_jsx("span", null, t('Max stay')), " ", maximumStayDays ? "".concat(maximumStayDays, " ").concat(t('nights')) : t('No maximum stay'))), Description_jsx(Column, null, Description_jsx("p", null, Description_jsx("span", null, t('Last updated')), " ", lastUpdated ? (0,utils_date/* formatDate */.p6)(lastUpdated, language, Description_DATE_FORMAT) : 'N/A')));
};
/* harmony default export */ var AvailabilityYears_Description = (Description);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/startOfYear/index.js
var startOfYear = __webpack_require__(81290);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/addMonths/index.js
var addMonths = __webpack_require__(28187);
;// CONCATENATED MODULE: ../shared/src/components/Unisystem/AvailabilityYears/Years/styles.js

var Years_styles_templateObject, Years_styles_templateObject2;


var Years_styles_Wrapper = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1pd9fao-0"
})(["display:flex;flex-wrap:wrap;", ""], function (_ref) {
  var theme = _ref.theme;
  return theme.gap(7);
});
var Year = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1pd9fao-1"
})(["display:flex;flex-direction:column;align-items:center;width:265px;", ""], theme/* mediaMin.mediumBreakpoint */.A3.mediumBreakpoint(Years_styles_templateObject || (Years_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n    width: 100%;\n  "]))));
var YearTitle = /*#__PURE__*/styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
  componentId: "sc-1pd9fao-2"
})(["font-size:", ";font-weight:600;line-height:", ";color:", ";"], function (props) {
  return props.theme.rem(18);
}, function (props) {
  return props.theme.rem(20);
}, function (props) {
  return props.theme.colors.blueDianne;
});
var Months = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1pd9fao-3"
})(["display:grid;grid-template-columns:repeat(4,58px);grid-template-rows:repeat(3,50px);gap:10px;margin-top:", ";", ""], function (props) {
  return props.theme.space(5);
}, theme/* mediaMin.mediumBreakpoint */.A3.mediumBreakpoint(Years_styles_templateObject2 || (Years_styles_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    width: 100%;\n    grid-template-columns: repeat(4, 1fr);\n  "]))));
var Month = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1pd9fao-4"
})(["display:flex;align-items:center;flex-direction:column;position:relative;border-radius:4px;color:", ";background-color:", ";&.available{background:", ";& > span{color:", ";}}&.occupied{background:", ";}& > .occupied ~ span{color:", ";}span{&.quarters,&.three-quarters,&.halfs{position:absolute;height:50px;background:", ";top:0;left:0;z-index:1;border-top-left-radius:4px;border-bottom-left-radius:4px;}&.three-quarters{width:75%;}&.quarters{width:25%;}&.halfs{width:50%;}&.halfs-last,&.three-quarters-last,&.quarters-last{left:unset;right:0;border-top-left-radius:0;border-bottom-left-radius:0;border-top-right-radius:4px;border-bottom-right-radius:4px;}&.halfs,&.halfs-last,&.quarters-last,&.three-quarters-last{&.occupied{background:", ";}}}"], function (props) {
  return props.theme.colors.cornFlowerBlue;
}, function (props) {
  return props.theme.colors.mistySilver;
}, function (props) {
  return props.theme.colors.bluishCyan;
}, function (props) {
  return props.theme.colors.blueDianne;
}, function (props) {
  return props.theme.colors.palePeach;
}, function (props) {
  return props.theme.colors.blueDianne;
}, function (props) {
  return props.theme.colors.bluishCyan;
}, function (props) {
  return props.theme.colors.palePeach;
});
var MonthTitle = /*#__PURE__*/styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  componentId: "sc-1pd9fao-5"
})(["font-size:", ";line-height:", ";text-transform:capitalize;z-index:1;"], function (props) {
  return props.theme.rem(16);
}, function (props) {
  return props.theme.rem(24);
});
var MonthPrice = /*#__PURE__*/styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  componentId: "sc-1pd9fao-6"
})(["font-size:", ";z-index:1;"], function (props) {
  return props.theme.rem(14);
});
var Legend = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1pd9fao-7"
})(["display:flex;", " flex-basis:100%;margin-top:", ";span{display:inline-flex;align-items:center;position:relative;padding-inline-start:", ";color:", ";&:before{content:'';position:absolute;left:0;width:20px;height:20px;border-radius:4px;}&:first-child{&:before{background:", ";}}&:last-child{&:before{background:", ";}}}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.gap(4);
}, function (props) {
  return props.theme.space(7);
}, function (props) {
  return props.theme.space(9);
}, function (props) {
  return props.theme.colors.blueDianne;
}, function (props) {
  return props.theme.colors.bluishCyan;
}, function (props) {
  return props.theme.colors.palePeach;
});
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/startOfMonth/index.js
var startOfMonth = __webpack_require__(12414);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/endOfMonth/index.js
var endOfMonth = __webpack_require__(8548);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/isPast/index.js
var isPast = __webpack_require__(46552);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/startOfDay/index.js
var startOfDay = __webpack_require__(10405);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/endOfDay/index.js
var endOfDay = __webpack_require__(11106);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/isAfter/index.js
var isAfter = __webpack_require__(42598);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/isBefore/index.js
var isBefore = __webpack_require__(63063);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/isSameYear/index.js
var isSameYear = __webpack_require__(31794);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/isSameMonth/index.js
var isSameMonth = __webpack_require__(53009);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/getMonth/index.js
var getMonth = __webpack_require__(51981);
;// CONCATENATED MODULE: ../shared/src/constants/availability.js
var CONTRACT_TYPE = {
  FIXED: 'fixed',
  FIXED_UNITARY: 'fixed-unitary',
  NIGHTLY: 'nightly',
  FORTNIGHT: 'fortnight',
  MONTHLY: 'monthly'
};
var AVAILABILITY_TYPE = {
  FIXED: {
    AVAILABLE: 'available',
    OCCUPIED: 'occupied'
  },
  STANDARD_UNITARY: {
    AVAILABLE: 'available',
    OCCUPIED: 'occupied'
  },
  STANDARD: {
    AVAILABLE: 'available',
    OCCUPIED: 'occupied'
  }
};
var HALF_QUARTER_TYPE = {
  '2': 'three-quarters',
  '1': 'halfs',
  '0': 'quarters'
};
var HALF_QUARTER_LAST_TYPE = {
  '0': 'three-quarters three-quarters-last',
  '1': 'halfs halfs-last',
  '2': 'quarters quarters-last'
};
;// CONCATENATED MODULE: ../shared/src/utils/avalabilityCalculations/index.js



var getQuartersOrHalfs = function getQuartersOrHalfs(date) {
  var isLast = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var days = date.getDate();
  var start = (0,startOfMonth/* default */.Z)(date).getDate();
  var end = (0,endOfMonth/* default */.Z)(date).getDate();
  if (days === start || days === end) {
    return null;
  }
  var half = Math.floor(end / 2);
  var quarter = Math.floor(end / 3);
  var order = [quarter, half, quarter * 2];
  var closest = order.reduce(function (_ref, curr, index) {
    var pos = _ref.pos,
      prev = _ref.prev;
    return Math.abs(curr - days) < Math.abs(prev - days) ? {
      pos: index,
      prev: curr
    } : {
      pos: pos,
      prev: prev
    };
  }, {
    pos: 0,
    prev: 0
  });
  return isLast ? HALF_QUARTER_LAST_TYPE[closest.pos] : HALF_QUARTER_TYPE[closest.pos];
};
var getMonthClassName = function getMonthClassName(date) {
  var blockedIntervals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if ((0,isPast/* default */.Z)((0,endOfMonth/* default */.Z)(date))) {
    return {
      className: '',
      childClassName: ''
    };
  }
  var today = new Date();
  var isCurrentMonth = (0,format/* default */.Z)(today, 'yyyy-MM') === (0,format/* default */.Z)(date, 'yyyy-MM');
  var currentMonthClass = isCurrentMonth ? getQuartersOrHalfs(today, true) : null;
  var blocked = blockedIntervals.reduce(function (acc, _ref2) {
    var start_date = _ref2.start_date,
      end_date = _ref2.end_date;
    var startTemp = (0,startOfDay/* default */.Z)(new Date(start_date));
    var end = (0,endOfDay/* default */.Z)(new Date(end_date));
    var start = (0,isAfter/* default */.Z)(end, today) && (0,isBefore/* default */.Z)(startTemp, today) ? today : startTemp;
    if ((0,isBefore/* default */.Z)(end, today)) {
      return acc;
    }
    var startMonth = (0,endOfDay/* default */.Z)((0,startOfMonth/* default */.Z)(date));
    var endMonth = (0,startOfDay/* default */.Z)((0,endOfMonth/* default */.Z)(date));
    var isMonthBlocked = (0,isAfter/* default */.Z)(startMonth, start) && (0,isBefore/* default */.Z)(endMonth, end);
    if (isMonthBlocked) {
      return {
        className: currentMonthClass ? '' : AVAILABILITY_TYPE.STANDARD_UNITARY.OCCUPIED,
        childClassName: "".concat(currentMonthClass || '', " occupied")
      };
    }
    if (!((0,isSameYear/* default */.Z)(startMonth, start) && (0,isSameMonth/* default */.Z)(startMonth, start)) && !((0,isSameYear/* default */.Z)(endMonth, end) && (0,isSameMonth/* default */.Z)(endMonth, end))) {
      return acc;
    }
    var isStartAfter = (0,isAfter/* default */.Z)(start, startMonth);
    var block = isStartAfter ? start : end;
    var partBlocked = getQuartersOrHalfs(block, isStartAfter);
    return {
      className: currentMonthClass ? '' : AVAILABILITY_TYPE.STANDARD_UNITARY.AVAILABLE,
      childClassName: "".concat(partBlocked, " occupied")
    };
  }, null);
  return blocked || {
    className: currentMonthClass ? null : AVAILABILITY_TYPE.STANDARD_UNITARY.AVAILABLE,
    childClassName: currentMonthClass
  };
};
var getMonthPrice = function getMonthPrice(date, accommodationOffer, t) {
  var _accommodationOffer$c;
  var isTypeFixed = [CONTRACT_TYPE.FIXED, CONTRACT_TYPE.FIXED_UNITARY].includes(accommodationOffer.contract.type);
  if (isTypeFixed) {
    var _accommodationOffer$r = accommodationOffer.reference_price,
      amount = _accommodationOffer$r.amount,
      currencyCode = _accommodationOffer$r.currency_code;
    return (0,money/* formatMoney */.lb)(amount, currencyCode);
  }
  var rents = ((_accommodationOffer$c = accommodationOffer.contract.standard) === null || _accommodationOffer$c === void 0 ? void 0 : _accommodationOffer$c.rents) || [];
  var monthIndex = (0,getMonth/* default */.Z)(date);
  var rent = rents[monthIndex];
  if (!rent) {
    return t('no_price');
  }
  return (0,money/* formatMoney */.lb)(rent.amount, rent.currency_code);
};
;// CONCATENATED MODULE: ../shared/src/components/Unisystem/AvailabilityYears/Years/index.js



var Years_jsx = react.createElement;
function Years_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Years_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Years_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Years_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }






var Years = function Years(_ref) {
  var accommodationOffer = _ref.accommodationOffer;
  var _useTranslation = (0,esm/* useTranslation */.$G)(),
    t = _useTranslation.t,
    language = _useTranslation.i18n.language;
  var generatedMonths = Array.from({
    length: 24
  }, function (_, index) {
    var _accommodationOffer$a, _accommodationOffer$a2;
    var today = new Date();
    var startYear = (0,startOfYear/* default */.Z)(today);
    var date = (0,addMonths/* default */.Z)(startYear, index);
    var month = (0,utils_date/* formatDate */.p6)(date, language, 'MMM');
    var year = date.getFullYear();
    var blockedIntervals = ((_accommodationOffer$a = accommodationOffer.availabilities) === null || _accommodationOffer$a === void 0 ? void 0 : (_accommodationOffer$a2 = _accommodationOffer$a.standard_unitary) === null || _accommodationOffer$a2 === void 0 ? void 0 : _accommodationOffer$a2.blocked_intervals) || [];
    var className = getMonthClassName(date, blockedIntervals);
    return Years_objectSpread({
      year: year,
      month: month,
      price: getMonthPrice(date, accommodationOffer, t)
    }, className);
  });
  var groupedMonths = generatedMonths.reduce(function (acc, monthData) {
    var rest = acc[monthData.year] || [];
    return Years_objectSpread(Years_objectSpread({}, acc), {}, (0,defineProperty/* default */.Z)({}, monthData.year, [].concat((0,toConsumableArray/* default */.Z)(rest), [monthData])));
  }, {});
  return Years_jsx(Years_styles_Wrapper, null, Object.entries(groupedMonths).map(function (_ref2) {
    var _ref3 = (0,slicedToArray/* default */.Z)(_ref2, 2),
      year = _ref3[0],
      months = _ref3[1];
    return Years_jsx(Year, {
      key: year
    }, Years_jsx(YearTitle, null, year), Years_jsx(Months, null, months.map(function (monthData, index) {
      return Years_jsx(Month, {
        key: "".concat(year, "-").concat(index),
        className: "".concat(monthData.className)
      }, monthData.childClassName && Years_jsx("span", {
        className: monthData.childClassName
      }), Years_jsx(MonthTitle, null, monthData.month), Years_jsx(MonthPrice, null, monthData.price));
    })));
  }), Years_jsx(Legend, null, Years_jsx("span", null, t('Available')), Years_jsx("span", null, t('Occupied'))));
};
/* harmony default export */ var AvailabilityYears_Years = (Years);
;// CONCATENATED MODULE: ../shared/src/components/Unisystem/AvailabilityYears/styles.js

var AvailabilityYears_styles_Wrapper = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1k4of7i-0"
})(["width:100%;margin-top:40px;"]);
;// CONCATENATED MODULE: ../shared/src/components/Unisystem/AvailabilityYears/index.js
var AvailabilityYears_jsx = react.createElement;




var AvailabilityYears = function AvailabilityYears(_ref) {
  var accommodationOffer = _ref.accommodationOffer;
  return AvailabilityYears_jsx(AvailabilityYears_styles_Wrapper, null, AvailabilityYears_jsx(AvailabilityYears_Years, {
    accommodationOffer: accommodationOffer
  }), AvailabilityYears_jsx(AvailabilityYears_Description, {
    accommodationOffer: accommodationOffer
  }));
};
/* harmony default export */ var Unisystem_AvailabilityYears = (AvailabilityYears);
;// CONCATENATED MODULE: ./src/components/Availability/styles.js

var Availability_styles_Wrapper = /*#__PURE__*/styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  componentId: "sc-1xxuk9t-0"
})(["width:100%;h2{font-family:'IntervalNextReg',sans-serif;font-size:", ";line-height:", ";font-weight:600;color:", ";}"], function (props) {
  return props.theme.rem(22);
}, function (props) {
  return props.theme.rem(26);
}, function (props) {
  return props.theme.availabilitySection.description.color;
});
;// CONCATENATED MODULE: ./src/components/Availability/index.js
var Availability_jsx = react.createElement;






var Availability = function Availability(_ref) {
  var accommodationOffer = _ref.accommodationOffer;

  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t;

  return Availability_jsx(Availability_styles_Wrapper, {
    id: "Availability"
  }, Availability_jsx("h2", null, t('Availability')), Availability_jsx(Unisystem_AvailabilityYears, {
    accommodationOffer: accommodationOffer
  }));
};

var Availability_mapStateToProps = function mapStateToProps(_ref2) {
  var accommodationOffer = _ref2.offer.offerAggregate.accommodation_offer;
  return {
    accommodationOffer: accommodationOffer
  };
};

/* harmony default export */ var components_Availability = ((0,es/* connect */.$j)(Availability_mapStateToProps)(Availability));
// EXTERNAL MODULE: ../shared/src/hooks/index.js + 2 modules
var hooks = __webpack_require__(31681);
// EXTERNAL MODULE: ../shared/src/components/Unisystem/StatusBanner/styles.js
var StatusBanner_styles = __webpack_require__(97749);
;// CONCATENATED MODULE: ./src/components/ServicesExpenses/Mobile/styles.js


var Mobile_styles_Wrapper = /*#__PURE__*/styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  componentId: "sc-12u4vnd-0"
})(["width:100%;h2{font-family:'IntervalNextReg',sans-serif;font-size:", ";line-height:", ";font-weight:600;color:", ";& + p{font-size:", ";line-height:", ";color:", ";margin-top:", ";}}"], function (props) {
  return props.theme.rem(22);
}, function (props) {
  return props.theme.rem(26);
}, function (props) {
  return props.theme.servicesExpensesSection.text.color;
}, function (props) {
  return props.theme.rem(16);
}, function (props) {
  return props.theme.rem(20);
}, function (props) {
  return props.theme.servicesExpensesSection.text.color;
}, function (props) {
  return props.theme.space(3);
});
var SectionItemList = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-12u4vnd-1"
})(["display:flex;flex-direction:column;"]);
var SectionItemWrapper = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-12u4vnd-2"
})(["display:flex;justify-content:space-between;padding-bottom:", ";& + p{font-size:", ";line-height:", ";margin-bottom:", ";color:", ";&:not(:last-of-type){margin-bottom:", ";border-bottom:1px solid ", ";padding-bottom:", ";}}"], function (props) {
  return props.theme.space(2);
}, function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.rem(18);
}, function (props) {
  return props.theme.space(2);
}, function (props) {
  return props.theme.servicesExpensesSection.text.color;
}, function (props) {
  return props.theme.space(3);
}, function (props) {
  return props.theme.sections.separator.color;
}, function (props) {
  return props.theme.space(2);
});
var Sections = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-12u4vnd-3"
})(["width:100%;padding:", " ", ";border:1px solid ", ";border-radius:8px;display:flex;flex-direction:column;", ";&:not(:last-of-type){margin-bottom:", ";}&:first-of-type{margin-top:", ";}h3{font-size:", ";line-height:", ";font-weight:600;color:", ";}", "{margin-top:2px;padding:0;}"], function (props) {
  return props.theme.space(4);
}, function (props) {
  return props.theme.space(5);
}, function (props) {
  return props.theme.sections.border.color;
}, function (_ref) {
  var theme = _ref.theme;
  return theme.gap(4);
}, function (props) {
  return props.theme.space(2);
}, function (props) {
  return props.theme.space(5);
}, function (props) {
  return props.theme.rem(18);
}, function (props) {
  return props.theme.rem(20);
}, function (props) {
  return props.theme.servicesExpensesSection.text.color;
}, StatusBanner_styles/* Wrapper */.im);
var styles_Description = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-12u4vnd-4"
})(["color:", ";display:flex;flex-direction:row;align-items:center;column-gap:8px;h4{font-size:", ";line-height:", ";}"], function (props) {
  return props.theme.servicesExpensesSection.text.color;
}, function (props) {
  return props.theme.rem(16);
}, function (props) {
  return props.theme.rem(20);
});
var Value = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-12u4vnd-5"
})(["font-size:", ";line-height:", ";text-align:right;font-weight:600;color:", ";"], function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.rem(20);
}, function (props) {
  return props.theme.servicesExpensesSection.text.color;
});
var Bills = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-12u4vnd-6"
})(["width:100%;display:flex;flex-direction:column;", ";", " ", "{font-size:", ";line-height:", ";color:", ";}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.gap(4, 'column');
}, function (props) {
  return !props.canShowBillsTotal && "\n    margin-bottom: ".concat(props.theme.space(1), ";\n  ");
}, StatusBanner_styles/* Wrapper */.im, function (props) {
  return props.theme.rem(12);
}, function (props) {
  return props.theme.rem(18);
}, function (props) {
  return props.theme.servicesExpensesSection.statusBanner.textColor;
});
var BillsSeparator = /*#__PURE__*/styled_components_browser_esm/* default.hr.withConfig */.ZP.hr.withConfig({
  componentId: "sc-12u4vnd-7"
})(["border:0;border-top:", ";"], function (props) {
  return "1px solid ".concat(props.theme.sections.separator.color);
});
var BillsTotalWrapper = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-12u4vnd-8"
})(["display:flex;flex-direction:column;", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.gap(1);
});
var BillsTotal = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-12u4vnd-9"
})(["display:flex;align-items:center;justify-content:space-between;font-size:", ";line-height:", ";border-radius:4px;padding:", " ", ";color:", ";"], function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.rem(20);
}, function (props) {
  return props.theme.space(1);
}, function (props) {
  return props.theme.space(2);
}, function (props) {
  return props.theme.servicesExpensesSection.text.color;
});
var BillsTotalText = /*#__PURE__*/styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  componentId: "sc-12u4vnd-10"
})(["font-size:", ";line-height:", ";"], function (props) {
  return props.theme.rem(16);
}, function (props) {
  return props.theme.rem(26);
});
var BillsTotalAmount = /*#__PURE__*/styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  componentId: "sc-12u4vnd-11"
})(["font-weight:700;font-size:", ";line-height:", ";"], function (props) {
  return props.theme.rem(16);
}, function (props) {
  return props.theme.rem(20);
});
// EXTERNAL MODULE: ../shared/src/components/Unisystem/StatusBanner/index.js
var StatusBanner = __webpack_require__(14096);
;// CONCATENATED MODULE: ../shared/src/svg/assigned-file.js


var assigned_file_excluded = ["color", "fillColor"];
var assigned_file_jsx = react.createElement;

var AssignedFile = function AssignedFile(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#224251' : _ref$color,
    _ref$fillColor = _ref.fillColor,
    fillColor = _ref$fillColor === void 0 ? '#fff' : _ref$fillColor,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, assigned_file_excluded);
  return assigned_file_jsx("svg", (0,esm_extends/* default */.Z)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none"
  }, props), assigned_file_jsx("g", null, assigned_file_jsx("path", {
    fill: fillColor,
    d: "M16.25 4.758h-10V26.65L10 25.434l3.75 1.216 3.75-1.216 3.75 1.216V9.623c0-2.294 0-3.44-.733-4.152-.732-.713-1.91-.713-4.267-.713Z"
  }), assigned_file_jsx("path", {
    stroke: color,
    d: "M6.25 4.758h10c2.358 0 3.535 0 4.267.713.733.712.733 1.858.733 4.152V26.65l-3.75-1.216-3.75 1.216L10 25.434 6.25 26.65V4.15"
  }), assigned_file_jsx("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeWidth: 0.7,
    d: "M18.125 11.65H12.5m3.75 1.182H12.5M18.125 19.15H12.5m3.75 1.182H12.5"
  }), assigned_file_jsx("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7,
    d: "m8.75 22.275 1.875-2.355H8.75L10 17.9"
  }), assigned_file_jsx("path", {
    stroke: color,
    strokeLinejoin: "round",
    strokeWidth: 0.7,
    d: "M11.25 12.9a1.25 1.25 0 1 1-2.5 0c0-.69 1.25-2.5 1.25-2.5s1.25 1.81 1.25 2.5Z",
    clipRule: "evenodd"
  }), assigned_file_jsx("path", {
    fill: fillColor,
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M17.5 6.65a3.75 3.75 0 1 0 7.5 0 3.75 3.75 0 0 0-7.5 0Z"
  }), assigned_file_jsx("path", {
    fill: fillColor,
    d: "m22.5 5.4-1.312 2.32a.389.389 0 0 1-.109.125.264.264 0 0 1-.28.027.345.345 0 0 1-.122-.103L20 6.87"
  }), assigned_file_jsx("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m22.5 5.4-1.312 2.32a.389.389 0 0 1-.109.125.264.264 0 0 1-.28.027.345.345 0 0 1-.122-.103L20 6.87"
  })), assigned_file_jsx("defs", null, assigned_file_jsx("clipPath", {
    id: "a"
  }, assigned_file_jsx("path", {
    fill: fillColor,
    d: "M0 .4h30v30H0z"
  }))));
};
/* harmony default export */ var assigned_file = (AssignedFile);
;// CONCATENATED MODULE: ./src/components/ServicesExpenses/BillItem/styles.js

var BillItem_styles_Wrapper = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1x0yjfx-0"
})(["display:flex;flex-direction:column;justify-content:center;color:", ";", ";span{display:flex;flex-direction:row;font-size:", ";line-height:", ";max-height:fit-content;svg{margin-right:", ";}&:last-of-type{flex:1;align-items:center;font-size:", ";}}"], function (props) {
  return props.theme.servicesExpensesSection.text.color;
}, function (_ref) {
  var theme = _ref.theme;
  return theme.gap(1);
}, function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.rem(20);
}, function (props) {
  return props.theme.space(1);
}, function (props) {
  return props.theme.rem(16);
});
var BillIncluded = /*#__PURE__*/styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  componentId: "sc-1x0yjfx-1"
})(["", " ", ""], function (props) {
  return props.hasMaxAmount && "\n      font-weight: 700;\n\n      span {\n        display: inline-block;\n        font-weight: 400;\n        margin-left: ".concat(props.theme.space(1), ";\n      }\n    ");
}, function (props) {
  return !props.hasMaxAmount && "\n      color: ".concat(props.theme.servicesExpensesSection.billsGridItem.colors.billIncluded, ";\n    ");
});
// EXTERNAL MODULE: ../shared/src/svg/check-bullet-green.js
var check_bullet_green = __webpack_require__(84717);
;// CONCATENATED MODULE: ../shared/src/svg/cross-bullet.js


var cross_bullet_excluded = ["color"];
var cross_bullet_jsx = react.createElement;

var CrossBullet = function CrossBullet(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#224251' : _ref$color,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, cross_bullet_excluded);
  return cross_bullet_jsx("svg", (0,esm_extends/* default */.Z)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none"
  }, props), cross_bullet_jsx("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M10 18.333A9.167 9.167 0 1 0 10 0a9.167 9.167 0 0 0 0 18.333ZM5.574 4.74a.75.75 0 0 1 1.06 0l3.283 3.283L13.2 4.74a.75.75 0 1 1 1.06 1.061l-3.282 3.283 3.282 3.282a.75.75 0 0 1-1.06 1.061l-3.283-3.282-3.283 3.282a.75.75 0 1 1-1.06-1.06l3.282-3.283L5.574 5.8a.75.75 0 0 1 0-1.06Z",
    clipRule: "evenodd"
  }));
};
/* harmony default export */ var cross_bullet = (CrossBullet);
// EXTERNAL MODULE: ../shared/src/utils/stringManipulation/index.js
var stringManipulation = __webpack_require__(1660);
;// CONCATENATED MODULE: ./src/components/ServicesExpenses/BillItem/index.js
var BillItem_jsx = react.createElement;







var BillItem = function BillItem(_ref) {
  var _bill$maximum, _bill$maximum$max;

  var name = _ref.name,
      bill = _ref.bill,
      t = _ref.t,
      formatMoney = _ref.formatMoney;
  var colors = src_theme/* theme.servicesExpensesSection.billsGridItem.colors */.r.servicesExpensesSection.billsGridItem.colors;
  var hasMaxAmount = (_bill$maximum = bill.maximum) === null || _bill$maximum === void 0 ? void 0 : (_bill$maximum$max = _bill$maximum.max) === null || _bill$maximum$max === void 0 ? void 0 : _bill$maximum$max.amount;
  return BillItem_jsx(BillItem_styles_Wrapper, null, BillItem_jsx("span", null, t((0,stringManipulation/* capitalizeFirstLetter */.fm)(name))), BillItem_jsx("span", null, bill.included ? BillItem_jsx(BillIncluded, {
    hasMaxAmount: hasMaxAmount
  }, hasMaxAmount ? BillItem_jsx(react.Fragment, null, t('Up to'), " ", formatMoney(bill.maximum.max.amount, bill.maximum.max.currency_code), BillItem_jsx("span", null, "/", t('month'))) : BillItem_jsx(react.Fragment, null, BillItem_jsx(check_bullet_green/* default */.Z, {
    fillColor: colors.billIncluded
  }), BillItem_jsx("span", null, t('Included in the price')))) : BillItem_jsx(react.Fragment, null, BillItem_jsx(cross_bullet, null), BillItem_jsx("span", null, t('Not included in the price')))));
};

/* harmony default export */ var ServicesExpenses_BillItem = (BillItem);
;// CONCATENATED MODULE: ./src/components/ServicesExpenses/Mobile/index.js
var Mobile_jsx = react.createElement;









var ServicesExpensesMobile = function ServicesExpensesMobile(_ref) {
  var _bills$billNames$, _bills$billNames$$max, _bills$billNames$$max2;

  var servicesAndExpensesData = _ref.servicesAndExpensesData,
      landlordPoliciesData = _ref.landlordPoliciesData,
      bills = _ref.bills,
      billNames = _ref.billNames,
      canShowTotalBills = _ref.canShowTotalBills,
      totalBills = _ref.totalBills,
      globalMaximum = _ref.globalMaximum,
      isEveryBillCovered = _ref.isEveryBillCovered;

  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t;

  return Mobile_jsx(Mobile_styles_Wrapper, {
    id: "Services and expenses"
  }, Mobile_jsx("h2", null, t('Services and expenses')), Mobile_jsx("p", null, t('Extra services, expenses and fees to be paid directly to the Landlord')), servicesAndExpensesData.length > 0 && Mobile_jsx(Sections, null, Mobile_jsx("h3", null, t('One-time payments')), Mobile_jsx(SectionItemList, null, servicesAndExpensesData.map(function (item, index) {
    return Mobile_jsx(SectionItem, {
      key: index,
      title: item.title,
      description: item.description,
      value: item.price
    });
  }))), Mobile_jsx(Sections, null, Mobile_jsx("h3", null, t('Fixed Monthly Bills')), isEveryBillCovered && Mobile_jsx(StatusBanner/* default */.Z, {
    message: t('Everything is covered! All bills are included in the price.'),
    icon: Mobile_jsx(assigned_file, {
      color: src_theme/* theme.unisystem.statusBanner.text.green */.r.unisystem.statusBanner.text.green
    }),
    color: 'green',
    type: 'text'
  }), Mobile_jsx(Bills, {
    canShowBillsTotal: true
  }, isEveryBillCovered && Mobile_jsx(BillsSeparator, null), billNames.map(function (billName, index) {
    var isLastBill = index + 1 === billNames.length;
    return Mobile_jsx(react.Fragment, {
      key: billName
    }, Mobile_jsx(ServicesExpenses_BillItem, {
      name: billName,
      bill: bills[billName],
      t: t,
      formatMoney: utils/* formatMoney */.lb
    }), !isLastBill && Mobile_jsx(BillsSeparator, null));
  }), canShowTotalBills && Mobile_jsx(BillsTotalWrapper, null, Mobile_jsx(BillsSeparator, null), Mobile_jsx(BillsTotal, null, Mobile_jsx(BillsTotalText, null, t('Total monthly bills included up to')), Mobile_jsx(BillsTotalAmount, null, (0,utils/* formatMoney */.lb)((globalMaximum === null || globalMaximum === void 0 ? void 0 : globalMaximum.amount) || totalBills, (globalMaximum === null || globalMaximum === void 0 ? void 0 : globalMaximum.currency_code) || ((_bills$billNames$ = bills[billNames[0]]) === null || _bills$billNames$ === void 0 ? void 0 : (_bills$billNames$$max = _bills$billNames$.maximum) === null || _bills$billNames$$max === void 0 ? void 0 : (_bills$billNames$$max2 = _bills$billNames$$max.max) === null || _bills$billNames$$max2 === void 0 ? void 0 : _bills$billNames$$max2.currency_code) || 'EUR')))))), landlordPoliciesData.length > 0 && Mobile_jsx(Sections, null, Mobile_jsx("h3", null, t('Other fees')), Mobile_jsx(SectionItemList, null, landlordPoliciesData.map(function (item, index) {
    return Mobile_jsx(SectionItem, {
      key: index,
      title: item.title,
      description: item.description,
      value: item.value,
      banner: item.banner
    });
  }))));
};

var SectionItem = function SectionItem(_ref2) {
  var title = _ref2.title,
      description = _ref2.description,
      value = _ref2.value,
      banner = _ref2.banner;
  return Mobile_jsx(react.Fragment, null, Mobile_jsx(SectionItemWrapper, null, Mobile_jsx(styles_Description, null, Mobile_jsx("h4", null, title)), Mobile_jsx(Value, null, value)), Mobile_jsx("p", null, description), banner);
};

/* harmony default export */ var Mobile = (ServicesExpensesMobile);
;// CONCATENATED MODULE: ./src/components/ServicesExpenses/Desktop/styles.js


var Desktop_styles_Wrapper = /*#__PURE__*/styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  componentId: "sc-1pyjdju-0"
})(["width:100%;h2{font-family:'IntervalNextReg',sans-serif;font-size:", ";line-height:", ";font-weight:600;color:", ";& + p{font-size:", ";line-height:", ";color:", ";margin-top:", ";}}"], function (props) {
  return props.theme.rem(22);
}, function (props) {
  return props.theme.rem(26);
}, function (props) {
  return props.theme.servicesExpensesSection.text.color;
}, function (props) {
  return props.theme.rem(16);
}, function (props) {
  return props.theme.rem(20);
}, function (props) {
  return props.theme.servicesExpensesSection.text.color;
}, function (props) {
  return props.theme.space(3);
});
var styles_SectionItemList = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1pyjdju-1"
})(["display:flex;flex-direction:column;"]);
var styles_SectionItemWrapper = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1pyjdju-2"
})(["display:flex;justify-content:space-between;padding-bottom:", ";& + p{font-size:", ";line-height:", ";margin-bottom:", ";color:", ";&:not(:last-of-type){margin-bottom:", ";border-bottom:1px solid ", ";padding-bottom:", ";}}"], function (props) {
  return props.theme.space(2);
}, function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.rem(18);
}, function (props) {
  return props.theme.space(2);
}, function (props) {
  return props.theme.servicesExpensesSection.text.color;
}, function (props) {
  return props.theme.space(3);
}, function (props) {
  return props.theme.sections.separator.color;
}, function (props) {
  return props.theme.space(2);
});
var styles_Sections = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1pyjdju-3"
})(["width:630px;padding:", " ", ";border:1px solid ", ";border-radius:8px;display:flex;flex-direction:column;", ";&:not(:last-of-type){margin-bottom:", ";}&:first-of-type{margin-top:", ";}h3{font-size:", ";line-height:", ";font-weight:600;color:", ";}", "{margin-top:2px;padding:0;}"], function (props) {
  return props.theme.space(4);
}, function (props) {
  return props.theme.space(5);
}, function (props) {
  return props.theme.sections.border.color;
}, function (_ref) {
  var theme = _ref.theme;
  return theme.gap(4);
}, function (props) {
  return props.theme.space(2);
}, function (props) {
  return props.theme.space(5);
}, function (props) {
  return props.theme.rem(18);
}, function (props) {
  return props.theme.rem(20);
}, function (props) {
  return props.theme.servicesExpensesSection.text.color;
}, StatusBanner_styles/* Wrapper */.im);
var Desktop_styles_Description = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1pyjdju-4"
})(["color:", ";display:flex;flex-direction:row;align-items:center;column-gap:8px;h4{font-size:", ";line-height:", ";}"], function (props) {
  return props.theme.servicesExpensesSection.text.color;
}, function (props) {
  return props.theme.rem(16);
}, function (props) {
  return props.theme.rem(20);
});
var styles_Value = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1pyjdju-5"
})(["font-size:", ";line-height:", ";text-align:right;font-weight:600;color:", ";"], function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.rem(20);
}, function (props) {
  return props.theme.servicesExpensesSection.text.color;
});
var styles_Bills = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1pyjdju-6"
})(["width:100%;display:grid;grid-template-columns:repeat(2,minmax(0,1fr));column-gap:", ";row-gap:", ";", " ", "{grid-column:1 / span 2;font-size:", ";line-height:", ";color:", ";}"], function (props) {
  return props.theme.space(4);
}, function (props) {
  return props.theme.space(4);
}, function (props) {
  return !props.canShowBillsTotal && "\n    margin-bottom: ".concat(props.theme.space(1), ";\n  ");
}, StatusBanner_styles/* Wrapper */.im, function (props) {
  return props.theme.rem(12);
}, function (props) {
  return props.theme.rem(18);
}, function (props) {
  return props.theme.servicesExpensesSection.statusBanner.textColor;
});
var styles_BillsSeparator = /*#__PURE__*/styled_components_browser_esm/* default.hr.withConfig */.ZP.hr.withConfig({
  componentId: "sc-1pyjdju-7"
})(["border:0;border-top:", ";grid-column:1 / span 2;"], function (props) {
  return "1px solid ".concat(props.theme.sections.separator.color);
});
var styles_BillsTotalWrapper = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1pyjdju-8"
})(["display:flex;flex-direction:column;grid-column:1 / span 2;", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.gap(1);
});
var styles_BillsTotal = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1pyjdju-9"
})(["display:flex;align-items:center;justify-content:space-between;font-size:", ";line-height:", ";border-radius:4px;padding:", " ", ";color:", ";"], function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.rem(20);
}, function (props) {
  return props.theme.space(1);
}, function (props) {
  return props.theme.space(2);
}, function (props) {
  return props.theme.servicesExpensesSection.text.color;
});
var styles_BillsTotalText = /*#__PURE__*/styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  componentId: "sc-1pyjdju-10"
})(["font-size:", ";line-height:", ";"], function (props) {
  return props.theme.rem(16);
}, function (props) {
  return props.theme.rem(26);
});
var styles_BillsTotalAmount = /*#__PURE__*/styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  componentId: "sc-1pyjdju-11"
})(["font-weight:700;font-size:", ";line-height:", ";"], function (props) {
  return props.theme.rem(16);
}, function (props) {
  return props.theme.rem(20);
});
;// CONCATENATED MODULE: ./src/components/ServicesExpenses/Desktop/index.js
var Desktop_jsx = react.createElement;









var ServicesExpensesDesktop = function ServicesExpensesDesktop(_ref) {
  var _bills$billNames$, _bills$billNames$$max, _bills$billNames$$max2;

  var servicesAndExpensesData = _ref.servicesAndExpensesData,
      landlordPoliciesData = _ref.landlordPoliciesData,
      bills = _ref.bills,
      billNames = _ref.billNames,
      canShowTotalBills = _ref.canShowTotalBills,
      totalBills = _ref.totalBills,
      globalMaximum = _ref.globalMaximum,
      isEveryBillCovered = _ref.isEveryBillCovered;

  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t;

  return Desktop_jsx(Desktop_styles_Wrapper, {
    id: "Services and expenses"
  }, Desktop_jsx("h2", null, t('Services and expenses')), Desktop_jsx("p", null, t('Extra services, expenses and fees to be paid directly to the Landlord')), servicesAndExpensesData.length > 0 && Desktop_jsx(styles_Sections, null, Desktop_jsx("h3", null, t('One-time payments')), Desktop_jsx(styles_SectionItemList, null, servicesAndExpensesData.map(function (item, index) {
    return Desktop_jsx(Desktop_SectionItem, {
      key: index,
      title: item.title,
      description: item.description,
      value: item.price
    });
  }))), Desktop_jsx(styles_Sections, null, Desktop_jsx("h3", null, t('Fixed Monthly Bills')), isEveryBillCovered && Desktop_jsx(StatusBanner/* default */.Z, {
    message: t('Everything is covered! All bills are included in the price.'),
    icon: Desktop_jsx(assigned_file, {
      color: src_theme/* theme.unisystem.statusBanner.text.green */.r.unisystem.statusBanner.text.green
    }),
    color: 'green',
    type: 'text'
  }), Desktop_jsx(styles_Bills, {
    canShowBillsTotal: true
  }, isEveryBillCovered && Desktop_jsx(styles_BillsSeparator, null), billNames.map(function (billName, index) {
    var isLastBill = index + 1 === billNames.length;
    var hasSeparator = !isLastBill && (index + 1) % 2 === 0;
    return Desktop_jsx(react.Fragment, {
      key: billName
    }, Desktop_jsx(ServicesExpenses_BillItem, {
      name: billName,
      bill: bills[billName],
      t: t,
      formatMoney: utils/* formatMoney */.lb
    }), hasSeparator && Desktop_jsx(styles_BillsSeparator, null));
  }), canShowTotalBills && Desktop_jsx(styles_BillsTotalWrapper, null, Desktop_jsx(styles_BillsSeparator, null), Desktop_jsx(styles_BillsTotal, null, Desktop_jsx(styles_BillsTotalText, null, t('Total monthly bills included up to')), Desktop_jsx(styles_BillsTotalAmount, null, (0,utils/* formatMoney */.lb)((globalMaximum === null || globalMaximum === void 0 ? void 0 : globalMaximum.amount) || totalBills, (globalMaximum === null || globalMaximum === void 0 ? void 0 : globalMaximum.currency_code) || ((_bills$billNames$ = bills[billNames[0]]) === null || _bills$billNames$ === void 0 ? void 0 : (_bills$billNames$$max = _bills$billNames$.maximum) === null || _bills$billNames$$max === void 0 ? void 0 : (_bills$billNames$$max2 = _bills$billNames$$max.max) === null || _bills$billNames$$max2 === void 0 ? void 0 : _bills$billNames$$max2.currency_code) || 'EUR')))))), landlordPoliciesData.length > 0 && Desktop_jsx(styles_Sections, null, Desktop_jsx("h3", null, t('Other fees')), Desktop_jsx(styles_SectionItemList, null, landlordPoliciesData.map(function (item, index) {
    return Desktop_jsx(Desktop_SectionItem, {
      key: index,
      title: item.title,
      description: item.description,
      value: item.value,
      banner: item.banner
    });
  }))));
};

var Desktop_SectionItem = function SectionItem(_ref2) {
  var title = _ref2.title,
      description = _ref2.description,
      value = _ref2.value,
      banner = _ref2.banner;
  return Desktop_jsx(react.Fragment, null, Desktop_jsx(styles_SectionItemWrapper, null, Desktop_jsx(Desktop_styles_Description, null, Desktop_jsx("h4", null, title)), Desktop_jsx(styles_Value, null, value)), Desktop_jsx("p", null, description), banner);
};

/* harmony default export */ var Desktop = (ServicesExpensesDesktop);
// EXTERNAL MODULE: ../shared/src/utils/bills/index.js
var utils_bills = __webpack_require__(52651);
// EXTERNAL MODULE: ../shared/src/constants/otherFees.js
var constants_otherFees = __webpack_require__(9462);
// EXTERNAL MODULE: ../shared/src/constants/billTypes.js
var billTypes = __webpack_require__(35144);
;// CONCATENATED MODULE: ./src/components/ServicesExpenses/styles.js

var CleaningIncludedTag = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-3d54g4-0"
})(["padding:", ";border-radius:4px;font-size:", ";line-height:", ";color:", ";background-color:", ";"], function (props) {
  return props.theme.space(1);
}, function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.rem(18);
}, function (props) {
  return props.theme.colors.lightest;
}, function (props) {
  return props.theme.colors.emerald;
});
var OtherFeeDescriptionWrapper = /*#__PURE__*/styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  componentId: "sc-3d54g4-1"
})(["display:flex;flex-direction:column;", ""], function (_ref) {
  var theme = _ref.theme;
  return theme.gap(2, 'column');
});
var NoteFromLandlordWrapper = /*#__PURE__*/styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  componentId: "sc-3d54g4-2"
})(["display:flex;flex-direction:column;", ""], function (_ref2) {
  var theme = _ref2.theme;
  return theme.gap(1, 'column');
});
var NoteFromLandlordContent = /*#__PURE__*/styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  componentId: "sc-3d54g4-3"
})(["color:", ";"], function (props) {
  return props.theme.colors.cornFlowerBlue;
});
var CleaningFeeLabels = /*#__PURE__*/(/* unused pure expression or super */ null && (styled.span.withConfig({
  componentId: "sc-3d54g4-4"
})(["display:flex;flex-direction:row;flex-wrap:wrap;column-gap:", ";"], function (props) {
  return props.theme.space(1);
})));
var SelectDatesToSee = /*#__PURE__*/styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  componentId: "sc-3d54g4-5"
})(["cursor:pointer;color:", ";"], function (props) {
  return props.theme.colors.uniBlue;
});
// EXTERNAL MODULE: ../shared/src/utils/servicesExpenses/index.js + 2 modules
var servicesExpenses = __webpack_require__(99439);
;// CONCATENATED MODULE: ../shared/src/svg/cleaning-included.js


var cleaning_included_excluded = ["color"];
var cleaning_included_jsx = react.createElement;

var CleaningIncluded = function CleaningIncluded(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#224251' : _ref$color,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, cleaning_included_excluded);
  return cleaning_included_jsx("svg", (0,esm_extends/* default */.Z)({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), cleaning_included_jsx("g", {
    clipPath: "url(#clip0_3445_71)"
  }, cleaning_included_jsx("path", {
    d: "M3.26241 4.68945L15.3471 4.68945L17.8381 10.2575L0.771438 10.2575L3.26241 4.68945Z",
    stroke: color
  }), cleaning_included_jsx("mask", {
    id: "path-2-inside-1_3445_71",
    fill: "white"
  }, cleaning_included_jsx("rect", {
    x: "4.22223",
    y: "2",
    width: "4.22222",
    height: "3.16667",
    rx: "0.4"
  })), cleaning_included_jsx("rect", {
    x: "4.22223",
    y: "2",
    width: "4.22222",
    height: "3.16667",
    rx: "0.4",
    stroke: color,
    strokeWidth: "1.6",
    mask: "url(#path-2-inside-1_3445_71)"
  }), cleaning_included_jsx("path", {
    d: "M13.2268 8.61896C13.2803 8.65708 13.3443 8.67755 13.41 8.67749C13.4756 8.67742 13.5396 8.65684 13.593 8.61862C13.6463 8.57874 13.6869 8.52415 13.7097 8.46156L13.8284 8.09647C13.8569 8.01045 13.9051 7.93228 13.9691 7.86818C14.0331 7.80408 14.1113 7.75582 14.1973 7.72726L14.5689 7.60648C14.6312 7.58413 14.6849 7.54276 14.7224 7.48821C14.76 7.43367 14.7794 7.36871 14.778 7.30253C14.7766 7.23634 14.7544 7.17226 14.7146 7.11935C14.6748 7.06644 14.6194 7.02738 14.5562 7.00768L14.1904 6.88929C14.1043 6.86086 14.0261 6.8127 13.9619 6.74865C13.8978 6.68461 13.8495 6.60646 13.8209 6.52043L13.7001 6.14952C13.6782 6.08827 13.6378 6.03532 13.5846 5.99794C13.5313 5.96056 13.4678 5.9406 13.4027 5.9408C13.3367 5.94052 13.2723 5.96098 13.2186 5.99929C13.1649 6.03761 13.1246 6.09183 13.1033 6.15431L12.9815 6.52728C12.9529 6.61075 12.9058 6.68668 12.8437 6.74937C12.7816 6.81206 12.7061 6.8599 12.6229 6.88929L12.252 7.00939C12.19 7.03129 12.1364 7.07197 12.0987 7.12577C12.0609 7.17957 12.0409 7.2438 12.0414 7.30952C12.0419 7.37524 12.0629 7.43917 12.1014 7.4924C12.14 7.54563 12.1941 7.58551 12.2564 7.60648L12.6215 7.72521C12.7077 7.75401 12.786 7.80249 12.8502 7.86681C12.9144 7.93114 12.9628 8.00953 12.9914 8.09578L13.1119 8.46532C13.1334 8.52691 13.1735 8.58098 13.2268 8.61896ZM12.728 7.39844L12.4354 7.30776L12.731 7.21162C12.866 7.1651 12.9884 7.08791 13.0886 6.98613C13.1885 6.88347 13.2638 6.76029 13.309 6.62479L13.3996 6.33087L13.4955 6.62582C13.5408 6.76273 13.6176 6.88712 13.7197 6.98902C13.8218 7.09092 13.9463 7.16751 14.0833 7.21264L14.3844 7.30469L14.0902 7.40049C13.9531 7.44573 13.8285 7.52247 13.7264 7.62456C13.6243 7.72665 13.5475 7.85124 13.5023 7.98834L13.4116 8.28158L13.3162 7.98765C13.271 7.85033 13.1943 7.7255 13.0921 7.62323C12.99 7.52095 12.8652 7.44373 12.728 7.39844Z",
    fill: color
  }), cleaning_included_jsx("path", {
    d: "M11.7125 15.6132C11.7767 15.659 11.8535 15.6835 11.9323 15.6834C12.0111 15.6834 12.0878 15.6587 12.1519 15.6128C12.2159 15.5649 12.2646 15.4994 12.2919 15.4243L12.4344 14.9862C12.4686 14.883 12.5264 14.7892 12.6032 14.7123C12.6801 14.6354 12.7738 14.5774 12.877 14.5432L13.323 14.3982C13.3978 14.3714 13.4622 14.3218 13.5072 14.2563C13.5523 14.1909 13.5756 14.1129 13.5739 14.0335C13.5722 13.9541 13.5456 13.8772 13.4979 13.8137C13.4501 13.7502 13.3836 13.7033 13.3078 13.6797L12.8688 13.5376C12.7655 13.5035 12.6716 13.4457 12.5946 13.3688C12.5176 13.292 12.4597 13.1982 12.4254 13.095L12.2804 12.6499C12.2541 12.5764 12.2057 12.5128 12.1418 12.468C12.0779 12.4231 12.0017 12.3992 11.9236 12.3994C11.8444 12.3991 11.7671 12.4236 11.7026 12.4696C11.6382 12.5156 11.5898 12.5807 11.5643 12.6556L11.4181 13.1032C11.3838 13.2034 11.3273 13.2945 11.2527 13.3697C11.1782 13.4449 11.0876 13.5023 10.9878 13.5376L10.5427 13.6817C10.4683 13.708 10.404 13.7568 10.3587 13.8214C10.3134 13.8859 10.2894 13.963 10.29 14.0419C10.2906 14.1207 10.3158 14.1975 10.362 14.2613C10.4083 14.3252 10.4733 14.3731 10.548 14.3982L10.9862 14.5407C11.0896 14.5753 11.1836 14.6334 11.2606 14.7106C11.3377 14.7878 11.3957 14.8819 11.43 14.9854L11.5746 15.4288C11.6004 15.5028 11.6485 15.5676 11.7125 15.6132ZM11.1139 14.1486L10.7628 14.0398L11.1176 13.9244C11.2796 13.8686 11.4265 13.776 11.5466 13.6538C11.6665 13.5306 11.7569 13.3828 11.8111 13.2202L11.9199 12.8675L12.0349 13.2214C12.0893 13.3857 12.1815 13.535 12.304 13.6573C12.4265 13.7796 12.5759 13.8715 12.7403 13.9256L13.1016 14.0361L12.7485 14.1511C12.584 14.2053 12.4345 14.2974 12.312 14.4199C12.1895 14.5424 12.0974 14.6919 12.0431 14.8565L11.9343 15.2084L11.8197 14.8556C11.7655 14.6909 11.6735 14.5411 11.5509 14.4183C11.4283 14.2956 11.2786 14.2029 11.1139 14.1486Z",
    fill: color
  }), cleaning_included_jsx("path", {
    d: "M21.1267 16.1606C21.1909 16.2063 21.2677 16.2309 21.3465 16.2308C21.4252 16.2307 21.502 16.206 21.5661 16.1602C21.6301 16.1123 21.6788 16.0468 21.7061 15.9717L21.8486 15.5336C21.8828 15.4304 21.9406 15.3366 22.0174 15.2596C22.0943 15.1827 22.188 15.1248 22.2912 15.0905L22.7372 14.9456C22.8119 14.9188 22.8764 14.8691 22.9214 14.8037C22.9665 14.7382 22.9898 14.6603 22.9881 14.5809C22.9864 14.5014 22.9598 14.4245 22.9121 14.361C22.8643 14.2976 22.7978 14.2507 22.722 14.227L22.283 14.085C22.1797 14.0509 22.0858 13.9931 22.0088 13.9162C21.9318 13.8394 21.8739 13.7456 21.8395 13.6423L21.6946 13.1972C21.6683 13.1237 21.6199 13.0602 21.556 13.0153C21.4921 12.9705 21.4158 12.9465 21.3378 12.9468C21.2586 12.9464 21.1813 12.971 21.1168 13.017C21.0524 13.063 21.004 13.128 20.9785 13.203L20.8323 13.6506C20.798 13.7507 20.7414 13.8418 20.6669 13.9171C20.5924 13.9923 20.5018 14.0497 20.402 14.085L19.9569 14.2291C19.8825 14.2554 19.8182 14.3042 19.7729 14.3687C19.7276 14.4333 19.7036 14.5104 19.7042 14.5892C19.7048 14.6681 19.7299 14.7448 19.7762 14.8087C19.8224 14.8726 19.8875 14.9204 19.9622 14.9456L20.4003 15.0881C20.5038 15.1226 20.5978 15.1808 20.6748 15.258C20.7518 15.3352 20.8098 15.4293 20.8442 15.5328L20.9888 15.9762C21.0146 16.0501 21.0627 16.115 21.1267 16.1606ZM20.528 14.6959L20.177 14.5871L20.5317 14.4718C20.6938 14.4159 20.8406 14.3233 20.9608 14.2012C21.0807 14.078 21.1711 13.9302 21.2253 13.7676L21.3341 13.4149L21.4491 13.7688C21.5035 13.9331 21.5957 14.0824 21.7182 14.2046C21.8407 14.3269 21.9901 14.4188 22.1545 14.473L22.5158 14.5834L22.1627 14.6984C21.9982 14.7527 21.8487 14.8448 21.7262 14.9673C21.6036 15.0898 21.5116 15.2393 21.4573 15.4038L21.3485 15.7557L21.2339 15.403C21.1797 15.2382 21.0876 15.0884 20.9651 14.9657C20.8425 14.843 20.6928 14.7503 20.528 14.6959Z",
    fill: color
  }), cleaning_included_jsx("path", {
    d: "M16.4201 12.9468V11.2101C16.4201 10.6578 15.9724 10.2101 15.4201 10.2101H3.18933C2.63705 10.2101 2.18933 10.6578 2.18933 11.2101V19.6095C2.18933 20.1618 2.63705 20.6095 3.18933 20.6095H14.7781",
    stroke: color,
    strokeLinecap: "round"
  }), cleaning_included_jsx("rect", {
    x: "4.37872",
    y: "12.9468",
    width: "2.18935",
    height: "2.18935",
    stroke: color,
    strokeWidth: "0.5",
    strokeLinejoin: "round"
  }), cleaning_included_jsx("rect", {
    x: "4.37872",
    y: "15.1361",
    width: "2.18935",
    height: "2.18935",
    stroke: color,
    strokeWidth: "0.5",
    strokeLinejoin: "round"
  }), cleaning_included_jsx("rect", {
    x: "6.56805",
    y: "15.1361",
    width: "2.18935",
    height: "2.18935",
    stroke: color,
    strokeWidth: "0.5",
    strokeLinejoin: "round"
  }), cleaning_included_jsx("rect", {
    x: "6.56805",
    y: "12.9468",
    width: "2.18935",
    height: "2.18935",
    stroke: color,
    strokeWidth: "0.5",
    strokeLinejoin: "round"
  }), cleaning_included_jsx("path", {
    d: "M18.1469 13.3559C18.2803 12.9653 20.8812 5.51866 20.8984 5.47021C20.9303 5.37981 20.9969 5.30576 21.0836 5.26434C21.1703 5.22293 21.27 5.21753 21.3608 5.24935C21.4515 5.28116 21.5259 5.34759 21.5675 5.434C21.6091 5.52041 21.6146 5.61974 21.5828 5.71014C21.4225 6.17768 18.9197 13.3338 18.825 13.6059M16.1567 19.0547C16.4013 18.6661 16.8417 18.036 17.0789 17.6589C16.7741 17.9357 16.2346 18.6509 15.9417 18.9269C15.4103 18.6752 14.8999 18.3815 14.4155 18.0486C15.1606 17.7258 15.8283 17.249 16.3743 16.6496C15.6944 17.1636 14.9284 17.5534 14.1117 17.8007C13.7314 17.4467 13.375 17.068 13.0449 16.6671C14.8353 16.7993 16.5514 15.7631 17.4613 14.3581C17.8207 14.4815 18.1831 14.5956 18.5484 14.7003C18.7508 14.7576 18.9214 14.8939 19.021 15.0787C19.6523 16.1037 19.6006 17.1249 19.0202 18.1461C18.7777 18.5732 18.4184 19.2243 18.053 19.5529C17.4033 19.463 16.7666 19.2955 16.1567 19.0547Z",
    stroke: color,
    strokeWidth: "0.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), cleaning_included_jsx("mask", {
    id: "path-12-inside-2_3445_71",
    fill: "white"
  }, cleaning_included_jsx("rect", {
    x: "17.6341",
    y: "13.1886",
    width: "1.73733",
    height: "1.10881",
    rx: "0.2",
    transform: "rotate(19.1804 17.6341 13.1886)"
  })), cleaning_included_jsx("rect", {
    x: "17.6341",
    y: "13.1886",
    width: "1.73733",
    height: "1.10881",
    rx: "0.2",
    transform: "rotate(19.1804 17.6341 13.1886)",
    stroke: color,
    strokeWidth: "0.6",
    mask: "url(#path-12-inside-2_3445_71)"
  }), cleaning_included_jsx("circle", {
    cx: "19.5278",
    cy: "20.4722",
    r: "0.5",
    fill: color,
    stroke: color,
    strokeWidth: "0.0555556"
  }), cleaning_included_jsx("circle", {
    cx: "20.5833",
    cy: "18.3612",
    r: "0.5",
    fill: color,
    stroke: color,
    strokeWidth: "0.0555556"
  }), cleaning_included_jsx("circle", {
    cx: "20.8472",
    cy: "19.6805",
    r: "0.263889",
    fill: color
  })), cleaning_included_jsx("defs", null, cleaning_included_jsx("clipPath", {
    id: "clip0_3445_71"
  }, cleaning_included_jsx("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};
/* harmony default export */ var cleaning_included = (CleaningIncluded);
// EXTERNAL MODULE: ./src/store/actions/offer/index.js
var offer = __webpack_require__(71070);
;// CONCATENATED MODULE: ./src/components/ServicesExpenses/index.js



var _OTHER_FEES_BASE_DESC;

var ServicesExpenses_jsx = react.createElement;
















var OTHER_FEES_BASE_DESCRIPTIONS_MAP = (_OTHER_FEES_BASE_DESC = {}, (0,defineProperty/* default */.Z)(_OTHER_FEES_BASE_DESC, constants_otherFees/* OTHER_FEES_TYPE.ADMIN_FEE_IN_ADVANCE */.ar.ADMIN_FEE_IN_ADVANCE, '{{recurrence}} charged in advance for necessary maintenance'), (0,defineProperty/* default */.Z)(_OTHER_FEES_BASE_DESC, constants_otherFees/* OTHER_FEES_TYPE.BED_LINEN_AND_TOWELS */.ar.BED_LINEN_AND_TOWELS, '{{recurrence}} charged for bed linen and towels'), (0,defineProperty/* default */.Z)(_OTHER_FEES_BASE_DESC, constants_otherFees/* OTHER_FEES_TYPE.CHECK_IN_AND_CHECK_OUT_ON_WEEKENDS */.ar.CHECK_IN_AND_CHECK_OUT_ON_WEEKENDS, '{{recurrence}} charged for check-in/out in weekends'), (0,defineProperty/* default */.Z)(_OTHER_FEES_BASE_DESC, constants_otherFees/* OTHER_FEES_TYPE.CITY_REGISTRATION */.ar.CITY_REGISTRATION, '{{recurrence}} charged for the required city registration process'), (0,defineProperty/* default */.Z)(_OTHER_FEES_BASE_DESC, constants_otherFees/* OTHER_FEES_TYPE.CITY_TAXES */.ar.CITY_TAXES, '{{recurrence}} charged by the local authorities'), (0,defineProperty/* default */.Z)(_OTHER_FEES_BASE_DESC, constants_otherFees/* OTHER_FEES_TYPE.CONDOMINIUM_FEE */.ar.CONDOMINIUM_FEE, '{{recurrence}} charged for the necessary maintenance of the condominium'), (0,defineProperty/* default */.Z)(_OTHER_FEES_BASE_DESC, constants_otherFees/* OTHER_FEES_TYPE.DEPOSIT_LAST_MONTH */.ar.DEPOSIT_LAST_MONTH, '{{recurrence}} charged for the last month\'s rent'), (0,defineProperty/* default */.Z)(_OTHER_FEES_BASE_DESC, constants_otherFees/* OTHER_FEES_TYPE.EARLY_OR_LATE_HOURS_FOR_CHECK_IN_AND_CHECK_OUT */.ar.EARLY_OR_LATE_HOURS_FOR_CHECK_IN_AND_CHECK_OUT, '{{recurrence}} charged for the check-ins/ check-outs in early or late hours'), (0,defineProperty/* default */.Z)(_OTHER_FEES_BASE_DESC, constants_otherFees/* OTHER_FEES_TYPE.FIXED_BILLS_FEE */.ar.FIXED_BILLS_FEE, '{{recurrence}} charged for the fixed bills'), (0,defineProperty/* default */.Z)(_OTHER_FEES_BASE_DESC, constants_otherFees/* OTHER_FEES_TYPE.LAST_MONTH_RENT_IN_ADVANCE */.ar.LAST_MONTH_RENT_IN_ADVANCE, '{{recurrence}} charged in advance for the last month rent'), (0,defineProperty/* default */.Z)(_OTHER_FEES_BASE_DESC, constants_otherFees/* OTHER_FEES_TYPE.LAUNDRY_FEE */.ar.LAUNDRY_FEE, '{{recurrence}} charged for the laundry services provided'), (0,defineProperty/* default */.Z)(_OTHER_FEES_BASE_DESC, constants_otherFees/* OTHER_FEES_TYPE.OVERNIGHT_GUESTS */.ar.OVERNIGHT_GUESTS, '{{recurrence}} charged for overnight guests'), (0,defineProperty/* default */.Z)(_OTHER_FEES_BASE_DESC, constants_otherFees/* OTHER_FEES_TYPE.PARKING_FEE */.ar.PARKING_FEE, '{{recurrence}} charged for the use of parking spaces'), (0,defineProperty/* default */.Z)(_OTHER_FEES_BASE_DESC, constants_otherFees/* OTHER_FEES_TYPE.SECURITY_DEPOSIT_IN_ADVANCE */.ar.SECURITY_DEPOSIT_IN_ADVANCE, '{{recurrence}} charged in advance for the security deposit'), (0,defineProperty/* default */.Z)(_OTHER_FEES_BASE_DESC, constants_otherFees/* OTHER_FEES_TYPE.SIGNATURE_AND_REGISTRATION_OF_THE_TENANCY_AGREEMENT */.ar.SIGNATURE_AND_REGISTRATION_OF_THE_TENANCY_AGREEMENT, '{{recurrence}} charged for the associated costs with the tenancy agreement'), (0,defineProperty/* default */.Z)(_OTHER_FEES_BASE_DESC, constants_otherFees/* OTHER_FEES_TYPE.VARIABLE_SECURITY_DEPOSIT */.ar.VARIABLE_SECURITY_DEPOSIT, '{{recurrence}} charged for security deposit with a variable price'), _OTHER_FEES_BASE_DESC);

var ServicesExpenses = function ServicesExpenses(_ref) {
  var _offer$costs, _offer$costs$services, _offer$costs2, _offer$contract, _offer$contract2, _offer$contract3, _offer$contract3$land, _offer$contract3$land2, _offerAggregate$prope, _offerAggregate$prope2, _offerAggregate$prope3, _bills$maximum, _adminFee$value, _variableAdminFee$def, _variableAdminFee$def2, _priceDetailsAdminFee;

  var offerAggregate = _ref.offerAggregate,
      priceDetailsAdminFee = _ref.priceDetailsAdminFee,
      hasDatesSelected = _ref.hasDatesSelected,
      setIsCalendarOpen = _ref.setIsCalendarOpen,
      rents = _ref.rents;

  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var _useMedia = (0,hooks/* useMedia */.GS)(),
      is = _useMedia.is;

  var offer = offerAggregate === null || offerAggregate === void 0 ? void 0 : offerAggregate.accommodation_offer;
  var cleaning = offer === null || offer === void 0 ? void 0 : (_offer$costs = offer.costs) === null || _offer$costs === void 0 ? void 0 : (_offer$costs$services = _offer$costs.services) === null || _offer$costs$services === void 0 ? void 0 : _offer$costs$services.cleaning;
  var bills = offer === null || offer === void 0 ? void 0 : (_offer$costs2 = offer.costs) === null || _offer$costs2 === void 0 ? void 0 : _offer$costs2.bills;
  var adminFee = offer === null || offer === void 0 ? void 0 : (_offer$contract = offer.contract) === null || _offer$contract === void 0 ? void 0 : _offer$contract.admin_fee;
  var variableAdminFee = offer === null || offer === void 0 ? void 0 : (_offer$contract2 = offer.contract) === null || _offer$contract2 === void 0 ? void 0 : _offer$contract2.variable_admin_fee;
  var otherFees = offer === null || offer === void 0 ? void 0 : (_offer$contract3 = offer.contract) === null || _offer$contract3 === void 0 ? void 0 : (_offer$contract3$land = _offer$contract3.landlord_policies) === null || _offer$contract3$land === void 0 ? void 0 : (_offer$contract3$land2 = _offer$contract3$land.costs) === null || _offer$contract3$land2 === void 0 ? void 0 : _offer$contract3$land2.items;
  var hasGasInProperty = (offerAggregate === null || offerAggregate === void 0 ? void 0 : (_offerAggregate$prope = offerAggregate.property_aggregate) === null || _offerAggregate$prope === void 0 ? void 0 : (_offerAggregate$prope2 = _offerAggregate$prope.property) === null || _offerAggregate$prope2 === void 0 ? void 0 : (_offerAggregate$prope3 = _offerAggregate$prope2.main_features) === null || _offerAggregate$prope3 === void 0 ? void 0 : _offerAggregate$prope3.gas_type) === billTypes/* GAS_INSTALLATION */.MT;
  var cleaningFee = otherFees === null || otherFees === void 0 ? void 0 : otherFees.find(function (policy) {
    return policy.type === constants_otherFees/* OTHER_FEES_TYPE.CLEANING_FEE */.ar.CLEANING_FEE;
  });
  var isCleaningFeeIncluded = ((cleaning === null || cleaning === void 0 ? void 0 : cleaning.periodicity) || (cleaning === null || cleaning === void 0 ? void 0 : cleaning.type)) && !cleaningFee;
  var filterKeys = ['__typename', 'maximum', 'gas'];
  var billNames = [].concat((0,toConsumableArray/* default */.Z)(bills ? Object.keys(bills).filter(function (key) {
    return !filterKeys.includes(key);
  }) : []), (0,toConsumableArray/* default */.Z)(hasGasInProperty ? ['gas'] : []));
  var areAllBillsIncluded = billNames.length > 0 && billNames.every(function (billName) {
    return bills[billName].included;
  });
  var hasAnyBillCapped = billNames.some(function (billName) {
    var _bills$billName$maxim;

    return (_bills$billName$maxim = bills[billName].maximum) === null || _bills$billName$maxim === void 0 ? void 0 : _bills$billName$maxim.capped;
  });
  var globalMaximum = bills === null || bills === void 0 ? void 0 : (_bills$maximum = bills.maximum) === null || _bills$maximum === void 0 ? void 0 : _bills$maximum.max;
  var totalBills = (0,utils_bills/* calculateTotalBills */.r)(bills);
  var canShowTotalBills = globalMaximum || totalBills > 0;
  var isEveryBillCovered = areAllBillsIncluded && !hasAnyBillCapped;
  var deposit = (0,servicesExpenses/* getDepositInfo */.ZS)(offer === null || offer === void 0 ? void 0 : offer.contract, t);
  var servicesAndExpensesData = [].concat((0,toConsumableArray/* default */.Z)((adminFee === null || adminFee === void 0 ? void 0 : (_adminFee$value = adminFee.value) === null || _adminFee$value === void 0 ? void 0 : _adminFee$value.amount) > 0 && !(otherFees !== null && otherFees !== void 0 && otherFees.find(function (policy) {
    return policy.type === constants_otherFees/* OTHER_FEES_TYPE.ADMIN_FEE_IN_ADVANCE */.ar.ADMIN_FEE_IN_ADVANCE;
  })) ? [{
    title: t('Landlord Admin Fee'),
    description: t('To cover the overall expenses from the administrative tasks involved in the rental activity, such as check-in and check-out, property management, communications, rent collection, among others.'),
    price: (0,utils/* formatMoney */.lb)(adminFee.value.amount, adminFee.value.currency_code)
  }] : []), (0,toConsumableArray/* default */.Z)(deposit !== null && deposit !== void 0 && deposit.amount && !(otherFees !== null && otherFees !== void 0 && otherFees.find(function (policy) {
    return policy.type === constants_otherFees/* OTHER_FEES_TYPE.SECURITY_DEPOSIT_IN_ADVANCE */.ar.SECURITY_DEPOSIT_IN_ADVANCE;
  })) ? [{
    title: t('Security deposit'),
    description: t('Refundable payment to be made directly to Landlord, which should be refunded if you meet all the rental conditions.'),
    price: deposit.amount
  }] : []), (0,toConsumableArray/* default */.Z)((variableAdminFee === null || variableAdminFee === void 0 ? void 0 : (_variableAdminFee$def = variableAdminFee.default_admin_fee) === null || _variableAdminFee$def === void 0 ? void 0 : (_variableAdminFee$def2 = _variableAdminFee$def.value) === null || _variableAdminFee$def2 === void 0 ? void 0 : _variableAdminFee$def2.amount) > 0 && !(otherFees !== null && otherFees !== void 0 && otherFees.find(function (policy) {
    return policy.type === constants_otherFees/* OTHER_FEES_TYPE.ADMIN_FEE_IN_ADVANCE */.ar.ADMIN_FEE_IN_ADVANCE;
  })) ? [{
    title: t('Landlord Admin Fee'),
    description: t('The admin fee for this listing is variable and may depend on factors like the length of stay. It covers administrative costs, including contract registration, initial and final cleaning, and any necessary maintenance by the property management.'),
    price: priceDetailsAdminFee !== null && priceDetailsAdminFee !== void 0 && (_priceDetailsAdminFee = priceDetailsAdminFee.value) !== null && _priceDetailsAdminFee !== void 0 && _priceDetailsAdminFee.amount ? (0,utils/* formatMoney */.lb)(priceDetailsAdminFee.value.amount, priceDetailsAdminFee.value.currency_code) : ServicesExpenses_jsx(SelectDatesToSee, {
      onClick: function onClick() {
        return setIsCalendarOpen(true);
      }
    }, t('Select dates to see'))
  }] : []));

  var getLastRentComponent = function getLastRentComponent() {
    var _rents$value, _rents;

    var money = (_rents$value = (_rents = rents[rents.length - 1]) === null || _rents === void 0 ? void 0 : _rents.value) !== null && _rents$value !== void 0 ? _rents$value : null;

    if (money) {
      return (0,utils/* formatMoney */.lb)(money.amount, money.currency_code);
    }

    return !hasDatesSelected ? ServicesExpenses_jsx(SelectDatesToSee, {
      onClick: function onClick() {
        return setIsCalendarOpen(true);
      }
    }, t('Select dates to see')) : null;
  };

  var landlordPoliciesData = [].concat((0,toConsumableArray/* default */.Z)((otherFees === null || otherFees === void 0 ? void 0 : otherFees.map(function (policy) {
    return {
      title: t((0,servicesExpenses/* assembleFeeTitle */.U)(policy.type)),
      description: ServicesExpenses_jsx(OtherFeeDescription, {
        fee: policy,
        cleaning: cleaning,
        t: t
      }),
      value: policy.type === constants_otherFees/* OTHER_FEES_TYPE.LAST_MONTH_RENT_IN_ADVANCE */.ar.LAST_MONTH_RENT_IN_ADVANCE ? getLastRentComponent() : (0,utils/* formatMoney */.lb)(policy.amount.amount, policy.amount.currency_code)
    };
  })) || []), (0,toConsumableArray/* default */.Z)(isCleaningFeeIncluded ? [{
    title: t('Cleaning fee'),
    description: ServicesExpenses_jsx(OtherFeeDescription, {
      cleaning: cleaning,
      fee: {
        type: constants_otherFees/* OTHER_FEES_TYPE.CLEANING_FEE */.ar.CLEANING_FEE
      },
      t: t
    }),
    value: ServicesExpenses_jsx(CleaningIncludedTag, null, t('Included')),
    banner: ServicesExpenses_jsx(StatusBanner/* default */.Z, {
      message: t('One less thing on your to-do list! Cleaning is covered for you.'),
      icon: ServicesExpenses_jsx(cleaning_included, {
        color: src_theme/* theme.unisystem.statusBanner.text.green */.r.unisystem.statusBanner.text.green
      }),
      color: 'green',
      type: 'text'
    })
  }] : []));
  var Component = (0,react.useMemo)(function () {
    return is.mobile ? Mobile : Desktop;
  }, [is.mobile]);
  return ServicesExpenses_jsx(Component, {
    servicesAndExpensesData: servicesAndExpensesData,
    landlordPoliciesData: landlordPoliciesData,
    bills: bills,
    billNames: billNames,
    canShowTotalBills: canShowTotalBills,
    totalBills: totalBills,
    globalMaximum: globalMaximum,
    isEveryBillCovered: isEveryBillCovered
  });
};

var OtherFeeDescription = function OtherFeeDescription(_ref2) {
  var cleaning = _ref2.cleaning,
      fee = _ref2.fee,
      t = _ref2.t;
  var type = fee.type,
      recurrence = fee.recurrence,
      additionalInformation = fee.additional_information;
  var formattedRecurrenceOfFee = t((0,servicesExpenses/* formatRecurrenceOfFee */.Nl)(recurrence));
  var description = type === constants_otherFees/* OTHER_FEES_TYPE.CLEANING_FEE */.ar.CLEANING_FEE ? (0,servicesExpenses/* assembleCleaningFeeBaseDescription */.zc)(cleaning, formattedRecurrenceOfFee, t) : t(OTHER_FEES_BASE_DESCRIPTIONS_MAP[type], {
    recurrence: formattedRecurrenceOfFee
  });

  if (!description && !additionalInformation) {
    return null;
  }

  return ServicesExpenses_jsx(OtherFeeDescriptionWrapper, null, ServicesExpenses_jsx("span", null, (description || formattedRecurrenceOfFee).concat('.')), additionalInformation && ServicesExpenses_jsx(NoteFromLandlordWrapper, null, ServicesExpenses_jsx("span", null, "".concat(t('Note from landlord'), ":")), ServicesExpenses_jsx(NoteFromLandlordContent, null, additionalInformation)));
};

var ServicesExpenses_mapStateToProps = function mapStateToProps(_ref3) {
  var _offerAggregate$prope4, _priceDetails$data, _priceDetails$data$st, _priceDetails$data2, _priceDetails$data2$s, _priceDetails$data3, _priceDetails$data$re, _priceDetails$data4, _priceDetails$data4$r;

  var _ref3$offer = _ref3.offer,
      offerAggregate = _ref3$offer.offerAggregate,
      priceDetails = _ref3$offer.priceDetails;
  var accommodationOffer = offerAggregate === null || offerAggregate === void 0 ? void 0 : offerAggregate.accommodation_offer;
  var property = offerAggregate === null || offerAggregate === void 0 ? void 0 : (_offerAggregate$prope4 = offerAggregate.property_aggregate) === null || _offerAggregate$prope4 === void 0 ? void 0 : _offerAggregate$prope4.property;
  var hasDatesSelected = !!(priceDetails !== null && priceDetails !== void 0 && (_priceDetails$data = priceDetails.data) !== null && _priceDetails$data !== void 0 && (_priceDetails$data$st = _priceDetails$data.start_end) !== null && _priceDetails$data$st !== void 0 && _priceDetails$data$st.start) && !!(priceDetails !== null && priceDetails !== void 0 && (_priceDetails$data2 = priceDetails.data) !== null && _priceDetails$data2 !== void 0 && (_priceDetails$data2$s = _priceDetails$data2.start_end) !== null && _priceDetails$data2$s !== void 0 && _priceDetails$data2$s.end);
  return {
    offerAggregate: {
      property_aggregate: {
        property: property
      },
      accommodation_offer: {
        contract: accommodationOffer === null || accommodationOffer === void 0 ? void 0 : accommodationOffer.contract,
        costs: accommodationOffer === null || accommodationOffer === void 0 ? void 0 : accommodationOffer.costs,
        requisites: accommodationOffer === null || accommodationOffer === void 0 ? void 0 : accommodationOffer.requisites
      }
    },
    priceDetailsAdminFee: priceDetails === null || priceDetails === void 0 ? void 0 : (_priceDetails$data3 = priceDetails.data) === null || _priceDetails$data3 === void 0 ? void 0 : _priceDetails$data3.admin_fee,
    rents: (_priceDetails$data$re = priceDetails === null || priceDetails === void 0 ? void 0 : (_priceDetails$data4 = priceDetails.data) === null || _priceDetails$data4 === void 0 ? void 0 : (_priceDetails$data4$r = _priceDetails$data4.rents) === null || _priceDetails$data4$r === void 0 ? void 0 : _priceDetails$data4$r.items) !== null && _priceDetails$data$re !== void 0 ? _priceDetails$data$re : [],
    hasDatesSelected: hasDatesSelected
  };
};

var ServicesExpenses_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setIsCalendarOpen: function setIsCalendarOpen(isCalendarOpen) {
      return dispatch((0,offer/* setIsCalendarOpenAction */.s9)({
        isCalendarOpen: isCalendarOpen
      }));
    }
  };
};

/* harmony default export */ var components_ServicesExpenses = ((0,es/* connect */.$j)(ServicesExpenses_mapStateToProps, ServicesExpenses_mapDispatchToProps)(ServicesExpenses));
;// CONCATENATED MODULE: ./src/components/RentalConditions/styles.js

var RentalConditions_styles_Wrapper = /*#__PURE__*/styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  componentId: "sc-1ehebjx-0"
})(["width:100%;h2{font-family:'IntervalNextReg',sans-serif;font-size:", ";line-height:", ";font-weight:600;color:", ";}"], function (props) {
  return props.theme.rem(22);
}, function (props) {
  return props.theme.rem(26);
}, function (props) {
  return props.theme.rentalConditionsSection.text.color;
});
var List = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1ehebjx-1"
})(["display:flex;flex-direction:column;", " margin-top:", ";.text-strike-through{text-decoration:line-through;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.gap(5, 'column');
}, function (props) {
  return props.theme.space(6);
});
;// CONCATENATED MODULE: ./src/components/RentalConditions/Item/styles.js

var Item_styles_Wrapper = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-7pe2f2-0"
})(["display:flex;align-items:center;flex-wrap:wrap;", " color:", ";svg{width:26px;height:auto;flex-shrink:0;flex-basis:26px;}ul{flex-basis:100%;padding-left:", ";font-size:", ";}h3{flex-basis:100%;font-size:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.gap(2);
}, function (props) {
  return props.theme.rentalConditionsSection.text.color;
}, function (props) {
  return props.theme.space(5.5);
}, function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.rem(14);
});
;// CONCATENATED MODULE: ./src/components/RentalConditions/Item/index.js

var Item_excluded = ["icon", "text", "children"];
var Item_jsx = react.createElement;



var Item_Item = function Item(_ref) {
  var icon = _ref.icon,
      text = _ref.text,
      children = _ref.children,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, Item_excluded);

  return Item_jsx(Item_styles_Wrapper, props, icon, Item_jsx("span", null, text), children);
};

/* harmony default export */ var RentalConditions_Item = (Item_Item);
;// CONCATENATED MODULE: ../shared/src/constants/rule-codes.js
var RULE_CODES = {
  PETS_ALLOWED: 'pets-allowed',
  SMOKING_ALLOWED: 'smoking-allowed',
  OVERNIGHT_GUESTS_ALLOWED: 'overnight-guests-allowed'
};
;// CONCATENATED MODULE: ./src/utils/rentalConditions/styles.js

var ListItem = /*#__PURE__*/styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
  componentId: "sc-1ilsx2i-0"
})(["list-style-type:disc;"]);
var styles_List = /*#__PURE__*/styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  componentId: "sc-1ilsx2i-1"
})(["padding-left:", ";"], function (props) {
  return props.theme.space(13);
});
// EXTERNAL MODULE: ../shared/src/svg/no-pets.js
var no_pets = __webpack_require__(9171);
;// CONCATENATED MODULE: ../shared/src/svg/couples.js


var couples_excluded = ["color"];
var couples_jsx = react.createElement;

var Couples = function Couples(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#224251' : _ref$color,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, couples_excluded);
  return couples_jsx("svg", (0,esm_extends/* default */.Z)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 25,
    fill: "none",
    viewBox: "0 0 26 25"
  }, props), couples_jsx("path", {
    stroke: color,
    strokeLinejoin: "round",
    d: "M7.286 15.268v2.525l-4.504 1.634C1.702 19.818 1 20.852 1 22.01v1.725h17.143V22.01c0-1.157-.704-2.19-1.782-2.582l-4.503-1.634v-2.67"
  }), couples_jsx("path", {
    stroke: color,
    strokeLinejoin: "round",
    d: "M13.97 10.482c0 3.03-2.02 5.486-4.512 5.486-2.492 0-4.511-2.456-4.511-5.486 0-3.028 2.02-5.481 4.511-5.481 2.49 0 4.511 2.453 4.511 5.481Z",
    clipRule: "evenodd"
  }), couples_jsx("path", {
    stroke: color,
    strokeLinejoin: "round",
    d: "M13.934 9.988c-.15.02-.275.008-.427.038-1.538.3-2.524-.264-3.371-1.764-.507.986-2.092 1.764-3.396 1.764-.641 0-1.194-.133-1.746-.427"
  }), couples_jsx("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21.036 23.734H25V22.01c0-1.157-.703-2.19-1.781-2.582l-4.504-1.634v-2.67"
  }), couples_jsx("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16.316 5c2.491 0 4.511 2.455 4.511 5.482 0 3.03-2.02 5.485-4.511 5.485"
  }), couples_jsx("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M20.791 9.988c-.15.02-.275.008-.427.038-1.538.3-2.524-.264-3.37-1.764"
  }), couples_jsx("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8,
    d: "m14 1.938-.211-.313C13.544 1.262 13.183 1 12.75 1c-.692 0-1.25.628-1.25 1.406 0 .29.078.56.211.781C11.936 3.567 14 6 14 6m0-4.063s0 .313.211-.312c.14-.414.606-.625 1.039-.625.692 0 1.25.628 1.25 1.406 0 .29-.078.56-.211.781C16.064 3.567 14 6 14 6"
  }), couples_jsx("path", {
    fill: color,
    d: "M14.2 1.67h.3v.3h-.3z"
  }));
};
/* harmony default export */ var couples = (Couples);
;// CONCATENATED MODULE: ../shared/src/svg/smoking.js


var smoking_excluded = ["color"];
var smoking_jsx = react.createElement;

var Smoking = function Smoking(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#224251' : _ref$color,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, smoking_excluded);
  return smoking_jsx("svg", (0,esm_extends/* default */.Z)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), smoking_jsx("rect", {
    width: 17.8,
    height: 3.8,
    x: 1.1,
    y: 12.366,
    stroke: color,
    strokeWidth: 0.8,
    rx: 0.6
  }), smoking_jsx("path", {
    stroke: color,
    strokeWidth: 0.6,
    d: "M5 12.766v3"
  }), smoking_jsx("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeWidth: 0.7,
    d: "M21 12.766v3M22.5 12.766v3"
  }), smoking_jsx("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeWidth: 0.8,
    d: "M20.79 4.766c-.97 0-2.426.467-2.426 1.4 0 .933.485.933 0 1.867-.485.933.65 1.733 1.136 1.733.485 0 .698-.578 1.29.133.473.57 0 1.867 0 1.867"
  }), smoking_jsx("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeWidth: 0.8,
    d: "M20 3c.636 0 2.093.24 2.5.766.407.526.573 1.014 0 2-.427.735-2 .581-2 1.5 0 .92 2.13.174 2.13.996v2.104"
  }));
};
/* harmony default export */ var smoking = (Smoking);
// EXTERNAL MODULE: ../shared/src/svg/no-smoking.js
var no_smoking = __webpack_require__(2348);
;// CONCATENATED MODULE: ../shared/src/svg/no-couples.js


var no_couples_excluded = ["color", "background"];
var no_couples_jsx = react.createElement;

var NoCouples = function NoCouples(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#224251' : _ref$color,
    _ref$background = _ref.background,
    background = _ref$background === void 0 ? '#fff' : _ref$background,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, no_couples_excluded);
  return no_couples_jsx("svg", (0,esm_extends/* default */.Z)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), no_couples_jsx("path", {
    stroke: color,
    strokeLinejoin: "round",
    d: "M6.976 14.296v1.998l-3.565 1.294A2.159 2.159 0 0 0 2 19.632v1.366h13.572v-1.366a2.16 2.16 0 0 0-1.411-2.044l-3.565-1.294v-2.113"
  }), no_couples_jsx("path", {
    stroke: color,
    strokeLinejoin: "round",
    d: "M12.268 10.507c0 2.398-1.6 4.342-3.572 4.342-1.973 0-3.571-1.944-3.571-4.342 0-2.398 1.598-4.34 3.571-4.34 1.972 0 3.572 1.942 3.572 4.34Z",
    clipRule: "evenodd"
  }), no_couples_jsx("path", {
    stroke: color,
    strokeLinejoin: "round",
    d: "M12.24 10.116c-.12.015-.219.006-.339.03-1.217.237-1.998-.21-2.668-1.397-.402.78-1.657 1.396-2.69 1.396-.507 0-.944-.105-1.381-.337"
  }), no_couples_jsx("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M17.861 20.998H21v-1.365a2.16 2.16 0 0 0-1.41-2.044l-3.566-1.294v-2.114"
  }), no_couples_jsx("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.125 6.167c1.972 0 3.571 1.943 3.571 4.34 0 2.398-1.599 4.342-3.571 4.342"
  }), no_couples_jsx("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M17.668 10.116c-.12.015-.218.006-.338.03-1.218.237-1.998-.21-2.669-1.397"
  }), no_couples_jsx("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8,
    d: "m12.292 3.742-.168-.247c-.193-.287-.479-.495-.822-.495-.547 0-.99.497-.99 1.113 0 .23.062.443.168.619.178.3 1.812 2.226 1.812 2.226m0-3.216s0 .248.167-.247c.11-.328.48-.495.822-.495.548 0 .99.497.99 1.113 0 .23-.062.443-.167.619-.178.3-1.812 2.226-1.812 2.226"
  }), no_couples_jsx("path", {
    fill: color,
    d: "M12.45 3.53h.238v.238h-.238z"
  }), no_couples_jsx("rect", {
    width: 1.5,
    height: 28.638,
    x: 1.354,
    y: 2.373,
    fill: color,
    stroke: background,
    strokeWidth: 0.5,
    rx: 0.75,
    transform: "rotate(-45 1.354 2.373)"
  }));
};
/* harmony default export */ var no_couples = (NoCouples);
// EXTERNAL MODULE: ../shared/src/svg/domestic-student.js
var domestic_student = __webpack_require__(55600);
;// CONCATENATED MODULE: ../shared/src/svg/occasional-guests.js


var occasional_guests_excluded = ["color", "background"];
var occasional_guests_jsx = react.createElement;

var OccasionalGuests = function OccasionalGuests(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#224251' : _ref$color,
    _ref$background = _ref.background,
    background = _ref$background === void 0 ? '#fff' : _ref$background,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, occasional_guests_excluded);
  return occasional_guests_jsx("svg", (0,esm_extends/* default */.Z)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), occasional_guests_jsx("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M22 20v-3m0 0H10m12 0v-2a3 3 0 0 0-3-3h-9v5m-8 0h8m-8-6v9m2-8a2 2 0 1 0 4 0 2 2 0 0 0-4 0Z"
  }), occasional_guests_jsx("g", {
    stroke: color,
    strokeLinejoin: "round",
    clipPath: "url(#a)"
  }, occasional_guests_jsx("path", {
    strokeLinecap: "round",
    strokeWidth: 0.4,
    d: "M11 5h1l-1 1h1m.5-3h1.333L12.5 4.333h1.333"
  }), occasional_guests_jsx("path", {
    strokeWidth: 0.7,
    d: "M9.546 4a2.648 2.648 0 0 0-.123.8c0 1.44 1.147 2.607 2.562 2.607.349 0 .695-.072 1.015-.213A2.567 2.567 0 0 1 10.562 9C9.147 9 8 7.833 8 6.394 8 5.32 8.637 4.4 9.546 4Z"
  })), occasional_guests_jsx("defs", null, occasional_guests_jsx("clipPath", {
    id: "a"
  }, occasional_guests_jsx("path", {
    fill: background,
    d: "M7 2h8v8H7z"
  }))));
};
/* harmony default export */ var occasional_guests = (OccasionalGuests);
// EXTERNAL MODULE: ../shared/src/svg/no-occasional-guests.js
var no_occasional_guests = __webpack_require__(83544);
;// CONCATENATED MODULE: ../shared/src/svg/calendar-minimum-stay.js


var calendar_minimum_stay_excluded = ["colorStroke", "colorFill"];
var calendar_minimum_stay_jsx = react.createElement;

var CalendarMinimumStay = function CalendarMinimumStay(_ref) {
  var _ref$colorStroke = _ref.colorStroke,
    colorStroke = _ref$colorStroke === void 0 ? '#224251' : _ref$colorStroke,
    _ref$colorFill = _ref.colorFill,
    colorFill = _ref$colorFill === void 0 ? '#224251' : _ref$colorFill,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, calendar_minimum_stay_excluded);
  return calendar_minimum_stay_jsx("svg", (0,esm_extends/* default */.Z)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), calendar_minimum_stay_jsx("g", {
    clipPath: "url(#a)"
  }, calendar_minimum_stay_jsx("g", {
    stroke: colorStroke,
    strokeLinecap: "round",
    clipPath: "url(#b)"
  }, calendar_minimum_stay_jsx("path", {
    strokeLinejoin: "round",
    d: "M17.5 23.501a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z"
  }), calendar_minimum_stay_jsx("path", {
    strokeLinejoin: "round",
    d: "M9.5 18.5h-8a1 1 0 0 1-1-1v-14a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1V10M5.5.501v5M15.5.501v5M.5 7.501h20"
  }), calendar_minimum_stay_jsx("path", {
    strokeWidth: 1.1,
    d: "M17.5 14v3.8c0 .11.09.2.2.2h3.1"
  }))), calendar_minimum_stay_jsx("defs", null, calendar_minimum_stay_jsx("clipPath", {
    id: "a"
  }, calendar_minimum_stay_jsx("path", {
    fill: colorFill,
    d: "M0 0h24v24H0z"
  })), calendar_minimum_stay_jsx("clipPath", {
    id: "b"
  }, calendar_minimum_stay_jsx("path", {
    fill: colorFill,
    d: "M0 0h24v24H0z"
  }))));
};
/* harmony default export */ var calendar_minimum_stay = (CalendarMinimumStay);
// EXTERNAL MODULE: ../shared/src/svg/international-student.js
var international_student = __webpack_require__(48175);
;// CONCATENATED MODULE: ../shared/src/svg/calendar-short-term-penalty.js


var calendar_short_term_penalty_excluded = ["color"];
var calendar_short_term_penalty_jsx = react.createElement;

var CalendarShortTermPenalty = function CalendarShortTermPenalty(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#224251' : _ref$color,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, calendar_short_term_penalty_excluded);
  return calendar_short_term_penalty_jsx("svg", (0,esm_extends/* default */.Z)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), calendar_short_term_penalty_jsx("g", {
    stroke: color,
    strokeLinecap: "round",
    clipPath: "url(#a)"
  }, calendar_short_term_penalty_jsx("path", {
    strokeLinejoin: "round",
    d: "M17.5 23.501a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z"
  }), calendar_short_term_penalty_jsx("path", {
    strokeLinejoin: "round",
    d: "M9.5 18.5h-8a1 1 0 0 1-1-1v-14a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1V10M5.5.501v5M15.5.501v5M.5 7.501h20"
  }), calendar_short_term_penalty_jsx("path", {
    strokeWidth: 1.2,
    d: "M17.43 18.02v-3.54M17.43 20.02v0"
  })), calendar_short_term_penalty_jsx("defs", null, calendar_short_term_penalty_jsx("clipPath", {
    id: "a"
  }, calendar_short_term_penalty_jsx("path", {
    fill: color,
    d: "M0 0h24v24H0z"
  }))));
};
/* harmony default export */ var calendar_short_term_penalty = (CalendarShortTermPenalty);
;// CONCATENATED MODULE: ../shared/src/svg/no-professionals-alt.js


var no_professionals_alt_excluded = ["color"];
var no_professionals_alt_jsx = react.createElement;

var NoProfessionalsAlt = function NoProfessionalsAlt(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#224251' : _ref$color,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, no_professionals_alt_excluded);
  return no_professionals_alt_jsx("svg", (0,esm_extends/* default */.Z)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), no_professionals_alt_jsx("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M12 13c2.762 0 5-2.238 5-5 0-2.763-2.238-5-5-5S7 5.237 7 8c0 2.762 2.238 5 5 5Zm4-5c0 2.21-1.79 4-4 4s-4-1.79-4-4 1.79-4 4-4 4 1.79 4 4Zm-1.482 5.937L13 18.272V18l-.287-2.01a.5.5 0 0 0 .382-.369l.25-1A.5.5 0 0 0 12.86 14h-1.719a.498.498 0 0 0-.485.621l.25 1a.5.5 0 0 0 .382.368l-.281 1.966-1.527-4.023-.01-.022a.74.74 0 0 0-.838-.396c-.17.042-.358.086-.557.133-.468.109-.997.232-1.498.372-.707.197-1.439.445-1.947.779C3.693 15.413 3 16.227 3 17.25V21h18v-3.75c0-1.023-.693-1.838-1.63-2.452-.508-.334-1.24-.582-1.947-.779a37.602 37.602 0 0 0-1.497-.373 66.232 66.232 0 0 1-.558-.132.74.74 0 0 0-.837.396l-.014.027Zm1.204.689-.356-.084L13.454 20H20v-2.75c0-.523-.352-1.073-1.178-1.616-.367-.242-.965-.457-1.666-.652a35.452 35.452 0 0 0-1.434-.356Zm-7.081-.085L10.713 20H4v-2.75c0-.523.352-1.073 1.178-1.616.367-.242.966-.457 1.667-.652.475-.128.952-.247 1.433-.356l.363-.085Z",
    clipRule: "evenodd"
  }), no_professionals_alt_jsx("path", {
    stroke: color,
    strokeWidth: 0.8,
    d: "M7.5 8c2.363-.394 4.416-1.719 5.181-2.263a.435.435 0 0 1 .576.067c.296.338.798.878 1.243 1.196.683.488 2 1 2 1"
  }), no_professionals_alt_jsx("rect", {
    width: 1.5,
    height: 28.638,
    x: 1.354,
    y: 2.373,
    fill: color,
    stroke: "#fff",
    strokeWidth: 0.5,
    rx: 0.75,
    transform: "rotate(-45 1.354 2.373)"
  }));
};
/* harmony default export */ var no_professionals_alt = (NoProfessionalsAlt);
;// CONCATENATED MODULE: ../shared/src/svg/no-students.js


var no_students_excluded = ["color"];
var no_students_jsx = react.createElement;

var NoStudents = function NoStudents(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#224251' : _ref$color,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, no_students_excluded);
  return no_students_jsx("svg", (0,esm_extends/* default */.Z)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), no_students_jsx("path", {
    fill: color,
    d: "m18.965 17.56-4.082-1.054c.729-.593 1.239-1.318 1.385-2.24.51-.132.875-.659.875-1.318 0-.197-.073-.395-.073-.527l.364-2.568c0-.066.146-1.318-.948-2.438-.874-.922-2.405-1.383-4.373-1.383-1.969 0-3.427.461-4.375 1.383-1.093 1.054-.947 2.372-.947 2.438l.364 2.569c-.073.131-.073.329-.073.526 0 .66.365 1.12.875 1.318.073.922.656 1.713 1.458 2.306l-4.228.988C3.875 18.02 3 19.14 3 20.458v1.713c0 .197.146.329.365.329h17.568c.22 0 .365-.132.365-.33v-1.712c-.073-1.317-.948-2.437-2.333-2.898ZM8.25 7.876c.802-.79 2.114-1.185 3.864-1.185s3.061.395 3.79 1.12c.875.856.73 1.91.73 1.91l-.292 1.976c-.073 0-.146-.066-.219-.066l-.364-1.515c0-.132-.22-.263-.365-.263-2.26 0-2.697-.593-2.916-.989.073-.065 0-.197-.073-.263a.379.379 0 0 0-.51 0c-.146.066-.219.198-.292.33-.219.395-.656.987-2.916.987-.146-.065-.291.066-.364.198l-.292 1.515c-.073 0-.146.066-.219.066L7.52 9.72s-.073-.988.729-1.845Zm.437 6.06c0-.197-.146-.329-.364-.329-.365 0-.51-.46-.51-.724 0-.264.072-.725.51-.725.145 0 .291-.132.364-.263l.292-1.45c2.041 0 2.697-.46 3.135-1.054.437.593 1.093 1.054 3.134 1.12l.292 1.45c0 .131.219.263.364.263.365 0 .51.461.51.724 0 .264-.072.725-.51.725-.218 0-.364.132-.364.33 0 .988-.73 1.778-1.531 2.37a.578.578 0 0 0-.292.133c-.583.395-1.239.593-1.676.593-.365 0-1.021-.198-1.604-.527-.073-.066-.146-.066-.219-.132-.802-.593-1.53-1.45-1.53-2.503Zm3.427 4.81c-.438 0-.802-.33-.802-.725v-.461c.291.066.583.131.802.131.218 0 .51-.066.801-.131v.46c0 .396-.364.725-.801.725Zm-8.384 1.712c0-1.054.656-1.91 1.677-2.306l4.665-1.12c.146.067.292.198.51.264v.79c0 .527.365 1.055.875 1.252l-1.822 2.503H3.729v-1.383Zm6.78 1.383 1.604-2.174 1.603 2.174H10.51Zm9.987 0h-5.905l-.948-1.284-.947-1.285c.51-.197.874-.724.874-1.251v-.79c.22-.067.365-.198.584-.33l4.52 1.186c1.093.329 1.75 1.251 1.75 2.305v1.45h.072Z"
  }), no_students_jsx("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.9,
    d: "m19.468 3.973-3.513 1.601-3.806-.914-3.66.8-3.66-1.487L12.15 1l7.32 2.973Z"
  }), no_students_jsx("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeWidth: 0.8,
    d: "M17.377 7.404c0-1.516-2.847-2.287-5.228-2.287-2.38 0-5.228.771-5.228 2.287"
  }), no_students_jsx("path", {
    stroke: color,
    strokeLinecap: "square",
    strokeWidth: 0.4,
    d: "M18.945 3.745v2.653"
  }), no_students_jsx("path", {
    fill: color,
    d: "M18.757 6.601a.2.2 0 0 1 .38 0l.637 1.912a.2.2 0 0 1-.19.264H18.31a.2.2 0 0 1-.19-.264l.638-1.912Z"
  }), no_students_jsx("rect", {
    width: 1.5,
    height: 28.638,
    x: 1.354,
    y: 2.373,
    fill: color,
    stroke: "#fff",
    strokeWidth: 0.5,
    rx: 0.75,
    transform: "rotate(-45 1.354 2.373)"
  }));
};
/* harmony default export */ var no_students = (NoStudents);
;// CONCATENATED MODULE: ../shared/src/svg/persons.js


var persons_excluded = ["color"];
var persons_jsx = react.createElement;

var Persons = function Persons(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#224251' : _ref$color,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, persons_excluded);
  return persons_jsx("svg", (0,esm_extends/* default */.Z)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 25,
    fill: "none"
  }, props), persons_jsx("path", {
    stroke: color,
    strokeLinejoin: "round",
    d: "M8.286 14.715v2.524l-4.504 1.635C2.702 19.264 2 20.299 2 21.456v1.725h17.143v-1.725c0-1.157-.704-2.19-1.782-2.582l-4.503-1.634v-2.67"
  }), persons_jsx("path", {
    stroke: color,
    strokeLinejoin: "round",
    d: "M14.97 9.928c0 3.03-2.02 5.486-4.511 5.486-2.493 0-4.512-2.456-4.512-5.486 0-3.027 2.02-5.481 4.512-5.481 2.49 0 4.51 2.454 4.51 5.481Z",
    clipRule: "evenodd"
  }), persons_jsx("path", {
    stroke: color,
    strokeLinejoin: "round",
    d: "M14.934 9.435c-.15.02-.275.008-.427.038-1.538.3-2.524-.265-3.37-1.764-.508.985-2.093 1.764-3.397 1.764-.641 0-1.194-.133-1.746-.427"
  }), persons_jsx("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M22.035 23.18H26v-1.723c0-1.158-.703-2.191-1.782-2.583l-4.503-1.634v-2.67"
  }), persons_jsx("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M17.316 4.447c2.491 0 4.51 2.454 4.51 5.482 0 3.03-2.02 5.485-4.51 5.485"
  }), persons_jsx("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21.791 9.435c-.15.02-.275.008-.427.038-1.538.3-2.524-.265-3.37-1.764"
  }));
};
/* harmony default export */ var persons = (Persons);
;// CONCATENATED MODULE: ./src/utils/rentalConditions/index.js

var rentalConditions_jsx = react.createElement;



















var getRentalConditions = function getRentalConditions(_ref) {
  var minimumStay = _ref.minimumStay,
      shortTermPenaltyAmount = _ref.shortTermPenaltyAmount,
      shortTermPenaltyPrice = _ref.shortTermPenaltyPrice,
      extraGuestsAmountStandardContract = _ref.extraGuestsAmountStandardContract,
      extraGuestsAmountFixedUnitaryContract = _ref.extraGuestsAmountFixedUnitaryContract,
      extraGuestsFormattedAmount = _ref.extraGuestsFormattedAmount,
      overnightGuestsAllowed = _ref.overnightGuestsAllowed,
      requirementsList = _ref.requirementsList,
      petsAllowed = _ref.petsAllowed,
      smokingAllowed = _ref.smokingAllowed,
      isCouplesAllowed = _ref.isCouplesAllowed,
      gender = _ref.gender,
      t = _ref.t,
      originsList = _ref.originsList,
      occupationsList = _ref.occupationsList;
  var baseConditions = [{
    icon: calendar_minimum_stay,
    translationKey: 'Minimum stay',
    translationValues: {
      count: minimumStay
    },
    order: true
  }];
  var hasShortTermPenalty = shortTermPenaltyAmount && shortTermPenaltyAmount > 0;
  return [].concat(baseConditions, (0,toConsumableArray/* default */.Z)(hasShortTermPenalty ? [{
    icon: calendar_short_term_penalty,
    translationKey: 'Short term penalty',
    translationValues: {
      days: shortTermPenaltyAmount,
      amount: shortTermPenaltyPrice || ''
    },
    order: true
  }] : []), (0,toConsumableArray/* default */.Z)(extraGuestsAmountStandardContract > 0 || extraGuestsAmountFixedUnitaryContract > 0 ? [{
    icon: persons,
    translationKey: 'Extra per tenant {{amount}}',
    translationValues: {
      amount: extraGuestsFormattedAmount || '0'
    },
    order: true
  }] : []), (0,toConsumableArray/* default */.Z)(overnightGuestsAllowed ? [{
    icon: occasional_guests,
    translationKey: 'Overnight guests allowed',
    order: true
  }] : [{
    icon: no_occasional_guests/* default */.Z,
    translationKey: 'Overnight guests allowed',
    className: 'text-strike-through',
    order: false
  }]), [{
    icon: isCouplesAllowed ? couples : no_couples,
    translationKey: 'Couples allowed',
    className: isCouplesAllowed ? '' : 'text-strike-through',
    order: isCouplesAllowed
  }, {
    icon: petsAllowed ? pet : no_pets/* default */.Z,
    translationKey: 'Pets allowed',
    className: petsAllowed ? '' : 'text-strike-through',
    order: petsAllowed
  }, {
    icon: smokingAllowed ? smoking : no_smoking/* default */.Z,
    translationKey: 'Smoking allowed',
    className: smokingAllowed ? '' : 'text-strike-through',
    order: smokingAllowed
  }], (0,toConsumableArray/* default */.Z)(gender !== null && gender !== void 0 && gender.length ? [{
    icon: gender.includes('males') ? female_gender : male_gender,
    translationKey: gender.includes('males') ? 'Females only' : 'Males only',
    order: true
  }] : []), (0,toConsumableArray/* default */.Z)(originsList !== null && originsList !== void 0 && originsList.length ? [{
    icon: originsList.includes('domestic') ? international_student/* default */.Z : domestic_student/* default */.Z,
    translationKey: originsList.includes('domestic') ? 'International students only' : 'Domestic students only',
    order: true
  }] : []), (0,toConsumableArray/* default */.Z)(occupationsList !== null && occupationsList !== void 0 && occupationsList.length ? occupationsList.filter(function (occupation) {
    return occupation != 'unknown';
  }).map(function (occupation) {
    return {
      icon: occupation === 'professional-placement' ? no_professionals_alt : no_students,
      translationKey: occupation === 'professional-placement' ? 'Professionals allowed' : occupation === 'undergraduate' ? 'Undergraduate students allowed' : 'Postgraduate students allowed',
      className: 'text-strike-through',
      order: false
    };
  }) : []), (0,toConsumableArray/* default */.Z)(requirementsList !== null && requirementsList !== void 0 && requirementsList.length ? [{
    translationKey: 'Requirements',
    content: rentalConditions_jsx(react.Fragment, null, rentalConditions_jsx("h3", null, t('Provide documents')), rentalConditions_jsx(styles_List, null, requirementsList.map(function (requirement, index) {
      return rentalConditions_jsx(ListItem, {
        key: index
      }, requirement);
    }))),
    order: true
  }] : [])).sort(function (a, b) {
    return a.order && !b.order ? -1 : !a.order && b.order ? 0 : 1;
  });
};
;// CONCATENATED MODULE: ./src/utils/rentalConditions/formatting/index.js

var formatExtraGuestsAmount = function formatExtraGuestsAmount(standardAmount, unitaryAmount, currencyCode, language) {
  var amount = standardAmount || unitaryAmount;
  return !amount || !currencyCode ? '' : formatMoneyPerCountry(amount, currencyCode, language);
};
var getRequirementsList = function getRequirementsList(requirements, t) {
  var requirementsMap = [{
    condition: requirements.contract,
    text: t('Contract required')
  }, {
    condition: requirements.guarantor,
    text: t('Guarantor required')
  }, {
    condition: requirements.offlineId,
    text: t('Passport or ID')
  }, {
    condition: requirements.occupation,
    text: t('Proof of occupation')
  }];
  return requirementsMap.filter(function (_ref) {
    var condition = _ref.condition;
    return condition;
  }).map(function (_ref2) {
    var text = _ref2.text;
    return text;
  });
};
;// CONCATENATED MODULE: ./src/utils/rentalConditions/penalties/index.js

var calculateShortTermPenalty = function calculateShortTermPenalty(accommodationOffer) {
  var _accommodationOffer$c, _accommodationOffer$c2;

  if (!(accommodationOffer !== null && accommodationOffer !== void 0 && (_accommodationOffer$c = accommodationOffer.contract) !== null && _accommodationOffer$c !== void 0 && (_accommodationOffer$c2 = _accommodationOffer$c.standard) !== null && _accommodationOffer$c2 !== void 0 && _accommodationOffer$c2.penalty)) {
    return {
      shortTermPenaltyAmount: 0,
      shortTermPenaltyPrice: ''
    };
  }

  var _accommodationOffer$c3 = accommodationOffer.contract.standard.penalty,
      penaltyPrice = _accommodationOffer$c3.value,
      penaltyNights = _accommodationOffer$c3.nights_threshold;

  if (!(penaltyPrice !== null && penaltyPrice !== void 0 && penaltyPrice.amount) || !penaltyNights) {
    return {
      shortTermPenaltyAmount: 0,
      shortTermPenaltyPrice: ''
    };
  }

  return {
    shortTermPenaltyAmount: penaltyNights,
    shortTermPenaltyPrice: (0,money/* formatMoney */.lb)(penaltyPrice.amount, penaltyPrice.currency_code) || ''
  };
};
;// CONCATENATED MODULE: ../shared/src/constants/restrictionsTypes.js
var OCCUPANCY_TYPES = {
  DOMESTIC: 'domestic',
  INTERNATIONAL: 'international'
};
var GENDER_RESTRICTIONS_TO_GENDER_TYPE = {
  MALES: 'F',
  FEMALES: 'M'
};
;// CONCATENATED MODULE: ./src/components/RentalConditions/index.js
var RentalConditions_jsx = react.createElement;














var RentalConditions = function RentalConditions(_ref) {
  var minimumStay = _ref.minimumStay,
      extraGuestsAmountStandardContract = _ref.extraGuestsAmountStandardContract,
      extraGuestsAmountFixedUnitaryContract = _ref.extraGuestsAmountFixedUnitaryContract,
      shortTermPenaltyAmount = _ref.shortTermPenaltyAmount,
      shortTermPenaltyPrice = _ref.shortTermPenaltyPrice,
      gender = _ref.gender,
      extraGuestsFormattedAmount = _ref.extraGuestsFormattedAmount,
      isCouplesAllowed = _ref.isCouplesAllowed,
      petsAllowed = _ref.petsAllowed,
      smokingAllowed = _ref.smokingAllowed,
      overnightGuestsAllowed = _ref.overnightGuestsAllowed,
      requirements = _ref.requirements,
      originsList = _ref.originsList,
      occupationsList = _ref.occupationsList,
      guestGender = _ref.guestGender,
      showGenderRestrictionModal = _ref.showGenderRestrictionModal;

  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var genderRestriction = gender === null || gender === void 0 ? void 0 : gender[0];
  var allowedGender = GENDER_RESTRICTIONS_TO_GENDER_TYPE[genderRestriction === null || genderRestriction === void 0 ? void 0 : genderRestriction.toUpperCase()];
  var requirementsList = getRequirementsList(requirements, t);
  var rentalConditions = (0,react.useMemo)(function () {
    return getRentalConditions({
      minimumStay: minimumStay,
      shortTermPenaltyAmount: shortTermPenaltyAmount,
      shortTermPenaltyPrice: shortTermPenaltyPrice,
      extraGuestsAmountStandardContract: extraGuestsAmountStandardContract,
      extraGuestsAmountFixedUnitaryContract: extraGuestsAmountFixedUnitaryContract,
      extraGuestsFormattedAmount: extraGuestsFormattedAmount,
      requirementsList: requirementsList,
      petsAllowed: petsAllowed,
      smokingAllowed: smokingAllowed,
      isCouplesAllowed: isCouplesAllowed,
      overnightGuestsAllowed: overnightGuestsAllowed,
      gender: gender,
      originsList: originsList,
      occupationsList: occupationsList,
      t: t
    });
  }, [minimumStay, shortTermPenaltyAmount, shortTermPenaltyPrice, extraGuestsAmountStandardContract, extraGuestsAmountFixedUnitaryContract, extraGuestsFormattedAmount, requirementsList, petsAllowed, smokingAllowed, isCouplesAllowed, gender, originsList, occupationsList, t]);
  (0,react.useEffect)(function () {
    var shouldRenderGenderRestrictionModal = !genderRestriction || !guestGender || allowedGender === guestGender;

    if (shouldRenderGenderRestrictionModal) {
      return;
    }

    showGenderRestrictionModal(genderRestriction);
  }, [guestGender, genderRestriction, allowedGender]);
  return RentalConditions_jsx(RentalConditions_styles_Wrapper, {
    id: 'rental-conditions'
  }, RentalConditions_jsx("h2", null, t('Rental Conditions')), RentalConditions_jsx(List, null, rentalConditions.map(function (_ref2, index) {
    var icon = _ref2.icon,
        translationKey = _ref2.translationKey,
        translationValues = _ref2.translationValues,
        content = _ref2.content,
        _ref2$className = _ref2.className,
        className = _ref2$className === void 0 ? '' : _ref2$className;
    var Icon = icon;
    var text = t(translationKey, translationValues);
    return RentalConditions_jsx(RentalConditions_Item, {
      key: index,
      icon: Icon ? RentalConditions_jsx(Icon, null) : null,
      text: text,
      className: className
    }, content);
  })));
};

var RentalConditions_mapStateToProps = function mapStateToProps(_ref3) {
  var _offerAggregate$prope, _offerAggregate$prope2, _contract$standard, _contract$standard$ex, _contract$standard2, _contract$standard2$e, _propertyAggregate$pr, _propertyAggregate$pr2, _propertyAggregate$pr3, _propertyAggregate$pr4, _profile$profile, _profile$profile$basi, _contract$fixed_unita, _contract$fixed_unita2;

  var offerAggregate = _ref3.offer.offerAggregate,
      profile = _ref3.profile;
  var accommodationOffer = offerAggregate.accommodation_offer;
  var propertyAggregate = offerAggregate.property_aggregate;

  var _ref4 = accommodationOffer || {},
      _ref4$requisites = _ref4.requisites;

  _ref4$requisites = _ref4$requisites === void 0 ? {} : _ref4$requisites;
  var conditions = _ref4$requisites.conditions,
      requirements = _ref4$requisites.requirements,
      _ref4$restrictions = _ref4.restrictions;
  _ref4$restrictions = _ref4$restrictions === void 0 ? {} : _ref4$restrictions;
  var gender = _ref4$restrictions.gender,
      occupancy = _ref4$restrictions.occupancy,
      _ref4$price = _ref4.price;
  _ref4$price = _ref4$price === void 0 ? {} : _ref4$price;
  var referencePrice = _ref4$price.reference,
      contract = _ref4.contract;
  var rules = (offerAggregate === null || offerAggregate === void 0 ? void 0 : (_offerAggregate$prope = offerAggregate.property_aggregate) === null || _offerAggregate$prope === void 0 ? void 0 : (_offerAggregate$prope2 = _offerAggregate$prope.property) === null || _offerAggregate$prope2 === void 0 ? void 0 : _offerAggregate$prope2.rules) || [];
  var extraGuestAmount = (contract === null || contract === void 0 ? void 0 : (_contract$standard = contract.standard) === null || _contract$standard === void 0 ? void 0 : (_contract$standard$ex = _contract$standard.extra_per_guest) === null || _contract$standard$ex === void 0 ? void 0 : _contract$standard$ex.amount) || 0;
  var extraGuestCurrency = (contract === null || contract === void 0 ? void 0 : (_contract$standard2 = contract.standard) === null || _contract$standard2 === void 0 ? void 0 : (_contract$standard2$e = _contract$standard2.extra_per_guest) === null || _contract$standard2$e === void 0 ? void 0 : _contract$standard2$e.currency_code) || (referencePrice === null || referencePrice === void 0 ? void 0 : referencePrice.currency_code);
  var extraGuestsFormattedAmount = (0,utils/* formatMoneyPerCountry */.h6)(extraGuestAmount, extraGuestCurrency);

  var _calculateShortTermPe = calculateShortTermPenalty(accommodationOffer),
      shortTermPenaltyAmount = _calculateShortTermPe.shortTermPenaltyAmount,
      shortTermPenaltyPrice = _calculateShortTermPe.shortTermPenaltyPrice;

  var originsList = propertyAggregate === null || propertyAggregate === void 0 ? void 0 : (_propertyAggregate$pr = propertyAggregate.property) === null || _propertyAggregate$pr === void 0 ? void 0 : (_propertyAggregate$pr2 = _propertyAggregate$pr.restrictions) === null || _propertyAggregate$pr2 === void 0 ? void 0 : _propertyAggregate$pr2.origin;
  var occupationsList = propertyAggregate === null || propertyAggregate === void 0 ? void 0 : (_propertyAggregate$pr3 = propertyAggregate.property) === null || _propertyAggregate$pr3 === void 0 ? void 0 : (_propertyAggregate$pr4 = _propertyAggregate$pr3.restrictions) === null || _propertyAggregate$pr4 === void 0 ? void 0 : _propertyAggregate$pr4.occupation;

  var getRuleValue = function getRuleValue(rules, ruleCode) {
    var _rules$find;

    return Array.isArray(rules) && ((_rules$find = rules.find(function (rule) {
      return rule.code === ruleCode;
    })) === null || _rules$find === void 0 ? void 0 : _rules$find.exists) || false;
  };

  var guestGender = profile === null || profile === void 0 ? void 0 : (_profile$profile = profile.profile) === null || _profile$profile === void 0 ? void 0 : (_profile$profile$basi = _profile$profile.basic_info) === null || _profile$profile$basi === void 0 ? void 0 : _profile$profile$basi.gender;
  return {
    minimumStay: conditions === null || conditions === void 0 ? void 0 : conditions.minimum_nights,
    shortTermPenaltyAmount: shortTermPenaltyAmount,
    shortTermPenaltyPrice: shortTermPenaltyPrice,
    extraGuestsAmountStandardContract: extraGuestAmount,
    extraGuestsAmountFixedUnitaryContract: (contract === null || contract === void 0 ? void 0 : (_contract$fixed_unita = contract.fixed_unitary) === null || _contract$fixed_unita === void 0 ? void 0 : (_contract$fixed_unita2 = _contract$fixed_unita.extra_per_guest) === null || _contract$fixed_unita2 === void 0 ? void 0 : _contract$fixed_unita2.amount) || 0,
    extraGuestsFormattedAmount: extraGuestsFormattedAmount,
    gender: gender,
    isCouplesAllowed: !(occupancy !== null && occupancy !== void 0 && occupancy.find(function (couples) {
      return couples === 'couples';
    })) && (conditions === null || conditions === void 0 ? void 0 : conditions.max_guests) > 1,
    petsAllowed: getRuleValue(rules, RULE_CODES.PETS_ALLOWED),
    smokingAllowed: getRuleValue(rules, RULE_CODES.SMOKING_ALLOWED),
    overnightGuestsAllowed: getRuleValue(rules, RULE_CODES.OVERNIGHT_GUESTS_ALLOWED),
    requirements: {
      contract: requirements === null || requirements === void 0 ? void 0 : requirements.contract,
      guarantor: requirements === null || requirements === void 0 ? void 0 : requirements.guarantor,
      offlineId: requirements === null || requirements === void 0 ? void 0 : requirements.offline_id,
      occupation: requirements === null || requirements === void 0 ? void 0 : requirements.occupation
    },
    originsList: originsList,
    occupationsList: occupationsList,
    guestGender: guestGender
  };
};

var RentalConditions_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    showGenderRestrictionModal: function showGenderRestrictionModal(genderRestriction) {
      return dispatch((0,modal/* showModalAction */.bF)({
        modalId: modal_displayer.modalIds.GENDER_RESTRICTION,
        genderRestriction: genderRestriction
      }));
    }
  };
};

/* harmony default export */ var components_RentalConditions = ((0,es/* connect */.$j)(RentalConditions_mapStateToProps, RentalConditions_mapDispatchToProps)(RentalConditions));
;// CONCATENATED MODULE: ./src/components/PricingBox/Desktop/PriceDetails/styles.js



var PriceDetails_styles_Wrapper = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-zh2eq-0"
})(["display:flex;flex-direction:column;gap:", ";", "{border-top:1px solid ", ";}"], function (props) {
  return props.theme.space(5);
}, Separator/* default */.Z, theme/* theme.separator.color */.rS.separator.color);
var PriceDetails_styles_Title = /*#__PURE__*/styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
  componentId: "sc-zh2eq-1"
})(["font-size:", ";color:", ";margin-top:-", ";"], function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.colors.cornFlowerBlue;
}, function (props) {
  return props.theme.space(4);
});
// EXTERNAL MODULE: ../shared/src/constants/payTo.js
var payTo = __webpack_require__(10748);
// EXTERNAL MODULE: ../shared/src/constants/months.js
var months = __webpack_require__(629);
// EXTERNAL MODULE: ../shared/src/components/PriceLine/index.js
var PriceLine = __webpack_require__(11769);
;// CONCATENATED MODULE: ./src/components/PricingBox/Desktop/PriceDetails/index.js

var PriceDetails_jsx = react.createElement;









var PriceDetails = function PriceDetails(_ref) {
  var priceDetails = _ref.priceDetails,
      hasRentCollection = _ref.hasRentCollection;

  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var serviceFee = priceDetails.fee.values.capped,
      holdingDeposit = priceDetails.deposit,
      firstRentPayment = priceDetails.first_payment,
      _priceDetails$rents$i = (0,slicedToArray/* default */.Z)(priceDetails.rents.items, 1),
      firstRent = _priceDetails$rents$i[0],
      onBooking = priceDetails.payments.on_booking;

  var hasServiceFee = serviceFee.amount > 0;
  var hasHoldingDeposit = holdingDeposit.pay_to === payTo/* PAY_TO.US */.X.US;
  return PriceDetails_jsx(PriceDetails_styles_Wrapper, null, PriceDetails_jsx(Separator/* default */.Z, null), PriceDetails_jsx("h2", null, t('If and only after the landlord approves')), PriceDetails_jsx(PriceDetails_styles_Title, null, t('You\'ll pay through Uniplaces'), ":"), PriceDetails_jsx(PriceLine/* default */.Z, {
    bigger: true,
    title: hasRentCollection ? t("".concat(months/* MONTHS */.g[firstRent.month])) : t('First rental payment'),
    description: t('Covers the first month'),
    value: (0,utils/* formatMoney */.lb)(firstRentPayment.total.amount, firstRentPayment.total.currency_code)
  }), hasServiceFee ? PriceDetails_jsx(PriceLine/* default */.Z, {
    bigger: true,
    title: t('One-time service fee'),
    description: t('One time payment'),
    value: (0,utils/* formatMoney */.lb)(serviceFee.amount, serviceFee.currency_code)
  }) : null, hasHoldingDeposit ? PriceDetails_jsx(PriceLine/* default */.Z, {
    bigger: true,
    title: t('Holding deposit'),
    value: (0,utils/* formatMoney */.lb)(holdingDeposit.value.amount, holdingDeposit.value.currency_code)
  }) : null, PriceDetails_jsx(PriceLine/* default */.Z, {
    title: t('Total'),
    bigger: true,
    bold: true,
    value: (0,utils/* formatMoney */.lb)(onBooking.amount, onBooking.currency_code)
  }));
};

/* harmony default export */ var Desktop_PriceDetails = (PriceDetails);
// EXTERNAL MODULE: ../shared/src/constants/contractType.js
var constants_contractType = __webpack_require__(50957);
;// CONCATENATED MODULE: ./src/utils/pricing/index.js

var getPricing = function getPricing(_ref) {
  var _contract$contractTyp, _contract$contractTyp2, _priceDetailsData$ren;

  var accommodationOffer = _ref.accommodationOffer,
      priceDetailsRequest = _ref.priceDetailsRequest,
      priceDetailsData = _ref.priceDetailsData;
  var contract = accommodationOffer.contract,
      referencePrice = accommodationOffer.reference_price;
  var guests = priceDetailsRequest.guests;
  var isAnyTypeFixed = [constants_contractType/* CONTRACT_TYPE.FIXED */.G.FIXED, constants_contractType/* CONTRACT_TYPE.FIXED_UNITARY */.G.FIXED_UNITARY].includes(contract.type);
  var contractType = isAnyTypeFixed ? 'fixed_unitary' : 'standard';
  var extraPerGuest = (_contract$contractTyp = contract[contractType]) === null || _contract$contractTyp === void 0 ? void 0 : _contract$contractTyp.extra_per_guest;
  var extraAfter = (_contract$contractTyp2 = contract[contractType]) === null || _contract$contractTyp2 === void 0 ? void 0 : _contract$contractTyp2.extra_after;
  var isExtraPerGuestAppliable = extraPerGuest && extraPerGuest.amount > 0 && guests > extraAfter;
  var extraPriceAmount = isExtraPerGuestAppliable ? extraPerGuest.amount * (guests - extraAfter) : 0;

  var _ref2 = ((priceDetailsData === null || priceDetailsData === void 0 ? void 0 : (_priceDetailsData$ren = priceDetailsData.rents) === null || _priceDetailsData$ren === void 0 ? void 0 : _priceDetailsData$ren.items) || []).find(function (_ref3) {
    var value = _ref3.value;
    return !!(value !== null && value !== void 0 && value.amount);
  }) || {},
      firstRentValue = _ref2.value;

  return {
    isAnyTypeFixed: isAnyTypeFixed,
    extraPriceAmount: extraPriceAmount,
    firstRentValue: firstRentValue,
    referencePrice: referencePrice
  };
};
// EXTERNAL MODULE: ../shared/src/svg/piggy-bank-alt.js
var piggy_bank_alt = __webpack_require__(51151);
;// CONCATENATED MODULE: ../shared/src/components/Unisystem/Input/styles.js

var Input_styles_Wrapper = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-17764bp-0"
})(["display:flex;flex-direction:column;", ";width:100%;"], function (_ref) {
  var theme = _ref.theme;
  return theme.gap(3, 'column');
});
var styles_LabelsWrapper = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-17764bp-1"
})(["display:flex;align-items:center;", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.gap(3);
});
var styles_Label = /*#__PURE__*/styled_components_browser_esm/* default.label.withConfig */.ZP.label.withConfig({
  componentId: "sc-17764bp-2"
})(["display:block;font-size:", ";font-weight:400;line-height:", ";color:", ";"], function (props) {
  return props.theme.rem(props.isSmall ? 14 : 16);
}, function (props) {
  return props.theme.rem(props.isSmall ? 19 : 20);
}, function (props) {
  return props.theme.unisystem.input.label;
});
var HelperLabel = /*#__PURE__*/(0,styled_components_browser_esm/* default */.ZP)(styles_Label).withConfig({
  componentId: "sc-17764bp-3"
})(["color:", ";"], function (props) {
  return props.theme.unisystem.input.helperLabel;
});
var MaxLength = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-17764bp-4"
})(["display:flex;margin-top:-6px;justify-content:flex-end;width:100%;font-size:", ";font-weight:400;line-height:", ";color:", ";"], function (props) {
  return props.theme.rem(16);
}, function (props) {
  return props.theme.rem(20);
}, function (props) {
  return props.isOnLimit ? props.theme.unisystem.input.maxLength.textLimit : props.theme.unisystem.input.maxLength.text;
});
var InsideLabel = /*#__PURE__*/styled_components_browser_esm/* default.label.withConfig */.ZP.label.withConfig({
  componentId: "sc-17764bp-5"
})(["display:flex;align-items:center;font-size:", ";line-height:", ";color:", ";text-transform:uppercase;", ";& > svg{width:16px;height:16px;}"], function (props) {
  return props.theme.rem(12);
}, function (props) {
  return props.theme.rem(16);
}, function (props) {
  return props.theme.unisystem.input.insideLabel;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.gap(1);
});
var InputBox = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-17764bp-6"
})(["display:flex;flex-direction:column;justify-content:center;padding:9px;border:1px solid ", ";border-radius:8px;min-height:", ";", ";background:", ";span{display:flex;align-items:center;margin:0;height:100%;width:100%;textarea,input{flex:1;border:0;background:transparent;max-width:100%;height:100%;font-weight:500;font-size:", ";line-height:", ";resize:none;font-family:IntervalNextReg,sans-serif;color:", ";&::placeholder{color:", ";}&:focus{border-color:transparent;outline:none;}&::-webkit-outer-spin-button,&::-webkit-inner-spin-button{-webkit-appearance:none;margin:0;}&[type=number]{-moz-appearance:textfield;}}textarea{min-height:78px;}}&:hover{background:", ";}", " ", " ", " ", " ", ""], function (props) {
  return props.theme.unisystem.input.border;
}, function (props) {
  return props.isTextarea ? '98px' : props.isSmall ? '40px' : '48px';
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.gap(1);
}, function (props) {
  return props.isDisabled ? props.theme.unisystem.input.disabled.background : props.theme.unisystem.input.disabled.backgroundDefault;
}, function (props) {
  return props.theme.rem(props.isSmall ? 14 : 16);
}, function (props) {
  return props.theme.rem(props.isSmall ? 19 : 20);
}, function (props) {
  return props.theme.unisystem.input.text;
}, function (props) {
  return props.theme.unisystem.input.placeholder;
}, function (props) {
  return props.isDisabled ? props.theme.unisystem.input.disabled.background : props.theme.unisystem.input.focused.background;
}, function (props) {
  return props.isFilled && "\n      background: ".concat(props.theme.unisystem.input.filled.background, ";\n      color: ").concat(props.theme.unisystem.input.filled.text, ";\n    ");
}, function (props) {
  return props.isSucceeded && "\n      border: 2px solid ".concat(props.theme.unisystem.input.success.border, ";\n      padding: ").concat(props.theme.space(2), "\n    ");
}, function (props) {
  return props.isFocused && "\n      border: 2px solid ".concat(props.theme.unisystem.input.focused.border, ";\n      color: ").concat(props.theme.unisystem.input.focused.text, ";\n      background: ").concat(props.theme.unisystem.input.focused.background, ";\n    ");
}, function (props) {
  return props.isDisabled && "\n      color: ".concat(props.theme.unisystem.input.disabled.text, ";\n\n      textarea,\n      input {\n        color: ").concat(props.theme.unisystem.input.disabled.text, ";\n      }\n  ");
}, function (props) {
  return props.isErrored && "\n      border: 2px solid ".concat(props.theme.unisystem.input.error.border, ";\n      padding: ").concat(props.theme.space(2), "\n  ");
});
var Info = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-17764bp-7"
})(["display:flex;justify-content:flex-start;align-items:center;background:", ";border-radius:8px;height:", ";padding:0 ", ";", ";p{font-size:", ";line-height:", ";color:", ";}"], function (props) {
  return props.theme.unisystem.input.info.background;
}, function (props) {
  return props.isSmall ? '40px' : '48px';
}, function (props) {
  return props.theme.space(6);
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.gap(2.5);
}, function (props) {
  return props.theme.rem(props.isSmall ? 14 : 16);
}, function (props) {
  return props.theme.rem(props.isSmall ? 19 : 20);
}, function (props) {
  return props.theme.unisystem.input.info.text;
});
var Message = /*#__PURE__*/styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  componentId: "sc-17764bp-8"
})(["font-size:", ";line-height:", ";color:", ";", ""], function (props) {
  return props.theme.rem(props.isSmall ? 14 : 16);
}, function (props) {
  return props.theme.rem(props.isSmall ? 19 : 20);
}, function (props) {
  return props.theme.unisystem.input.message.text;
}, function (props) {
  return props.isErrored && "\n     color: ".concat(props.theme.unisystem.input.message.errorColor, ";\n    ");
});
var SystemMessage = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-17764bp-9"
})(["display:flex;align-items:center;", ";height:", ";padding-inline:23px;font-size:", ";line-height:", ";background-color:", ";color:", ";border-radius:8px;svg{g{stroke:", ";}}"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.gap(2.5);
}, function (props) {
  return props.isSmall ? '40px' : '48px';
}, function (props) {
  return props.theme.rem(props.isSmall ? 14 : 16);
}, function (props) {
  return props.theme.rem(props.isSmall ? 18 : 20);
}, function (props) {
  return props.theme.unisystem.input.errorSystem.background;
}, function (props) {
  return props.theme.unisystem.input.errorSystem.color;
}, function (props) {
  return props.theme.unisystem.input.errorSystem.iconColor;
});
;// CONCATENATED MODULE: ../shared/src/svg/input-info.js

var input_info_jsx = react.createElement;

var InputInfo = function InputInfo(props) {
  return input_info_jsx("svg", (0,esm_extends/* default */.Z)({
    width: 24,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), input_info_jsx("g", {
    clipPath: "url(#a)",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }, input_info_jsx("path", {
    d: "M23 12.31c.11 6.08-4.92 11.09-11 11.19-6.07.1-10.89-4.73-11-10.81C.9 6.62 5.93 1.6 12 1.5c6.07-.11 10.89 4.73 11 10.81ZM12 14V7",
    strokeLinecap: "round"
  }), input_info_jsx("path", {
    d: "M12.5 17.5c0 .28-.22.5-.5.5s-.5-.22-.5-.5.22-.5.5-.5.5.22.5.5Z",
    fill: "#fff"
  })), input_info_jsx("defs", null, input_info_jsx("clipPath", {
    id: "a"
  }, input_info_jsx("path", {
    fill: "#fff",
    transform: "translate(0 .5)",
    d: "M0 0h24v24H0z"
  }))));
};
/* harmony default export */ var input_info = (InputInfo);
// EXTERNAL MODULE: ../shared/src/svg/check.js
var check = __webpack_require__(18599);
;// CONCATENATED MODULE: ../shared/src/svg/times.js


var times_excluded = ["color"];
var times_jsx = react.createElement;

var Times = function Times(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#224251' : _ref$color,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, times_excluded);
  return times_jsx("svg", (0,esm_extends/* default */.Z)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    fill: "none"
  }, props), times_jsx("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M1 16 16 1M16 16 1 1"
  }));
};
/* harmony default export */ var times = (Times);
;// CONCATENATED MODULE: ../shared/src/svg/exclamation-lines.js


var exclamation_lines_excluded = ["fillColor", "pathFillColor"];
var exclamation_lines_jsx = react.createElement;

var ExclamationLines = function ExclamationLines(_ref) {
  var _ref$fillColor = _ref.fillColor,
    fillColor = _ref$fillColor === void 0 ? '#224251' : _ref$fillColor,
    _ref$pathFillColor = _ref.pathFillColor,
    pathFillColor = _ref$pathFillColor === void 0 ? '#fff' : _ref$pathFillColor,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, exclamation_lines_excluded);
  return exclamation_lines_jsx("svg", (0,esm_extends/* default */.Z)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), exclamation_lines_jsx("g", {
    stroke: fillColor,
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    clipPath: "url(#a)"
  }, exclamation_lines_jsx("path", {
    strokeLinecap: "round",
    d: "M23 11.81c.11 6.08-4.92 11.09-11 11.19-6.07.1-10.89-4.73-11-10.81C.9 6.12 5.93 1.1 12 1c6.07-.11 10.89 4.73 11 10.81ZM12 13.5v-7"
  }), exclamation_lines_jsx("path", {
    fill: "#224251",
    d: "M12.5 17c0 .28-.22.5-.5.5s-.5-.22-.5-.5.22-.5.5-.5.5.22.5.5Z"
  })), exclamation_lines_jsx("defs", null, exclamation_lines_jsx("clipPath", {
    id: "a"
  }, exclamation_lines_jsx("path", {
    fill: pathFillColor,
    d: "M0 0h24v24H0z"
  }))));
};
/* harmony default export */ var exclamation_lines = (ExclamationLines);
;// CONCATENATED MODULE: ../shared/src/components/Unisystem/Input/index.js


var Input_excluded = ["label", "insideLabel", "placeholder", "value", "onChange", "onClick", "onBlur", "info", "type", "min", "successMessage", "errorMessage", "errorAction", "systemErrorMessage", "isSmall", "isTextarea", "isDisabled", "autoFocus", "helperLabel"];
var Input_jsx = react.createElement;








var Input = function Input(_ref) {
  var label = _ref.label,
    insideLabel = _ref.insideLabel,
    placeholder = _ref.placeholder,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
    _ref$onBlur = _ref.onBlur,
    onBlur = _ref$onBlur === void 0 ? function () {} : _ref$onBlur,
    info = _ref.info,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'text' : _ref$type,
    _ref$min = _ref.min,
    min = _ref$min === void 0 ? 0 : _ref$min,
    successMessage = _ref.successMessage,
    errorMessage = _ref.errorMessage,
    _ref$errorAction = _ref.errorAction,
    errorAction = _ref$errorAction === void 0 ? function () {} : _ref$errorAction,
    systemErrorMessage = _ref.systemErrorMessage,
    isSmall = _ref.isSmall,
    isTextarea = _ref.isTextarea,
    _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
    _ref$autoFocus = _ref.autoFocus,
    autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus,
    helperLabel = _ref.helperLabel,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, Input_excluded);
  var _useTranslation = (0,esm/* useTranslation */.$G)(),
    t = _useTranslation.t;
  var inputRef = (0,react.useRef)(null);
  var _useState = (0,react.useState)(false),
    isFocused = _useState[0],
    setIsFocused = _useState[1];
  var _useState2 = (0,react.useState)(false),
    isFilled = _useState2[0],
    setIsFilled = _useState2[1];
  var handleInputFocus = function handleInputFocus() {
    return setIsFocused(true);
  };
  var handleInputBlur = function handleInputBlur(_ref2) {
    var _inputRef$current;
    var value = _ref2.target.value;
    onBlur(value);
    setIsFocused(false);
    setIsFilled(!!((_inputRef$current = inputRef.current) !== null && _inputRef$current !== void 0 && _inputRef$current.value));
  };
  var handleErrorClick = (0,react.useCallback)(function () {
    return errorAction(inputRef);
  }, [errorAction, inputRef]);
  var translatedPlaceholder = placeholder ? t(placeholder) : null;
  var isErrored = !!errorMessage;
  var classNames = [isFocused ? 'is-focused' : '', isFilled ? 'is-filled' : '', isDisabled ? 'is-disabled' : '', isErrored ? 'is-errored' : null];
  return Input_jsx(Input_styles_Wrapper, props, label ? Input_jsx(styles_LabelsWrapper, null, Input_jsx(styles_Label, {
    isSmall: isSmall
  }, label), helperLabel ? Input_jsx(HelperLabel, {
    isSmall: isSmall
  }, helperLabel) : null) : null, Input_jsx(InputBox, {
    isTextarea: isTextarea,
    isSmall: isSmall,
    isErrored: isErrored,
    isSucceeded: !!successMessage,
    isSystemError: !!systemErrorMessage,
    isFocused: isFocused,
    isFilled: isFilled,
    isDisabled: isDisabled,
    type: type,
    min: min,
    className: classNames.join(' ')
  }, insideLabel ? Input_jsx(InsideLabel, {
    isSmall: isSmall
  }, insideLabel) : null, Input_jsx("span", null, isTextarea ? Input_jsx("textarea", (0,esm_extends/* default */.Z)({
    placeholder: translatedPlaceholder,
    value: value,
    onFocus: handleInputFocus,
    onBlur: handleInputBlur,
    ref: inputRef,
    onChange: onChange,
    onClick: onClick,
    disabled: isDisabled,
    type: type,
    min: min,
    autoFocus: autoFocus
  }, props)) : Input_jsx("input", (0,esm_extends/* default */.Z)({
    placeholder: translatedPlaceholder,
    value: value,
    onFocus: handleInputFocus,
    onBlur: handleInputBlur,
    ref: inputRef,
    onChange: onChange,
    onClick: onClick,
    disabled: isDisabled,
    type: type,
    min: min,
    autoFocus: autoFocus
  }, props)), successMessage ? Input_jsx(check/* default */.Z, {
    color: theme/* theme.unisystem.input.success.icon */.rS.unisystem.input.success.icon
  }) : null, errorMessage ? Input_jsx(times, {
    color: theme/* theme.unisystem.input.error.icon */.rS.unisystem.input.error.icon,
    onClick: handleErrorClick
  }) : null)), props.maxLength ? Input_jsx(MaxLength, {
    isOnLimit: value.length === props.maxLength
  }, value.length, "/", props.maxLength) : null, info ? Input_jsx(Info, {
    isSmall: isSmall
  }, Input_jsx(input_info, null), " ", Input_jsx("p", null, info)) : null, successMessage ? Input_jsx(Message, {
    isSmall: isSmall
  }, successMessage) : null, errorMessage && typeof errorMessage === 'string' ? Input_jsx(Message, {
    isSmall: isSmall,
    isErrored: !!errorMessage
  }, errorMessage) : null, systemErrorMessage ? Input_jsx(SystemMessage, {
    isSmall: isSmall
  }, Input_jsx(exclamation_lines, null), systemErrorMessage) : null);
};
/* harmony default export */ var Unisystem_Input = (Input);
;// CONCATENATED MODULE: ../shared/src/components/Unisystem/Calendar/DatePicker/Pricing/styles.js

var WrapperDesktop = /*#__PURE__*/styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  componentId: "sc-1onq2xb-0"
})(["font-size:", ";font-weight:600;color:", ";span{font-size:", ";font-weight:500;color:", ";}"], function (props) {
  return props.theme.rem(32);
}, function (props) {
  return props.theme.colors.blueDianne;
}, function (props) {
  return props.theme.rem(16);
}, function (props) {
  return props.theme.colors.cornFlowerBlue;
});
var WrapperMobile = /*#__PURE__*/(0,styled_components_browser_esm/* default */.ZP)(WrapperDesktop).withConfig({
  componentId: "sc-1onq2xb-1"
})(["font-size:", ";"], function (props) {
  return props.theme.rem(22);
});
;// CONCATENATED MODULE: ../shared/src/components/Unisystem/Calendar/DatePicker/Pricing/index.js
var Pricing_jsx = react.createElement;





var Pricing = function Pricing(_ref) {
  var firstPayment = _ref.firstPayment,
    referencePrice = _ref.referencePrice;
  var _useTranslation = (0,esm/* useTranslation */.$G)(),
    t = _useTranslation.t;
  var _useContext = (0,react.useContext)(media/* MediaContext */.Y),
    is = _useContext.is;
  var _ref2 = firstPayment || {},
    firstPaymentAmount = _ref2.amount,
    firstPaymentCurrency = _ref2.currency_code;
  var _ref3 = referencePrice || {},
    referenceAmount = _ref3.amount,
    referenceCurrency = _ref3.currency_code;
  var formattedFirstPaymentPrice = firstPaymentAmount && firstPaymentCurrency ? (0,utils/* formatMoney */.lb)(firstPaymentAmount, firstPaymentCurrency) : null;
  var formattedReferencePrice = referenceAmount && referenceCurrency ? (0,utils/* formatMoney */.lb)(referenceAmount, referenceCurrency) : null;
  var Wrapper = (0,react.useMemo)(function () {
    return is.mobile ? WrapperMobile : WrapperDesktop;
  }, [is.mobile]);
  return Pricing_jsx(Wrapper, null, formattedFirstPaymentPrice || formattedReferencePrice, Pricing_jsx("span", null, " /".concat(t('month'))));
};
/* harmony default export */ var DatePicker_Pricing = (Pricing);
;// CONCATENATED MODULE: ../shared/src/components/Unisystem/Calendar/DatePicker/MaxStay/styles.js

var MaxStay_styles_templateObject;


var MaxStay_styles_Wrapper = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-91ahho-0"
})(["width:100%;display:flex;gap:", ";justify-content:flex-start;", ";"], function (props) {
  return props.theme.space(3);
}, theme/* mediaMin.smallBreakpoint */.A3.smallBreakpoint(MaxStay_styles_templateObject || (MaxStay_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n    justify-content: space-between;\n  "]))));
var MaxValues = /*#__PURE__*/styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  componentId: "sc-91ahho-1"
})(["display:flex;align-items:center;", ";font-size:", ";color:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.gap(1);
}, function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.unisystem.calendar.maxStay.color;
});
;// CONCATENATED MODULE: ../shared/src/svg/calendar-lock.js

var calendar_lock_jsx = react.createElement;

var CalendarLock = function CalendarLock(props) {
  return calendar_lock_jsx("svg", (0,esm_extends/* default */.Z)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), calendar_lock_jsx("g", {
    clipPath: "url(#a)"
  }, calendar_lock_jsx("g", {
    stroke: "#647A85",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    clipPath: "url(#b)"
  }, calendar_lock_jsx("path", {
    d: "M12.5 18.5h-11a1 1 0 0 1-1-1v-14a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v6M5.5.501v5M15.5.501v5M.5 7.501h20"
  }), calendar_lock_jsx("path", {
    d: "M15.5 15.501h7s1 0 1 1V22.5s0 1-1 1h-7s-1 0-1-1v-5.999s0-1 1-1Z"
  }), calendar_lock_jsx("path", {
    d: "M17.75 19.564a1.25 1.25 0 1 0 2.5 0 1.25 1.25 0 0 0-2.5 0ZM21.5 14a2.5 2.5 0 0 0-5 0v1.5h5V14Z"
  }))), calendar_lock_jsx("defs", null, calendar_lock_jsx("clipPath", {
    id: "a"
  }, calendar_lock_jsx("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })), calendar_lock_jsx("clipPath", {
    id: "b"
  }, calendar_lock_jsx("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};
/* harmony default export */ var calendar_lock = (CalendarLock);
;// CONCATENATED MODULE: ../shared/src/components/Unisystem/Calendar/DatePicker/MaxStay/index.js
var MaxStay_jsx = react.createElement;




var MaxStay = function MaxStay(_ref) {
  var max = _ref.max;
  var _useTranslation = (0,esm/* useTranslation */.$G)(),
    t = _useTranslation.t;
  return MaxStay_jsx(MaxStay_styles_Wrapper, null, max ? MaxStay_jsx(MaxValues, null, MaxStay_jsx(calendar_lock, null), MaxStay_jsx("span", null, t('Max stay')), " ", max ? "".concat(max, " ").concat(t('nights')) : t('No maximum stay')) : null);
};
/* harmony default export */ var DatePicker_MaxStay = (MaxStay);
// EXTERNAL MODULE: ../shared/src/components/Counter/index.js + 2 modules
var Counter = __webpack_require__(98600);
// EXTERNAL MODULE: ../shared/src/components/Counter/styles.js
var Counter_styles = __webpack_require__(59841);
;// CONCATENATED MODULE: ../shared/src/components/Unisystem/Calendar/TenantCounter/styles.js


var TenantCounter_styles_Wrapper = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-katbgw-0"
})(["display:flex;align-items:center;padding-bottom:", ";svg{margin-right:", ";g{path{stroke:", ";}}}", "{margin-left:", ";}"], function (props) {
  return props.theme.space(2);
}, function (props) {
  return props.theme.space(2);
}, function (props) {
  return props.theme.colors.blueDianne;
}, Counter_styles/* Wrapper */.i, function (props) {
  return props.theme.space(2);
});
// EXTERNAL MODULE: ../shared/src/hooks/tracking/services/amplitude/dataAmplitude.js
var dataAmplitude = __webpack_require__(79884);
// EXTERNAL MODULE: ../shared/src/hooks/tracking/events.js
var events = __webpack_require__(29915);
;// CONCATENATED MODULE: ../shared/src/components/Unisystem/Calendar/TenantCounter/index.js
var TenantCounter_jsx = react.createElement;







var TenantCounter = function TenantCounter(_ref) {
  var guests = _ref.guests,
    maxGuests = _ref.maxGuests,
    setGuests = _ref.setGuests;
  var _useTranslation = (0,esm/* useTranslation */.$G)(),
    t = _useTranslation.t;
  var handleUpdate = function handleUpdate(newValue) {
    (0,dataAmplitude/* trackAmplitude */.pt)(events/* default.extraGuestAdded */.Z.extraGuestAdded, {
      newValue: newValue
    });
    setGuests(newValue);
  };
  return TenantCounter_jsx(TenantCounter_styles_Wrapper, null, TenantCounter_jsx(persons, null), "".concat(guests, " ").concat(t(guests > 1 ? 'people' : 'person')), TenantCounter_jsx(Counter/* default */.Z, {
    min: 1,
    max: maxGuests,
    value: guests,
    onUpdate: handleUpdate
  }));
};
/* harmony default export */ var Calendar_TenantCounter = (TenantCounter);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/eachDayOfInterval/index.js
var eachDayOfInterval = __webpack_require__(575);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/startOfWeek/index.js
var startOfWeek = __webpack_require__(49122);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/addDays/index.js
var addDays = __webpack_require__(63761);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/isSameDay/index.js
var isSameDay = __webpack_require__(82276);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/isSunday/index.js
var isSunday = __webpack_require__(26187);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/isFirstDayOfMonth/index.js
var isFirstDayOfMonth = __webpack_require__(39983);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/isSaturday/index.js
var isSaturday = __webpack_require__(40868);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/isLastDayOfMonth/index.js
var isLastDayOfMonth = __webpack_require__(12582);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/isToday/index.js
var isToday = __webpack_require__(82236);
// EXTERNAL MODULE: ../shared/src/components/FilterCard/index.js
var components_FilterCard = __webpack_require__(33200);
;// CONCATENATED MODULE: ../shared/src/components/MoveInOutPicker/styles.js



var cellSpaces = 10;
var styles_Container = /*#__PURE__*/(/* unused pure expression or super */ null && (styled.div.withConfig({
  componentId: "sc-1u0huor-0"
})(["width:100%;position:relative;justify-content:flex-start;display:flex;flex:1;user-select:none;"])));
var InputContainer = /*#__PURE__*/(/* unused pure expression or super */ null && (styled.label.withConfig({
  componentId: "sc-1u0huor-1"
})(["", " flex:1;min-width:50px;cursor:pointer;&.disabled{background:transparent;opacity:0.5;pointer-events:none;}svg{width:20px;margin-right:", ";pointer-events:none;}&:first-of-type{margin-right:", ";}"], FilterCard, function (props) {
  return props.theme.space(2);
}, function (props) {
  return props.theme.space(2);
})));
var styles_Input = /*#__PURE__*/(/* unused pure expression or super */ null && (styled.input.withConfig({
  componentId: "sc-1u0huor-2"
})(["border:0;font-size:", ";font-family:IntervalNextReg,sans-serif;font-weight:100;line-height:normal;color:", ";background:transparent;border:0;min-width:50px;cursor:pointer;"], function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.dateRange.color;
})));
var DayPickerContainer = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1u0huor-3"
})(["", " box-shadow:", ";height:auto;flex-direction:column;width:100%;min-width:", ";justify-content:center;padding:", ";"], components_FilterCard/* default */.Z, function (props) {
  return props.theme.dateRange.pickerBoxShadow;
}, function (props) {
  return props.theme.space(cellSpaces + 2);
}, function (props) {
  return props.theme.space(6);
});
var MonthContainer = /*#__PURE__*/styled_components_browser_esm/* default.table.withConfig */.ZP.table.withConfig({
  componentId: "sc-1u0huor-4"
})(["background:white;width:100%;& > tbody{display:flex;flex-direction:column;justify-content:left;", ";}"], function (props) {
  return props.theme.gap(2);
});
var ClassNameStyles = /*#__PURE__*/(0,styled_components_browser_esm/* css */.iv)(["&.available-move-in{color:", ";border:1px solid ", ";border-radius:56px;}&.selected-between{background-color:", ";border:none;color:", ";&.first{border-top-left-radius:56px;border-bottom-left-radius:56px;}&.last{border-top-right-radius:56px;border-bottom-right-radius:56px;}}&.minimum-stay-last{&:not(.selected-between){z-index:0;border-top-right-radius:56px;border-bottom-right-radius:56px;position:relative;color:", ";&:before{content:'';position:absolute;background:", ";width:50%;left:0;height:100%;z-index:-2;}&:after{content:'';position:absolute;background:", ";border-radius:50%;top:0;width:40px;height:40px;z-index:-1;}}}&.hovered-day{&:not(.disabled){border-top-right-radius:56px;border-bottom-right-radius:56px;z-index:0;position:relative;color:", ";&:before{content:'';position:absolute;background:", ";width:50%;left:0;height:100%;z-index:-2;}&:after{content:'';position:absolute;background:", ";border-radius:50%;top:0;width:40px;height:40px;z-index:-1;}}}&.disabled{color:", ";position:relative;pointer-events:none;cursor:not-allowed;&.selected{color:", ";}&.minimum-stay{background-color:", ";border:none;color:", ";&.first{border-top-left-radius:56px;border-bottom-left-radius:56px;}&.last{border-top-right-radius:56px;border-bottom-right-radius:56px;}}&:not(.no-day):after{content:'';width:25px;height:1px;background:", ";position:absolute;top:50%;border-radius:56px;}&.minimum-stay,&.max-move-in{pointer-events:auto;}&.minimum-stay,&.selected{&:after{content:none;}}}&.selected{position:relative;z-index:0;color:", ";&:not(.disabled.first),&:not(.disabled.last){&:before{content:'';position:absolute;width:90%;height:100%;background-color:", ";z-index:-2;}&.selected-start:before{margin-left:5px;}&.selected-end:before{margin-right:5px;}}&.selected-end{&:before{border-top-right-radius:56px;border-bottom-right-radius:56px;}&:after{background:", ";}}&.selected-start{&:before{border-top-left-radius:56px;border-bottom-left-radius:56px;}&.selected-start-no-end{color:", ";background-color:", ";border-top-left-radius:56px;border-bottom-left-radius:56px;&:before{background-color:", ";border-top-right-radius:56px;border-bottom-right-radius:56px;margin-right:", ";width:40px;height:40px;border-radius:50%;margin-left:", ";}}}&:after{content:'';position:absolute;width:40px;height:40px;background-color:", ";border-radius:50%;z-index:-1;}&.only:before{border-radius:56px;}}&.first{&:before{border-top-left-radius:56px;border-bottom-left-radius:56px;}}&:last-of-type{", "{white-space:normal;left:-40px;&:after{left:83%;}}}&:first-of-type{", "{white-space:normal;left:55px;&:after{left:15%;}}}"], function (props) {
  return props.theme.unisystem.calendar.selected.background;
}, function (props) {
  return props.theme.unisystem.calendar.selected.background;
}, function (props) {
  return props.theme.unisystem.calendar.selectedBetweenBackground;
}, function (props) {
  return props.theme.unisystem.calendar.selected.between.color;
}, function (props) {
  return props.theme.unisystem.calendar.selected.color;
}, function (props) {
  return props.theme.unisystem.calendar.selectedBetweenBackground;
}, function (props) {
  return props.theme.unisystem.calendar.hoverBackground;
}, function (props) {
  return props.theme.unisystem.calendar.selected.color;
}, function (props) {
  return props.theme.unisystem.calendar.selectedBetweenBackground;
}, function (props) {
  return props.theme.unisystem.calendar.hoverBackground;
}, function (props) {
  return props.theme.unisystem.calendar.disabledDatesColor;
}, function (props) {
  return props.theme.unisystem.calendar.color;
}, function (props) {
  return props.theme.unisystem.calendar.selectedBetweenBackground;
}, function (props) {
  return props.theme.unisystem.calendar.selected.between.color;
}, function (props) {
  return props.theme.unisystem.calendar.disabledDatesColor;
}, function (props) {
  return props.theme.unisystem.calendar.selected.color;
}, function (props) {
  return props.theme.unisystem.calendar.selectedBetweenBackground;
}, function (props) {
  return props.theme.unisystem.calendar.selected.background;
}, function (props) {
  return props.theme.unisystem.calendar.selected.color;
}, function (props) {
  return props.theme.unisystem.calendar.selectedBetweenBackground;
}, function (props) {
  return props.theme.unisystem.calendar.selected.background;
}, function (props) {
  return props.theme.space(2);
}, function (props) {
  return props.theme.space(2);
}, function (props) {
  return props.theme.unisystem.calendar.selected.background;
}, Tooltip_styles/* TooltipContainer */.DY, Tooltip_styles/* TooltipContainer */.DY);
var DayContainer = /*#__PURE__*/styled_components_browser_esm/* default.th.withConfig */.ZP.th.withConfig({
  componentId: "sc-1u0huor-5"
})(["display:inline-flex;justify-content:center;align-items:center;cursor:pointer;font-size:", ";width:", ";height:40px;height:", ";font-family:IntervalNextReg,sans-serif;font-weight:100;line-height:normal;color:", ";", " ", "{min-width:100%;width:140px;white-space:normal;&:after{top:98%;}}"], function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.choosingStart ? '40px' : '100%';
}, function (props) {
  return props.theme.space(cellSpaces);
}, function (props) {
  return props.theme.unisystem.calendar.color;
}, ClassNameStyles, Tooltip_styles/* TooltipContainer */.DY);
var Arrow = /*#__PURE__*/(/* unused pure expression or super */ null && (styled.span.withConfig({
  componentId: "sc-1u0huor-6"
})(["display:flex;svg{width:13px;transform:rotateZ(0deg);transition:transform 0.25s ease-in-out;margin-right:auto;}&.down{svg{transform:rotateZ(180deg);}}"])));
var RowContainer = /*#__PURE__*/styled_components_browser_esm/* default.tr.withConfig */.ZP.tr.withConfig({
  componentId: "sc-1u0huor-7"
})(["display:inline-flex;align-content:center;justify-content:space-between;height:40px;"]);
var WeekContainer = /*#__PURE__*/styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  componentId: "sc-1u0huor-8"
})(["display:inline-flex;margin-bottom:", ";width:100%;justify-content:space-between;"], function (props) {
  return props.theme.space(2);
});
var WeekDayContainer = /*#__PURE__*/styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
  componentId: "sc-1u0huor-9"
})(["width:", "%;color:", ";font-size:", ";font-family:IntervalNextReg,sans-serif;font-weight:100;line-height:normal;text-align:center;text-transform:uppercase;"], 100 / 7, function (props) {
  return props.theme.dateRange.color;
}, function (props) {
  return props.theme.rem(12);
});
var MonthSelector = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1u0huor-10"
})(["display:flex;position:relative;", ";justify-content:space-between;align-items:center;width:100%;padding:0 ", ";margin-bottom:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.gap(3);
}, function (props) {
  return props.theme.space(2);
}, function (props) {
  return props.theme.space(4);
});
var MonthLabel = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1u0huor-11"
})(["font-size:", ";line-height:", ";font-family:IntervalNextReg,sans-serif;color:", ";text-align:center;width:100%;text-transform:uppercase;display:flex;flex-direction:column;", ";& > span{font-weight:600;text-transform:capitalize;color:", ";}"], function (props) {
  return props.theme.rem(16);
}, function (props) {
  return props.theme.rem(20);
}, function (props) {
  return props.theme.dateRange.color;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.gap(1);
}, function (props) {
  return props.theme.dateRange.monthColor;
});
var styles_MonthPrice = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1u0huor-12"
})(["font-size:", ";line-height:", ";font-family:IntervalNextReg,sans-serif;color:", ";text-align:center;width:100%;text-transform:lowercase;"], function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.rem(18);
}, function (props) {
  return props.theme.dateRange.color;
});
var MonthSelectorArrow = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1u0huor-13"
})(["color:", ";cursor:pointer;display:flex;border-radius:2px;border:", ";width:36px;height:36px;justify-content:center;align-items:center;&.disabled{opacity:0.5;pointer-events:none;}svg{width:8px;height:8px;display:block;}"], function (props) {
  return props.theme.dateRange.color;
}, function (props) {
  return "1px solid ".concat(props.theme.dateRange.arrowBordersColor);
});
var MonthSelectorLeftArrow = /*#__PURE__*/(0,styled_components_browser_esm/* default */.ZP)(MonthSelectorArrow).withConfig({
  componentId: "sc-1u0huor-14"
})(["transform:rotateZ(-90deg);left:10px;position:absolute;"]);
var MonthSelectorRightArrow = /*#__PURE__*/(0,styled_components_browser_esm/* default */.ZP)(MonthSelectorArrow).withConfig({
  componentId: "sc-1u0huor-15"
})(["transform:rotateZ(90deg);right:10px;position:absolute;"]);
var TableRangeMonths = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1u0huor-16"
})(["display:flex;flex-direction:row;justify-content:space-around;width:100%;", ""], function (_ref3) {
  var theme = _ref3.theme;
  return theme.gap(2);
});
var TableRangeMonth = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1u0huor-17"
})(["display:flex;flex-direction:column;margin:0 ", ";flex:1;table,ul{width:100%;}"], function (props) {
  return props.theme.space(1);
});
// EXTERNAL MODULE: ../shared/src/hooks/dateRange/index.js + 2 modules
var hooks_dateRange = __webpack_require__(6179);
;// CONCATENATED MODULE: ../shared/src/contexts/calendar/index.js
var calendar_jsx = react.createElement;

var CalendarContext = /*#__PURE__*/(0,react.createContext)({});
var CalendarProvider = function CalendarProvider(_ref) {
  var validateDates = _ref.validateDates,
    children = _ref.children;
  return calendar_jsx(CalendarContext.Provider, {
    value: {
      validateDates: validateDates
    }
  }, children);
};

;// CONCATENATED MODULE: ../shared/src/components/MoveInOutPicker/day.js

var day_jsx = react.createElement;








var Day = function Day(_ref) {
  var dayLabel = _ref.dayLabel,
    date = _ref.date,
    _ref$dateRange = _ref.dateRange,
    dateRange = _ref$dateRange === void 0 ? {} : _ref$dateRange,
    _ref$hoverHandlers = _ref.hoverHandlers,
    hoverHandlers = _ref$hoverHandlers === void 0 ? [null, function () {}] : _ref$hoverHandlers;
  var dayRef = (0,react.useRef)();
  var _useTranslation = (0,esm/* useTranslation */.$G)(),
    t = _useTranslation.t,
    language = _useTranslation.i18n.language;
  var _useContext = (0,react.useContext)(CalendarContext),
    validateDates = _useContext.validateDates;
  var _useState = (0,react.useState)(false),
    tooltipVisible = _useState[0],
    setTooltipVisible = _useState[1];
  var startDate = dateRange.startDate,
    endDate = dateRange.endDate,
    _dateRange$blockedDat = dateRange.blockedDates,
    blockedDates = _dateRange$blockedDat === void 0 ? [] : _dateRange$blockedDat,
    minBookingDays = dateRange.minBookingDays,
    maxMoveInDate = dateRange.maxMoveInDate,
    choosingStart = dateRange.choosingStart,
    choosingEnd = dateRange.choosingEnd;
  var _hoverHandlers = (0,slicedToArray/* default */.Z)(hoverHandlers, 2),
    hoveredDate = _hoverHandlers[0],
    setHoveredDate = _hoverHandlers[1];
  var _useDay = (0,hooks_dateRange/* useDay */.xp)(dayRef, date, dateRange),
    disabledDate = _useDay.disabledDate,
    onClick = _useDay.onClick;
  var finalDate = endDate || hoveredDate;
  var isBlocked = blockedDates.some(function (blockedDate) {
    return (0,isSameDay/* default */.Z)(date, blockedDate);
  });
  var isMaxMoveInExceeded = !startDate && maxMoveInDate && (0,isAfter/* default */.Z)((0,startOfDay/* default */.Z)(date), maxMoveInDate);
  var isMinimumStay = startDate && (0,isAfter/* default */.Z)(date, startDate) && (0,isBefore/* default */.Z)(date, (0,addDays/* default */.Z)(startDate, minBookingDays));
  var isMinimumStayLast = startDate && (0,isSameDay/* default */.Z)(date, (0,addDays/* default */.Z)(startDate, minBookingDays));
  var isBetween = startDate && finalDate && (0,isAfter/* default */.Z)(date, startDate) && (0,isBefore/* default */.Z)(date, finalDate);
  var isDisabled = disabledDate || isBlocked || !date;
  var dayClasses = {
    disabled: isDisabled,
    'available-move-in': !isDisabled && choosingStart && maxMoveInDate && !isMaxMoveInExceeded,
    'selected-start': date && startDate && (0,isSameDay/* default */.Z)(date, startDate),
    'selected-start-no-end': date && startDate && !endDate && (0,isSameDay/* default */.Z)(date, startDate),
    'selected-end': date && endDate && (0,isSameDay/* default */.Z)(date, endDate),
    selected: date && (startDate && (0,isSameDay/* default */.Z)(date, startDate) || endDate && (0,isSameDay/* default */.Z)(date, endDate)),
    'minimum-stay': isMinimumStay,
    'minimum-stay-last': isMinimumStayLast,
    'selected-between': isBetween,
    first: date && ((0,isSunday/* default */.Z)(date) || (0,isFirstDayOfMonth/* default */.Z)(date)),
    last: date && ((0,isSaturday/* default */.Z)(date) || (0,isLastDayOfMonth/* default */.Z)(date)),
    only: date && ((0,isFirstDayOfMonth/* default */.Z)(date) && (0,isSaturday/* default */.Z)(date) || (0,isLastDayOfMonth/* default */.Z)(date) && (0,isSunday/* default */.Z)(date)),
    today: date && (0,isToday/* default */.Z)(date),
    'no-day': !date,
    'hovered-day': date && startDate && !endDate && hoveredDate && (0,isSameDay/* default */.Z)(date, hoveredDate),
    'max-move-in': isMaxMoveInExceeded
  };
  var getTooltipContent = function getTooltipContent() {
    if (isMaxMoveInExceeded) {
      return t('Move-in must be before {{date}}', {
        date: (0,utils/* formatDate */.p6)(maxMoveInDate, language, 'MMM dd')
      });
    }
    if (isMinimumStay || isMinimumStayLast) {
      return t('Minimum of {{nights}} nights', {
        nights: minBookingDays
      });
    }
    return null;
  };
  var tooltipContent = getTooltipContent();
  var shouldShowTooltip = !!tooltipContent && tooltipVisible;
  var handleOnClick = (0,react.useCallback)(function (event) {
    onClick(event);
    if (choosingEnd && startDate && date && isMinimumStay) {
      validateDates((0,utils/* formatDate */.p6)(new Date(startDate)), (0,utils/* formatDate */.p6)(date));
    }
  }, [choosingEnd, startDate, date, isMinimumStay, onClick]);
  var handleMouseEnter = (0,react.useCallback)(function () {
    if (date) {
      setHoveredDate(date);
      setTooltipVisible(true);
    }
  }, [date, setHoveredDate]);
  var handleMouseLeave = (0,react.useCallback)(function () {
    setTooltipVisible(false);
  }, []);
  var className = Object.keys(dayClasses).filter(function (name) {
    return dayClasses[name];
  }).join(' ');
  return day_jsx(DayContainer, {
    ref: dayRef,
    tabIndex: dayClasses.disabled ? null : '-1',
    className: className,
    onClick: handleOnClick,
    onMouseLeave: handleMouseLeave,
    onMouseEnter: handleMouseEnter,
    choosingStart: choosingStart
  }, shouldShowTooltip ? day_jsx(Tooltip/* default */.Z, {
    bottom: false
  }, dayLabel, day_jsx("span", null, tooltipContent)) : dayLabel);
};
/* harmony default export */ var day = (Day);
// EXTERNAL MODULE: ../shared/src/constants/date-picker-supported-locales.js + 51 modules
var date_picker_supported_locales = __webpack_require__(22868);
;// CONCATENATED MODULE: ../shared/src/components/MoveInOutPicker/month.js

var month_jsx = react.createElement;







var month_Month = function Month(_ref) {
  var year = _ref.year,
    month = _ref.month,
    dateRange = _ref.dateRange,
    hoverHandlers = _ref.hoverHandlers;
  var firstDayOfWeek = dateRange.firstDayOfWeek;
  var _useMonth = (0,hooks_dateRange/* useMonth */.VR)({
      year: year,
      month: month,
      firstDayOfWeek: firstDayOfWeek
    }),
    days = _useMonth.days;
  var _useTranslation = (0,esm/* useTranslation */.$G)(),
    t = _useTranslation.t,
    language = _useTranslation.i18n.language;
  var _hoverHandlers = (0,slicedToArray/* default */.Z)(hoverHandlers, 2),
    setHoveredDate = _hoverHandlers[1];
  var currentLocale = date_picker_supported_locales/* DATE_PICKER_SUPPORTED_LOCALES */.n[language] || undefined;
  var weekdayLabels = (0,eachDayOfInterval/* default */.Z)({
    start: (0,startOfWeek/* default */.Z)(new Date(), {
      weekStartsOn: 0
    }),
    end: (0,addDays/* default */.Z)((0,startOfWeek/* default */.Z)(new Date(), {
      weekStartsOn: 0
    }), 6)
  }).map(function (day) {
    return t((0,format/* default */.Z)(day, 'EEE', {
      locale: currentLocale
    }));
  });
  return month_jsx(react.Fragment, null, month_jsx(WeekContainer, null, weekdayLabels.map(function (weekDay, i) {
    return month_jsx(WeekDayContainer, {
      key: i
    }, weekDay);
  })), month_jsx(MonthContainer, {
    role: "presentation",
    onMouseLeave: function onMouseLeave() {
      return setHoveredDate(null);
    }
  }, month_jsx("tbody", null, days.map(function (week, chunk) {
    return month_jsx(RowContainer, {
      key: chunk
    }, week.map(function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        date = _ref2.date,
        dayLabel = _ref2.dayLabel;
      var index = arguments.length > 1 ? arguments[1] : undefined;
      return date && dayLabel ? month_jsx(day, {
        date: date,
        dateRange: dateRange,
        key: date.toString(),
        dayLabel: dayLabel,
        hoverHandlers: hoverHandlers
      }) : month_jsx(day, {
        dateRange: dateRange,
        key: "".concat(chunk - index)
      });
    }));
  }))));
};
/* harmony default export */ var MoveInOutPicker_month = (month_Month);
;// CONCATENATED MODULE: ../shared/src/components/MoveInOutPicker/index.js
var MoveInOutPicker_jsx = react.createElement;








var MoveInOutPicker = function MoveInOutPicker(_ref) {
  var dateRange = _ref.dateRange,
    _ref$rents = _ref.rents,
    rents = _ref$rents === void 0 ? [] : _ref$rents;
  var _useTranslation = (0,esm/* useTranslation */.$G)(),
    t = _useTranslation.t,
    language = _useTranslation.i18n.language;
  var activeMonths = dateRange.activeMonths,
    isPresentActiveMonth = dateRange.isPresentActiveMonth,
    firstDayOfWeek = dateRange.firstDayOfWeek,
    goToPreviousMonths = dateRange.goToPreviousMonths,
    goToNextMonths = dateRange.goToNextMonths;
  var hoverHandlers = (0,react.useState)(null);
  var months = (0,hooks_dateRange/* useMonths */.rF)(activeMonths, firstDayOfWeek);
  return MoveInOutPicker_jsx(DayPickerContainer, null, MoveInOutPicker_jsx(MonthSelector, null, MoveInOutPicker_jsx(MonthSelectorLeftArrow, {
    onClick: goToPreviousMonths,
    className: isPresentActiveMonth && 'disabled'
  }, MoveInOutPicker_jsx(svg/* ArrowIcon */.e0, {
    color: theme/* theme.colors.blueDianne */.rS.colors.blueDianne
  })), months.map(function (_ref2) {
    var monthLabel = _ref2.monthLabel,
      year = _ref2.year;
    var monthNumber = (0,utils/* monthLabelToNumber */.UT)(monthLabel, language);
    var rent = rents[monthNumber];
    return MoveInOutPicker_jsx(MonthLabel, {
      key: "".concat(monthLabel, "-").concat(year)
    }, MoveInOutPicker_jsx("span", null, monthLabel, " ", MoveInOutPicker_jsx("span", null, year)), rent ? MoveInOutPicker_jsx(styles_MonthPrice, null, (0,utils/* formatMoney */.lb)(rent.amount, rent.currency_code), "/", t('month')) : null);
  }), MoveInOutPicker_jsx(MonthSelectorRightArrow, {
    onClick: goToNextMonths
  }, MoveInOutPicker_jsx(svg/* ArrowIcon */.e0, {
    color: theme/* theme.colors.blueDianne */.rS.colors.blueDianne
  }))), MoveInOutPicker_jsx(TableRangeMonths, null, activeMonths.map(function (month) {
    return MoveInOutPicker_jsx(TableRangeMonth, {
      key: "".concat(month.year, "-").concat(month.month)
    }, MoveInOutPicker_jsx(MoveInOutPicker_month, {
      year: month.year,
      month: month.month,
      dateRange: dateRange,
      hoverHandlers: hoverHandlers
    }));
  })));
};
/* harmony default export */ var components_MoveInOutPicker = (MoveInOutPicker);
;// CONCATENATED MODULE: ../shared/src/components/Unisystem/Calendar/DatePicker/Desktop/styles.js


var DatePicker_Desktop_styles_Wrapper = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-y2ndtq-0"
})(["display:flex;flex-direction:column;gap:", ";", "{box-shadow:none;padding:0;}", ",", "{width:30px;height:30px;border-radius:50%;background-color:", ";box-shadow:0px 3px 10px 0px rgba(34,66,81,0.1);svg{width:14px;height:14px;}}", ",", "{border:none;}"], function (props) {
  return props.theme.space(3);
}, DayPickerContainer, MonthSelectorLeftArrow, MonthSelectorRightArrow, function (props) {
  return props.theme.unisystem.calendar.arrowButtonsBackground;
}, MonthSelectorLeftArrow, MonthSelectorRightArrow);
var styles_Header = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-y2ndtq-1"
})(["width:100%;display:flex;justify-content:space-between;margin-bottom:", ";"], function (props) {
  return props.theme.space(2);
});
var HeaderLeft = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-y2ndtq-2"
})(["display:flex;flex-direction:column;gap:", ";"], function (props) {
  return props.theme.space(3);
});
var HeaderRight = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-y2ndtq-3"
})(["display:flex;flex-direction:column;align-items:flex-end;gap:", ";"], function (props) {
  return props.theme.space(3);
});
var DatesTitle = /*#__PURE__*/styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  componentId: "sc-y2ndtq-4"
})(["font-size:", ";line-height:", ";color:", ";display:flex;align-items:center;", ";height:26px;svg{width:24px;height:24px;}span{background-color:", ";font-size:", ";line-height:", ";color:", ";padding:", " ", ";border-radius:4px;}"], function (props) {
  return props.theme.rem(16);
}, function (props) {
  return props.theme.rem(20);
}, function (props) {
  return props.theme.unisystem.calendar.datesLabel.titleColor;
}, function (_ref) {
  var theme = _ref.theme;
  return theme.gap(2);
}, function (props) {
  return props.theme.unisystem.calendar.datesLabel.selectMoveInOut.background;
}, function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.rem(18);
}, function (props) {
  return props.theme.unisystem.calendar.datesLabel.selectMoveInOut.color;
}, function (props) {
  return props.theme.space(1);
}, function (props) {
  return props.theme.space(2);
});
;// CONCATENATED MODULE: ../shared/src/components/Unisystem/Calendar/DatePicker/Desktop/index.js
var DatePicker_Desktop_jsx = react.createElement;










var DatePickerDesktop = function DatePickerDesktop(_ref) {
  var guests = _ref.guests,
    maxGuests = _ref.maxGuests,
    setGuests = _ref.setGuests,
    moveIn = _ref.moveIn,
    moveOut = _ref.moveOut,
    dateRange = _ref.dateRange,
    firstPayment = _ref.firstPayment,
    referencePrice = _ref.referencePrice,
    maximumStay = _ref.maximumStay,
    _ref$rents = _ref.rents,
    rents = _ref$rents === void 0 ? [] : _ref$rents;
  var _useTranslation = (0,esm/* useTranslation */.$G)(),
    t = _useTranslation.t,
    language = _useTranslation.i18n.language;
  var moveInDate = moveIn ? (0,utils/* formatDate */.p6)(new Date(moveIn), language, 'dd MMM yyyy') : null;
  var moveOutDate = moveOut ? (0,utils/* formatDate */.p6)(new Date(moveOut), language, 'dd MMM yyyy') : null;
  return DatePicker_Desktop_jsx(DatePicker_Desktop_styles_Wrapper, null, DatePicker_Desktop_jsx(styles_Header, null, DatePicker_Desktop_jsx(HeaderLeft, null, DatePicker_Desktop_jsx(DatePicker_Pricing, {
    firstPayment: firstPayment,
    referencePrice: referencePrice
  }), DatePicker_Desktop_jsx(DatesTitle, null, !moveInDate && !moveOutDate ? DatePicker_Desktop_jsx("span", null, t('Select your move-in date')) : DatePicker_Desktop_jsx(react.Fragment, null, moveInDate || '', DatePicker_Desktop_jsx(arrow_next/* default */.Z, {
    color: theme/* theme.colors.cornFlowerBlue */.rS.colors.cornFlowerBlue
  }), moveOutDate !== null && moveOutDate !== void 0 ? moveOutDate : DatePicker_Desktop_jsx("span", null, t('Select your move-out date'))))), DatePicker_Desktop_jsx(HeaderRight, null, maxGuests > 1 ? DatePicker_Desktop_jsx(Calendar_TenantCounter, {
    guests: guests,
    maxGuests: maxGuests,
    setGuests: setGuests
  }) : null)), DatePicker_Desktop_jsx(components_MoveInOutPicker, {
    dateRange: dateRange,
    rents: rents
  }), maximumStay && DatePicker_Desktop_jsx(DatePicker_MaxStay, {
    max: maximumStay
  }));
};
/* harmony default export */ var DatePicker_Desktop = (DatePickerDesktop);
;// CONCATENATED MODULE: ../shared/src/components/MoveInOutPickerMobile/styles.js



var styles_cellSpaces = 10;
var MoveInOutPickerMobile_styles_Container = /*#__PURE__*/(/* unused pure expression or super */ null && (styled.div.withConfig({
  componentId: "sc-1dwv7ej-0"
})(["width:100%;position:relative;justify-content:flex-start;display:flex;flex:1;user-select:none;"])));
var styles_InputContainer = /*#__PURE__*/(/* unused pure expression or super */ null && (styled.label.withConfig({
  componentId: "sc-1dwv7ej-1"
})(["", " flex:1;min-width:50px;cursor:pointer;&.disabled{background:transparent;opacity:0.5;pointer-events:none;}svg{width:20px;margin-right:", ";pointer-events:none;}&:first-of-type{margin-right:", ";}"], FilterCard, function (props) {
  return props.theme.space(2);
}, function (props) {
  return props.theme.space(2);
})));
var MoveInOutPickerMobile_styles_Input = /*#__PURE__*/(/* unused pure expression or super */ null && (styled.input.withConfig({
  componentId: "sc-1dwv7ej-2"
})(["border:0;font-size:", ";font-family:IntervalNextReg,sans-serif;font-weight:100;line-height:normal;color:", ";background:transparent;border:0;min-width:50px;cursor:pointer;"], function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.dateRange.color;
})));
var styles_DayPickerContainer = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1dwv7ej-3"
})(["", " box-shadow:", ";height:auto;flex-direction:column;width:100%;min-width:", ";justify-content:center;padding:", ";"], components_FilterCard/* default */.Z, function (props) {
  return props.theme.dateRange.pickerBoxShadow;
}, function (props) {
  return props.theme.space(styles_cellSpaces + 2);
}, function (props) {
  return props.theme.space(6);
});
var styles_MonthContainer = /*#__PURE__*/styled_components_browser_esm/* default.table.withConfig */.ZP.table.withConfig({
  componentId: "sc-1dwv7ej-4"
})(["background:white;width:100%;& > tbody{display:flex;flex-direction:column;justify-content:left;", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.gap(1, 'column');
});
var styles_ClassNameStyles = /*#__PURE__*/(0,styled_components_browser_esm/* css */.iv)(["&.available-move-in{color:", ";border:1px solid ", ";border-radius:56px;}&.selected-between{background-color:", ";border:none;color:", ";&.first{border-top-left-radius:56px;border-bottom-left-radius:56px;}&.last{border-top-right-radius:56px;border-bottom-right-radius:56px;}}&.minimum-stay-last{&:not(.selected-between){z-index:0;position:relative;color:", ";&:before{content:'';position:absolute;background:", ";height:100%;z-index:-2;width:50%;left:0;}&:after{content:'';position:absolute;background:", ";border-radius:56px;width:40px;height:40px;z-index:-1;}}}&.disabled{color:", ";position:relative;pointer-events:none;cursor:not-allowed;&.minimum-stay{background-color:", ";border:none;&.first{border-top-left-radius:56px;border-bottom-left-radius:56px;}&.last{border-top-right-radius:56px;border-bottom-right-radius:56px;}}&:not(.no-day):after{content:'';width:25px;height:1px;background:", ";position:absolute;border-radius:56px;}&.minimum-stay,&.max-move-in{pointer-events:auto;}&.minimum-stay,&.selected{color:", ";&:after{content:none;}}}&.first{&:before{border-top-left-radius:56px;border-bottom-left-radius:56px;}}&:last-of-type{", "{white-space:normal;left:-40px;&:after{left:84%;}}}&:first-of-type{", "{white-space:normal;left:55px;&:after{left:16%;}}}"], function (props) {
  return props.theme.unisystem.calendar.selected.background;
}, function (props) {
  return props.theme.unisystem.calendar.selected.background;
}, function (props) {
  return props.theme.unisystem.calendar.selectedBetweenBackground;
}, function (props) {
  return props.theme.unisystem.calendar.selected.between.color;
}, function (props) {
  return props.theme.unisystem.calendar.selected.color;
}, function (props) {
  return props.theme.unisystem.calendar.selectedBetweenBackground;
}, function (props) {
  return props.theme.unisystem.calendar.hoverBackground;
}, function (props) {
  return props.theme.unisystem.calendar.disabledDatesColor;
}, function (props) {
  return props.theme.unisystem.calendar.selectedBetweenBackground;
}, function (props) {
  return props.theme.unisystem.calendar.disabledDatesColor;
}, function (props) {
  return props.theme.unisystem.calendar.selected.between.color;
}, Tooltip_styles/* TooltipContainer */.DY, Tooltip_styles/* TooltipContainer */.DY);
var styles_DayContainer = /*#__PURE__*/styled_components_browser_esm/* default.th.withConfig */.ZP.th.withConfig({
  componentId: "sc-1dwv7ej-5"
})(["display:inline-flex;justify-content:center;align-items:center;cursor:pointer;font-size:", ";width:", ";height:40px;height:", ";font-family:IntervalNextReg,sans-serif;font-weight:100;line-height:normal;color:", ";", " ", "{min-width:100%;white-space:nowrap;&:after{top:98%;}}", "{min-width:100%;width:140px;white-space:normal;&:after{top:98%;}}"], function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.choosingStart ? '40px' : '100%';
}, function (props) {
  return props.theme.space(styles_cellSpaces);
}, function (props) {
  return props.theme.unisystem.calendar.color;
}, styles_ClassNameStyles, Tooltip_styles/* TooltipContainer */.DY, Tooltip_styles/* TooltipContainer */.DY);
var styles_Arrow = /*#__PURE__*/(/* unused pure expression or super */ null && (styled.span.withConfig({
  componentId: "sc-1dwv7ej-6"
})(["display:flex;svg{width:13px;transform:rotateZ(0deg);transition:transform 0.25s ease-in-out;margin-right:auto;}&.down{svg{transform:rotateZ(180deg);}}"])));
var styles_RowContainer = /*#__PURE__*/styled_components_browser_esm/* default.tr.withConfig */.ZP.tr.withConfig({
  componentId: "sc-1dwv7ej-7"
})(["display:inline-flex;align-content:center;justify-content:space-between;height:40px;"]);
var styles_WeekContainer = /*#__PURE__*/styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  componentId: "sc-1dwv7ej-8"
})(["display:inline-flex;margin-top:", ";margin-bottom:", ";width:100%;min-height:min-content;justify-content:space-between;"], function (props) {
  return props.theme.space(8);
}, function (props) {
  return props.theme.space(2);
});
var styles_WeekDayContainer = /*#__PURE__*/styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
  componentId: "sc-1dwv7ej-9"
})(["width:", "%;color:", ";font-size:", ";font-family:IntervalNextReg,sans-serif;font-weight:100;line-height:", ";text-align:center;text-transform:uppercase;"], 100 / 7, function (props) {
  return props.theme.dateRange.color;
}, function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.rem(18);
});
var styles_MonthSelector = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1dwv7ej-10"
})(["display:flex;flex-direction:column;", ";justify-content:center;align-items:center;width:100%;padding:0 ", ";margin-bottom:0;min-height:min-content;"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.gap(1, 'column');
}, function (props) {
  return props.theme.space(3);
});
var styles_MonthLabel = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1dwv7ej-11"
})(["font-size:", ";line-height:", ";font-family:IntervalNextReg,sans-serif;color:", ";text-align:center;width:100%;text-transform:capitalize;"], function (props) {
  return props.theme.rem(16);
}, function (props) {
  return props.theme.rem(20);
}, function (props) {
  return props.theme.unisystem.calendar.color;
});
var MoveInOutPickerMobile_styles_MonthPrice = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1dwv7ej-12"
})(["font-size:", ";line-height:", ";font-family:IntervalNextReg,sans-serif;color:", ";text-align:center;width:100%;"], function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.rem(18);
}, function (props) {
  return props.theme.dateRange.color;
});
var styles_MonthSelectorArrow = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1dwv7ej-13"
})(["color:", ";cursor:pointer;display:flex;border-radius:2px;border:", ";width:40px;height:40px;justify-content:center;align-items:center;&.disabled{opacity:0.5;pointer-events:none;}svg{width:13px;height:13px;display:block;}"], function (props) {
  return props.theme.dateRange.color;
}, function (props) {
  return "1px solid ".concat(props.theme.dateRange.arrowBordersColor);
});
var styles_MonthSelectorLeftArrow = /*#__PURE__*/(0,styled_components_browser_esm/* default */.ZP)(styles_MonthSelectorArrow).withConfig({
  componentId: "sc-1dwv7ej-14"
})(["transform:rotateZ(-90deg);"]);
var styles_MonthSelectorRightArrow = /*#__PURE__*/(0,styled_components_browser_esm/* default */.ZP)(styles_MonthSelectorArrow).withConfig({
  componentId: "sc-1dwv7ej-15"
})(["transform:rotateZ(90deg);"]);
var SelectedClassNameStyles = /*#__PURE__*/(0,styled_components_browser_esm/* css */.iv)([".selected{background:transparent;position:relative;color:", ";z-index:0;&.selected-start{color:", ";&:before{left:auto;right:0;}&:after{content:'';border-top-right-radius:56px;border-bottom-right-radius:56px;background-color:", ";height:40px;width:40px;}}&.selected-end{&:after{background:", ";}}&:before{content:'';position:absolute;left:0;width:50%;height:40px;right:0;background-color:", ";z-index:-2;}&:after{content:'';position:absolute;width:40px;height:40px;background-color:", ";border-radius:56px;z-index:-1;}}"], function (props) {
  return props.theme.unisystem.calendar.selected.color;
}, function (props) {
  return props.theme.unisystem.calendar.selected.color;
}, function (props) {
  return props.theme.unisystem.calendar.selected.background;
}, function (props) {
  return props.theme.unisystem.calendar.selected.background;
}, function (props) {
  return props.theme.unisystem.calendar.selectedBetweenBackground;
}, function (props) {
  return props.theme.unisystem.calendar.selected.background;
});
var styles_TableRangeMonths = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1dwv7ej-16"
})(["display:flex;flex-direction:column;width:100%;", ";min-height:100%;overflow-y:scroll;overflow-x:hidden;padding-bottom:", ";button{flex-shrink:0;align-self:center;width:95%;&:first-of-type{margin-top:", ";margin-right:", ";margin-left:", ";}&:last-of-type{margin-bottom:", ";}}", " tbody{row-gap:", ";}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.gap(3, 'column');
}, function (props) {
  return props.theme.space(12);
}, function (props) {
  return props.theme.space(3);
}, function (props) {
  return props.theme.space(2);
}, function (props) {
  return props.theme.space(2);
}, function (props) {
  return props.theme.space(16);
}, SelectedClassNameStyles, function (props) {
  return props.theme.space(2);
});
var styles_TableRangeMonth = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1dwv7ej-17"
})(["display:flex;flex-direction:column;margin:0;flex:1;min-height:min-content;table,ul{width:100%;}"]);
;// CONCATENATED MODULE: ../shared/src/components/Unisystem/Calendar/DatePicker/Mobile/styles.js

var Mobile_styles_templateObject, Mobile_styles_templateObject2;





var DatePicker_Mobile_styles_Wrapper = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1bcq339-0"
})(["display:flex;flex-direction:column;min-height:min-content;", "{box-shadow:none;padding:0;height:calc(100vh - 200px);padding-bottom:73px;", "}", ",", "{width:30px;height:30px;border-radius:50%;background-color:", ";svg{width:30px;height:10px;}}", "{", ";}", ",", "{border:none;}"], styles_DayPickerContainer, (0,theme/* mediaLandscape */.EK)(Mobile_styles_templateObject || (Mobile_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n      padding-bottom: 0;\n    "]))), styles_MonthSelectorLeftArrow, styles_MonthSelectorRightArrow, function (props) {
  return props.theme.unisystem.calendar.arrowButtonsBackground;
}, styles_TableRangeMonths, function (_ref) {
  var theme = _ref.theme;
  return theme.gap(5);
}, styles_MonthSelectorLeftArrow, styles_MonthSelectorRightArrow);
var Mobile_styles_Header = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1bcq339-1"
})(["width:100%;display:flex;flex-direction:column;justify-content:space-between;", ";", "{justify-content:flex-end;font-size:", ";line-height:", ";white-space:nowrap;& > div{font-weight:600;}}", ""], function (_ref2) {
  var theme = _ref2.theme;
  return theme.gap(4, 'column');
}, TenantCounter_styles_Wrapper, function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.rem(18);
}, (0,theme/* mediaLandscape */.EK)(Mobile_styles_templateObject2 || (Mobile_styles_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    flex-direction: row;\n    ", ";\n\n    ", " {\n      margin-left: ", ";\n    }\n  "])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.gap(0);
}, MaxStay_styles_Wrapper, function (props) {
  return props.theme.space(4);
}));
var styles_DatesTitle = /*#__PURE__*/styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  componentId: "sc-1bcq339-2"
})(["font-size:", ";line-height:", ";color:", ";margin-top:", ";display:flex;align-items:center;height:26px;svg{margin:0 ", ";width:24px;height:24px;}span{background-color:", ";font-size:", ";line-height:", ";color:", ";padding:", " ", ";}"], function (props) {
  return props.theme.rem(16);
}, function (props) {
  return props.theme.rem(20);
}, function (props) {
  return props.theme.unisystem.calendar.datesLabel.titleColor;
}, function (props) {
  return props.theme.space(2);
}, function (props) {
  return props.theme.space(2);
}, function (props) {
  return props.theme.unisystem.calendar.datesLabel.selectMoveInOut.background;
}, function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.rem(18);
}, function (props) {
  return props.theme.unisystem.calendar.datesLabel.selectMoveInOut.color;
}, function (props) {
  return props.theme.space(1);
}, function (props) {
  return props.theme.space(2);
});
;// CONCATENATED MODULE: ../shared/src/components/MoveInOutPickerMobile/day.js
var MoveInOutPickerMobile_day_jsx = react.createElement;








var day_Day = function Day(_ref) {
  var dayLabel = _ref.dayLabel,
    date = _ref.date,
    _ref$dateRange = _ref.dateRange,
    dateRange = _ref$dateRange === void 0 ? {} : _ref$dateRange;
  var dayRef = (0,react.useRef)();
  var _useTranslation = (0,esm/* useTranslation */.$G)(),
    t = _useTranslation.t,
    language = _useTranslation.i18n.language;
  var _useContext = (0,react.useContext)(CalendarContext),
    validateDates = _useContext.validateDates;
  var _useState = (0,react.useState)(false),
    showTooltip = _useState[0],
    setShowTooltip = _useState[1];
  var startDate = dateRange.startDate,
    endDate = dateRange.endDate,
    _dateRange$blockedDat = dateRange.blockedDates,
    blockedDates = _dateRange$blockedDat === void 0 ? [] : _dateRange$blockedDat,
    minBookingDays = dateRange.minBookingDays,
    maxMoveInDate = dateRange.maxMoveInDate,
    choosingStart = dateRange.choosingStart,
    choosingEnd = dateRange.choosingEnd;
  var _useDay = (0,hooks_dateRange/* useDay */.xp)(dayRef, date, dateRange),
    disabledDate = _useDay.disabledDate,
    onClick = _useDay.onClick;
  var isBetween = (0,isAfter/* default */.Z)(date, startDate) && (0,isBefore/* default */.Z)(date, endDate);
  var isFirstOfMonth = (0,isFirstDayOfMonth/* default */.Z)(date);
  var isLastOfMonth = (0,isLastDayOfMonth/* default */.Z)(date);
  var isSundayDay = (0,isSunday/* default */.Z)(date);
  var isSaturdayDay = (0,isSaturday/* default */.Z)(date);
  var isBlocked = !!blockedDates.find(function (blockedDate) {
    return (0,isSameDay/* default */.Z)(date, blockedDate);
  });
  var isMinimumStay = startDate && (0,isAfter/* default */.Z)(date, startDate) && (0,isBefore/* default */.Z)(date, (0,addDays/* default */.Z)(startDate, minBookingDays));
  var isMinimumStayLast = startDate && (0,isSameDay/* default */.Z)(date, (0,addDays/* default */.Z)(startDate, minBookingDays));
  var isMaxMoveInExceeded = !startDate && maxMoveInDate && (0,isAfter/* default */.Z)(date, maxMoveInDate);
  var isDisabled = disabledDate || isBlocked || !date;
  var dayClasses = {
    disabled: isDisabled,
    'available-move-in': !isDisabled && choosingStart && maxMoveInDate && !isMaxMoveInExceeded,
    'selected-start': (0,isSameDay/* default */.Z)(date, startDate),
    'selected-end': (0,isSameDay/* default */.Z)(date, endDate),
    selected: (0,isSameDay/* default */.Z)(date, startDate) || (0,isSameDay/* default */.Z)(date, endDate),
    'minimum-stay': (0,isAfter/* default */.Z)(date, startDate) && (0,isBefore/* default */.Z)(date, (0,addDays/* default */.Z)(startDate, minBookingDays)),
    'minimum-stay-last': (0,isSameDay/* default */.Z)(date, (0,addDays/* default */.Z)(startDate, minBookingDays)),
    'selected-between': isBetween,
    first: isSundayDay || isFirstOfMonth,
    last: isSaturdayDay || isLastOfMonth,
    only: isFirstOfMonth && isSaturdayDay || isLastOfMonth && isSundayDay,
    today: date && (0,isToday/* default */.Z)(date),
    'no-day': !date,
    'max-move-in': isMaxMoveInExceeded
  };
  var handleOnClick = (0,react.useCallback)(function (event) {
    onClick(event);
    if (choosingEnd && startDate && date && isMinimumStay) {
      validateDates((0,utils/* formatDate */.p6)(new Date(startDate)), (0,utils/* formatDate */.p6)(date));
    }
  }, [choosingEnd, startDate, date, isMinimumStay, onClick, validateDates]);
  var handleTouchStart = (0,react.useCallback)(function () {
    if (dayClasses['max-move-in'] || dayClasses['minimum-stay'] || dayClasses['minimum-stay-last']) {
      setShowTooltip(true);
    }
  }, [dayClasses, setShowTooltip]);
  var getTooltipContent = function getTooltipContent() {
    if (isMaxMoveInExceeded) {
      return t('Move-in must be before {{date}}', {
        date: (0,utils/* formatDate */.p6)(maxMoveInDate, language, 'MMM dd')
      });
    }
    if (isMinimumStay || isMinimumStayLast) {
      return t('Minimum of {{nights}} nights', {
        nights: minBookingDays
      });
    }
    return null;
  };
  var className = Object.keys(dayClasses).filter(function (name) {
    return dayClasses[name];
  }).join(' ');
  var tooltipContent = getTooltipContent();
  var shouldShowTooltip = !!tooltipContent && showTooltip;
  return MoveInOutPickerMobile_day_jsx(styles_DayContainer, {
    ref: dayRef,
    tabIndex: dayClasses.disabled ? null : '-1',
    className: className,
    onClick: handleOnClick,
    onTouchStart: handleTouchStart,
    choosingStart: choosingStart
  }, shouldShowTooltip ? MoveInOutPickerMobile_day_jsx(Tooltip/* default */.Z, {
    bottom: false
  }, dayLabel, MoveInOutPickerMobile_day_jsx("span", null, tooltipContent)) : dayLabel);
};
/* harmony default export */ var MoveInOutPickerMobile_day = (day_Day);
;// CONCATENATED MODULE: ../shared/src/components/MoveInOutPickerMobile/month.js
var MoveInOutPickerMobile_month_jsx = react.createElement;




var MoveInOutPickerMobile_month_Month = function Month(_ref) {
  var year = _ref.year,
    month = _ref.month,
    dateRange = _ref.dateRange;
  var firstDayOfWeek = dateRange.firstDayOfWeek;
  var _useMonth = (0,hooks_dateRange/* useMonth */.VR)({
      year: year,
      month: month,
      firstDayOfWeek: firstDayOfWeek
    }),
    days = _useMonth.days;
  return MoveInOutPickerMobile_month_jsx(styles_MonthContainer, {
    role: "presentation"
  }, MoveInOutPickerMobile_month_jsx("tbody", null, days.map(function (week, chunk) {
    return MoveInOutPickerMobile_month_jsx(styles_RowContainer, {
      key: chunk
    }, week.map(function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        date = _ref2.date,
        dayLabel = _ref2.dayLabel;
      var index = arguments.length > 1 ? arguments[1] : undefined;
      return date && dayLabel ? MoveInOutPickerMobile_month_jsx(MoveInOutPickerMobile_day, {
        date: date,
        dateRange: dateRange,
        key: date.toString(),
        dayLabel: dayLabel
      }) : MoveInOutPickerMobile_month_jsx(MoveInOutPickerMobile_day, {
        dateRange: dateRange,
        key: "".concat(chunk - index)
      });
    }));
  })));
};
/* harmony default export */ var MoveInOutPickerMobile_month = (MoveInOutPickerMobile_month_Month);
;// CONCATENATED MODULE: ../shared/src/components/Search/Button/styles.js

var Button_styles_templateObject, Button_styles_templateObject2, Button_styles_templateObject3;


var Button_styles_Wrapper = /*#__PURE__*/styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  componentId: "sc-bxpt8w-0"
})(["display:flex;justify-content:center;align-items:center;padding:0 ", ";width:auto;min-width:50px;height:", ";overflow:visible;font-family:IntervalNextReg,sans-serif;font-weight:100;line-height:normal;font-size:", ";font-weight:600;line-height:normal;border:none;border-radius:8px;-webkit-font-smoothing:inherit;-moz-osx-font-smoothing:inherit;-webkit-appearance:none;white-space:nowrap;cursor:pointer;&:disabled{opacity:0.5;}&::-moz-focus-inner{border:0;padding:0;}& > svg:first-child{margin-right:", ";", "}& > svg:last-child{margin-left:", ";", "}", " ", " ", " ", " ", " ", ""], function (props) {
  return props.theme.space(3);
}, function (props) {
  return props.isSmall ? '32px' : '40px';
}, function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.space(3);
}, function (props) {
  return !props.isMobile && theme/* mediaMin.largeBreakpoint */.A3.largeBreakpoint(Button_styles_templateObject || (Button_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n      margin-right: 0;\n    "])));
}, function (props) {
  return props.theme.space(3);
}, theme/* mediaMin.largeBreakpoint */.A3.largeBreakpoint(Button_styles_templateObject2 || (Button_styles_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n      margin-right: 0;\n    "]))), function (props) {
  return !props.isMobile && theme/* mediaMin.largeBreakpoint */.A3.largeBreakpoint(Button_styles_templateObject3 || (Button_styles_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n    & > span {\n      display: none;\n    }\n  "])));
}, function (props) {
  return props.isPrimary && "\n    background-color: ".concat(props.theme.buttons.primary.background, ";\n    color: ").concat(props.theme.buttons.primary.color, ";\n\n    &:hover {\n      background-color: ").concat(props.theme.buttons.primary.hover, ";\n    }\n  ");
}, function (props) {
  return props.isSecondary && "\n    background: ".concat(props.theme.buttons.secondary.background, ";\n    border: 1px solid ").concat(props.theme.buttons.secondary.border, ";\n    color: ").concat(props.theme.buttons.secondary.color, ";\n\n    &:hover {\n      background-color: ").concat(props.theme.buttons.secondary.hover, ";\n    }\n  ");
}, function (props) {
  return props.isTertiary && "\n    background: ".concat(props.theme.buttons.tertiary.background, ";\n    box-shadow: 0 0 0 1px ").concat(props.theme.buttons.tertiary.border, ";\n    color: ").concat(props.theme.buttons.tertiary.color, ";\n\n    &:hover {\n      background-color: ").concat(props.theme.buttons.tertiary.hover, ";\n    }\n\n    ").concat(props.isMobile && "\n      flex-grow: 1;\n    ", "\n\n    ").concat(props.isSelected && "\n      display: flex;\n      background: ".concat(props.theme.buttons.tertiary.backgroundSelected, ";\n      box-shadow: 0px 0px 0px 1.5px ").concat(props.theme.buttons.tertiary.selected, ";\n      color: ").concat(props.theme.buttons.tertiary.selectedColor, ";\n\n      &:hover {\n        background-color: ").concat(props.theme.buttons.tertiary.backgroundSelected, ";\n        box-shadow: 0px 0px 0px 2px ").concat(props.theme.buttons.tertiary.selected, ";\n      }\n    "), "\n  ");
}, function (props) {
  return props.isDanger && "\n    background: ".concat(props.theme.buttons.danger.background, ";\n    color: ").concat(props.theme.buttons.danger.color, ";\n\n    &:hover {\n      background-color: ").concat(props.theme.buttons.danger.hover, ";\n    }\n  ");
}, function (props) {
  return props.isGhost && "\n    background: ".concat(props.theme.buttons.ghost.background, ";\n    color: ").concat(props.theme.buttons.ghost.color, ";\n\n    &:hover {\n      background-color: ").concat(props.theme.buttons.ghost.hover, ";\n    }\n  ");
});
;// CONCATENATED MODULE: ../shared/src/components/Search/Button/index.js
var Button_jsx = react.createElement;



var Button_Button = function Button(_ref) {
  var children = _ref.children,
    onClick = _ref.onClick,
    isPrimary = _ref.isPrimary,
    isSecondary = _ref.isSecondary,
    isTertiary = _ref.isTertiary,
    isDanger = _ref.isDanger,
    isGhost = _ref.isGhost,
    isSelected = _ref.isSelected,
    isSmall = _ref.isSmall;
  var _useContext = (0,react.useContext)(media/* MediaContext */.Y),
    is = _useContext.is;
  return Button_jsx(Button_styles_Wrapper, {
    onClick: onClick,
    isPrimary: isPrimary,
    isSecondary: isSecondary,
    isTertiary: isTertiary,
    isDanger: isDanger,
    isGhost: isGhost,
    isSelected: isSelected,
    isSmall: isSmall,
    isMobile: is === null || is === void 0 ? void 0 : is.mobile
  }, children);
};
/* harmony default export */ var Search_Button = (Button_Button);
;// CONCATENATED MODULE: ../shared/src/components/MoveInOutPickerMobile/index.js
var MoveInOutPickerMobile_jsx = react.createElement;









var MoveInOutPickerMobile = function MoveInOutPickerMobile(_ref) {
  var dateRange = _ref.dateRange,
    _ref$classNames = _ref.classNames,
    classNames = _ref$classNames === void 0 ? {} : _ref$classNames,
    _ref$rents = _ref.rents,
    rents = _ref$rents === void 0 ? [] : _ref$rents;
  var _useTranslation = (0,esm/* useTranslation */.$G)(),
    t = _useTranslation.t,
    language = _useTranslation.i18n.language;
  var activeMonths = dateRange.activeMonths,
    firstDayOfWeek = dateRange.firstDayOfWeek,
    goToPreviousMonthsByOneMonth = dateRange.goToPreviousMonthsByOneMonth;
  var _useState = (0,react.useState)(4),
    visibleMonths = _useState[0],
    setVisibleMonths = _useState[1];
  var currentLocale = date_picker_supported_locales/* DATE_PICKER_SUPPORTED_LOCALES */.n[language] || undefined;
  var months = (0,hooks_dateRange/* useMonths */.rF)(activeMonths, firstDayOfWeek);
  var weekdayLabels = (0,eachDayOfInterval/* default */.Z)({
    start: (0,startOfWeek/* default */.Z)(new Date(), {
      weekStartsOn: 0
    }),
    end: (0,addDays/* default */.Z)((0,startOfWeek/* default */.Z)(new Date(), {
      weekStartsOn: 0
    }), 6)
  }).map(function (day) {
    return t((0,format/* default */.Z)(day, 'EEE', {
      locale: currentLocale
    }));
  });
  var showMoreMonths = function showMoreMonths() {
    return setVisibleMonths(function (prevVisible) {
      return Math.min(prevVisible + 4, activeMonths.length);
    });
  };
  var className = Object.keys(classNames).filter(function (name) {
    return classNames[name];
  }).join(' ');
  return MoveInOutPickerMobile_jsx(styles_DayPickerContainer, {
    className: className
  }, MoveInOutPickerMobile_jsx(styles_WeekContainer, null, weekdayLabels.map(function (weekDay, i) {
    return MoveInOutPickerMobile_jsx(styles_WeekDayContainer, {
      key: i
    }, weekDay);
  })), MoveInOutPickerMobile_jsx(styles_TableRangeMonths, null, MoveInOutPickerMobile_jsx(Search_Button, {
    isTertiary: true,
    onClick: goToPreviousMonthsByOneMonth
  }, t('Show previous dates')), activeMonths.slice(0, visibleMonths).map(function (month, index) {
    var monthLabel = months[index].monthLabel;
    var monthNumber = (0,utils/* monthLabelToNumber */.UT)(monthLabel, language);
    var rent = rents[monthNumber];
    return MoveInOutPickerMobile_jsx(react.Fragment, {
      key: "".concat(month.year, "-").concat(month.month)
    }, MoveInOutPickerMobile_jsx(styles_MonthSelector, null, MoveInOutPickerMobile_jsx(styles_MonthLabel, null, "".concat(monthLabel, " "), MoveInOutPickerMobile_jsx("span", null, months[index].year)), rent ? MoveInOutPickerMobile_jsx(MoveInOutPickerMobile_styles_MonthPrice, null, (0,utils/* formatMoney */.lb)(rent.amount, rent.currency_code), "/", t('month')) : null), MoveInOutPickerMobile_jsx(styles_TableRangeMonth, null, MoveInOutPickerMobile_jsx(MoveInOutPickerMobile_month, {
      year: month.year,
      month: month.month,
      dateRange: dateRange
    })));
  }), visibleMonths < activeMonths.length && MoveInOutPickerMobile_jsx(Search_Button, {
    isTertiary: true,
    onClick: showMoreMonths
  }, t('Show more dates'))));
};
/* harmony default export */ var components_MoveInOutPickerMobile = (MoveInOutPickerMobile);
;// CONCATENATED MODULE: ../shared/src/components/Unisystem/Calendar/DatePicker/Mobile/index.js
var DatePicker_Mobile_jsx = react.createElement;









var DatePickerMobile = function DatePickerMobile(_ref) {
  var moveIn = _ref.moveIn,
    moveOut = _ref.moveOut,
    dateRange = _ref.dateRange,
    firstPayment = _ref.firstPayment,
    referencePrice = _ref.referencePrice,
    guests = _ref.guests,
    maxGuests = _ref.maxGuests,
    setGuests = _ref.setGuests,
    _ref$classNames = _ref.classNames,
    classNames = _ref$classNames === void 0 ? {} : _ref$classNames,
    _ref$rents = _ref.rents,
    rents = _ref$rents === void 0 ? [] : _ref$rents;
  var _useTranslation = (0,esm/* useTranslation */.$G)(),
    t = _useTranslation.t,
    language = _useTranslation.i18n.language;
  var moveInDate = moveIn ? (0,utils/* formatDate */.p6)(new Date(moveIn), language, 'dd MMM yyyy') : null;
  var moveOutDate = moveOut ? (0,utils/* formatDate */.p6)(new Date(moveOut), language, 'dd MMM yyyy') : null;
  return DatePicker_Mobile_jsx(DatePicker_Mobile_styles_Wrapper, null, DatePicker_Mobile_jsx(Mobile_styles_Header, null, DatePicker_Mobile_jsx("span", null, DatePicker_Mobile_jsx(DatePicker_Pricing, {
    firstPayment: firstPayment,
    referencePrice: referencePrice
  }), DatePicker_Mobile_jsx(styles_DatesTitle, null, !moveInDate && !moveOutDate ? DatePicker_Mobile_jsx("span", null, t('Select your move-in date')) : DatePicker_Mobile_jsx(react.Fragment, null, moveInDate || '', DatePicker_Mobile_jsx(arrow_next/* default */.Z, {
    color: theme/* theme.colors.cornFlowerBlue */.rS.colors.cornFlowerBlue
  }), moveOutDate !== null && moveOutDate !== void 0 ? moveOutDate : DatePicker_Mobile_jsx("span", null, t('Select your move-out date'))))), maxGuests > 1 ? DatePicker_Mobile_jsx(Calendar_TenantCounter, {
    guests: guests,
    maxGuests: maxGuests,
    setGuests: setGuests
  }) : null), DatePicker_Mobile_jsx(components_MoveInOutPickerMobile, {
    rents: rents,
    dateRange: dateRange,
    classNames: classNames
  }));
};
/* harmony default export */ var DatePicker_Mobile = (DatePickerMobile);
// EXTERNAL MODULE: ../shared/src/utils/transformers/contracts.js + 10 modules
var contracts = __webpack_require__(46483);
// EXTERNAL MODULE: ../../node_modules/@datepicker-react/hooks/lib/index.esm.js
var index_esm = __webpack_require__(24823);
// EXTERNAL MODULE: ../shared/src/hooks/dateRange/dateFormats.js
var dateFormats = __webpack_require__(32193);
// EXTERNAL MODULE: ../shared/src/hooks/dateRange/utils.js
var dateRange_utils = __webpack_require__(71383);
;// CONCATENATED MODULE: ../shared/src/hooks/dateRange/without-input.js

function without_input_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function without_input_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? without_input_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : without_input_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }







var displayFormat = 'dd MMM, yyy';
var useDateRangeWithoutInputs = function useDateRangeWithoutInputs(ref) {
  var start = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var startName = arguments.length > 3 ? arguments[3] : undefined;
  var endName = arguments.length > 4 ? arguments[4] : undefined;
  var onChange = arguments.length > 5 ? arguments[5] : undefined;
  var availableFrom = arguments.length > 6 ? arguments[6] : undefined;
  var validation = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : function () {
    return true;
  };
  var minBookingDays = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : 21;
  var firstDayOfWeek = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : 0;
  var numberOfMonths = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : 1;
  var isDateBlocked = arguments.length > 11 && arguments[11] !== undefined ? arguments[11] : function () {
    return false;
  };
  var maxMoveInDate = arguments.length > 12 && arguments[12] !== undefined ? arguments[12] : null;
  var _useTranslation = (0,esm/* useTranslation */.$G)(),
    _useTranslation$i18n$ = _useTranslation.i18n.language,
    language = _useTranslation$i18n$ === void 0 ? 'en' : _useTranslation$i18n$;
  var _useDateFormats = (0,dateFormats/* useDateFormats */.$)(language),
    format = _useDateFormats.format,
    dateToString = _useDateFormats.dateToString,
    stringToDate = _useDateFormats.stringToDate;
  var _useState = (0,react.useState)(availableFrom),
    initialVisibleMonth = _useState[0],
    setInitialVisibleMonth = _useState[1];
  var _useState2 = (0,react.useState)(null),
    focusedInput = _useState2[0],
    setFocusedInput = _useState2[1];
  var _useState3 = (0,react.useState)(stringToDate(start)),
    startDate = _useState3[0],
    setStartDate = _useState3[1];
  var _useState4 = (0,react.useState)(stringToDate(end)),
    endDate = _useState4[0],
    setEndDate = _useState4[1];
  var _useKeyNavigation = (0,src/* useKeyNavigation */.Fp)(ref),
    isFocused = _useKeyNavigation.isFocused,
    blur = _useKeyNavigation.blur,
    focus = _useKeyNavigation.focus;
  var isChoosingStart = !start;
  var isChoosingEnd = !!start && !end;
  var activeStartDate = isChoosingEnd ? startDate : undefined;
  var activeEndDate = isChoosingStart ? endDate : undefined;
  var selectStartDate = function selectStartDate(date, input) {
    if (!validation(date.toISOString(), null)) {
      return null;
    }
    setStartDate(date);
    setFocusedInput(input);
  };
  var selectEndDate = function selectEndDate(date, input) {
    if (!startDate || !validation(startDate.toISOString(), date.toISOString())) {
      return null;
    }
    setEndDate(date);
    setFocusedInput(input);
  };
  var datePicker = (0,index_esm/* useDatepicker */.DB)({
    minBookingDate: activeStartDate || availableFrom,
    startDate: activeStartDate,
    endDate: activeEndDate,
    focusedInput: focusedInput,
    onDatesChange: (0,dateRange_utils/* onDatesChange */.K)(selectStartDate, selectEndDate, isChoosingStart, isChoosingEnd),
    numberOfMonths: numberOfMonths,
    firstDayOfWeek: firstDayOfWeek,
    //the hook has a bug of one day
    minBookingDays: minBookingDays + 1,
    initialVisibleMonth: initialVisibleMonth,
    changeActiveMonthOnSelect: false,
    isDateBlocked: isDateBlocked
  });

  //date conversions input: string -> internalState: Date
  (0,react.useEffect)(function () {
    var _onChange;
    if (start === dateToString(startDate)) {
      return;
    }
    onChange((_onChange = {}, (0,defineProperty/* default */.Z)(_onChange, startName, dateToString(startDate)), (0,defineProperty/* default */.Z)(_onChange, endName, dateToString(endDate)), _onChange));
    if (endDate) {
      blur();
    }
  }, [startDate]);
  (0,react.useEffect)(function () {
    var _onChange2;
    if (end === dateToString(endDate)) {
      return;
    }
    onChange((_onChange2 = {}, (0,defineProperty/* default */.Z)(_onChange2, startName, dateToString(startDate)), (0,defineProperty/* default */.Z)(_onChange2, endName, dateToString(endDate)), _onChange2));
  }, [endDate]);
  (0,react.useEffect)(function () {
    setStartDate(stringToDate(start));
  }, [start]);
  (0,react.useEffect)(function () {
    setEndDate(stringToDate(end));
  }, [end]);

  //focusChange and blur
  (0,react.useEffect)(function () {
    if (startDate && endDate) {
      return;
    }
    if (!focusedInput) {
      setInitialVisibleMonth(new Date());
      blur();
      return;
    }
    var newActiveMonth = !startDate && !endDate ? availableFrom : (0,addDays/* default */.Z)(startDate, minBookingDays) || startDate;
    datePicker.goToDate(newActiveMonth);
  }, [focusedInput]);
  (0,react.useEffect)(function () {
    if (!isFocused) {
      setFocusedInput(null);
      return;
    }
  }, [isFocused]);
  var isPresentActiveMonth = (0,react.useMemo)(function () {
    var activeMonth = datePicker.activeMonths[0];
    if (!activeMonth) {
      return false;
    }
    return (0,isSameMonth/* default */.Z)(activeMonth.date, new Date());
  }, [datePicker.activeMonths[0]]);
  var onResetDates = function onResetDates() {
    var _onChange3;
    onChange((_onChange3 = {}, (0,defineProperty/* default */.Z)(_onChange3, startName, null), (0,defineProperty/* default */.Z)(_onChange3, endName, null), _onChange3));
    blur();
  };
  (0,react.useEffect)(function () {
    if (!isChoosingStart) {
      return;
    }
    setFocusedInput(index_esm/* START_DATE */.dB);
  }, [isChoosingStart]);
  (0,react.useEffect)(function () {
    if (!isChoosingEnd) {
      return;
    }
    setFocusedInput(index_esm/* END_DATE */.I7);
  }, [isChoosingEnd]);
  return without_input_objectSpread(without_input_objectSpread({}, datePicker), {}, {
    goToPreviousMonths: isPresentActiveMonth ? function () {} : datePicker.goToPreviousMonths,
    onResetDates: onResetDates,
    isPresentActiveMonth: isPresentActiveMonth,
    isFocused: isFocused,
    focus: focus,
    choosingStart: isChoosingStart,
    choosingEnd: isChoosingEnd,
    startDate: startDate,
    endDate: endDate,
    startDateLabel: format(startDate, displayFormat),
    endDateLabel: format(endDate, displayFormat),
    minBookingDays: minBookingDays,
    maxMoveInDate: maxMoveInDate
  });
};
;// CONCATENATED MODULE: ../shared/src/utils/availabilities/availability-rules.js


function availability_rules_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function availability_rules_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? availability_rules_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : availability_rules_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }



var FORMAT = 'dd MMMM yyyy';
var MESSAGES = {
  min: function min(moveInOut) {
    return "The ".concat(moveInOut, " needs to be booked after {{date}}");
  },
  max: function max(moveInOut) {
    return moveInOut === 'move-in' ? 'The move-in date must be on or before <span>{{date}}</span>. Select a date in the available range above.' : "The ".concat(moveInOut, " cannot be booked after {{date}}");
  }
};
var validAvailabilityRules = function validAvailabilityRules(t, language) {
  var availabilityRules = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var availableFrom = arguments.length > 3 ? arguments[3] : undefined;
  var moveIn = arguments.length > 4 ? arguments[4] : undefined;
  var moveOut = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
  if (!availabilityRules || !availabilityRules.length || !moveIn && !moveOut) {
    return {
      isValid: true,
      error: null
    };
  }
  var _availabilityRules$ma = availabilityRules.map(function (_ref) {
      var _gap$move_in_out$item, _gap$move_in_out;
      var gap = _ref.gap;
      return ((_gap$move_in_out$item = gap === null || gap === void 0 ? void 0 : (_gap$move_in_out = gap.move_in_out) === null || _gap$move_in_out === void 0 ? void 0 : _gap$move_in_out.items) !== null && _gap$move_in_out$item !== void 0 ? _gap$move_in_out$item : []).reduce(function (prevAcc, _ref2) {
        var start = _ref2.start,
          end = _ref2.end;
        if (!prevAcc.isValid) {
          return prevAcc;
        }
        var isStartValid = isGapValid(start, moveIn, availableFrom, language);
        var isEndValid = moveOut ? isGapValid(end, moveOut, moveIn, language) : {
          isValid: true
        };
        var error = !isStartValid.isValid ? availability_rules_objectSpread(availability_rules_objectSpread({}, isStartValid), {}, {
          error: MESSAGES[isStartValid.type]('move-in')
        }) : !isEndValid.isValid ? availability_rules_objectSpread(availability_rules_objectSpread({}, isEndValid), {}, {
          error: MESSAGES[isEndValid.type]('move-out')
        }) : {};
        return availability_rules_objectSpread(availability_rules_objectSpread({}, error), {}, {
          isValid: isEndValid.isValid && isStartValid.isValid
        });
      }, {
        isValid: true
      });
    }),
    _availabilityRules$ma2 = (0,slicedToArray/* default */.Z)(_availabilityRules$ma, 1),
    _availabilityRules$ma3 = _availabilityRules$ma2[0],
    isValid = _availabilityRules$ma3.isValid,
    error = _availabilityRules$ma3.error,
    date = _availabilityRules$ma3.date;
  return {
    isValid: isValid,
    error: t(error, {
      date: date
    })
  };
};
var isGapValid = function isGapValid(availabilityRange, moveInOut, availableFrom, language) {
  var _ref3 = availabilityRange || {},
    min = _ref3.min,
    max = _ref3.max;
  var isMinValid = min ? isMinOrMaxValid(min, moveInOut, availableFrom, utils_date/* isBeforeOrSame */.v3, language) : {
    isValid: true
  };
  var isMaxValid = max ? isMinOrMaxValid(max, moveInOut, availableFrom, utils_date/* isAfterOrSame */.lF, language) : {
    isValid: true
  };
  var error = !isMinValid.isValid ? availability_rules_objectSpread({
    type: 'min'
  }, isMinValid) : !isMaxValid.isValid ? availability_rules_objectSpread({
    type: 'max'
  }, isMaxValid) : {};
  return availability_rules_objectSpread(availability_rules_objectSpread({}, error), {}, {
    isValid: isMaxValid.isValid && isMinValid.isValid
  });
};
var isMinOrMaxValid = function isMinOrMaxValid(_ref4, moveInOut, availableFrom, condition, language) {
  var days = _ref4.days,
    fixed_date = _ref4.fixed_date;
  var isDaysValid = !days || condition((0,addDays/* default */.Z)(availableFrom, days), moveInOut);
  var isFixedDateValid = !fixed_date || condition((0,contracts/* toDate */.ZU)(fixed_date), moveInOut);
  return {
    isValid: isDaysValid && isFixedDateValid,
    date: !isDaysValid ? (0,utils_date/* formatDate */.p6)((0,addDays/* default */.Z)(availableFrom, days), language, FORMAT) : !isFixedDateValid ? (0,utils_date/* formatDate */.p6)((0,contracts/* toDate */.ZU)(fixed_date), language, FORMAT) : null
  };
};
var getMaxMoveInDate = function getMaxMoveInDate(availableFrom, availabilityRules) {
  var rule = availabilityRules.find(function (rule) {
    var _rule$gap, _rule$gap$move_in_out, _rule$gap$move_in_out2, _rule$gap$move_in_out3, _rule$gap$move_in_out4, _rule$gap$move_in_out5;
    return rule === null || rule === void 0 ? void 0 : (_rule$gap = rule.gap) === null || _rule$gap === void 0 ? void 0 : (_rule$gap$move_in_out = _rule$gap.move_in_out) === null || _rule$gap$move_in_out === void 0 ? void 0 : (_rule$gap$move_in_out2 = _rule$gap$move_in_out.items) === null || _rule$gap$move_in_out2 === void 0 ? void 0 : (_rule$gap$move_in_out3 = _rule$gap$move_in_out2[0]) === null || _rule$gap$move_in_out3 === void 0 ? void 0 : (_rule$gap$move_in_out4 = _rule$gap$move_in_out3.start) === null || _rule$gap$move_in_out4 === void 0 ? void 0 : (_rule$gap$move_in_out5 = _rule$gap$move_in_out4.max) === null || _rule$gap$move_in_out5 === void 0 ? void 0 : _rule$gap$move_in_out5.days;
  });
  if (!rule) {
    return null;
  }
  return (0,addDays/* default */.Z)(availableFrom, rule.gap.move_in_out.items[0].start.max.days);
};
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/differenceInDays/index.js + 1 modules
var differenceInDays = __webpack_require__(97467);
;// CONCATENATED MODULE: ../shared/src/utils/availabilities/min-stay-penalty.js


var SHORT_TERM_FIXED = 'fixed';
var validateShortTermPenalty = function validateShortTermPenalty(t, language, startDate, endDate, penalty) {
  if (!startDate || !endDate) {
    return {
      warning: null
    };
  }
  var nights = penalty.nights_threshold;
  var selectedNights = (0,differenceInDays/* default */.Z)(endDate, startDate);
  if (nights < 0 || selectedNights >= nights) {
    return {
      warning: null
    };
  }
  if (penalty.type === SHORT_TERM_FIXED) {
    var _penalty$value = penalty.value,
      amount = _penalty$value.amount,
      currency = _penalty$value.currency_code;
    return {
      warning: t('This listing has a penalty for selecting less than {{days}} days. Rent will be increased by {{money}} a month', {
        days: nights,
        money: (0,utils/* formatMoney */.lb)(amount, currency, language)
      })
    };
  }
  return {
    warning: t('This listing has a penalty for selecting less than {{days}} days. Rent will be increased by {{percentage}} a month', {
      days: nights,
      percentage: "".concat(penalty.percentage * 100, "%")
    })
  };
};
;// CONCATENATED MODULE: ../shared/src/utils/availabilities/month-rent-changes.js



var validateMonthRentChange = function validateMonthRentChange(t, language, startDate, endDate, rents) {
  if (!startDate || !endDate || !rents) {
    return {
      warning: null
    };
  }
  var rentValues = rents.map(function (_ref) {
    var amount = _ref.amount;
    return amount;
  });
  var doesMonthRentChange = _toConsumableArray(new Set(rentValues)).length > 1;
  if (!doesMonthRentChange) {
    return {
      warning: null
    };
  }
  var _rents = _slicedToArray(rents, 1),
    currency = _rents[0].currency_code;
  var lowRent = formatMoney(Math.min.apply(Math, _toConsumableArray(rentValues)), currency, language);
  var highRent = formatMoney(Math.max.apply(Math, _toConsumableArray(rentValues)), currency, language);
  return {
    warning: t('The rent changes from month to month, from {{lowRent}} to {{highRent}}', {
      lowRent: lowRent,
      highRent: highRent
    })
  };
};
;// CONCATENATED MODULE: ../shared/src/utils/availabilities/index.js



;// CONCATENATED MODULE: ../shared/src/utils/availabilities/availabilities.js

var isDateBlocked = function isDateBlocked(date) {
  var blockedDates = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var availablePeriods = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var isWithinBlockedDates = blockedDates.some(function (_ref) {
    var start_date = _ref.start_date,
      end_date = _ref.end_date;
    return (0,isWithinInterval/* default */.Z)(date, {
      start: (0,startOfDay/* default */.Z)(new Date(start_date)),
      end: (0,startOfDay/* default */.Z)(new Date(end_date))
    });
  });
  var isWithinAvailablePeriods = availablePeriods.some(function (_ref2) {
    var start_date = _ref2.start_date,
      end_date = _ref2.end_date;
    return (0,isWithinInterval/* default */.Z)(date, {
      start: (0,startOfDay/* default */.Z)(new Date(start_date)),
      end: (0,startOfDay/* default */.Z)(new Date(end_date))
    });
  });
  return isWithinBlockedDates || !isWithinAvailablePeriods;
};
;// CONCATENATED MODULE: ../shared/src/components/Unisystem/Calendar/DatePicker/index.js
var DatePicker_jsx = react.createElement;









var DEFAULT_MINIMUM_DAY_GAP = 27;
var MONTHS_TO_SHOW = {
  mobile: 24,
  desktop: 2
};
var DatePicker = function DatePicker(_ref) {
  var guests = _ref.guests,
    maxGuests = _ref.maxGuests,
    setGuests = _ref.setGuests,
    firstPayment = _ref.firstPayment,
    referencePrice = _ref.referencePrice,
    minimumStay = _ref.minimumStay,
    maximumStay = _ref.maximumStay,
    availableFrom = _ref.availableFrom,
    moveIn = _ref.moveIn,
    moveOut = _ref.moveOut,
    setMoveInOut = _ref.setMoveInOut,
    _ref$classNames = _ref.classNames,
    classNames = _ref$classNames === void 0 ? {} : _ref$classNames,
    _ref$blockedDates = _ref.blockedDates,
    blockedDates = _ref$blockedDates === void 0 ? [] : _ref$blockedDates,
    _ref$rents = _ref.rents,
    rents = _ref$rents === void 0 ? [] : _ref$rents,
    _ref$availabilityRule = _ref.availabilityRules,
    availabilityRules = _ref$availabilityRule === void 0 ? [] : _ref$availabilityRule,
    _ref$availablePeriods = _ref.availablePeriods,
    availablePeriods = _ref$availablePeriods === void 0 ? [] : _ref$availablePeriods;
  var _useContext = (0,react.useContext)(media/* MediaContext */.Y),
    is = _useContext.is;
  var _useContext2 = (0,react.useContext)(CalendarContext),
    validateDates = _useContext2.validateDates;
  var ref = (0,react.useRef)();
  var dateRange = useDateRangeWithoutInputs(ref, moveIn, moveOut, 'moveIn', 'moveOut', function (_ref2) {
    var moveIn = _ref2.moveIn,
      moveOut = _ref2.moveOut;
    return setMoveInOut(moveIn, moveOut);
  }, moveIn && (0,contracts/* toDate */.ZU)(moveIn, contracts/* DATE_FORMAT */.zT) || availableFrom, validateDates, minimumStay || DEFAULT_MINIMUM_DAY_GAP, 0, is.mobile ? MONTHS_TO_SHOW.mobile : MONTHS_TO_SHOW.desktop, function (date) {
    return isDateBlocked(date, blockedDates, availablePeriods);
  }, getMaxMoveInDate(availableFrom, availabilityRules));
  return is.mobile ? DatePicker_jsx(DatePicker_Mobile, {
    firstPayment: firstPayment,
    referencePrice: referencePrice,
    guests: guests,
    maxGuests: maxGuests,
    setGuests: setGuests,
    moveIn: moveIn,
    moveOut: moveOut,
    dateRange: dateRange,
    classNames: classNames,
    rents: rents
  }) : DatePicker_jsx(DatePicker_Desktop, {
    guests: guests,
    maxGuests: maxGuests,
    setGuests: setGuests,
    moveIn: moveIn,
    moveOut: moveOut,
    dateRange: dateRange,
    firstPayment: firstPayment,
    referencePrice: referencePrice,
    maximumStay: maximumStay,
    rents: rents
  });
};
/* harmony default export */ var Calendar_DatePicker = (DatePicker);
;// CONCATENATED MODULE: ../shared/src/svg/save-money.js


var save_money_excluded = ["color", "secondaryColor"];
var save_money_jsx = react.createElement;

var SaveMoney = function SaveMoney(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#224251' : _ref$color,
    _ref$secondaryColor = _ref.secondaryColor,
    secondaryColor = _ref$secondaryColor === void 0 ? '#fff' : _ref$secondaryColor,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, save_money_excluded);
  return save_money_jsx("svg", (0,esm_extends/* default */.Z)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), save_money_jsx("g", {
    clipPath: "url(#a)"
  }, save_money_jsx("path", {
    fill: color,
    d: "M8.582 12.299a.93.93 0 1 1-1.86 0 .93.93 0 0 1 1.86 0Zm1.411-1.855a8.183 8.183 0 0 1 2.264-.315c.826 0 1.616.12 2.348.338a.62.62 0 0 0 .354-1.188 9.424 9.424 0 0 0-2.701-.39c-.91 0-1.787.128-2.607.362a.62.62 0 1 0 .342 1.193Z"
  }), save_money_jsx("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M12.39 7c-3.931 0-7.356 2.317-8.345 5.61H3.32c-.193 0-.383.044-.557.128a1.325 1.325 0 0 0-.453.357 1.4 1.4 0 0 0-.29 1.108l.336 1.986c.08.474.32.903.677 1.212.357.31.808.48 1.275.479h.347c.396.698.908 1.33 1.512 1.88l-.963 3.368a.7.7 0 0 0 .105.6.644.644 0 0 0 .529.272h2.64c.137 0 .27-.043.38-.124a.678.678 0 0 0 .242-.328l.637-1.837c.838.235 1.73.363 2.655.363.934 0 1.833-.129 2.678-.37l.717 1.866a.676.676 0 0 0 .242.312c.11.077.24.118.372.118h2.64a.644.644 0 0 0 .53-.275.693.693 0 0 0 .101-.602l-1.004-3.408c1.441-1.334 2.352-3.151 2.352-5.178 0-.198-.008-.393-.026-.586.345-.15.67-.362.93-.604.417.416 1.077.416 1.077-.567 0 .303-.66.303-.609-.035.055-.11.095-.227.12-.347a.98.98 0 0 0-.268-.877.746.746 0 0 0-.933-.133.987.987 0 0 0-.337.32c-.086.133-.14.285-.158.444-.032.33.108.653.422.89a2.619 2.619 0 0 1-.342.207C20.19 9.626 16.56 7 12.39 7Zm-7.194 6.437c.601-2.81 3.522-5.077 7.194-5.077 4.154 0 7.31 2.875 7.31 6.177 0 1.706-.825 3.278-2.206 4.417a.7.7 0 0 0-.218.728l.872 2.958h-1.3l-.78-2.022a.672.672 0 0 0-.339-.368.642.642 0 0 0-.491-.024 8.443 8.443 0 0 1-2.848.488 8.485 8.485 0 0 1-2.848-.488.642.642 0 0 0-.502.029.673.673 0 0 0-.337.384L8.01 22.64H6.717l.836-2.924a.7.7 0 0 0-.004-.399.68.68 0 0 0-.22-.327 6.285 6.285 0 0 1-1.696-2.096.673.673 0 0 0-.243-.273c.776-.26-.223-.1-.345-.101h-.74a.649.649 0 0 1-.424-.16.685.685 0 0 1-.225-.403l-.336-1.986h1.232c.15 0 .296-.053.414-.15a.683.683 0 0 0 .23-.384Zm16.665-1.166a.827.827 0 0 1-.13.286l-.058-.034c-.193-.122-.207-.238-.2-.303a.332.332 0 0 1 .154-.236c.065-.036.106-.028.149.017a.278.278 0 0 1 .084.27Z",
    clipRule: "evenodd"
  }), save_money_jsx("path", {
    fill: secondaryColor,
    stroke: color,
    d: "M6.482 8.311c.12.044.229.091.312.141.125.075.28.204.427.343l-.444.374-.295-.858Z"
  }), save_money_jsx("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeWidth: 0.6,
    d: "m11.907 1.754.844 3.15m.19-2.443c-.098-.362-.53-.561-.964-.445-.435.117-.709.505-.612.867.097.363.529.562.964.446.435-.117.866.083.963.445.097.362-.177.75-.612.867-.435.117-.866-.083-.963-.445"
  }), save_money_jsx("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeWidth: 0.6,
    d: "M10.407 1.407a2.718 2.718 0 1 1-.704 1.22"
  })), save_money_jsx("defs", null, save_money_jsx("clipPath", {
    id: "a"
  }, save_money_jsx("path", {
    fill: secondaryColor,
    d: "M0 0h24v24H0z"
  }))));
};
/* harmony default export */ var save_money = (SaveMoney);
;// CONCATENATED MODULE: ../shared/src/svg/person-plus.js


var person_plus_excluded = ["color"];
var person_plus_jsx = react.createElement;

var PersonPlus = function PersonPlus(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#224251' : _ref$color,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, person_plus_excluded);
  return person_plus_jsx("svg", (0,esm_extends/* default */.Z)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), person_plus_jsx("g", {
    stroke: color,
    clipPath: "url(#a)"
  }, person_plus_jsx("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M9.774 13.191v2.586L4.935 17.5C3.775 17.883 3 19.032 3 20.18V22h14.032M18 17.021l-3.387-1.244V13"
  }), person_plus_jsx("path", {
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M11.9 13.8c2.761 0 5-2.686 5-6s-2.239-6-5-6c-2.762 0-5 2.686-5 6s2.238 6 5 6Z"
  }), person_plus_jsx("path", {
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M16.8 7.2h-.5c-1.7.3-2.8-.3-3.7-1.9-.6 1.1-2.3 1.9-3.8 1.9-.7 0-1.3-.1-1.9-.5"
  }), person_plus_jsx("path", {
    strokeLinecap: "round",
    d: "M17 20h6M20 17v6"
  })));
};
/* harmony default export */ var person_plus = (PersonPlus);
;// CONCATENATED MODULE: ../shared/src/svg/calendar-info.js


var calendar_info_excluded = ["color"];
var calendar_info_jsx = react.createElement;

var CalendarInfo = function CalendarInfo(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#224251' : _ref$color,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, calendar_info_excluded);
  return calendar_info_jsx("svg", (0,esm_extends/* default */.Z)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), calendar_info_jsx("g", {
    stroke: color,
    clipPath: "url(#a)"
  }, calendar_info_jsx("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M17.5 23.501a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z"
  }), calendar_info_jsx("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M17.5 20.5V17a.5.5 0 0 0-.5-.5h-1M16 20.501h3M9.5 18.5h-8a1 1 0 0 1-1-1v-14a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1V10M5.5.501v5M15.5.501v5M.5 7.501h20"
  }), calendar_info_jsx("path", {
    d: "M16.75 14.5a.25.25 0 1 1 0-.5M16.75 14.5a.25.25 0 1 0 0-.5"
  })));
};
/* harmony default export */ var calendar_info = (CalendarInfo);
;// CONCATENATED MODULE: ../shared/src/components/Unisystem/Calendar/notifications.js


var notifications_jsx = react.createElement;
function notifications_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function notifications_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? notifications_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : notifications_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }










var getNotifications = function getNotifications(validation, t, _ref) {
  var _validation$suggestio;
  var isInstantBooking = _ref.isInstantBooking,
    extraPrice = _ref.extraPrice,
    setMoveInOut = _ref.setMoveInOut;
  return [].concat((0,toConsumableArray/* default */.Z)(isInstantBooking ? [{
    type: 'extra-data',
    icon: notifications_jsx(svg/* ThunderIcon */.Sg, {
      height: 24,
      color: theme/* theme.colors.uniBlue */.rS.colors.uniBlue
    }),
    message: 'Instant Booking: If you book this place now your book will be confirmed instantly',
    color: 'blue',
    isVisible: true,
    hasClose: true
  }] : []), (0,toConsumableArray/* default */.Z)(extraPrice ? [{
    type: 'extra-data',
    icon: notifications_jsx(person_plus, null),
    message: 'Adding another tenant changes the rental price. <span>Rent will be increased by {{price}} a month.</span>',
    messageParams: {
      price: (0,utils/* formatMoneyPerCountry */.h6)(extraPrice.amount, extraPrice.currency_code)
    },
    color: 'blue',
    isVisible: true,
    hasClose: true
  }] : []), (0,toConsumableArray/* default */.Z)(!validation.isValid && validation.error ? [{
    type: 'validation',
    message: validation.error,
    color: 'red',
    icon: notifications_jsx(calendar_lock, null),
    hasClose: true,
    isRepeatable: true
  }] : []), (0,toConsumableArray/* default */.Z)(validation.isValid && validation.warning ? [{
    type: 'validation',
    message: validation.warning,
    color: 'yellow',
    icon: notifications_jsx(calendar_info, null),
    hasClose: true,
    isRepeatable: true
  }] : []), (0,toConsumableArray/* default */.Z)(!validation.error && validation !== null && validation !== void 0 && (_validation$suggestio = validation.suggestions) !== null && _validation$suggestio !== void 0 && _validation$suggestio.dates ? [{
    type: 'validation',
    icon: notifications_jsx(save_money, null),
    message: validation.suggestions.message,
    action: {
      cancel: {
        message: t('I’m ok with my dates')
      },
      confirm: {
        message: t('Change dates'),
        onClick: function onClick() {
          return setMoveInOut(validation.suggestions.dates.moveIn, validation.suggestions.dates.moveOut);
        }
      }
    },
    color: 'green'
  }] : []));
};
var Notifications = function Notifications(_ref2) {
  var _notifications;
  var validations = _ref2.validations,
    isMobile = _ref2.isMobile,
    extraData = _ref2.extraData;
  var _useTranslation = (0,esm/* useTranslation */.$G)(),
    t = _useTranslation.t;
  var _useState = (0,react.useState)(JSON.stringify(validations)),
    cachedValidations = _useState[0],
    setCachedValidations = _useState[1];
  var _useState2 = (0,react.useState)(JSON.stringify(extraData)),
    cachedExtraData = _useState2[0],
    setCachedExtraData = _useState2[1];
  var _useState3 = (0,react.useState)(getNotifications(validations, t, extraData)),
    notifications = _useState3[0],
    setNotifications = _useState3[1];
  var _useState4 = (0,react.useState)((_notifications = notifications[notifications.length - 1]) !== null && _notifications !== void 0 ? _notifications : null),
    notification = _useState4[0],
    setNotification = _useState4[1];
  (0,react.useEffect)(function () {
    var hasValidationChanged = JSON.stringify(validations) !== cachedValidations;
    var hasExtraDataChanged = JSON.stringify(extraData) !== cachedExtraData;
    var newNotifications = getNotifications(validations, t, extraData);
    var validationNotifications = newNotifications.filter(function (_ref3) {
      var type = _ref3.type,
        _ref3$isRepeatable = _ref3.isRepeatable,
        isRepeatable = _ref3$isRepeatable === void 0 ? null : _ref3$isRepeatable;
      return hasValidationChanged ? type === 'validation' : type === 'validation' && !!isRepeatable;
    });
    var extraDataNotifications = newNotifications.filter(function (_ref4) {
      var type = _ref4.type,
        _ref4$isRepeatable = _ref4.isRepeatable,
        isRepeatable = _ref4$isRepeatable === void 0 ? null : _ref4$isRepeatable;
      return hasExtraDataChanged ? type === 'extra-data' : type === 'extra-data' && !!isRepeatable;
    });
    if (!validationNotifications.length && !extraDataNotifications.length) {
      return;
    }
    hasValidationChanged && setCachedValidations(JSON.stringify(validations));
    if (hasExtraDataChanged) {
      setCachedExtraData(JSON.stringify(extraData));
      setNotifications([].concat((0,toConsumableArray/* default */.Z)(extraDataNotifications), (0,toConsumableArray/* default */.Z)(validationNotifications)));
      return;
    }
    setNotifications([].concat((0,toConsumableArray/* default */.Z)(validationNotifications), (0,toConsumableArray/* default */.Z)(extraDataNotifications)));
  }, [validations, extraData]);
  (0,react.useEffect)(function () {
    var _notifications2;
    setNotification((_notifications2 = notifications[notifications.length - 1]) !== null && _notifications2 !== void 0 ? _notifications2 : null);
  }, [notifications]);
  var _onClose = function onClose(deleteIndex) {
    setNotifications(notifications.filter(function (_, index) {
      return index !== deleteIndex;
    }));
  };
  if (!notification) {
    return null;
  }
  var action = notification.action,
    icon = notification.icon,
    color = notification.color,
    message = notification.message,
    messageParams = notification.messageParams,
    hasClose = notification.hasClose;
  var confirmAction = action ? notifications_objectSpread(notifications_objectSpread({}, action), {}, {
    confirm: notifications_objectSpread(notifications_objectSpread({}, action.confirm), {}, {
      onClick: function onClick() {
        _onClose(notifications.length - 1);
        action.confirm.onClick();
      }
    })
  }) : action;
  return notifications_jsx(StatusBanner/* default */.Z, {
    animate: true,
    icon: icon,
    color: color,
    message: messageParams ? t(message, messageParams) : t(message),
    isFixed: isMobile,
    isMobile: isMobile,
    key: "status-".concat(message),
    action: confirmAction,
    hasClose: hasClose,
    onClose: function onClose() {
      return _onClose(notifications.length - 1);
    }
  });
};
/* harmony default export */ var notifications = (Notifications);
// EXTERNAL MODULE: ../shared/src/components/Unisystem/Button/styles.js
var Button_styles = __webpack_require__(5550);
// EXTERNAL MODULE: ../shared/src/components/ReserveWarning/styles.js
var ReserveWarning_styles = __webpack_require__(27674);
;// CONCATENATED MODULE: ../shared/src/components/Unisystem/Calendar/styles.js




var fadeIn = /*#__PURE__*/(0,styled_components_browser_esm/* keyframes */.F4)(["from{opacity:0;}to{opacity:1;}"]);
var slideIn = /*#__PURE__*/(0,styled_components_browser_esm/* keyframes */.F4)(["from{transform:translateY(20px);opacity:0;}to{transform:translateY(0);opacity:1;}"]);
var upSmooth = /*#__PURE__*/(0,styled_components_browser_esm/* keyframes */.F4)(["from{opacity:0.75;transform:translateY(650px);}to{opacity:1;transform:translateY(0px);}"]);
var styles_WrapperDesktop = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1prcmwh-0"
})(["position:relative;z-index:1000;display:flex;flex-direction:column;gap:", ";position:absolute;top:0;right:0;width:", ";padding:", ";background:", ";box-shadow:20px 5px 30px 0px ", ";z-index:1;border-radius:12px;border:1px solid ", ";animation:", " 0.3s ease-out,", " 0.3s ease-out;overflow-y:auto;.close-icon{display:block;width:15px;height:15px;position:absolute;top:24px;right:31px;}"], function (props) {
  return props.theme.space(3);
}, function (props) {
  return props.isBig ? '754px' : '500px';
}, function (props) {
  return props.theme.space(8);
}, function (props) {
  return props.theme.unisystem.calendar.background;
}, function (props) {
  return props.theme.unisystem.calendar.shadow;
}, function (props) {
  return props.theme.unisystem.calendar.borderColor;
}, slideIn, fadeIn);
var styles_WrapperMobile = /*#__PURE__*/(0,styled_components_browser_esm/* default */.ZP)(styles_WrapperDesktop).withConfig({
  componentId: "sc-1prcmwh-1"
})(["position:fixed;width:100%;height:100dvh;top:0;right:0;bottom:0;left:0;padding:", ";padding-bottom:130px;overflow-y:", ";animation:", " 0.45s ease-out;", "{font-size:", ";line-height:", ";}"], function (props) {
  return props.theme.space(5);
}, function (props) {
  return props.showPaymentSummary ? 'auto' : 'hidden';
}, upSmooth, ReserveWarning_styles/* Wrapper */.i, function (props) {
  return props.theme.rem(12);
}, function (props) {
  return props.theme.rem(24);
});
var Calendar_styles_Header = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1prcmwh-2"
})(["display:flex;align-items:center;justify-content:", ";width:100%;min-height:min-content;& > ", "{border:none;text-decoration:underline ", ";padding:0;span{color:", ";}}svg{cursor:pointer;border-radius:50%;z-index:1;background:transparent;padding:", ";margin-left:", ";width:36px;height:36px;> path{fill:", ";}&:hover{background:", ";}}"], function (_ref) {
  var hasSingleChild = _ref.hasSingleChild;
  return hasSingleChild ? 'flex-end' : 'space-between';
}, Button_styles/* Wrapper */.i, function (props) {
  return props.theme.buttons.tertiary.color;
}, function (props) {
  return props.theme.buttons.tertiary.color;
}, function (props) {
  return props.theme.space(2);
}, function (props) {
  return props.theme.space(-2);
}, function (props) {
  return props.theme.colors.cornFlowerBlue;
}, function (props) {
  return props.theme.closeButton.background;
});
var ButtonsDesktop = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1prcmwh-3"
})(["display:flex;justify-content:flex-end;align-self:flex-end;gap:", ";margin-top:auto;", "{min-width:120px;width:fit-content;&:only-child{width:100%;}}"], function (props) {
  return props.theme.space(3);
}, Button_styles/* Wrapper */.i);
var ButtonsMobile = /*#__PURE__*/(0,styled_components_browser_esm/* default */.ZP)(ButtonsDesktop).withConfig({
  componentId: "sc-1prcmwh-4"
})(["position:fixed;bottom:0;left:0;width:100%;height:64px;align-items:center;justify-content:space-between;padding:0 ", ";border-top:1px solid ", ";background:white;", " ", ":only-child{justify-content:center;}"], function (props) {
  return props.theme.space(3);
}, function (props) {
  return props.theme.colors.shadyGray;
}, function (props) {
  return props.showPaymentSummary && (0,styled_components_browser_esm/* css */.iv)(["flex-direction:column;height:auto;padding:", ";", " ", "{width:100%;}", "{padding:0;}"], props.theme.space(5), function (_ref2) {
    var theme = _ref2.theme;
    return theme.gap(2, 'column');
  }, Button_styles/* Wrapper */.i, StatusBanner_styles/* Wrapper */.im);
}, Button_styles/* Wrapper */.i);
// EXTERNAL MODULE: ../shared/src/components/PaymentSummary/index.js + 3 modules
var PaymentSummary = __webpack_require__(63636);
;// CONCATENATED MODULE: ../shared/src/utils/availabilities/stay.js


var isValidStay = function isValidStay(start, end, minimumStay, maximumStay, t) {
  var language = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 'en';
  if (!start || !end) {
    return {
      isValid: true,
      error: null
    };
  }
  var stayDuration = (0,differenceInDays/* default */.Z)(end, start);
  var isMinimumStayInvalid = minimumStay && stayDuration < minimumStay;
  if (isMinimumStayInvalid) {
    var minimumMoveOut = new Date(start);
    minimumMoveOut.setDate(minimumMoveOut.getDate() + minimumStay);
    return {
      isValid: false,
      error: t('This listing requires a minimum stay of {{nights}} nights. Please select a move-out date starting from {{moveOut}}.', {
        nights: minimumStay,
        moveOut: (0,utils_date/* formatDate */.p6)(minimumMoveOut, language, 'dd MMMM yyyy')
      })
    };
  }
  var isMaximumStayInvalid = maximumStay && stayDuration > maximumStay;
  if (isMaximumStayInvalid) {
    var maximumMoveOut = new Date(start);
    maximumMoveOut.setDate(maximumMoveOut.getDate() + maximumStay);
    return {
      isValid: false,
      error: t('The maximum stay for this listing is {{nights}} nights. Please select a move-out date before {{moveOut}}.', {
        nights: maximumStay,
        moveOut: (0,utils_date/* formatDate */.p6)(maximumMoveOut, language, 'dd MMMM yyyy')
      })
    };
  }
  return {
    isValid: true,
    error: null
  };
};
;// CONCATENATED MODULE: ../shared/src/utils/availabilities/valid-dates.js

var isValidDates = function isValidDates(moveIn, moveOut) {
  if (!moveIn && !moveOut) {
    return true;
  }
  var today = (0,startOfDay/* default */.Z)(new Date());
  var moveInDate = moveIn ? (0,startOfDay/* default */.Z)(moveIn) : null;
  var moveOutDate = moveOut ? (0,startOfDay/* default */.Z)(moveOut) : null;
  if (moveInDate && (0,isBefore/* default */.Z)(moveInDate, today) || moveOutDate && ((0,isBefore/* default */.Z)(moveOutDate, today) || (0,isBefore/* default */.Z)(moveOutDate, moveInDate))) {
    return {
      isValid: false,
      error: 'Invalid date'
    };
  }
  return {
    isValid: true,
    error: null
  };
};
;// CONCATENATED MODULE: ../shared/src/utils/availabilities/suggestions.js


var _CONTRACT_CONDITIONS;
function suggestions_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function suggestions_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? suggestions_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : suggestions_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }







var CONTRACT_CONDITIONS = (_CONTRACT_CONDITIONS = {}, (0,defineProperty/* default */.Z)(_CONTRACT_CONDITIONS, constants_contractType/* CONTRACT_TYPE.MONTHLY */.G.MONTHLY, {
  moveInDays: Array.from({
    length: 12
  }).map(function (_, index) {
    return 20 + index;
  }),
  moveOutDays: Array.from({
    length: 10
  }).map(function (_, index) {
    return 1 + index;
  }),
  suggestStart: function suggestStart(start) {
    return (0,addDays/* default */.Z)((0,endOfMonth/* default */.Z)(start), 1);
  },
  suggestEnd: function suggestEnd(end) {
    return (0,addDays/* default */.Z)((0,startOfMonth/* default */.Z)(end), -1);
  },
  messages: {
    options: {
      rent: 1
    },
    start: 'If you select <span>{{moveIn}}</span> as your move-in, you’ll save a month of rent ({{price}}).',
    end: 'If you select <span>{{moveOut}}</span> as your move-out, you’ll save a month of rent ({{price}}).',
    both: 'If you select <span>{{moveIn}}</span> as your move-in and <span>{{moveOut}}</span> as your move-out, you’ll save two months of rent ({{price}}).'
  }
}), (0,defineProperty/* default */.Z)(_CONTRACT_CONDITIONS, constants_contractType/* CONTRACT_TYPE.FORTNIGHT */.G.FORTNIGHT, {
  moveInDays: [].concat((0,toConsumableArray/* default */.Z)(Array.from({
    length: 5
  }).map(function (_, index) {
    return 10 + index;
  })), (0,toConsumableArray/* default */.Z)(Array.from({
    length: 6
  }).map(function (_, index) {
    return 25 + index;
  }))),
  moveOutDays: [].concat((0,toConsumableArray/* default */.Z)(Array.from({
    length: 5
  }).map(function (_, index) {
    return 1 + index;
  })), (0,toConsumableArray/* default */.Z)(Array.from({
    length: 5
  }).map(function (_, index) {
    return 16 + index;
  }))),
  suggestStart: function suggestStart(start) {
    return parseInt((0,format/* default */.Z)(start, 'dd'), 10) > 15 ? (0,addDays/* default */.Z)((0,endOfMonth/* default */.Z)(start), 1) : (0,addDays/* default */.Z)((0,startOfMonth/* default */.Z)(start), 15);
  },
  suggestEnd: function suggestEnd(end) {
    return parseInt((0,format/* default */.Z)(end, 'dd'), 10) > 15 ? (0,addDays/* default */.Z)((0,startOfMonth/* default */.Z)(end), 14) : (0,addDays/* default */.Z)((0,startOfMonth/* default */.Z)(end), -1);
  },
  messages: {
    options: {
      rent: 0.5
    },
    start: 'If you select <span>{{moveIn}}</span> as your move-in, you’ll save half a month of rent ({{price}}).',
    end: 'If you select <span>{{moveOut}}</span> as your move-out, you’ll save half a month of rent ({{price}}).',
    both: 'If you select <span>{{moveIn}}</span> as your move-in and <span>{{moveOut}}</span> as your move-out, you’ll save one month of rent ({{price}}).'
  }
}), _CONTRACT_CONDITIONS);
var suggestions_DATE_FORMAT = 'MMMM dd yyyy';
var suggestions_getPricing = function getPricing(ratio, language, rentMoveIn, rentMoveOut) {
  var _rentMoveIn$currency_, _rentMoveIn$amount;
  var currency = (_rentMoveIn$currency_ = rentMoveIn === null || rentMoveIn === void 0 ? void 0 : rentMoveIn.currency_code) !== null && _rentMoveIn$currency_ !== void 0 ? _rentMoveIn$currency_ : rentMoveOut === null || rentMoveOut === void 0 ? void 0 : rentMoveOut.currency_code;
  if (rentMoveIn && rentMoveOut) {
    return (0,money/* formatMoney */.lb)((rentMoveIn.amount + rentMoveOut.amount) * ratio, currency, language);
  }
  return (0,money/* formatMoney */.lb)(((_rentMoveIn$amount = rentMoveIn === null || rentMoveIn === void 0 ? void 0 : rentMoveIn.amount) !== null && _rentMoveIn$amount !== void 0 ? _rentMoveIn$amount : rentMoveOut === null || rentMoveOut === void 0 ? void 0 : rentMoveOut.amount) * ratio, currency, language);
};
var getMessage = function getMessage(moveIn, moveOut, rents, _ref, language) {
  var start = _ref.start,
    end = _ref.end,
    both = _ref.both,
    rent = _ref.options.rent;
  var rentMoveIn = moveIn && rents[parseInt((0,format/* default */.Z)(moveIn, 'MM'), 10) - 1];
  var rentMoveOut = moveOut && rents[parseInt((0,format/* default */.Z)(moveOut, 'MM'), 10) - 1];
  if (moveIn && moveOut) {
    var _price = suggestions_getPricing(rent, language, rentMoveIn, rentMoveOut);
    return {
      message: both,
      extra: {
        moveIn: (0,utils_date/* formatDate */.p6)(moveIn, language, suggestions_DATE_FORMAT),
        moveOut: (0,utils_date/* formatDate */.p6)(moveOut, language, suggestions_DATE_FORMAT),
        price: _price
      }
    };
  }
  var price = suggestions_getPricing(rent, language, rentMoveIn, rentMoveOut);
  return moveIn ? {
    message: start,
    extra: {
      moveIn: (0,utils_date/* formatDate */.p6)(moveIn, language, suggestions_DATE_FORMAT),
      price: price
    }
  } : {
    message: end,
    extra: {
      moveOut: (0,utils_date/* formatDate */.p6)(moveOut, language, suggestions_DATE_FORMAT),
      price: price
    }
  };
};
var isValidSuggestion = function isValidSuggestion(moveIn, moveOut, availabilityRules, availableFrom, minimumStay, maximumStay, t) {
  var dates = isValidDates(moveIn, moveOut);
  var stay = isValidStay(moveIn, moveOut, minimumStay, maximumStay, t);
  var rules = validAvailabilityRules(t, 'en', availabilityRules, availableFrom, moveIn, moveOut);
  return dates.isValid && stay.isValid && rules.isValid;
};
var contract = function contract() {
  var start = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var end = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var t = arguments.length > 2 ? arguments[2] : undefined;
  var language = arguments.length > 3 ? arguments[3] : undefined;
  var rents = arguments.length > 4 ? arguments[4] : undefined;
  var contractType = arguments.length > 5 ? arguments[5] : undefined;
  var availabilityRules = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
  var availableFrom = arguments.length > 7 ? arguments[7] : undefined;
  var minimumStay = arguments.length > 8 ? arguments[8] : undefined;
  var maximumStay = arguments.length > 9 ? arguments[9] : undefined;
  if (!start || !end || ![constants_contractType/* CONTRACT_TYPE.MONTHLY */.G.MONTHLY, constants_contractType/* CONTRACT_TYPE.FORTNIGHT */.G.FORTNIGHT].includes(contractType)) {
    return {};
  }
  var dateStart = (0,parseISO/* default */.Z)(start);
  var dateEnd = (0,parseISO/* default */.Z)(end);
  var _CONTRACT_CONDITIONS$ = CONTRACT_CONDITIONS[contractType],
    moveInDays = _CONTRACT_CONDITIONS$.moveInDays,
    moveOutDays = _CONTRACT_CONDITIONS$.moveOutDays,
    suggestStart = _CONTRACT_CONDITIONS$.suggestStart,
    suggestEnd = _CONTRACT_CONDITIONS$.suggestEnd,
    messages = _CONTRACT_CONDITIONS$.messages;
  var moveIn = moveInDays.includes(parseInt((0,format/* default */.Z)(dateStart, 'dd'), 10)) ? suggestStart(dateStart) : null;
  var moveOut = moveOutDays.includes(parseInt((0,format/* default */.Z)(dateEnd, 'dd'), 10)) ? suggestEnd(dateEnd) : null;
  if (!moveIn && !moveOut || !isValidSuggestion(moveIn !== null && moveIn !== void 0 ? moveIn : dateStart, moveOut !== null && moveOut !== void 0 ? moveOut : dateEnd, availabilityRules, availableFrom, minimumStay, maximumStay, t)) {
    return {};
  }
  var _getMessage = getMessage(moveIn, moveOut, rents, messages, language),
    message = _getMessage.message,
    extra = _getMessage.extra;
  return {
    dates: {
      moveIn: moveIn ? (0,utils_date/* formatDate */.p6)(moveIn) : start,
      moveOut: moveOut ? (0,utils_date/* formatDate */.p6)(moveOut) : end
    },
    contractType: contractType,
    message: t(message, extra)
  };
};
var getSuggestions = function getSuggestions() {
  return suggestions_objectSpread({}, contract.apply(void 0, arguments));
};
;// CONCATENATED MODULE: ../shared/src/utils/availabilities/range-valid.js


function range_valid_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function range_valid_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? range_valid_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : range_valid_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }






var getProps = function getProps(offer) {
  var _Math$max, _availabilityRules$, _availabilityRules$$g, _availabilityRules$$g2, _availabilityRules$$g3, _availabilityRules$$g4, _availabilityRules$$g5, _availabilityRules$$g6, _availabilityRules$0$, _availabilityRules$2, _availabilityRules$2$, _availabilityRules$2$2, _availabilityRules$2$3, _availabilityRules$2$4, _availabilityRules$2$5, _availabilityRules$2$6;
  var _offer$contract = offer.contract,
    contractType = _offer$contract.type,
    _offer$contract$stand = _offer$contract.standard,
    rents = _offer$contract$stand.rents,
    penalty = _offer$contract$stand.penalty,
    _offer$availabilities = offer.availabilities.availability_rules,
    availabilityRules = _offer$availabilities === void 0 ? [] : _offer$availabilities,
    conditionsMinimumNights = offer.requisites.conditions.minimum_nights;
  var minimumStay = (_Math$max = Math.max(conditionsMinimumNights || 0, ((_availabilityRules$ = availabilityRules[0]) === null || _availabilityRules$ === void 0 ? void 0 : (_availabilityRules$$g = _availabilityRules$.gap) === null || _availabilityRules$$g === void 0 ? void 0 : (_availabilityRules$$g2 = _availabilityRules$$g.move_in_out) === null || _availabilityRules$$g2 === void 0 ? void 0 : (_availabilityRules$$g3 = _availabilityRules$$g2.items) === null || _availabilityRules$$g3 === void 0 ? void 0 : (_availabilityRules$$g4 = _availabilityRules$$g3[0]) === null || _availabilityRules$$g4 === void 0 ? void 0 : (_availabilityRules$$g5 = _availabilityRules$$g4.end) === null || _availabilityRules$$g5 === void 0 ? void 0 : (_availabilityRules$$g6 = _availabilityRules$$g5.min) === null || _availabilityRules$$g6 === void 0 ? void 0 : _availabilityRules$$g6.days) || 0)) !== null && _Math$max !== void 0 ? _Math$max : null;
  var maximumStay = (_availabilityRules$0$ = (_availabilityRules$2 = availabilityRules[0]) === null || _availabilityRules$2 === void 0 ? void 0 : (_availabilityRules$2$ = _availabilityRules$2.gap) === null || _availabilityRules$2$ === void 0 ? void 0 : (_availabilityRules$2$2 = _availabilityRules$2$.move_in_out) === null || _availabilityRules$2$2 === void 0 ? void 0 : (_availabilityRules$2$3 = _availabilityRules$2$2.items) === null || _availabilityRules$2$3 === void 0 ? void 0 : (_availabilityRules$2$4 = _availabilityRules$2$3[0]) === null || _availabilityRules$2$4 === void 0 ? void 0 : (_availabilityRules$2$5 = _availabilityRules$2$4.end) === null || _availabilityRules$2$5 === void 0 ? void 0 : (_availabilityRules$2$6 = _availabilityRules$2$5.max) === null || _availabilityRules$2$6 === void 0 ? void 0 : _availabilityRules$2$6.days) !== null && _availabilityRules$0$ !== void 0 ? _availabilityRules$0$ : null;
  var availableFrom = (0,contracts/* getAvailableFrom */.yA)(offer);
  return {
    availabilityRules: availabilityRules,
    availableFrom: availableFrom,
    contractType: contractType,
    penalty: penalty,
    rents: rents,
    minimumStay: minimumStay,
    maximumStay: maximumStay
  };
};
var isRangeValid = function isRangeValid() {
  var start = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var end = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var t = arguments.length > 2 ? arguments[2] : undefined;
  var language = arguments.length > 3 ? arguments[3] : undefined;
  var offer = arguments.length > 4 ? arguments[4] : undefined;
  var startDate = start && (0,parseISO/* default */.Z)(start);
  var endDate = end && (0,parseISO/* default */.Z)(end);
  var _getProps = getProps(offer),
    availabilityRules = _getProps.availabilityRules,
    availableFrom = _getProps.availableFrom,
    contractType = _getProps.contractType,
    minimumStay = _getProps.minimumStay,
    maximumStay = _getProps.maximumStay,
    penalty = _getProps.penalty,
    rents = _getProps.rents;
  var rules = validAvailabilityRules(t, language, availabilityRules, availableFrom, startDate, endDate);
  var minStayWarning = validateShortTermPenalty(t, language, startDate, endDate, penalty);
  var validStayError = isValidStay(startDate, endDate, minimumStay, maximumStay, t, language);
  var _filter = [rules, validStayError].filter(function (_ref) {
      var isValid = _ref.isValid;
      return !isValid;
    }),
    _filter2 = (0,slicedToArray/* default */.Z)(_filter, 1),
    _filter2$ = _filter2[0],
    validation = _filter2$ === void 0 ? null : _filter2$;
  var _filter3 = [minStayWarning].filter(function (_ref2) {
      var warning = _ref2.warning;
      return warning;
    }),
    _filter4 = (0,slicedToArray/* default */.Z)(_filter3, 1),
    _filter4$ = _filter4[0],
    warning = _filter4$ === void 0 ? {} : _filter4$;
  var suggestions = getSuggestions(start, end, t, language, rents, contractType, availabilityRules, availableFrom, minimumStay, maximumStay);
  return range_valid_objectSpread(range_valid_objectSpread(range_valid_objectSpread({}, warning), validation !== null && validation !== void 0 ? validation : range_valid_objectSpread(range_valid_objectSpread({}, rules), validStayError)), {}, {
    suggestions: suggestions
  });
};
// EXTERNAL MODULE: ../shared/src/svg/arrowDown.js
var arrowDown = __webpack_require__(73332);
;// CONCATENATED MODULE: ../shared/src/components/Unisystem/Calendar/FixedContracts/styles.js

var FixedContracts_styles_templateObject;



var FixedContracts_styles_WrapperDesktop = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-13g8t58-0"
})(["display:flex;flex-direction:column;gap:", ";max-height:50vh;"], function (props) {
  return props.theme.space(4);
});
var FixedContracts_styles_WrapperMobile = /*#__PURE__*/(0,styled_components_browser_esm/* default */.ZP)(FixedContracts_styles_WrapperDesktop).withConfig({
  componentId: "sc-13g8t58-1"
})(["max-height:calc(100dvh - 150px);"]);
var MainHeaderDesktop = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-13g8t58-2"
})(["display:flex;justify-content:space-between;align-items:center;", ""], theme/* mediaMin.largeBreakpoint */.A3.largeBreakpoint(FixedContracts_styles_templateObject || (FixedContracts_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n    align-items: flex-start;\n    flex-direction: column;\n    gap: ", ";\n\n    ", " {\n      align-self: flex-end;\n    }\n  "])), function (props) {
  return props.theme.space(3);
}, TenantCounter_styles_Wrapper));
var MainHeaderMobile = /*#__PURE__*/(0,styled_components_browser_esm/* default */.ZP)(MainHeaderDesktop).withConfig({
  componentId: "sc-13g8t58-3"
})(["align-items:flex-start;flex-direction:column;gap:", ";", "{align-self:flex-end;}"], function (props) {
  return props.theme.space(3);
}, TenantCounter_styles_Wrapper);
var FixedDatesTitle = /*#__PURE__*/styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
  componentId: "sc-13g8t58-4"
})(["font-family:'IntervalNextMed',sans-serif;font-size:", ";font-weight:600;line-height:", ";color:", ";"], function (props) {
  return props.theme.rem(32);
}, function (props) {
  return props.theme.rem(40);
}, function (props) {
  return props.theme.unisystem.calendar.fixedContracts.color;
});
var Content = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-13g8t58-5"
})(["display:flex;flex-direction:column;gap:", ";width:100%;overflow-y:scroll;"], function (props) {
  return props.theme.space(3);
});
var styles_Accordion = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-13g8t58-6"
})(["width:100%;border-radius:8px;border:1px solid ", ";background-color:", ";transition:all 0.2s ease-in-out;cursor:pointer;&:hover{background-color:", ";}&.selected{background-color:", ";border:1px solid ", ";}"], function (props) {
  return props.theme.unisystem.calendar.fixedContracts.border;
}, function (props) {
  return props.theme.unisystem.calendar.fixedContracts.itemBackground;
}, function (props) {
  return props.theme.unisystem.calendar.fixedContracts.hoverBackground;
}, function (props) {
  return props.theme.unisystem.calendar.fixedContracts.selectedBackground;
}, function (props) {
  return props.theme.unisystem.calendar.fixedContracts.selectedBorder;
});
var FixedContracts_styles_Header = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-13g8t58-7"
})(["display:flex;flex-direction:column;justify-content:center;gap:", ";font-size:", ";padding:", ";"], function (props) {
  return props.theme.space(3);
}, function (props) {
  return props.theme.rem(16);
}, function (props) {
  return props.theme.space(3);
});
var FixedContracts_styles_Title = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-13g8t58-8"
})(["display:flex;align-items:center;gap:", ";font-size:16px;font-weight:400;line-height:20px;color:", ";svg{width:24px;path{fill:", ";}}"], function (props) {
  return props.theme.space(2);
}, function (props) {
  return props.theme.unisystem.calendar.fixedContracts.color;
}, function (props) {
  return props.theme.unisystem.calendar.fixedContracts.arrowSvgColor;
});
var styles_Subtitle = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-13g8t58-9"
})(["font-family:'IntervalNextReg',sans-serif;display:flex;align-items:center;gap:", ";font-size:", ";text-decoration:underline;color:", ";svg{width:16px;height:8px;transition:transform 0.2s ease-in-out;}", ""], function (props) {
  return props.theme.space(2);
}, function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.unisystem.calendar.fixedContracts.instalmentsTitle;
}, function (props) {
  return props.isSelected && "\n      color: ".concat(function (props) {
    return props.theme.unisystem.calendar.fixedContracts.color;
  }, ";\n\n      svg {\n        transform: rotate(-180deg);\n\n        path {\n          stroke: ").concat(function (props) {
    return props.theme.unisystem.calendar.fixedContracts.arrowSvgColorSelected;
  }, ";\n        }\n      }\n    ");
});
var Instalments = /*#__PURE__*/styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  componentId: "sc-13g8t58-10"
})(["display:flex;flex-direction:column;gap:12px;padding:", ";"], function (props) {
  return props.theme.space(3);
});
var Instalment = /*#__PURE__*/styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
  componentId: "sc-13g8t58-11"
})(["display:flex;justify-content:space-between;font-size:", ";line-height:", ";color:", ";span:first-of-type{font-family:'IntervalNextMed',sans-serif;}"], function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.rem(18);
}, function (props) {
  return props.theme.unisystem.calendar.fixedContracts.instalmentColor;
});
;// CONCATENATED MODULE: ../shared/src/components/Unisystem/Calendar/FixedContracts/index.js
var FixedContracts_jsx = react.createElement;










var FixedContracts = function FixedContracts(_ref) {
  var guests = _ref.guests,
    maxGuests = _ref.maxGuests,
    setGuests = _ref.setGuests,
    options = _ref.options,
    selectedOption = _ref.selectedOption,
    selectOption = _ref.selectOption,
    _ref$classNames = _ref.classNames,
    classNames = _ref$classNames === void 0 ? {} : _ref$classNames;
  var _useTranslation = (0,esm/* useTranslation */.$G)(),
    t = _useTranslation.t,
    language = _useTranslation.i18n.language;
  var _useContext = (0,react.useContext)(media/* MediaContext */.Y),
    is = _useContext.is;
  var className = Object.keys(classNames).filter(function (name) {
    return classNames[name];
  }).join(' ');
  var _useMemo = (0,react.useMemo)(function () {
      return is.mobile ? [FixedContracts_styles_WrapperMobile, MainHeaderMobile] : [FixedContracts_styles_WrapperDesktop, MainHeaderDesktop];
    }, [is.mobile]),
    Wrapper = _useMemo[0],
    MainHeader = _useMemo[1];
  return FixedContracts_jsx(Wrapper, null, FixedContracts_jsx(MainHeader, null, FixedContracts_jsx(FixedDatesTitle, null, t('Fixed dates')), FixedContracts_jsx(Calendar_TenantCounter, {
    guests: guests,
    maxGuests: maxGuests,
    setGuests: setGuests
  })), FixedContracts_jsx(StatusBanner/* default */.Z, {
    color: 'yellow',
    icon: FixedContracts_jsx(svg/* InfoIcon */.sz, null),
    message: 'This landlord only works with fixed dates. Please choose the ones that work best for you'
  }), FixedContracts_jsx(Content, null, options.map(function (_ref2) {
    var optionId = _ref2.id,
      startDate = _ref2.start_date,
      endDate = _ref2.end_date,
      instalments = _ref2.instalments,
      contractValue = _ref2.contract_value;
    var isSelected = optionId === selectedOption;
    var lowerInstalment = instalments === null || instalments === void 0 ? void 0 : instalments.reduce(function (acc, instalment) {
      return !acc && instalment.value.amount || instalment.value.amount < acc ? (0,utils/* formatMoney */.lb)(instalment.value.amount, instalment.value.currency_code) : acc;
    }, null);
    return FixedContracts_jsx(styles_Accordion, {
      key: optionId,
      className: "".concat(className, " ").concat(isSelected ? ' selected' : ''),
      onClick: function onClick() {
        return selectOption(isSelected ? null : optionId);
      }
    }, FixedContracts_jsx(FixedContracts_styles_Header, null, FixedContracts_jsx(FixedContracts_styles_Title, null, (0,utils/* formatDate */.p6)(new Date(startDate), language, 'd MMMM yyyy'), FixedContracts_jsx(arrow_next/* default */.Z, null), (0,utils/* formatDate */.p6)(new Date(endDate), language, 'd MMMM yyyy')), (instalments === null || instalments === void 0 ? void 0 : instalments.length) > 1 ? FixedContracts_jsx(styles_Subtitle, {
      isSelected: isSelected
    }, instalments === null || instalments === void 0 ? void 0 : instalments.length, " ", t('Instalments from'), " ", lowerInstalment, FixedContracts_jsx(arrowDown/* default */.Z, null)) : FixedContracts_jsx(styles_Subtitle, {
      isSelected: isSelected
    }, "1 ".concat(t('Instalment')), " - ", (0,utils/* formatMoney */.lb)(contractValue.amount, contractValue.currency_code))), isSelected && instalments && FixedContracts_jsx(Instalments, null, instalments === null || instalments === void 0 ? void 0 : instalments.map(function (instalment, index) {
      return FixedContracts_jsx(Instalment, {
        key: index
      }, FixedContracts_jsx("span", null, (0,utils/* formatDate */.p6)(new Date(instalment.date), language, 'd MMMM yyyy')), FixedContracts_jsx("span", null, (0,utils/* formatMoney */.lb)(instalment.value.amount, instalment.value.currency_code)));
    })));
  })));
};
/* harmony default export */ var Calendar_FixedContracts = (FixedContracts);
// EXTERNAL MODULE: ../shared/src/hooks/useOnOutsideClickOrPressEsc.js
var useOnOutsideClickOrPressEsc = __webpack_require__(59371);
// EXTERNAL MODULE: ../shared/src/components/ReserveWarning/index.js
var ReserveWarning = __webpack_require__(47763);
;// CONCATENATED MODULE: ../shared/src/components/Unisystem/Calendar/index.js

var Calendar_jsx = react.createElement;
function Calendar_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Calendar_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Calendar_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Calendar_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }




















var Calendar = function Calendar(_ref) {
  var _standardUnitary$avai, _standard$available_p, _standardUnitary$bloc, _Math$max, _availabilityRules$, _availabilityRules$$g, _availabilityRules$$g2, _availabilityRules$$g3, _availabilityRules$$g4, _availabilityRules$$g5, _availabilityRules$$g6, _availabilityRules$0$, _availabilityRules$2, _availabilityRules$2$, _availabilityRules$2$2, _availabilityRules$2$3, _availabilityRules$2$4, _availabilityRules$2$5, _availabilityRules$2$6, _availabilityRules$3, _availabilityRules$3$, _availabilityRules$3$2, _availabilityRules$3$3, _availabilityRules$3$4, _availabilityRules$3$5, _availabilityRules$3$6;
  var onClose = _ref.onClose,
    accommodationOffer = _ref.accommodationOffer,
    property = _ref.property,
    priceDetailsRequest = _ref.priceDetailsRequest,
    priceDetailsData = _ref.priceDetailsData,
    setMoveInOut = _ref.setMoveInOut,
    setGuests = _ref.setGuests,
    selectFixedOption = _ref.selectFixedOption,
    onConfirm = _ref.onConfirm,
    extraPrice = _ref.extraPrice,
    isLoading = _ref.isLoading,
    _ref$classNames = _ref.classNames,
    classNames = _ref$classNames === void 0 ? {} : _ref$classNames,
    _ref$setShowPaymentSu = _ref.setShowPaymentSummary,
    setShowPaymentSummary = _ref$setShowPaymentSu === void 0 ? function () {} : _ref$setShowPaymentSu,
    _ref$showPaymentSumma = _ref.showPaymentSummary,
    showPaymentSummary = _ref$showPaymentSumma === void 0 ? false : _ref$showPaymentSumma,
    source = _ref.source;
  var _useTranslation = (0,esm/* useTranslation */.$G)(),
    t = _useTranslation.t,
    language = _useTranslation.i18n.language;
  var _useContext = (0,react.useContext)(media/* MediaContext */.Y),
    is = _useContext.is;
  var ref = (0,react.useRef)();
  (0,useOnOutsideClickOrPressEsc/* default */.Z)(ref, onClose);
  var _accommodationOffer$c = accommodationOffer.contract,
    contractType = _accommodationOffer$c.type,
    isInstantBooking = _accommodationOffer$c.is_instant_booking,
    fixed = _accommodationOffer$c.fixed,
    fixedUnitary = _accommodationOffer$c.fixed_unitary,
    rents = _accommodationOffer$c.standard.rents,
    _accommodationOffer$a = accommodationOffer.availabilities,
    standard = _accommodationOffer$a.standard,
    standardUnitary = _accommodationOffer$a.standard_unitary,
    _accommodationOffer$a2 = _accommodationOffer$a.availability_rules,
    availabilityRules = _accommodationOffer$a2 === void 0 ? [] : _accommodationOffer$a2,
    _accommodationOffer$r = accommodationOffer.requisites.conditions,
    maxGuests = _accommodationOffer$r.max_guests,
    conditionsMinimumNights = _accommodationOffer$r.minimum_nights,
    referencePrice = accommodationOffer.reference_price;
  var availablePeriods = standardUnitary ? (_standardUnitary$avai = standardUnitary === null || standardUnitary === void 0 ? void 0 : standardUnitary.available_periods) !== null && _standardUnitary$avai !== void 0 ? _standardUnitary$avai : [] : (_standard$available_p = standard === null || standard === void 0 ? void 0 : standard.available_periods) !== null && _standard$available_p !== void 0 ? _standard$available_p : [];
  var blockedIntervals = standardUnitary ? (_standardUnitary$bloc = standardUnitary === null || standardUnitary === void 0 ? void 0 : standardUnitary.blocked_intervals) !== null && _standardUnitary$bloc !== void 0 ? _standardUnitary$bloc : [] : [];
  var minimumStay = (_Math$max = Math.max(conditionsMinimumNights || 0, ((_availabilityRules$ = availabilityRules[0]) === null || _availabilityRules$ === void 0 ? void 0 : (_availabilityRules$$g = _availabilityRules$.gap) === null || _availabilityRules$$g === void 0 ? void 0 : (_availabilityRules$$g2 = _availabilityRules$$g.move_in_out) === null || _availabilityRules$$g2 === void 0 ? void 0 : (_availabilityRules$$g3 = _availabilityRules$$g2.items) === null || _availabilityRules$$g3 === void 0 ? void 0 : (_availabilityRules$$g4 = _availabilityRules$$g3[0]) === null || _availabilityRules$$g4 === void 0 ? void 0 : (_availabilityRules$$g5 = _availabilityRules$$g4.end) === null || _availabilityRules$$g5 === void 0 ? void 0 : (_availabilityRules$$g6 = _availabilityRules$$g5.min) === null || _availabilityRules$$g6 === void 0 ? void 0 : _availabilityRules$$g6.days) || 0)) !== null && _Math$max !== void 0 ? _Math$max : null;
  var maximumStay = (_availabilityRules$0$ = (_availabilityRules$2 = availabilityRules[0]) === null || _availabilityRules$2 === void 0 ? void 0 : (_availabilityRules$2$ = _availabilityRules$2.gap) === null || _availabilityRules$2$ === void 0 ? void 0 : (_availabilityRules$2$2 = _availabilityRules$2$.move_in_out) === null || _availabilityRules$2$2 === void 0 ? void 0 : (_availabilityRules$2$3 = _availabilityRules$2$2.items) === null || _availabilityRules$2$3 === void 0 ? void 0 : (_availabilityRules$2$4 = _availabilityRules$2$3[0]) === null || _availabilityRules$2$4 === void 0 ? void 0 : (_availabilityRules$2$5 = _availabilityRules$2$4.end) === null || _availabilityRules$2$5 === void 0 ? void 0 : (_availabilityRules$2$6 = _availabilityRules$2$5.max) === null || _availabilityRules$2$6 === void 0 ? void 0 : _availabilityRules$2$6.days) !== null && _availabilityRules$0$ !== void 0 ? _availabilityRules$0$ : null;
  var firstPayment = priceDetailsData.first_payment;
  var moveIn = priceDetailsRequest.moveIn,
    moveOut = priceDetailsRequest.moveOut,
    guests = priceDetailsRequest.guests,
    optionId = priceDetailsRequest.optionId;
  var isAnyTypeFixed = [constants_contractType/* CONTRACT_TYPE.FIXED */.G.FIXED, constants_contractType/* CONTRACT_TYPE.FIXED_UNITARY */.G.FIXED_UNITARY].includes(contractType);
  var availableFrom = (0,contracts/* getAvailableFrom */.yA)(accommodationOffer, (_availabilityRules$3 = availabilityRules[0]) === null || _availabilityRules$3 === void 0 ? void 0 : (_availabilityRules$3$ = _availabilityRules$3.gap) === null || _availabilityRules$3$ === void 0 ? void 0 : (_availabilityRules$3$2 = _availabilityRules$3$.move_in_out) === null || _availabilityRules$3$2 === void 0 ? void 0 : (_availabilityRules$3$3 = _availabilityRules$3$2.items) === null || _availabilityRules$3$3 === void 0 ? void 0 : (_availabilityRules$3$4 = _availabilityRules$3$3[0]) === null || _availabilityRules$3$4 === void 0 ? void 0 : (_availabilityRules$3$5 = _availabilityRules$3$4.start) === null || _availabilityRules$3$5 === void 0 ? void 0 : (_availabilityRules$3$6 = _availabilityRules$3$5.min) === null || _availabilityRules$3$6 === void 0 ? void 0 : _availabilityRules$3$6.days);
  var _useState = (0,react.useState)(!isAnyTypeFixed && isRangeValid(moveIn, moveOut, t, language, accommodationOffer)),
    validations = _useState[0],
    setValidations = _useState[1];
  (0,react.useEffect)(function () {
    setValidations(!isAnyTypeFixed && isRangeValid(moveIn, moveOut, t, language, accommodationOffer));
  }, [moveIn, moveOut, showPaymentSummary]);
  var clearDates = (0,react.useCallback)(function () {
    return setMoveInOut(null, null);
  }, [isAnyTypeFixed, onClose]);
  var handleConfirm = (0,react.useCallback)(function () {
    if (!isAnyTypeFixed) {
      (0,dataAmplitude/* trackAmplitude */.pt)(events/* default.datesApplied */.Z.datesApplied, {
        moveIn: moveIn,
        moveOut: moveOut,
        source: source
      });
    }
    if (isAnyTypeFixed) {
      var selectedOption = ((fixed === null || fixed === void 0 ? void 0 : fixed.options) || (fixedUnitary === null || fixedUnitary === void 0 ? void 0 : fixedUnitary.options)).find(function (option) {
        return option.id === optionId;
      });
      var startDate = selectedOption.start_date,
        endDate = selectedOption.end_date;
      (0,dataAmplitude/* trackAmplitude */.pt)(events/* default.datesApplied */.Z.datesApplied, {
        moveIn: startDate,
        moveOut: endDate,
        source: source
      });
    }
    onConfirm(moveIn, moveOut, guests, optionId);
    if (is.mobile) {
      setShowPaymentSummary(true);
    }
  }, [moveIn, moveOut, guests, optionId, onConfirm, fixed === null || fixed === void 0 ? void 0 : fixed.options, fixedUnitary === null || fixedUnitary === void 0 ? void 0 : fixedUnitary.options]);
  var validateDates = function validateDates(startDate, endDate) {
    var validation = !isAnyTypeFixed && isRangeValid(startDate, endDate, t, language, accommodationOffer);
    setValidations(validation);
    return !validation.error;
  };
  var classes = Calendar_objectSpread(Calendar_objectSpread({}, classNames), {}, {
    'has-notifications': !!validations.error
  });
  var _useMemo = (0,react.useMemo)(function () {
      return is.mobile ? [styles_WrapperMobile, ButtonsMobile] : [styles_WrapperDesktop, ButtonsDesktop];
    }, [is.mobile]),
    Wrapper = _useMemo[0],
    Buttons = _useMemo[1];
  return Calendar_jsx(CalendarProvider, {
    validateDates: validateDates
  }, Calendar_jsx(Wrapper, {
    ref: ref,
    isBig: !isAnyTypeFixed,
    showPaymentSummary: showPaymentSummary
  }, showPaymentSummary ? Calendar_jsx(react.Fragment, null, Calendar_jsx(Calendar_styles_Header, null, Calendar_jsx(svg_close/* CloseIcon */.T, {
    onClick: onClose
  }), Calendar_jsx(Button/* default */.Z, {
    isTertiary: true,
    onClick: function onClick() {
      return setShowPaymentSummary(false);
    }
  }, t('Edit dates'))), Calendar_jsx(PaymentSummary/* default */.Z, {
    accommodationOffer: accommodationOffer,
    property: property,
    priceDetails: priceDetailsData,
    onClose: onClose,
    onEditDates: function onEditDates() {
      return setShowPaymentSummary(false);
    }
  })) : Calendar_jsx(react.Fragment, null, is.mobile && Calendar_jsx(Calendar_styles_Header, {
    hasSingleChild: !showPaymentSummary
  }, Calendar_jsx(svg_close/* CloseIcon */.T, {
    onClick: onClose
  })), isAnyTypeFixed ? Calendar_jsx(Calendar_FixedContracts, {
    guests: guests,
    maxGuests: maxGuests,
    setGuests: setGuests,
    options: (fixed === null || fixed === void 0 ? void 0 : fixed.options) || (fixedUnitary === null || fixedUnitary === void 0 ? void 0 : fixedUnitary.options),
    selectedOption: optionId,
    selectOption: selectFixedOption,
    classNames: classNames
  }) : Calendar_jsx(Calendar_DatePicker, {
    guests: guests,
    maxGuests: maxGuests,
    setGuests: setGuests,
    firstPayment: firstPayment === null || firstPayment === void 0 ? void 0 : firstPayment.total,
    referencePrice: referencePrice,
    minimumStay: minimumStay,
    maximumStay: maximumStay,
    availableFrom: availableFrom,
    moveIn: moveIn ? (0,utils/* formatDate */.p6)((0,parseISO/* default */.Z)(moveIn)) : null,
    moveOut: moveOut ? (0,utils/* formatDate */.p6)((0,parseISO/* default */.Z)(moveOut)) : null,
    setMoveInOut: setMoveInOut,
    classNames: classes,
    rents: rents,
    availablePeriods: availablePeriods,
    blockedDates: blockedIntervals.filter(function (_ref2) {
      var date = _ref2.end_date;
      return (0,isBefore/* default */.Z)(new Date(), new Date(date)) && (0,isBefore/* default */.Z)(availableFrom, new Date(date));
    }),
    availabilityRules: availabilityRules
  })), !showPaymentSummary && Calendar_jsx(notifications, {
    validations: validations,
    isMobile: is.mobile,
    extraData: {
      extraPrice: extraPrice,
      isInstantBooking: isInstantBooking,
      setMoveInOut: setMoveInOut
    }
  }), Calendar_jsx(Buttons, {
    showPaymentSummary: showPaymentSummary
  }, !showPaymentSummary && Calendar_jsx(Button/* default */.Z, {
    isGhost: true,
    onClick: isAnyTypeFixed ? onClose : clearDates,
    isDisabled: isLoading
  }, t(isAnyTypeFixed ? 'Cancel' : 'Clear Dates')), Calendar_jsx(Button/* default */.Z, {
    isPrimary: true,
    onClick: handleConfirm,
    isDisabled: (!moveIn || !moveOut || !validations.isValid) && !optionId || isLoading
  }, t(showPaymentSummary ? 'Request to book' : isAnyTypeFixed ? 'Confirm Dates' : 'Select dates')), !!showPaymentSummary && Calendar_jsx(ReserveWarning/* default */.Z
  // eslint-disable-next-line quotes
  , {
    message: t("Don't worry - pressing this button won't charge you anything!")
  }))));
};
/* harmony default export */ var Unisystem_Calendar = (Calendar);
// EXTERNAL MODULE: ../shared/src/utils/queryParams/index.js + 1 modules
var queryParams = __webpack_require__(50436);
;// CONCATENATED MODULE: ./src/components/PricingBox/Desktop/styles.js





var OuterWrapper = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-bci2fn-0"
})(["position:sticky;top:72px;z-index:2;"]);
var PricingBox_Desktop_styles_Wrapper = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-bci2fn-1"
})(["display:flex;flex-direction:column;gap:", ";width:100%;background:", ";box-shadow:0px 5px 20px 0px ", ";border-radius:12px;padding:", ";z-index:1;color:", ";> ", "{width:100%;}"], function (props) {
  return props.theme.space(4);
}, function (props) {
  return props.theme.pricingBox.background;
}, function (props) {
  return props.theme.pricingBox.shadow;
}, function (props) {
  return props.theme.space(5);
}, function (props) {
  return props.theme.pricingBox.price.mainColor;
}, Button_styles/* Wrapper */.i);
var styles_ReserveWarning = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-bci2fn-2"
})(["display:flex;", ";align-items:center;font-size:", ";line-height:", ";color:", ";font-weight:600;"], function (_ref) {
  var theme = _ref.theme;
  return theme.gap(2);
}, function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.rem(18);
}, function (props) {
  return props.theme.pricingBox.price.tertiaryColor;
});
var PriceSection = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-bci2fn-3"
})(["display:flex;justify-content:space-between;align-items:center;& > span{display:flex;align-items:center;gap:", ";svg{g{path{stroke:", ";}}}}"], function (props) {
  return props.theme.space(2);
}, function (props) {
  return props.theme.colors.blueDianne;
});
var Desktop_styles_Price = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-bci2fn-4"
})(["font-size:", ";line-height:", ";font-weight:600;span{color:", ";font-weight:500;font-size:", ";}"], function (props) {
  return props.theme.rem(22);
}, function (props) {
  return props.theme.rem(26);
}, function (props) {
  return props.theme.pricingBox.price.secondaryColor;
}, function (props) {
  return props.theme.rem(16);
});
var DatesSection = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-bci2fn-5"
})(["display:flex;justify-content:space-between;align-items:center;gap:", ";", "{width:45%;cursor:pointer;input{cursor:pointer;}}svg{width:64px;}"], function (props) {
  return props.theme.space(1);
}, Input_styles_Wrapper);
var CalendarWrapper = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-bci2fn-6"
})(["position:absolute;top:80px;right:-16px;", "{max-height:80vh;}", ""], styles_WrapperDesktop, function (props) {
  return props.hasSelectedDates && "\n      ".concat(DayContainer, " {\n        cursor: default;\n      }\n  ");
});
;// CONCATENATED MODULE: ./src/utils/doubleBookings/index.js
var isDoubleBooking = function isDoubleBooking(paidBookings, moveIn, moveOut) {
  if (!(paidBookings !== null && paidBookings !== void 0 && paidBookings.length) || !moveIn || !moveOut) {
    return false;
  }

  var formattedMoveIn = new Date(moveIn);
  var formattedMoveOut = new Date(moveOut);
  return paidBookings.some(function (booking) {
    var bookingMoveIn = new Date(booking.moveInOut.start);
    var bookingMoveOut = new Date(booking.moveInOut.end);
    return formattedMoveIn >= bookingMoveIn && formattedMoveIn <= bookingMoveOut || formattedMoveOut >= bookingMoveIn && formattedMoveOut <= bookingMoveOut || formattedMoveIn <= bookingMoveIn && formattedMoveOut >= bookingMoveOut;
  });
};
// EXTERNAL MODULE: ../shared/src/constants/countryCodes.js
var countryCodes = __webpack_require__(33591);
;// CONCATENATED MODULE: ../shared/src/utils/countryCode/index.js

var getCountryCode = function getCountryCode(cityCode) {
  return cityCode === null || cityCode === void 0 ? void 0 : cityCode.split('-')[0].toLowerCase();
};
var getCountryNamefromCityCode = function getCountryNamefromCityCode(cityCode) {
  var _COUNTRY_CODES$find;
  return (_COUNTRY_CODES$find = countryCodes/* COUNTRY_CODES.find */.Q.find(function (_ref) {
    var code = _ref.code;
    return code === getCountryCode(cityCode).toUpperCase();
  })) === null || _COUNTRY_CODES$find === void 0 ? void 0 : _COUNTRY_CODES$find.name.toLowerCase();
};
;// CONCATENATED MODULE: ./src/components/PricingBox/Desktop/index.js
var PricingBox_Desktop_jsx = react.createElement;


























var MOVE_IN_OUT_FORMAT = 'dd MMM yyyy';
var CALENDAR_SOURCES = {
  MOVE_IN: 'move in',
  MOVE_OUT: 'move out',
  SELECT_DATES: 'select dates'
};

var PricingBoxDesktop = function PricingBoxDesktop(_ref) {
  var _contract$fixed, _contract$fixed_unita, _accommodationOffer$c, _accommodationOffer$c2;

  var paidBookings = _ref.paidBookings,
      priceDetailsRequest = _ref.priceDetailsRequest,
      priceDetailsData = _ref.priceDetailsData,
      accommodationOffer = _ref.accommodationOffer,
      priceDetailsError = _ref.priceDetailsError,
      setPriceDetailsRequest = _ref.setPriceDetailsRequest,
      requestPriceDetails = _ref.requestPriceDetails,
      showDoubleBookingModal = _ref.showDoubleBookingModal,
      showPaymentSummary = _ref.showPaymentSummary,
      isLoading = _ref.isLoading,
      isCalendarOpen = _ref.isCalendarOpen,
      setIsCalendarOpen = _ref.setIsCalendarOpen,
      trackSelectDatesAction = _ref.trackSelectDatesAction,
      trackRequestIntentionAction = _ref.trackRequestIntentionAction,
      trackFixedContractModalOpenAction = _ref.trackFixedContractModalOpenAction,
      trackFixedContractOptionClickAction = _ref.trackFixedContractOptionClickAction,
      trackFixedContractConfirmClickAction = _ref.trackFixedContractConfirmClickAction,
      trackFixedContractCancelClickAction = _ref.trackFixedContractCancelClickAction,
      property = _ref.property,
      trackOpenCheckout = _ref.trackOpenCheckout;

  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t,
      language = _useTranslation.i18n.language;

  var router = (0,next_router.useRouter)();

  var _useState = (0,react.useState)(null),
      calendarSource = _useState[0],
      setCalendarSource = _useState[1];

  var offerId = accommodationOffer.id,
      contract = accommodationOffer.contract,
      offerGenderRestriction = accommodationOffer.restrictions.gender;
  var moveInRequest = priceDetailsRequest.moveIn,
      moveOutRequest = priceDetailsRequest.moveOut,
      optionId = priceDetailsRequest.optionId,
      guests = priceDetailsRequest.guests;

  var _ref2 = (priceDetailsData === null || priceDetailsData === void 0 ? void 0 : priceDetailsData.start_end) || {},
      moveIn = _ref2.start,
      moveOut = _ref2.end;

  var _getPricing = getPricing({
    accommodationOffer: accommodationOffer,
    priceDetailsRequest: priceDetailsRequest,
    priceDetailsData: priceDetailsData
  }),
      isAnyTypeFixed = _getPricing.isAnyTypeFixed,
      extraPriceAmount = _getPricing.extraPriceAmount,
      firstRentValue = _getPricing.firstRentValue,
      referencePrice = _getPricing.referencePrice;

  var extraPrice = extraPriceAmount ? {
    amount: extraPriceAmount,
    currency_code: referencePrice.currency_code
  } : null;
  var isInstantBooking = contract.is_instant_booking;
  var formattedFirstRentValue = firstRentValue && (0,utils/* formatMoney */.lb)(firstRentValue.amount, firstRentValue.currency_code);
  var moveInDate = moveInRequest || moveIn ? new Date(moveInRequest || moveIn) : null;
  var moveOutDate = moveOut || moveOutRequest ? new Date(moveOutRequest || moveOut) : null;
  var formattedMoveIn = moveInDate ? (0,utils/* formatDate */.p6)(moveInDate, language, MOVE_IN_OUT_FORMAT) : t('Select dates');
  var formattedMoveOut = moveOutDate ? (0,utils/* formatDate */.p6)(moveOutDate, language, MOVE_IN_OUT_FORMAT) : t('Select dates');
  var setMoveInOut = (0,react.useCallback)(function (moveIn, moveOut) {
    return setPriceDetailsRequest({
      moveIn: moveIn,
      moveOut: moveOut
    });
  });
  var selectFixedOption = (0,react.useCallback)(function (optionId) {
    setPriceDetailsRequest({
      optionId: optionId
    });
    trackFixedContractOptionClickAction(offerId);
  });
  var propertyType = property.typology.type_code,
      offerType = property.lifecycle.rent_by,
      cityCode = property.location.address.city_code,
      propertyGenderRestriction = property.restrictions.gender;

  var openCheckout = function openCheckout() {
    trackOpenCheckout(isAnyTypeFixed ? selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.start_date : moveInRequest, isAnyTypeFixed ? selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.end_date : moveOutRequest, guests, optionId, offerId, (0,utils/* fromMoneyCoreFormat */.fI)(firstRentValue === null || firstRentValue === void 0 ? void 0 : firstRentValue.amount) || (0,utils/* fromMoneyCoreFormat */.fI)(referencePrice.amount), (firstRentValue === null || firstRentValue === void 0 ? void 0 : firstRentValue.currency_code) || referencePrice.currency_code, (0,contracts/* getAvailableFrom */.yA)(accommodationOffer), propertyType, offerType, router.query.city, getCountryNamefromCityCode(cityCode), offerGenderRestriction, propertyGenderRestriction);
    (0,redirect/* redirectToCheckout */.VX)(offerId, isAnyTypeFixed ? {
      guests: guests,
      optionId: optionId
    } : {
      guests: guests,
      moveIn: moveInDate,
      moveOut: moveOutDate
    });
  };

  var openCheckoutOrDoubleBookingModal = function openCheckoutOrDoubleBookingModal() {
    if (isDoubleBooking(paidBookings, moveIn, moveOut)) {
      showDoubleBookingModal({
        onRequestBookingAnyway: openCheckout
      });
      return;
    }

    openCheckout();
  };

  var onConfirmSuggested = function onConfirmSuggested(moveInSuggested, moveOutSuggested) {
    (0,queryParams/* changeUrlQuery */.gJ)(router, {
      moveIn: moveInSuggested,
      moveOut: moveOutSuggested,
      guests: guests,
      optionId: optionId
    });
  };

  var _useState2 = (0,react.useState)(!isAnyTypeFixed && isRangeValid(moveIn && (0,utils/* formatDate */.p6)(moveInDate), moveOut && (0,utils/* formatDate */.p6)(moveOutDate), t, language, accommodationOffer)),
      validations = _useState2[0],
      setValidations = _useState2[1];

  (0,react.useEffect)(function () {
    setValidations(!isAnyTypeFixed && isRangeValid(moveIn && (0,utils/* formatDate */.p6)(moveInDate), moveOut && (0,utils/* formatDate */.p6)(moveOutDate), t, language, accommodationOffer));
  }, [moveIn, moveOut, priceDetailsRequest, language]);
  var formattedReferencePrice = (0,utils/* formatMoney */.lb)(referencePrice.amount, referencePrice.currency_code);
  var fixedContractOptions = (contract === null || contract === void 0 ? void 0 : (_contract$fixed = contract.fixed) === null || _contract$fixed === void 0 ? void 0 : _contract$fixed.options) || (contract === null || contract === void 0 ? void 0 : (_contract$fixed_unita = contract.fixed_unitary) === null || _contract$fixed_unita === void 0 ? void 0 : _contract$fixed_unita.options);
  var selectedOption = fixedContractOptions === null || fixedContractOptions === void 0 ? void 0 : fixedContractOptions.find(function (option) {
    return option.id === optionId;
  });
  var formattedStartDate = selectedOption !== null && selectedOption !== void 0 && selectedOption.start_date ? (0,utils/* formatDate */.p6)(new Date(selectedOption.start_date), language, MOVE_IN_OUT_FORMAT) : t('Select dates');
  var formattedEndDate = selectedOption !== null && selectedOption !== void 0 && selectedOption.end_date ? (0,utils/* formatDate */.p6)(new Date(selectedOption.end_date), language, MOVE_IN_OUT_FORMAT) : t('Select dates');

  var openCalendar = function openCalendar(source) {
    if (isAnyTypeFixed) {
      trackFixedContractModalOpenAction(offerId);
    }

    trackSelectDatesAction();
    trackRequestIntentionAction();
    setIsCalendarOpen(true);
    setCalendarSource(source);
  };

  var closeCalendar = function closeCalendar() {
    var _router$query$moveIn, _router$query$moveOut, _router$query$optionI;

    if (isAnyTypeFixed) {
      trackFixedContractCancelClickAction(offerId);
    }

    setPriceDetailsRequest({
      moveIn: (_router$query$moveIn = router.query.moveIn) !== null && _router$query$moveIn !== void 0 ? _router$query$moveIn : null,
      moveOut: (_router$query$moveOut = router.query.moveOut) !== null && _router$query$moveOut !== void 0 ? _router$query$moveOut : null,
      guests: +router.query.guests ? +router.query.guests : 1,
      optionId: (_router$query$optionI = router.query.optionId) !== null && _router$query$optionI !== void 0 ? _router$query$optionI : null
    });
    setIsCalendarOpen(false);
  };

  var onConfirm = function onConfirm(moveIn, moveOut, guests, optionId) {
    if (isAnyTypeFixed) {
      trackFixedContractConfirmClickAction(offerId);
    }

    (0,queryParams/* changeUrlQuery */.gJ)(router, {
      moveIn: moveIn,
      moveOut: moveOut,
      guests: guests,
      optionId: optionId
    });
    closeCalendar();
  };

  var setGuests = (0,react.useCallback)(function (updatedGuests) {
    if (+updatedGuests === priceDetailsRequest.guests) {
      return;
    }

    setPriceDetailsRequest({
      guests: +updatedGuests
    });
  }, [guests, moveIn, moveOut, optionId]);
  (0,react.useEffect)(function () {
    if (!priceDetailsError) {
      return;
    }

    var _router$query = router.query,
        offerId = _router$query.offerId,
        city = _router$query.city,
        guests = _router$query.guests;
    (0,queryParams/* replaceFromQuery */.nK)(router, {
      offerId: offerId,
      city: city,
      guests: guests
    });
  }, [priceDetailsError]);
  (0,react.useEffect)(function () {
    var _normalizeQuery = (0,queryParams/* normalizeQuery */.Up)(router.query),
        moveIn = _normalizeQuery.moveIn,
        moveOut = _normalizeQuery.moveOut,
        guests = _normalizeQuery.guests,
        optionId = _normalizeQuery.optionId;

    var shouldRequestPriceDetails = false;

    if (moveIn && moveIn !== priceDetailsRequest.moveIn && moveOut && moveOut !== priceDetailsRequest.moveOut) {
      setMoveInOut(moveIn, moveOut);
      shouldRequestPriceDetails = true;
    }

    if (+guests && +guests !== priceDetailsRequest.guests) {
      setPriceDetailsRequest({
        guests: +guests
      });
      shouldRequestPriceDetails = true;
    }

    if (optionId && optionId !== priceDetailsRequest.optionId) {
      selectFixedOption(optionId);
      shouldRequestPriceDetails = true;
    }

    if (shouldRequestPriceDetails) {
      requestPriceDetails();
    }
  }, [router.query]);
  (0,react.useEffect)(function () {
    var _document;

    if (!isCalendarOpen) {
      return;
    }

    var calendar = (_document = document) === null || _document === void 0 ? void 0 : _document.getElementById('pricing-box');

    var _ref3 = (calendar === null || calendar === void 0 ? void 0 : calendar.getBoundingClientRect()) || {},
        calendarTop = _ref3.top,
        calendarBottom = _ref3.bottom;

    var shouldScrollIntoCalendar = calendarBottom > window.innerHeight || calendarTop < 0;

    if (!shouldScrollIntoCalendar) {
      return;
    }

    calendar.scrollIntoView({
      behavior: 'smooth'
    });
  }, [isCalendarOpen]);
  return PricingBox_Desktop_jsx(OuterWrapper, null, PricingBox_Desktop_jsx(PricingBox_Desktop_styles_Wrapper, {
    id: "pricing-box"
  }, PricingBox_Desktop_jsx(PriceSection, null, PricingBox_Desktop_jsx(Desktop_styles_Price, null, formattedFirstRentValue || formattedReferencePrice, PricingBox_Desktop_jsx("span", null, "/".concat(t('month')))), PricingBox_Desktop_jsx("span", null, PricingBox_Desktop_jsx(persons, null), "".concat(guests, " ").concat(t(guests > 1 ? 'people' : 'person')))), PricingBox_Desktop_jsx(DatesSection, null, PricingBox_Desktop_jsx(Unisystem_Input, {
    value: isAnyTypeFixed ? formattedStartDate : formattedMoveIn,
    insideLabel: t('Move in'),
    isDisabled: isLoading,
    onClick: function onClick() {
      return openCalendar(CALENDAR_SOURCES.MOVE_IN);
    }
  }), PricingBox_Desktop_jsx(arrow_next/* default */.Z, {
    color: src_theme/* theme.colors.cornFlowerBlue */.r.colors.cornFlowerBlue
  }), PricingBox_Desktop_jsx(Unisystem_Input, {
    value: isAnyTypeFixed ? formattedEndDate : formattedMoveOut,
    insideLabel: t('Move out'),
    isDisabled: isLoading,
    onClick: function onClick() {
      return openCalendar(CALENDAR_SOURCES.MOVE_OUT);
    }
  })), PricingBox_Desktop_jsx(notifications, {
    validations: validations,
    extraData: {
      extraPrice: extraPrice,
      isInstantBooking: isInstantBooking,
      setMoveInOut: onConfirmSuggested
    }
  }), PricingBox_Desktop_jsx(Button/* default */.Z, {
    isPrimary: true,
    isLoading: isLoading,
    onClick: (moveIn && moveOut || optionId) && priceDetailsData ? openCheckoutOrDoubleBookingModal : function () {
      return openCalendar(CALENDAR_SOURCES.SELECT_DATES);
    }
  }, (moveIn && moveOut || optionId) && priceDetailsData ? t('Start booking') : t('Select dates')), Object.keys(priceDetailsData).length > 0 && PricingBox_Desktop_jsx(react.Fragment, null, PricingBox_Desktop_jsx(styles_ReserveWarning, null, t("Don't worry - pressing this button won't charge you anything!")), PricingBox_Desktop_jsx(Desktop_PriceDetails, {
    priceDetails: priceDetailsData,
    hasRentCollection: (_accommodationOffer$c = accommodationOffer.contract) === null || _accommodationOffer$c === void 0 ? void 0 : (_accommodationOffer$c2 = _accommodationOffer$c.rent_collection) === null || _accommodationOffer$c2 === void 0 ? void 0 : _accommodationOffer$c2.active
  }), PricingBox_Desktop_jsx(styles_ReserveWarning, null, PricingBox_Desktop_jsx(piggy_bank_alt/* default */.Z, null), t("If you find it cheaper elsewhere, we'll refund the difference.")), PricingBox_Desktop_jsx(Button/* default */.Z, {
    isGhost: true,
    onClick: function onClick() {
      return showPaymentSummary(accommodationOffer, property, priceDetailsData);
    }
  }, t('Review price details'), " ", PricingBox_Desktop_jsx(arrow_next/* default */.Z, {
    color: src_theme/* theme.colors.cornFlowerBlue */.r.colors.cornFlowerBlue,
    width: 24
  }))), isCalendarOpen && PricingBox_Desktop_jsx(CalendarWrapper, {
    hasSelectedDates: !!moveOutDate
  }, PricingBox_Desktop_jsx(Unisystem_Calendar, {
    onClose: closeCalendar,
    accommodationOffer: accommodationOffer,
    property: property,
    priceDetailsRequest: priceDetailsRequest,
    priceDetailsData: priceDetailsData,
    setMoveInOut: setMoveInOut,
    setGuests: setGuests,
    selectFixedOption: selectFixedOption,
    onConfirm: onConfirm,
    extraPrice: extraPrice,
    isLoading: isLoading,
    source: calendarSource
  }))));
};

var Desktop_mapStateToProps = function mapStateToProps(_ref4) {
  var paidBookings = _ref4.profile.paidBookings,
      _ref4$offer = _ref4.offer,
      _ref4$offer$priceDeta = _ref4$offer.priceDetails,
      isLoading = _ref4$offer$priceDeta.isLoading,
      priceDetailsRequest = _ref4$offer$priceDeta.request,
      priceDetailsData = _ref4$offer$priceDeta.data,
      _ref4$offer$priceDeta2 = _ref4$offer$priceDeta.error,
      error = _ref4$offer$priceDeta2 === void 0 ? null : _ref4$offer$priceDeta2,
      offerAggregate = _ref4$offer.offerAggregate,
      isCalendarOpen = _ref4$offer.isCalendarOpen;
  return {
    paidBookings: paidBookings,
    priceDetailsRequest: priceDetailsRequest || {},
    priceDetailsData: priceDetailsData || {},
    priceDetailsError: error,
    accommodationOffer: offerAggregate.accommodation_offer,
    isLoading: isLoading,
    isCalendarOpen: isCalendarOpen,
    property: offerAggregate.property_aggregate.property
  };
};

var Desktop_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setPriceDetailsRequest: function setPriceDetailsRequest(_ref5) {
      var guests = _ref5.guests,
          moveIn = _ref5.moveIn,
          moveOut = _ref5.moveOut,
          optionId = _ref5.optionId;
      return dispatch((0,offer/* setPriceDetailsRequest */.dp)({
        guests: guests,
        moveIn: moveIn,
        moveOut: moveOut,
        optionId: optionId
      }));
    },
    setIsCalendarOpen: function setIsCalendarOpen(newValue) {
      return dispatch((0,offer/* setIsCalendarOpenAction */.s9)({
        isCalendarOpen: newValue
      }));
    },
    requestPriceDetails: function requestPriceDetails() {
      return dispatch((0,offer/* requestPriceDetails */.uU)());
    },
    showPaymentSummary: function showPaymentSummary(accommodationOffer, property, priceDetails) {
      dispatch((0,actions_tracking/* trackPriceReview */.v)({
        context: 'offer page'
      }));
      dispatch((0,modal/* showModalAction */.bF)({
        modalId: modal_displayer.modalIds.PAYMENT_SUMMARY,
        accommodationOffer: accommodationOffer,
        property: property,
        priceDetails: priceDetails
      }));
    },
    showDoubleBookingModal: function showDoubleBookingModal(_ref6) {
      var onRequestBookingAnyway = _ref6.onRequestBookingAnyway;
      return dispatch((0,modal/* showModalAction */.bF)({
        modalId: modal_displayer.modalIds.DOUBLE_BOOKING,
        onRequestBookingAnyway: onRequestBookingAnyway
      }));
    },
    trackSelectDatesAction: function trackSelectDatesAction() {
      return dispatch((0,actions_tracking/* trackSelectDates */.sz)());
    },
    trackRequestIntentionAction: function trackRequestIntentionAction() {
      return dispatch((0,actions_tracking/* trackRequestIntention */.OU)());
    },
    trackFixedContractModalOpenAction: function trackFixedContractModalOpenAction(offerId) {
      return dispatch((0,actions_tracking/* trackFixedContractModalOpen */.Iu)({
        offerId: offerId
      }));
    },
    trackFixedContractOptionClickAction: function trackFixedContractOptionClickAction(offerId) {
      return dispatch((0,actions_tracking/* trackFixedContractOptionClick */.qh)({
        offerId: offerId
      }));
    },
    trackFixedContractConfirmClickAction: function trackFixedContractConfirmClickAction(offerId) {
      return dispatch((0,actions_tracking/* trackFixedContractConfirmClick */.Lf)({
        offerId: offerId
      }));
    },
    trackFixedContractCancelClickAction: function trackFixedContractCancelClickAction(offerId) {
      return dispatch((0,actions_tracking/* trackFixedContractCancelClick */.ek)({
        offerId: offerId
      }));
    },
    trackOpenCheckout: function trackOpenCheckout(moveIn, moveOut, guests, optionId, offerId, price, currencyCode, availableFrom, propertyType, offerType, city, country, offerGenderRestriction, propertyGenderRestriction) {
      dispatch((0,actions_tracking/* trackRequestToBook */.ef)());
      dispatch((0,actions_tracking/* trackRequestIntention */.OU)());
      dispatch((0,actions_tracking/* trackRequestToBookAmplitude */.BP)({
        moveIn: moveIn,
        moveOut: moveOut,
        guests: guests,
        optionId: optionId,
        offerId: offerId,
        price: price,
        currencyCode: currencyCode,
        availableFrom: availableFrom,
        propertyType: propertyType,
        offerType: offerType,
        city: city,
        country: country,
        offerGenderRestriction: offerGenderRestriction,
        propertyGenderRestriction: propertyGenderRestriction
      }));
    }
  };
};

/* harmony default export */ var PricingBox_Desktop = ((0,es/* connect */.$j)(Desktop_mapStateToProps, Desktop_mapDispatchToProps)(PricingBoxDesktop));
;// CONCATENATED MODULE: ./src/components/MorePlacesLikeThis/styles.js


var MorePlacesLikeThis_styles_templateObject, MorePlacesLikeThis_styles_templateObject2;







var MorePlacesLikeThis_styles_Wrapper = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1epx5fl-0"
})(["width:100%;max-width:100%;margin-top:", ";", " ", "{", ";margin-top:0;color:", ";", "{", ";", "{p{font-size:", ";line-height:", ";font-weight:600;}}", "{", ";}}", " & > div{", ";}", "{min-width:291px;", "{height:240px;}", "{display:inline;}}}"], function (props) {
  return props.theme.space(2);
}, theme/* mediaMin.smallBreakpoint */.A3.smallBreakpoint(MorePlacesLikeThis_styles_templateObject || (MorePlacesLikeThis_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-top: ", ";\n  "])), function (props) {
  return props.theme.space(1);
}), MoreListings_styles_Wrapper, function (props) {
  return props.theme.gap(10);
}, function (props) {
  return props.theme.morePlacesLikeThisSection.textColor;
}, SimpleCarousel_styles_Wrapper, function (props) {
  return props.theme.gap(10);
}, Header, function (props) {
  return props.theme.rem(18);
}, function (props) {
  return props.theme.rem(20);
}, Carousel, function (props) {
  return props.theme.gap(3);
}, theme/* mediaMin.smallBreakpoint */.A3.smallBreakpoint(MorePlacesLikeThis_styles_templateObject2 || (MorePlacesLikeThis_styles_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n      ", "\n    "])), function (_ref) {
  var theme = _ref.theme;
  return theme.gap(7);
}), function (props) {
  return props.theme.gap(3);
}, styles_WrapperLink, Photos, OfferCard_styles_Title);
// EXTERNAL MODULE: ../shared/src/contexts/wishlist/index.js + 56 modules
var wishlist = __webpack_require__(59808);
;// CONCATENATED MODULE: ./src/components/MorePlacesLikeThis/index.js
var MorePlacesLikeThis_jsx = react.createElement;







var MorePlacesLikeThis = function MorePlacesLikeThis(_ref) {
  var _recommendations$data;

  var recommendations = _ref.recommendations,
      trackMorePlacesLikeThisAction = _ref.trackMorePlacesLikeThisAction;

  if (!(recommendations !== null && recommendations !== void 0 && (_recommendations$data = recommendations.data) !== null && _recommendations$data !== void 0 && _recommendations$data.length)) {
    return null;
  }

  return MorePlacesLikeThis_jsx(MorePlacesLikeThis_styles_Wrapper, null, MorePlacesLikeThis_jsx(wishlist/* WishlistContextProvider */.T, null, MorePlacesLikeThis_jsx(components_MoreListings, {
    title: "More places like this",
    recommendations: recommendations,
    disableWishlist: false,
    cardWidth: 291,
    cardGap: 12,
    trackListing: trackMorePlacesLikeThisAction,
    showTrustedTag: true
  })));
};

var MorePlacesLikeThis_mapStateToProps = function mapStateToProps(_ref2) {
  var _ref2$offer$recommend = _ref2.offer.recommendations;
  _ref2$offer$recommend = _ref2$offer$recommend === void 0 ? {} : _ref2$offer$recommend;
  var recommendations = _ref2$offer$recommend.byOffer;
  return {
    recommendations: recommendations
  };
};

var MorePlacesLikeThis_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    trackMorePlacesLikeThisAction: function trackMorePlacesLikeThisAction() {
      return dispatch((0,actions_tracking/* trackMorePlacesLikeThis */.xH)());
    }
  };
};

/* harmony default export */ var components_MorePlacesLikeThis = ((0,es/* connect */.$j)(MorePlacesLikeThis_mapStateToProps, MorePlacesLikeThis_mapDispatchToProps)(MorePlacesLikeThis));
;// CONCATENATED MODULE: ../shared/src/svg/pin.js


var pin_excluded = ["color"];
var pin_jsx = react.createElement;

var Pin = function Pin(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#224251' : _ref$color,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, pin_excluded);
  return pin_jsx("svg", (0,esm_extends/* default */.Z)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 20,
    fill: "none"
  }, props), pin_jsx("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M9 20C7.666 20 .818 13.533.818 8.182S4.482 0 9 0c4.518 0 8.182 2.83 8.182 8.182C17.182 13.532 10.335 20 9 20Zm0-7.273a4.545 4.545 0 1 0 0-9.09 4.545 4.545 0 0 0 0 9.09Z",
    clipRule: "evenodd"
  }));
};
/* harmony default export */ var pin = (Pin);
// EXTERNAL MODULE: ../shared/src/svg/share.js
var share = __webpack_require__(69547);
;// CONCATENATED MODULE: ../shared/src/svg/report-flag.js


var report_flag_excluded = ["color", "width", "height"];
var report_flag_jsx = react.createElement;

var ReportFlag = function ReportFlag(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#00ADEF' : _ref$color,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 24 : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 30 : _ref$height,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, report_flag_excluded);
  return report_flag_jsx("svg", (0,esm_extends/* default */.Z)({
    width: width,
    height: height,
    viewBox: "0 0 24 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), report_flag_jsx("path", {
    d: "M.6 1.2v27.6V1.2Zm22.8 3.228S13.2 7.2 13.2 3.6C13.2 0 3 3.6 3 3.6V18s10.2-3.6 10.2 0 10.2.888 10.2.888V4.428Z",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
/* harmony default export */ var report_flag = (ReportFlag);
// EXTERNAL MODULE: ../shared/src/svg/heart-outline.js
var heart_outline = __webpack_require__(46117);
// EXTERNAL MODULE: ../shared/src/constants/propertyFeatures.js
var propertyFeatures = __webpack_require__(3373);
;// CONCATENATED MODULE: ./src/utils/headerTitle/index.js




function headerTitle_ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function headerTitle_objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? headerTitle_ownKeys(Object(t), !0).forEach(function (r) {
      (0,defineProperty/* default */.Z)(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : headerTitle_ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}










var generateOfferTags = function generateOfferTags(_ref) {
  var rentBy = _ref.rentBy,
      bedType = _ref.bedType,
      bathroomType = _ref.bathroomType,
      numberOfBedrooms = _ref.numberOfBedrooms,
      numberOfBathrooms = _ref.numberOfBathrooms,
      hasElevator = _ref.hasElevator,
      propertyType = _ref.propertyType,
      maxGuests = _ref.maxGuests,
      area = _ref.area,
      t = _ref.t;
  var isRentByEntireProperty = rentBy === rentType/* RENT_TYPE.ENTIRE_PROPERTY */.u.ENTIRE_PROPERTY;
  var isRentByBed = rentBy === rentType/* RENT_TYPE.BED */.u.BED;
  var isApartment = propertyType === unitTypes/* PROPERTY_UNIT_TYPE.APARTMENT */.DV.APARTMENT;
  var isStudio = propertyType === unitTypes/* PROPERTY_UNIT_TYPE.STUDIO */.DV.STUDIO;
  var hasEnsuite = bathroomType === 'private_bathroom';
  var basePills = [].concat((0,toConsumableArray/* default */.Z)(maxGuests ? [pluralization('{{count}} person', 'Up to {{count}} people', maxGuests, t)] : []), (0,toConsumableArray/* default */.Z)(area ? ["".concat(area, " ").concat(t('sqm'))] : []), (0,toConsumableArray/* default */.Z)((isApartment || isStudio) && hasElevator ? [t('With elevator')] : []));

  if (isRentByEntireProperty) {
    return [isStudio ? "".concat(t((0,stringManipulation/* capitalizeFirstLetter */.fm)(propertyType))) : pluralization('{{count}} bedroom apartment', '{{count}} bedrooms apartment', numberOfBedrooms, t)].concat((0,toConsumableArray/* default */.Z)(numberOfBathrooms ? [pluralization('{{count}} bathroom', '{{count}} bathrooms', numberOfBathrooms, t)] : []), (0,toConsumableArray/* default */.Z)(basePills));
  }

  if (hasEnsuite) {
    return [t(isRentByBed ? translations/* BED_TYPE_TRANSLATIONS */.EE[bedType] : translations/* BEDROOM_TYPE_TRANSLATIONS */.Jh[bedType]), isStudio ? "".concat(t((0,stringManipulation/* capitalizeFirstLetter */.fm)(propertyType))) : pluralization('{{count}} bedroom apartment', '{{count}} bedrooms apartment', numberOfBedrooms, t)].concat((0,toConsumableArray/* default */.Z)(basePills));
  }

  return [t(isRentByBed ? translations/* BED_TYPE_TRANSLATIONS */.EE[bedType] : translations/* BEDROOM_TYPE_TRANSLATIONS */.Jh[bedType]), isStudio ? "".concat(t((0,stringManipulation/* capitalizeFirstLetter */.fm)(propertyType))) : pluralization('{{count}} bedroom apartment', '{{count}} bedrooms apartment', numberOfBedrooms, t)].concat((0,toConsumableArray/* default */.Z)(numberOfBathrooms ? [pluralization('{{count}} bathroom', '{{count}} bathrooms', numberOfBathrooms, t)] : []), (0,toConsumableArray/* default */.Z)(basePills));
};
var generateTitleData = function generateTitleData(offerAggregate) {
  var _offerAggregate$prope = offerAggregate.property_aggregate.property,
      _offerAggregate$prope2 = _offerAggregate$prope.lifecycle,
      rentByType = _offerAggregate$prope2.rent_by,
      features = _offerAggregate$prope2.features,
      _offerAggregate$prope3 = _offerAggregate$prope.typology,
      propertyAccommodationType = _offerAggregate$prope3.accommodation_type_code,
      propertyType = _offerAggregate$prope3.type_code,
      numberOfBedrooms = _offerAggregate$prope3.number_of_bedrooms,
      numberOfBathrooms = _offerAggregate$prope3.number_of_bathrooms,
      area = _offerAggregate$prope3.area,
      floors = _offerAggregate$prope.floors,
      _offerAggregate$accom = offerAggregate.accommodation_offer,
      maxGuests = _offerAggregate$accom.requisites.conditions.max_guests,
      _offerAggregate$accom2 = _offerAggregate$accom.property,
      unitType = _offerAggregate$accom2.unit_type,
      unitId = _offerAggregate$accom2.unit_id;
  var isResidence = propertyAccommodationType === accommodationType/* ACCOMMODATION_TYPE_CODE.RESIDENCE */.s.RESIDENCE;

  var _floors = (0,slicedToArray/* default */.Z)(floors, 1),
      units = _floors[0].units;

  var unit = (0,transformers/* findUnit */.u7)(units, unitId);
  var rentBy = isResidence ? getRentByTypeFromUnitType(unitType) : rentByType;
  var common = {
    maxGuests: maxGuests,
    propertyType: propertyType,
    area: area,
    rentBy: rentBy,
    hasElevator: features === null || features === void 0 ? void 0 : features.some(function (_ref2) {
      var Code = _ref2.Code,
          Exists = _ref2.Exists;
      return Code === propertyFeatures/* PROPERTY_FEATURES.ELEVATOR */.U.ELEVATOR && Exists;
    }),
    numberOfBedrooms: (0,transformers/* getNumberOfBedrooms */.Y)(floors, numberOfBedrooms),
    numberOfBathrooms: (0,transformers/* getNumberOfBathrooms */.XZ)(floors, numberOfBathrooms),
    bathroomType: (0,utils_unitTypes/* findBathroomType */.N8)(rentBy, units, unit === null || unit === void 0 ? void 0 : unit.subunits)
  };

  if (isRentByProperty(common.rentBy)) {
    return headerTitle_objectSpread(headerTitle_objectSpread({}, common), {}, {
      propertyAccommodationType: propertyAccommodationType,
      propertyType: propertyType
    });
  }

  if (isRentByBed(common.rentBy)) {
    return headerTitle_objectSpread(headerTitle_objectSpread({}, common), {}, {
      bedType: bedType(offerAggregate, common.rentBy)
    });
  }

  if (isRentByBedroom(common.rentBy)) {
    return headerTitle_objectSpread(headerTitle_objectSpread({}, common), {}, {
      bedType: bedType(offerAggregate, common.rentBy)
    });
  }
};

var isRentByProperty = function isRentByProperty(rentBy) {
  return rentBy === rentType/* RENT_TYPE.ENTIRE_PROPERTY */.u.ENTIRE_PROPERTY;
};

var isRentByBed = function isRentByBed(rentBy) {
  return rentBy === rentType/* RENT_TYPE.BED */.u.BED;
};

var isRentByBedroom = function isRentByBedroom(rentBy) {
  return rentBy === rentType/* RENT_TYPE.BEDROOM */.u.BEDROOM;
};

var bedType = function bedType(offerAggregate, rentBy) {
  var _offerAggregate$prope4 = (0,slicedToArray/* default */.Z)(offerAggregate.property_aggregate.property.floors, 1),
      units = _offerAggregate$prope4[0].units;

  var _offerAggregate$accom3 = offerAggregate.accommodation_offer.property,
      unitId = _offerAggregate$accom3.unit_id,
      subunitId = _offerAggregate$accom3.subunit_id;
  var unit = getRentingUnitOrSubunit(units, unitId, subunitId, rentBy);

  if (isRentByBed(rentBy)) {
    return unit.type_code;
  }

  if (isRentByBedroom(rentBy)) {
    var beds = unit.subunits.filter(function (subunit) {
      return isSubunitBed(subunit);
    });
    return getBedsType(beds);
  }
};

var getBedsType = function getBedsType(beds) {
  if (beds.length === 1) {
    return beds[0].type_code;
  }

  if (beds.length === 2) {
    return unitTypes/* SUBUNIT_TYPES.TWIN_BED */.vz.TWIN_BED;
  }

  return unitTypes/* SUBUNIT_TYPES.MULTIPLE_BED */.vz.MULTIPLE_BED;
};

var getRentingUnitOrSubunit = function getRentingUnitOrSubunit(units, unitId, subunitId, rentBy) {
  var unit = (0,transformers/* findUnit */.u7)(units, unitId);

  if (isRentByBedroom(rentBy)) {
    return unit;
  }

  if (isRentByBed(rentBy)) {
    return getSubunitFromUnitById(subunitId, unit);
  }
};

var isSubunitBed = function isSubunitBed(_ref3) {
  var subunitType = _ref3.type_code;
  return [unitTypes/* SUBUNIT_TYPES.SINGLE_BED */.vz.SINGLE_BED, unitTypes/* SUBUNIT_TYPES.DOUBLE_BED */.vz.DOUBLE_BED].includes(subunitType);
};

var getSubunitFromUnitById = function getSubunitFromUnitById(id, _ref4) {
  var subunits = _ref4.subunits;
  return !subunits.length ? null : subunits.find(function (_ref5) {
    var subunitId = _ref5.id;
    return id === subunitId;
  });
};

var getRentByTypeFromUnitType = function getRentByTypeFromUnitType(unitType) {
  if (!unitType || [unitTypes/* PROPERTY_UNIT_TYPE.APARTMENT */.DV.APARTMENT, unitTypes/* PROPERTY_UNIT_TYPE.STUDIO */.DV.STUDIO].includes(unitType)) {
    return rentType/* RENT_TYPE.ENTIRE_PROPERTY */.u.ENTIRE_PROPERTY;
  }

  if (unitType === unitTypes/* PROPERTY_UNIT_TYPE.BEDROOM */.DV.BEDROOM) {
    return rentType/* RENT_TYPE.BEDROOM */.u.BEDROOM;
  }

  if ([unitTypes/* PROPERTY_UNIT_TYPE.BED */.DV.BED, unitTypes/* SUBUNIT_TYPES.SINGLE_BED */.vz.SINGLE_BED, unitTypes/* SUBUNIT_TYPES.DOUBLE_BED */.vz.DOUBLE_BED].includes(unitType)) {
    return rentType/* RENT_TYPE.BED */.u.BED;
  }
};
;// CONCATENATED MODULE: ./src/components/HeaderTitle/Desktop/styles.js

var HeaderTitle_Desktop_styles_Wrapper = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1yx4bkn-0"
})(["display:flex;flex-direction:column;width:100%;gap:", ";"], function (props) {
  return props.theme.space(4);
});
var Desktop_styles_Title = /*#__PURE__*/styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
  componentId: "sc-1yx4bkn-1"
})(["font-family:'IntervalNextMed',sans-serif;font-size:", ";font-weight:600;color:", ";"], function (props) {
  return props.theme.rem(32);
}, function (props) {
  return props.theme.headerTitle.title.color;
});
var styles_Tags = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1yx4bkn-2"
})(["display:flex;align-items:center;", ";& > span{", ";color:", ";& > span{color:", ";}}"], function (_ref) {
  var theme = _ref.theme;
  return theme.gap(2);
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.gap(2);
}, function (props) {
  return props.theme.headerTitle.tags.color;
}, function (props) {
  return props.theme.headerTitle.tags.separatorColor;
});
var BottomLine = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1yx4bkn-3"
})(["display:flex;align-items:center;justify-content:space-between;width:100%;padding-right:", ";"], function (props) {
  return props.theme.space(2);
});
var Location = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1yx4bkn-4"
})(["display:flex;align-items:center;gap:", ";color:", ";"], function (props) {
  return props.theme.space(2);
}, function (props) {
  return props.theme.headerTitle.location.color;
});
var Actions = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1yx4bkn-5"
})(["display:flex;align-items:center;gap:", ";"], function (props) {
  return props.theme.space(8);
});
var Action = /*#__PURE__*/styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  componentId: "sc-1yx4bkn-6"
})(["display:flex;align-items:center;gap:", ";color:", ";font-family:'IntervalNextMed',sans-serif;font-size:", ";font-weight:500;line-height:", ";border-radius:8px;transition:opacity 0.5s ease-out;&:hover{cursor:pointer;text-decoration:underline;}", ";"], function (props) {
  return props.theme.space(2);
}, function (props) {
  return props.theme.headerTitle.actions.color;
}, function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.rem(18);
}, function (_ref3) {
  var isLoading = _ref3.isLoading;
  return isLoading && "\n      pointer-events: none;\n      opacity: 0.5;\n  ";
});
;// CONCATENATED MODULE: ./src/components/HeaderTitle/Desktop/index.js
var HeaderTitle_Desktop_jsx = react.createElement;
















var HeaderTitleDesktop = function HeaderTitleDesktop(_ref) {
  var _neighborhood$metadat;

  var offerId = _ref.offerId,
      accommodationOffer = _ref.accommodationOffer,
      neighborhood = _ref.neighborhood,
      city = _ref.city,
      titleTranslations = _ref.titleTranslations,
      cityTranslations = _ref.cityTranslations,
      rentBy = _ref.rentBy,
      bedType = _ref.bedType,
      bathroomType = _ref.bathroomType,
      numberOfBedrooms = _ref.numberOfBedrooms,
      numberOfBathrooms = _ref.numberOfBathrooms,
      hasElevator = _ref.hasElevator,
      propertyType = _ref.propertyType,
      maxGuests = _ref.maxGuests,
      area = _ref.area,
      street = _ref.street,
      isLoggedIn = _ref.isLoggedIn,
      isWishlistLoading = _ref.isWishlistLoading,
      isOnWishlist = _ref.isOnWishlist,
      showWishlistModal = _ref.showWishlistModal,
      showShareModal = _ref.showShareModal,
      showReportModal = _ref.showReportModal,
      addToWishlist = _ref.addToWishlist,
      removeFromWishlist = _ref.removeFromWishlist,
      trackReportListingOpenAction = _ref.trackReportListingOpenAction,
      trackAddToWishlistAction = _ref.trackAddToWishlistAction,
      trackShareLinkAction = _ref.trackShareLinkAction;

  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t,
      language = _useTranslation.i18n.language;

  var tags = generateOfferTags({
    rentBy: rentBy,
    bedType: bedType,
    bathroomType: bathroomType,
    numberOfBedrooms: numberOfBedrooms,
    numberOfBathrooms: numberOfBathrooms,
    hasElevator: hasElevator,
    propertyType: propertyType,
    maxGuests: maxGuests,
    area: area,
    t: t
  });

  var handleWishlistClick = function handleWishlistClick() {
    trackAddToWishlistAction(accommodationOffer, city, neighborhood, language);

    if (!isLoggedIn) {
      showWishlistModal();
      return;
    }

    isOnWishlist ? removeFromWishlist({
      offerId: offerId,
      city: city
    }) : addToWishlist({
      offerId: offerId,
      city: city
    });
  };

  var showReportListingModal = function showReportListingModal() {
    showReportModal();
    trackReportListingOpenAction();
  };

  var showShareListingModal = function showShareListingModal() {
    showShareModal();
    trackShareLinkAction();
  };

  return HeaderTitle_Desktop_jsx(HeaderTitle_Desktop_styles_Wrapper, null, HeaderTitle_Desktop_jsx(Desktop_styles_Title, null, (0,transformers/* translateFromLanguage */.JB)(titleTranslations, language)), HeaderTitle_Desktop_jsx(styles_Tags, null, tags.map(function (tag, i) {
    return HeaderTitle_Desktop_jsx("span", {
      key: tag
    }, tag, i !== tags.length - 1 && HeaderTitle_Desktop_jsx("span", null, "\u2022"));
  })), HeaderTitle_Desktop_jsx(BottomLine, null, HeaderTitle_Desktop_jsx(Location, null, HeaderTitle_Desktop_jsx(pin, null), [street, (0,transformers/* translateFromLanguage */.JB)(neighborhood === null || neighborhood === void 0 ? void 0 : (_neighborhood$metadat = neighborhood.metadata) === null || _neighborhood$metadat === void 0 ? void 0 : _neighborhood$metadat.name_translations, language), (0,transformers/* translateFromLanguage */.JB)(cityTranslations, language)].filter(function (item) {
    return item && item.trim();
  }).join(', ')), HeaderTitle_Desktop_jsx(Actions, null, HeaderTitle_Desktop_jsx(Action, {
    role: 'button',
    onClick: handleWishlistClick,
    isLoading: isWishlistLoading
  }, HeaderTitle_Desktop_jsx(heart_outline/* default */.Z, {
    color: src_theme/* theme.headerTitle.actions.color */.r.headerTitle.actions.color,
    strokeWidth: 1,
    filled: isOnWishlist
  }), ' ', t(isOnWishlist ? 'Saved' : 'Save')), HeaderTitle_Desktop_jsx(Action, {
    role: 'button',
    onClick: showShareListingModal
  }, HeaderTitle_Desktop_jsx(share/* default */.Z, {
    color: src_theme/* theme.headerTitle.actions.color */.r.headerTitle.actions.color
  }), " ", t('Share')), HeaderTitle_Desktop_jsx(Action, {
    role: 'button',
    onClick: showReportListingModal
  }, HeaderTitle_Desktop_jsx(report_flag, {
    color: src_theme/* theme.headerTitle.actions.color */.r.headerTitle.actions.color,
    width: 24,
    height: 24
  }), " ", t('Report')))));
};

var HeaderTitle_Desktop_mapStateToProps = function mapStateToProps(_ref2) {
  var _wishlist$cities;

  var offerAggregate = _ref2.offer.offerAggregate,
      _ref2$profile = _ref2.profile,
      isLoggedIn = _ref2$profile.isLoggedIn,
      wishlist = _ref2$profile.wish_list;
  var accommodationOffer = offerAggregate.accommodation_offer,
      _offerAggregate$globa = offerAggregate.globalization_aggregate.city,
      cityTranslations = _offerAggregate$globa.metadata.name_translations,
      city = _offerAggregate$globa.configuration.slug,
      _offerAggregate$prope = offerAggregate.property_aggregate,
      neighborhood = _offerAggregate$prope.neighborhood,
      street = _offerAggregate$prope.property.location.address.street;
  var offerId = accommodationOffer.id,
      titleTranslations = accommodationOffer.title;

  var _generateTitleData = generateTitleData(offerAggregate),
      rentBy = _generateTitleData.rentBy,
      bedType = _generateTitleData.bedType,
      bathroomType = _generateTitleData.bathroomType,
      numberOfBedrooms = _generateTitleData.numberOfBedrooms,
      numberOfBathrooms = _generateTitleData.numberOfBathrooms,
      hasElevator = _generateTitleData.hasElevator,
      propertyType = _generateTitleData.propertyType,
      maxGuests = _generateTitleData.maxGuests,
      area = _generateTitleData.area;

  var isOnWishlist = wishlist === null || wishlist === void 0 ? void 0 : (_wishlist$cities = wishlist.cities) === null || _wishlist$cities === void 0 ? void 0 : _wishlist$cities.items.some(function (_ref3) {
    var accommodation_offer_ids = _ref3.accommodation_offer_ids;
    return accommodation_offer_ids.includes(offerId);
  });
  return {
    offerId: offerId,
    accommodationOffer: accommodationOffer,
    neighborhood: neighborhood,
    city: city,
    titleTranslations: titleTranslations,
    cityTranslations: cityTranslations,
    rentBy: rentBy,
    bedType: bedType,
    bathroomType: bathroomType,
    numberOfBedrooms: numberOfBedrooms,
    numberOfBathrooms: numberOfBathrooms,
    hasElevator: hasElevator,
    propertyType: propertyType,
    maxGuests: maxGuests,
    area: area,
    isLoggedIn: isLoggedIn,
    isOnWishlist: isOnWishlist,
    isWishlistLoading: wishlist === null || wishlist === void 0 ? void 0 : wishlist.isLoading,
    street: street
  };
};

var HeaderTitle_Desktop_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    showWishlistModal: function showWishlistModal() {
      return dispatch((0,modal/* showModalAction */.bF)({
        modalId: modal_displayer.modalIds.WISHLIST
      }));
    },
    showShareModal: function showShareModal() {
      return dispatch((0,modal/* showModalAction */.bF)({
        modalId: modal_displayer.modalIds.SHARE
      }));
    },
    showReportModal: function showReportModal() {
      return dispatch((0,modal/* showModalAction */.bF)({
        modalId: modal_displayer.modalIds.REPORT_LISTING
      }));
    },
    addToWishlist: function addToWishlist(_ref4) {
      var offerId = _ref4.offerId,
          city = _ref4.city;
      return dispatch((0,profile/* addToWishlistAction */.$C)({
        offerId: offerId,
        city: city
      }));
    },
    removeFromWishlist: function removeFromWishlist(_ref5) {
      var offerId = _ref5.offerId,
          city = _ref5.city;
      return dispatch((0,profile/* removeFromWishlistAction */.b5)({
        offerId: offerId,
        city: city
      }));
    },
    trackReportListingOpenAction: function trackReportListingOpenAction() {
      return dispatch((0,actions_tracking/* trackReportListingOpen */.S0)());
    },
    trackAddToWishlistAction: function trackAddToWishlistAction(offer, citySlug, neighborhood, language) {
      return dispatch((0,actions_tracking/* trackAddToWishlist */.i2)({
        offer: offer,
        citySlug: citySlug,
        neighborhood: neighborhood,
        language: language
      }));
    },
    trackShareLinkAction: function trackShareLinkAction() {
      return dispatch((0,actions_tracking/* trackShareLink */.Yh)());
    }
  };
};

/* harmony default export */ var HeaderTitle_Desktop = ((0,es/* connect */.$j)(HeaderTitle_Desktop_mapStateToProps, HeaderTitle_Desktop_mapDispatchToProps)(HeaderTitleDesktop));
;// CONCATENATED MODULE: ./src/components/WhyRentWithUniplaces/styles.js


var WhyRentWithUniplaces_styles_templateObject, WhyRentWithUniplaces_styles_templateObject2, WhyRentWithUniplaces_styles_templateObject3;



var Heading = /*#__PURE__*/styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
  componentId: "sc-17zn0ul-0"
})(["font-family:'IntervalNextReg',sans-serif;font-size:", ";line-height:", ";font-weight:600;color:", ";margin-bottom:", ";"], function (props) {
  return props.theme.rem(22);
}, function (props) {
  return props.theme.rem(26);
}, function (props) {
  return props.theme.accordion.titleColor;
}, function (props) {
  return props.theme.space(6);
});
var WhyRentWithUniplaces_styles_Container = /*#__PURE__*/styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  componentId: "sc-17zn0ul-1"
})(["width:100%;"]);
var Rows = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-17zn0ul-2"
})(["display:flex;padding:", ";border:1px solid ", ";border-radius:", ";&:not(:last-of-type){margin-bottom:", ";", "}h3{font-family:'IntervalNextReg',sans-serif;font-size:", ";line-height:", ";font-weight:600;color:", ";}p{font-size:", ";line-height:", ";color:", ";}", ""], function (props) {
  return props.theme.space(5);
}, function (props) {
  return props.theme.whyRentWithUniplaces.borderColor;
}, function (props) {
  return props.theme.space(2);
}, function (props) {
  return props.theme.space(5);
}, theme/* mediaMin.mediumBreakpoint */.A3.mediumBreakpoint(WhyRentWithUniplaces_styles_templateObject || (WhyRentWithUniplaces_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n      margin-bottom: 0;\n    "]))), function (props) {
  return props.theme.rem(18);
}, function (props) {
  return props.theme.rem(20);
}, function (props) {
  return props.theme.whyRentWithUniplaces.titleColor;
}, function (props) {
  return props.theme.rem(16);
}, function (props) {
  return props.theme.rem(24);
}, function (props) {
  return props.theme.whyRentWithUniplaces.textColor;
}, theme/* mediaMin.mediumBreakpoint */.A3.mediumBreakpoint(WhyRentWithUniplaces_styles_templateObject2 || (WhyRentWithUniplaces_styles_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    width: 300px;\n    flex-shrink: 0;\n    flex-direction: column;\n    ", "\n    padding-left: ", ";\n  "])), function (_ref) {
  var theme = _ref.theme;
  return theme.gap(4);
}, function (props) {
  return props.theme.space(5);
}));
var WhyRentWithUniplaces_styles_Description = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-17zn0ul-3"
})(["display:flex;flex-direction:column;gap:", ";"], function (props) {
  return props.theme.space(2);
});
var ValueProposition = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-17zn0ul-4"
})(["width:100%;", ""], theme/* mediaMin.mediumBreakpoint */.A3.mediumBreakpoint(WhyRentWithUniplaces_styles_templateObject3 || (WhyRentWithUniplaces_styles_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n    display: flex;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    align-items: stretch;\n    ", "\n    overflow-x: scroll;\n    -ms-overflow-style: none;\n    scrollbar-width: none;\n\n    &::-webkit-scrollbar {\n      display: none;\n    }\n  "])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.gap(2);
}));
;// CONCATENATED MODULE: ../shared/src/svg/money-colored.js


var money_colored_excluded = ["fillWhite", "fillGreen", "fillBlack"];
var money_colored_jsx = react.createElement;

var MoneyColored = function MoneyColored(_ref) {
  var _ref$fillWhite = _ref.fillWhite,
    fillWhite = _ref$fillWhite === void 0 ? '#fff' : _ref$fillWhite,
    _ref$fillGreen = _ref.fillGreen,
    fillGreen = _ref$fillGreen === void 0 ? '#9BDFB8' : _ref$fillGreen,
    _ref$fillBlack = _ref.fillBlack,
    fillBlack = _ref$fillBlack === void 0 ? '#224251' : _ref$fillBlack,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, money_colored_excluded);
  return money_colored_jsx("svg", (0,esm_extends/* default */.Z)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 54,
    fill: "none",
    viewBox: "0 0 60 54"
  }, props), money_colored_jsx("path", {
    fill: fillWhite,
    d: "M57.423 1.77H6.12a.867.867 0 0 0-.981.857.86.86 0 0 0 .857.858h50.571v23.91h-1.714V6.056a.86.86 0 0 0-.857-.857H2.566a.86.86 0 0 0-.857.857V31.68a.86.86 0 0 0 .857.857H22.28v5.152c0 .214.082.42.223.578 1.127 1.235 3.613 1.938 6.99 1.972h.172c3.145 0 5.331-.827 6.415-1.483 1.32.844 3.523 1.333 6.245 1.359h.193c3.647 0 6.012-1.119 6.844-1.792a.859.859 0 0 0 .317-.621c.034-.66.03-1.86.026-2.915 0-.677-.005-1.302 0-1.697v-.553h4.29a.86.86 0 0 0 .857-.857V29.11h2.571a.86.86 0 0 0 .857-.857V2.627a.86.86 0 0 0-.857-.857Zm-54 5.143h49.715v20.482h-3.433c0-.442 0-.836.004-1.115v-1.71c0-.677-.004-1.298 0-1.693v-1.71c0-.677-.004-1.298 0-1.692v-.018c0-1.761-2.507-3.544-7.299-3.544-4.791 0-7.298 1.783-7.298 3.544v4.586c-1.222-.707-3.082-1.191-5.559-1.191-4.774 0-7.273 1.783-7.273 3.54v1.003H5.995a.86.86 0 0 0-.857.857.86.86 0 0 0 .857.857H22.28v1.714H3.423V6.913Zm43.616 23.91h-9.42a3.623 3.623 0 0 1-.75-.416c0-.227 0-.432.004-.595V29.109h.386c1.303.488 3.034.767 5.066.788h.193c2.061 0 3.702-.36 4.898-.788h.574c0 .467 0 .913-.012 1.273-.223.133-.54.287-.939.441Zm-22.534 0a3.539 3.539 0 0 1-.51-.313V29.11h.754c1.187.501 2.786.823 4.804.823 2.019 0 3.617-.322 4.805-.823h.754v1.423c-.154.09-.347.188-.579.291H24.505Zm-.51-4.431c0-.643 2.108-1.826 5.558-1.826 3.45 0 5.559 1.183 5.559 1.826 0 .278-.399.66-1.132 1.003h-8.85C24.398 27.052 24 26.67 24 26.392h-.004Zm12.878.613c0-.228 0-.433.005-.596a.89.89 0 0 0-.052-.304v-.575c1.337.6 3.236.939 5.499.96h.193c2.412 0 4.26-.488 5.477-1.015 0 .548 0 1.08-.013 1.495-.21.125-.506.27-.874.416h-9.545a3.463 3.463 0 0 1-.69-.39v.009Zm11.122-7.548c0 .643-2.122 1.826-5.585 1.826-3.462 0-5.584-1.183-5.584-1.826 0-.642 2.122-1.83 5.584-1.83 3.463 0 5.585 1.183 5.585 1.83Zm-5.585 3.54c2.49 0 4.359-.484 5.585-1.191 0 .643 0 1.281-.013 1.77-.802.471-2.722 1.243-5.64 1.204-2.97-.03-4.744-.613-5.516-1.208v-1.766c1.226.711 3.094 1.191 5.584 1.191Zm-7.298 14.34c-.814.472-2.722 1.222-5.602 1.188-2.974-.035-4.748-.613-5.515-1.209v-1.431c1.324.595 3.205.93 5.498.955h.172c2.391 0 4.225-.475 5.443-.994v1.496l.004-.005Zm0-3.402c-.814.471-2.722 1.221-5.602 1.187-2.974-.035-4.748-.613-5.515-1.209v-1.376h.141c1.316.558 3.137.87 5.357.896h.172c2.237 0 3.981-.42 5.194-.896h.249v1.398h.004Zm12.87 3.261c-.802.471-2.734 1.239-5.64 1.204-2.923-.03-4.684-.591-5.477-1.183.008-.424.008-.93.008-1.448 1.333.587 3.215.917 5.447.938h.193c2.413 0 4.26-.488 5.477-1.015 0 .548 0 1.08-.012 1.495l.004.009Zm0-3.403c-.802.472-2.734 1.234-5.64 1.204-2.914-.03-4.676-.591-5.469-1.178 0-.232 0-.442.005-.604v-.678h.45c1.294.476 3.004.746 5.001.763h.193c2.018 0 3.634-.343 4.826-.763h.651c0 .459 0 .9-.013 1.256h-.004Zm5.156-2.97h-3.433c0-.45 0-.853.004-1.136V29.11h3.433v1.714h-.004Z"
  }), money_colored_jsx("path", {
    fill: fillWhite,
    d: "M29.67 41.953h-.184c-2.739-.03-6.382-.493-8.242-2.529a2.576 2.576 0 0 1-.673-1.735v-3.437h-18A2.573 2.573 0 0 1 0 31.68V6.056a2.573 2.573 0 0 1 2.571-2.571h1.003A2.578 2.578 0 0 1 6.21.056h51.219A2.573 2.573 0 0 1 60 2.627v25.625a2.574 2.574 0 0 1-2.571 2.571h-.858v.857A2.573 2.573 0 0 1 54 34.252h-2.576v.497c0 1.11.009 2.331-.03 3.047a2.577 2.577 0 0 1-.951 1.864c-1.239 1.003-4.059 2.169-7.92 2.169h-.21c-2.529-.026-4.659-.416-6.236-1.136-1.226.566-3.356 1.26-6.403 1.26h-.004ZM5.139 8.627v17.199a2.59 2.59 0 0 1 .857-.146H20.63c.57-3.116 4.89-4.543 8.923-4.543 1.406 0 2.7.146 3.845.425v-2.105c0-3.613 4.671-5.258 9.012-5.258 4.342 0 8.94 1.62 9.013 5.173V19.582c-.008.407-.004.955 0 1.547v1.611V8.627H5.14ZM51.424 25.68V22.93c-.008.364-.004.96 0 1.603v1.148ZM40.72 19.457a12.25 12.25 0 0 0 1.697.112c.643 0 1.204-.043 1.697-.112a12.181 12.181 0 0 0-1.697-.115c-.643 0-1.205.043-1.697.115Z"
  }), money_colored_jsx("path", {
    fill: fillGreen,
    fillRule: "evenodd",
    d: "M5.996 28.252h51.429V2.628H5.996V2.61",
    clipRule: "evenodd"
  }), money_colored_jsx("path", {
    fill: fillBlack,
    d: "M57.424 29.109H5.996a.86.86 0 0 1-.857-.857.86.86 0 0 1 .857-.857h50.571V3.485H5.996a.86.86 0 0 1-.857-.858.867.867 0 0 1 .981-.857h51.304a.86.86 0 0 1 .858.857v25.625a.86.86 0 0 1-.858.857Z"
  }), money_colored_jsx("path", {
    fill: fillGreen,
    d: "M53.995 6.056H2.566V31.68h51.429V6.056Z"
  }), money_colored_jsx("path", {
    fill: fillBlack,
    d: "M53.997 32.537H2.568a.86.86 0 0 1-.857-.857V6.056a.86.86 0 0 1 .857-.857h51.429a.86.86 0 0 1 .857.857V31.68a.86.86 0 0 1-.857.857ZM3.425 30.823H53.14V6.913H3.424v23.91Z"
  }), money_colored_jsx("path", {
    fill: fillWhite,
    d: "M28.256 27.485a8.571 8.571 0 1 0 0-17.143 8.571 8.571 0 0 0 0 17.143Z"
  }), money_colored_jsx("path", {
    fill: fillWhite,
    fillRule: "evenodd",
    d: "M36.01 26.22c-4.693-3.296-8.97-3.248-12.858 0v11.323c3.956 2.743 8.242 2.721 12.858 0V26.22Z",
    clipRule: "evenodd"
  }), money_colored_jsx("path", {
    fill: fillWhite,
    fillRule: "evenodd",
    d: "M48.84 19.282c-4.693-3.292-8.97-3.249-12.858 0v17.893c3.956 2.738 8.242 2.72 12.858 0V19.282Z",
    clipRule: "evenodd"
  }), money_colored_jsx("path", {
    fill: fillBlack,
    d: "M49.71 19.466v-.009c0-1.761-2.507-3.544-7.299-3.544-4.791 0-7.298 1.783-7.298 3.544v4.586c-1.222-.707-3.082-1.191-5.559-1.191-4.774 0-7.273 1.782-7.273 3.54v11.297c0 .214.082.42.223.578 1.127 1.235 3.613 1.938 6.99 1.972h.172c3.145 0 5.331-.827 6.415-1.483 1.32.844 3.523 1.333 6.244 1.358h.193c3.648 0 6.013-1.118 6.845-1.79a.859.859 0 0 0 .317-.622c.034-.66.03-1.86.026-2.915 0-.677-.005-1.303 0-1.697V31.385c0-.678-.005-1.303 0-1.698V27.974c0-.678-.005-1.3 0-1.694v-1.71c0-.677-.005-1.298 0-1.693v-1.71c0-.677-.005-1.298 0-1.693v-.008h.004Zm-1.715 2.34c0 .643 0 1.281-.012 1.77-.802.471-2.722 1.243-5.64 1.204-2.97-.03-4.745-.613-5.516-1.208v-1.766c1.226.711 3.094 1.191 5.584 1.191 2.49 0 4.359-.484 5.584-1.191Zm-.012 8.576c-.802.471-2.735 1.234-5.64 1.204-2.915-.03-4.676-.591-5.469-1.179 0-.227 0-.433.004-.595v-.857c1.333.587 3.215.917 5.447.938h.193c2.413 0 4.26-.489 5.477-1.016 0 .549 0 1.08-.012 1.496v.009Zm0-3.403c-.802.471-2.735 1.23-5.64 1.204-2.915-.03-4.676-.591-5.469-1.178 0-.228 0-.433.004-.596a.892.892 0 0 0-.051-.304v-.575c1.337.6 3.236.939 5.498.96h.193c2.413 0 4.26-.488 5.477-1.015 0 .548 0 1.08-.012 1.495v.009Zm-12.87 2.691v.862c-.815.471-2.73 1.217-5.602 1.187-2.974-.035-4.748-.613-5.515-1.209v-1.766c1.221.708 3.081 1.192 5.558 1.192s4.337-.48 5.559-1.192v.93-.004Zm-11.117 3.527v-.72c1.324.596 3.205.93 5.498.956h.172c2.391 0 4.225-.476 5.447-.994v1.495c-.815.472-2.722 1.222-5.602 1.188-2.974-.035-4.748-.613-5.515-1.209v-.716Zm12.878.622c0-.232 0-.442.004-.605v-.857c1.333.587 3.215.918 5.447.939h.193c2.413 0 4.26-.489 5.477-1.016 0 .553 0 1.089-.012 1.505-.802.47-2.735 1.234-5.64 1.204-2.915-.03-4.676-.592-5.469-1.179v.009Zm5.537-16.192c3.463 0 5.584 1.183 5.584 1.83 0 .643-2.12 1.826-5.584 1.826-3.463 0-5.584-1.183-5.584-1.826s2.121-1.83 5.584-1.83Zm-12.857 6.939c3.45 0 5.559 1.183 5.559 1.826s-2.109 1.825-5.559 1.825-5.558-1.182-5.558-1.825 2.108-1.826 5.558-1.826Zm-.043 13.959c-2.974-.035-4.748-.613-5.515-1.21v-1.43c1.324.595 3.205.93 5.498.955h.172c2.391 0 4.225-.476 5.442-.994v1.496c-.814.471-2.721 1.221-5.601 1.187l.004-.005Zm18.472-1.33c-.802.472-2.735 1.24-5.64 1.205-2.923-.03-4.685-.591-5.478-1.183.01-.424.01-.93.01-1.448 1.332.587 3.213.917 5.446.938h.193c2.413 0 4.26-.488 5.477-1.015 0 .548 0 1.08-.013 1.495l.005.009Z"
  }));
};
/* harmony default export */ var money_colored = (MoneyColored);
;// CONCATENATED MODULE: ../shared/src/svg/files.js


var files_excluded = ["fillWhite", "fillGreen", "fillBlack"];
var files_jsx = react.createElement;

var Files = function Files(_ref) {
  var _ref$fillWhite = _ref.fillWhite,
    fillWhite = _ref$fillWhite === void 0 ? '#fff' : _ref$fillWhite,
    _ref$fillGreen = _ref.fillGreen,
    fillGreen = _ref$fillGreen === void 0 ? '#14AE5C' : _ref$fillGreen,
    _ref$fillBlack = _ref.fillBlack,
    fillBlack = _ref$fillBlack === void 0 ? '#224251' : _ref$fillBlack,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, files_excluded);
  return files_jsx("svg", (0,esm_extends/* default */.Z)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 60,
    viewBox: "0 0 48 60",
    fill: "none"
  }, props), files_jsx("path", {
    fill: fillWhite,
    d: "M40.799 3.6c0-.66-.54-1.2-1.2-1.2h-36c-.66 0-1.2.54-1.2 1.2v48c0 .66.54 1.2 1.2 1.2.66 0 1.2-.54 1.2-1.2V4.8h34.8c.66 0 1.2-.54 1.2-1.2Z"
  }), files_jsx("path", {
    fill: fillWhite,
    d: "M3.6 55.2A3.603 3.603 0 0 1 0 51.6v-48C0 1.614 1.614 0 3.6 0h36c1.986 0 3.6 1.614 3.6 3.6s-1.614 3.6-3.6 3.6H7.2v44.4c0 1.986-1.614 3.6-3.6 3.6Z"
  }), files_jsx("path", {
    fill: fillWhite,
    d: "M44.4 7.2h-36c-.66 0-1.2.54-1.2 1.2v48c0 .66.54 1.2 1.2 1.2h36c.66 0 1.2-.54 1.2-1.2v-48c0-.66-.54-1.2-1.2-1.2Zm-1.2 48H9.6V9.6h33.6v45.6Z"
  }), files_jsx("path", {
    fill: fillWhite,
    d: "M44.4 60h-36a3.603 3.603 0 0 1-3.6-3.6v-48c0-1.986 1.614-3.6 3.6-3.6h36c1.986 0 3.6 1.614 3.6 3.6v48c0 1.986-1.614 3.6-3.6 3.6ZM12 52.8h28.8V12H12v40.8Z"
  }), files_jsx("path", {
    fill: fillWhite,
    d: "M15.6 16.8h21.6c.66 0 1.2-.54 1.2-1.2 0-.66-.54-1.2-1.2-1.2H15.6c-.66 0-1.2.54-1.2 1.2 0 .66.54 1.2 1.2 1.2Z"
  }), files_jsx("path", {
    fill: fillWhite,
    d: "M37.2 19.2H15.6a3.603 3.603 0 0 1-3.6-3.6c0-1.986 1.614-3.6 3.6-3.6h21.6c1.986 0 3.6 1.614 3.6 3.6s-1.614 3.6-3.6 3.6ZM15.6 26.4h21.6c.66 0 1.2-.54 1.2-1.2 0-.66-.54-1.2-1.2-1.2H15.6c-.66 0-1.2.54-1.2 1.2 0 .66.54 1.2 1.2 1.2Z"
  }), files_jsx("path", {
    fill: fillWhite,
    d: "M37.2 28.8H15.6a3.603 3.603 0 0 1-3.6-3.6c0-1.986 1.614-3.6 3.6-3.6h21.6c1.986 0 3.6 1.614 3.6 3.6s-1.614 3.6-3.6 3.6ZM15.6 36h21.6c.66 0 1.2-.54 1.2-1.2 0-.66-.54-1.2-1.2-1.2H15.6c-.66 0-1.2.54-1.2 1.2 0 .66.54 1.2 1.2 1.2Z"
  }), files_jsx("path", {
    fill: fillWhite,
    d: "M37.2 38.4H15.6a3.603 3.603 0 0 1-3.6-3.6c0-1.986 1.614-3.6 3.6-3.6h21.6c1.986 0 3.6 1.614 3.6 3.6s-1.614 3.6-3.6 3.6ZM15.6 21.6h19.2c.66 0 1.2-.54 1.2-1.2 0-.66-.54-1.2-1.2-1.2H15.6c-.66 0-1.2.54-1.2 1.2 0 .66.54 1.2 1.2 1.2Z"
  }), files_jsx("path", {
    fill: fillWhite,
    d: "M34.8 24H15.6a3.603 3.603 0 0 1-3.6-3.6c0-1.986 1.614-3.6 3.6-3.6h19.2c1.986 0 3.6 1.614 3.6 3.6S36.786 24 34.8 24ZM37.198 48.001h-6c-.66 0-1.2.54-1.2 1.2 0 .66.54 1.2 1.2 1.2h6c.66 0 1.2-.54 1.2-1.2 0-.66-.54-1.2-1.2-1.2Z"
  }), files_jsx("path", {
    fill: fillWhite,
    d: "M37.2 52.8h-6a3.603 3.603 0 0 1-3.6-3.6c0-1.985 1.614-3.6 3.6-3.6h6c1.986 0 3.6 1.615 3.6 3.6 0 1.987-1.614 3.6-3.6 3.6ZM15.6 31.2h19.2c.66 0 1.2-.54 1.2-1.2 0-.66-.54-1.2-1.2-1.2H15.6c-.66 0-1.2.54-1.2 1.2 0 .66.54 1.2 1.2 1.2Z"
  }), files_jsx("path", {
    fill: fillWhite,
    d: "M34.8 33.6H15.6A3.603 3.603 0 0 1 12 30c0-1.986 1.614-3.6 3.6-3.6h19.2c1.986 0 3.6 1.614 3.6 3.6s-1.614 3.6-3.6 3.6ZM15.6 40.8h19.2c.66 0 1.2-.54 1.2-1.2 0-.66-.54-1.2-1.2-1.2H15.6c-.66 0-1.2.54-1.2 1.2 0 .66.54 1.2 1.2 1.2Z"
  }), files_jsx("path", {
    fill: fillWhite,
    d: "M34.8 43.2H15.6a3.603 3.603 0 0 1-3.6-3.6c0-1.986 1.614-3.6 3.6-3.6h19.2c1.986 0 3.6 1.614 3.6 3.6s-1.614 3.6-3.6 3.6Z"
  }), files_jsx("path", {
    fill: fillGreen,
    d: "M39.602 3.6h-36v48h36v-48Z"
  }), files_jsx("path", {
    fill: fillWhite,
    d: "M44.399 8.4h-36v48h36v-48Z"
  }), files_jsx("path", {
    fill: fillBlack,
    d: "M40.8 3.6c0-.66-.54-1.2-1.2-1.2h-36c-.66 0-1.2.54-1.2 1.2v48c0 .66.54 1.2 1.2 1.2.66 0 1.2-.54 1.2-1.2V4.8h34.8c.66 0 1.2-.54 1.2-1.2Z"
  }), files_jsx("path", {
    fill: fillBlack,
    d: "M44.4 7.2h-36c-.66 0-1.2.54-1.2 1.2v48c0 .66.54 1.2 1.2 1.2h36c.66 0 1.2-.54 1.2-1.2v-48c0-.66-.54-1.2-1.2-1.2Zm-1.2 48H9.6V9.6h33.6v45.6Z"
  }), files_jsx("path", {
    fill: fillBlack,
    d: "M15.6 16.8h21.6c.66 0 1.2-.54 1.2-1.2 0-.66-.54-1.2-1.2-1.2H15.6c-.66 0-1.2.54-1.2 1.2 0 .66.54 1.2 1.2 1.2ZM15.6 26.4h21.6c.66 0 1.2-.54 1.2-1.2 0-.66-.54-1.2-1.2-1.2H15.6c-.66 0-1.2.54-1.2 1.2 0 .66.54 1.2 1.2 1.2ZM15.6 36h21.6c.66 0 1.2-.54 1.2-1.2 0-.66-.54-1.2-1.2-1.2H15.6c-.66 0-1.2.54-1.2 1.2 0 .66.54 1.2 1.2 1.2ZM15.6 21.6h19.2c.66 0 1.2-.54 1.2-1.2 0-.66-.54-1.2-1.2-1.2H15.6c-.66 0-1.2.54-1.2 1.2 0 .66.54 1.2 1.2 1.2ZM37.201 48h-6c-.66 0-1.2.54-1.2 1.2 0 .66.54 1.2 1.2 1.2h6c.66 0 1.2-.54 1.2-1.2 0-.66-.54-1.2-1.2-1.2ZM15.6 31.2h19.2c.66 0 1.2-.54 1.2-1.2 0-.66-.54-1.2-1.2-1.2H15.6c-.66 0-1.2.54-1.2 1.2 0 .66.54 1.2 1.2 1.2ZM15.6 40.8h19.2c.66 0 1.2-.54 1.2-1.2 0-.66-.54-1.2-1.2-1.2H15.6c-.66 0-1.2.54-1.2 1.2 0 .66.54 1.2 1.2 1.2Z"
  }));
};
/* harmony default export */ var files = (Files);
;// CONCATENATED MODULE: ../shared/src/svg/train.js


var train_excluded = ["fillWhite", "fillGreen", "fillBlack"];
var train_jsx = react.createElement;

var Train = function Train(_ref) {
  var _ref$fillWhite = _ref.fillWhite,
    fillWhite = _ref$fillWhite === void 0 ? '#fff' : _ref$fillWhite,
    _ref$fillGreen = _ref.fillGreen,
    fillGreen = _ref$fillGreen === void 0 ? '#14AE5C' : _ref$fillGreen,
    _ref$fillBlack = _ref.fillBlack,
    fillBlack = _ref$fillBlack === void 0 ? '#224251' : _ref$fillBlack,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, train_excluded);
  return train_jsx("svg", (0,esm_extends/* default */.Z)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 60,
    viewBox: "0 0 45 60",
    fill: "none"
  }, props), train_jsx("path", {
    fill: fillWhite,
    fillRule: "evenodd",
    d: "M41.664 15.934V15a5.006 5.006 0 0 0-5.01-5.005H11.813A5.005 5.005 0 0 0 6.808 15v34.97a5.005 5.005 0 0 0 5.005 5.005h24.84c2.77 0 5.011-2.241 5.011-5.006V36.923",
    clipRule: "evenodd"
  }), train_jsx("path", {
    fill: fillGreen,
    fillRule: "evenodd",
    d: "M41.662 48.477H6.806v2.353a4.146 4.146 0 0 0 4.148 4.144h26.56a4.146 4.146 0 0 0 4.148-4.144v-2.353Z",
    clipRule: "evenodd"
  }), train_jsx("path", {
    fill: fillBlack,
    d: "M36.654 56H11.813a6.037 6.037 0 0 1-6.03-6.03V15a6.04 6.04 0 0 1 6.03-6.03h24.841c3.328 0 6.036 2.707 6.036 6.03v.933c0 .564-.462 1.026-1.026 1.026a1.029 1.029 0 0 1-1.025-1.026V15c0-2.195-1.79-3.98-3.985-3.98H11.813A3.983 3.983 0 0 0 7.833 15v34.97a3.983 3.983 0 0 0 3.98 3.979h24.841c2.2 0 3.985-1.785 3.985-3.98V36.923c0-.564.461-1.026 1.025-1.026.564 0 1.026.462 1.026 1.026V49.97c0 3.323-2.708 6.031-6.036 6.031Z"
  }), train_jsx("path", {
    fill: fillGreen,
    d: "M29.167 7.523a1.029 1.029 0 0 1-1.025-1.026V1.026c0-.564.461-1.026 1.025-1.026.564 0 1.026.462 1.026 1.026v5.471c0 .565-.462 1.026-1.026 1.026ZM19.3 7.523a1.029 1.029 0 0 1-1.026-1.026V1.026C18.274.462 18.736 0 19.3 0c.564 0 1.026.462 1.026 1.026v5.471c0 .565-.462 1.026-1.026 1.026Z"
  }), train_jsx("path", {
    fill: fillBlack,
    d: "M41.668 30.77a1.029 1.029 0 0 1-1.025-1.026V23.59c0-.564.461-1.026 1.025-1.026.564 0 1.026.462 1.026 1.026v6.154c0 .564-.462 1.025-1.026 1.025ZM36.73 43.508a1.029 1.029 0 0 1-1.025-1.026v-7.457c0-2.21-1.8-4.01-4.016-4.01H16.776c-2.21 0-4.01 1.8-4.01 4.01v7.457c0 .564-.461 1.026-1.025 1.026a1.029 1.029 0 0 1-1.026-1.026v-7.457a6.067 6.067 0 0 1 6.061-6.061H31.69c3.344 0 6.067 2.718 6.067 6.061v7.457c0 .564-.462 1.026-1.026 1.026ZM36.73 26.016a1.029 1.029 0 0 1-1.025-1.026v-4.959c0-2.21-1.8-4.01-4.016-4.01H16.776c-2.21 0-4.01 1.8-4.01 4.01v4.96c0 .563-.461 1.025-1.025 1.025a1.029 1.029 0 0 1-1.026-1.026v-4.959a6.067 6.067 0 0 1 6.061-6.061H31.69c3.344 0 6.067 2.718 6.067 6.061v4.96c0 .563-.462 1.025-1.026 1.025ZM41.668 49.503c-.323 0-32.333-.01-34.851 0a1.024 1.024 0 0 1-1.026-1.02c0-.565.456-1.026 1.02-1.032 2.524-.01 34.539 0 34.862 0 .564 0 1.026.462 1.026 1.026 0 .564-.462 1.026-1.026 1.026h-.005ZM31.668 2.051H16.807a1.029 1.029 0 0 1-1.026-1.025c0-.564.462-1.026 1.026-1.026h14.861c.565 0 1.026.462 1.026 1.026 0 .564-.462 1.025-1.026 1.025Z"
  }), train_jsx("path", {
    fill: fillBlack,
    fillRule: "evenodd",
    d: "M17.802 54.975h-3.497v2.25c0 .468.184.909.513 1.237a1.742 1.742 0 0 0 2.471 0c.328-.328.513-.77.513-1.236v-2.251Z",
    clipRule: "evenodd"
  }), train_jsx("path", {
    fill: fillBlack,
    d: "M16.054 60a2.755 2.755 0 0 1-1.96-.81 2.762 2.762 0 0 1-.815-1.964v-2.252c0-.564.462-1.025 1.026-1.025h3.497c.564 0 1.026.461 1.026 1.025v2.252c0 .738-.287 1.436-.815 1.959a2.768 2.768 0 0 1-1.96.815Zm-.723-4v1.226c0 .194.077.374.21.513a.74.74 0 0 0 1.02 0 .713.713 0 0 0 .21-.513V56h-1.446.006Z"
  }), train_jsx("path", {
    fill: fillBlack,
    fillRule: "evenodd",
    d: "M34.166 54.975H30.67v2.25c0 .468.18.909.508 1.237a1.754 1.754 0 0 0 2.477 0c.328-.328.512-.77.512-1.236v-2.251Z",
    clipRule: "evenodd"
  }), train_jsx("path", {
    fill: fillBlack,
    d: "M32.418 60a2.741 2.741 0 0 1-1.964-.815 2.736 2.736 0 0 1-.81-1.96v-2.25c0-.565.461-1.026 1.025-1.026h3.498c.564 0 1.025.461 1.025 1.025v2.252c0 .738-.287 1.436-.815 1.959a2.79 2.79 0 0 1-1.96.815Zm-.723-4v1.226c0 .194.072.38.205.513a.742.742 0 0 0 1.026 0 .713.713 0 0 0 .21-.513V56H31.69h.005Z"
  }), train_jsx("path", {
    fill: fillGreen,
    d: "M43.208 34.36h-3.077a1.029 1.029 0 0 1-1.026-1.026c0-.564.462-1.026 1.026-1.026h3.077c.564 0 1.026.462 1.026 1.026 0 .564-.462 1.025-1.026 1.025ZM1.028 49.61A1.028 1.028 0 0 1 .3 47.856l2.18-2.174c.4-.4 1.05-.4 1.45 0 .4.4.4 1.051 0 1.451l-2.179 2.174c-.2.2-.461.298-.723.298v.005ZM40.13 21.539c-.354 0-.697-.185-.887-.513a1.023 1.023 0 0 1 .374-1.4l2.662-1.539a1.027 1.027 0 0 1 1.4.375 1.023 1.023 0 0 1-.374 1.4L40.643 21.4a1.042 1.042 0 0 1-.513.139Z"
  }));
};
/* harmony default export */ var train = (Train);
;// CONCATENATED MODULE: ../shared/src/svg/certificate.js


var certificate_excluded = ["fillWhite", "fillBlack", "fillGreen"];
var certificate_jsx = react.createElement;

var Certificate = function Certificate(_ref) {
  var _ref$fillWhite = _ref.fillWhite,
    fillWhite = _ref$fillWhite === void 0 ? '#fff' : _ref$fillWhite,
    _ref$fillBlack = _ref.fillBlack,
    fillBlack = _ref$fillBlack === void 0 ? '#224251' : _ref$fillBlack,
    _ref$fillGreen = _ref.fillGreen,
    fillGreen = _ref$fillGreen === void 0 ? '#14AE5C' : _ref$fillGreen,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, certificate_excluded);
  return certificate_jsx("svg", (0,esm_extends/* default */.Z)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 60,
    viewBox: "0 0 49 60",
    fill: "none"
  }, props), certificate_jsx("path", {
    fill: fillWhite,
    d: "M44.897 27.234c.788-.837 1.24-2 1.24-3.197s-.452-2.364-1.24-3.196a.194.194 0 0 1-.039-.212c.495-1.038.563-2.287.193-3.427-.37-1.139-1.163-2.105-2.163-2.653a.191.191 0 0 1-.101-.192c.149-1.14-.168-2.35-.875-3.316-.702-.971-1.754-1.644-2.88-1.856a.19.19 0 0 1-.153-.149c-.211-1.13-.89-2.182-1.855-2.884-.966-.701-2.178-1.023-3.312-.874a.187.187 0 0 1-.192-.097C32.967 4.172 32 3.384 30.862 3.014c-1.14-.37-2.384-.298-3.422.192a.207.207 0 0 1-.217-.029c-.836-.788-2-1.24-3.196-1.24-1.197 0-2.36.452-3.196 1.24a.199.199 0 0 1-.217.034c-1.038-.49-2.283-.563-3.422-.193-1.139.37-2.105 1.164-2.653 2.163a.191.191 0 0 1-.192.101c-1.144-.149-2.35.173-3.317.875-.966.702-1.644 1.755-1.855 2.88a.19.19 0 0 1-.15.153c-1.129.212-2.181.89-2.883 1.855-.702.966-1.024 2.178-.875 3.312a.199.199 0 0 1-.096.197c-1.01.548-1.802 1.519-2.172 2.658-.37 1.14-.298 2.384.192 3.418a.207.207 0 0 1-.029.216c-.788.836-1.24 2-1.24 3.196 0 1.197.452 2.36 1.24 3.196a.194.194 0 0 1 .038.212c-.49 1.038-.562 2.288-.192 3.427.37 1.14 1.163 2.105 2.163 2.653.072.039.11.115.101.192-.149 1.14.168 2.35.875 3.317.702.966 1.754 1.644 2.879 1.855a.19.19 0 0 1 .154.15c.11.586.35 1.153.687 1.662L3.72 51.357a.955.955 0 0 0 .057 1.048.956.956 0 0 0 .98.37l6.129-1.331 1.913 5.974c.115.361.433.62.812.664.034 0 .068.005.101.005a.963.963 0 0 0 .832-.481l7.012-12.146c.731.447 1.591.692 2.476.692a4.8 4.8 0 0 0 2.475-.692L33.52 57.6c.173.298.49.48.831.48.034 0 .068 0 .101-.004a.958.958 0 0 0 .813-.663l1.913-5.975 6.128 1.332a.965.965 0 0 0 .98-.37.964.964 0 0 0 .058-1.048l-6.147-10.647c.336-.51.576-1.072.687-1.658a.19.19 0 0 1 .149-.154c1.13-.211 2.182-.889 2.884-1.855s1.024-2.177.875-3.312a.187.187 0 0 1 .096-.192c1.01-.553 1.797-1.519 2.168-2.658.37-1.14.297-2.384-.193-3.422a.207.207 0 0 1 .029-.216l.005-.005ZM13.962 54.756l-1.514-4.74a.962.962 0 0 0-1.12-.644l-4.86 1.058 4.817-8.344c.923.586 2.024.846 3.062.711a.191.191 0 0 1 .192.096c.548 1.01 1.519 1.798 2.658 2.168.735.24 1.524.293 2.264.168l-5.499 9.527ZM41.59 50.43l-4.86-1.058a.958.958 0 0 0-1.12.645l-1.513 4.739-5.499-9.527a4.797 4.797 0 0 0 2.269-.163c1.139-.37 2.105-1.159 2.653-2.163a.191.191 0 0 1 .192-.101c1.048.135 2.144-.125 3.067-.711l4.816 8.339h-.005Zm1.908-24.513a2.11 2.11 0 0 0-.37 2.35c.279.591.317 1.341.101 2.01-.216.667-.687 1.249-1.269 1.566a2.117 2.117 0 0 0-1.077 2.12c.082.649-.11 1.374-.524 1.942-.413.567-1.043.975-1.687 1.1a2.105 2.105 0 0 0-1.677 1.683c-.12.644-.534 1.273-1.096 1.682-.567.413-1.293.605-1.947.524a2.125 2.125 0 0 0-2.12 1.081c-.312.572-.898 1.048-1.561 1.264-.668.217-1.418.178-2.014-.105a2.125 2.125 0 0 0-2.35.374c-.477.447-1.178.717-1.88.717s-1.404-.27-1.884-.721a2.116 2.116 0 0 0-2.35-.37c-.592.278-1.341.317-2.005.1-.668-.216-1.25-.687-1.567-1.268a2.121 2.121 0 0 0-2.12-1.077c-.648.086-1.374-.11-1.941-.524-.567-.413-.976-1.043-1.101-1.692a2.1 2.1 0 0 0-1.682-1.677c-.644-.12-1.274-.529-1.683-1.096-.413-.567-.605-1.293-.523-1.947a2.11 2.11 0 0 0-1.082-2.115c-.572-.312-1.043-.899-1.26-1.562-.215-.668-.177-1.418.107-2.014a2.116 2.116 0 0 0-.375-2.35c-.447-.476-.717-1.178-.717-1.88 0-.701.27-1.403.721-1.884a2.12 2.12 0 0 0 .37-2.35c-.278-.591-.317-1.341-.1-2.01.216-.667.687-1.249 1.269-1.566a2.117 2.117 0 0 0 1.076-2.12c-.082-.649.11-1.374.524-1.941.413-.568 1.043-.976 1.687-1.101a2.112 2.112 0 0 0 1.678-1.683c.12-.644.528-1.273 1.095-1.682.568-.413 1.289-.605 1.947-.524a2.11 2.11 0 0 0 2.12-1.081c.312-.572.899-1.043 1.562-1.26.663-.216 1.418-.177 2.004.101h.005c.788.37 1.706.226 2.35-.374.476-.447 1.178-.717 1.88-.717s1.403.27 1.884.721a2.12 2.12 0 0 0 2.35.37c.592-.278 1.341-.317 2.01-.1.668.216 1.25.687 1.566 1.268a2.114 2.114 0 0 0 2.12 1.077c.649-.082 1.375.11 1.942.524.567.413.976 1.043 1.1 1.687a2.111 2.111 0 0 0 1.683 1.678c.644.12 1.274.528 1.682 1.096.413.567.606 1.292.524 1.946a2.11 2.11 0 0 0 1.081 2.115c.573.312 1.048.899 1.265 1.562.216.668.178 1.418-.106 2.014a2.116 2.116 0 0 0 .375 2.35c.447.476.716 1.178.716 1.88s-.27 1.403-.721 1.88l-.005.009Z"
  }), certificate_jsx("path", {
    fill: fillWhite,
    d: "M34.343 60a2.893 2.893 0 0 1-2.495-1.442l-6.176-10.695a6.813 6.813 0 0 1-3.293 0l-6.176 10.695a2.892 2.892 0 0 1-2.793 1.427 2.894 2.894 0 0 1-2.451-1.99l-1.38-4.311-4.422.961a2.899 2.899 0 0 1-2.941-1.115 2.883 2.883 0 0 1-.168-3.143l5.618-9.734-.072-.182a6.726 6.726 0 0 1-3.009-2.312 6.704 6.704 0 0 1-1.269-3.571 6.692 6.692 0 0 1-2.245-6.917A6.719 6.719 0 0 1 0 24.032c0-1.302.385-2.57 1.072-3.633a6.753 6.753 0 0 1 .1-3.793 6.659 6.659 0 0 1 2.144-3.124A6.693 6.693 0 0 1 7.59 7.594a6.752 6.752 0 0 1 2.312-3.009 6.703 6.703 0 0 1 3.572-1.269 6.692 6.692 0 0 1 6.917-2.245 6.703 6.703 0 0 1 7.272 0 6.751 6.751 0 0 1 3.792.102 6.66 6.66 0 0 1 3.124 2.143 6.664 6.664 0 0 1 3.571 1.27 6.755 6.755 0 0 1 2.312 3.003 6.753 6.753 0 0 1 3.01 2.312 6.703 6.703 0 0 1 1.268 3.572 6.692 6.692 0 0 1 2.245 6.917 6.719 6.719 0 0 1 1.072 3.638 6.715 6.715 0 0 1-1.072 3.633 6.753 6.753 0 0 1-.101 3.793 6.695 6.695 0 0 1-2.144 3.124 6.708 6.708 0 0 1-1.269 3.576 6.756 6.756 0 0 1-3.004 2.312c-.024.063-.048.13-.077.192l5.614 9.724a2.883 2.883 0 0 1-3.105 4.263l-4.427-.961-1.38 4.311a2.887 2.887 0 0 1-2.436 1.99c-.11.01-.212.015-.308.015h-.005ZM11.526 47.426a2.87 2.87 0 0 1 2.745 2.004l.192.6 1.865-3.229a6.668 6.668 0 0 1-2.855-2.052 6.494 6.494 0 0 1-1.385-.221l-1.788 3.1.616-.135c.197-.043.408-.067.615-.067h-.005Zm20.187-.625 1.865 3.23.192-.6a2.869 2.869 0 0 1 3.365-1.938l.61.135-1.787-3.1a6.404 6.404 0 0 1-1.38.22 6.669 6.669 0 0 1-2.865 2.053Zm-11.016-5.792c1.024 0 2 .385 2.754 1.086.11.106.327.207.572.207.245 0 .457-.096.558-.192a4.028 4.028 0 0 1 4.48-.721.9.9 0 0 0 1.077-.336 4.02 4.02 0 0 1 4.041-2.067.875.875 0 0 0 .582-.173c.187-.135.312-.346.336-.481a4.027 4.027 0 0 1 3.206-3.216.893.893 0 0 0 .5-.34c.14-.188.192-.429.173-.563a4.04 4.04 0 0 1 2.052-4.052.9.9 0 0 0 .37-.48.902.902 0 0 0-.01-.592 4.031 4.031 0 0 1 .703-4.484l.01-.01a.867.867 0 0 0 .196-.563c0-.245-.096-.456-.192-.557a4.027 4.027 0 0 1-.721-4.48.905.905 0 0 0 .02-.605c-.073-.221-.232-.404-.356-.471a4.033 4.033 0 0 1-2.072-4.038.895.895 0 0 0-.168-.581c-.14-.188-.346-.313-.48-.337a4.022 4.022 0 0 1-3.217-3.201.864.864 0 0 0-.34-.5c-.188-.134-.424-.192-.563-.173a4.025 4.025 0 0 1-4.047-2.052.881.881 0 0 0-.48-.37c-.222-.072-.467-.048-.592.01a4.032 4.032 0 0 1-4.484-.703.892.892 0 0 0-.573-.206c-.245 0-.456.096-.557.192a4.031 4.031 0 0 1-4.403.755l-.144-.068a.897.897 0 0 0-.538.015c-.221.072-.404.23-.471.356a4.031 4.031 0 0 1-4.047 2.071.89.89 0 0 0-.577.168.9.9 0 0 0-.341.481 4.033 4.033 0 0 1-3.202 3.22.879.879 0 0 0-.5.342c-.139.187-.192.427-.173.562a4.024 4.024 0 0 1-2.052 4.047.857.857 0 0 0-.37.48c-.072.222-.048.467.01.592a4.031 4.031 0 0 1-.702 4.484.892.892 0 0 0-.207.572c0 .245.096.457.192.558a4.023 4.023 0 0 1 .717 4.484.864.864 0 0 0-.015.601c.072.221.23.404.356.471a4.033 4.033 0 0 1 2.071 4.038.895.895 0 0 0 .169.581c.14.188.346.313.48.337a4.022 4.022 0 0 1 3.216 3.2.878.878 0 0 0 .341.5c.188.14.423.188.563.174a4.035 4.035 0 0 1 4.051 2.052.9.9 0 0 0 .481.37.886.886 0 0 0 .587-.01 4.04 4.04 0 0 1 1.73-.389v.005Z"
  }), certificate_jsx("path", {
    fill: fillWhite,
    d: "M24.028 6.734c-9.54 0-17.303 7.762-17.303 17.303s7.762 17.304 17.303 17.304 17.303-7.763 17.303-17.304c0-9.54-7.762-17.303-17.303-17.303Zm0 32.684c-8.479 0-15.38-6.897-15.38-15.38 0-8.484 6.901-15.382 15.38-15.382 8.479 0 15.38 6.898 15.38 15.381 0 8.484-6.901 15.381-15.38 15.381Z"
  }), certificate_jsx("path", {
    fill: fillWhite,
    d: "M24.028 43.263c-10.603 0-19.226-8.623-19.226-19.226S13.425 4.811 24.028 4.811s19.226 8.623 19.226 19.226-8.623 19.226-19.226 19.226Zm0-32.684c-7.421 0-13.458 6.037-13.458 13.458s6.037 13.458 13.458 13.458 13.458-6.037 13.458-13.458S31.449 10.58 24.028 10.58Z"
  }), certificate_jsx("path", {
    fill: fillWhite,
    fillRule: "evenodd",
    d: "m7.354 51.218-2.807.61 9.613-16.65 9.161 5.288-.875 1.51-7.32-4.226-7.772 13.468Z",
    clipRule: "evenodd"
  }), certificate_jsx("path", {
    fill: fillGreen,
    fillRule: "evenodd",
    d: "m22.448 41.975-8.738 15.14-2.178-6.805-4.177.908 7.773-13.468 7.32 4.225Z",
    clipRule: "evenodd"
  }), certificate_jsx("path", {
    fill: fillWhite,
    fillRule: "evenodd",
    d: "m36.15 39.086-7.262 4.192 6.364 11.021-.904 2.817-9.613-16.65 9.162-5.287 2.254 3.907Z",
    clipRule: "evenodd"
  }), certificate_jsx("path", {
    fill: fillGreen,
    fillRule: "evenodd",
    d: "m36.15 39.087 7.358 12.742-6.984-1.519-1.273 3.99-6.364-11.022 7.262-4.191Z",
    clipRule: "evenodd"
  }), certificate_jsx("path", {
    fill: fillWhite,
    fillRule: "evenodd",
    d: "M20.212 4.071c.428.197.933.12 1.279-.207.615-.581 1.533-.975 2.538-.975 1.004 0 1.922.394 2.537.975.346.327.856.404 1.284.207.764-.365 1.759-.461 2.715-.149.957.312 1.702.971 2.11 1.716.231.413.688.649 1.154.586.841-.105 1.817.11 2.63.702.811.591 1.32 1.452 1.48 2.283.086.466.451.827.918.918.831.159 1.691.664 2.283 1.476.59.812.807 1.788.697 2.629-.058.471.177.928.59 1.158.746.404 1.404 1.154 1.717 2.11.307.957.216 1.952-.15 2.716a1.16 1.16 0 0 0 .203 1.284c.586.615.98 1.533.98 2.537 0 1.005-.394 1.918-.98 2.538-.322.346-.404.85-.202 1.279.365.769.456 1.764.149 2.715-.313.957-.971 1.707-1.716 2.11-.413.231-.65.688-.591 1.159.11.84-.106 1.817-.697 2.629-.592.812-1.452 1.322-2.283 1.476a1.16 1.16 0 0 0-.919.918c-.158.836-.668 1.696-1.48 2.283-.812.59-1.788.807-2.629.701a1.159 1.159 0 0 0-1.154.587 3.721 3.721 0 0 1-2.11 1.716c-.956.312-1.951.216-2.715-.145a1.16 1.16 0 0 0-1.284.202c-.615.582-1.533.98-2.537.98-1.005 0-1.923-.398-2.538-.98a1.153 1.153 0 0 0-1.279-.201c-.769.36-1.764.456-2.72.144-.952-.308-1.702-.971-2.11-1.716a1.155 1.155 0 0 0-1.154-.587c-.841.106-1.817-.11-2.63-.701-.811-.587-1.32-1.447-1.475-2.283a1.172 1.172 0 0 0-.918-.918c-.836-.154-1.696-.664-2.288-1.476-.586-.812-.807-1.788-.697-2.63a1.158 1.158 0 0 0-.59-1.158c-.741-.403-1.404-1.153-1.717-2.11-.307-.951-.216-1.946.15-2.715.201-.428.12-.933-.203-1.279a3.744 3.744 0 0 1-.98-2.538c0-1.004.399-1.922.98-2.537a1.16 1.16 0 0 0 .202-1.284c-.365-.764-.456-1.759-.149-2.716.313-.956.976-1.706 1.716-2.11.418-.23.65-.687.591-1.158-.11-.841.11-1.817.697-2.63a3.744 3.744 0 0 1 2.288-1.475c.462-.091.827-.452.913-.918.16-.831.669-1.692 1.48-2.283.813-.591 1.789-.807 2.63-.697.466.058.928-.178 1.154-.591.408-.745 1.158-1.404 2.11-1.716.956-.312 1.951-.216 2.72.15Z",
    clipRule: "evenodd"
  }), certificate_jsx("path", {
    fill: fillGreen,
    fillRule: "evenodd",
    d: "M23.273 14.934a.828.828 0 0 1 .736-.457c.307 0 .6.178.74.457.72 1.451 1.778 3.566 2.206 4.422.12.24.35.403.615.447.947.139 3.288.495 4.888.735.308.043.563.26.659.558a.823.823 0 0 1-.202.84c-1.154 1.14-2.84 2.798-3.523 3.471a.82.82 0 0 0-.236.721c.159.947.548 3.278.813 4.874a.835.835 0 0 1-.327.803.827.827 0 0 1-.866.062l-4.388-2.278a.835.835 0 0 0-.754 0c-.856.442-2.952 1.533-4.389 2.278a.827.827 0 0 1-.865-.063.826.826 0 0 1-.327-.802c.265-1.596.654-3.927.813-4.874a.82.82 0 0 0-.236-.72c-.682-.674-2.37-2.332-3.523-3.471a.823.823 0 0 1-.202-.841.811.811 0 0 1 .658-.558c1.601-.24 3.942-.596 4.889-.735a.836.836 0 0 0 .615-.447c.428-.856 1.485-2.97 2.206-4.422Z",
    clipRule: "evenodd"
  }), certificate_jsx("path", {
    fill: fillBlack,
    d: "M44.897 27.234c.788-.837 1.24-2 1.24-3.197s-.452-2.364-1.24-3.196a.194.194 0 0 1-.039-.212c.495-1.038.563-2.287.193-3.427-.37-1.139-1.163-2.105-2.163-2.653a.191.191 0 0 1-.101-.192c.149-1.14-.168-2.35-.875-3.316-.702-.971-1.754-1.644-2.88-1.856a.19.19 0 0 1-.153-.149c-.211-1.13-.89-2.182-1.855-2.884-.966-.701-2.178-1.023-3.312-.874a.187.187 0 0 1-.192-.097C32.967 4.172 32 3.384 30.862 3.014c-1.14-.37-2.384-.298-3.422.192a.207.207 0 0 1-.217-.029c-.836-.788-2-1.24-3.196-1.24-1.197 0-2.36.452-3.196 1.24a.199.199 0 0 1-.217.034c-1.038-.49-2.283-.563-3.422-.193-1.139.37-2.105 1.164-2.653 2.163a.191.191 0 0 1-.192.101c-1.144-.149-2.35.173-3.317.875-.966.702-1.644 1.755-1.855 2.88a.19.19 0 0 1-.15.153c-1.129.212-2.181.89-2.883 1.855-.702.966-1.024 2.178-.875 3.312a.199.199 0 0 1-.096.197c-1.01.548-1.802 1.519-2.172 2.658-.37 1.14-.298 2.384.192 3.418a.207.207 0 0 1-.029.216c-.788.836-1.24 2-1.24 3.196 0 1.197.452 2.36 1.24 3.196a.194.194 0 0 1 .038.212c-.49 1.038-.562 2.288-.192 3.427.37 1.14 1.163 2.105 2.163 2.653.072.039.11.115.101.192-.149 1.14.168 2.35.875 3.317.702.966 1.754 1.644 2.879 1.855a.19.19 0 0 1 .154.15c.11.586.35 1.153.687 1.662L3.72 51.357a.955.955 0 0 0 .057 1.048.956.956 0 0 0 .98.37l6.129-1.331 1.913 5.974c.115.361.433.62.812.664.034 0 .068.005.101.005a.963.963 0 0 0 .832-.481l7.012-12.146c.731.447 1.591.692 2.476.692a4.8 4.8 0 0 0 2.475-.692L33.52 57.6c.173.298.49.48.831.48.034 0 .068 0 .101-.004a.958.958 0 0 0 .813-.663l1.913-5.975 6.128 1.332a.965.965 0 0 0 .98-.37.964.964 0 0 0 .058-1.048l-6.147-10.647c.336-.51.576-1.072.687-1.658a.19.19 0 0 1 .149-.154c1.13-.211 2.182-.889 2.884-1.855s1.024-2.177.875-3.312a.187.187 0 0 1 .096-.192c1.01-.553 1.797-1.519 2.168-2.658.37-1.14.297-2.384-.193-3.422a.207.207 0 0 1 .029-.216l.005-.005ZM13.962 54.756l-1.514-4.74a.962.962 0 0 0-1.12-.644l-4.86 1.058 4.817-8.344c.923.586 2.024.846 3.062.711a.191.191 0 0 1 .192.096c.548 1.01 1.519 1.798 2.658 2.168.735.24 1.524.293 2.264.168l-5.499 9.527ZM41.59 50.43l-4.86-1.058a.958.958 0 0 0-1.12.645l-1.513 4.739-5.499-9.527a4.797 4.797 0 0 0 2.269-.163c1.139-.37 2.105-1.159 2.653-2.163a.191.191 0 0 1 .192-.101c1.048.135 2.144-.125 3.067-.711l4.816 8.339h-.005Zm1.908-24.513a2.11 2.11 0 0 0-.37 2.35c.279.591.317 1.341.101 2.01-.216.667-.687 1.249-1.269 1.566a2.117 2.117 0 0 0-1.077 2.12c.082.649-.11 1.374-.524 1.942-.413.567-1.043.975-1.687 1.1a2.105 2.105 0 0 0-1.677 1.683c-.12.644-.534 1.273-1.096 1.682-.567.413-1.293.605-1.947.524a2.125 2.125 0 0 0-2.12 1.081c-.312.572-.898 1.048-1.561 1.264-.668.217-1.418.178-2.014-.105a2.125 2.125 0 0 0-2.35.374c-.477.447-1.178.717-1.88.717s-1.404-.27-1.884-.721a2.116 2.116 0 0 0-2.35-.37c-.592.278-1.341.317-2.005.1-.668-.216-1.25-.687-1.567-1.268a2.121 2.121 0 0 0-2.12-1.077c-.648.086-1.374-.11-1.941-.524-.567-.413-.976-1.043-1.101-1.692a2.1 2.1 0 0 0-1.682-1.677c-.644-.12-1.274-.529-1.683-1.096-.413-.567-.605-1.293-.523-1.947a2.11 2.11 0 0 0-1.082-2.115c-.572-.312-1.043-.899-1.26-1.562-.215-.668-.177-1.418.107-2.014a2.116 2.116 0 0 0-.375-2.35c-.447-.476-.717-1.178-.717-1.88 0-.701.27-1.403.721-1.884a2.12 2.12 0 0 0 .37-2.35c-.278-.591-.317-1.341-.1-2.01.216-.667.687-1.249 1.269-1.566a2.117 2.117 0 0 0 1.076-2.12c-.082-.649.11-1.374.524-1.941.413-.568 1.043-.976 1.687-1.101a2.112 2.112 0 0 0 1.678-1.683c.12-.644.528-1.273 1.095-1.682.568-.413 1.289-.605 1.947-.524a2.11 2.11 0 0 0 2.12-1.081c.312-.572.899-1.043 1.562-1.26.663-.216 1.418-.177 2.004.101h.005c.788.37 1.706.226 2.35-.374.476-.447 1.178-.717 1.88-.717s1.403.27 1.884.721a2.12 2.12 0 0 0 2.35.37c.592-.278 1.341-.317 2.01-.1.668.216 1.25.687 1.566 1.268a2.114 2.114 0 0 0 2.12 1.077c.649-.082 1.375.11 1.942.524.567.413.976 1.043 1.1 1.687a2.111 2.111 0 0 0 1.683 1.678c.644.12 1.274.528 1.682 1.096.413.567.606 1.292.524 1.946a2.11 2.11 0 0 0 1.081 2.115c.573.312 1.048.899 1.265 1.562.216.668.178 1.418-.106 2.014a2.116 2.116 0 0 0 .375 2.35c.447.476.716 1.178.716 1.88s-.27 1.403-.721 1.88l-.005.009Z"
  }), certificate_jsx("path", {
    fill: fillBlack,
    d: "M24.027 6.734c-9.54 0-17.303 7.762-17.303 17.303s7.762 17.304 17.303 17.304S41.33 33.578 41.33 24.037c0-9.54-7.762-17.303-17.303-17.303Zm0 32.684c-8.479 0-15.38-6.897-15.38-15.38 0-8.484 6.901-15.382 15.38-15.382 8.479 0 15.38 6.898 15.38 15.381 0 8.484-6.901 15.381-15.38 15.381Z"
  }));
};
/* harmony default export */ var certificate = (Certificate);
;// CONCATENATED MODULE: ../shared/src/constants/valuePropositionItems.js




var valuePropositionItems = [{
  title: 'No guarantor, no bureaucracies',
  description: 'Say goodbye to guarantors, income proofs, and endless calls. Book your stay online effortlessly with Uniplaces from anywhere in the world.',
  icon: files
}, {
  title: 'Safe arrival',
  description: 'If your property isn’t as listed, report it within 24 hours of your move-in. We’ll freeze your payment and help resolve the issue fast.',
  icon: train
}, {
  title: 'Certificate of Prepaid Accommodation',
  description: 'Need a document for your visa application? We’ve got you covered with a prepaid accommodation certificate.',
  icon: certificate
}, {
  title: 'Send multiple booking requests, only pay one',
  description: 'Interested in more than one place? Send multiple booking requests! The first accepted one will be confirmed and paid automatically.',
  icon: money_colored
}];
;// CONCATENATED MODULE: ./src/components/WhyRentWithUniplaces/index.js
var WhyRentWithUniplaces_jsx = react.createElement;







var WhyRentWithUniplaces = function WhyRentWithUniplaces(_ref) {
  var trackReferralClickAction = _ref.trackReferralClickAction;

  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t;

  return WhyRentWithUniplaces_jsx(WhyRentWithUniplaces_styles_Container, null, WhyRentWithUniplaces_jsx(Heading, null, t('Why rent with Uniplaces')), WhyRentWithUniplaces_jsx(ValueProposition, null, valuePropositionItems.map(function (_ref2) {
    var title = _ref2.title,
        description = _ref2.description;
    return WhyRentWithUniplaces_jsx(Rows, {
      key: t(title)
    }, WhyRentWithUniplaces_jsx(WhyRentWithUniplaces_styles_Description, null, WhyRentWithUniplaces_jsx("h3", null, t(title)), WhyRentWithUniplaces_jsx("p", null, t(description))));
  })));
};

var WhyRentWithUniplaces_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    trackReferralClickAction: function trackReferralClickAction() {
      return dispatch((0,actions_tracking/* trackReferralClick */.fH)({
        context: 'why-rent-with-uniplaces'
      }));
    }
  };
};

/* harmony default export */ var components_WhyRentWithUniplaces = ((0,es/* connect */.$j)(null, WhyRentWithUniplaces_mapDispatchToProps)(WhyRentWithUniplaces));
;// CONCATENATED MODULE: ../shared/src/components/RegistrationNumber/styles.js

var RegistrationNumber_styles_Container = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-hgv1zo-0"
})(["display:flex;align-items:flex-end;align-self:flex-start;gap:", ";"], function (props) {
  return props.theme.gap(1, 'row');
});
var RegistrationNumber_styles_Label = /*#__PURE__*/styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  componentId: "sc-hgv1zo-1"
})(["color:", ";font-size:", ";font-family:'IntervalNextMed',sans-serif;"], function (props) {
  return props.theme.registrationNumber.text;
}, function (props) {
  return props.theme.rem(16);
});
var RegistrationValue = /*#__PURE__*/styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  componentId: "sc-hgv1zo-2"
})(["color:", ";font-size:", ";"], function (props) {
  return props.theme.registrationNumber.text;
}, function (props) {
  return props.theme.rem(14);
});
var TooltipContent = /*#__PURE__*/styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  componentId: "sc-hgv1zo-3"
})(["display:block;"]);
;// CONCATENATED MODULE: ../shared/src/components/RegistrationNumber/index.js
var RegistrationNumber_jsx = react.createElement;






var RegistrationNumber = function RegistrationNumber(_ref) {
  var registrationNumber = _ref.registrationNumber;
  var _useTranslation = (0,esm/* useTranslation */.$G)(),
    t = _useTranslation.t;
  return RegistrationNumber_jsx(RegistrationNumber_styles_Container, null, RegistrationNumber_jsx(RegistrationNumber_styles_Label, null, t('Registration Number')), RegistrationNumber_jsx(RegistrationValue, null, registrationNumber), RegistrationNumber_jsx(src/* Tooltip */.u, null, RegistrationNumber_jsx(exclamation/* default */.Z, {
    color: theme/* theme.registrationNumber.iconColor */.rS.registrationNumber.iconColor
  }), RegistrationNumber_jsx(TooltipContent, null, t('This is the official registration number assigned by Spanish authorities to verify this rental is legally listed'))));
};
/* harmony default export */ var components_RegistrationNumber = (RegistrationNumber);
;// CONCATENATED MODULE: ./src/containers/Offer/View/Desktop/styles.js


var Desktop_styles_templateObject;





var Main = /*#__PURE__*/styled_components_browser_esm/* default.main.withConfig */.ZP.main.withConfig({
  componentId: "sc-t1yop1-0"
})(["display:flex;flex-direction:column;align-items:center;justify-content:center;padding-top:", ";padding-bottom:", ";gap:", ";max-width:1200px;margin:0 auto;", ""], function (props) {
  return props.theme.space(32);
}, function (props) {
  return props.theme.space(10);
}, function (props) {
  return props.theme.space(8);
}, theme/* tabletRange.samsungTab */.zM.samsungTab('landscape')(Desktop_styles_templateObject || (Desktop_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding-inline: ", ";\n  "])), function (props) {
  return props.theme.space(5);
}));
var styles_Content = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-t1yop1-1"
})(["display:flex;justify-content:space-between;width:100%;"]);
var LeftSideContent = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-t1yop1-2"
})(["width:60%;align-self:flex-start;display:flex;flex-direction:column;gap:", ";", "{position:sticky;top:60px;background:white;z-index:2;", "{margin-bottom:", ";}}"], function (props) {
  return props.theme.space(10);
}, Tabs_styles_Wrapper, TabsWrapper, function (props) {
  return props.theme.space(1);
});
var RightSideContent = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-t1yop1-3"
})(["width:38%;display:flex;flex-direction:column;gap:", ";", "{margin-top:", ";}"], function (props) {
  return props.theme.space(5);
}, PricingBox_Desktop_styles_Wrapper, function (props) {
  return props.theme.space(3);
});
var SectionPlaceholder = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-t1yop1-4"
})(["min-height:400px;"]);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../shared/src/contexts/profile/index.js
var contexts_profile = __webpack_require__(42395);
;// CONCATENATED MODULE: ../shared/src/components/Header/Mobile/styles.js


var Nav = /*#__PURE__*/styled_components_browser_esm/* default.nav.withConfig */.ZP.nav.withConfig({
  componentId: "sc-1ace05e-0"
})(["display:flex;align-items:center;width:100%;height:60px;padding:0 ", ";position:", ";top:0;left:0;z-index:2;background:", ";transform:translateY(0);animation:", ";@keyframes slideDown{from{opacity:0;transform:translateY(-60px);}to{opacity:1;}}"], function (props) {
  return props.theme.space(4);
}, function (props) {
  return props.isSticky ? 'fixed' : 'absolute';
}, function (props) {
  return props.theme.header.mobile.background;
}, function (props) {
  return props.isSticky ? 'slideDown 0.8s ease-out' : null;
});
var Close = /*#__PURE__*/(0,styled_components_browser_esm/* default */.ZP)(svg_close/* CloseIcon */.T).withConfig({
  componentId: "sc-1ace05e-1"
})(["width:20px;path{fill:", ";}"], function (props) {
  return props.theme.header.mobile.closePath;
});
var Header_Mobile_styles_Wrapper = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1ace05e-2"
})(["display:flex;align-items:center;justify-content:space-between;width:100%;& svg:first-child{width:140px;height:33px;}.hamburger{g{fill:", ";}}"], function (props) {
  return props.theme.header.mobile.hamburger;
});
var Menu = /*#__PURE__*/styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  componentId: "sc-1ace05e-3"
})(["position:fixed;top:0;left:0;width:100vw;height:100dvh;transform:translate3d(0,-100%,0);transition:transform 0.25s ease-out;background-color:", ";padding:", " ", ";z-index:11;overflow-y:scroll;height:100vh;"], function (props) {
  return props.theme.header.background;
}, function (props) {
  return props.theme.space(15);
}, function (props) {
  return props.theme.space(8);
});
var Welcome = /*#__PURE__*/styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
  componentId: "sc-1ace05e-4"
})(["font-family:IntervalNextReg,sans-serif;font-weight:100;line-height:normal;font-size:", ";color:", ";margin-top:14px;margin-bottom:14px;"], function (props) {
  return props.theme.rem(32);
}, function (props) {
  return props.theme.header.mobile.welcome.color;
});
var Mobile_styles_Item = /*#__PURE__*/styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
  componentId: "sc-1ace05e-5"
})(["display:", ";width:100%;padding:", " 0;&:focus{text-decoration:none;}a{&.back-to-uniplaces,&.back-to-residences{border:2px solid ", ";padding:", " ", ";border-radius:8px;}}a{text-decoration:none;font-family:IntervalNextReg,sans-serif;font-weight:100;line-height:normal;color:", ";font-size:", ";}"], function (props) {
  return props.hide ? 'none' : 'flex';
}, function (props) {
  return props.theme.space(3);
}, function (props) {
  return props.theme.header.mobile.svg.gPathFill;
}, function (props) {
  return props.theme.space(1);
}, function (props) {
  return props.theme.space(3);
}, function (props) {
  return props.theme.header.mobile.svg.gPathFill;
}, function (props) {
  return props.theme.rem(16);
});
var Mobile_styles_Input = /*#__PURE__*/styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
  componentId: "sc-1ace05e-6"
})(["display:none;&:checked ~ ", "{position:fixed;display:flex;z-index:12;justify-content:space-between;background-color:", ";left:0;padding:", ";& svg:first-child{path{transition:fill 0.25s ease-out;fill:", ";}g{path{transition:fill 0.25s ease-out;fill:", ";}}}& ", "{path{transition:fill 0.25s ease-out;}}}&:checked ~ ", "{transform:translate3d(0,0,0);padding-bottom:", ";}"], Header_Mobile_styles_Wrapper, function (props) {
  return props.theme.header.background;
}, function (props) {
  return props.theme.space(4);
}, function (props) {
  return props.theme.header.mobile.svg.pathFill;
}, function (props) {
  return props.theme.header.mobile.svg.gPathFill;
}, Close, Menu, function (props) {
  return props.theme.space(35);
});
var styles_Separator = /*#__PURE__*/styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
  componentId: "sc-1ace05e-7"
})(["border-bottom:1px solid ", ";margin:", " 0;"], function (props) {
  return props.theme.header.mobile.separator.borderColor;
}, function (props) {
  return props.theme.space(3);
});
var SSOItem = /*#__PURE__*/styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
  componentId: "sc-1ace05e-8"
})(["display:flex;justify-content:space-between;border-bottom:1px solid ", ";margin-bottom:", ";a{text-decoration:none;font-family:IntervalNextReg,sans-serif;justify-content:center;align-items:center;border-radius:2px;font-weight:400;margin:16px 0;height:44px;width:48%;display:flex;border:2px solid transparent;font-size:", ";&.login{color:", ";background-color:", ";border:1px solid ", ";border-radius:8px;}&.signup{color:", ";background-color:", ";border-radius:8px;}}"], function (props) {
  return props.theme.header.mobile.separator.borderColor;
}, function (props) {
  return props.theme.space(2);
}, function (props) {
  return props.theme.rem(18);
}, function (props) {
  return props.theme.header.mobile.login.color;
}, function (props) {
  return props.theme.header.mobile.login.background;
}, function (props) {
  return props.theme.header.mobile.login.color;
}, function (props) {
  return props.theme.header.mobile.signup.color;
}, function (props) {
  return props.theme.header.mobile.signup.background;
});
var UniversityLogo = /*#__PURE__*/styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  componentId: "sc-1ace05e-9"
})(["max-width:250px;max-height:60px;"]);
var PartnerLogo = /*#__PURE__*/styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  componentId: "sc-1ace05e-10"
})(["height:40px;"]);
;// CONCATENATED MODULE: ../shared/src/components/Header/Mobile/authenticated.js
/* provided dependency */ var process = __webpack_require__(34406);
var authenticated_jsx = react.createElement;




var guestTabs = [{
  href: "".concat("https://uniplaces.com/", "dashboard/bookings"),
  key: 'header:Your stays'
}, {
  href: "".concat("https://uniplaces.com/", "dashboard/wishlist"),
  key: 'header:Favourites'
}];
var ApTabs = [{
  href: "".concat(process.env.AP_URL, "bookings/requests"),
  key: 'header:Dashboard'
}];
var AuthenticatedMenu = function AuthenticatedMenu(_ref) {
  var isAccommodationProvider = _ref.isAccommodationProvider,
    hideTabs = _ref.hideTabs,
    guestName = _ref.guestName;
  var _useTranslation = (0,esm/* useTranslation */.$G)('header'),
    t = _useTranslation.t;
  var tabs = isAccommodationProvider ? ApTabs : guestTabs;
  var _useContext = (0,react.useContext)(contexts_profile/* ProfileContext */.J),
    profile = _useContext.profile;
  var _ref2 = profile || {},
    _ref2$basic_info = _ref2.basic_info;
  _ref2$basic_info = _ref2$basic_info === void 0 ? {} : _ref2$basic_info;
  var _ref2$basic_info$full = _ref2$basic_info.full_name;
  _ref2$basic_info$full = _ref2$basic_info$full === void 0 ? {} : _ref2$basic_info$full;
  var _ref2$basic_info$full2 = _ref2$basic_info$full.first,
    first = _ref2$basic_info$full2 === void 0 ? t('header:User') : _ref2$basic_info$full2;
  var firstName = guestName || first;
  return authenticated_jsx(react.Fragment, null, authenticated_jsx(Welcome, null, t('header:Hello'), ", ", authenticated_jsx("span", null, firstName)), !hideTabs && tabs.map(function (_ref3, index) {
    var key = _ref3.key,
      href = _ref3.href;
    var translation = t(key);
    return authenticated_jsx(Mobile_styles_Item, {
      key: index
    }, authenticated_jsx("a", {
      href: href,
      title: translation
    }, translation));
  }), authenticated_jsx(styles_Separator, null));
};
/* harmony default export */ var authenticated = (AuthenticatedMenu);
;// CONCATENATED MODULE: ../shared/src/components/Header/Mobile/unauthenticated.js
var unauthenticated_jsx = react.createElement;





var createLocation = function createLocation(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return {
    pathname: to,
    query: {
      from: from
    }
  };
};
var UnauthenticatedMenu = function UnauthenticatedMenu() {
  var _useTranslation = (0,esm/* useTranslation */.$G)('header'),
    t = _useTranslation.t;
  var _useRouter = (0,next_router.useRouter)(),
    pathname = _useRouter.pathname,
    query = _useRouter.query;
  var isResidences = pathname.includes('/residences');
  var fromInferred = isResidences ? 'uniresidences' : query === null || query === void 0 ? void 0 : query.from;
  return unauthenticated_jsx(SSOItem, null, unauthenticated_jsx((link_default()), {
    href: createLocation('/login', query === null || query === void 0 ? void 0 : query.from),
    prefetch: false,
    className: "login"
  }, t('header:Log in')), unauthenticated_jsx((link_default()), {
    href: createLocation('/signup', fromInferred),
    prefetch: false,
    className: "signup"
  }, t('header:Sign up')));
};
/* harmony default export */ var unauthenticated = (UnauthenticatedMenu);
;// CONCATENATED MODULE: ../shared/src/components/Header/Mobile/tabs/index.js
var tabs_jsx = react.createElement;







var tabs_Tabs = function Tabs(_ref) {
  var isLoggedIn = _ref.isLoggedIn,
    isAccommodationProvider = _ref.isAccommodationProvider,
    tabs = _ref.tabs,
    hideUserTabs = _ref.hideUserTabs,
    guestName = _ref.guestName;
  var _useTranslation = (0,esm/* useTranslation */.$G)('header'),
    t = _useTranslation.t,
    language = _useTranslation.i18n.language;
  var _useRouter = (0,next_router.useRouter)(),
    _useRouter$query = _useRouter.query,
    query = _useRouter$query === void 0 ? {} : _useRouter$query;
  var menu = (0,react.useMemo)(function () {
    return isLoggedIn ? tabs_jsx(authenticated, {
      isAccommodationProvider: isAccommodationProvider,
      hideTabs: hideUserTabs,
      guestName: guestName
    }) : tabs_jsx(unauthenticated, null);
  }, [isLoggedIn]);
  return tabs_jsx(react.Fragment, null, menu, tabs.map(function (_ref2, index) {
    var key = _ref2.key,
      href = _ref2.href,
      _ref2$separator = _ref2.separator,
      separator = _ref2$separator === void 0 ? false : _ref2$separator,
      path = _ref2.path,
      event = _ref2['data-event'],
      target = _ref2.target,
      rel = _ref2.rel,
      styleName = _ref2.styleName;
    if (separator) {
      return tabs_jsx(styles_Separator, {
        key: index
      });
    }
    var translation = t(key);
    if (!href) {
      return tabs_jsx(Mobile_styles_Item, {
        key: index
      }, tabs_jsx((link_default()), {
        href: path,
        prefetch: false
      }, translation));
    }
    return tabs_jsx(Mobile_styles_Item, {
      key: index
    }, tabs_jsx("a", {
      href: href(language, query),
      title: translation,
      target: target,
      "data-event": event,
      className: styleName,
      rel: target === '_blank' ? 'noopener noreferrer' : ''
    }, translation));
  }), tabs_jsx(Mobile_styles_Item, {
    hide: !isLoggedIn || hideUserTabs
  }, tabs_jsx((link_default()), {
    href: "/logout",
    prefetch: false
  }, t('header:Logout'))));
};
/* harmony default export */ var Mobile_tabs = (tabs_Tabs);
;// CONCATENATED MODULE: ../shared/src/components/Header/Mobile/tabs/tabsLinksData.js
var TALK_TO_US = {
  EN: 'http://find.uniplaces.com/talk-to-us/',
  ES: 'http://find.uniplaces.com/hable-con-nosotros/',
  PT: 'http://find.uniplaces.com/fale-conosco/',
  FR: 'http://find.uniplaces.com/parle-nous/',
  IT: 'http://find.uniplaces.com/parla-con-noi/',
  DE: 'http://find.uniplaces.com/sprechen-sie-uns-an/',
  NL: 'http://find.uniplaces.com/talk-to-us/',
  PL: 'http://find.uniplaces.com/talk-to-us/',
  ZH: 'http://find.uniplaces.com/talk-to-us/'
};
var CITY_GUIDES = {
  EN: 'https://find.uniplaces.com/guides/',
  ES: 'https://find.uniplaces.com/giuas-de-la-ciudad/',
  PT: 'https://find.uniplaces.com/guias-da-cidade/',
  FR: 'https://find.uniplaces.com/guides-de-villes/',
  IT: 'https://find.uniplaces.com/guide-della-citt/',
  DE: 'https://find.uniplaces.com/stadtfhrer/',
  NL: 'https://find.uniplaces.com/guides/',
  PL: 'https://find.uniplaces.com/guides/',
  ZH: 'https://find.uniplaces.com/guides/'
};
;// CONCATENATED MODULE: ../shared/src/components/Header/Mobile/tabs/uniplaces.js

var defaultTabs = [{
  href: function href() {
    return "https://uniplaces.com/";
  },
  key: 'header:Home'
}, {
  href: function href() {
    return "https://rent.uniplaces.com";
  },
  'data-event': 'self-service-click',
  key: 'header:List your property'
}, {
  href: function href() {
    var language = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'en';
    return "".concat("https://uniplaces.com/").concat(language, "/how-it-works");
  },
  key: 'How it works'
}, {
  href: function href() {
    var language = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'en';
    return TALK_TO_US[language.toUpperCase()];
  },
  'data-event': 'support-click',
  key: 'Contact us'
}, {
  href: function href() {
    return "https://help.uniplaces.com/help/s/";
  },
  key: 'Help centre'
}, {
  href: function href() {
    return "https://ambassadors.uniplaces.com/";
  },
  key: 'Become an Ambassador'
}, {
  separator: true
}];
var apTabs = [{
  href: function href() {
    return "https://uniplaces.com/";
  },
  key: 'header:Home'
}, {
  href: function href() {
    return "".concat("https://uniplaces.com/", "dashboard/profile");
  },
  key: 'header:Settings'
}, {
  href: function href() {
    return "https://find.uniplaces.com/howitworks/landlords/";
  },
  key: 'How it works'
}, {
  href: function href() {
    return "https://help.uniplaces.com/help/s/";
  },
  key: 'Help centre'
}];
var uniplaces_guestTabs = [{
  href: function href() {
    return "https://uniplaces.com/";
  },
  key: 'header:Home'
}, {
  href: function href() {
    return "".concat("https://uniplaces.com/", "dashboard/profile");
  },
  key: 'header:Settings'
}, {
  href: function href() {
    var language = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'en';
    return TALK_TO_US[language === null || language === void 0 ? void 0 : language.toUpperCase()];
  },
  'data-event': 'support-click',
  key: 'Contact us'
}, {
  href: function href() {
    var language = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'en';
    return "".concat("https://uniplaces.com/").concat(language, "/how-it-works");
  },
  key: 'How it works'
}, {
  href: function href() {
    return "https://help.uniplaces.com/help/s/";
  },
  key: 'Help centre'
}, {
  href: function href() {
    return "https://ambassadors.uniplaces.com/";
  },
  key: 'Become an Ambassador'
}, {
  href: function href() {
    return "https://find.uniplaces.com/referafriend/";
  },
  key: 'Refer your friends'
}];
;// CONCATENATED MODULE: ../shared/src/hooks/freezeHTML.js

var headStyleActive = {
  overflow: 'hidden',
  position: 'fixed'
};
var headStyleRestored = {
  overflow: 'auto',
  position: 'relative'
};
var useFreezeHTML = function useFreezeHTML(shouldFreezeHTML) {
  var unless = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  (0,react.useEffect)(function () {
    if (unless) {
      return;
    }
    Object.assign(document.documentElement.style, shouldFreezeHTML ? headStyleActive : headStyleRestored);
  }, [shouldFreezeHTML]);
};
/* harmony default export */ var freezeHTML = (useFreezeHTML);
;// CONCATENATED MODULE: ../shared/src/svg/close-rounded.js

var close_rounded_jsx = react.createElement;

var CloseRounded = function CloseRounded(props) {
  return close_rounded_jsx("svg", (0,esm_extends/* default */.Z)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none"
  }, props), close_rounded_jsx("path", {
    stroke: "#224251",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m5 19.287 15-15M20 19.287l-15-15"
  }));
};
/* harmony default export */ var close_rounded = (CloseRounded);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(12524);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ../shared/src/components/Dropdown/styles.js

var Dropdown_styles_templateObject;


var Dropdown_styles_List = /*#__PURE__*/styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  componentId: "sc-1dm8zpn-0"
})(["display:none;&:focus{outline:none;}"]);
var Dropdown_styles_Title = /*#__PURE__*/styled_components_browser_esm/* default.label.withConfig */.ZP.label.withConfig({
  componentId: "sc-1dm8zpn-1"
})(["margin-bottom:", ";cursor:pointer;line-height:", ";text-transform:capitalize;user-select:none;display:flex;justify-content:space-between;gap:", ";.open{transform:rotate(-180deg);}svg{transition:all 0.25s ease;align-self:center;}&:not(:last-of-type){margin-right:0;}"], function (props) {
  return props.theme.space(2);
}, function (props) {
  return props.theme.rem(16);
}, function (props) {
  return props.theme.space(2);
});
var Dropdown_styles_Container = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1dm8zpn-2"
})(["display:flex;flex-direction:column;position:relative;font-size:", ";color:", ";font-family:IntervalNextReg,sans-serif;font-weight:100;line-height:normal;user-select:none;> input{display:none;&[type='checkbox']:checked ~ ", "{display:block;max-height:initial;height:auto;width:215px;z-index:2;li{&:hover a{border:none;}}}}input[type='checkbox']:checked + ", "{position:relative;&:after{transform:rotate(-45deg);}&:before{transform:rotate(45deg);}}&:focus{outline:none;}"], function (props) {
  return props.theme.rem(16);
}, function (props) {
  return props.theme.dropdown.containerColor;
}, Dropdown_styles_List, Dropdown_styles_Title);
var Dropdown_styles_Item = /*#__PURE__*/styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
  componentId: "sc-1dm8zpn-3"
})(["margin-right:0 !important;user-select:none;font-weight:400;&:focus,&:hover{font-family:IntervalNextReg,sans-serif;font-weight:600;outline:none;&:before{content:'';position:absolute;top:0;left:-1px;width:3px;height:", ";background-color:", ";}}&.selected{button,a{font-family:IntervalNextReg,sans-serif;font-weight:600;}}button,a{font-family:IntervalNextReg,sans-serif;display:flex;align-items:center;height:", ";width:100%;border:0;padding-left:", ";justify-content:left;font-size:", ";text-decoration:none;text-align:left;color:", ";background:none;cursor:pointer;position:relative;user-select:none;&:focus,&:hover{outline:none;font-weight:600;}}", ""], function (props) {
  return props.theme.space(8);
}, function (props) {
  return props.theme.dropdown.selectedColor;
}, function (props) {
  return props.theme.space(8);
}, function (props) {
  return props.theme.space(5);
}, function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.dropdown.color;
}, theme/* mediaMin.smallBreakpoint */.A3.smallBreakpoint(Dropdown_styles_templateObject || (Dropdown_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n    &:focus,\n    &:hover {\n      &:before {\n        width: 0;\n      }\n    }\n  "]))));
var Dropdown_styles_Separator = /*#__PURE__*/styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
  componentId: "sc-1dm8zpn-4"
})(["height:1px;background-color:", ";margin-block-end:", ";"], function (props) {
  return props.theme.dropdown.itemColor;
}, function (props) {
  return props.theme.space(3);
});
// EXTERNAL MODULE: ../shared/src/hooks/keyNavigation.js
var keyNavigation = __webpack_require__(95450);
;// CONCATENATED MODULE: ../shared/src/components/Dropdown/index.js

var Dropdown_jsx = react.createElement;








var isActive = function isActive(selected, current) {
  return selected.toUpperCase() === current.toUpperCase();
};
var Dropdown = function Dropdown(_ref) {
  var values = _ref.values,
    selected = _ref.selected,
    onSelect = _ref.onSelect,
    title = _ref.title,
    id = _ref.id,
    Icon = _ref.Icon;
  var _useTranslation = (0,esm/* useTranslation */.$G)('header'),
    language = _useTranslation.i18n.language;
  var _useState = (0,react.useState)(false),
    isOpen = _useState[0],
    setIsOpen = _useState[1];
  var htmlRef = (0,react.useRef)();
  var _useKeyNavigation = (0,keyNavigation/* useKeyNavigation */.F)(htmlRef),
    isFocused = _useKeyNavigation.isFocused,
    _useKeyNavigation$sta = _useKeyNavigation.state,
    selectedIndex = _useKeyNavigation$sta.selected,
    blured = _useKeyNavigation$sta.blured;
  var closeDropdown = function closeDropdown() {
    return setIsOpen(false);
  };
  var toggleDropdown = (0,react.useCallback)(function (e) {
    setIsOpen(!isOpen);
  }, [isOpen]);
  var delegateClickEvent = function delegateClickEvent(_ref2) {
    var firstChild = _ref2.target.firstChild;
    return firstChild.click && firstChild.click();
  };
  var onFocusHandler = function onFocusHandler() {
    return setIsOpen(true);
  };
  var closeDropdownAfter = function closeDropdownAfter(handleFunction) {
    return function (e) {
      handleFunction(e);
      closeDropdown();
    };
  };
  var _useRouter = (0,next_router.useRouter)(),
    query = _useRouter.query;
  (0,react.useEffect)(function () {
    if (!blured && isFocused) {
      return;
    }
    closeDropdown();
  }, [blured, isFocused]);
  var itemContent = function itemContent(value) {
    if (value.link || value.href) {
      return Dropdown_jsx((link_default()), (0,esm_extends/* default */.Z)({}, value, {
        href: value.href ? value.href(language) : value.link,
        query: query,
        prefetch: false
      }), value.translation);
    }
    return Dropdown_jsx("button", {
      value: value.key,
      onClick: closeDropdownAfter(onSelect),
      readOnly: true
    }, value.translation);
  };
  var dropdownId = id || 'dropdown-checkbox';
  return Dropdown_jsx(Dropdown_styles_Container, {
    ref: htmlRef,
    role: "listbox",
    tabIndex: "0",
    onFocus: onFocusHandler
  }, Dropdown_jsx("input", {
    id: dropdownId,
    type: "checkbox",
    checked: isOpen,
    readOnly: true,
    className: 'dropdown-checkbox'
  }), Dropdown_jsx(Dropdown_styles_Title, {
    onMouseDown: toggleDropdown,
    htmlFor: dropdownId
  }, title ? title : selected, Icon ? Dropdown_jsx(Icon, null) : Dropdown_jsx(arrowDown/* default */.Z, {
    className: isOpen ? 'open' : ''
  })), Dropdown_jsx(Dropdown_styles_List, null, values.map(function (value, i) {
    return Dropdown_jsx(react.Fragment, {
      key: i
    }, Dropdown_jsx(Dropdown_styles_Item, {
      role: "option",
      tabIndex: "-1",
      "aria-selected": selectedIndex === i + 1,
      onClick: delegateClickEvent,
      className: classnames_default()({
        selected: isActive(selected, value.translation)
      })
    }, itemContent(value)), value.separator ? Dropdown_jsx(Dropdown_styles_Separator, null) : null);
  })));
};
/* harmony default export */ var components_Dropdown = (Dropdown);
;// CONCATENATED MODULE: ../shared/src/constants/languageTranslations.js
/* harmony default export */ var languageTranslations = ({
  DE: 'Deutsch',
  EN: 'English',
  ES: 'Español',
  FR: 'Français',
  IT: 'Italiano',
  NL: 'Nederlands',
  PL: 'Polski',
  PT: 'Português',
  ZH: '中文'
});
var LOCALE_CODE_TO_TRANSLATION = {
  de_DE: 'German',
  en_GB: 'English',
  es_ES: 'Spanish',
  fr_FR: 'French',
  it_IT: 'Italian',
  nl_NL: 'Dutch',
  pl_PL: 'Polish',
  pt_PT: 'Portuguese',
  zh_CN: 'Chinese'
};
;// CONCATENATED MODULE: ../shared/src/components/LanguageSelector/styles.js

var LanguageSelector_styles_templateObject;


var LanguageSelector_styles_Container = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1dgc82e-0"
})(["display:flex;align-items:center;flex-grow:1;gap:", ";svg{width:auto !important;& > path{fill:transparent !important;stroke:", ";}}& > div{flex-grow:1;}label{font-family:IntervalNextReg,sans-serif;}", ""], function (props) {
  return props.theme.space(2);
}, function (props) {
  return props.theme.header.dropdown.icon;
}, src/* mediaMin.smallBreakpoint */.A3.smallBreakpoint(LanguageSelector_styles_templateObject || (LanguageSelector_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding-inline: ", ";\n    width: 100%;\n\n    label {\n      margin-top: ", ";\n    }\n\n    svg {\n      align-self: baseline;\n\n      & > path {\n        stroke: ", ";\n      }\n    }\n  "])), function (props) {
  return props.theme.space(2);
}, function (props) {
  return props.theme.space(1);
}, function (props) {
  return props.theme.header.mobile.dropdown.icon;
}));
;// CONCATENATED MODULE: ../shared/src/components/LanguageSelector/index.js


var LanguageSelector_jsx = react.createElement;
function LanguageSelector_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function LanguageSelector_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? LanguageSelector_ownKeys(Object(t), !0).forEach(function (r) { (0,defineProperty/* default */.Z)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : LanguageSelector_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }





var LanguageSelector = function LanguageSelector(_ref) {
  var _ref$onSelect = _ref.onSelect,
    onSelect = _ref$onSelect === void 0 ? function () {} : _ref$onSelect,
    changeLanguageByUrlHandler = _ref.changeLanguageByUrlHandler;
  var _useRouter = (0,next_router.useRouter)(),
    asPath = _useRouter.asPath,
    locale = _useRouter.locale;
  var _Object$entries$find = Object.entries(languageTranslations).find(function (_ref2) {
      var _ref3 = (0,slicedToArray/* default */.Z)(_ref2, 1),
        key = _ref3[0];
      return key.toLowerCase() === locale.toLowerCase();
    }),
    _Object$entries$find2 = (0,slicedToArray/* default */.Z)(_Object$entries$find, 1),
    key = _Object$entries$find2[0];
  return LanguageSelector_jsx(LanguageSelector_styles_Container, null, LanguageSelector_jsx(components_Dropdown, {
    values: Object.entries(languageTranslations).map(function (_ref4) {
      var _ref5 = (0,slicedToArray/* default */.Z)(_ref4, 2),
        key = _ref5[0],
        translation = _ref5[1];
      return LanguageSelector_objectSpread(LanguageSelector_objectSpread({}, !changeLanguageByUrlHandler ? {
        link: asPath
      } : {}), {}, {
        key: key.toLocaleLowerCase(),
        locale: key.toLocaleLowerCase(),
        translation: translation
      });
    }),
    selected: languageTranslations[key],
    title: key,
    onSelect: onSelect
  }));
};
/* harmony default export */ var components_LanguageSelector = (LanguageSelector);
;// CONCATENATED MODULE: ../shared/src/utils/decideTabs/index.js
var decideTab = function decideTab(isLoggedIn, isAccommodationProvider, defaultTabs, apTabs, guestTabs) {
  if (!isLoggedIn) {
    return defaultTabs;
  }
  return isAccommodationProvider ? apTabs : guestTabs;
};
;// CONCATENATED MODULE: ../shared/src/components/Header/Mobile/index.js
var Header_Mobile_jsx = react.createElement;










var HeaderMobile = function HeaderMobile(_ref) {
  var isLoggedIn = _ref.isLoggedIn,
    isAccommodationProvider = _ref.isAccommodationProvider,
    changeLanguageHandler = _ref.changeLanguageHandler,
    Logo = _ref.Logo,
    _ref$handleAfterMenuI = _ref.handleAfterMenuIsToggled,
    handleAfterMenuIsToggled = _ref$handleAfterMenuI === void 0 ? function () {} : _ref$handleAfterMenuI,
    tabs = _ref.tabs,
    hideUserTabs = _ref.hideUserTabs,
    isSticky = _ref.isSticky,
    guestName = _ref.guestName,
    changeLanguageByUrlHandler = _ref.changeLanguageByUrlHandler;
  var _useState = (0,react.useState)(false),
    menuOpen = _useState[0],
    setMenuOpen = _useState[1];
  var toggleMenuOpened = function toggleMenuOpened() {
    setMenuOpen(!menuOpen);
    handleAfterMenuIsToggled(menuOpen);
  };
  var hamburgerMenu = (0,react.useMemo)(function () {
    var Icon = menuOpen ? close_rounded : hamburger;
    return Header_Mobile_jsx(Icon, {
      className: !menuOpen ? 'hamburger' : '',
      onClick: toggleMenuOpened
    });
  }, [menuOpen]);
  freezeHTML(menuOpen);
  var theme = (0,react.useContext)(styled_components_browser_esm/* ThemeContext */.Ni);
  var decideTabValue = decideTab(isLoggedIn, isAccommodationProvider, defaultTabs, apTabs, uniplaces_guestTabs);
  return Header_Mobile_jsx(Nav, {
    isSticky: isSticky
  }, Header_Mobile_jsx(react.Fragment, null, Header_Mobile_jsx(Mobile_styles_Input, {
    type: "checkbox",
    checked: menuOpen,
    onChange: toggleMenuOpened
  }), Header_Mobile_jsx(Header_Mobile_styles_Wrapper, null, theme.mobileLogoURL ? Header_Mobile_jsx(UniversityLogo, {
    src: theme.mobileLogoURL
  }) : theme.partnerLogoUrl ? Header_Mobile_jsx(PartnerLogo, {
    src: theme.partnerLogoUrl
  }) : Header_Mobile_jsx(Logo, {
    onlyIcon: isSticky
  }), hamburgerMenu), Header_Mobile_jsx(Menu, {
    className: "authlist"
  }, Header_Mobile_jsx(Mobile_tabs, {
    isLoggedIn: isLoggedIn,
    tabs: tabs !== null && tabs !== void 0 ? tabs : decideTabValue,
    isAccommodationProvider: isAccommodationProvider,
    hideUserTabs: hideUserTabs,
    guestName: guestName
  }), Header_Mobile_jsx(Mobile_styles_Item, null, Header_Mobile_jsx(components_LanguageSelector, {
    onSelect: changeLanguageHandler,
    changeLanguageByUrlHandler: changeLanguageByUrlHandler
  })))));
};
/* harmony default export */ var Header_Mobile = (HeaderMobile);
;// CONCATENATED MODULE: ../shared/src/components/Header/Desktop/styles.js

var Header_Desktop_styles_templateObject;




var styles_Nav = /*#__PURE__*/styled_components_browser_esm/* default.nav.withConfig */.ZP.nav.withConfig({
  componentId: "sc-1vxvgv6-0"
})(["display:flex;justify-content:space-between;align-items:center;width:100%;height:60px;position:fixed;top:0;left:0;z-index:2;background:", ";svg{&.logo{width:140px;}&#arrow-down{path{stroke:", ";}}}.middle-menu{margin-left:", ";gap:", ";}.authlist{li:last-child{margin-right:", ";& > div{height:40px;border-radius:8px;padding-inline:", ";&:hover{background:", ";}label{display:flex;align-items:center;height:40px;color:", ";gap:", ";}svg{g{fill:", ";}}}}& > li{& > a{display:flex;align-items:center;height:40px;border-radius:8px;padding-inline:12px;padding-block:0;&:hover{background:", ";border:none;}}}li.checkout-signup{& > div{&:hover{background-color:transparent;}label{color:white;&:hover{background-color:transparent;}svg#arrow-down{margin-top:0;path{stroke:white;}}}}}}", ""], function (props) {
  return props.theme.header.background;
}, function (props) {
  return props.theme.header.dropdown.icon;
}, function (props) {
  return props.theme.space(40);
}, function (props) {
  return props.theme.space(5);
}, function (props) {
  return props.theme.space(5);
}, function (props) {
  return props.theme.space(3);
}, function (props) {
  return props.theme.header.hamburgerHover;
}, function (props) {
  return props.theme.header.link.authlistLinkColor;
}, function (props) {
  return props.theme.space(4);
}, function (props) {
  return props.theme.header.hamburger;
}, function (props) {
  return props.theme.header.authLinksBackground;
}, theme/* aboveMin.extraLargeBreakpoint */.si.extraLargeBreakpoint(Header_Desktop_styles_templateObject || (Header_Desktop_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding-left: 10%;\n    padding-right: 10%;\n  "]))));
var Desktop_styles_List = /*#__PURE__*/styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  componentId: "sc-1vxvgv6-1"
})(["display:flex;justify-content:", ";align-items:center;gap:", ";"], function (props) {
  return props.hasTabs ? 'space-between' : 'flex-end';
}, function (props) {
  return props.theme.space(3);
});
var Desktop_styles_Item = /*#__PURE__*/styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
  componentId: "sc-1vxvgv6-2"
})(["position:relative;&:hover{cursor:pointer;}a{font-family:IntervalNextReg,sans-serif;font-size:", ";color:", ";text-decoration:none;padding-bottom:", ";&:hover{text-decoration:none;color:", ";border-bottom:2px solid ", ";}&.signup{display:flex;align-items:center;height:38px;padding:0 17px;background-color:", ";color:", ";border-radius:8px;font-size:14px;&:hover{padding:0 17px;border-bottom:0;}}&.become-landlord{border:2px solid ", ";padding:", " ", ";border-radius:8px;transition:background-color 0.5s ease-out;&:hover{background-color:", ";color:", ";}}&.list-your-place{display:flex;align-items:center;align-self:flex-end;height:31px;padding:", " ", ";background:", ";font-family:IntervalNextReg,sans-serif;font-weight:600;font-size:", ";border-radius:", ";color:", ";border:none;text-decoration:none;border-radius:20px;&:hover{background:", ";}}&.back-to-uniplaces{display:flex;align-items:center;align-self:flex-end;height:", ";padding:0 ", ";background:", ";font-family:IntervalNextReg,sans-serif;font-weight:600;font-size:", ";border-radius:", ";color:", ";text-decoration:none;border:1px solid ", ";&:hover{background:", ";color:", ";border:1px solid ", ";}a{&:hover{text-decoration:none;border-bottom:unset;}}}}", "{width:250px;padding:", " ", ";position:absolute;top:50px;right:0;background:", ";box-shadow:0px 3px 10px 0px rgba(34,66,81,0.1);border:1px solid ", ";border-radius:8px;", "{font-size:", ";position:relative;height:34px;border-radius:6px;&:not(:last-child){margin-bottom:", ";}&:before{content:none;}&:hover{background:", ";}a{font-family:IntervalNextReg,sans-serif;font-size:", ";color:", ";padding-bottom:0;padding-left:", ";}}}", "{font-family:IntervalNextReg,sans-serif;font-size:", ";color:", ";margin-bottom:0;&:before{right:6px;background:", ";opacity:0.5;}&:after{right:11px;background:", ";opacity:0.5;}&:hover{color:", ";text-decoration:none;&:before,&:after{background:", ";}}}:has(", "){label{display:flex;align-items:center;height:40px;border-radius:8px;padding-inline:12px;color:", ";&:hover{background:", ";color:", ";}#arrow-down,#arrow-up{path{stroke:", ";}}}}"], function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.header.link.authlistLinkColor;
}, function (props) {
  return props.theme.space(2);
}, function (props) {
  return props.theme.header.link.color;
}, function (props) {
  return props.theme.header.link.color;
}, function (props) {
  return props.theme.header.link.signup;
}, function (props) {
  return props.theme.header.link.color;
}, function (props) {
  return props.theme.header.link.color;
}, function (props) {
  return props.theme.space(1);
}, function (props) {
  return props.theme.space(3);
}, function (props) {
  return props.theme.header.link.color;
}, function (props) {
  return props.theme.typography.bodyColor;
}, function (props) {
  return props.theme.space(2);
}, function (props) {
  return props.theme.space(3);
}, function (props) {
  return props.theme.header.list_your_place.button_background_color;
}, function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.rem(8);
}, function (props) {
  return props.theme.typography.invertedColor;
}, function (props) {
  return props.theme.header.list_your_place.button_hover_color;
}, function (props) {
  return props.theme.space(10);
}, function (props) {
  return props.theme.space(4);
}, function (props) {
  return props.theme.header.back_to_uniplaces.button_color;
}, function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.rem(8);
}, function (props) {
  return props.theme.typography.invertedColor;
}, function (props) {
  return props.theme.header.back_to_uniplaces.button_color;
}, function (props) {
  return props.theme.colors.lightest;
}, function (props) {
  return props.theme.header.back_to_uniplaces.button_color;
}, function (props) {
  return props.theme.header.back_to_uniplaces.button_color;
}, Dropdown_styles_List, function (props) {
  return props.theme.space(5);
}, function (props) {
  return props.theme.space(4);
}, function (props) {
  return props.theme.header.dropdown.background;
}, function (props) {
  return props.theme.header.dropdown.border;
}, Dropdown_styles_Item, function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.space(3);
}, function (props) {
  return props.theme.header.dropdown.hoverLinks;
}, function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.dropdown.color;
}, function (props) {
  return props.theme.space(2);
}, Dropdown_styles_Title, function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.header.label.color;
}, function (props) {
  return props.theme.header.label.background;
}, function (props) {
  return props.theme.header.label.background;
}, function (props) {
  return props.theme.header.label.selected;
}, function (props) {
  return props.theme.header.label.selected;
}, LanguageSelector_styles_Container, function (props) {
  return props.theme.header.link.authlistLinkColor;
}, function (props) {
  return props.theme.header.authLinksBackground;
}, function (props) {
  return props.theme.header.link.color;
}, function (props) {
  return props.theme.header.dropdown.icon;
});
;// CONCATENATED MODULE: ../shared/src/components/Header/Desktop/tabs/index.js
var Desktop_tabs_jsx = react.createElement;





var Desktop_tabs_Tabs = function Tabs(_ref) {
  var tabs = _ref.tabs;
  var _useTranslation = (0,esm/* useTranslation */.$G)('header'),
    t = _useTranslation.t,
    language = _useTranslation.i18n.language;
  var _useRouter = (0,next_router.useRouter)(),
    _useRouter$query = _useRouter.query,
    query = _useRouter$query === void 0 ? {} : _useRouter$query;
  return Desktop_tabs_jsx(react.Fragment, null, tabs.map(function (_ref2) {
    var key = _ref2.key,
      className = _ref2.className,
      href = _ref2.href,
      path = _ref2.path,
      styleName = _ref2.styleName,
      event = _ref2['data-event'],
      target = _ref2.target,
      rel = _ref2.rel;
    var translation = t(key);
    if (!href) {
      return Desktop_tabs_jsx(Desktop_styles_Item, {
        key: key
      }, Desktop_tabs_jsx((link_default()), {
        href: path
      }, translation));
    }
    return Desktop_tabs_jsx(Desktop_styles_Item, {
      key: key,
      className: className
    }, Desktop_tabs_jsx("a", {
      href: href(language, query),
      title: translation,
      "data-event": event,
      target: target,
      rel: target === '_blank' ? 'noopener noreferrer' : '',
      className: styleName
    }, translation));
  }));
};
/* harmony default export */ var Desktop_tabs = (Desktop_tabs_Tabs);
;// CONCATENATED MODULE: ../shared/src/components/Header/Desktop/tabs/tabsLinksData.js
var tabsLinksData_TALK_TO_US = {
  EN: 'http://find.uniplaces.com/talk-to-us/',
  ES: 'http://find.uniplaces.com/hable-con-nosotros/',
  PT: 'http://find.uniplaces.com/fale-conosco/',
  FR: 'http://find.uniplaces.com/parle-nous/',
  IT: 'http://find.uniplaces.com/parla-con-noi/',
  DE: 'http://find.uniplaces.com/sprechen-sie-uns-an/',
  NL: 'http://find.uniplaces.com/talk-to-us/',
  PL: 'http://find.uniplaces.com/talk-to-us/',
  ZH: 'http://find.uniplaces.com/talk-to-us/'
};
var tabsLinksData_CITY_GUIDES = {
  EN: 'https://find.uniplaces.com/guides/',
  ES: 'https://find.uniplaces.com/giuas-de-la-ciudad/',
  PT: 'https://find.uniplaces.com/guias-da-cidade/',
  FR: 'https://find.uniplaces.com/guides-de-villes/',
  IT: 'https://find.uniplaces.com/guide-della-citt/',
  DE: 'https://find.uniplaces.com/stadtfhrer/',
  NL: 'https://find.uniplaces.com/guides/',
  PL: 'https://find.uniplaces.com/guides/',
  ZH: 'https://find.uniplaces.com/guides/'
};
;// CONCATENATED MODULE: ../shared/src/components/Header/Desktop/tabs/uniplaces.js

var uniplaces_defaultTabs = [{
  href: function href() {
    var language = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'en';
    return tabsLinksData_TALK_TO_US[language.toUpperCase()];
  },
  'data-event': 'support-click',
  key: 'header:Contact us',
  target: '_blank'
}, {
  href: function href() {
    return "https://rent.uniplaces.com";
  },
  'data-event': 'self-service-click',
  key: 'header:List your property',
  styleName: 'list-your-place',
  target: '_blank'
}];
;// CONCATENATED MODULE: ../shared/src/components/Header/styles.js

var Header_styles_Header = /*#__PURE__*/styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
  componentId: "sc-xuuptx-0"
})(["z-index:auto;"]);
var styles_UniversityLogo = /*#__PURE__*/styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  componentId: "sc-xuuptx-1"
})(["max-width:250px;max-height:60px;"]);
var styles_PartnerLogo = /*#__PURE__*/styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  componentId: "sc-xuuptx-2"
})(["max-width:250px;max-height:60px;"]);
;// CONCATENATED MODULE: ../shared/src/components/Header/Desktop/authenticated.js
/* provided dependency */ var authenticated_process = __webpack_require__(34406);
var Desktop_authenticated_jsx = react.createElement;








var accommodationProviderDropdownItems = [{
  key: 'Dashboard',
  link: "".concat(authenticated_process.env.AP_URL, "bookings/requests"),
  separator: true,
  target: '_blank'
}, {
  key: 'Settings',
  link: "".concat(authenticated_process.env.AP_URL, "account/details"),
  target: '_blank'
}, {
  key: 'How it works',
  href: function href() {
    return "https://find.uniplaces.com/howitworks/landlords/";
  },
  target: '_blank'
}, {
  link: "".concat("https://help.uniplaces.com/help/s/"),
  key: 'Help centre',
  separator: true,
  target: '_blank'
}, {
  key: 'Logout',
  link: '/logout'
}];
var guestDropdownItems = [{
  key: 'Your stays',
  link: '/dashboard/bookings',
  target: '_blank'
}, {
  key: 'Favourites',
  link: '/dashboard/wishlist',
  separator: true,
  target: '_blank'
}, {
  key: 'Settings',
  link: '/dashboard/profile',
  target: '_blank'
}, {
  key: 'Contact us',
  href: function href() {
    var language = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'en';
    return tabsLinksData_TALK_TO_US[language.toUpperCase()];
  },
  target: '_blank'
}, {
  key: 'How it works',
  href: function href(language) {
    return "".concat("https://uniplaces.com/").concat(language, "/how-it-works");
  },
  target: '_blank'
}, {
  link: "".concat("https://help.uniplaces.com/help/s/"),
  key: 'Help centre',
  target: '_blank'
}, {
  key: 'Become an Ambassador',
  link: "".concat("https://ambassadors.uniplaces.com/"),
  target: '_blank'
}, {
  key: 'Refer your friends',
  link: '/dashboard/referral',
  separator: true,
  target: '_blank'
}, {
  key: 'Logout',
  link: '/logout'
}];
var authenticated_AuthenticatedMenu = function AuthenticatedMenu(_ref) {
  var isAccommodationProvider = _ref.isAccommodationProvider,
    hideUserTabs = _ref.hideUserTabs,
    changeLanguageHandler = _ref.changeLanguageHandler,
    changeLanguageByUrlHandler = _ref.changeLanguageByUrlHandler,
    guestName = _ref.guestName;
  var _useTranslation = (0,esm/* useTranslation */.$G)('header'),
    t = _useTranslation.t;
  var _useContext = (0,react.useContext)(contexts_profile/* ProfileContext */.J),
    profile = _useContext.profile;
  var _ref2 = profile || {},
    _ref2$basic_info = _ref2.basic_info;
  _ref2$basic_info = _ref2$basic_info === void 0 ? {} : _ref2$basic_info;
  var _ref2$basic_info$full = _ref2$basic_info.full_name;
  _ref2$basic_info$full = _ref2$basic_info$full === void 0 ? {} : _ref2$basic_info$full;
  var _ref2$basic_info$full2 = _ref2$basic_info$full.first,
    first = _ref2$basic_info$full2 === void 0 ? t('header:User') : _ref2$basic_info$full2;
  var dropdownItems = isAccommodationProvider ? accommodationProviderDropdownItems : guestDropdownItems;
  var hello = t('header:Hello');
  return Desktop_authenticated_jsx(react.Fragment, null, Desktop_authenticated_jsx(Desktop_styles_Item, null, Desktop_authenticated_jsx(components_LanguageSelector, {
    onSelect: changeLanguageHandler,
    changeLanguageByUrlHandler: changeLanguageByUrlHandler
  })), hideUserTabs ? null : Desktop_authenticated_jsx(Desktop_styles_Item, null, Desktop_authenticated_jsx(components_Dropdown, {
    id: 'usermenu',
    values: dropdownItems.map(function (_ref3) {
      var key = _ref3.key,
        href = _ref3.href,
        link = _ref3.link,
        separator = _ref3.separator;
      return {
        key: key,
        href: href,
        link: link,
        translation: t("".concat(key)),
        separator: separator
      };
    }),
    title: "".concat(hello, ", ").concat(guestName || first),
    selected: '',
    onSelect: function onSelect() {},
    Icon: hamburger
  })));
};
/* harmony default export */ var Desktop_authenticated = (authenticated_AuthenticatedMenu);
;// CONCATENATED MODULE: ../shared/src/components/Header/Desktop/tabs/guestLinksData.js

var GUEST_DROPDOWN_ITEMS = [{
  link: "".concat("https://rent.uniplaces.com"),
  key: 'List your property',
  target: '_blank'
}, {
  href: function href() {
    var language = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'en';
    return "".concat("https://uniplaces.com/").concat(language, "/how-it-works");
  },
  key: 'How it works',
  target: '_blank'
}, {
  href: function href() {
    var language = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'en';
    return tabsLinksData_TALK_TO_US[language.toUpperCase()];
  },
  key: 'Contact us',
  target: '_blank'
}, {
  link: "".concat("https://help.uniplaces.com/help/s/"),
  key: 'Help centre',
  target: '_blank'
}, {
  key: 'Become an Ambassador',
  link: "".concat("https://ambassadors.uniplaces.com/"),
  separator: true,
  target: '_blank'
}, {
  key: 'Sign up',
  link: '/signup'
}, {
  key: 'Log in',
  link: '/login'
}];
;// CONCATENATED MODULE: ../shared/src/components/Header/Desktop/unauthenticated.js
var Desktop_unauthenticated_jsx = react.createElement;











var unauthenticated_UnauthenticatedMenu = function UnauthenticatedMenu(_ref) {
  var changeLanguageHandler = _ref.changeLanguageHandler,
    hideHamburgerMenu = _ref.hideHamburgerMenu;
  var _useTranslation = (0,esm/* useTranslation */.$G)('header'),
    t = _useTranslation.t;
  var _useRouter = (0,next_router.useRouter)(),
    locale = _useRouter.locale;
  var _useRouter2 = (0,next_router.useRouter)(),
    pathname = _useRouter2.pathname;
  var isResidences = pathname.includes('/residences');
  var signupURL = isResidences ? '/signup?from=uniresidences' : '/signup';
  var isSignupOrLogin = pathname.includes('/signup') || pathname.includes('/login');
  var handleClick = function handleClick(_ref2) {
    var link = _ref2.link;
    link && link === '/signup' ? (0,dataAmplitude/* trackAmplitude */.pt)(events/* default.viewSignupPage */.Z.viewSignupPage, {
      origin: 'hamburger menu'
    }) : (0,dataAmplitude/* trackAmplitude */.pt)(events/* default.viewSignupPage */.Z.viewSignupPage, {
      origin: pathname
    });
  };
  return Desktop_unauthenticated_jsx(react.Fragment, null, !isSignupOrLogin && Desktop_unauthenticated_jsx(react.Fragment, null, Desktop_unauthenticated_jsx(Desktop_styles_Item, null, Desktop_unauthenticated_jsx((link_default()), {
    href: signupURL,
    locale: locale,
    prefetch: false,
    onClick: handleClick
  }, t('header:Sign up'))), Desktop_unauthenticated_jsx(Desktop_styles_Item, null, Desktop_unauthenticated_jsx((link_default()), {
    href: "/login",
    locale: locale,
    prefetch: false
  }, t('header:Log in')))), Desktop_unauthenticated_jsx(Desktop_styles_Item, {
    className: isSignupOrLogin ? 'checkout-signup' : ''
  }, Desktop_unauthenticated_jsx(components_LanguageSelector, {
    onSelect: changeLanguageHandler
  })), hideHamburgerMenu ? null : Desktop_unauthenticated_jsx(Desktop_styles_Item, null, Desktop_unauthenticated_jsx(components_Dropdown, {
    id: 'usermenu',
    values: GUEST_DROPDOWN_ITEMS.map(function (_ref3) {
      var key = _ref3.key,
        href = _ref3.href,
        link = _ref3.link,
        separator = _ref3.separator,
        target = _ref3.target;
      return {
        key: key,
        href: href,
        link: link,
        translation: t("".concat(key)),
        separator: separator,
        target: target,
        onClick: function onClick() {
          return handleClick({
            link: link
          });
        }
      };
    }),
    selected: '',
    onSelect: function onSelect() {},
    Icon: hamburger
  })));
};
/* harmony default export */ var Desktop_unauthenticated = (unauthenticated_UnauthenticatedMenu);
;// CONCATENATED MODULE: ../shared/src/components/Header/Desktop/index.js
var Header_Desktop_jsx = react.createElement;








var HeaderDesktop = function HeaderDesktop(_ref) {
  var isLoggedIn = _ref.isLoggedIn,
    isAccommodationProvider = _ref.isAccommodationProvider,
    changeLanguageHandler = _ref.changeLanguageHandler,
    _ref$tabs = _ref.tabs,
    tabs = _ref$tabs === void 0 ? uniplaces_defaultTabs : _ref$tabs,
    Logo = _ref.Logo,
    hideUserTabs = _ref.hideUserTabs,
    hideHamburgerMenu = _ref.hideHamburgerMenu,
    guestName = _ref.guestName,
    changeLanguageByUrlHandler = _ref.changeLanguageByUrlHandler;
  var loggedInState = isLoggedIn ? Header_Desktop_jsx(Desktop_authenticated, {
    guestName: guestName,
    isAccommodationProvider: isAccommodationProvider,
    hideUserTabs: hideUserTabs,
    changeLanguageHandler: changeLanguageHandler,
    changeLanguageByUrlHandler: changeLanguageByUrlHandler
  }) : Header_Desktop_jsx(Desktop_unauthenticated, {
    changeLanguageHandler: changeLanguageHandler,
    hideHamburgerMenu: hideHamburgerMenu,
    changeLanguageByUrlHandler: changeLanguageByUrlHandler
  });
  var tabsComponent = tabs.length && !hideUserTabs ? Header_Desktop_jsx(Desktop_tabs, {
    tabs: tabs
  }) : null;
  var theme = (0,react.useContext)(styled_components_browser_esm/* ThemeContext */.Ni);
  return Header_Desktop_jsx(styles_Nav, {
    className: "header-desk-nav"
  }, theme.mobileLogoURL ? Header_Desktop_jsx(styles_UniversityLogo, {
    src: theme.mobileLogoURL
  }) : theme.partnerLogoUrl ? Header_Desktop_jsx(styles_PartnerLogo, {
    src: theme.partnerLogoUrl
  }) : Header_Desktop_jsx(Logo, null), Header_Desktop_jsx(Desktop_styles_List, {
    hasTabs: tabs.length,
    className: "middle-menu"
  }, tabsComponent), Header_Desktop_jsx(Desktop_styles_List, {
    className: "authlist"
  }, tabs.length ? loggedInState : null));
};
/* harmony default export */ var Header_Desktop = (HeaderDesktop);
// EXTERNAL MODULE: ../shared/src/svg/logo.js
var logo = __webpack_require__(56992);
;// CONCATENATED MODULE: ../shared/src/components/Header/Logo/index.js
var Logo_jsx = react.createElement;




var LogoUniplaces = function LogoUniplaces(_ref) {
  var onlyIcon = _ref.onlyIcon;
  var _useRouter = (0,next_router.useRouter)(),
    pathname = _useRouter.pathname,
    locale = _useRouter.locale;
  if (pathname === '/' || /^\/[a-z]{2}$/i.test(pathname)) {
    return Logo_jsx(logo/* LogoIcon */.K, {
      onlyIcon: onlyIcon
    });
  }
  var link = (0,redirect/* getHomepageByLocale */.sg)(pathname, locale);
  return Logo_jsx("a", {
    href: link,
    title: 'Uniplaces'
  }, Logo_jsx(logo/* LogoIcon */.K, {
    onlyIcon: onlyIcon
  }));
};
/* harmony default export */ var Header_Logo = (LogoUniplaces);
;// CONCATENATED MODULE: ../shared/src/components/Header/index.js
var Header_jsx = react.createElement;








var Header_Header = function Header(_ref) {
  var className = _ref.className,
    tabs = _ref.tabs,
    _ref$Logo = _ref.Logo,
    Logo = _ref$Logo === void 0 ? Header_Logo : _ref$Logo,
    _ref$handleAfterMenuI = _ref.handleAfterMenuIsToggled,
    handleAfterMenuIsToggled = _ref$handleAfterMenuI === void 0 ? function () {} : _ref$handleAfterMenuI,
    hideUserTabs = _ref.hideUserTabs,
    _ref$isLoggedInOutsid = _ref.isLoggedInOutsideOfContext,
    isLoggedInOutsideOfContext = _ref$isLoggedInOutsid === void 0 ? undefined : _ref$isLoggedInOutsid,
    isSticky = _ref.isSticky,
    hideHamburgerMenu = _ref.hideHamburgerMenu,
    _ref$isGuestUnauthent = _ref.isGuestUnauthenticatedOutsideOfContext,
    isGuestUnauthenticatedOutsideOfContext = _ref$isGuestUnauthent === void 0 ? undefined : _ref$isGuestUnauthent,
    onChangeLanguage = _ref.onChangeLanguage,
    guestName = _ref.guestName;
  var _useTranslation = (0,esm/* useTranslation */.$G)('header'),
    i18n = _useTranslation.i18n;
  var _useContext = (0,react.useContext)(media/* MediaContext */.Y),
    is = _useContext.is;
  var changeLanguageHandler = (0,react.useCallback)(function (e) {
    i18n.changeLanguage(e.target.getAttribute('value'));
  }, [i18n.language]);
  var isLoggedIn = isLoggedInOutsideOfContext;
  var isAccommodationProvider;
  var isGuestUnauthenticated = isGuestUnauthenticatedOutsideOfContext;
  if (isLoggedInOutsideOfContext === undefined) {
    var _useContext2 = (0,react.useContext)(contexts_profile/* ProfileContext */.J),
      isAccommodationProviderContext = _useContext2.isAccommodationProvider,
      isLoggedInContext = _useContext2.isLoggedIn,
      isGuestUnauthenticatedContext = _useContext2.isGuestUnauthenticated;
    isAccommodationProvider = isAccommodationProviderContext;
    isLoggedIn = isLoggedInContext;
    isGuestUnauthenticated = isGuestUnauthenticatedContext;
  }
  var Component = (0,react.useMemo)(function () {
    return is.mobile ? Header_Mobile : Header_Desktop;
  }, [is.mobile]);
  var _useState = (0,react.useState)(false),
    hasMounted = _useState[0],
    setHasMounted = _useState[1];
  (0,react.useEffect)(function () {
    return setHasMounted(true);
  }, []);
  if (!hasMounted) {
    return null;
  }
  return Header_jsx(Header_styles_Header, {
    className: className
  }, Header_jsx(Component, {
    tabs: tabs,
    changeLanguageHandler: onChangeLanguage || changeLanguageHandler,
    updateLanguageByUrl: !!onChangeLanguage,
    isLoggedIn: isLoggedIn,
    isAccommodationProvider: isAccommodationProvider,
    handleAfterMenuIsToggled: handleAfterMenuIsToggled,
    Logo: Logo,
    hideUserTabs: hideUserTabs,
    isSticky: isSticky,
    hideHamburgerMenu: hideHamburgerMenu || isGuestUnauthenticated,
    guestName: guestName
  }));
};
/* harmony default export */ var components_Header = (Header_Header);
;// CONCATENATED MODULE: ../shared/src/components/Footer/styles.js

var Footer_styles_templateObject, Footer_styles_templateObject2, Footer_styles_templateObject3, styles_templateObject4, styles_templateObject5, styles_templateObject6, styles_templateObject7, styles_templateObject8, styles_templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18;


var FooterWrapper = /*#__PURE__*/styled_components_browser_esm/* default.footer.withConfig */.ZP.footer.withConfig({
  componentId: "sc-1xls7qh-0"
})(["width:100%;background:", ";padding:", " 0;font-size:", ";", ""], function (props) {
  return props.theme.footer.background;
}, function (props) {
  return props.theme.space(9);
}, function (props) {
  return props.theme.rem(18);
}, theme/* mediaMin.extraSmallBreakpoint */.A3.extraSmallBreakpoint(Footer_styles_templateObject || (Footer_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: ", " 0;\n  "])), function (props) {
  return props.theme.space(3);
}));
var InnerFooter = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1xls7qh-1"
})(["max-width:1100px;margin:0 auto;", " ", " ", ""], theme/* mediaMin.largeBreakpoint */.A3.largeBreakpoint(Footer_styles_templateObject2 || (Footer_styles_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding-left: ", ";\n    padding-right: ", ";\n  "])), function (props) {
  return props.theme.space(10);
}, function (props) {
  return props.theme.space(10);
}), theme/* mediaMin.extraSmallBreakpoint */.A3.extraSmallBreakpoint(Footer_styles_templateObject3 || (Footer_styles_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n    display: flex;\n    flex-direction: column;\n    padding-left: ", ";\n    padding-right: ", ";\n  "])), function (props) {
  return props.theme.space(4);
}, function (props) {
  return props.theme.space(4);
}), theme/* aboveMin.extraLargeBreakpoint */.si.extraLargeBreakpoint(styles_templateObject4 || (styles_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n    max-width: 1200px;\n  "]))));
var FooterRow = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1xls7qh-2"
})(["display:flex;flex-wrap:wrap;justify-content:space-between;border-top:1px solid ", ";padding-top:", ";margin-top:", ";a,.copy-right,.termly-display-preferences,.terms-of-service,.privacy-policy{font-family:IntervalNextReg,sans-serif;font-size:", ";color:", ";text-decoration:none;cursor:pointer;", "}& > *{", "}", ""], function (props) {
  return props.theme.footer.line;
}, function (props) {
  return props.theme.space(5);
}, function (props) {
  return props.theme.space(12);
}, function (props) {
  return props.theme.rem(18);
}, function (props) {
  return props.theme.footer.link;
}, theme/* mediaMin.extraSmallBreakpoint */.A3.extraSmallBreakpoint(styles_templateObject5 || (styles_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n      font-size: ", ";\n      text-align: center;\n    "])), function (props) {
  return props.theme.rem(14);
}), theme/* mediaMin.extraSmallBreakpoint */.A3.extraSmallBreakpoint(styles_templateObject6 || (styles_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n        flex-basis: 100%;\n        justify-content: center;\n\n        &:first-child {\n            margin-bottom: ", ";\n            display: flex;\n            align-items: center;\n\n            svg {\n              margin-right: ", ";\n            }\n        }\n    "])), function (props) {
  return props.theme.space(4);
}, function (props) {
  return props.theme.space(3);
}), theme/* mediaMin.extraSmallBreakpoint */.A3.extraSmallBreakpoint(styles_templateObject7 || (styles_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n    order: 3;\n    margin-top: 0;\n    padding-top: ", ";\n  "])), function (props) {
  return props.theme.space(4);
}));
var Grid = /*#__PURE__*/styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  componentId: "sc-1xls7qh-3"
})(["--gap:30px;--itemWith:20%;display:flex;flex-wrap:wrap;margin:calc(var(--gap) / -2);& > *{margin:calc(var(--gap) / 2);flex-grow:1;flex-basis:calc(var(--itemWith) - var(--gap));", " ", "}", ""], theme/* mediaMin.smallBreakpoint */.A3.smallBreakpoint(styles_templateObject8 || (styles_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n        flex-basis: calc(50% - var(--gap));\n    "]))), theme/* mediaMin.extraSmallBreakpoint */.A3.extraSmallBreakpoint(styles_templateObject9 || (styles_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n        flex-basis: 100%;\n        margin: 0;\n    "]))), theme/* mediaMin.extraSmallBreakpoint */.A3.extraSmallBreakpoint(_templateObject10 || (_templateObject10 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: ", " ", " ", ";\n    order: 1;\n  "])), function (props) {
  return props.theme.space(3);
}, function (props) {
  return props.theme.space(4);
}, function (props) {
  return props.theme.space(2);
}));
var GridColumn = /*#__PURE__*/styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
  componentId: "sc-1xls7qh-4"
})(["padding-top:", ";", ""], function (props) {
  return props.theme.space(12);
}, theme/* mediaMin.extraSmallBreakpoint */.A3.extraSmallBreakpoint(_templateObject11 || (_templateObject11 = (0,taggedTemplateLiteral/* default */.Z)(["\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    position: relative;\n    padding: ", " 0;\n    border-bottom: 1px solid ", ";\n  "])), function (props) {
  return props.theme.space(4);
}, function (props) {
  return props.theme.footer.line;
}));
var HiddenCheckbox = /*#__PURE__*/styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
  componentId: "sc-1xls7qh-5"
})(["display:none;", ""], theme/* mediaMin.extraSmallBreakpoint */.A3.extraSmallBreakpoint(_templateObject12 || (_templateObject12 = (0,taggedTemplateLiteral/* default */.Z)(["\n    &:checked ~ ul {\n      margin-top: ", ";\n      max-height: 100%;\n    }\n\n    &:checked ~ label {\n      &:after {\n        transform: rotate(-45deg);\n      }\n\n      &:before {\n        transform: rotate(45deg);\n      }\n    }\n  "])), function (props) {
  return props.theme.space(4);
}));
var CollapsibleSection = /*#__PURE__*/styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  componentId: "sc-1xls7qh-6"
})(["display:flex;flex-direction:column;", ";padding-top:", ";", ""], function (_ref) {
  var theme = _ref.theme;
  return theme.gap(4, 'column');
}, function (props) {
  return props.theme.space(8);
}, theme/* mediaMin.extraSmallBreakpoint */.A3.extraSmallBreakpoint(_templateObject13 || (_templateObject13 = (0,taggedTemplateLiteral/* default */.Z)(["\n    max-height: 0;\n    overflow: hidden;\n    padding-top: 0;\n    ", ";\n  "])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.gap(2, 'column');
}));
var Footer_styles_Label = /*#__PURE__*/styled_components_browser_esm/* default.label.withConfig */.ZP.label.withConfig({
  componentId: "sc-1xls7qh-7"
})(["font-family:IntervalNextReg,sans-serif;font-weight:600;font-size:", ";font-weight:600;color:", ";", ""], function (props) {
  return props.theme.rem(18);
}, function (props) {
  return props.theme.footer.title;
}, theme/* mediaMin.extraSmallBreakpoint */.A3.extraSmallBreakpoint(_templateObject14 || (_templateObject14 = (0,taggedTemplateLiteral/* default */.Z)(["\n    font-size: ", ";\n    font-weight: 500;\n    display: block;\n    cursor: pointer;\n\n    &:after {\n      content: ' ';\n      top: ", ";\n      position: absolute;\n      display: block;\n      right: 6px;\n      transform: rotate(45deg);\n      width: 10px;\n      height: 2px;\n      background-color: ", ";\n    }\n\n    &:before {\n      content: ' ';\n      top: ", ";\n      position: absolute;\n      display: block;\n      transform: rotate(-45deg);\n      right: 0;\n      width: 10px;\n      height: 2px;\n      background-color: ", ";\n    }\n  "])), function (props) {
  return props.theme.rem(18);
}, function (props) {
  return props.theme.space(6);
}, function (props) {
  return props.theme.footer.title;
}, function (props) {
  return props.theme.space(6);
}, function (props) {
  return props.theme.footer.title;
}));
var Footer_styles_Item = /*#__PURE__*/styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
  componentId: "sc-1xls7qh-8"
})(["display:flex;a,span{cursor:pointer;font-family:IntervalNextReg,sans-serif;font-size:", ";color:", ";text-decoration:none;", "}"], function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.footer.link;
}, theme/* mediaMin.extraSmallBreakpoint */.A3.extraSmallBreakpoint(_templateObject15 || (_templateObject15 = (0,taggedTemplateLiteral/* default */.Z)(["\n      font-size: ", ";\n      margin-left: ", ";\n      padding: ", " 0;\n      border-top: 1px solid ", ";\n      width: 100%;\n      height: 32px;\n      align-items: center;\n      display: flex;\n    "])), function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.space(10);
}, function (props) {
  return props.theme.space(2);
}, function (props) {
  return props.theme.footer.line;
}));
var CopyRight = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1xls7qh-9"
})(["span{display:flex;align-items:center;svg{margin-right:", ";}}"], function (props) {
  return props.theme.space(2);
});
var TermsAndPrivacy = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1xls7qh-10"
})(["display:flex;.terms-of-service,.privacy-policy,.termly-display-preferences{margin-left:", ";}", ""], function (props) {
  return props.theme.space(5);
}, theme/* mediaMin.extraSmallBreakpoint */.A3.extraSmallBreakpoint(_templateObject16 || (_templateObject16 = (0,taggedTemplateLiteral/* default */.Z)(["\n    border-top: 1px solid ", ";\n    padding-bottom: ", ";\n    padding-top: ", ";\n\n    .privacy-policy,\n    .termly-display-preferences {\n      border-left: 1px solid ", ";\n      padding-left: ", ";\n    }\n  "])), function (props) {
  return props.theme.footer.line;
}, function (props) {
  return props.theme.space(4);
}, function (props) {
  return props.theme.space(4);
}, function (props) {
  return props.theme.footer.line;
}, function (props) {
  return props.theme.space(4);
}));
var SocialRow = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1xls7qh-11"
})(["display:flex;align-items:center;padding-bottom:", ";border-bottom:1px solid ", ";& a + a{margin-left:", ";}svg{path{opacity:1;fill:", ";}}", ""], function (props) {
  return props.theme.space(7);
}, function (props) {
  return props.theme.footer.line;
}, function (props) {
  return props.theme.space(4);
}, function (props) {
  return props.theme.footer.text;
}, theme/* mediaMin.extraSmallBreakpoint */.A3.extraSmallBreakpoint(_templateObject17 || (_templateObject17 = (0,taggedTemplateLiteral/* default */.Z)(["\n    order: 2;\n    border-bottom: none;\n    padding-bottom: ", ";\n    padding-top: ", ";\n    align-items: center;\n    justify-content: center;\n  "])), function (props) {
  return props.theme.space(8);
}, function (props) {
  return props.theme.space(10);
}));
var PaymentMethods = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1xls7qh-12"
})(["display:flex;align-items:center;justify-content:center;", ";width:100%;margin-bottom:", ";", ""], function (_ref3) {
  var theme = _ref3.theme;
  return theme.gap(10);
}, function (props) {
  return props.theme.space(10);
}, theme/* mediaMin.smallBreakpoint */.A3.smallBreakpoint(_templateObject18 || (_templateObject18 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding: ", " ", ";\n    flex-wrap: wrap;\n    ", ";\n    height: 116px;\n    margin-bottom: 0;\n  "])), function (props) {
  return props.theme.space(2);
}, function (props) {
  return props.theme.space(3);
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.gap(4);
}));
;// CONCATENATED MODULE: ../shared/src/svg/facebook.js

var facebook_jsx = react.createElement;

var Facebook = function Facebook(props) {
  return facebook_jsx("svg", (0,esm_extends/* default */.Z)({
    width: 10,
    height: 20
  }, props), facebook_jsx("path", {
    d: "M9.821 6.22H6.538V4.634c0-.747.457-.92.779-.92h2.298V.426l-3.33-.01c-3.02 0-3.593 2.449-3.593 4.017v1.787H.384v3.333h2.308v10h3.846v-10H9.5l.321-3.333z",
    fill: "#647A85",
    fillRule: "evenodd",
    fillOpacity: 1,
    opacity: 0.3
  }));
};
/* harmony default export */ var facebook = (Facebook);
;// CONCATENATED MODULE: ../shared/src/svg/instagram.js

var instagram_jsx = react.createElement;

var Instagram = function Instagram(props) {
  return instagram_jsx("svg", (0,esm_extends/* default */.Z)({
    width: 20,
    height: 20
  }, props), instagram_jsx("g", {
    fill: "#647A85",
    fillRule: "evenodd",
    opacity: 1
  }, instagram_jsx("path", {
    d: "M10 1.804c2.67 0 2.985.01 4.04.059.974.044 1.504.207 1.856.344.466.181.8.398 1.15.748.35.35.566.683.747 1.15.137.351.3.88.344 1.855.048 1.055.059 1.37.059 4.04s-.01 2.985-.059 4.04c-.044.974-.207 1.504-.344 1.856-.181.466-.398.8-.748 1.15-.35.35-.683.566-1.15.747-.351.137-.88.3-1.855.344-1.054.048-1.37.059-4.04.059s-2.986-.01-4.04-.059c-.974-.044-1.504-.207-1.856-.344a3.097 3.097 0 0 1-1.15-.748 3.097 3.097 0 0 1-.747-1.15c-.137-.351-.3-.88-.344-1.855-.048-1.055-.059-1.37-.059-4.04s.01-2.985.059-4.04c.044-.974.207-1.504.344-1.856.181-.466.398-.8.748-1.15.35-.35.683-.566 1.15-.747.351-.137.88-.3 1.855-.344 1.055-.048 1.37-.059 4.04-.059m0-1.8c-2.715 0-3.055.01-4.122.06-1.064.048-1.79.217-2.426.464A4.9 4.9 0 0 0 1.68 1.681a4.9 4.9 0 0 0-1.153 1.77C.281 4.089.112 4.815.063 5.879.015 6.945.003 7.285.003 10s.012 3.055.06 4.122c.049 1.064.218 1.79.465 2.426a4.9 4.9 0 0 0 1.153 1.771 4.9 4.9 0 0 0 1.77 1.153c.637.247 1.363.416 2.427.465 1.067.048 1.407.06 4.122.06s3.055-.012 4.122-.06c1.064-.049 1.79-.218 2.426-.465a4.9 4.9 0 0 0 1.771-1.153 4.9 4.9 0 0 0 1.153-1.77c.247-.637.416-1.363.465-2.427.048-1.067.06-1.407.06-4.122s-.012-3.055-.06-4.122c-.049-1.064-.218-1.79-.465-2.426a4.9 4.9 0 0 0-1.153-1.771 4.9 4.9 0 0 0-1.77-1.153c-.637-.247-1.363-.416-2.427-.465C13.055.015 12.715.003 10 .003"
  }), instagram_jsx("path", {
    d: "M10 4.866a5.134 5.134 0 1 0 0 10.268 5.134 5.134 0 0 0 0-10.268zm0 8.466a3.332 3.332 0 1 1 0-6.664 3.332 3.332 0 0 1 0 6.664zM16.536 4.664a1.2 1.2 0 1 1-2.4 0 1.2 1.2 0 0 1 2.4 0"
  })));
};
/* harmony default export */ var instagram = (Instagram);
;// CONCATENATED MODULE: ../shared/src/svg/youtube.js

var youtube_jsx = react.createElement;

var Youtube = function Youtube(props) {
  return youtube_jsx("svg", (0,esm_extends/* default */.Z)({
    width: 24,
    height: 17
  }, props), youtube_jsx("path", {
    d: "M16.538 8.532l-6.769 4.331A.5.5 0 0 1 9 12.441V3.779a.498.498 0 0 1 .769-.421l6.769 4.331a.5.5 0 0 1 0 .843M20.062 0H3.937A3.944 3.944 0 0 0 0 3.94v9.121A3.943 3.943 0 0 0 3.937 17h16.125A3.943 3.943 0 0 0 24 13.061V3.94A3.944 3.944 0 0 0 20.062 0",
    fill: "#647A85",
    fillRule: "evenodd",
    opacity: 0.3
  }));
};
/* harmony default export */ var youtube = (Youtube);
;// CONCATENATED MODULE: ../shared/src/svg/pinterest.js
var pinterest_jsx = react.createElement;

var Pinterest = function Pinterest(props) {
  return pinterest_jsx("svg", {
    width: 21,
    height: 21,
    viewBox: "0 0 21 21"
  }, pinterest_jsx("path", {
    d: "M10.0178 0C4.48506 0 0.00109863 4.55891 0.00109863 10.1819C0.00109863 14.4951 2.64114 18.1826 6.36808 19.6666C6.27984 18.8614 6.20163 17.6221 6.40217 16.7435C6.58465 15.9485 7.5773 11.6821 7.5773 11.6821C7.5773 11.6821 7.2775 11.0716 7.2775 10.1696C7.2775 8.75497 8.08465 7.69806 9.09034 7.69806C9.94562 7.69806 10.3577 8.35035 10.3577 9.13208C10.3577 10.0066 9.81026 11.3122 9.5285 12.523C9.29288 13.5361 10.0288 14.3626 11.0115 14.3626C12.7912 14.3626 14.1609 12.4547 14.1609 9.69978C14.1609 7.26184 12.4373 5.55773 9.9767 5.55773C7.1261 5.55773 5.45264 7.73067 5.45264 9.97598C5.45264 10.8505 5.78452 11.7891 6.19862 12.2998C6.23381 12.3382 6.25867 12.3852 6.27078 12.4363C6.2829 12.4874 6.28188 12.5407 6.26781 12.5913C6.19161 12.9123 6.02215 13.6044 5.99007 13.746C5.94595 13.9325 5.84468 13.9723 5.65417 13.8826C4.40384 13.2904 3.62175 11.4314 3.62175 9.93725C3.62175 6.72574 5.91687 3.77616 10.2404 3.77616C13.7157 3.77616 16.4159 6.29257 16.4159 9.65697C16.4159 13.1671 14.2391 15.9893 11.218 15.9893C10.2023 15.9893 9.24876 15.4542 8.92189 14.8213L8.29722 17.2409C8.07162 18.1255 7.46099 19.2344 7.0529 19.9112C8.01358 20.2127 9.0134 20.3656 10.0188 20.3647C15.5506 20.3647 20.0355 15.8058 20.0355 10.1829C20.0355 4.55992 15.5496 0 10.0178 0Z",
    fill: "#647A85"
  }));
};
/* harmony default export */ var pinterest = (Pinterest);
;// CONCATENATED MODULE: ../shared/src/svg/uniplaces.js

var uniplaces_jsx = react.createElement;

var UniplacesSVG = function UniplacesSVG(props) {
  return uniplaces_jsx("svg", (0,esm_extends/* default */.Z)({
    width: 12,
    height: 15,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), uniplaces_jsx("path", {
    d: "M15.675.482.965 0C.368 0-.07.442.008 1.046l2.47 18.334c.081.602.558.803 1.038.442l1.991-1.407A3.157 3.157 0 0 1 7.5 17.85c.757.04 6.814.442 6.814.442.291.009.575-.093.796-.285.221-.191.364-.46.399-.752l1.154-15.637a1.033 1.033 0 0 0-.58-1.04 1.01 1.01 0 0 0-.407-.096Zm-.327 1.729-.92 14.505a.398.398 0 0 1-.31.36.39.39 0 0 1-.167 0l-4.658-.994c-.679-.123-1.117-.523-1.196-1.167L6.947 4.021a.487.487 0 0 1 .399-.523l7.61-1.618c.233-.072.392.097.392.33Z",
    fill: "#647A85"
  }));
};
/* harmony default export */ var uniplaces = (UniplacesSVG);
;// CONCATENATED MODULE: ../shared/src/utils/insertSubdomain/index.js
var insertSubdomain = function insertSubdomain(originalDomain, subDomain) {
  var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var http = originalDomain.match(/^(?:https?:\/\/)?(?:www\.)?/)[0];
  var domain = originalDomain.replace(http, '');
  var lastChar = originalDomain.substr(-1);
  return lastChar === '/' ? "".concat(http).concat(subDomain, ".").concat(domain).concat(path) : "".concat(http).concat(subDomain, ".").concat(domain, "/").concat(path);
};
;// CONCATENATED MODULE: ../shared/src/constants/footerData.js
/* provided dependency */ var Buffer = __webpack_require__(48834)["lW"];
/* provided dependency */ var footerData_process = __webpack_require__(34406);

var footerData = [{
  title: 'Uniplaces',
  items: [{
    id: '01',
    href: function href(language) {
      return Buffer.from("".concat("https://uniplaces.com/").concat(language, "/about-us")).toString('base64');
    },
    translation: 'footer:About us',
    hideAnchorFromCrawlers: true
  }, {
    id: '02',
    href: function href(language) {
      return Buffer.from("".concat("https://uniplaces.com/").concat(language, "/how-it-works")).toString('base64');
    },
    dataEvent: 'how-it-works-click',
    translation: 'footer:How it works',
    hideAnchorFromCrawlers: true
  }, {
    id: '03',
    href: function href(language) {
      return "".concat("https://uniplaces.com/").concat(language, "/partners");
    },
    translation: 'footer:Partners'
  }, {
    id: '04',
    href: function href() {
      return 'https://newsroom.uniplaces.com/';
    },
    translation: 'footer:Newsroom'
  }, {
    id: '05',
    href: function href() {
      return 'https://find.uniplaces.com/guides/';
    },
    translation: 'footer:Guides'
  }]
}, {
  title: 'footer:Tenants',
  items: [{
    id: '01',
    href: function href(language) {
      return Buffer.from(mappedLinks.bookWithAnAgent[language] || mappedLinks.bookWithAnAgent.other).toString('base64');
    },
    translation: 'footer:Book with an agent',
    hideAnchorFromCrawlers: true
  }, {
    id: '02',
    href: function href(language) {
      return Buffer.from(mappedLinks.inviteFriends[language] || mappedLinks.inviteFriends.en).toString('base64');
    },
    translation: 'footer:Invite friends',
    hideAnchorFromCrawlers: true
  }, {
    id: '03',
    href: function href() {
      return "".concat("https://blog.uniplaces.com/");
    },
    translation: 'footer:Stories'
  }, {
    id: '04',
    href: function href() {
      return Buffer.from("".concat(footerData_process.env.GROUP_BOOKING_URL)).toString('base64');
    },
    translation: 'footer:Group Booking',
    hideAnchorFromCrawlers: true
  }]
}, {
  title: 'footer:Landlords',
  items: [{
    id: '01',
    href: function href(language) {
      return Buffer.from(mappedLinks.howItWorks[language] || mappedLinks.howItWorks.en).toString('base64');
    },
    translation: 'footer:How it works',
    hideAnchorFromCrawlers: true
  }, {
    id: '02',
    href: function href(language) {
      return mappedLinks.startListing[language] || mappedLinks.startListing.en;
    },
    translation: 'footer:Start listing'
  }, {
    id: '03',
    href: function href(language) {
      return mappedLinks.startRent[language] || mappedLinks.startRent.en;
    },
    translation: 'footer:List your place'
  }]
}, {
  title: 'footer:Support',
  items: [{
    id: '01',
    href: function href(language) {
      return Buffer.from("".concat("https://uniplaces.com/").concat(language, "/cancellation-policies")).toString('base64');
    },
    translation: 'footer:Cancellation policies',
    hideAnchorFromCrawlers: true
  }, {
    id: '02',
    href: function href(language) {
      return "".concat("https://help.uniplaces.com/help/s/", "?language=").concat(language);
    },
    translation: 'footer:Help'
  }, {
    id: '03',
    href: function href(language) {
      return Buffer.from(mappedLinks.contactUs[language] || mappedLinks.contactUs.en).toString('base64');
    },
    translation: 'footer:Talk to us',
    hideAnchorFromCrawlers: true
  }]
}, {
  title: 'footer:Join us',
  items: [{
    id: '01',
    href: function href() {
      return "".concat("https://affiliates.uniplaces.com/");
    },
    translation: 'footer:Become an Affiliate'
  }, {
    id: '02',
    href: function href() {
      return "".concat("https://ambassadors.uniplaces.com/");
    },
    translation: 'footer:Become an Ambassador'
  }, {
    id: '03',
    href: function href() {
      return 'https://find.uniplaces.com/b2b/';
    },
    translation: 'footer:B2B Partnerships'
  }, {
    id: '04',
    href: function href() {
      return "".concat("https://careers.staging-uniplaces.com/");
    },
    translation: 'footer:Careers'
  }]
}];
var mappedLinks = {
  howItWorks: {
    en: 'https://find.uniplaces.com/howitworks/landlords/',
    de: 'https://find.uniplaces.com/de/untersttzung/vermieter/',
    es: 'https://find.uniplaces.com/es/como-funciona/propietario/',
    fr: 'https://find.uniplaces.com/fr/comment-ca-marche/propritaire/',
    it: 'https://find.uniplaces.com/it/come-funziona/proprietario/',
    pt: 'https://find.uniplaces.com/pt/como-funciona/propietario/'
  },
  startListing: {
    en: 'https://portal.uniplaces.com/english/home',
    es: 'https://portal.uniplaces.com/espanol/home',
    it: 'https://portal.uniplaces.com/italiano/home',
    pt: 'https://portal.uniplaces.com/portugues/home'
  },
  startRent: {
    en: "".concat(insertSubdomain("".concat("https://uniplaces.com/").replace('www.', ''), 'rent', 'en')),
    de: "".concat(insertSubdomain("".concat("https://uniplaces.com/").replace('www.', ''), 'rent', 'de')),
    es: "".concat(insertSubdomain("".concat("https://uniplaces.com/").replace('www.', ''), 'rent', 'es')),
    fr: "".concat(insertSubdomain("".concat("https://uniplaces.com/").replace('www.', ''), 'rent', 'fr')),
    it: "".concat(insertSubdomain("".concat("https://uniplaces.com/").replace('www.', ''), 'rent', 'it')),
    pt: "".concat(insertSubdomain("".concat("https://uniplaces.com/").replace('www.', ''), 'rent', 'pt'))
  },
  inviteFriends: {
    en: 'https://find.uniplaces.com/referafriend/',
    de: 'https://find.uniplaces.com/referafriend/de/',
    es: 'https://find.uniplaces.com/referafriend/es/',
    fr: 'https://find.uniplaces.com/referafriend/fr/',
    it: 'https://find.uniplaces.com/referafriend/it/',
    pt: 'https://find.uniplaces.com/referafriend/pt/'
  },
  contactUs: {
    en: 'https://find.uniplaces.com/contactsupport/',
    pt: 'https://find.uniplaces.com/pt/apoio/',
    es: 'https://find.uniplaces.com/es/apoyo/',
    de: 'https://find.uniplaces.com/de/untersttzung/',
    fr: 'https://find.uniplaces.com/fr/soutien/',
    it: 'https://find.uniplaces.com/it/supporto/'
  },
  bookWithAnAgent: {
    en: 'https://find.uniplaces.com/talk-to-an-agent/',
    pt: 'https://find.uniplaces.com/fale-com-um-agente/pt/',
    es: 'https://find.uniplaces.com/hable-con-un-agente/es/',
    de: 'https://find.uniplaces.com/sprechen-sie-mit-einem-agenten/de/',
    fr: 'https://find.uniplaces.com/parlez-a-un-agent/fr/',
    it: 'https://find.uniplaces.com/parlare-con-un-agente/it/',
    other: 'https://find.uniplaces.com/find-accommodation-europe/'
  }
};
;// CONCATENATED MODULE: ../shared/src/components/TermlyConsentLink/index.js
var TermlyConsentLink_jsx = react.createElement;

var TermlyConsentLink = function TermlyConsentLink(_ref) {
  var title = _ref.title;
  return TermlyConsentLink_jsx("span", {
    className: "termly-display-preferences",
    role: "button"
  }, title);
};
/* harmony default export */ var components_TermlyConsentLink = (TermlyConsentLink);
;// CONCATENATED MODULE: ../shared/src/svg/amex.js

var amex_jsx = react.createElement;

var Amex = function Amex(props) {
  return amex_jsx("svg", (0,esm_extends/* default */.Z)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 40,
    fill: "none"
  }, props), amex_jsx("path", {
    fill: "#F7F7F7",
    d: "M0 5a5 5 0 0 1 5-5h50a5 5 0 0 1 5 5v30a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5V5Z"
  }), amex_jsx("path", {
    fill: "#2557D6",
    d: "m44.278 12.338-1.16 2.56h2.328l-1.168-2.56Zm-13.396 1.586c.219-.104.348-.33.348-.61 0-.275-.136-.474-.355-.568-.199-.104-.505-.116-.8-.116H28v1.426h2.049c.328 0 .602-.004.834-.132ZM4.268 12.338l-1.147 2.56h2.302l-1.155-2.56Zm53.44 16.395H54.45v-1.377h3.244c.321 0 .547-.038.682-.159.128-.107.201-.26.2-.418a.507.507 0 0 0-.206-.425c-.123-.098-.301-.142-.595-.142-1.584-.05-3.56.044-3.56-1.988 0-.931.65-1.912 2.42-1.912h3.36v-1.277h-3.121c-.942 0-1.627.205-2.111.524v-.524h-4.617c-.739 0-1.605.166-2.015.524v-.524h-8.245v.524c-.657-.43-1.764-.524-2.275-.524h-5.439v.524c-.519-.457-1.673-.524-2.377-.524H23.71l-1.392 1.371-1.305-1.371H11.92v8.96h8.92l1.436-1.393 1.352 1.393 5.499.005v-2.108h.54c.73.01 1.59-.016 2.35-.315v2.418h4.535V27.66h.22c.278 0 .306.01.306.264v2.07h13.779c.875 0 1.79-.203 2.295-.573v.574h4.37c.91 0 1.799-.116 2.474-.413v-1.67c-.41.546-1.208.822-2.288.822ZM29.74 26.618h-2.105v2.154h-3.278l-2.077-2.126-2.159 2.125h-6.68v-6.42h6.783l2.075 2.104 2.146-2.105h5.39c1.338 0 2.842.337 2.842 2.116 0 1.784-1.463 2.152-2.937 2.152Zm10.12-.291c.238.313.273.606.28 1.172v1.273h-1.694v-.804c0-.386.04-.958-.273-1.257-.246-.23-.622-.284-1.237-.284h-1.803v2.345h-1.695V22.35h3.894c.855 0 1.476.035 2.03.303.532.293.867.694.867 1.426 0 1.025-.751 1.548-1.195 1.709.375.126.682.352.826.539Zm6.967-2.649h-3.95v1.168h3.854v1.31h-3.854v1.277l3.95.006v1.332h-5.63v-6.42h5.63v1.327Zm4.335 5.093h-3.285v-1.377h3.271c.32 0 .547-.038.69-.159.115-.099.199-.243.199-.418a.532.532 0 0 0-.206-.425c-.13-.098-.307-.142-.6-.142-1.578-.05-3.554.044-3.554-1.988 0-.931.644-1.912 2.412-1.912h3.382v1.367h-3.095c-.306 0-.506.01-.675.116-.185.104-.254.258-.254.462 0 .242.157.407.37.478.177.057.368.073.656.073l.908.023c.915.02 1.544.164 1.926.516.328.309.505.7.505 1.36 0 1.382-.95 2.026-2.65 2.026Zm-13.082-4.99c-.204-.11-.505-.115-.805-.115h-2.077v1.442h2.05c.327 0 .606-.01.832-.132a.678.678 0 0 0 .35-.617c0-.274-.132-.473-.35-.577Zm18.846-.115c-.307 0-.511.01-.683.116-.178.104-.246.258-.246.462 0 .242.15.407.368.478.178.056.37.073.65.073l.915.022c.922.02 1.538.165 1.913.517.069.049.11.104.157.159v-1.827h-3.074Zm-27.128 0h-2.2V25.3h2.18c.649 0 1.052-.292 1.052-.848 0-.561-.423-.787-1.032-.787Zm-14.678 0v1.167h3.703v1.31H15.12v1.278h4.147l1.927-1.884-1.845-1.871H15.12Zm10.829 4.49v-5.148l-2.59 2.533 2.59 2.615Zm-10.687-10.31v1.107h14.091l-.006-2.34h.273c.19.005.246.021.246.308v2.032h7.289v-.545c.587.287 1.502.545 2.705.545h3.066l.656-1.426h1.455l.642 1.426h5.909V17.6l.894 1.354h4.735V10h-4.686v1.057L51.875 10h-4.808v1.057L46.464 10H39.97c-1.087 0-2.043.138-2.815.523V10h-4.482v.523c-.491-.397-1.16-.523-1.905-.523H14.393l-1.1 2.312L12.167 10H7.007v1.057L6.44 10H2.043L0 14.257v3.405l3.02-6.42h2.507l2.868 6.078v-6.078h2.753l2.207 4.355 2.028-4.355h2.809v6.42h-1.73l-.006-5.028-2.445 5.028H12.53l-2.452-5.032v5.032H6.647l-.648-1.432H2.487l-.655 1.432H0v1.291h2.882l.65-1.425h1.455l.648 1.425h5.67v-1.09l.506 1.095h2.944l.506-1.111Zm22.205-5.855c.545-.513 1.4-.75 2.562-.75h1.633v1.376h-1.599c-.615 0-.963.084-1.298.38-.287.271-.485.782-.485 1.455 0 .688.15 1.184.464 1.508.26.254.732.33 1.176.33h.758l2.377-5.048h2.527l2.856 6.072v-6.072h2.568l2.965 4.471v-4.47h1.727v6.419h-2.39l-3.197-4.819v4.819h-3.435l-.656-1.432h-3.504l-.637 1.432h-1.974c-.82 0-1.858-.165-2.446-.71-.593-.545-.9-1.284-.9-2.451-.001-.952.183-1.823.908-2.51Zm-3.469-.75h1.721v6.42h-1.721v-6.42Zm-7.76 0h3.88c.862 0 1.497.022 2.043.308.533.287.853.706.853 1.422 0 1.024-.75 1.552-1.188 1.711.369.128.684.354.834.54.239.32.28.605.28 1.179v1.26h-1.702l-.006-.809c0-.386.04-.942-.266-1.25-.247-.226-.622-.275-1.23-.275h-1.81v2.335h-1.687v-6.42Zm-6.799 0h5.635v1.338h-3.948v1.157h3.853v1.316h-3.853v1.282h3.948v1.328h-5.635v-6.42Z"
  }));
};
/* harmony default export */ var amex = (Amex);
;// CONCATENATED MODULE: ../shared/src/svg/klarna.js

var klarna_jsx = react.createElement;

var Klarna = function Klarna(props) {
  return klarna_jsx("svg", (0,esm_extends/* default */.Z)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 40,
    fill: "none",
    viewBox: "0 0 60 40"
  }, props), klarna_jsx("path", {
    fill: "#FFB3C7",
    d: "M0 5a5 5 0 0 1 5-5h50a5 5 0 0 1 5 5v30a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5V5Z"
  }), klarna_jsx("path", {
    fill: "#1D1D1B",
    d: "M55 24.128v.036a1.435 1.435 0 1 1-1.428-1.442h.012a1.411 1.411 0 0 1 1.415 1.406ZM46.91 23.583a1.986 1.986 0 1 1-.146-3.966 1.985 1.985 0 1 1 .147 3.966Zm1.99-5.807v.494a4.025 4.025 0 1 0 0 6.662v.494h2.27v-7.65H48.9ZM41.85 20.55v4.847h-2.27v-4.033c0-1.108-.575-1.709-1.562-1.709a.735.735 0 0 0-.24 0 1.62 1.62 0 0 0-1.47 1.737v4.018h-2.282v-7.65h2.256v.867a2.752 2.752 0 0 1 2.337-1.069c.067 0 .146-.013.213-.013a3.012 3.012 0 0 1 3.018 3.006ZM32.97 17.785v2.216h-.027c-.894 0-2.189.654-2.189 1.855v3.579H28.43v-7.65h2.31v1.001a2.866 2.866 0 0 1 2.23-1ZM22.98 23.567a1.985 1.985 0 1 1 1.977-1.994v.004a2.06 2.06 0 0 1-1.976 1.99Zm1.99-5.808v.494a3.982 3.982 0 0 0-2.243-.708 4.032 4.032 0 0 0 0 8.064c.802 0 1.583-.24 2.244-.694v.494h2.27v-7.651l-2.27.001ZM17.82 14.373h-2.377V25.43h2.377V14.373ZM7.51 14.373H5V25.43h2.51V14.373ZM14.692 25.429h-3.115l-3.765-5.194.975-.734a6.383 6.383 0 0 0 2.536-5.128h2.457a8.839 8.839 0 0 1-2.563 6.275l3.475 4.78Z"
  }));
};
/* harmony default export */ var klarna = (Klarna);
;// CONCATENATED MODULE: ../shared/src/svg/mastercard.js

var mastercard_jsx = react.createElement;

var Mastercard = function Mastercard(props) {
  return mastercard_jsx("svg", (0,esm_extends/* default */.Z)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 40,
    fill: "none"
  }, props), mastercard_jsx("path", {
    fill: "#F7F7F7",
    d: "M0 5a5 5 0 0 1 5-5h50a5 5 0 0 1 5 5v30a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5V5Z"
  }), mastercard_jsx("path", {
    fill: "#FF5F00",
    d: "m36.26 8.16-12.91.044.39 23.637 12.912-.044-.392-23.638Z"
  }), mastercard_jsx("path", {
    fill: "#EB001B",
    d: "M24.198 20.07c-.08-4.807 2.074-9.08 5.448-11.85-2.547-1.998-5.739-3.2-9.2-3.188-8.197.028-14.717 6.782-14.58 15.101.14 8.32 6.883 15.027 15.081 15a14.43 14.43 0 0 0 9.092-3.251c-3.465-2.706-5.76-7.004-5.84-11.812Z"
  }), mastercard_jsx("path", {
    fill: "#F79E1B",
    d: "M54.133 19.868c.139 8.32-6.382 15.073-14.58 15.1-3.46.013-6.652-1.189-9.199-3.187 3.415-2.77 5.527-7.043 5.447-11.85a15.396 15.396 0 0 0-5.84-11.812 14.43 14.43 0 0 1 9.092-3.25c8.198-.028 14.943 6.722 15.08 14.999Z"
  }));
};
/* harmony default export */ var mastercard = (Mastercard);
;// CONCATENATED MODULE: ../shared/src/svg/paypal.js

var paypal_jsx = react.createElement;

var Paypal = function Paypal(props) {
  return paypal_jsx("svg", (0,esm_extends/* default */.Z)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 40,
    viewBox: "0 0 60 40",
    fill: "none"
  }, props), paypal_jsx("path", {
    fill: "#F7F7F7",
    d: "M0 5a5 5 0 0 1 5-5h50a5 5 0 0 1 5 5v30a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5V5Z"
  }), paypal_jsx("path", {
    fill: "#2199D6",
    d: "M40.319 12.54c0 .16 0 .321-.16.482-1.284 6.417-5.455 8.502-10.91 8.502h-2.727c-.641 0-1.283.482-1.283 1.123l-1.444 8.984-.32 2.567c0 .481.32.802.64.802h4.974c.642 0 1.123-.481 1.123-.962v-.321l.963-5.776v-.32c.16-.642.641-.963 1.123-.963h.802c4.813 0 8.502-1.925 9.465-7.54.481-2.407.16-4.332-.962-5.615-.321-.321-.803-.642-1.284-.963Z"
  }), paypal_jsx("path", {
    fill: "#252C5E",
    d: "M39.036 12.06c-.16 0-.32-.161-.641-.161-.16 0-.482-.16-.642-.16-.802-.161-1.604-.161-2.406-.161h-7.38c-.16 0-.32 0-.481.16-.321.16-.642.482-.642.802l-1.604 9.947v.32c.16-.64.641-1.122 1.283-1.122h2.727c5.455 0 9.626-2.246 10.91-8.503 0-.16 0-.32.16-.481l-.963-.481c-.16-.16-.32-.16-.32-.16Z"
  }), paypal_jsx("path", {
    fill: "#263577",
    d: "M26.844 12.54c0-.32.321-.641.642-.802.16 0 .321-.16.481-.16h7.38c.802 0 1.765 0 2.407.16.16 0 .48 0 .641.16.16 0 .321.161.642.161.16 0 .16 0 .32.16.322.16.642.321.963.482.321-2.407 0-4.01-1.283-5.455C37.593 5.642 35.027 5 31.817 5h-9.465c-.641 0-1.283.482-1.283 1.123l-3.85 24.706c0 .481.32.963.802.963h5.775l1.444-9.305 1.604-9.947Z"
  }));
};
/* harmony default export */ var paypal = (Paypal);
;// CONCATENATED MODULE: ../shared/src/svg/visa.js

var visa_jsx = react.createElement;

var Visa = function Visa(props) {
  return visa_jsx("svg", (0,esm_extends/* default */.Z)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 40,
    fill: "none"
  }, props), visa_jsx("path", {
    fill: "#F7F7F7",
    d: "M0 5a5 5 0 0 1 5-5h50a5 5 0 0 1 5 5v30a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5V5Z"
  }), visa_jsx("path", {
    fill: "#3362AB",
    d: "M51.638 12.544h-3.143c-.95 0-1.681.292-2.12 1.242l-5.994 13.67h4.24s.73-1.828.877-2.266h5.19c.146.512.512 2.193.512 2.193H55l-3.362-14.84Zm-4.97 9.576c.365-.878 1.608-4.167 1.608-4.167 0 .073.365-.877.511-1.389l.293 1.316s.804 3.582.95 4.313h-3.363v-.073ZM40.672 22.559c0 3.07-2.778 5.117-7.091 5.117-1.828 0-3.582-.366-4.532-.804l.585-3.363.511.22c1.316.584 2.193.803 3.802.803 1.17 0 2.412-.438 2.412-1.462 0-.658-.512-1.096-2.12-1.827-1.535-.731-3.582-1.9-3.582-4.02 0-2.925 2.85-4.898 6.871-4.898 1.535 0 2.851.292 3.655.658l-.584 3.216-.293-.292c-.73-.293-1.681-.585-3.07-.585-1.535.073-2.266.73-2.266 1.316 0 .657.877 1.17 2.266 1.827 2.34 1.096 3.436 2.34 3.436 4.094Z"
  }), visa_jsx("path", {
    fill: "#F9B50B",
    d: "m5 12.69.073-.292h6.286c.877 0 1.535.292 1.755 1.243l1.388 6.579C13.113 16.71 9.897 13.86 5 12.69Z"
  }), visa_jsx("path", {
    fill: "#3362AB",
    d: "m23.346 12.544-6.36 14.839h-4.312L9.019 14.956c2.632 1.681 4.825 4.313 5.629 6.14l.438 1.535 3.948-10.16h4.313v.073ZM25.03 12.47h4.02L26.49 27.384h-4.02l2.558-14.912Z"
  }));
};
/* harmony default export */ var visa = (Visa);
;// CONCATENATED MODULE: ../shared/src/svg/apple-pay.js

var apple_pay_jsx = react.createElement;

var ApplePay = function ApplePay(props) {
  return apple_pay_jsx("svg", (0,esm_extends/* default */.Z)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 24,
    viewBox: "0 0 55 24",
    fill: "none"
  }, props), apple_pay_jsx("path", {
    fill: "#224251",
    d: "M17.831 20.278c-1.034.95-2.162.8-3.25.35-1.149-.46-2.204-.48-3.417 0-1.52.62-2.32.44-3.228-.35-5.148-5.03-4.389-12.689 1.456-12.969 1.424.07 2.415.74 3.249.8 1.245-.24 2.437-.93 3.766-.84 1.593.12 2.796.72 3.587 1.8-3.292 1.87-2.511 5.98.506 7.13-.601 1.5-1.382 2.989-2.68 4.089l.011-.01ZM12.535 7.249C12.377 5.02 14.287 3.18 16.481 3c.306 2.58-2.469 4.5-3.946 4.25ZM29.89 19V7.64h4.063c1.1 0 1.987.331 2.664.993.677.661 1.016 1.536 1.016 2.625 0 1.078-.339 1.95-1.016 2.617s-1.565 1-2.664 1h-2.492V19h-1.57Zm1.57-5.438h2.243c.75 0 1.32-.205 1.711-.617.396-.416.594-.979.594-1.687 0-.708-.198-1.268-.594-1.68-.39-.417-.96-.625-1.71-.625H31.46v4.61Zm6.892 3.47c0-.876.442-1.542 1.328-2 .89-.46 2.172-.704 3.843-.735v-.164c0-.594-.174-1.06-.523-1.399-.349-.343-.805-.515-1.367-.515-.412 0-.834.07-1.266.21a3.83 3.83 0 0 0-1.101.555l-.43-.93c.349-.301.792-.541 1.328-.718a4.997 4.997 0 0 1 1.617-.274c1.005 0 1.805.287 2.399.86.599.568.898 1.349.898 2.344V19h-1.492v-1.281c-.208.437-.576.786-1.102 1.047a3.77 3.77 0 0 1-1.695.39 3.13 3.13 0 0 1-1.187-.218 2.063 2.063 0 0 1-.891-.711c-.24-.329-.36-.727-.36-1.196Zm1.57-.157c0 .328.107.594.32.797.219.203.508.305.867.305a2.26 2.26 0 0 0 1.72-.743c.463-.494.694-1.132.694-1.914v-.078c-1.15.031-2.039.19-2.664.477-.625.286-.937.672-.937 1.156Zm6.21-5.523v-.125h1.65l2.202 6.171 2.164-6.171h1.602v.125l-3.477 9.007c-.479 1.26-1.257 1.891-2.336 1.891-.677 0-1.273-.14-1.789-.422l.383-1.039c.417.182.774.273 1.07.273.334 0 .597-.09.79-.273.192-.182.372-.469.539-.86l.242-.718-3.04-7.86Z"
  }));
};
/* harmony default export */ var apple_pay = (ApplePay);
;// CONCATENATED MODULE: ../shared/src/svg/google-pay.js

var google_pay_jsx = react.createElement;

var GooglePay = function GooglePay(props) {
  return google_pay_jsx("svg", (0,esm_extends/* default */.Z)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 24,
    viewBox: "0 0 55 24",
    fill: "none"
  }, props), google_pay_jsx("path", {
    fill: "#4285F4",
    d: "M21.518 12.298c0-.62-.07-1.239-.139-1.858h-8.687v3.511h4.934c-.208 1.102-.834 2.134-1.807 2.754v2.272h2.989c1.737-1.583 2.71-3.924 2.71-6.678"
  }), google_pay_jsx("path", {
    fill: "#34A853",
    d: "M12.691 21.182c2.502 0 4.587-.826 6.116-2.203l-2.988-2.273c-.835.551-1.877.895-3.128.895-2.363 0-4.448-1.583-5.143-3.786H4.49v2.34c1.599 3.099 4.726 5.027 8.201 5.027Z"
  }), google_pay_jsx("path", {
    fill: "#FBBC04",
    d: "M7.548 13.814c-.417-1.102-.417-2.341 0-3.512v-2.34H4.49c-1.32 2.547-1.32 5.577 0 8.193l3.058-2.341Z"
  }), google_pay_jsx("path", {
    fill: "#EA4335",
    d: "M12.691 6.584a5.2 5.2 0 0 1 3.545 1.377l2.64-2.616c-1.667-1.515-3.891-2.41-6.115-2.341-3.475 0-6.672 1.928-8.2 5.026l3.057 2.341c.625-2.203 2.71-3.787 5.073-3.787Z"
  }), google_pay_jsx("path", {
    fill: "#224251",
    d: "M29.89 19V7.64h4.063c1.1 0 1.987.331 2.664.993.677.661 1.016 1.536 1.016 2.625 0 1.078-.339 1.95-1.016 2.617s-1.565 1-2.664 1h-2.492V19h-1.57Zm1.57-5.438h2.243c.75 0 1.32-.205 1.711-.617.396-.416.594-.979.594-1.687 0-.708-.198-1.268-.594-1.68-.39-.417-.96-.625-1.71-.625H31.46v4.61Zm6.892 3.47c0-.876.442-1.542 1.328-2 .89-.46 2.172-.704 3.843-.735v-.164c0-.594-.174-1.06-.523-1.399-.349-.343-.805-.515-1.367-.515-.412 0-.834.07-1.266.21a3.83 3.83 0 0 0-1.101.555l-.43-.93c.349-.301.792-.541 1.328-.718a4.997 4.997 0 0 1 1.617-.274c1.005 0 1.805.287 2.399.86.599.568.898 1.349.898 2.344V19h-1.492v-1.281c-.208.437-.576.786-1.102 1.047a3.77 3.77 0 0 1-1.695.39 3.13 3.13 0 0 1-1.187-.218 2.063 2.063 0 0 1-.891-.711c-.24-.329-.36-.727-.36-1.196Zm1.57-.157c0 .328.107.594.32.797.219.203.508.305.867.305a2.26 2.26 0 0 0 1.72-.743c.463-.494.694-1.132.694-1.914v-.078c-1.15.031-2.039.19-2.664.477-.625.286-.937.672-.937 1.156Zm6.21-5.523v-.125h1.65l2.202 6.171 2.164-6.171h1.602v.125l-3.477 9.007c-.479 1.26-1.257 1.891-2.336 1.891-.677 0-1.273-.14-1.789-.422l.383-1.039c.417.182.774.273 1.07.273.334 0 .597-.09.79-.273.192-.182.372-.469.539-.86l.242-.718-3.04-7.86Z"
  }));
};
/* harmony default export */ var google_pay = (GooglePay);
;// CONCATENATED MODULE: ../shared/src/constants/payment-methods.js







var PAYMENT_METHODS = [{
  name: 'visa',
  Icon: visa
}, {
  name: 'american-express',
  Icon: amex
}, {
  name: 'mastercard',
  Icon: mastercard
}, {
  name: 'paypal',
  Icon: paypal
}, {
  name: 'klarna',
  Icon: klarna
}, {
  name: 'apple-pay',
  Icon: apple_pay
}, {
  name: 'google-pay',
  Icon: google_pay
}];
;// CONCATENATED MODULE: ../shared/src/components/Footer/index.js

var Footer_excluded = ["t", "language", "withPaymentMethods"];
var Footer_jsx = react.createElement;













var Footer = function Footer(_ref) {
  var t = _ref.t,
    language = _ref.language,
    _ref$withPaymentMetho = _ref.withPaymentMethods,
    withPaymentMethods = _ref$withPaymentMetho === void 0 ? false : _ref$withPaymentMetho,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, Footer_excluded);
  var _useState = (0,react.useState)(false),
    isMounted = _useState[0],
    setIsMounted = _useState[1];
  var _useRouter = (0,next_router.useRouter)(),
    pathname = _useRouter.pathname,
    locale = _useRouter.locale;
  var domainUrl = (0,redirect/* getHomepageByLocale */.sg)(pathname, locale);
  var onClickableElementClick = function onClickableElementClick(url) {
    return window.open(decodeURIComponent(window.atob(url)));
  };
  var getClickableElement = (0,react.useCallback)(function (url, translation, hideAnchorFromCrawlers) {
    if (!hideAnchorFromCrawlers || !url) {
      return null;
    }
    return !isMounted ? Footer_jsx("span", null, t(translation)) : Footer_jsx("span", {
      onClick: function onClick() {
        return onClickableElementClick(url);
      }
    }, t(translation));
  }, [isMounted]);
  (0,react.useEffect)(function () {
    return setIsMounted(true);
  }, []);
  return Footer_jsx(FooterWrapper, props, withPaymentMethods && Footer_jsx(PaymentMethods, null, PAYMENT_METHODS.map(function (_ref2) {
    var name = _ref2.name,
      Icon = _ref2.Icon;
    return Footer_jsx(Icon, {
      key: "".concat(name, "-footer-icon")
    });
  })), Footer_jsx(InnerFooter, null, Footer_jsx(SocialRow, null, Footer_jsx("a", {
    rel: "noopener noreferrer",
    target: "_blank",
    href: "https://www.facebook.com/uniplaces.pt",
    title: "Facebook"
  }, Footer_jsx(facebook, null)), Footer_jsx("a", {
    rel: "noopener noreferrer",
    target: "_blank",
    href: "https://www.instagram.com/uniplaces",
    title: "Instagram"
  }, Footer_jsx(instagram, null)), Footer_jsx("a", {
    rel: "noopener noreferrer",
    target: "_blank",
    href: "https://www.youtube.com/user/uniplacesvideos",
    title: "Youtube"
  }, Footer_jsx(youtube, null)), Footer_jsx("a", {
    rel: "noopener noreferrer",
    target: "_blank",
    href: "https://www.pinterest.com/uniplaces",
    title: "Pinterest"
  }, Footer_jsx(pinterest, null))), Footer_jsx(Grid, null, footerData.map(function (_ref3) {
    var title = _ref3.title,
      items = _ref3.items;
    return Footer_jsx(GridColumn, {
      key: title
    }, Footer_jsx(HiddenCheckbox, {
      id: title,
      type: "checkbox"
    }), Footer_jsx(Footer_styles_Label, {
      htmlFor: title
    }, t(title)), Footer_jsx(CollapsibleSection, null, items.map(function (_ref4) {
      var id = _ref4.id,
        href = _ref4.href,
        translation = _ref4.translation,
        link = _ref4.link,
        dataEvent = _ref4.dataEvent,
        hideAnchorFromCrawlers = _ref4.hideAnchorFromCrawlers;
      return Footer_jsx(Footer_styles_Item, {
        key: id
      }, href(language) && !hideAnchorFromCrawlers ? Footer_jsx("a", {
        href: href(language),
        rel: "noopener noreferrer",
        target: "_blank"
      }, t(translation)) : getClickableElement(href(language), translation, hideAnchorFromCrawlers), link && !hideAnchorFromCrawlers ? Footer_jsx((link_default()), {
        href: link,
        "data-event": dataEvent
      }, t(translation)) : getClickableElement(link, translation, hideAnchorFromCrawlers));
    })));
  })), Footer_jsx(FooterRow, null, Footer_jsx(CopyRight, null, Footer_jsx("span", {
    className: "copy-right",
    onClick: function onClick() {
      return window.open(domainUrl);
    }
  }, Footer_jsx(uniplaces, null), " \xA9 ".concat(new Date().getFullYear(), " Uniplaces, ").concat(t('footer:All rights reserved')))), Footer_jsx(TermsAndPrivacy, null, Footer_jsx("span", {
    className: "terms-of-service",
    onClick: function onClick() {
      return window.open("".concat("https://uniplaces.com/").concat(language, "/terms/terms-of-service"));
    }
  }, t('footer:Terms')), Footer_jsx("span", {
    className: "privacy-policy",
    onClick: function onClick() {
      return window.open("".concat("https://uniplaces.com/").concat(language, "/terms/privacy-policy"));
    }
  }, t('footer:Privacy')), Footer_jsx(components_TermlyConsentLink, {
    className: "termly",
    title: t('footer:Consent Preferences')
  })))));
};
/* harmony default export */ var components_Footer = (Footer);
;// CONCATENATED MODULE: ./src/containers/Offer/View/styles.js


var View_styles_templateObject, View_styles_templateObject2;





var OfferHeader = /*#__PURE__*/(0,styled_components_browser_esm/* default */.ZP)(components_Header).withConfig({
  componentId: "sc-qsd4zc-0"
})(["nav{z-index:3;}"]);
var OfferFooter = /*#__PURE__*/(0,styled_components_browser_esm/* default */.ZP)(components_Footer).withConfig({
  componentId: "sc-qsd4zc-1"
})(["", " ", ""], theme/* mediaMin.mediumBreakpoint */.A3.mediumBreakpoint(View_styles_templateObject || (View_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding-bottom: ", ";\n  "])), function (props) {
  return props.theme.space(24);
}), theme/* tabletRange.ipad */.zM.ipad()(View_styles_templateObject2 || (View_styles_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    padding-bottom: ", ";\n  "])), function (props) {
  return props.theme.space(26);
}));
var InfoSection = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-qsd4zc-2"
})(["display:flex;flex-direction:column;gap:", ";width:100%;"], function (props) {
  return props.theme.gap(4, 'column');
});
;// CONCATENATED MODULE: ./src/containers/Offer/View/Desktop/index.js

var View_Desktop_jsx = react.createElement;
























var WhereYoullBeLiving = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 26314).then(__webpack_require__.bind(__webpack_require__, 26314));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(26314)];
    }
  }
});
var HEADER_SIZE = 60;
var TABS_SIZE = 40;
var TABS = [{
  id: 'Overview',
  label: 'Overview'
}, {
  id: 'Availability',
  label: 'Availability'
}, {
  id: 'Landlord',
  label: 'Landlord'
}, {
  id: 'Services and expenses',
  label: 'Services and expenses'
}, {
  id: 'Contract',
  label: 'Contract'
}];

var OfferViewDesktop = function OfferViewDesktop(_ref) {
  var trackQuickPageNavigationAction = _ref.trackQuickPageNavigationAction,
      rentalRegistrationCode = _ref.rentalRegistrationCode;

  var _useInView = useInView({
    triggerOnce: true,
    rootMargin: '200px 0px'
  }),
      _useInView2 = (0,slicedToArray/* default */.Z)(_useInView, 2),
      whereYoullBeLivingRef = _useInView2[0],
      isWhereYoullBeLivingInView = _useInView2[1];

  var onTabClick = (0,react.useCallback)(function (sectionName) {
    var targetElement = document.getElementById(sectionName);

    if (!targetElement) {
      return;
    }

    var elementPosition = targetElement.getBoundingClientRect().top + window.scrollY;
    var offsetPosition = elementPosition - (HEADER_SIZE + TABS_SIZE);
    trackQuickPageNavigationAction(sectionName);
    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  }, []);
  return View_Desktop_jsx(Main, null, View_Desktop_jsx(HeaderTitle_Desktop, null), View_Desktop_jsx(components_Gallery, null), View_Desktop_jsx(styles_Content, null, View_Desktop_jsx(LeftSideContent, null, View_Desktop_jsx(Unisystem_Tabs, {
    tabs: TABS,
    onSelectTab: onTabClick
  }), View_Desktop_jsx(components_Overview, null), View_Desktop_jsx(Separator/* default */.Z, null), View_Desktop_jsx(components_Availability, null), View_Desktop_jsx(Separator/* default */.Z, null), View_Desktop_jsx(components_Landlord, null), View_Desktop_jsx(Separator/* default */.Z, null), View_Desktop_jsx(components_ServicesExpenses, null), View_Desktop_jsx(Separator/* default */.Z, null), View_Desktop_jsx(components_RentalConditions, null), View_Desktop_jsx(Separator/* default */.Z, null), View_Desktop_jsx(components_Contract, null), View_Desktop_jsx(Separator/* default */.Z, null), View_Desktop_jsx("div", {
    ref: whereYoullBeLivingRef
  }, isWhereYoullBeLivingInView ? View_Desktop_jsx(WhereYoullBeLiving, null) : View_Desktop_jsx(SectionPlaceholder, null)), View_Desktop_jsx(src_components_Reviews, null), View_Desktop_jsx(components_WhyRentWithUniplaces, null), View_Desktop_jsx(src_components_FAQ, null)), View_Desktop_jsx(RightSideContent, null, View_Desktop_jsx(PricingBox_Desktop, null))), View_Desktop_jsx(components_MorePlacesLikeThis, null), View_Desktop_jsx(InfoSection, null, rentalRegistrationCode && View_Desktop_jsx(components_RegistrationNumber, {
    registrationNumber: rentalRegistrationCode
  }), View_Desktop_jsx(Breadcrumbs, null)));
};

var View_Desktop_mapStateToProps = function mapStateToProps(_ref2) {
  var _contract$landlord_po, _contract$landlord_po2;

  var contract = _ref2.offer.offerAggregate.accommodation_offer.contract;
  return {
    rentalRegistrationCode: contract === null || contract === void 0 ? void 0 : (_contract$landlord_po = contract.landlord_policies) === null || _contract$landlord_po === void 0 ? void 0 : (_contract$landlord_po2 = _contract$landlord_po.rental_registration_code) === null || _contract$landlord_po2 === void 0 ? void 0 : _contract$landlord_po2.value
  };
};

var View_Desktop_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    trackQuickPageNavigationAction: function trackQuickPageNavigationAction(sectionName) {
      return dispatch((0,actions_tracking/* trackQuickPageNavigation */._f)({
        sectionName: sectionName
      }));
    }
  };
};

/* harmony default export */ var View_Desktop = ((0,es/* connect */.$j)(View_Desktop_mapStateToProps, View_Desktop_mapDispatchToProps)(OfferViewDesktop));
;// CONCATENATED MODULE: ./src/containers/Offer/View/Mobile/styles.js


var View_Mobile_styles_templateObject;







var styles_Main = /*#__PURE__*/styled_components_browser_esm/* default.main.withConfig */.ZP.main.withConfig({
  componentId: "sc-177ktdk-0"
})(["display:flex;flex-direction:column;align-items:center;justify-content:center;", " padding-bottom:", ";padding-inline:", ";@supports not (padding-inline:", "){padding-left:", ";padding-right:", ";}", "{width:100%;align-items:flex-start;}", "{flex-wrap:wrap;}", "{", "}"], function (_ref) {
  var theme = _ref.theme;
  return theme.gap(7, 'column');
}, function (props) {
  return props.theme.space(20);
}, function (props) {
  return props.theme.space(5);
}, function (props) {
  return props.theme.space(5);
}, function (props) {
  return props.theme.space(5);
}, function (props) {
  return props.theme.space(5);
}, Title, CustomBreadcrumbs_styles_Wrapper, RegistrationNumber_styles_Container, theme/* mediaMin.smallBreakpoint */.A3.smallBreakpoint(View_Mobile_styles_templateObject || (View_Mobile_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n      ", " {\n        left: auto;\n        right: 0;\n        transform: none;\n      }\n    "])), Tooltip_styles/* TooltipContainer */.DY));
var styles_SectionPlaceholder = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-177ktdk-1"
})(["min-height:400px;"]);
// EXTERNAL MODULE: ../shared/src/hooks/useScrollLock/index.js
var useScrollLock = __webpack_require__(92310);
;// CONCATENATED MODULE: ./src/components/PricingBox/Mobile/styles.js



var MainWrapper = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1jq8m7l-0"
})(["position:fixed;z-index:1;width:100%;bottom:0;border-radius:20px;margin-bottom:0;> ", "{margin:", ";box-shadow:", ";}"], StatusBanner_styles/* Wrapper */.im, function (props) {
  return props.theme.space(2);
}, function (props) {
  return props.theme.pricingBox.notification.boxShadow;
});
var PricingBox_Mobile_styles_Wrapper = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1jq8m7l-1"
})(["display:flex;flex-direction:column;", " background:", ";border-radius:20px 20px 0 0;height:fit-content;border-top:1px solid ", ";padding:", ";color:", ";> ", "{width:100%;}& > p{font-size:", ";color:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.gap(2, 'column');
}, function (props) {
  return props.theme.pricingBox.background;
}, function (props) {
  return props.theme.pricingBox.border;
}, function (props) {
  return props.theme.space(4);
}, function (props) {
  return props.theme.pricingBox.price.mainColor;
}, Button_styles/* Wrapper */.i, function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.pricingBox.dates.label;
});
var Mobile_styles_Content = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1jq8m7l-2"
})(["width:100%;display:flex;justify-content:space-between;align-items:center;", "{min-width:160px;width:fit-content;}"], Button_styles/* Wrapper */.i);
var LeftSection = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1jq8m7l-3"
})(["display:flex;flex-direction:column;justify-content:space-between;gap:", ";"], function (props) {
  return props.theme.space(1);
});
var Mobile_styles_Price = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1jq8m7l-4"
})(["font-size:", ";line-height:", ";color:", ";font-weight:600;", " span{color:", ";font-weight:500;font-size:", ";}"], function (props) {
  return props.theme.rem(22);
}, function (props) {
  return props.theme.rem(26);
}, function (props) {
  return props.theme.pricingBox.price.mainColor;
}, function (_ref2) {
  var isClickable = _ref2.isClickable;
  return isClickable && "\n      text-underline-offset: 2px;\n      text-decoration-line: underline;\n      text-decoration-thickness: from-font;\n  ";
}, function (props) {
  return props.theme.pricingBox.price.secondaryColor;
}, function (props) {
  return props.theme.rem(16);
});
var Dates = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1jq8m7l-5"
})(["display:flex;align-items:center;font-size:", ";line-height:", ";gap:", ";color:", ";", ""], function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.rem(18);
}, function (props) {
  return props.theme.space(1);
}, function (props) {
  return props.theme.pricingBox.dates.label;
}, function (_ref3) {
  var hasDates = _ref3.hasDates;
  return hasDates && "\n      color: ".concat(function (props) {
    return props.theme.pricingBox.dates.date;
  }, ";\n      border-bottom: 1px solid ").concat(function (props) {
    return props.theme.pricingBox.dates.border;
  }, ";\n  ");
});
;// CONCATENATED MODULE: ./src/components/PricingBox/Mobile/index.js
var PricingBox_Mobile_jsx = react.createElement;





















var Mobile_DATE_FORMAT = 'dd MMM yyyy';
var Mobile_HEADER_SIZE = 64;

var PricingBoxMobile = function PricingBoxMobile(_ref) {
  var _contract$fixed, _contract$fixed_unita;

  var accommodationOffer = _ref.accommodationOffer,
      paidBookings = _ref.paidBookings,
      priceDetailsRequest = _ref.priceDetailsRequest,
      priceDetailsData = _ref.priceDetailsData,
      hasPriceDetails = _ref.hasPriceDetails,
      setPriceDetailsRequest = _ref.setPriceDetailsRequest,
      requestPriceDetails = _ref.requestPriceDetails,
      isLoading = _ref.isLoading,
      isCalendarOpen = _ref.isCalendarOpen,
      setIsCalendarOpen = _ref.setIsCalendarOpen,
      showDoubleBookingModal = _ref.showDoubleBookingModal,
      trackSelectDatesAction = _ref.trackSelectDatesAction,
      trackRequestToBookAction = _ref.trackRequestToBookAction,
      trackRequestIntentionAction = _ref.trackRequestIntentionAction,
      trackFixedContractModalOpenAction = _ref.trackFixedContractModalOpenAction,
      trackFixedContractOptionClickAction = _ref.trackFixedContractOptionClickAction,
      trackFixedContractConfirmClickAction = _ref.trackFixedContractConfirmClickAction,
      trackFixedContractCancelClickAction = _ref.trackFixedContractCancelClickAction,
      property = _ref.property,
      trackRequestToBookAmplitudeAction = _ref.trackRequestToBookAmplitudeAction;

  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t,
      language = _useTranslation.i18n.language;

  var router = (0,next_router.useRouter)();

  var _useState = (0,react.useState)(false),
      showPaymentSummary = _useState[0],
      setShowPaymentSummary = _useState[1];

  var _useScrollLock = (0,useScrollLock/* default */.Z)(),
      lockScroll = _useScrollLock.lockScroll,
      unlockScroll = _useScrollLock.unlockScroll;

  var openCalendar = function openCalendar() {
    if (isAnyTypeFixed) {
      trackFixedContractModalOpenAction(offerId);
    }

    trackSelectDatesAction();
    trackRequestIntentionAction();
    setIsCalendarOpen(true);
  };

  var openPaymentDetails = function openPaymentDetails() {
    setShowPaymentSummary(true);
    setIsCalendarOpen(true);
  };

  var closeCalendar = function closeCalendar() {
    var _ref2, _router$query$moveIn, _ref3, _router$query$moveOut, _router$query$optionI;

    if (isAnyTypeFixed) {
      trackFixedContractCancelClickAction(offerId);
    }

    setPriceDetailsRequest({
      moveIn: (_ref2 = (_router$query$moveIn = router.query.moveIn) !== null && _router$query$moveIn !== void 0 ? _router$query$moveIn : router.query['move-in']) !== null && _ref2 !== void 0 ? _ref2 : null,
      moveOut: (_ref3 = (_router$query$moveOut = router.query.moveOut) !== null && _router$query$moveOut !== void 0 ? _router$query$moveOut : router.query['move-out']) !== null && _ref3 !== void 0 ? _ref3 : null,
      guests: +router.query.guests ? +router.query.guests : 1,
      optionId: (_router$query$optionI = router.query.optionId) !== null && _router$query$optionI !== void 0 ? _router$query$optionI : null
    });
    setIsCalendarOpen(false);
  };

  var offerId = accommodationOffer.id,
      contract = accommodationOffer.contract,
      offerGenderRestriction = accommodationOffer.restrictions.gender;
  var moveInRequest = priceDetailsRequest.moveIn,
      moveOutRequest = priceDetailsRequest.moveOut,
      guests = priceDetailsRequest.guests,
      optionId = priceDetailsRequest.optionId;

  var _ref4 = (priceDetailsData === null || priceDetailsData === void 0 ? void 0 : priceDetailsData.start_end) || {},
      moveIn = _ref4.start,
      moveOut = _ref4.end;

  var moveInDate = moveInRequest || moveIn ? new Date(moveInRequest || moveIn) : null;
  var moveOutDate = moveOut || moveOutRequest ? new Date(moveOutRequest || moveOut) : null;
  var formattedMoveIn = moveInDate ? (0,utils/* formatDate */.p6)(moveInDate, language, Mobile_DATE_FORMAT) : t('Select dates');
  var formattedMoveOut = moveOutDate ? (0,utils/* formatDate */.p6)(moveOutDate, language, Mobile_DATE_FORMAT) : t('Select dates');

  var _getPricing = getPricing({
    accommodationOffer: accommodationOffer,
    priceDetailsRequest: priceDetailsRequest,
    priceDetailsData: priceDetailsData
  }),
      isAnyTypeFixed = _getPricing.isAnyTypeFixed,
      extraPriceAmount = _getPricing.extraPriceAmount,
      firstRentValue = _getPricing.firstRentValue,
      referencePrice = _getPricing.referencePrice;

  var extraPrice = extraPriceAmount ? {
    amount: extraPriceAmount,
    currency_code: referencePrice.currency_code
  } : null;
  var isInstantBooking = contract.is_instant_booking;

  var setMoveInOut = function setMoveInOut(moveIn, moveOut) {
    return setPriceDetailsRequest({
      moveIn: moveIn,
      moveOut: moveOut
    });
  };

  var selectFixedOption = (0,react.useCallback)(function (optionId) {
    trackFixedContractOptionClickAction(offerId);
    setPriceDetailsRequest({
      optionId: optionId
    });
  });
  var propertyType = property.typology.type_code,
      offerType = property.lifecycle.rent_by,
      cityCode = property.location.address.city_code,
      propertyGenderRestriction = property.restrictions.gender;

  var openCheckout = function openCheckout() {
    trackRequestToBookAction();
    trackRequestIntentionAction();
    trackRequestToBookAmplitudeAction(isAnyTypeFixed ? selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.start_date : moveInRequest, isAnyTypeFixed ? selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.end_date : moveOutRequest, guests, optionId, offerId, (0,utils/* fromMoneyCoreFormat */.fI)(firstRentValue === null || firstRentValue === void 0 ? void 0 : firstRentValue.amount) || (0,utils/* fromMoneyCoreFormat */.fI)(referencePrice.amount), (firstRentValue === null || firstRentValue === void 0 ? void 0 : firstRentValue.currency_code) || referencePrice.currency_code, (0,contracts/* getAvailableFrom */.yA)(accommodationOffer), propertyType, offerType, router.query.city, getCountryNamefromCityCode(cityCode), offerGenderRestriction, propertyGenderRestriction);
    (0,redirect/* redirectToCheckout */.VX)(offerId, isAnyTypeFixed ? {
      guests: guests,
      optionId: optionId
    } : {
      guests: guests,
      moveIn: moveInDate,
      moveOut: moveOutDate
    });
  };

  var openCheckoutOrDoubleBookingModal = function openCheckoutOrDoubleBookingModal() {
    if (isDoubleBooking(paidBookings, moveIn, moveOut)) {
      showDoubleBookingModal({
        onRequestBookingAnyway: openCheckout
      });
      return;
    }

    openCheckout();
  };

  var setGuests = function setGuests(updatedGuests) {
    if (+updatedGuests === priceDetailsRequest.guests) {
      return;
    }

    setPriceDetailsRequest({
      guests: +updatedGuests
    });
  };

  var onConfirm = (0,react.useCallback)(function (moveIn, moveOut, guests, optionId) {
    setIsCalendarOpen(false);

    if (isAnyTypeFixed) {
      trackFixedContractConfirmClickAction(offerId);
    }

    (0,queryParams/* changeUrlQuery */.gJ)(router, {
      'move-in': moveIn,
      'move-out': moveOut,
      guests: guests,
      optionId: optionId
    });
  }, [moveIn, moveOut, guests, optionId]);
  var formattedFirstRentValue = firstRentValue && (0,utils/* formatMoney */.lb)(firstRentValue.amount, firstRentValue.currency_code);
  var formattedReferencePrice = (0,utils/* formatMoney */.lb)(referencePrice.amount, referencePrice.currency_code);

  var onConfirmSuggested = function onConfirmSuggested(moveInSuggested, moveOutSuggested) {
    (0,queryParams/* changeUrlQuery */.gJ)(router, {
      moveIn: moveInSuggested,
      moveOut: moveOutSuggested,
      guests: guests,
      optionId: optionId
    });
  };

  var _useState2 = (0,react.useState)(!isAnyTypeFixed && isRangeValid(moveIn && (0,utils/* formatDate */.p6)(moveInDate), moveOut && (0,utils/* formatDate */.p6)(moveOutDate), t, language, accommodationOffer)),
      validations = _useState2[0],
      setValidations = _useState2[1];

  (0,react.useEffect)(function () {
    setValidations(!isAnyTypeFixed && isRangeValid(moveIn && (0,utils/* formatDate */.p6)(moveInDate), moveOut && (0,utils/* formatDate */.p6)(moveOutDate), t, language, accommodationOffer));
  }, [moveIn, moveOut, priceDetailsRequest, language]);
  var fixedContractOptions = (contract === null || contract === void 0 ? void 0 : (_contract$fixed = contract.fixed) === null || _contract$fixed === void 0 ? void 0 : _contract$fixed.options) || (contract === null || contract === void 0 ? void 0 : (_contract$fixed_unita = contract.fixed_unitary) === null || _contract$fixed_unita === void 0 ? void 0 : _contract$fixed_unita.options);
  var selectedOption = fixedContractOptions === null || fixedContractOptions === void 0 ? void 0 : fixedContractOptions.find(function (option) {
    return option.id === optionId;
  });
  var formattedStartDate = selectedOption !== null && selectedOption !== void 0 && selectedOption.start_date ? (0,utils/* formatDate */.p6)(new Date(selectedOption.start_date), language, Mobile_DATE_FORMAT) : null;
  var formattedEndDate = selectedOption !== null && selectedOption !== void 0 && selectedOption.end_date ? (0,utils/* formatDate */.p6)(new Date(selectedOption.end_date), language, Mobile_DATE_FORMAT) : null;
  (0,react.useEffect)(function () {
    var _normalizeQuery = (0,queryParams/* normalizeQuery */.Up)(router.query),
        moveIn = _normalizeQuery.moveIn,
        moveOut = _normalizeQuery.moveOut,
        guests = _normalizeQuery.guests,
        optionId = _normalizeQuery.optionId;

    var shouldRequestPriceDetails = false;

    if (moveIn && moveIn !== priceDetailsRequest.moveIn && moveOut && moveOut !== priceDetailsRequest.moveOut) {
      setMoveInOut(moveIn, moveOut);
      shouldRequestPriceDetails = true;
    }

    if (+guests && +guests !== priceDetailsRequest.guests) {
      setPriceDetailsRequest({
        guests: +guests
      });
      shouldRequestPriceDetails = true;
    }

    if (optionId && optionId !== priceDetailsRequest.optionId) {
      selectFixedOption(optionId);
      shouldRequestPriceDetails = true;
    }

    if (shouldRequestPriceDetails) {
      requestPriceDetails();
    }
  }, [router.query]);
  (0,react.useEffect)(function () {
    if (isCalendarOpen) {
      lockScroll(Mobile_HEADER_SIZE);
    }

    return function () {
      return unlockScroll();
    };
  }, [isCalendarOpen]);
  return PricingBox_Mobile_jsx(MainWrapper, {
    id: "pricing-box"
  }, !isCalendarOpen && PricingBox_Mobile_jsx(notifications, {
    validations: validations,
    extraData: {
      extraPrice: extraPrice,
      isInstantBooking: isInstantBooking,
      setMoveInOut: onConfirmSuggested
    }
  }), PricingBox_Mobile_jsx(PricingBox_Mobile_styles_Wrapper, null, PricingBox_Mobile_jsx(Mobile_styles_Content, null, PricingBox_Mobile_jsx(LeftSection, null, PricingBox_Mobile_jsx(Mobile_styles_Price, {
    isClickable: hasPriceDetails,
    onClick: hasPriceDetails ? openPaymentDetails : null
  }, formattedFirstRentValue || formattedReferencePrice, PricingBox_Mobile_jsx("span", null, "/".concat(t('month')))), PricingBox_Mobile_jsx(Dates, {
    hasDates: moveIn && moveOut
  }, moveIn && moveOut || optionId ? PricingBox_Mobile_jsx(react.Fragment, null, PricingBox_Mobile_jsx("span", null, isAnyTypeFixed ? formattedStartDate : formattedMoveIn), " -", ' ', PricingBox_Mobile_jsx("span", null, isAnyTypeFixed ? formattedEndDate : formattedMoveOut)) : PricingBox_Mobile_jsx("span", null, t('Add dates for price')))), PricingBox_Mobile_jsx(Button/* default */.Z, {
    isPrimary: true,
    isDisabled: isLoading,
    onClick: (moveIn && moveOut || optionId) && hasPriceDetails ? openCheckoutOrDoubleBookingModal : openCalendar
  }, (moveIn && moveOut || optionId) && hasPriceDetails ? t('Reserve') : t('Select dates'))), isCalendarOpen && PricingBox_Mobile_jsx(Unisystem_Calendar, {
    onClose: closeCalendar,
    accommodationOffer: accommodationOffer,
    property: property,
    priceDetailsRequest: priceDetailsRequest,
    priceDetailsData: priceDetailsData,
    setMoveInOut: setMoveInOut,
    setGuests: setGuests,
    selectFixedOption: selectFixedOption,
    extraPrice: extraPrice,
    onConfirm: showPaymentSummary ? openCheckout : onConfirm,
    isLoading: isLoading,
    showPaymentSummary: showPaymentSummary && Object.keys(priceDetailsData).length,
    setShowPaymentSummary: setShowPaymentSummary
  })));
};

var Mobile_mapStateToProps = function mapStateToProps(_ref5) {
  var paidBookings = _ref5.profile.paidBookings,
      _ref5$offer = _ref5.offer,
      _ref5$offer$priceDeta = _ref5$offer.priceDetails,
      isLoading = _ref5$offer$priceDeta.isLoading,
      priceDetailsRequest = _ref5$offer$priceDeta.request,
      priceDetailsData = _ref5$offer$priceDeta.data,
      offerAggregate = _ref5$offer.offerAggregate,
      isCalendarOpen = _ref5$offer.isCalendarOpen;
  return {
    paidBookings: paidBookings,
    priceDetailsRequest: priceDetailsRequest || {},
    priceDetailsData: priceDetailsData || {},
    hasPriceDetails: !!priceDetailsData,
    accommodationOffer: offerAggregate.accommodation_offer,
    isLoading: isLoading,
    isCalendarOpen: isCalendarOpen,
    property: offerAggregate.property_aggregate.property
  };
};

var Mobile_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setPriceDetailsRequest: function setPriceDetailsRequest(_ref6) {
      var guests = _ref6.guests,
          moveIn = _ref6.moveIn,
          moveOut = _ref6.moveOut,
          optionId = _ref6.optionId;
      return dispatch((0,offer/* setPriceDetailsRequest */.dp)({
        guests: guests,
        moveIn: moveIn,
        moveOut: moveOut,
        optionId: optionId
      }));
    },
    setIsCalendarOpen: function setIsCalendarOpen(newValue) {
      return dispatch((0,offer/* setIsCalendarOpenAction */.s9)({
        isCalendarOpen: newValue
      }));
    },
    showDoubleBookingModal: function showDoubleBookingModal(_ref7) {
      var onRequestBookingAnyway = _ref7.onRequestBookingAnyway;
      return dispatch((0,modal/* showModalAction */.bF)({
        modalId: modal_displayer.modalIds.DOUBLE_BOOKING,
        onRequestBookingAnyway: onRequestBookingAnyway
      }));
    },
    requestPriceDetails: function requestPriceDetails() {
      return dispatch((0,offer/* requestPriceDetails */.uU)());
    },
    clearPriceDetails: function clearPriceDetails() {
      return dispatch((0,offer/* setPriceDetailsData */.DW)({
        priceDetails: null
      }));
    },
    trackSelectDatesAction: function trackSelectDatesAction() {
      return dispatch((0,actions_tracking/* trackSelectDates */.sz)());
    },
    trackRequestToBookAction: function trackRequestToBookAction() {
      return dispatch((0,actions_tracking/* trackRequestToBook */.ef)());
    },
    trackRequestIntentionAction: function trackRequestIntentionAction() {
      return dispatch((0,actions_tracking/* trackRequestIntention */.OU)());
    },
    trackFixedContractModalOpenAction: function trackFixedContractModalOpenAction(offerId) {
      return dispatch((0,actions_tracking/* trackFixedContractModalOpen */.Iu)({
        offerId: offerId
      }));
    },
    trackFixedContractOptionClickAction: function trackFixedContractOptionClickAction(offerId) {
      return dispatch((0,actions_tracking/* trackFixedContractOptionClick */.qh)({
        offerId: offerId
      }));
    },
    trackFixedContractConfirmClickAction: function trackFixedContractConfirmClickAction(offerId) {
      return dispatch((0,actions_tracking/* trackFixedContractConfirmClick */.Lf)({
        offerId: offerId
      }));
    },
    trackFixedContractCancelClickAction: function trackFixedContractCancelClickAction(offerId) {
      return dispatch((0,actions_tracking/* trackFixedContractCancelClick */.ek)({
        offerId: offerId
      }));
    },
    trackRequestToBookAmplitudeAction: function trackRequestToBookAmplitudeAction(moveIn, moveOut, guests, optionId, offerId, price, currencyCode, availableFrom, propertyType, offerType, city, country, offerGenderRestriction, propertyGenderRestriction) {
      return dispatch((0,actions_tracking/* trackRequestToBookAmplitude */.BP)({
        moveIn: moveIn,
        moveOut: moveOut,
        guests: guests,
        optionId: optionId,
        offerId: offerId,
        price: price,
        currencyCode: currencyCode,
        availableFrom: availableFrom,
        propertyType: propertyType,
        offerType: offerType,
        city: city,
        country: country,
        offerGenderRestriction: offerGenderRestriction,
        propertyGenderRestriction: propertyGenderRestriction
      }));
    }
  };
};

/* harmony default export */ var PricingBox_Mobile = ((0,es/* connect */.$j)(Mobile_mapStateToProps, Mobile_mapDispatchToProps)(PricingBoxMobile));
;// CONCATENATED MODULE: ./src/components/HeaderTitle/Mobile/styles.js

var HeaderTitle_Mobile_styles_Wrapper = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1yhina4-0"
})(["display:flex;flex-direction:column;width:100%;", ""], function (_ref) {
  var theme = _ref.theme;
  return theme.gap(4, 'column');
});
var Mobile_styles_Title = /*#__PURE__*/styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
  componentId: "sc-1yhina4-1"
})(["font-family:'IntervalNextMed',sans-serif;font-size:", ";font-weight:600;color:", ";"], function (props) {
  return props.theme.rem(22);
}, function (props) {
  return props.theme.headerTitle.title.color;
});
var Mobile_styles_Tags = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1yhina4-2"
})(["display:flex;align-items:center;", ";flex-wrap:wrap;width:100%;& > span{color:", ";& > span{margin-left:", ";color:", ";}}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.gap(2);
}, function (props) {
  return props.theme.headerTitle.tags.color;
}, function (props) {
  return props.theme.space(2);
}, function (props) {
  return props.theme.headerTitle.tags.separatorColor;
});
var styles_Location = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1yhina4-3"
})(["display:flex;align-items:center;", ";color:", ";line-height:", ";svg{min-width:20px;}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.gap(2);
}, function (props) {
  return props.theme.headerTitle.location.color;
}, function (props) {
  return props.theme.rem(20);
});
var styles_Actions = /*#__PURE__*/styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  componentId: "sc-1yhina4-4"
})(["display:flex;align-items:center;", ";justify-content:space-around;span,svg{margin-bottom:0;}"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.gap(8);
});
var styles_Action = /*#__PURE__*/styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  componentId: "sc-1yhina4-5"
})(["display:flex;align-items:center;", ";color:", ";font-family:'IntervalNextMed',sans-serif;font-size:", ";font-weight:500;line-height:", ";transition:opacity 0.5s ease-out;&:hover{cursor:pointer;}", ";"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.gap(3);
}, function (props) {
  return props.theme.headerTitle.actions.color;
}, function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.rem(18);
}, function (_ref6) {
  var isLoading = _ref6.isLoading;
  return isLoading && "\n      pointer-events: none;\n      opacity: 0.5;\n  ";
});
;// CONCATENATED MODULE: ./src/components/HeaderTitle/Mobile/index.js
var HeaderTitle_Mobile_jsx = react.createElement;
















var HeaderTitleMobile = function HeaderTitleMobile(_ref) {
  var _neighborhood$metadat;

  var offerId = _ref.offerId,
      accommodationOffer = _ref.accommodationOffer,
      neighborhood = _ref.neighborhood,
      city = _ref.city,
      titleTranslations = _ref.titleTranslations,
      cityTranslations = _ref.cityTranslations,
      rentBy = _ref.rentBy,
      bedType = _ref.bedType,
      bathroomType = _ref.bathroomType,
      numberOfBedrooms = _ref.numberOfBedrooms,
      numberOfBathrooms = _ref.numberOfBathrooms,
      hasElevator = _ref.hasElevator,
      propertyType = _ref.propertyType,
      maxGuests = _ref.maxGuests,
      area = _ref.area,
      street = _ref.street,
      isLoggedIn = _ref.isLoggedIn,
      isWishlistLoading = _ref.isWishlistLoading,
      isOnWishlist = _ref.isOnWishlist,
      showWishlistModal = _ref.showWishlistModal,
      showShareModal = _ref.showShareModal,
      showReportModal = _ref.showReportModal,
      addToWishlist = _ref.addToWishlist,
      removeFromWishlist = _ref.removeFromWishlist,
      trackReportListingOpenAction = _ref.trackReportListingOpenAction,
      trackAddToWishlistAction = _ref.trackAddToWishlistAction,
      trackShareLinkAction = _ref.trackShareLinkAction;

  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t,
      language = _useTranslation.i18n.language;

  var tags = generateOfferTags({
    rentBy: rentBy,
    bedType: bedType,
    bathroomType: bathroomType,
    numberOfBedrooms: numberOfBedrooms,
    numberOfBathrooms: numberOfBathrooms,
    hasElevator: hasElevator,
    propertyType: propertyType,
    maxGuests: maxGuests,
    area: area,
    t: t
  });

  var handleWishlistClick = function handleWishlistClick() {
    trackAddToWishlistAction(accommodationOffer, city, neighborhood, language);

    if (!isLoggedIn) {
      showWishlistModal();
      return;
    }

    isOnWishlist ? removeFromWishlist({
      offerId: offerId,
      city: city
    }) : addToWishlist({
      offerId: offerId,
      city: city
    });
  };

  var showReportListingModal = function showReportListingModal() {
    showReportModal();
    trackReportListingOpenAction();
  };

  var showShareListingModal = function showShareListingModal() {
    showShareModal();
    trackShareLinkAction();
  };

  return HeaderTitle_Mobile_jsx(HeaderTitle_Mobile_styles_Wrapper, null, HeaderTitle_Mobile_jsx(styles_Actions, null, HeaderTitle_Mobile_jsx(styles_Action, {
    role: 'button',
    onClick: handleWishlistClick,
    isLoading: isWishlistLoading
  }, HeaderTitle_Mobile_jsx(heart_outline/* default */.Z, {
    color: src_theme/* theme.headerTitle.actions.color */.r.headerTitle.actions.color,
    strokeWidth: 1,
    filled: isOnWishlist
  }), ' ', HeaderTitle_Mobile_jsx("span", null, t(isOnWishlist ? 'Saved' : 'Save'))), HeaderTitle_Mobile_jsx(styles_Action, {
    role: 'button',
    onClick: showShareListingModal
  }, HeaderTitle_Mobile_jsx(share/* default */.Z, {
    color: src_theme/* theme.headerTitle.actions.color */.r.headerTitle.actions.color
  }), " ", HeaderTitle_Mobile_jsx("span", null, t('Share'))), HeaderTitle_Mobile_jsx(styles_Action, {
    role: 'button',
    onClick: showReportListingModal
  }, HeaderTitle_Mobile_jsx(report_flag, {
    color: src_theme/* theme.headerTitle.actions.color */.r.headerTitle.actions.color
  }), " ", HeaderTitle_Mobile_jsx("span", null, t('Report')))), HeaderTitle_Mobile_jsx(Mobile_styles_Title, null, (0,transformers/* translateFromLanguage */.JB)(titleTranslations, language)), HeaderTitle_Mobile_jsx(styles_Location, null, HeaderTitle_Mobile_jsx(pin, null), ' ', HeaderTitle_Mobile_jsx("span", null, [street, (0,transformers/* translateFromLanguage */.JB)(neighborhood === null || neighborhood === void 0 ? void 0 : (_neighborhood$metadat = neighborhood.metadata) === null || _neighborhood$metadat === void 0 ? void 0 : _neighborhood$metadat.name_translations, language), (0,transformers/* translateFromLanguage */.JB)(cityTranslations, language)].filter(function (item) {
    return item && item.trim();
  }).join(', '))), HeaderTitle_Mobile_jsx(Mobile_styles_Tags, null, tags.map(function (tag, i) {
    return HeaderTitle_Mobile_jsx("span", {
      key: tag
    }, tag, i !== tags.length - 1 && HeaderTitle_Mobile_jsx("span", null, "\u2022"));
  })));
};

var HeaderTitle_Mobile_mapStateToProps = function mapStateToProps(_ref2) {
  var _wishlist$cities;

  var offerAggregate = _ref2.offer.offerAggregate,
      _ref2$profile = _ref2.profile,
      isLoggedIn = _ref2$profile.isLoggedIn,
      wishlist = _ref2$profile.wish_list;
  var accommodationOffer = offerAggregate.accommodation_offer,
      _offerAggregate$globa = offerAggregate.globalization_aggregate.city,
      cityTranslations = _offerAggregate$globa.metadata.name_translations,
      city = _offerAggregate$globa.configuration.slug,
      _offerAggregate$prope = offerAggregate.property_aggregate,
      neighborhood = _offerAggregate$prope.neighborhood,
      street = _offerAggregate$prope.property.location.address.street;
  var offerId = accommodationOffer.id,
      titleTranslations = accommodationOffer.title;

  var _generateTitleData = generateTitleData(offerAggregate),
      rentBy = _generateTitleData.rentBy,
      bedType = _generateTitleData.bedType,
      bathroomType = _generateTitleData.bathroomType,
      numberOfBedrooms = _generateTitleData.numberOfBedrooms,
      numberOfBathrooms = _generateTitleData.numberOfBathrooms,
      hasElevator = _generateTitleData.hasElevator,
      propertyType = _generateTitleData.propertyType,
      maxGuests = _generateTitleData.maxGuests,
      area = _generateTitleData.area;

  var isOnWishlist = wishlist === null || wishlist === void 0 ? void 0 : (_wishlist$cities = wishlist.cities) === null || _wishlist$cities === void 0 ? void 0 : _wishlist$cities.items.some(function (_ref3) {
    var accommodation_offer_ids = _ref3.accommodation_offer_ids;
    return accommodation_offer_ids.includes(offerId);
  });
  return {
    offerId: offerId,
    accommodationOffer: accommodationOffer,
    neighborhood: neighborhood,
    city: city,
    titleTranslations: titleTranslations,
    cityTranslations: cityTranslations,
    rentBy: rentBy,
    bedType: bedType,
    bathroomType: bathroomType,
    numberOfBedrooms: numberOfBedrooms,
    numberOfBathrooms: numberOfBathrooms,
    hasElevator: hasElevator,
    propertyType: propertyType,
    maxGuests: maxGuests,
    area: area,
    street: street,
    isLoggedIn: isLoggedIn,
    isOnWishlist: isOnWishlist,
    isWishlistLoading: wishlist === null || wishlist === void 0 ? void 0 : wishlist.isLoading
  };
};

var HeaderTitle_Mobile_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    showWishlistModal: function showWishlistModal() {
      return dispatch((0,modal/* showModalAction */.bF)({
        modalId: modal_displayer.modalIds.WISHLIST
      }));
    },
    showShareModal: function showShareModal() {
      return dispatch((0,modal/* showModalAction */.bF)({
        modalId: modal_displayer.modalIds.SHARE
      }));
    },
    showReportModal: function showReportModal() {
      return dispatch((0,modal/* showModalAction */.bF)({
        modalId: modal_displayer.modalIds.REPORT_LISTING
      }));
    },
    addToWishlist: function addToWishlist(_ref4) {
      var offerId = _ref4.offerId,
          city = _ref4.city;
      return dispatch((0,profile/* addToWishlistAction */.$C)({
        offerId: offerId,
        city: city
      }));
    },
    removeFromWishlist: function removeFromWishlist(_ref5) {
      var offerId = _ref5.offerId,
          city = _ref5.city;
      return dispatch((0,profile/* removeFromWishlistAction */.b5)({
        offerId: offerId,
        city: city
      }));
    },
    trackReportListingOpenAction: function trackReportListingOpenAction() {
      return dispatch((0,actions_tracking/* trackReportListingOpen */.S0)());
    },
    trackAddToWishlistAction: function trackAddToWishlistAction(offer, citySlug, neighborhood, language) {
      return dispatch((0,actions_tracking/* trackAddToWishlist */.i2)({
        offer: offer,
        citySlug: citySlug,
        neighborhood: neighborhood,
        language: language
      }));
    },
    trackShareLinkAction: function trackShareLinkAction() {
      return dispatch((0,actions_tracking/* trackShareLink */.Yh)());
    }
  };
};

/* harmony default export */ var HeaderTitle_Mobile = ((0,es/* connect */.$j)(HeaderTitle_Mobile_mapStateToProps, HeaderTitle_Mobile_mapDispatchToProps)(HeaderTitleMobile));
;// CONCATENATED MODULE: ./src/containers/Offer/View/Mobile/index.js

var View_Mobile_jsx = react.createElement;






















var Mobile_WhereYoullBeLiving = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 26314).then(__webpack_require__.bind(__webpack_require__, 26314));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(26314)];
    }
  }
});

var OfferViewMobile = function OfferViewMobile(_ref) {
  var rentalRegistrationCode = _ref.rentalRegistrationCode;

  var _useInView = useInView({
    triggerOnce: true,
    rootMargin: '200px 0px'
  }),
      _useInView2 = (0,slicedToArray/* default */.Z)(_useInView, 2),
      whereYoullBeLivingRef = _useInView2[0],
      isWhereYoullBeLivingInView = _useInView2[1];

  return View_Mobile_jsx(react.Fragment, null, View_Mobile_jsx(components_Gallery, null), View_Mobile_jsx(styles_Main, null, View_Mobile_jsx(HeaderTitle_Mobile, null), View_Mobile_jsx(Separator/* default */.Z, null), View_Mobile_jsx(components_Overview, null), View_Mobile_jsx(Separator/* default */.Z, null), View_Mobile_jsx(components_Availability, null), View_Mobile_jsx(Separator/* default */.Z, null), View_Mobile_jsx(components_Landlord, null), View_Mobile_jsx(Separator/* default */.Z, null), View_Mobile_jsx(components_ServicesExpenses, null), View_Mobile_jsx(Separator/* default */.Z, null), View_Mobile_jsx(components_RentalConditions, null), View_Mobile_jsx(Separator/* default */.Z, null), View_Mobile_jsx(components_Contract, null), View_Mobile_jsx(Separator/* default */.Z, null), View_Mobile_jsx("div", {
    ref: whereYoullBeLivingRef
  }, isWhereYoullBeLivingInView ? View_Mobile_jsx(Mobile_WhereYoullBeLiving, null) : View_Mobile_jsx(styles_SectionPlaceholder, null)), View_Mobile_jsx(src_components_Reviews, null), View_Mobile_jsx(components_WhyRentWithUniplaces, null), View_Mobile_jsx(src_components_FAQ, null), View_Mobile_jsx(components_MorePlacesLikeThis, null), View_Mobile_jsx(PricingBox_Mobile, null), View_Mobile_jsx(InfoSection, null, rentalRegistrationCode && View_Mobile_jsx(components_RegistrationNumber, {
    registrationNumber: rentalRegistrationCode
  }), View_Mobile_jsx(Breadcrumbs, null))));
};

var View_Mobile_mapStateToProps = function mapStateToProps(_ref2) {
  var _contract$landlord_po, _contract$landlord_po2;

  var contract = _ref2.offer.offerAggregate.accommodation_offer.contract;
  return {
    rentalRegistrationCode: contract === null || contract === void 0 ? void 0 : (_contract$landlord_po = contract.landlord_policies) === null || _contract$landlord_po === void 0 ? void 0 : (_contract$landlord_po2 = _contract$landlord_po.rental_registration_code) === null || _contract$landlord_po2 === void 0 ? void 0 : _contract$landlord_po2.value
  };
};

/* harmony default export */ var View_Mobile = ((0,es/* connect */.$j)(View_Mobile_mapStateToProps)(OfferViewMobile));
// EXTERNAL MODULE: ../shared/src/clients/dataEvents/index.js + 1 modules
var dataEvents = __webpack_require__(15920);
// EXTERNAL MODULE: ../shared/src/hooks/auth.js + 8 modules
var auth = __webpack_require__(34543);
;// CONCATENATED MODULE: ../shared/src/hooks/streams/index.js





var OFFER_VIEW = 'offer-view';
var SEARCH_KEY = 'search-id';
var getSearchId = function getSearchId(location) {
  var _searchKey$split;
  if (!location || !location.hash || !location.hash.includes(SEARCH_KEY)) {
    return null;
  }
  var hashes = location.hash.split('#');
  var searchKey = hashes.find(function (element) {
    return element.includes(SEARCH_KEY);
  });
  var _ref = (_searchKey$split = searchKey.split("".concat(SEARCH_KEY, "="))) !== null && _searchKey$split !== void 0 ? _searchKey$split : [null, null],
    _ref2 = (0,slicedToArray/* default */.Z)(_ref, 2),
    searchId = _ref2[1];
  return searchId;
};
var useStreams = function useStreams(offers) {
  var referrer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var isCrawler = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var _useRouter = (0,next_router.useRouter)(),
    query = _useRouter.query,
    asPath = _useRouter.asPath;
  var _useAuth = (0,auth/* useAuth */.a)(),
    profile = _useAuth.profile,
    isLoadingProfile = _useAuth.isLoadingProfile;
  var _asPath$split = asPath.split('?'),
    _asPath$split2 = (0,slicedToArray/* default */.Z)(_asPath$split, 2),
    _asPath$split2$ = _asPath$split2[1],
    queryString = _asPath$split2$ === void 0 ? '' : _asPath$split2$;
  var handleOfferViewTracking = function handleOfferViewTracking() {
    if (isLoadingProfile || !window.location) {
      return null;
    }
    var searchId = getSearchId(window.location) || query[SEARCH_KEY] || null;
    var _ref3 = searchId ? searchId.split('_') : [null, ''],
      _ref4 = (0,slicedToArray/* default */.Z)(_ref3, 2),
      tracking = _ref4[1];
    Promise.all(isCrawler ? [Promise.resolve()] : offers.map(function (_ref5) {
      var id = _ref5.accommodation_offer.id;
      return (0,dataEvents/* sendEvent */.q)(OFFER_VIEW, {
        view_id: searchId,
        event_name: 'guest_view_offer',
        offer_id: id,
        guest_id: profile ? profile.id : null,
        referrer: referrer,
        tracking_id: tracking,
        query_string: queryString,
        created_at: Date.now()
      });
    }));
  };
  (0,react.useEffect)(function () {
    handleOfferViewTracking();
  }, [isLoadingProfile]);
};
// EXTERNAL MODULE: ../shared/src/clients/core/index.js + 1 modules
var core = __webpack_require__(30629);
;// CONCATENATED MODULE: ./src/containers/Offer/View/index.js

var View_jsx = react.createElement;

function View_ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function View_objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? View_ownKeys(Object(t), !0).forEach(function (r) {
      (0,defineProperty/* default */.Z)(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : View_ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}













var OfferView = function OfferView(_ref) {
  var isCrawler = _ref.isCrawler,
      guestName = _ref.guestName,
      token = _ref.token,
      isLoggedIn = _ref.isLoggedIn,
      notificationEmail = _ref.notificationEmail,
      offerAggregate = _ref.offerAggregate,
      generateGalleryGrid = _ref.generateGalleryGrid,
      trackViewOfferPageAction = _ref.trackViewOfferPageAction,
      loadOfferViews = _ref.loadOfferViews,
      referrer = _ref.referrer,
      profile = _ref.profile,
      priceDetails = _ref.priceDetails;

  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t,
      language = _useTranslation.i18n.language;

  var _useContext = (0,react.useContext)(media/* MediaContext */.Y),
      is = _useContext.is;

  useStreams([offerAggregate], referrer, isCrawler);
  var Component = (0,react.useMemo)(function () {
    return is.mobile ? View_Mobile : View_Desktop;
  }, [is.mobile]);
  (0,react.useEffect)(function () {
    generateGalleryGrid();
    loadOfferViews(language);

    if (token) {
      (0,core/* addAuthentication */.MH)(token);
    }

    var _offerAggregate$accom = offerAggregate.accommodation_offer;
    _offerAggregate$accom = _offerAggregate$accom === void 0 ? {} : _offerAggregate$accom;
    var offerGenderRestriction = _offerAggregate$accom.restrictions.gender,
        _offerAggregate$prope = offerAggregate.property_aggregate.property.restrictions.gender,
        propertyGenderRestriction = _offerAggregate$prope === void 0 ? [] : _offerAggregate$prope;
    trackViewOfferPageAction(View_objectSpread(View_objectSpread({}, offerAggregate), {}, {
      language: language,
      profile: profile,
      priceDetails: priceDetails
    }), notificationEmail, referrer, offerGenderRestriction, propertyGenderRestriction);
  }, []);
  return View_jsx(react.Fragment, null, View_jsx(OfferHeader, {
    isLoggedInOutsideOfContext: isLoggedIn,
    guestName: guestName
  }), View_jsx(Component, null), View_jsx(OfferFooter, {
    t: t,
    language: language,
    withPaymentMethods: true
  }));
};

var View_mapStateToProps = function mapStateToProps(_ref2) {
  var _profile$basic_info, _profile$basic_info$f, _profile$contacts;

  var _ref2$profile = _ref2.profile,
      isLoggedIn = _ref2$profile.isLoggedIn,
      token = _ref2$profile.token,
      profile = _ref2$profile.profile,
      profileDefault = _ref2.profile,
      _ref2$offer = _ref2.offer,
      offerAggregate = _ref2$offer.offerAggregate,
      referrer = _ref2$offer.tracking.referrer,
      priceDetails = _ref2$offer.priceDetails,
      page = _ref2.page;
  var guestName = profile === null || profile === void 0 ? void 0 : (_profile$basic_info = profile.basic_info) === null || _profile$basic_info === void 0 ? void 0 : (_profile$basic_info$f = _profile$basic_info.full_name) === null || _profile$basic_info$f === void 0 ? void 0 : _profile$basic_info$f.first;
  var notificationEmail = profile === null || profile === void 0 ? void 0 : (_profile$contacts = profile.contacts) === null || _profile$contacts === void 0 ? void 0 : _profile$contacts.notification_email_address;
  return {
    isCrawler: page === null || page === void 0 ? void 0 : page.isCrawler,
    guestName: guestName,
    token: token,
    isLoggedIn: isLoggedIn,
    notificationEmail: notificationEmail,
    offerAggregate: offerAggregate,
    referrer: referrer,
    profile: profileDefault,
    priceDetails: priceDetails
  };
};

var View_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    generateGalleryGrid: function generateGalleryGrid() {
      return dispatch((0,offer/* generateGalleryGrid */.AM)());
    },
    loadOfferViews: function loadOfferViews(locale) {
      return dispatch((0,offer/* getOfferViews */.Nb)(locale));
    },
    trackViewOfferPageAction: function trackViewOfferPageAction(trackingData, notificationEmail, referrer, offerGenderRestriction, propertyGenderRestriction) {
      return dispatch((0,actions_tracking/* trackViewOfferPage */.kI)({
        trackingData: trackingData,
        notificationEmail: notificationEmail,
        referrer: referrer,
        offerGenderRestriction: offerGenderRestriction,
        propertyGenderRestriction: propertyGenderRestriction
      }));
    }
  };
};

/* harmony default export */ var View = ((0,es/* connect */.$j)(View_mapStateToProps, View_mapDispatchToProps)(OfferView));
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ./pages/accommodation/[city]/[offerId].js


function _offerId_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _offerId_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? _offerId_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : _offerId_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var OfferPage = function OfferPage(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(View, _offerId_objectSpread({}, props));
};

var __N_SSP = true;
/* harmony default export */ var _offerId_ = (OfferPage);

/***/ }),

/***/ 64571:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/accommodation/[city]/[offerId]",
      function () {
        return __webpack_require__(64807);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [72538,99885,81119,52882,49774,92888,40179], function() { return __webpack_exec__(64571); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);